(function() {
    'use strict';

    angular
        .module('pcsApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngSanitize',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'ui.select',
            'cgNotify',
            'datatables',
            'datatables.buttons',
            'summernote'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();

(function () {
    'use strict';

    angular
        .module('pcsApp')
        .factory('User', User);

    User.$inject = ['$resource', 'DateUtils'];

    function User ($resource, DateUtils) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    for (var i = 0; i < data.congresses.length; i++) {
                        data.congresses[i].startDate = DateUtils.convertLocalDateFromServer(data.congresses[i].startDate);
                        data.congresses[i].endDate = DateUtils.convertLocalDateFromServer(data.congresses[i].endDate);
                    }
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular.module('pcsApp')
        .factory('RoomReservationByRoomFilter', RoomReservationByRoomFilter);

    RoomReservationByRoomFilter.$inject = ['$cookies', '$state'];

    function RoomReservationByRoomFilter ($cookies, $state) {
        var roomReservationByRoomFilter = null;

        return {
            setRoomReservationByRoomFilter: function (filter) {
                if (filter) {
                    roomReservationByRoomFilter = {
                        congressHotel: filter.congressHotel
                    };
                    $cookies.putObject('room-reservation-by-room-filter', roomReservationByRoomFilter);
                }
                else {
                    roomReservationByRoomFilter = null;
                    $cookies.remove('room-reservation-by-room-filter');
                }

            },
            getRoomReservationByRoomFilter: function () {
                if (roomReservationByRoomFilter == null) {
                    roomReservationByRoomFilter = $cookies.getObject('room-reservation-by-room-filter');
                    if (!roomReservationByRoomFilter) {
                        return {
                            congressHotel: null
                        };
                    }
                }
                return roomReservationByRoomFilter;
            }
        };
    }
})();

(function() {
    'use strict';

    angular.module('pcsApp')
        .factory('RoomReservationByParticipantFilter', RoomReservationByParticipantFilter);

    RoomReservationByParticipantFilter.$inject = ['$cookies', '$state'];

    function RoomReservationByParticipantFilter ($cookies, $state) {
        var roomReservationByParticipantFilter = null;

        return {
            setRoomReservationByParticipantFilter: function (filter) {
                if (filter) {
                    roomReservationByParticipantFilter = {
                        congressHotel: filter.congressHotel
                    };
                    $cookies.putObject('room-reservation-by-participant-filter', roomReservationByParticipantFilter);
                }
                else {
                    roomReservationByParticipantFilter = null;
                    $cookies.remove('room-reservation-by-participant-filter');
                }

            },
            getRoomReservationByParticipantFilter: function () {
                if (roomReservationByParticipantFilter == null) {
                    roomReservationByParticipantFilter = $cookies.getObject('room-reservation-by-participant-filter');
                    if (!roomReservationByParticipantFilter) {
                        return {
                            congressHotel: null
                        };
                    }
                }
                return roomReservationByParticipantFilter;
            }
        };
    }
})();

(function() {
    'use strict';

    angular.module('pcsApp')
        .factory('RegIdStorage', RegIdStorage);

    RegIdStorage.$inject = ['$window'];

    function RegIdStorage ($window) {
        var lastRegId = null;

        return {
            setLastRegId: function (id) {
                if (id) {
                    lastRegId = id;
                    $window.sessionStorage.setItem('last-reg-id', lastRegId);
                }
                else {
                    lastRegId = null;
                    $window.sessionStorage.removeItem('last-reg-id');
                }

            },
            getLastRegId: function () {
                return lastRegId;
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('pcsApp')
        .factory('OptionalServiceApplicantFilter', OptionalServiceApplicantFilter);

    OptionalServiceApplicantFilter.$inject = ['$cookies', '$state'];

    function OptionalServiceApplicantFilter ($cookies, $state) {
        var optionalServiceApplicantFilter = null;

        return {
            setOptionalServiceApplicantFilter: function (filter) {
                if (filter) {
                    optionalServiceApplicantFilter = {
                        optionalService: filter.optionalService
                    };
                    $cookies.putObject('optional-service-applicant-filter', optionalServiceApplicantFilter);
                }
                else {
                    optionalServiceApplicantFilter = null;
                    $cookies.remove('optional-service-applicant-filter');
                }

            },
            getOptionalServiceApplicantFilter: function () {
                if (optionalServiceApplicantFilter == null) {
                    optionalServiceApplicantFilter = $cookies.getObject('optional-service-applicant-filter');
                    if (!optionalServiceApplicantFilter) {
                        return {
                            optionalService: null
                        };
                    }
                }
                return optionalServiceApplicantFilter;
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('SendInvoiceEmailDialogController', SendInvoiceEmailDialogController);

    SendInvoiceEmailDialogController.$inject = ['$timeout', '$scope', 'invoiceEmail', '$uibModalInstance', 'Invoice'];

    function SendInvoiceEmailDialogController ($timeout, $scope, invoiceEmail, $uibModalInstance, Invoice) {
        var vm = this;

        vm.invoiceEmail = { invoice: invoiceEmail.invoice, email: invoiceEmail.email };

        vm.clear = clear;
        vm.send = send;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function send () {
            vm.isSaving = true;
            Invoice.sendEmail({ invoiceId: vm.invoiceEmail.invoice, email: vm.invoiceEmail.email }, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:emailSent', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular.module('pcsApp')
        .factory('HotelSummaryFilter', HotelSummaryFilter);

    HotelSummaryFilter.$inject = ['$cookies', '$state'];

    function HotelSummaryFilter ($cookies, $state) {
        var hotelSummaryFilter = null;

        return {
            setHotelSummaryFilter: function (filter) {
                if (filter) {
                    hotelSummaryFilter = {
                        congressHotel: filter.congressHotel
                    };
                    $cookies.putObject('hotel-summary-report-filter', hotelSummaryFilter);
                }
                else {
                    hotelSummaryFilter = null;
                    $cookies.remove('hotel-summary-report-filter');
                }

            },
            getHotelSummaryFilter: function () {
                if (hotelSummaryFilter == null) {
                    hotelSummaryFilter = $cookies.getObject('hotel-summary-report-filter');
                    if (!hotelSummaryFilter) {
                        return {
                            congressHotel: null
                        };
                    }
                }
                return hotelSummaryFilter;
            }
        };
    }
})();

(function() {
    'use strict';

    angular.module('pcsApp')
        .factory('GroupDiscountItemFilter', GroupDiscountItemFilter);

    GroupDiscountItemFilter.$inject = ['$cookies', '$state'];

    function GroupDiscountItemFilter ($cookies, $state) {
        var groupDiscountItemFilter = null;

        return {
            setGroupDiscountItemFilter: function (filter) {
                if (filter) {
                    groupDiscountItemFilter = {
                        payingGroup: filter.payingGroup,
                        chargeableItemType: filter.chargeableItemType,
                        selectedChargeableItemIds: {}
                    };
                    $cookies.putObject('group-discount-item-filter', groupDiscountItemFilter);
                }
                else {
                    groupDiscountItemFilter = null;
                    $cookies.remove('group-discount-item-filter');
                }

            },
            getGroupDiscountItemFilter: function () {
                if (groupDiscountItemFilter == null) {
                    groupDiscountItemFilter = $cookies.getObject('group-discount-item-filter');
                    if (!groupDiscountItemFilter) {
                        return {
                            payingGroup: null,
                            chargeableItemType: null,
                            selectedChargeableItemIds: {}
                        };
                    }
                }
                return groupDiscountItemFilter;
            },
            resetSelectedItems: function () {
                if (groupDiscountItemFilter != null) {
                    groupDiscountItemFilter.selectedChargeableItemIds = {};
                }
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('EmailDialogController', EmailDialogController);

    EmailDialogController.$inject = ['$timeout', '$scope', 'registrationEmail', '$uibModalInstance', 'Email', 'CongressSelector'];

    function EmailDialogController ($timeout, $scope, registrationEmail, $uibModalInstance, Email, CongressSelector) {
        var vm = this;

        vm.mail = { congressId: CongressSelector.getSelectedCongress().id, lastName: registrationEmail.lastName, firstName: registrationEmail.firstName, email: registrationEmail.email, body: null };

        vm.summerNoteConfig = {
            height: 300,
            focus: true,
            toolbar: []
        };
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            Email.send(vm.mail, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:emailSent', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular.module('pcsApp')
        .factory('CongressSelector', CongressSelector);

    CongressSelector.$inject = ['$state', '$window'];

    function CongressSelector ($state, $window) {
        var selectedCongress = null;

        return {
            setSelectedCongress: function (congress) {
                if (congress) {
                    selectedCongress = {
                        id: congress.id,
                        meetingCode: congress.meetingCode,
                        name: congress.name,
                        startDate: congress.startDate,
                        endDate: congress.endDate,
                        defaultCountry: congress.defaultCountry
                    };
                    $window.sessionStorage.setItem('selected-congress', angular.toJson(selectedCongress));
                }
                else {
                    selectedCongress = null;
                    $window.sessionStorage.removeItem('selected-congress');
                    $state.go('home');
                }

            },
            getSelectedCongress: function () {
                if (selectedCongress == null && $window.sessionStorage.getItem('selected-congress')) {
                    selectedCongress = angular.fromJson($window.sessionStorage.getItem('selected-congress'));
                }
                return selectedCongress;
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('SendConfirmationDialogController', SendConfirmationDialogController);

    SendConfirmationDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'confirmationSettings', 'Confirmation', 'OptionalText', 'CongressSelector'];

    function SendConfirmationDialogController ($timeout, $scope, $uibModalInstance, confirmationSettings, Confirmation, OptionalText, CongressSelector) {
        var vm = this;

        vm.confirmationEmail = confirmationSettings.email;
        vm.language = 'hu';
        vm.optionalText = '';
        vm.regId = confirmationSettings.regId;
        OptionalText.queryByCongress({id: CongressSelector.getSelectedCongress().id}, function(result) {
            vm.optionalTexts = result;
        });

        vm.clear = clear;
        vm.sendAndPrintConfirmation = sendAndPrintConfirmation;
        vm.setOptionalTextMessage = setOptionalTextMessage;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function sendAndPrintConfirmation() {
            vm.isSaving = true;
            Confirmation.sendAndPrintConfirmation(createConfirmationForPrinting(), onSaveSuccess, onSaveError);
            vm.isSaving = false;
            $uibModalInstance.close();
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:confirmationSent', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function setOptionalTextMessage(text) {
            vm.optionalText = text;
        }

        function createConfirmationForPrinting() {
            var conf = {};
            conf.language = vm.language;
            conf.confirmationTitleType = 'CONFIRMATION';
            conf.optionalText = vm.optionalText;
            conf.registrationId = vm.regId;
            conf.congressId = CongressSelector.getSelectedCongress().id;
            conf.customConfirmationEmail = vm.confirmationEmail;
            conf.ignoredChargeableItemIdList = [];
            conf.ignoredChargedServiceIdList = [];
            return conf;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .factory('Sessions', Sessions);

    Sessions.$inject = ['$resource'];

    function Sessions ($resource) {
        return $resource('api/account/sessions/:series', {}, {
            'getAll': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('pcsApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage' ];

    function AuthServerProvider ($http, $localStorage ) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken () {
            var token = $localStorage.authenticationToken;
            return token;
        }

        function hasValidToken () {
            var token = this.getToken();
            return !!token;
        }

        function login (credentials) {
            var data = 'j_username=' + encodeURIComponent(credentials.username) +
                '&j_password=' + encodeURIComponent(credentials.password) +
                '&remember-me=' + credentials.rememberMe + '&submit=Login';

            return $http.post('api/authentication', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).success(function (response) {
                return response;
            });
        }

        function logout () {

            
            // logout from the server
            $http.post('api/logout').success(function (response) {
                delete $localStorage.authenticationToken;
                // to get a new csrf token call the api
                $http.get('api/account');
                return response;
            });
            
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            $state.go('login');
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }


        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .directive('regKeypressHandler', RegKeypressHandler);

    RegKeypressHandler.$inject = ['$state'];

    function RegKeypressHandler($state) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc($scope, $element, $attrs, $ctrl) {
            var keys = [];

            document.onkeydown = function(e) {
                keys.push(e.key);
                if (keys.length > 9) {
                    keys.shift();
                }

                var regex = /REG-[0-9]{5}/g;
                var match = keys.join("").match(regex);
                if (match) {
                    var regId = parseInt(match[0].substring(4, match[0].length));
                    console.log('keypressed regId:', regId);
                    $state.go('registration', {registrationId: regId}, {reload: true});
                }
            }
        }
    }

})();
(function() {
    'use strict';

    angular
        .module('pcsApp')
        .directive('minimalizaSidebar', minimalizaSidebar)
        .directive('sideNavigation', sideNavigation);

    //minimalizaSidebar.$inject = ['$timeout'];
    sideNavigation.$inject = ['$timeout'];

    function minimalizaSidebar() {
        var directive = {
            restrict: 'A',
            template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="" ng-click="vm.minimalize()"><i class="fa fa-bars"></i></a>',
            controller: MinSidebarController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    function MinSidebarController () {
        var vm = this;
        vm.minimalize = minimalize;

        function minimalize () {
            $("body").toggleClass("mini-navbar");
            if (!$('body').hasClass('mini-navbar') || $('body').hasClass('body-small')) {
                // Hide menu in order to smoothly turn on when maximize menu
                $('#side-menu').hide();
                // For smoothly turn on menu
                setTimeout(
                    function () {
                        $('#side-menu').fadeIn(400);
                    }, 200);
            } else if ($('body').hasClass('fixed-sidebar')){
                $('#side-menu').hide();
                setTimeout(
                    function () {
                        $('#side-menu').fadeIn(400);
                    }, 100);
            } else {
                // Remove all inline style from jquery fadeIn function to reset menu state
                $('#side-menu').removeAttr('style');
            }
        }
    }

    function sideNavigation($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                // Call the metsiMenu plugin and plug it to sidebar navigation
                $timeout(function(){
                    element.metisMenu();

                });

                // Enable initial fixed sidebar
                //var sidebar = element.parent();
                //sidebar.slimScroll({
                //    height: '100%',
                //    railOpacity: 0.9,
                //});
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'CongressSelector'];

    function NavbarController ($state, Auth, Principal, ProfileService, CongressSelector) {
        var vm = this;
        vm.$state = $state;
        vm.isCongressSelected = isCongressSelected;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        Principal.identity().then(function(account) {
            vm.account = account;
            vm.isAuthenticated = Principal.isAuthenticated;
        });

        function isCongressSelected () {
            return CongressSelector.getSelectedCongress() != null;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function(newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('HeaderController', HeaderController);

    HeaderController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'CongressSelector', 'RegIdStorage', 'User', 'GroupDiscountItemFilter'];

    function HeaderController ($state, Auth, Principal, ProfileService, CongressSelector, RegIdStorage, User, GroupDiscountItemFilter) {
        var vm = this;

        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.logout = logout;
        vm.$state = $state;
        vm.selectedCongress = CongressSelector.getSelectedCongress();
        vm.selectCongress = selectCongress;
        vm.congresses = [];

        function logout() {
            CongressSelector.setSelectedCongress(null);
            RegIdStorage.setLastRegId(null);
            Auth.logout();
            $state.go('login');
        }

        Principal.identity().then(function (account) {
            User.get({login: account.login}, function(user) {
                vm.congresses = user.congresses;
                if (vm.congresses) {
                    vm.congresses.sort(function (c1, c2) {
                        if (c1.meetingCode < c2.meetingCode) {
                            return -1;
                        }
                        else if (c1.meetingCode > c2.meetingCode) {
                            return 1;
                        }
                        else {
                            return 0;
                        }
                    });
                }
            });
        });

        function selectCongress(congress) {
            vm.selectedCongress = congress;
            CongressSelector.setSelectedCongress(congress);
            RegIdStorage.setLastRegId(null);
            GroupDiscountItemFilter.setGroupDiscountItemFilter(null);
            $state.go('home');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('FooterController', FooterController);

    FooterController.$inject = ['$state'];

    function FooterController ($state) {
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'base@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'base@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN']
            },
            views: {
                'content@base': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', '$state'];

    function HomeController ($scope, Principal, $state) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('WorkplaceMergeConfirmController', WorkplaceMergeConfirmController);

    WorkplaceMergeConfirmController.$inject = ['$scope', '$uibModalInstance', 'entity', 'selectedWorkplaces', 'Workplace'];

    function WorkplaceMergeConfirmController ($scope, $uibModalInstance, entity, selectedWorkplaces, Workplace) {
        var vm = this;
        vm.selectedWorkplaces = selectedWorkplaces;
        vm.workplace = entity;

        vm.clear = clear;
        vm.confirmMerge = confirmMerge;
        vm.createWorkplaceMergeDTO = createWorkplaceMergeDTO;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmMerge() {
            Workplace.merge(createWorkplaceMergeDTO(), onMergeComplete);
        }

        function onMergeComplete() {
            $uibModalInstance.close(true);
        }

        function createWorkplaceMergeDTO() {
            var workplace = {};
            workplace.workplaceId = vm.workplace.id;
            workplace.mergingWorkplaceIdList = [];

            for (var prop in vm.selectedWorkplaces) {
                if (vm.selectedWorkplaces.hasOwnProperty(prop)) {
                    workplace.mergingWorkplaceIdList.push(parseInt(prop, 10));
                }
            }
            return workplace;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('WorkplaceMergeController', WorkplaceMergeController);

    WorkplaceMergeController.$inject = ['$scope', 'entity', 'selectedWorkplaces', 'Workplace', 'CongressSelector', 'DTOptionsBuilder', 'DTColumnDefBuilder'];

    function WorkplaceMergeController ($scope, entity, selectedWorkplaces, Workplace, CongressSelector, DTOptionsBuilder, DTColumnDefBuilder) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions();
        //vm.dtOptions.withOption('stateSave', true);
        vm.dtOptions.withOption('order', [1, 'asc']);
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).notSortable()
        ];

        vm.workplace = entity;
        vm.selectedWorkplaces = selectedWorkplaces;
        vm.workplaces = [];
        vm.isAnyWorkplaceSelected = isAnyWorkplaceSelected;
        vm.toggleWorkplaceSelection = toggleWorkplaceSelection;

        function loadAllWorkplaces() {
            Workplace.queryByCongress({ id: CongressSelector.getSelectedCongress().id }, function(result) {
                vm.workplaces = result;
                for (var i = 0; i < vm.workplaces.length; i++) {
                    if (vm.workplaces[i].id === vm.workplace.id) {
                        vm.workplaces.splice(i, 1);
                        break;
                    }
                }
            });
        }

        loadAllWorkplaces();

        function isAnyWorkplaceSelected() {
            for (var prop in vm.selectedWorkplaces) {
                if (vm.selectedWorkplaces.hasOwnProperty(prop)) {
                    return true;
                }
            }
            return false;
        }

        function toggleWorkplaceSelection (workplaceId) {
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('WorkplaceDialogController', WorkplaceDialogController);

    WorkplaceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Workplace', 'Country', 'Congress'];

    function WorkplaceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Workplace, Country, Congress) {
        var vm = this;

        vm.workplace = entity;
        vm.clear = clear;
        vm.save = save;
        vm.countries = Country.query();
        vm.congresses = Congress.query();

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.workplace.id !== null) {
                Workplace.update(vm.workplace, onSaveSuccess, onSaveError);
            } else {
                Workplace.save(vm.workplace, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:workplaceUpdate', result);
            $uibModalInstance.close(result);
            //vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('WorkplaceDeleteController',WorkplaceDeleteController);

    WorkplaceDeleteController.$inject = ['$uibModalInstance', 'entity', 'Workplace'];

    function WorkplaceDeleteController($uibModalInstance, entity, Workplace) {
        var vm = this;

        vm.workplace = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Workplace.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('workplace', {
                parent: 'administration',
                url: '/workplace',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'pcsApp.workplace.home.title'
                },
                views: {
                    'content@base': {
                        templateUrl: 'app/entities/workplace/workplaces.html',
                        controller: 'WorkplaceController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    isPartner: function() { return false; },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('workplace');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('workplace.new', {
                parent: 'workplace',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'CongressSelector', function ($stateParams, $state, $uibModal, CongressSelector) {
                    $uibModal.open({
                        templateUrl: 'app/entities/workplace/workplace-dialog.html',
                        controller: 'WorkplaceDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    name: null,
                                    vatRegNumber: null,
                                    country: CongressSelector.getSelectedCongress().defaultCountry,
                                    department: null,
                                    zipCode: null,
                                    city: null,
                                    street: null,
                                    phone: null,
                                    fax: null,
                                    email: null,
                                    id: null,
                                    congress: CongressSelector.getSelectedCongress()
                                };
                            }
                        }
                    }).result.then(function () {
                            $state.go('workplace', null, {reload: 'workplace'});
                        }, function () {
                            $state.go('workplace');
                        });
                }]
            })
            .state('workplace.edit', {
                parent: 'workplace',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/workplace/workplace-dialog.html',
                        controller: 'WorkplaceDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Workplace', function (Workplace) {
                                return Workplace.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                            $state.go('workplace', null, {reload: 'workplace'});
                        }, function () {
                            $state.go('^');
                        });
                }]
            })
            .state('workplace.delete', {
                parent: 'workplace',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/workplace/workplace-delete-dialog.html',
                        controller: 'WorkplaceDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Workplace', function (Workplace) {
                                return Workplace.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                            $state.go('workplace', null, {reload: 'workplace'});
                        }, function () {
                            $state.go('^');
                        });
                }]
            })
            .state('workplace.merge', {
                parent: 'workplace',
                url: '/{id}/merge',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'pcsApp.workplace.home.title'
                },
                views: {
                    'content@base': {
                        templateUrl: 'app/entities/workplace/merge-workplaces.html',
                        controller: 'WorkplaceMergeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['Workplace', '$stateParams', function (Workplace, $stateParams) {
                        return Workplace.get({id: $stateParams.id}).$promise;
                    }],
                    selectedWorkplaces: function () {
                        return {};
                    }
                }
            })
            .state('workplace.merge.confirm', {
                parent: 'workplace.merge',
                url: '/confirm',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'pcsApp.workplace.home.title'
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'selectedWorkplaces', function ($stateParams, $state, $uibModal, selectedWorkplaces) {
                    $uibModal.open({
                        templateUrl: 'app/entities/workplace/workplace-merge-confirm-dialog.html',
                        controller: 'WorkplaceMergeConfirmController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Workplace', function (Workplace) {
                                return Workplace.get({id: $stateParams.id}).$promise;
                            }],
                            selectedWorkplaces: function () {
                                return selectedWorkplaces;
                            }
                        }
                    }).result.then(function (result) {
                            $state.go('workplace', null, {reload: true});
                        }, function () {
                            $state.go('^');
                        })
                }]
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('Workplace', Workplace);

    Workplace.$inject = ['$resource'];

    function Workplace ($resource) {
        var resourceUrl =  'api/workplaces/:id';

        return $resource(resourceUrl, {}, {
            'queryByCongress': {
                method: 'GET',
                url: 'api/workplaces/congress/:id',
                isArray: true
            },
            'queryForCongress': {
                method: 'GET',
                url: 'api/workplaces/all/congress/:id'
                ,isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' },
            'merge': {
                method: 'POST',
                url: 'api/workplaces/merge',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('WorkplaceController', WorkplaceController);

    WorkplaceController.$inject = ['$scope', '$state', 'Workplace', 'DTOptionsBuilder', 'DTColumnDefBuilder', 'CongressSelector', 'isPartner'];

    function WorkplaceController ($scope, $state, Workplace, DTOptionsBuilder, DTColumnDefBuilder, CongressSelector, isPartner) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withDOM('<"html5buttons"B>ltfgitp')
            .withButtons([
                {extend: 'excel', title: 'workplaces'},
                {extend: 'pdf', title: 'workplaces'}
            ]);

        vm.dtOptions.withOption('stateSave', true);
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(-1).notSortable()
        ];

        vm.workplaces = [];
        vm.isPartner = isPartner;

        loadAll();

        function loadAll() {
            if (!isPartner) {
                Workplace.queryByCongress({ id: CongressSelector.getSelectedCongress().id }, function(result) {
                    vm.workplaces = result;
                });
            }
            else {
                Workplace.queryByCongress({ id: 0 }, function(result) {
                    vm.workplaces = result;
                });
            }

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('partner', {
                parent: 'maintenance',
                url: '/partners',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'pcsApp.partner.home.title'
                },
                views: {
                    'content@base': {
                        templateUrl: 'app/entities/workplace/workplaces.html',
                        controller: 'WorkplaceController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    isPartner: function() { return true; },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('partner');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('partner.new', {
                parent: 'partner',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'CongressSelector', function($stateParams, $state, $uibModal, CongressSelector) {
                    $uibModal.open({
                        templateUrl: 'app/entities/workplace/workplace-dialog.html',
                        controller: 'WorkplaceDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    name: null,
                                    vatRegNumber: null,
                                    department: null,
                                    zipCode: null,
                                    city: null,
                                    street: null,
                                    phone: null,
                                    fax: null,
                                    email: null,
                                    id: null,
                                    congress: null
                                };
                            }
                        }
                    }).result.then(function(result) {
                            $state.go('partner', null, { reload: 'partner' });
                        }, function() {
                            $state.go('partner');
                        })
                }]
            })
            .state('partner.edit', {
                parent: 'partner',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/workplace/workplace-dialog.html',
                        controller: 'WorkplaceDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Workplace', function(Workplace) {
                                return Workplace.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function(result) {
                            $state.go('partner', null, { reload: 'partner' });
                        }, function() {
                            $state.go('^');
                        })
                }]
            })
            .state('partner.delete', {
                parent: 'partner',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/workplace/workplace-delete-dialog.html',
                        controller: 'WorkplaceDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Workplace', function(Workplace) {
                                return Workplace.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function(result) {
                            $state.go('partner', null, { reload: true });
                        }, function() {
                            $state.go('^');
                        })
                }]
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('VatInfoDialogController', VatInfoDialogController);

    VatInfoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'VatInfo', 'Congress'];

    function VatInfoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, VatInfo, Congress) {
        var vm = this;

        vm.vatInfo = entity;
        vm.clear = clear;
        vm.save = save;
        vm.vatRateTypeChanged = vatRateTypeChanged;


        vm.congresses = Congress.query();

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.vatInfo.id !== null) {
                VatInfo.update(vm.vatInfo, onSaveSuccess, onSaveError);
            } else {
                VatInfo.save(vm.vatInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:vatInfoUpdate', result);
            $uibModalInstance.close(result);
            //vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function vatRateTypeChanged() {
            if (vm.vatInfo.vatRateType !== 'REGULAR') {
                vm.vatInfo.vat = 0;
            }
            else {
                vm.vatInfo.vatExceptionReason = null;
            }
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('VatInfoDeleteController',VatInfoDeleteController);

    VatInfoDeleteController.$inject = ['$uibModalInstance', 'entity', 'VatInfo'];

    function VatInfoDeleteController($uibModalInstance, entity, VatInfo) {
        var vm = this;

        vm.vatInfo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            VatInfo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('vat-info', {
            parent: 'maintenance',
            url: '/vat-info',
            params: {
                congressSpecific: false
            },
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pcsApp.vatInfo.home.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/vat-info/vat-infos.html',
                    controller: 'VatInfoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                congressSpecific: ['$stateParams', function ($stateParams) {
                    return $stateParams.congressSpecific || false;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('vatInfo');
                    $translatePartialLoader.addPart('chargeableItemType');
                    $translatePartialLoader.addPart('vatRateType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('vat-info.new', {
            parent: 'vat-info',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'congressSpecific', 'CongressSelector', function($stateParams, $state, $uibModal, congressSpecific, CongressSelector) {
                $uibModal.open({
                    templateUrl: 'app/entities/vat-info/vat-info-dialog.html',
                    controller: 'VatInfoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                vat: null,
                                szj: null,
                                chargeableItemType: null,
                                vatRateType: null,
                                vatExceptionReason: null,
                                id: null,
                                congress: congressSpecific ? CongressSelector.getSelectedCongress() : null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('vat-info', null, { reload: 'vat-info' });
                }, function() {
                    $state.go('vat-info');
                });
            }]
        })
        .state('vat-info.edit', {
            parent: 'vat-info',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vat-info/vat-info-dialog.html',
                    controller: 'VatInfoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VatInfo', function(VatInfo) {
                            return VatInfo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('vat-info', null, { reload: 'vat-info' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('vat-info.delete', {
            parent: 'vat-info',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vat-info/vat-info-delete-dialog.html',
                    controller: 'VatInfoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['VatInfo', function(VatInfo) {
                            return VatInfo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('vat-info', null, { reload: 'vat-info' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('congress-vat-info', {
            parent: 'administration',
            url: '/vat-info',
            params: {
                congressSpecific: true
            },
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pcsApp.vatInfo.home.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/vat-info/vat-infos.html',
                    controller: 'VatInfoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                congressSpecific: ['$stateParams', function ($stateParams) {
                    return $stateParams.congressSpecific || false;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('vatInfo');
                    $translatePartialLoader.addPart('chargeableItemType');
                    $translatePartialLoader.addPart('vatRateType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('congress-vat-info.new', {
            parent: 'congress-vat-info',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'congressSpecific', 'CongressSelector', function($stateParams, $state, $uibModal, congressSpecific, CongressSelector) {
                $uibModal.open({
                    templateUrl: 'app/entities/vat-info/vat-info-dialog.html',
                    controller: 'VatInfoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                vat: null,
                                szj: null,
                                chargeableItemType: null,
                                vatRateType: null,
                                vatExceptionReason: null,
                                id: null,
                                congress: congressSpecific ? CongressSelector.getSelectedCongress() : null
                            };
                        }
                    }
                }).result.then(function() {
                        $state.go('congress-vat-info', null, { reload: 'congress-vat-info' });
                    }, function() {
                        $state.go('congress-vat-info');
                    });
            }]
        })
        .state('congress-vat-info.edit', {
            parent: 'congress-vat-info',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vat-info/vat-info-dialog.html',
                    controller: 'VatInfoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VatInfo', function(VatInfo) {
                            return VatInfo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                        $state.go('congress-vat-info', null, { reload: 'congress-vat-info' });
                    }, function() {
                        $state.go('^');
                    });
            }]
        })
        .state('congress-vat-info.delete', {
            parent: 'congress-vat-info',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vat-info/vat-info-delete-dialog.html',
                    controller: 'VatInfoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['VatInfo', function(VatInfo) {
                            return VatInfo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                        $state.go('congress-vat-info', null, { reload: 'congress-vat-info' });
                    }, function() {
                        $state.go('^');
                    });
            }]
        });

    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('VatInfo', VatInfo);

    VatInfo.$inject = ['$resource'];

    function VatInfo ($resource) {
        var resourceUrl =  'api/vat-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryByCongress': {
                method: 'GET',
                url: 'api/vat-infos/congress/:id'
                ,isArray: true},
            'queryForCongress': {
                method: 'GET',
                url: 'api/vat-infos/all/congress/:id'
                ,isArray: true},
            'queryForCongressAndItemType': {
                method: 'GET',
                url: 'api/vat-infos/all/congress/:id/item-type/:itemType'
                ,isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('VatInfoController', VatInfoController);

    VatInfoController.$inject = ['$scope', '$state', '$stateParams', 'VatInfo', 'congressSpecific', 'CongressSelector'];

    function VatInfoController ($scope, $state, $stateParams, VatInfo, congressSpecific, CongressSelector) {
        var vm = this;
        vm.congressSpecific = $stateParams.congressSpecific;
        vm.selectedCongressMeetingCode = vm.congressSpecific && CongressSelector.getSelectedCongress() ? CongressSelector.getSelectedCongress().meetingCode : "";
        vm.vatInfos = [];

        vm.vatInfos = [];
        vm.congressSpecific = congressSpecific;

        loadAll();

        function loadAll() {
            if (vm.congressSpecific) {
                VatInfo.queryByCongress({id: CongressSelector.getSelectedCongress().id}, function(result) {
                    vm.vatInfos = result;
                });
            }
            else {
                VatInfo.queryByCongress({id: 0}, function(result) {
                    vm.vatInfos = result;
                });
            }
        }
    }
})();

 (function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('RoomReservationByRoomSelectionDialogController', RoomReservationByRoomSelectionDialogController);

    RoomReservationByRoomSelectionDialogController.$inject = ['$timeout', '$state', '$scope', '$stateParams', '$uibModalInstance', 'listFilter', 'CongressHotel', 'CongressSelector', 'RoomReservationByRoomFilter'];

    function RoomReservationByRoomSelectionDialogController ($timeout, $state, $scope, $stateParams, $uibModalInstance, listFilter, CongressHotel, CongressSelector, RoomReservationByRoomFilter) {
        var vm = this;

        vm.listFilter = listFilter;
        vm.clear = clear;
        vm.select = select;
        CongressHotel.queryByCongress({id: CongressSelector.getSelectedCongress().id}, function(result) {
            vm.congressHotels = result;
        });

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
            $state.go('room-reservation-by-room');
        }

        function select () {
            vm.isSaving = true;
            RoomReservationByRoomFilter.setRoomReservationByRoomFilter(vm.listFilter);
            $uibModalInstance.close();
            $state.go('room-reservation-by-room', null, {reload: 'room-reservation-by-room'});
            vm.isSaving = false;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('room-reservation-by-room', {
                parent: 'report',
                url: '/room-reservation-by-room',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'pcsApp.roomReservationByRoom.home.title'
                },
                views: {
                    'content@base': {
                        templateUrl: 'app/entities/room-reservation-by-room/room-reservation-by-rooms.html',
                        controller: 'RoomReservationByRoomController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    listFilter: ['RoomReservationByRoomFilter', function (RoomReservationByRoomFilter) {
                        return RoomReservationByRoomFilter.getRoomReservationByRoomFilter();
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('roomReservationByRoom');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('room-reservation-by-room.selection', {
                parent: 'room-reservation-by-room',
                url: '/select',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'listFilter', function ($stateParams, $state, $uibModal, listFilter) {
                    $uibModal.open({
                        templateUrl: 'app/entities/room-reservation-by-room/room-reservation-by-room-selection-dialog.html',
                        controller: 'RoomReservationByRoomSelectionDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            listFilter: function () {
                                return listFilter;
                            }
                        }
                    });
                }]
            });
    }


})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('RoomReservationByRoom', RoomReservationByRoom);

    RoomReservationByRoom.$inject = ['$resource', 'DateUtils'];

    function RoomReservationByRoom ($resource, DateUtils) {
        var resourceUrl =  'api/room-reservation-by-rooms/:meetingCode/:hotelId';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('RoomReservationByRoomController', RoomReservationByRoomController);

    RoomReservationByRoomController.$inject = ['$scope', '$state', 'RoomReservationByRoom', 'DTOptionsBuilder', 'DTColumnDefBuilder', 'CongressSelector', 'listFilter'];

    function RoomReservationByRoomController ($scope, $state, RoomReservationByRoom, DTOptionsBuilder, DTColumnDefBuilder, CongressSelector, listFilter) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions();
        vm.dtOptions.withOption('order', [2, 'asc']);
        vm.dtOptions.withOption('scrollX', true);
        vm.dtOptions.withOption('stateSave', true);
        vm.dtColumnDefs = [
        ];

        vm.listFilter = listFilter;
        vm.downloadReportXls = downloadReportXls;

        vm.roomReservationByRooms = [];

        loadAll();

        function loadAll() {
            if (vm.listFilter.congressHotel) {
                RoomReservationByRoom.query({
                        meetingCode: CongressSelector.getSelectedCongress().meetingCode,
                        hotelId: listFilter.congressHotel.hotel.id
                    },
                    function (result) {
                        vm.roomReservationByRooms = result;
                    }
                );
            }
        }

        function downloadReportXls () {
            window.location.href = '/api/room-reservation-by-rooms/' + CongressSelector.getSelectedCongress().meetingCode
                + '/' + listFilter.congressHotel.hotel.id.toString() + '/download-report';
        }
    }
})();

 (function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('RoomReservationByParticipantSelectionDialogController', RoomReservationByParticipantSelectionDialogController);

    RoomReservationByParticipantSelectionDialogController.$inject = ['$timeout', '$state', '$scope', '$stateParams', '$uibModalInstance', 'listFilter', 'CongressHotel', 'CongressSelector', 'RoomReservationByParticipantFilter'];

    function RoomReservationByParticipantSelectionDialogController ($timeout, $state, $scope, $stateParams, $uibModalInstance, listFilter, CongressHotel, CongressSelector, RoomReservationByParticipantFilter) {
        var vm = this;

        vm.listFilter = listFilter;
        vm.clear = clear;
        vm.select = select;
        CongressHotel.queryByCongress({id: CongressSelector.getSelectedCongress().id}, function(result) {
            vm.congressHotels = result;
        });

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
            $state.go('room-reservation-by-participant');
        }

        function select () {
            vm.isSaving = true;
            RoomReservationByParticipantFilter.setRoomReservationByParticipantFilter(vm.listFilter);
            $uibModalInstance.close();
            $state.go('room-reservation-by-participant', null, {reload: 'room-reservation-by-participant'});
            vm.isSaving = false;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('room-reservation-by-participant', {
                parent: 'report',
                url: '/room-reservation-by-participant',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'pcsApp.roomReservationByParticipant.home.title'
                },
                views: {
                    'content@base': {
                        templateUrl: 'app/entities/room-reservation-by-participant/room-reservation-by-participants.html',
                        controller: 'RoomReservationByParticipantController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    listFilter: ['RoomReservationByParticipantFilter', function (RoomReservationByParticipantFilter) {
                        return RoomReservationByParticipantFilter.getRoomReservationByParticipantFilter();
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('roomReservationByParticipant');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('room-reservation-by-participant.selection', {
                parent: 'room-reservation-by-participant',
                url: '/select',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'listFilter', function ($stateParams, $state, $uibModal, listFilter) {
                    $uibModal.open({
                        templateUrl: 'app/entities/room-reservation-by-participant/room-reservation-by-participant-selection-dialog.html',
                        controller: 'RoomReservationByParticipantSelectionDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            listFilter: function () {
                                return listFilter;
                            }
                        }
                    });
                }]
            });
    }


})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('RoomReservationByParticipant', RoomReservationByParticipant);

    RoomReservationByParticipant.$inject = ['$resource', 'DateUtils'];

    function RoomReservationByParticipant ($resource, DateUtils) {
        var resourceUrl =  'api/room-reservation-by-participants/:meetingCode/:hotelId';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('RoomReservationByParticipantController', RoomReservationByParticipantController);

    RoomReservationByParticipantController.$inject = ['$scope', '$state', 'RoomReservationByParticipant', 'DTOptionsBuilder', 'DTColumnDefBuilder', 'CongressSelector', 'listFilter'];

    function RoomReservationByParticipantController ($scope, $state, RoomReservationByParticipant, DTOptionsBuilder, DTColumnDefBuilder, CongressSelector, listFilter) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions();
        vm.dtOptions.withOption('order', [1, 'asc']);
        vm.dtOptions.withOption('scrollX', true);
        vm.dtOptions.withOption('stateSave', true);
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).notSortable()
        ];

        vm.listFilter = listFilter;
        vm.downloadReportXls = downloadReportXls;

        vm.roomReservationByParticipants = [];

        loadAll();

        function loadAll() {
            if (vm.listFilter.congressHotel) {
                RoomReservationByParticipant.query({
                        meetingCode: CongressSelector.getSelectedCongress().meetingCode,
                        hotelId: listFilter.congressHotel.hotel.id
                    },
                    function (result) {
                        vm.roomReservationByParticipants = result;
                    }
                );
            }
        }

        function downloadReportXls () {
            window.location.href = '/api/room-reservation-by-participants/' + CongressSelector.getSelectedCongress().meetingCode
                + '/' + listFilter.congressHotel.hotel.id.toString() + '/download-report';
        }
    }
})();

'use strict';

angular.module('pcsApp').controller('SharedRoomReservationDialogController',
    ['$scope', '$stateParams', '$uibModalInstance', 'roomReservations', 'RoomReservation', 'registrationCurrency', 'CongressSelector', 'DTOptionsBuilder', 'DTColumnBuilder', 'DTColumnDefBuilder',
        function($scope, $stateParams, $uibModalInstance, roomReservations, RoomReservation, registrationCurrency, CongressSelector, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions();
        vm.dtColumnDefs = [
            // negative int calculated from the right of the columns
            DTColumnDefBuilder.newColumnDef(-1).notSortable()
        ];

        vm.roomReservations = roomReservations;
        vm.registrationCurrency = registrationCurrency;

        var onSaveSuccess = function (result) {
            $scope.$emit('pcsApp:sharedRoomReservationUpdate', result);
            $uibModalInstance.close(result);
            //vm.isSaving = false;
        };

        var onSaveError = function (result) {
            vm.isSaving = false;
        };

        vm.save = function (rrId) {
            vm.isSaving = true;
            var sharedRoomReservation = {
                registrationId: $stateParams.registrationId,
                rrId: rrId
            };
            RoomReservation.saveShared(sharedRoomReservation, onSaveSuccess, onSaveError);
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

}]);

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('RoomReservationRegistration', RoomReservationRegistration);

    RoomReservationRegistration.$inject = ['$resource', 'DateUtils'];

    function RoomReservationRegistration ($resource, DateUtils) {
        var resourceUrl =  'api/room-reservation-registrations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateOfGroupPayment = DateUtils.convertLocalDateFromServer(data.dateOfGroupPayment);
                        data.createdDate = DateUtils.convertLocalDateFromServer(data.createdDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateOfGroupPayment = DateUtils.convertLocalDateToServer(copy.dateOfGroupPayment);
                    copy.createdDate = DateUtils.convertLocalDateToServer(copy.createdDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateOfGroupPayment = DateUtils.convertLocalDateToServer(copy.dateOfGroupPayment);
                    copy.createdDate = DateUtils.convertLocalDateToServer(copy.createdDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('RoomReservationDialogController', RoomReservationDialogController);

    RoomReservationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'RoomReservation', 'Room', 'PayingGroupItem', 'CongressSelector', 'registrationCurrency', 'invoicedChargeableItemIds'];

    function RoomReservationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity,
        RoomReservation, Room, PayingGroupItem, CongressSelector, registrationCurrency, invoicedChargeableItemIds) {
        var vm = this;

        vm.roomReservation = entity;
        vm.invoicedChargeableItemIds = invoicedChargeableItemIds;
        vm.clear = clear;
        vm.save = save;
        vm.filterChargeableItemsByCurrencyCriteria = filterChargeableItemsByCurrencyCriteria;
        vm.isDateEditable = isDateEditable;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.rooms = Room.queryByCongressId({id: CongressSelector.getSelectedCongress().id});
        vm.payingGroupItems = PayingGroupItem.queryByCongressAndItemType({id: CongressSelector.getSelectedCongress().id, itemType: 'HOTEL'});
        vm.registrationCurrency = registrationCurrency;


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.roomReservation.id !== null) {
                RoomReservation.update(vm.roomReservation, onSaveSuccess, onSaveError);
            } else {
                RoomReservation.save(vm.roomReservation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:roomReservationUpdate', result);
            $uibModalInstance.close(result);
            //vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.arrivalDate = false;
        vm.datePickerOpenStatus.departureDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function filterChargeableItemsByCurrencyCriteria(obj) {
            var re = new RegExp(this.searchText, 'i');
            return (!this.registrationCurrency || this.registrationCurrency === obj.currency.currency) &&
                (!this.searchText || re.test(obj.congressHotel.hotel.name) ||  re.test(obj.roomType));
        }

        function isDateEditable () {
            var editable = true;
            for (var i = 0; i < vm.invoicedChargeableItemIds.length; i++) {
                if (vm.invoicedChargeableItemIds[i] == vm.roomReservation.id) {
                    editable = false;
                    break;
                }
            }
            return editable;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('RoomReservationDeleteController',RoomReservationDeleteController);

    RoomReservationDeleteController.$inject = ['$uibModalInstance', 'entity', 'RoomReservation'];

    function RoomReservationDeleteController($uibModalInstance, entity, RoomReservation) {
        var vm = this;

        vm.rrr = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RoomReservation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('room-reservation', {
            abstract: true,
            parent: 'registration',
            resolve: {
                registrationCurrency: ['registrationRegistrationTypes', 'roomReservations', 'orderedOptionalServices', function (registrationRegistrationTypes, roomReservations, orderedOptionalServices) {
                    if (registrationRegistrationTypes.length) {
                        return registrationRegistrationTypes[0].chargeableItemCurrency;
                    }

                    if (roomReservations.length) {
                        return roomReservations[0].chargeableItemCurrency;
                    }

                    if (orderedOptionalServices.length) {
                        return orderedOptionalServices[0].chargeableItemCurrency;
                    }
                    return null;
                }]
            }
        })
        .state('room-reservation.new', {
            parent: 'room-reservation',
            url: '/room-reservation/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'registration', 'CongressSelector', 'registrationCurrency', function($stateParams, $state, $uibModal, registration, CongressSelector, registrationCurrency) {
                $uibModal.open({
                    templateUrl: 'app/entities/room-reservation/room-reservation-dialog.html',
                    controller: 'RoomReservationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                roomId: null,
                                shared: false,
                                arrivalDate: new Date(CongressSelector.getSelectedCongress().startDate),
                                departureDate: new Date(CongressSelector.getSelectedCongress().endDate),
                                payingGroupItemId: null,
                                id: null,
                                registrationId: registration.id,
                                '@class': 'hu.pcs.domain.RoomReservation'
                            };
                        },
                        registrationCurrency: function () {
                            return registrationCurrency;
                        },
                        invoicedChargeableItemIds: function () {
                            return [];
                        }
                    }
                }).result.then(function(result) {
                        $state.go('registration', {registrationId: registration.id}, { reload: true });
                    }, function() {
                        $state.go('registration', {registrationId: registration.id});
                    })
            }]
        })
        .state('room-reservation.shared-selection', {
            parent: 'room-reservation',
            url: '/room-reservation/shared-selection',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'registration', 'RoomReservation', 'CongressSelector', 'registrationCurrency',
                function($stateParams, $state, $uibModal, registration, RoomReservation, CongressSelector, registrationCurrency) {
                    $uibModal.open({
                        templateUrl: 'app/entities/room-reservation/shared-room-reservation-dialog.html',
                        controller: 'SharedRoomReservationDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            roomReservations: ['RoomReservation', 'CongressSelector', function(RoomReservation, CongressSelector) {
                                return RoomReservation.queryVMForSharedRoomReservations({congressId: CongressSelector.getSelectedCongress().id, registrationId: $stateParams.registrationId});
                            }],
                            registrationCurrency: function () {
                                return registrationCurrency;
                            }
                        }
                    }).result.then(function(result) {
                            $state.go('registration', {registrationId: registration.id}, { reload: true });
                        }, function() {
                            $state.go('registration', {registrationId: registration.id});
                        })
                }]
        })
        .state('room-reservation.edit', {
            parent: 'room-reservation',
            url: '/room-reservation/{rrrId}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'registration', 'registrationCurrency', function($stateParams, $state, $uibModal, registration, registrationCurrency) {
                $uibModal.open({
                    templateUrl: 'app/entities/room-reservation/room-reservation-dialog.html',
                    controller: 'RoomReservationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RoomReservation', function(RoomReservation) {
                            return RoomReservation.get({id : $stateParams.rrrId, registrationId: $stateParams.registrationId}).$promise;
                        }],
                        invoicedChargeableItemIds: ['$stateParams', 'Invoice', function ($stateParams, Invoice) {
                            return Invoice.getInvoicedChargeableItemIdsByRegistrationId({id: $stateParams.registrationId});
                        }],
                        registrationCurrency: function () {
                            return registrationCurrency;
                        }
                    }
                }).result.then(function(result) {
                        $state.go('registration', {registrationId: registration.id}, { reload: true });
                    }, function() {
                        $state.go('registration', {registrationId: registration.id});
                    })
            }]
        })
        .state('room-reservation.delete', {
            parent: 'room-reservation',
            url: '/room-reservation/{rrrId}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'registration', function($stateParams, $state, $uibModal, registration) {
                $uibModal.open({
                    templateUrl: 'app/entities/room-reservation/room-reservation-delete-dialog.html',
                    controller: 'RoomReservationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RoomReservation', function(RoomReservation) {
                            return RoomReservation.get({id : $stateParams.rrrId, registrationId: $stateParams.registrationId});
                        }]
                    }
                }).result.then(function(result) {
                        $state.go('registration', {registrationId: registration.id}, { reload: true });
                    }, function() {
                        $state.go('registration', {registrationId: registration.id});
                    })
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('RoomReservation', RoomReservation);

    RoomReservation.$inject = ['$resource', 'DateUtils'];

    function RoomReservation ($resource, DateUtils) {
        var resourceUrl =  'api/room-reservations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                url: 'api/registrations/:registrationId/room-reservations/:id',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.arrivalDate = DateUtils.convertLocalDateFromServer(data.arrivalDate);
                        data.departureDate = DateUtils.convertLocalDateFromServer(data.departureDate);
                    }
                    return data;
                }
            },
            'queryVMByRegistrationId': {
                method: 'GET',
                url: 'api/registrations/:id/room-reservation-vms',
                isArray: true
            },
            'queryByRegistrationId': {
                method: 'GET',
                url: 'api/registrations/:id/room-reservations',
                isArray: true},
            'queryVMForSharedRoomReservations': {
                method: 'GET',
                url: 'api/congresses/:congressId/registrations/:registrationId/shared-room-reservation-vms',
                isArray: true},
            'getByRoomReservationId': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.arrivalDate = DateUtils.convertLocalDateFromServer(data.arrivalDate);
                    data.departureDate = DateUtils.convertLocalDateFromServer(data.departureDate);
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.arrivalDate = DateUtils.convertLocalDateToServer(copy.arrivalDate);
                    copy.departureDate = DateUtils.convertLocalDateToServer(copy.departureDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.arrivalDate = DateUtils.convertLocalDateToServer(copy.arrivalDate);
                    copy.departureDate = DateUtils.convertLocalDateToServer(copy.departureDate);
                    return angular.toJson(copy);
                }
            },
            'saveShared': {
                method: 'POST',
                url: 'api/room-reservations/shared'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .directive('onlineRoomQuantityValidation', onlineRoomQuantityValidation);

    function onlineRoomQuantityValidation() {
        var directive = {
            scope: {
                roomId: "=",
                hotelRooms: "=",
                arrivalDate: "="
            },
            require: 'ngModel',
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc($scope, $element, $attrs, $ctrl) {
            function validation(value) {
                var room = getRoomById($scope.hotelRooms, $scope.roomId);

                if (!value || !room || !$scope.arrivalDate) {
                    $ctrl.$setValidity('quantity', true);
                    return value;
                }

                var departureDate = new Date(value);
                departureDate.setHours(0, 0, 0, 0);

                for (var i = 0; room && room.reservations && i < room.reservations.length; i++) {
                    var reservation = room.reservations[i];
                    var reservationDate = new Date(reservation.reservationDate);
                    reservationDate.setHours(0, 0, 0, 0);
                    var originalArrivalDate = $scope.arrivalDate;
                    $scope.arrivalDate = null;
                    $scope.arrivalDate = originalArrivalDate;
                    //iterate over selected arrival and departure dates
                    var arrivalDate = new Date($scope.arrivalDate);
                    arrivalDate.setHours(0, 0, 0, 0);
                    for (; arrivalDate < departureDate; arrivalDate.setDate(arrivalDate.getDate() + 1)) {
                        if (reservationDate.getTime() === arrivalDate.getTime() && reservation.reserved >= room.quantity) {
                            $ctrl.$setValidity('quantity', false);
                            return value;
                        }
                    }
                    $ctrl.$setValidity('quantity', true);
                }
                return value;
            }

            $ctrl.$parsers.push(validation);
        }
    }

    function getRoomById(hotelRooms, id) {
        if (!hotelRooms) return null;
        for (var i = 0; i < hotelRooms.length; i++) {
            var hotel = hotelRooms[i];
            for (var j = 0; j < hotel.rooms.length; j++) {

                if (hotel.rooms[j].single && hotel.rooms[j].single.id == id) {
                    return hotel.rooms[j].single;
                }

                if (hotel.rooms[j].double && hotel.rooms[j].double.id == id) {
                    return hotel.rooms[j].double;
                }
            }
        }
        return null;
    }

})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('RoomDialogController', RoomDialogController);

    RoomDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'congressHotel', 'Room', 'Congress', 'VatInfo', 'CongressSelector'];

    function RoomDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, congressHotel, Room, Congress, VatInfo, CongressSelector) {
        var vm = this;

        vm.room = entity;
        vm.congressHotel = congressHotel;
        vm.clear = clear;
        vm.save = save;
        vm.currencies = [];
        vm.vatInfos = [];
        vm.getMaxReservedRoomNumber = getMaxReservedRoomNumber;

        Congress.get({id: CongressSelector.getSelectedCongress().id}, function(data) {
            vm.currencies = data.currencies;
        });

        VatInfo.queryForCongressAndItemType({ id: CongressSelector.getSelectedCongress().id, itemType: 'HOTEL' }, function(data) {
            vm.vatInfos = data;
        });

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function createRoomEntity() {
            return {
                id: vm.room.id,
                congressHotel: {id: vm.congressHotel.id},
                roomType: vm.room.roomType,
                bed: vm.room.bed,
                quantity: vm.room.quantity,
                price: vm.room.price,
                currency: {id: vm.room.currency.id},
                vatInfo: {id: vm.room.vatInfo.id},
                onlineVisibility: vm.room.onlineVisibility,
                onlineLabel: vm.room.onlineLabel,
                onlineExternalLink: vm.room.onlineExternalLink
            };
        }

        function save () {
            vm.isSaving = true;
            if (vm.room.id !== null) {
                Room.update(createRoomEntity(), onSaveSuccess, onSaveError);
            } else {
                Room.save(createRoomEntity(), onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:roomUpdate', result);
            $uibModalInstance.close(result);
            //vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function getMaxReservedRoomNumber () {
            var reserved = 0;
            for (var i = 0; i < vm.room.reservations && vm.room.reservations.length; i++) {
                if (vm.room.reservations[i].reserved > reserved) {
                    reserved = vm.room.reservations[i].reserved;
                }
            }
            return reserved;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('RoomDeleteController',RoomDeleteController);

    RoomDeleteController.$inject = ['$uibModalInstance', 'entity', 'Room'];

    function RoomDeleteController($uibModalInstance, entity, Room) {
        var vm = this;

        vm.room = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Room.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('room', {
            parent: 'congress-hotel',
            url: '/{congressHotelId}/rooms',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pcsApp.room.home.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/room/rooms.html',
                    controller: 'RoomController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                congressHotel: ['$stateParams', 'CongressHotel', function ($stateParams, CongressHotel) {
                    return CongressHotel.get({id: $stateParams.congressHotelId}).$promise;
                }],
                rooms: ['$stateParams', 'Room', function ($stateParams, Room) {
                    return Room.queryByCongressHotelId({id: $stateParams.congressHotelId});
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('room');
                    $translatePartialLoader.addPart('onlineVisibility');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('room.new', {
            parent: 'room',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'congressHotel', function($stateParams, $state, $uibModal, congressHotel) {
                $uibModal.open({
                    templateUrl: 'app/entities/room/room-dialog.html',
                    controller: 'RoomDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                roomType: null,
                                bed: null,
                                quantity: null,
                                reserved: 0,
                                price: null,
                                id: null,
                                onlineLabel: null,
                                onlineVisibility: 'VISIBLE',
                                congressHotel: {id: $stateParams.congressHotelId }
                            };
                        },
                        congressHotel: function () {
                            return congressHotel;
                        }
                    }
                }).result.then(function() {
                    $state.go('room', null, { reload: 'room' });
                }, function() {
                    $state.go('room');
                });
            }]
        })
        .state('room.edit', {
            parent: 'room',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'congressHotel', function($stateParams, $state, $uibModal, congressHotel) {
                $uibModal.open({
                    templateUrl: 'app/entities/room/room-dialog.html',
                    controller: 'RoomDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Room', function (Room) {
                            return Room.get({id: $stateParams.id}).$promise;
                        }],
                        congressHotel: function () {
                            return congressHotel;
                        }
                    },
                }).result.then(function() {
                    $state.go('room', null, { reload: 'room' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('room.delete', {
            parent: 'room',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/room/room-delete-dialog.html',
                    controller: 'RoomDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Room', function(Room) {
                            return Room.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('room', null, { reload: 'room' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('Room', Room);

    Room.$inject = ['$resource'];

    function Room ($resource) {
        var resourceUrl =  'api/rooms/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryByCongressHotelId': {
                method: 'GET',
                url: 'api/congress-hotel/:id/rooms',
                isArray: true
            },
            'queryByCongressId': {
                method: 'GET',
                url: 'api/congress/:id/rooms',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .directive('roomQuantityValidation', RoomQuantityValidation);

    function RoomQuantityValidation() {
        var directive = {
            scope: {
                reserved: "="
            },
            require: 'ngModel',
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc($scope, $element, $attrs, $ctrl) {
            function validation(value) {
                if ($scope.reserved > value) {
                    $ctrl.$setValidity('quantity', false);
                } else {
                    $ctrl.$setValidity('quantity', true);
                }
                return value;
            }

            $ctrl.$parsers.push(validation);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('RoomController', RoomController);

    RoomController.$inject = ['$scope', '$state', 'Room', 'DTOptionsBuilder', 'DTColumnDefBuilder', 'congressHotel', 'rooms'];

    function RoomController ($scope, $state, Room, DTOptionsBuilder, DTColumnDefBuilder, congressHotel, rooms) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions();
        vm.dtOptions.withOption('stateSave', true);
        vm.dtColumnDefs = [
            // negative int calculated from the right of the columns
            DTColumnDefBuilder.newColumnDef(-1).notSortable()
        ];

        vm.congressHotel = congressHotel;
        vm.rooms = rooms;

        //loadAll();

        function loadAll() {
            Room.queryByCongressHotelId({id: vm.congressHotel.id}, function(result) {
                vm.rooms = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('report', {
            abstract: true,
            url: '/report',
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('RegistrationTypeDialogController', RegistrationTypeDialogController);

    RegistrationTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RegistrationType', 'CongressSelector', 'VatInfo', 'Congress'];

    function RegistrationTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RegistrationType, CongressSelector, VatInfo, Congress) {
        var vm = this;

        vm.registrationType = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.currencies = [];
        vm.vatInfos = [];

        Congress.get({id: CongressSelector.getSelectedCongress().id}, function(data) {
            vm.currencies = data.currencies;
        });

        VatInfo.queryForCongressAndItemType({ id: CongressSelector.getSelectedCongress().id, itemType: 'REGISTRATION' }, function(data) {
            vm.vatInfos = data;
        });


        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.registrationType.id !== null) {
                RegistrationType.update(vm.registrationType, onSaveSuccess, onSaveError);
            } else {
                RegistrationType.save(vm.registrationType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:registrationTypeUpdate', result);
            $uibModalInstance.close(result);
            //vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.firstDeadline = false;
        vm.datePickerOpenStatus.secondDeadline = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('RegistrationTypeDeleteController',RegistrationTypeDeleteController);

    RegistrationTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'RegistrationType'];

    function RegistrationTypeDeleteController($uibModalInstance, entity, RegistrationType) {
        var vm = this;

        vm.registrationType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RegistrationType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('registration-type', {
            parent: 'administration',
            url: '/registration-type',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pcsApp.registrationType.home.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/registration-type/registration-types.html',
                    controller: 'RegistrationTypeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('registrationType');
                    $translatePartialLoader.addPart('registrationTypeType');
                    $translatePartialLoader.addPart('onlineType');
                    $translatePartialLoader.addPart('onlineVisibility');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('registration-type.new', {
            parent: 'registration-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'CongressSelector', function($stateParams, $state, $uibModal, CongressSelector) {
                $uibModal.open({
                    templateUrl: 'app/entities/registration-type/registration-type-dialog.html',
                    controller: 'RegistrationTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                name: null,
                                firstRegFee: null,
                                firstDeadline: null,
                                secondRegFee: null,
                                secondDeadline: null,
                                thirdRegFee: null,
                                registrationType: null,
                                onlineLabel: null,
                                onlineOrder: null,
                                onlineVisibility: 'VISIBLE',
                                onlineType: 'NORMAL',
                                id: null,
                                congress: CongressSelector.getSelectedCongress()
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('registration-type', null, { reload: 'registration-type' });
                }, function() {
                    $state.go('registration-type');
                });
            }]
        })
        .state('registration-type.edit', {
            parent: 'registration-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/registration-type/registration-type-dialog.html',
                    controller: 'RegistrationTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RegistrationType', function(RegistrationType) {
                            return RegistrationType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('registration-type', null, { reload: 'registration-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('registration-type.delete', {
            parent: 'registration-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/registration-type/registration-type-delete-dialog.html',
                    controller: 'RegistrationTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RegistrationType', function(RegistrationType) {
                            return RegistrationType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('registration-type', null, { reload: 'registration-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('RegistrationType', RegistrationType);

    RegistrationType.$inject = ['$resource', 'DateUtils'];

    function RegistrationType ($resource, DateUtils) {
        var resourceUrl =  'api/registration-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryByCongress': {
                method: 'GET',
                url: 'api/registration-types/congress/:id',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.firstDeadline = DateUtils.convertLocalDateFromServer(data.firstDeadline);
                        data.secondDeadline = DateUtils.convertLocalDateFromServer(data.secondDeadline);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.firstDeadline = DateUtils.convertLocalDateToServer(copy.firstDeadline);
                    copy.secondDeadline = DateUtils.convertLocalDateToServer(copy.secondDeadline);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.firstDeadline = DateUtils.convertLocalDateToServer(copy.firstDeadline);
                    copy.secondDeadline = DateUtils.convertLocalDateToServer(copy.secondDeadline);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('RegistrationTypeController', RegistrationTypeController);

    RegistrationTypeController.$inject = ['$scope', '$state', 'RegistrationType', 'CongressSelector'];

    function RegistrationTypeController ($scope, $state, RegistrationType, CongressSelector) {
        var vm = this;
        
        vm.registrationTypes = [];

        loadAll();

        function loadAll() {
            RegistrationType.queryByCongress({id: CongressSelector.getSelectedCongress().id}, function(result) {
                vm.registrationTypes = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('pcsApp')
        .controller('RegistrationRegistrationTypeDialogController', RegistrationRegistrationTypeDialogController);

    RegistrationRegistrationTypeDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'registrationCurrency', 'RegistrationRegistrationType', 'RegistrationType', 'PayingGroupItem', 'CongressSelector'];

    function RegistrationRegistrationTypeDialogController ($timeout, $scope, $uibModalInstance, entity, registrationCurrency, RegistrationRegistrationType, RegistrationType, PayingGroupItem, CongressSelector) {
        var vm = this;

        vm.registrationRegistrationType = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.setRegFeeAndCurrency = setRegFeeAndCurrency;
        vm.registrationTypes = RegistrationType.queryByCongress({id: CongressSelector.getSelectedCongress().id});
        vm.payingGroupItems = PayingGroupItem.queryByCongressAndItemType({id: CongressSelector.getSelectedCongress().id, itemType: 'REGISTRATION'});
        vm.registrationCurrency = registrationCurrency;

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.registrationRegistrationType.id !== null) {
                RegistrationRegistrationType.update(vm.registrationRegistrationType, onSaveSuccess, onSaveError);
            } else {
                RegistrationRegistrationType.save(vm.registrationRegistrationType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:registrationRegistrationTypeUpdate', result);
            $uibModalInstance.close(result);
            //vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function setRegFeeAndCurrency() {
            RegistrationRegistrationType.queryRegFeeVMByRegistrationTypeId({registrationId: vm.registrationRegistrationType.registration.id, registrationTypeId: vm.registrationRegistrationType.registrationType.id}, function (result) {
                vm.registrationRegistrationType.regFee = result.regFee;
                vm.registrationRegistrationType.currency = result.currency;
            });
        }


        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.dateOfGroupPayment = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('RegistrationRegistrationTypeDeleteController',RegistrationRegistrationTypeDeleteController);

    RegistrationRegistrationTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'RegistrationRegistrationType'];

    function RegistrationRegistrationTypeDeleteController($uibModalInstance, entity, RegistrationRegistrationType) {
        var vm = this;

        vm.registrationRegistrationType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RegistrationRegistrationType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('registration-registration-type', {
            abstract: true,
            parent: 'registration',
            resolve: {
                registrationCurrency: ['registrationRegistrationTypes', 'roomReservations', 'orderedOptionalServices', function (registrationRegistrationTypes, roomReservations, orderedOptionalServices) {
                    if (registrationRegistrationTypes.length) {
                        return registrationRegistrationTypes[0].chargeableItemCurrency;
                    }

                    if (roomReservations.length) {
                        return roomReservations[0].chargeableItemCurrency;
                    }

                    if (orderedOptionalServices.length) {
                        return orderedOptionalServices[0].chargeableItemCurrency;
                    }
                    return null;
                }]
            }
        })
        .state('registration-registration-type.new', {
            parent: 'registration-registration-type',
            url: '/registration-type/new',
            data: {
                authorities: ['ROLE_USER']
            },
                onEnter: ['$stateParams', '$state', '$uibModal', 'registration', 'registrationCurrency', function($stateParams, $state, $uibModal, registration, registrationCurrency) {
                    $uibModal.open({
                        templateUrl: 'app/entities/registration-registration-type/registration-registration-type-dialog.html',
                        controller: 'RegistrationRegistrationTypeDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    regFee: null,
                                    currency: null,
                                    createdDate: new Date(),
                                    dateOfGroupPayment: null,
                                    accPeople: null,
                                    id: null,
                                    registration: registration,
                                    '@class': 'hu.pcs.domain.RegistrationRegistrationType'
                                };
                            },
                            registrationCurrency: function () {
                                return registrationCurrency;
                            }
                        }
                    }).result.then(function (result) {
                            $state.go('registration', {registrationId: registration.id}, {reload: true});
                        }, function () {
                            $state.go('registration', {registrationId: registration.id});
                        });
                }]
        })
        .state('registration-registration-type.edit', {
            parent: 'registration-registration-type',
            url: '/registration-type/{regTypeId}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'registration', 'registrationCurrency', function($stateParams, $state, $uibModal, registration, registrationCurrency) {
                $uibModal.open({
                    templateUrl: 'app/entities/registration-registration-type/registration-registration-type-dialog.html',
                    controller: 'RegistrationRegistrationTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RegistrationRegistrationType', function (RegistrationRegistrationType) {
                            return RegistrationRegistrationType.get({id: $stateParams.regTypeId}).$promise;
                        }],
                        registrationCurrency: function () {
                            return registrationCurrency;
                        }
                    }
                }).result.then(function (result) {
                        $state.go('registration', {registrationId: registration.id}, {reload: true});
                    }, function () {
                        $state.go('registration', {registrationId: registration.id});
                    });
            }]
        })
        .state('registration-registration-type.delete', {
            parent: 'registration-registration-type',
            url: '/registration-type/{regTypeId}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'registration', function($stateParams, $state, $uibModal, registration) {
                $uibModal.open({
                    templateUrl: 'app/entities/registration-registration-type/registration-registration-type-delete-dialog.html',
                    controller: 'RegistrationRegistrationTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RegistrationRegistrationType', function (RegistrationRegistrationType) {
                            return RegistrationRegistrationType.get({id: $stateParams.regTypeId}).$promise;
                        }]
                    }
                }).result.then(function (result) {
                        $state.go('registration', {registrationId: registration.id}, {reload: true});
                    }, function () {
                        $state.go('registration', {registrationId: registration.id});
                    });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('RegistrationRegistrationType', RegistrationRegistrationType);

    RegistrationRegistrationType.$inject = ['$resource', 'DateUtils'];

    function RegistrationRegistrationType ($resource, DateUtils) {
        var resourceUrl =  'api/registration-registration-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryByRegistrationId' : {
                method: 'GET',
                url: 'api/registrations/:id/registration-registration-types',
                isArray: true
            },
            'queryVMByRegistrationId' : {
                method: 'GET',
                url: 'api/registrations/:id/registration-registration-type-vms',
                isArray: true
            },
            'queryRegFeeVMByRegistrationTypeId' : {
                method: 'GET',
                url: 'api/registrations/:registrationId/registration-types/:registrationTypeId/calculate-reg-fee'
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertLocalDateFromServer(data.createdDate);
                        data.dateOfGroupPayment = DateUtils.convertLocalDateFromServer(data.dateOfGroupPayment);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.createdDate = DateUtils.convertLocalDateToServer(copy.createdDate);
                    copy.dateOfGroupPayment = DateUtils.convertLocalDateToServer(copy.dateOfGroupPayment);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.createdDate = DateUtils.convertLocalDateToServer(copy.createdDate);
                    copy.dateOfGroupPayment = DateUtils.convertLocalDateToServer(copy.dateOfGroupPayment);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('RegistrationUploadDialogController', RegistrationUploadDialogController);

    RegistrationUploadDialogController.$inject = ['$timeout', '$scope', '$state', 'uploadFile', 'DataUtils', 'Registration'];

    function RegistrationUploadDialogController ($timeout, $scope, $state, uploadFile, DataUtils, Registration) {
        var vm = this;

        vm.uploadFile = uploadFile;
        vm.back = back;
        vm.messages = [];
        vm.sendUpload = sendUpload;

        vm.setFile = setFile;
        vm.clearFile = clearFile;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        function setFile($file, pcsFile) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        pcsFile.name = $file.name;
                        pcsFile.file = base64Data;
                        pcsFile.fileContentType = $file.type ? $file.type : 'application/octet-stream';
                    });
                });
            }
        }

        function back() {
            $state.go('registration', null, { reload: true });
        }

        function clearFile(file) {
            file.name = null;
            file.file = null;
            file.fileContentType = null;
        }

        function sendUpload () {
            vm.isSaving = true;
            vm.messages = Registration.upload(vm.uploadFile, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            clearFile(vm.uploadFile);
            $scope.$emit('pcsApp:registrationUpload', result);
        }

        function onSaveError () {
        }


    }
})();

'use strict';

angular.module('pcsApp').controller('RegistrationSummaryDialogController',
    ['$scope', '$stateParams', '$uibModalInstance', 'summary', function($scope, $stateParams, $uibModalInstance, summary) {
        var vm = this;
        vm.summary = summary;
        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
}]);

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('RegistrationSearchController',RegistrationSearchController);

    RegistrationSearchController.$inject = ['$scope', '$timeout', '$uibModalInstance', '$state', 'registrationArray', 'RegIdStorage', 'DTOptionsBuilder', 'DTColumnDefBuilder'];

    function RegistrationSearchController($scope, $timeout, $uibModalInstance, $state, registrationArray, RegIdStorage, DTOptionsBuilder, DTColumnDefBuilder) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withDOM('<"html5buttons"B>ltfgitp')
            .withOption('rowCallback', rowCallback)
            .withOption('initComplete', initComplete)
            .withButtons([
            ]);

        vm.dtColumnDefs = [
        ];

        function initComplete () {
            console.log('initComplete');
            angular.element('#search-datatable_filter label input').focus();
        }

        function doubleClickHandler(info) {
            vm.search(info[0]);
        }

        function rowCallback(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
            $('td', nRow).unbind('click');
            $('td', nRow).bind('click', function() {
                $scope.$apply(function() {
                    doubleClickHandler(aData);
                });
            });
            return nRow;
        }

        vm.registrationArray = registrationArray;
        vm.search = search;
        vm.clear = clear;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function search (regId) {
            for (var i = 0; i < vm.registrationArray.length; i++) {
                if (vm.registrationArray[i].regId == regId) {
                    $state.go('registration', {registrationId: vm.registrationArray[i].id});
                }
            }
            $uibModalInstance.close(true);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('RegistrationDialogController', RegistrationDialogController);

    RegistrationDialogController.$inject = ['$timeout', '$scope', '$state', 'registration', 'Registration',
        'workplaces', 'countries', 'registrationRegistrationTypes', 'roomReservations', 'orderedOptionalServices', 'chargedServices'];

    function RegistrationDialogController ($timeout, $scope, $state, registration, Registration,
       workplaces, countries, registrationRegistrationTypes, roomReservations, orderedOptionalServices, chargedServices) {
        var vm = this;

        vm.registration = registration;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.setShortName = setShortName;
        vm.copyWorkplace = copyWorkplace;
        vm.copyInvoiceDataFromReg = copyInvoiceDataFromReg;
        vm.copyInvoiceDataFromWorkplace = copyInvoiceDataFromWorkplace;
        vm.workplaces = workplaces;
        vm.countries = countries;
        vm.registrationRegistrationTypes = registrationRegistrationTypes;
        vm.roomReservations = roomReservations;
        vm.orderedOptionalServices = orderedOptionalServices;
        vm.chargedServices = chargedServices;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function save () {
            vm.isSaving = true;
            if (vm.registration.id !== null) {
                Registration.update(vm.registration, onSaveSuccess, onSaveError);
            } else {
                Registration.save(vm.registration, onSaveSuccess, onSaveError);
            }
        }

        function clear() {
            $state.go('registration');
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:registrationUpdate', result);
            //vm.isSaving = false;
            $state.go('registration', {registrationId: result.id}, { reload: true });
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function copyWorkplace() {
            vm.registration.country = vm.registration.workplace.country;
            vm.registration.zipCode = vm.registration.workplace.zipCode;
            vm.registration.city = vm.registration.workplace.city;
            vm.registration.street = vm.registration.workplace.street;
        }

        vm.datePickerOpenStatus.dateOfApp = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function setShortName() {
            if (!vm.registration.shortName) {
                vm.registration.shortName = vm.registration.firstName.charAt(0).toUpperCase() + '.';
            }
        }

        function copyInvoiceDataFromReg() {
            vm.registration.invoiceName = vm.registration.lastName + ' ' + vm.registration.firstName;
            vm.registration.invoiceCountry = vm.registration.country;
            vm.registration.invoiceZipCode = vm.registration.zipCode;
            vm.registration.invoiceCity = vm.registration.city;
            vm.registration.invoiceAddress = vm.registration.street;
        }

        function copyInvoiceDataFromWorkplace() {
            if (vm.registration.workplace) {
                vm.registration.invoiceName = vm.registration.workplace.name;
                vm.registration.invoiceCountry = vm.registration.workplace.country;
                vm.registration.invoiceZipCode = vm.registration.workplace.zipCode;
                vm.registration.invoiceCity = vm.registration.workplace.city;
                vm.registration.invoiceAddress = vm.registration.workplace.street;
                vm.registration.invoiceTaxNumber = vm.registration.workplace.vatRegNumber;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('RegistrationDeleteController',RegistrationDeleteController);

    RegistrationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Registration'];

    function RegistrationDeleteController($uibModalInstance, entity, Registration) {
        var vm = this;

        vm.registration = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Registration.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .run(stateChangeStart)
        .config(stateConfig);

    stateChangeStart.$inject = ['$rootScope', '$state', 'Registration', 'CongressSelector', 'RegIdStorage'];
    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('registration', {
            parent: 'administration',
            url: '/registrations/{registrationId}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pcsApp.registration.detail.title'
            },
            onEnter: ['$stateParams', 'RegIdStorage', function($stateParams, RegIdStorage) {
                RegIdStorage.setLastRegId($stateParams.registrationId);
            }],
            views: {
                'content@base': {
                    templateUrl: 'app/entities/registration/registrations.html',
                    controller: 'RegistrationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                registrationArray: ['CongressSelector', 'Registration', function(CongressSelector, Registration) {
                    return Registration.queryVMByCongress({id : CongressSelector.getSelectedCongress().id});
                }],
                registration: ['$stateParams', 'Registration', function($stateParams, Registration) {
                    if($stateParams.registrationId && $stateParams.registrationId != 0) {
                        return Registration.get({id : $stateParams.registrationId}).$promise;
                    }
                    else {
                        return null;
                    }
                }],
                registrationRegistrationTypes: ['$stateParams', 'RegistrationRegistrationType', function ($stateParams, RegistrationRegistrationType) {
                    return RegistrationRegistrationType.queryVMByRegistrationId({id: $stateParams.registrationId}).$promise;
                }],
                roomReservations: ['$stateParams', 'RoomReservation', function ($stateParams, RoomReservation) {
                    return RoomReservation.queryVMByRegistrationId({id: $stateParams.registrationId}).$promise;
                }],
                orderedOptionalServices: ['$stateParams', 'OrderedOptionalService', function ($stateParams, OrderedOptionalService) {
                    return OrderedOptionalService.queryVMByRegistrationId({id: $stateParams.registrationId}).$promise;
                }],
                chargedServices: ['$stateParams', 'ChargedService', function ($stateParams, ChargedService) {
                    return ChargedService.queryByRegistrationId({id: $stateParams.registrationId}).$promise;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('registration');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('registrationRegistrationType');
                    $translatePartialLoader.addPart('roomReservation');
                    $translatePartialLoader.addPart('roomReservationRegistration');
                    $translatePartialLoader.addPart('chargedService');
                    $translatePartialLoader.addPart('orderedOptionalService');
                    $translatePartialLoader.addPart('workplace');
                    $translatePartialLoader.addPart('country');
                    $translatePartialLoader.addPart('chargedServicePaymentMode');
                    $translatePartialLoader.addPart('chargeableItemType');
                    return $translate.refresh();
                }]
            }
        })
        .state('registration.new', {
            parent: 'registration',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/registration/registration-dialog.html',
                    controller: 'RegistrationDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                registration: ['CongressSelector', function (CongressSelector) {
                    return {
                        regId: null,
                        lastName: null,
                        firstName: null,
                        shortName: null,
                        title: null,
                        position: null,
                        otherData: null,
                        department: null,
                        country: CongressSelector.getSelectedCongress().defaultCountry,
                        zipCode: null,
                        city: null,
                        street: null,
                        phone: null,
                        email: null,
                        fax: null,
                        dateOfApp: new Date(),
                        remark: null,
                        onSpot: null,
                        cancelled: null,
                        presenter: null,
                        closed: null,
                        etiquette: null,
                        id: null,
                        congress: CongressSelector.getSelectedCongress()
                    };
                }],
                workplaces: ['Workplace', 'CongressSelector', function(Workplace, CongressSelector) {
                    return Workplace.queryByCongress({id: CongressSelector.getSelectedCongress().id});
                }],
                countries: ['Country', function(Country) {
                    return Country.query();
                }]
            }
        })
        .state('registration.edit', {
            parent: 'registration',
            url: '/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/registration/registration-dialog.html',
                    controller: 'RegistrationDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                registration: ['Registration', '$stateParams', function(Registration, $stateParams) {
                    return Registration.get({id : $stateParams.registrationId}).$promise;
                }],
                workplaces: ['Workplace', 'CongressSelector', function(Workplace, CongressSelector) {
                    return Workplace.queryByCongress({ id: CongressSelector.getSelectedCongress().id });
                }],
                countries: ['Country', function(Country) {
                    return Country.query();
                }]
            }
        })
        .state('registration.delete', {
            parent: 'registration',
            url: '/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'RegIdStorage', function($stateParams, $state, $uibModal, RegIdStorage) {
                $uibModal.open({
                    templateUrl: 'app/entities/registration/registration-delete-dialog.html',
                    controller: 'RegistrationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Registration', function(Registration) {
                            return Registration.get({id : $stateParams.registrationId}).$promise;
                        }]
                    }
                }).result.then(function() {
                    RegIdStorage.setLastRegId(null);
                    $state.transitionTo('registration', null, {
                        reload: true, inherit: false, notify: true
                    });
                    //$state.go('registration', null, { reload: 'registration' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('registration.upload', {
            parent: 'registration',
            url: '/upload',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/registration/registration-upload-dialog.html',
                    controller: 'RegistrationUploadDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                uploadFile: ['CongressSelector', function(CongressSelector) {
                    return {file: null, fileContentType: null, name: null, congressId: CongressSelector.getSelectedCongress().id };
                }]
            }
        })
        .state('registration.search', {
            parent: 'registration',
            url: '/search',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'RegIdStorage', 'registrationArray', function($stateParams, $state, $uibModal, RegIdStorage, registrationArray) {
                $uibModal.open({
                    templateUrl: 'app/entities/registration/registration-search-dialog.html',
                    controller: 'RegistrationSearchController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        registrationArray: function () {
                            return registrationArray;
                        }
                    }
                }).result.then(function (result) {
                    // $state.go('registration', {registrationId: result});
                }, function () {
                    $state.go('^');
                });
            }]
        })
        .state('registration.new.workplace-new', {
            parent: 'registration.new',
            url: '/workplace/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'registration', 'workplaces', 'CongressSelector', function($stateParams, $state, $uibModal, registration, workplaces, CongressSelector) {
                $uibModal.open({
                    templateUrl: 'app/entities/workplace/workplace-dialog.html',
                    controller: 'WorkplaceDialogController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                vatRegNumber: null,
                                department: null,
                                zipCode: null,
                                city: null,
                                street: null,
                                phone: null,
                                fax: null,
                                email: null,
                                id: null,
                                congress: CongressSelector.getSelectedCongress()
                            };
                        }
                    }
                }).result.then(function(result) {
                    registration.workplace = result;
                    registration.country = registration.workplace.country;
                    registration.zipCode = registration.workplace.zipCode;
                    registration.city = registration.workplace.city;
                    registration.street = registration.workplace.street;
                    registration.phone = registration.workplace.phone;
                    registration.email = registration.workplace.email;
                    registration.fax = registration.workplace.fax;

                    workplaces.push(result);
                        $state.go('registration.new');
                    }, function() {
                        $state.go('registration.new');
                    })
            }]
        })
        .state('registration.edit.workplace-new', {
            parent: 'registration.edit',
            url: '/workplace/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'registration', 'workplaces', 'CongressSelector', function($stateParams, $state, $uibModal, registration, workplaces, CongressSelector) {
                $uibModal.open({
                    templateUrl: 'app/entities/workplace/workplace-dialog.html',
                    controller: 'WorkplaceDialogController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                vatRegNumber: null,
                                department: null,
                                zipCode: null,
                                city: null,
                                street: null,
                                phone: null,
                                fax: null,
                                email: null,
                                id: null,
                                congress: CongressSelector.getSelectedCongress()
                            };
                        }
                    }
                }).result.then(function(result) {
                    registration.workplace = result;
                    registration.country = registration.workplace.country;
                    registration.zipCode = registration.workplace.zipCode;
                    registration.city = registration.workplace.city;
                    registration.street = registration.workplace.street;
                    registration.phone = registration.workplace.phone;
                    registration.email = registration.workplace.email;
                    registration.fax = registration.workplace.fax;

                    workplaces.push(result);
                        $state.go('registration.edit');
                    }, function() {
                        $state.go('registration.edit');
                    })
            }]
        })
        .state('registration.new.country-new', {
            parent: 'registration.new',
            url: '/country/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'registration', 'countries', function($stateParams, $state, $uibModal, registration, countries) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-dialog.html',
                    controller: 'CountryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function(result) {
                    registration.country = result;
                    countries.push(result);
                    $state.go('registration.new');
                }, function() {
                    $state.go('registration.new');
                });
            }]
        })
        .state('registration.edit.country-new', {
            parent: 'registration.edit',
            url: '/country/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'registration', 'countries', function($stateParams, $state, $uibModal, registration, countries) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-dialog.html',
                    controller: 'CountryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function(result) {
                    registration.country = result;
                    countries.push(result);
                    $state.go('registration.edit');
                }, function() {
                    $state.go('registration.edit');
                });
            }]
        })
        .state('registration.summary', {
            parent: 'registration',
            url: '/summary',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'registration', function($stateParams, $state, $uibModal, registration) {
                $uibModal.open({
                    templateUrl: 'app/entities/registration/registration-summary-dialog.html',
                    controller: 'RegistrationSummaryDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        summary: ['Registration', 'CongressSelector', function(Registration, CongressSelector) {
                            return Registration.getSummary({id : CongressSelector.getSelectedCongress().id});
                        }]
                    }
                }).result.then(function(result) {
                        $state.go('registration', {registrationId: registration.id});
                    }, function() {
                        $state.go('registration', {registrationId: registration.id});
                    })
            }]
        });
    }

    function stateChangeStart($rootScope, $state, Registration, CongressSelector, RegIdStorage) {
        $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
            if (toState.name === 'registration' && !toParams.registrationId) {
                event.preventDefault();
                if (RegIdStorage.getLastRegId()) {
                    $state.go('registration', {registrationId: RegIdStorage.getLastRegId()});
                }
                else {
                    Registration.getDefault({id: CongressSelector.getSelectedCongress().id}, function (result) {
                            RegIdStorage.setLastRegId(result.id);
                            $state.go('registration', {registrationId: result.id});
                        },
                        function (result) {
                            $state.go('registration', {registrationId: 0});
                        });
                }
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('Registration', Registration);

    Registration.$inject = ['$resource', 'DateUtils'];

    function Registration ($resource, DateUtils) {
        var resourceUrl =  'api/registrations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateOfApp = DateUtils.convertLocalDateFromServer(data.dateOfApp);
                    }
                    return data;
                }
            },
            'getDefault': {
                method: 'GET',
                url: 'api/registrations/default/congress/:id',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateOfApp = DateUtils.convertLocalDateFromServer(data.dateOfApp);
                        return data;
                    }
                    else {
                        return null;
                    }
                }
            },
            'getNextIdAfterDeletedId': {
                method: 'GET',
                url: 'api/registrations/nextid-after-the-deleted-id/:id/congress/:congressId',
                transformResponse: function (data) {
                    if (data) {
                        return angular.fromJson(data);
                    }
                    else {
                        return null;
                    }
                }
            },
            'getSummary': {
                method: 'GET',
                url: 'api/registrations/summary/congress/:id',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        return data;
                    }
                    else {
                        return null;
                    }
                }
            },
            'queryByCongress': {
                method: 'GET',
                url: 'api/registrations/congress/:id',
                isArray: true
            },
            'queryVMByCongress': {
                method: 'GET',
                url: 'api/registrations/vm/congress/:id',
                isArray: true
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateOfApp = DateUtils.convertLocalDateToServer(copy.dateOfApp);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateOfApp = DateUtils.convertLocalDateToServer(copy.dateOfApp);
                    return angular.toJson(copy);
                }
            },
            'upload': {
                method: 'POST', url: '/api/registrations/upload', isArray: true
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .filter('searchRegistrationFilter', function() {
            return searchRegistrationFilter;
        });

    angular
        .module('pcsApp')
        .controller('RegistrationController', RegistrationController);

    RegistrationController.$inject = ['$scope', '$rootScope', '$stateParams', 'registration', 'registrationRegistrationTypes',
        'roomReservations', 'orderedOptionalServices', 'chargedServices', 'Registration', 'registrationArray'];

    function RegistrationController ($scope, $rootScope, $stateParams, registration, registrationRegistrationTypes,
                                     roomReservations, orderedOptionalServices, chargedServices, Registration, registrationArray) {
        var vm = this;
        vm.registration = registration;
        vm.registrationArray = registrationArray;
        vm.registrationRegistrationTypes = registrationRegistrationTypes;
        vm.roomReservations = roomReservations;
        vm.orderedOptionalServices = orderedOptionalServices;
        vm.chargedServices = chargedServices;
        vm.searchBoxVisible = false;
        vm.isSaving = false;

        vm.saveCheckboxProperties = saveCheckboxProperties;
        vm.save = save;
        vm.displayRRTAccPeople = displayRRTAccPeople;
        vm.firstRegId = firstRegId;
        vm.prevRegId = prevRegId;
        vm.nextRegId = nextRegId;
        vm.lastRegId = lastRegId;
        vm.hasPrevRegId = hasPrevRegId;
        vm.hasNextRegId = hasNextRegId;

        function saveCheckboxProperties(propertyName) {
            vm.isSaving = true;
            Registration.update(vm.registration,
                function onSaveSuccess(result) {
                    vm.isSaving = false;
                },
                function onSaveError(result) {
                    vm.isSaving = false;
                    vm.registration[propertyName] = !vm.registration[propertyName];
                }
            );
        }

        function save() {
            Registration.update(vm.registration);
        }

        function displayRRTAccPeople(rrt) {
            return rrt.registrationTypeType === 'ACCOMPANYING_FEE' ? rrt.accPeople : '';
        }

        function firstRegId() {
            return vm.registrationArray[0] && vm.registrationArray[0].id;
        }

        function prevRegId() {
            return vm.registration && vm.registrationArray[indexOfRegistrationId(vm.registration.id) - 1] && vm.registrationArray[indexOfRegistrationId(vm.registration.id) - 1].id;
        }

        function nextRegId() {
            return vm.registration && vm.registrationArray[indexOfRegistrationId(vm.registration.id) + 1] && vm.registrationArray[indexOfRegistrationId(vm.registration.id) + 1].id;
        }

        function lastRegId() {
            return vm.registrationArray[vm.registrationArray.length - 1] && vm.registrationArray[vm.registrationArray.length - 1].id;
        }

        function hasPrevRegId() {
            return vm.registration && indexOfRegistrationId(vm.registration.id) > 0;
        }

        function hasNextRegId() {
            return vm.registration && indexOfRegistrationId(vm.registration.id) < vm.registrationArray.length - 1;
        }

        function indexOfRegistrationId(id) {
            var i, idx = -1;
            for (i = 0; i < vm.registrationArray.length; i++) {
                if (id === vm.registrationArray[i].id) {
                    idx = i;
                    break;
                }
            }
            return idx;
        }

    }

    function searchRegistrationFilter(registrations, searchText) {
        if (!searchText) {
            return registrations;
        }
        var re = new RegExp(searchText);
        var out = [];
        for (var i = 0; i < registrations.length; i++) {
            if (re.test('' + registrations[i].regId) || re.test(registrations[i].firstName) || re.test(registrations[i].lastName)) {
                out.push(registrations[i]);
            }
        }
        return out;
    }

})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('regfee-details-by-participant', {
                parent: 'report',
                url: '/regfee-details-by-participant',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'pcsApp.regFeeDetailsByParticipantController.home.title'
                },
                views: {
                    'content@base': {
                        templateUrl: 'app/entities/regfee-details-by-participant/regfee-details-by-participants.html',
                        controller: 'RegFeeDetailsByParticipantController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    reportFilter: function () {
                        return {
                            regType: null
                        };
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('regFeeDetailsByParticipant');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }


})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('RegFeeDetailsByParticipant', RegFeeDetailsByParticipant);

    RegFeeDetailsByParticipant.$inject = ['$resource'];

    function RegFeeDetailsByParticipant ($resource) {
        var resourceUrl =  'api/regfee-details-by-participant';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('RegFeeDetailsByParticipantController', RegFeeDetailsByParticipantController);

    RegFeeDetailsByParticipantController.$inject = ['$scope', '$state', 'RegFeeDetailsByParticipant', 'RegistrationType', 'reportFilter',
        'DTOptionsBuilder', 'DTColumnDefBuilder', 'CongressSelector', 'B64Encoder'];

    function RegFeeDetailsByParticipantController ($scope, $state, RegFeeDetailsByParticipant, RegistrationType, reportFilter,
       DTOptionsBuilder, DTColumnDefBuilder, CongressSelector, B64Encoder) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions();
        vm.dtOptions.withOption('order', [1, 'asc']);
        vm.dtOptions.withOption('stateSave', true);
        vm.dtColumnDefs = [];

        vm.registrationTypes = RegistrationType.queryByCongress({id: CongressSelector.getSelectedCongress().id});
        vm.reportFilter = reportFilter;

        vm.search = search;
        vm.clear = clear;
        vm.isAnyFilterSet = isAnyFilterSet;
        vm.downloadReportXls = downloadReportXls;

        vm.reportList = [];

        function clear() {
            vm.reportList = [];
            vm.reportFilter.regType = null;
        }

        function buildReportFilter(reportFilter) {
            return {
                congressId: CongressSelector.getSelectedCongress().id,
                registrationType: reportFilter.regType
            };
        }

        function search() {
            RegFeeDetailsByParticipant.query({
                    query: B64Encoder.encode(JSON.stringify(buildReportFilter(vm.reportFilter)))
                },
                function (result) {
                    vm.reportList = result;
                }
            );
        }

        function isAnyFilterSet() {
            return vm.reportFilter.regType;
        }

        function downloadReportXls () {
            window.location.href = '/api/regfee-details-by-participant/download-report?query=' + B64Encoder.encode(JSON.stringify(buildReportFilter(vm.reportFilter)));
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('regfee-details', {
                parent: 'report',
                url: '/regfee-details',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'pcsApp.regFeeDetailsController.home.title'
                },
                views: {
                    'content@base': {
                        templateUrl: 'app/entities/regfee-details/regfee-details.html',
                        controller: 'RegFeeDetailsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    reportFilter: function () {
                        return {
                            regType: null
                        };
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('regFeeDetails');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }


})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('RegFeeDetails', RegFeeDetails);

    RegFeeDetails.$inject = ['$resource'];

    function RegFeeDetails ($resource) {
        var resourceUrl =  'api/regfee-details/:congressId';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('RegFeeDetailsController', RegFeeDetailsController);

    RegFeeDetailsController.$inject = ['$scope', '$state', 'RegFeeDetails', 'DTOptionsBuilder', 'DTColumnDefBuilder', 'CongressSelector'];

    function RegFeeDetailsController ($scope, $state, RegFeeDetails, DTOptionsBuilder, DTColumnDefBuilder, CongressSelector) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions();
        vm.dtOptions.withOption('order', [1, 'asc']);
        vm.dtOptions.withOption('stateSave', true);
        vm.dtColumnDefs = [];

        vm.downloadReportXls = downloadReportXls;
        vm.reportList = [];

        loadReport();

        function loadReport() {
            RegFeeDetails.query({congressId: CongressSelector.getSelectedCongress().id},
                function (result) {
                    vm.reportList = result;
                }
            );
        }

        function downloadReportXls () {
            window.location.href = '/api/regfee-details/' + CongressSelector.getSelectedCongress().id + '/download-report';
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('RateDialogController', RateDialogController);

    RateDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Rate', 'Currency'];

    function RateDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Rate, Currency) {
        var vm = this;

        vm.rate = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.currencies = Currency.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rate.id !== null) {
                Rate.update(vm.rate, onSaveSuccess, onSaveError);
            } else {
                Rate.save(vm.rate, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:rateUpdate', result);
            $uibModalInstance.close(result);
            //vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.valid = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('RateDeleteController',RateDeleteController);

    RateDeleteController.$inject = ['$uibModalInstance', 'entity', 'Rate'];

    function RateDeleteController($uibModalInstance, entity, Rate) {
        var vm = this;

        vm.rate = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Rate.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('rate', {
            parent: 'maintenance',
            url: '/rate',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pcsApp.rate.home.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/rate/rates.html',
                    controller: 'RateController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rate');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('rate.new', {
            parent: 'rate',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rate/rate-dialog.html',
                    controller: 'RateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                rate: null,
                                valid: new Date(),
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('rate', null, { reload: 'rate' });
                }, function() {
                    $state.go('rate');
                });
            }]
        })
        .state('rate.edit', {
            parent: 'rate',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rate/rate-dialog.html',
                    controller: 'RateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Rate', function(Rate) {
                            return Rate.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rate', null, { reload: 'rate' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rate.delete', {
            parent: 'rate',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rate/rate-delete-dialog.html',
                    controller: 'RateDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Rate', function(Rate) {
                            return Rate.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rate', null, { reload: 'rate' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('Rate', Rate);

    Rate.$inject = ['$resource', 'DateUtils'];

    function Rate ($resource, DateUtils) {
        var resourceUrl =  'api/rates/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.valid = DateUtils.convertLocalDateFromServer(data.valid);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.valid = DateUtils.convertLocalDateToServer(copy.valid);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.valid = DateUtils.convertLocalDateToServer(copy.valid);
                    return angular.toJson(copy);
                }
            },
            'getCurrentRate': {
                method: 'GET',
                url: 'api/rates/current/:currency',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.valid = DateUtils.convertLocalDateFromServer(data.valid);
                    }
                    return data;
                }
            },
            'getRatesForDate': {
                method: 'GET',
                url: 'api/rates/:valid-date/:currency',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.valid = DateUtils.convertLocalDateFromServer(data.valid);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('RateController', RateController);

    RateController.$inject = ['$scope', '$state', 'Rate', 'DTOptionsBuilder', 'DTColumnDefBuilder'];

    function RateController ($scope, $state, Rate, DTOptionsBuilder, DTColumnDefBuilder) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withDOM('<"html5buttons"B>ltfgitp')
            .withButtons([
                {extend: 'excel', title: 'rates'},
                {extend: 'pdf', title: 'rates'}
            ]);

        vm.dtOptions.withOption('order', [1, 'desc']);
        vm.dtOptions.withOption('stateSave', true);
        vm.dtColumnDefs = [
            // negative int calculated from the right of the columns
            DTColumnDefBuilder.newColumnDef(-1).notSortable()
        ];

        vm.rates = [];

        loadAll();

        function loadAll() {
            Rate.query(function(result) {
                vm.rates = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('ShowPaymentRefundTransactionDialogController',ShowPaymentRefundTransactionDialogController);

    ShowPaymentRefundTransactionDialogController.$inject = ['$uibModalInstance', 'DTOptionsBuilder', 'DTColumnDefBuilder', 'refunds'];

    function ShowPaymentRefundTransactionDialogController($uibModalInstance, DTOptionsBuilder, DTColumnDefBuilder, refunds) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions();
        vm.dtOptions.withOption('order', [0, 'desc']);

        vm.refunds = refunds;
        vm.clear = clear;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('PaymentTransactionRefundDialogController',PaymentTransactionRefundDialogController);

    PaymentTransactionRefundDialogController.$inject = ['$uibModalInstance', 'entity', 'PaymentTransactionReport'];

    function PaymentTransactionRefundDialogController($uibModalInstance, entity, PaymentTransactionReport) {
        var vm = this;

        vm.paymentTransaction = entity;
        vm.refundAmount = vm.paymentTransaction.amount;
        vm.clear = clear;
        vm.confirm = confirm;
        vm.isReverse = isReverse;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirm() {
            PaymentTransactionReport.refund({
                    txId: vm.paymentTransaction.transactionId,
                    amount: vm.refundAmount,
                    currency: vm.paymentTransaction.currency
                },
                function (result) {
                    $uibModalInstance.close(true);
                }
            );
        }

        function isReverse() {
            return vm.paymentTransaction.paymentTrxStatus === 'PAYMENT_WAITING_FOR_SETTLEMENT'
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('payment-transaction-report', {
                parent: 'maintenance',
                url: '/payment-transaction-report',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'pcsApp.paymentTransactionReport.home.title'
                },
                views: {
                    'content@base': {
                        templateUrl: 'app/entities/payment-transaction-report/payment-transaction-reports.html',
                        controller: 'PaymentTransactionReportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    reportFilter: function () {
                        return {
                            transactionId: null,
                            orderNumber: null,
                            fromDate: null,
                            toDate: null
                        };
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('paymentTransactionReport');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('payment-transaction-report.refund', {
                parent: 'payment-transaction-report',
                url: '/{id}/refund',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/payment-transaction-report/payment-transaction-report-refund-dialog.html',
                        controller: 'PaymentTransactionRefundDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['PaymentTransactionReport', function(PaymentTransactionReport) {
                                return PaymentTransactionReport.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('payment-transaction-report');
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('payment-transaction-report.show-payment-refund-transaction', {
                parent: 'payment-transaction-report',
                url: '/{id}/show-payment-refund-transaction',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/payment-transaction-report/show-payment-refund-transaction-dialog.html',
                        controller: 'ShowPaymentRefundTransactionDialogController',
                        controllerAs: 'vm',
                        size: 'lg',
                        resolve: {
                            refunds: ['PaymentTransactionReport', function (PaymentTransactionReport) {
                                return PaymentTransactionReport.queryPaymentRefundTransactionsByTrxId({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function() {
                        $state.go('payment-transaction-report');
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }


})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('PaymentTransactionReport', PaymentTransactionReport);

    PaymentTransactionReport.$inject = ['$resource', 'DateUtils'];

    function PaymentTransactionReport ($resource, DateUtils) {
        var resourceUrl =  'api/payment-transaction-report/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.paymentTrxDate = DateUtils.convertDateTimeFromServer(data.paymentTrxDate);
                    }
                    return data;
                }
            },
            'query': { method: 'GET', isArray: true },
            'queryPaymentRefundTransactionsByTrxId': { url: resourceUrl + '/refunds', method: 'GET', isArray: true },
            'refund': { url: resourceUrl + '/refunds', method: 'POST' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('PaymentTransactionReportController', PaymentTransactionReportController);

    PaymentTransactionReportController.$inject = ['$scope', '$state', 'reportFilter', 'PaymentTransactionReport', 'DTOptionsBuilder',
        'DTColumnDefBuilder', 'DateUtils', 'B64Encoder'];

    function PaymentTransactionReportController ($scope, $state, reportFilter, PaymentTransactionReport, DTOptionsBuilder,
        DTColumnDefBuilder, DateUtils, B64Encoder) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions();
        vm.dtOptions.withOption('order', [1, 'desc']);
        vm.dtOptions.withOption('stateSave', true);
        vm.dtColumnDefs = [
            // negative int calculated from the right of the columns
            DTColumnDefBuilder.newColumnDef(0).notSortable()
        ];

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.fromDate = false;
        vm.datePickerOpenStatus.toDate = false;
        vm.openCalendar = openCalendar;

        vm.reportFilter = reportFilter;

        vm.search = search;
        vm.clear = clear;
        vm.isAnyFilterSet = isAnyFilterSet;
        vm.downloadReportXls = downloadReportXls;

        vm.reportList = [];

        function clear() {
            vm.reportList = [];
            vm.reportFilter.orderNumber = null;
            vm.reportFilter.transactionId = null;
            vm.reportFilter.fromDate = null;
            vm.reportFilter.toDate = null;
        }

        function buildReportFilter(reportFilter) {
            return {
                orderNumber: reportFilter.orderNumber,
                transactionId: reportFilter.transactionId,
                fromDate: DateUtils.convertLocalDateToServer(reportFilter.fromDate),
                toDate: DateUtils.convertLocalDateToServer(reportFilter.toDate)
            };
        }

        function search() {
            PaymentTransactionReport.query({
                    query: B64Encoder.encode(JSON.stringify(buildReportFilter(vm.reportFilter)))
                },
                function (result) {
                    vm.reportList = result;
                }
            );
        }

        function downloadReportXls () {
            window.location.href = '/api/payment-transaction-report/download-report?query=' + B64Encoder.encode(JSON.stringify(buildReportFilter(vm.reportFilter)));
        }

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function isAnyFilterSet() {
            return vm.reportFilter.orderNumber || vm.reportFilter.transactionId || vm.reportFilter.fromDate || vm.reportFilter.toDate;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('payment-summary', {
                parent: 'report',
                url: '/payment-summary',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'pcsApp.paymentSummary.home.title'
                },
                views: {
                    'content@base': {
                        templateUrl: 'app/entities/payment-summary/payment-summarys.html',
                        controller: 'PaymentSummaryController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('paymentSummary');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }


})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('PaymentSummary', PaymentSummary);

    PaymentSummary.$inject = ['$resource'];

    function PaymentSummary ($resource) {
        var resourceUrl =  'api/payment-summary/:congressId';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('PaymentSummaryController', PaymentSummaryController);

    PaymentSummaryController.$inject = ['$scope', '$state', 'PaymentSummary', 'DTOptionsBuilder', 'DTColumnDefBuilder', 'CongressSelector'];

    function PaymentSummaryController ($scope, $state, PaymentSummary, DTOptionsBuilder, DTColumnDefBuilder, CongressSelector) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions();
        vm.dtOptions.withOption('order', [0, 'asc']);
        vm.dtOptions.withOption('stateSave', true);
        vm.dtColumnDefs = [];

        vm.downloadReportXls = downloadReportXls;
        vm.reportList = [];

        loadReport();

        function loadReport() {
            PaymentSummary.query({congressId: CongressSelector.getSelectedCongress().id},
                function (result) {
                    vm.reportList = result;
                }
            );
        }

        function downloadReportXls () {
            window.location.href = '/api/payment-summary/' + CongressSelector.getSelectedCongress().id + '/download-report';
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('PayingGroupItemDialogController', PayingGroupItemDialogController);

    PayingGroupItemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PayingGroupItem', 'PayingGroup'];

    function PayingGroupItemDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PayingGroupItem, PayingGroup) {
        var vm = this;

        vm.payingGroupItem = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.clearOtherFields = clearOtherFields;
        vm.isHotelDateDiscountVisible = isHotelDateDiscountVisible;
        vm.isFieldRequired = isFieldRequired;
        vm.payinggroups = PayingGroup.query();

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clearOtherFields(fieldType) {
            if ('VALUE' === fieldType) {
                vm.payingGroupItem.amountPercentage = null;
                vm.payingGroupItem.hotelDateFrom = null;
                vm.payingGroupItem.hotelDateTo = null;
            }
            else if ('PERCENTAGE' === fieldType) {
                vm.payingGroupItem.amountValue = null;
                vm.payingGroupItem.hotelDateFrom = null;
                vm.payingGroupItem.hotelDateTo = null;
            }
            else if ('HOTEL_DATE' === fieldType) {
                vm.payingGroupItem.amountValue = null;
                vm.payingGroupItem.amountPercentage = null;
            }
        }

        function isHotelDateDiscountVisible () {
            if (vm.payingGroupItem.chargeableItemType === 'HOTEL') {
                return true;
            }
            else {
                return false;
            }
        }

        function isFieldRequired () {
            if (vm.payingGroupItem.chargeableItemType === 'HOTEL') {
                return !vm.payingGroupItem.amountValue && !vm.payingGroupItem.amountPercentage && !(vm.payingGroupItem.hotelDateFrom || vm.payingGroupItem.hotelDateTo);
            }
            else {
                return !vm.payingGroupItem.amountValue && !vm.payingGroupItem.amountPercentage;
            }
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.payingGroupItem.id !== null) {
                PayingGroupItem.update(vm.payingGroupItem, onSaveSuccess, onSaveError);
            } else {
                PayingGroupItem.save(vm.payingGroupItem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:payingGroupItemUpdate', result);
            $uibModalInstance.close(result);
            //vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.hotelDateFrom = false;
        vm.datePickerOpenStatus.hotelDateTo = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('PayingGroupItemDeleteController',PayingGroupItemDeleteController);

    PayingGroupItemDeleteController.$inject = ['$uibModalInstance', 'entity', 'PayingGroupItem'];

    function PayingGroupItemDeleteController($uibModalInstance, entity, PayingGroupItem) {
        var vm = this;

        vm.payingGroupItem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PayingGroupItem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('paying-group-item', {
            parent: 'administration',
            url: '/paying-groups/{payingGroupId}/paying-group-items',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pcsApp.payingGroupItem.home.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/paying-group-item/paying-group-items.html',
                    controller: 'PayingGroupItemController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                payingGroup: ['$stateParams', 'PayingGroup', function ($stateParams, PayingGroup) {
                    return PayingGroup.get({id: $stateParams.payingGroupId}).$promise;
                }],
                payingGroupItems: ['$stateParams', 'PayingGroupItem', function ($stateParams, PayingGroupItem) {
                    return PayingGroupItem.queryByPayingGroup({id: $stateParams.payingGroupId});
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('payingGroupItem');
                    $translatePartialLoader.addPart('chargeableItemType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('paying-group-item.new', {
            parent: 'paying-group-item',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/paying-group-item/paying-group-item-dialog.html',
                    controller: 'PayingGroupItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                amountPercentage: null,
                                amountValue: null,
                                hotelDateFrom: null,
                                hotelDateTo: null,
                                chargeableItemType: null,
                                id: null,
                                payingGroup: {id: $stateParams.payingGroupId }
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('paying-group-item', null, { reload: 'paying-group-item' });
                }, function() {
                    $state.go('paying-group-item');
                });
            }]
        })
        .state('paying-group-item.edit', {
            parent: 'paying-group-item',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/paying-group-item/paying-group-item-dialog.html',
                    controller: 'PayingGroupItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PayingGroupItem', function(PayingGroupItem) {
                            return PayingGroupItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('paying-group-item', null, { reload: 'paying-group-item' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('paying-group-item.delete', {
            parent: 'paying-group-item',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/paying-group-item/paying-group-item-delete-dialog.html',
                    controller: 'PayingGroupItemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PayingGroupItem', function(PayingGroupItem) {
                            return PayingGroupItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('paying-group-item', null, { reload: 'paying-group-item' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('PayingGroupItem', PayingGroupItem);

    PayingGroupItem.$inject = ['$resource', 'DateUtils'];

    function PayingGroupItem ($resource, DateUtils) {
        var resourceUrl =  'api/paying-group-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryByPayingGroup': {
                method: 'GET',
                url: 'api/paying-group/:id/paying-group-items',
                isArray: true
            },
            'queryByCongressAndItemType': {
                method: 'GET',
                url: 'api/congress/:id/paying-group/paying-group-items/:itemType',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.hotelDateFrom = DateUtils.convertLocalDateFromServer(data.hotelDateFrom);
                        data.hotelDateTo = DateUtils.convertLocalDateFromServer(data.hotelDateTo);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.hotelDateFrom = DateUtils.convertLocalDateToServer(copy.hotelDateFrom);
                    copy.hotelDateTo = DateUtils.convertLocalDateToServer(copy.hotelDateTo);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.hotelDateFrom = DateUtils.convertLocalDateToServer(copy.hotelDateFrom);
                    copy.hotelDateTo = DateUtils.convertLocalDateToServer(copy.hotelDateTo);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('PayingGroupItemController', PayingGroupItemController);

    PayingGroupItemController.$inject = ['$scope', '$state', 'PayingGroupItem', 'payingGroup', 'payingGroupItems', 'DTOptionsBuilder', 'DTColumnBuilder', 'DTColumnDefBuilder'];

    function PayingGroupItemController ($scope, $state, PayingGroupItem, payingGroup, payingGroupItems, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions();
        vm.dtOptions.withOption('stateSave', true);
        vm.dtColumnDefs = [
            // negative int calculated from the right of the columns
            DTColumnDefBuilder.newColumnDef(-1).notSortable()
        ];

        vm.payingGroup = payingGroup;
        vm.payingGroupItems = payingGroupItems;

        vm.payingGroupItems = [];

        loadAll();

        function loadAll() {
            PayingGroupItem.queryByPayingGroup({id: vm.payingGroup.id}, function(result) {
                vm.payingGroupItems = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('PayingGroupDialogController', PayingGroupDialogController);

    PayingGroupDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PayingGroup', 'Country', 'Congress', 'CongressSelector'];

    function PayingGroupDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PayingGroup, Country, Congress, CongressSelector) {
        var vm = this;

        vm.payingGroup = entity;
        vm.clear = clear;
        vm.save = save;
        vm.countries = Country.query();
        vm.currencies = [];

        Congress.get({id: CongressSelector.getSelectedCongress().id}, function(data) {
            vm.currencies = data.currencies;
        });

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.payingGroup.id !== null) {
                PayingGroup.update(vm.payingGroup, onSaveSuccess, onSaveError);
            } else {
                PayingGroup.save(vm.payingGroup, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:payingGroupUpdate', result);
            $uibModalInstance.close(result);
            //vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('PayingGroupDeleteController',PayingGroupDeleteController);

    PayingGroupDeleteController.$inject = ['$uibModalInstance', 'entity', 'PayingGroup'];

    function PayingGroupDeleteController($uibModalInstance, entity, PayingGroup) {
        var vm = this;

        vm.payingGroup = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PayingGroup.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('paying-group', {
            parent: 'administration',
            url: '/paying-group',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pcsApp.payingGroup.home.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/paying-group/paying-groups.html',
                    controller: 'PayingGroupController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('payingGroup');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('paying-group.new', {
            parent: 'paying-group',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'CongressSelector', function($stateParams, $state, $uibModal, CongressSelector) {
                $uibModal.open({
                    templateUrl: 'app/entities/paying-group/paying-group-dialog.html',
                    controller: 'PayingGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                zipCode: null,
                                city: null,
                                street: null,
                                contactName: null,
                                email: null,
                                phone: null,
                                fax: null,
                                taxNumber: null,
                                id: null,
                                congress: CongressSelector.getSelectedCongress()
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('paying-group', null, { reload: 'paying-group' });
                }, function() {
                    $state.go('paying-group');
                });
            }]
        })
        .state('paying-group.edit', {
            parent: 'paying-group',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/paying-group/paying-group-dialog.html',
                    controller: 'PayingGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PayingGroup', function(PayingGroup) {
                            return PayingGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('paying-group', null, { reload: 'paying-group' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('paying-group.delete', {
            parent: 'paying-group',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/paying-group/paying-group-delete-dialog.html',
                    controller: 'PayingGroupDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PayingGroup', function(PayingGroup) {
                            return PayingGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('paying-group', null, { reload: 'paying-group' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('PayingGroup', PayingGroup);

    PayingGroup.$inject = ['$resource'];

    function PayingGroup ($resource) {
        var resourceUrl =  'api/paying-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryByCongress': {
                method: 'GET',
                url: 'api/paying-groups/congress/:id',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('PayingGroupController', PayingGroupController);

    PayingGroupController.$inject = ['$scope', '$state', 'PayingGroup', 'DTOptionsBuilder', 'DTColumnDefBuilder', 'CongressSelector'];

    function PayingGroupController ($scope, $state, PayingGroup, DTOptionsBuilder, DTColumnDefBuilder, CongressSelector) {
        var vm = this;
        $scope.dtOptions = DTOptionsBuilder.newOptions();
        $scope.dtOptions.withOption('stateSave', true);
        $scope.dtColumnDefs = [
            // negative int calculated from the right of the columns
            DTColumnDefBuilder.newColumnDef(-1).notSortable()
        ];

        vm.payingGroups = [];

        loadAll();

        function loadAll() {
            PayingGroup.queryByCongress({id: CongressSelector.getSelectedCongress().id}, function(result) {
                vm.payingGroups = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('OrderedOptionalServiceDialogController', OrderedOptionalServiceDialogController);

    OrderedOptionalServiceDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'registrationCurrency', 'OrderedOptionalService', 'OptionalService', 'PayingGroupItem', 'Registration', 'CongressSelector'];

    function OrderedOptionalServiceDialogController ($timeout, $scope, $uibModalInstance, entity, registrationCurrency, OrderedOptionalService, OptionalService, PayingGroupItem, Registration, CongressSelector) {
        var vm = this;

        vm.orderedOptionalService = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.resetParticipantsField = resetParticipantsField ;

        vm.optionalServices = OptionalService.queryByCongress({id: CongressSelector.getSelectedCongress().id});
        vm.payingGroupItems = PayingGroupItem.queryByCongressAndItemType({id: CongressSelector.getSelectedCongress().id, itemType: 'OPTIONAL_SERVICE'});
        vm.registrationCurrency = registrationCurrency;

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.orderedOptionalService.id !== null) {
                OrderedOptionalService.update(vm.orderedOptionalService, onSaveSuccess, onSaveError);
            } else {
                OrderedOptionalService.save(vm.orderedOptionalService, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:orderedOptionalServiceUpdate', result);
            $uibModalInstance.close(result);
            /*vm.isSaving = false;*/
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function resetParticipantsField () {
            vm.orderedOptionalService.participant = null;
        }

        vm.datePickerOpenStatus.dateOfGroupPayment = false;
        vm.datePickerOpenStatus.createdDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('OrderedOptionalServiceDeleteController',OrderedOptionalServiceDeleteController);

    OrderedOptionalServiceDeleteController.$inject = ['$uibModalInstance', 'entity', 'OrderedOptionalService'];

    function OrderedOptionalServiceDeleteController($uibModalInstance, entity, OrderedOptionalService) {
        var vm = this;

        vm.orderedOptionalService = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            OrderedOptionalService.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('ordered-optional-service', {
                abstract: true,
                parent: 'registration',
                resolve: {
                    registrationCurrency: ['registrationRegistrationTypes', 'roomReservations', 'orderedOptionalServices', function (registrationRegistrationTypes, roomReservations, orderedOptionalServices) {
                        if (registrationRegistrationTypes.length) {
                            return registrationRegistrationTypes[0].chargeableItemCurrency;
                        }

                        if (roomReservations.length) {
                            return roomReservations[0].chargeableItemCurrency;
                        }

                        if (orderedOptionalServices.length) {
                            return orderedOptionalServices[0].chargeableItemCurrency;
                        }
                        return null;
                    }]
                }
            })
            .state('ordered-optional-service.new', {
                parent: 'ordered-optional-service',
                url: '/optional-service/new',
                data: {
                    authorities: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', 'registration', '$uibModal', 'registrationCurrency', function($stateParams, $state, registration, $uibModal, registrationCurrency) {
                    $uibModal.open({
                        templateUrl: 'app/entities/ordered-optional-service/ordered-optional-service-dialog.html',
                        controller: 'OrderedOptionalServiceDialogController',
                        controllerAs: 'vm',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    participant: null,
                                    dateOfGroupPayment: null,
                                    createdDate: null,
                                    id: null,
                                    registration: {id: registration.id},
                                    '@class': 'hu.pcs.domain.OrderedOptionalService'
                                };
                            },
                            registrationCurrency: function () {
                                return registrationCurrency;
                            }
                        }
                    }).result.then(function(result) {
                            $state.go('registration', {registrationId: registration.id}, { reload: true });
                        }, function() {
                            $state.go('registration', {registrationId: registration.id});
                        })
                }]
            })
            .state('ordered-optional-service.edit', {
                parent: 'ordered-optional-service',
                url: '/optional-service/{optionalServiceId}/edit',
                data: {
                    authorities: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', 'registration', '$uibModal', 'registrationCurrency', function($stateParams, $state, registration, $uibModal, registrationCurrency) {
                    $uibModal.open({
                        templateUrl: 'app/entities/ordered-optional-service/ordered-optional-service-dialog.html',
                        controller: 'OrderedOptionalServiceDialogController',
                        controllerAs: 'vm',
                        size: 'lg',
                        resolve: {
                            entity: ['OrderedOptionalService', function(OrderedOptionalService) {
                                return OrderedOptionalService.get({id : $stateParams.optionalServiceId}).$promise;
                            }],
                            registrationCurrency: function () {
                                return registrationCurrency;
                            }
                        }
                    }).result.then(function(result) {
                            $state.go('registration', {registrationId: registration.id}, { reload: true });
                        }, function() {
                            $state.go('registration', {registrationId: registration.id});
                        })
                }]
            })
            .state('ordered-optional-service.delete', {
                parent: 'ordered-optional-service',
                url: '/optional-service/{optionalServiceId}/delete',
                data: {
                    authorities: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', 'registration', '$uibModal', function($stateParams, $state, registration, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/ordered-optional-service/ordered-optional-service-delete-dialog.html',
                        controller: 'OrderedOptionalServiceDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['OrderedOptionalService', function(OrderedOptionalService) {
                                return OrderedOptionalService.get({id : $stateParams.optionalServiceId}).$promise;
                            }]
                        }
                    }).result.then(function(result) {
                            $state.go('registration', {registrationId: registration.id}, { reload: true });
                        }, function() {
                            $state.go('registration', {registrationId: registration.id});
                        })
                }]
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('OrderedOptionalService', OrderedOptionalService);

    OrderedOptionalService.$inject = ['$resource', 'DateUtils'];

    function OrderedOptionalService ($resource, DateUtils) {
        var resourceUrl =  'api/ordered-optional-services/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryByRegistrationId' : {
                method: 'GET',
                url: 'api/registrations/:id/ordered-optional-services',
                isArray: true
            },
            'queryVMByRegistrationId' : {
                method: 'GET',
                url: 'api/registrations/:id/ordered-optional-service-vms',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateOfGroupPayment = DateUtils.convertLocalDateFromServer(data.dateOfGroupPayment);
                        data.createdDate = DateUtils.convertLocalDateFromServer(data.createdDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateOfGroupPayment = DateUtils.convertLocalDateToServer(copy.dateOfGroupPayment);
                    copy.createdDate = DateUtils.convertLocalDateToServer(copy.createdDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateOfGroupPayment = DateUtils.convertLocalDateToServer(copy.dateOfGroupPayment);
                    copy.createdDate = DateUtils.convertLocalDateToServer(copy.createdDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .directive('oosReservedValidation', OosReservedValidation);

    function OosReservedValidation() {
        var directive = {
            scope: {
                optionalservice: "="
            },
            require: 'ngModel',
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attr, mCtrl) {
            function validation(value) {
                if (scope.optionalservice) {
                    var reserved = scope.optionalservice.reserved + value;
                    if (scope.optionalservice.maxPerson < reserved) {
                        mCtrl.$setValidity('exceededMaxPerson', false);
                    } else {
                        mCtrl.$setValidity('exceededMaxPerson', true);
                    }
                    return value;
                }
                else {
                    mCtrl.$setValidity('exceededMaxPerson', true);
                }
            }

            mCtrl.$parsers.push(validation);
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('OptionalTextDialogController', OptionalTextDialogController);

    OptionalTextDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'OptionalText', 'Congress'];

    function OptionalTextDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, OptionalText, Congress) {
        var vm = this;

        vm.optionalText = entity;
        vm.clear = clear;
        vm.save = save;
        vm.congresses = Congress.query();

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.optionalText.id !== null) {
                OptionalText.update(vm.optionalText, onSaveSuccess, onSaveError);
            } else {
                OptionalText.save(vm.optionalText, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:optionalTextUpdate', result);
            $uibModalInstance.close(result);
            //vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('OptionalTextDeleteController',OptionalTextDeleteController);

    OptionalTextDeleteController.$inject = ['$uibModalInstance', 'entity', 'OptionalText'];

    function OptionalTextDeleteController($uibModalInstance, entity, OptionalText) {
        var vm = this;

        vm.optionalText = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            OptionalText.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('optional-text', {
            parent: 'administration',
            url: '/optional-text',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pcsApp.optionalText.home.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/optional-text/optional-texts.html',
                    controller: 'OptionalTextController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('optionalText');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('optional-text.new', {
            parent: 'optional-text',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'CongressSelector', function($stateParams, $state, $uibModal, CongressSelector) {
                $uibModal.open({
                    templateUrl: 'app/entities/optional-text/optional-text-dialog.html',
                    controller: 'OptionalTextDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                optionalText: null,
                                id: null,
                                congress: CongressSelector.getSelectedCongress()
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('optional-text', null, { reload: 'optional-text' });
                }, function() {
                    $state.go('optional-text');
                });
            }]
        })
        .state('optional-text.edit', {
            parent: 'optional-text',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/optional-text/optional-text-dialog.html',
                    controller: 'OptionalTextDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OptionalText', function(OptionalText) {
                            return OptionalText.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('optional-text', null, { reload: 'optional-text' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('optional-text.delete', {
            parent: 'optional-text',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/optional-text/optional-text-delete-dialog.html',
                    controller: 'OptionalTextDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['OptionalText', function(OptionalText) {
                            return OptionalText.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('optional-text', null, { reload: 'optional-text' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('OptionalText', OptionalText);

    OptionalText.$inject = ['$resource'];

    function OptionalText ($resource) {
        var resourceUrl =  'api/optional-texts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryByCongress': {
                method: 'GET',
                url: 'api/optional-texts/congress/:id',
                isArray: true
            },

            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('OptionalTextController', OptionalTextController);

    OptionalTextController.$inject = ['$scope', '$state', 'OptionalText', 'CongressSelector'];

    function OptionalTextController ($scope, $state, OptionalText, CongressSelector) {
        var vm = this;
        
        vm.optionalTexts = [];

        loadAll();

        function loadAll() {
            OptionalText.queryByCongress({id: CongressSelector.getSelectedCongress().id}, function(result) {
                vm.optionalTexts = result;
            });
        }
    }
})();

 (function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('OptionalServiceApplicantSelectionDialogController', OptionalServiceApplicantSelectionDialogController);

    OptionalServiceApplicantSelectionDialogController.$inject = ['$timeout', '$state', '$scope', '$stateParams', '$uibModalInstance', 'listFilter', 'OptionalService', 'CongressSelector', 'OptionalServiceApplicantFilter'];

    function OptionalServiceApplicantSelectionDialogController ($timeout, $state, $scope, $stateParams, $uibModalInstance, listFilter, OptionalService, CongressSelector, OptionalServiceApplicantFilter) {
        var vm = this;

        vm.listFilter = listFilter;
        vm.clear = clear;
        vm.select = select;
        OptionalService.queryByCongress({id: CongressSelector.getSelectedCongress().id}, function(result) {
            vm.optionalServices = result;
        });

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
            $state.go('optional-service-applicant');
        }

        function select () {
            vm.isSaving = true;
            OptionalServiceApplicantFilter.setOptionalServiceApplicantFilter(vm.listFilter);
            $uibModalInstance.close();
            $state.go('optional-service-applicant', null, {reload: 'optional-service-applicant'});
            vm.isSaving = false;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('optional-service-applicant', {
                parent: 'report',
                url: '/optional-service-applicant',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'pcsApp.optionalServiceApplicant.home.title'
                },
                views: {
                    'content@base': {
                        templateUrl: 'app/entities/optional-service-applicant/optional-service-applicants.html',
                        controller: 'OptionalServiceApplicantController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    listFilter: ['OptionalServiceApplicantFilter', function (OptionalServiceApplicantFilter) {
                        return OptionalServiceApplicantFilter.getOptionalServiceApplicantFilter();
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('optionalServiceApplicant');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('optional-service-applicant.selection', {
                parent: 'optional-service-applicant',
                url: '/select',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'listFilter', function ($stateParams, $state, $uibModal, listFilter) {
                    $uibModal.open({
                        templateUrl: 'app/entities/optional-service-applicant/optional-service-applicant-selection-dialog.html',
                        controller: 'OptionalServiceApplicantSelectionDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            listFilter: function () {
                                return listFilter;
                            }
                        }
                    });
                }]
            });
    }


})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('OptionalServiceApplicant', OptionalServiceApplicant);

    OptionalServiceApplicant.$inject = ['$resource', 'DateUtils'];

    function OptionalServiceApplicant ($resource, DateUtils) {
        var resourceUrl =  'api/optional-service-applicants/:optionalServiceId';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('OptionalServiceApplicantController', OptionalServiceApplicantController);

    OptionalServiceApplicantController.$inject = ['$scope', '$state', 'OptionalServiceApplicant', 'DTOptionsBuilder', 'DTColumnDefBuilder', 'CongressSelector', 'OptionalService', 'listFilter'];

    function OptionalServiceApplicantController ($scope, $state, OptionalServiceApplicant, DTOptionsBuilder, DTColumnDefBuilder, CongressSelector, OptionalService, listFilter) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions();
        vm.dtOptions.withOption('order', [1, 'asc']);
        vm.dtOptions.withOption('stateSave', true);
        vm.dtColumnDefs = [];

        OptionalService.queryByCongress({id: CongressSelector.getSelectedCongress().id}, function(result) {
            vm.optionalServices = result;
        });

        vm.listFilter = listFilter;
        vm.downloadReportXls = downloadReportXls;

        vm.optionalServiceApplicants = [];

        loadAll();

        function loadAll() {
            if (vm.listFilter.optionalService) {
                OptionalServiceApplicant.query({
                        optionalServiceId: listFilter.optionalService.id
                    },
                    function (result) {
                        vm.optionalServiceApplicants = result;
                    }
                );
            }
        }

        function downloadReportXls () {
            window.location.href = '/api/optional-service-applicants' +
                '/' + listFilter.optionalService.id.toString() + '/download-report';
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('OptionalServiceDialogController', OptionalServiceDialogController);

    OptionalServiceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'OptionalService', 'Currency', 'VatInfo', 'Congress', 'CongressSelector'];

    function OptionalServiceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, OptionalService, Currency, VatInfo, Congress, CongressSelector) {
        var vm = this;

        vm.optionalService = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.currencies = [];
        vm.vatInfos = [];

        Congress.get({id: CongressSelector.getSelectedCongress().id}, function(data) {
            vm.currencies = data.currencies;
        });

        VatInfo.queryForCongressAndItemType({ id: CongressSelector.getSelectedCongress().id, itemType: 'OPTIONAL_SERVICE' }, function(data) {
            vm.vatInfos = data;
        });

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.optionalService.id !== null) {
                OptionalService.update(vm.optionalService, onSaveSuccess, onSaveError);
            } else {
                OptionalService.save(vm.optionalService, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:optionalServiceUpdate', result);
            $uibModalInstance.close(result);
            //vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('OptionalServiceDeleteController',OptionalServiceDeleteController);

    OptionalServiceDeleteController.$inject = ['$uibModalInstance', 'entity', 'OptionalService'];

    function OptionalServiceDeleteController($uibModalInstance, entity, OptionalService) {
        var vm = this;

        vm.optionalService = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            OptionalService.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('optional-service', {
            parent: 'administration',
            url: '/optional-service',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pcsApp.optionalService.home.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/optional-service/optional-services.html',
                    controller: 'OptionalServiceController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('optionalService');
                    $translatePartialLoader.addPart('onlineVisibility');
                    $translatePartialLoader.addPart('onlineType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('optional-service.new', {
            parent: 'optional-service',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'CongressSelector', function($stateParams, $state, $uibModal, CongressSelector) {
                $uibModal.open({
                    templateUrl: 'app/entities/optional-service/optional-service-dialog.html',
                    controller: 'OptionalServiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                name: null,
                                startDate: new Date(CongressSelector.getSelectedCongress().startDate),
                                endDate: new Date(CongressSelector.getSelectedCongress().endDate),
                                price: null,
                                maxPerson: null,
                                reserved: 0,
                                onlineLabel: null,
                                onlineOrder: null,
                                onlineVisibility: 'VISIBLE',
                                onlineType: 'NORMAL',
                                id: null,
                                congress: CongressSelector.getSelectedCongress()
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('optional-service', null, { reload: 'optional-service' });
                }, function() {
                    $state.go('optional-service');
                });
            }]
        })
        .state('optional-service.edit', {
            parent: 'optional-service',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/optional-service/optional-service-dialog.html',
                    controller: 'OptionalServiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OptionalService', function(OptionalService) {
                            return OptionalService.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('optional-service', null, { reload: 'optional-service' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('optional-service.delete', {
            parent: 'optional-service',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/optional-service/optional-service-delete-dialog.html',
                    controller: 'OptionalServiceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['OptionalService', function(OptionalService) {
                            return OptionalService.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('optional-service', null, { reload: 'optional-service' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('OptionalService', OptionalService);

    OptionalService.$inject = ['$resource', 'DateUtils'];

    function OptionalService ($resource, DateUtils) {
        var resourceUrl =  'api/optional-services/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryByCongress': {
                method: 'GET',
                url: 'api/optional-services/congress/:id',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertLocalDateFromServer(data.startDate);
                        data.endDate = DateUtils.convertLocalDateFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .directive('optionalServiceMaxPersonValidation', OptionalServiceMaxPersonValidation);

    function OptionalServiceMaxPersonValidation() {
        var directive = {
            scope: {
                reserved: "="
            },
            require: 'ngModel',
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc($scope, $element, $attrs, $ctrl) {
            function validation(value) {
                if ($scope.reserved > value) {
                    $ctrl.$setValidity('maxPerson', false);
                } else {
                    $ctrl.$setValidity('maxPerson', true);
                }
                return value;
            }

            $ctrl.$parsers.push(validation);
        }
    }

})();
(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('OptionalServiceController', OptionalServiceController);

    OptionalServiceController.$inject = ['$scope', '$state', 'OptionalService', 'CongressSelector'];

    function OptionalServiceController ($scope, $state, OptionalService, CongressSelector) {
        var vm = this;
        
        vm.optionalServices = [];

        loadAll();

        function loadAll() {
            OptionalService.queryByCongress({id: CongressSelector.getSelectedCongress().id}, function(result) {
                vm.optionalServices = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('optional-programs-members', {
                parent: 'report',
                url: '/optional-programs-members',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'pcsApp.optionalProgramsMembers.home.title'
                },
                views: {
                    'content@base': {
                        templateUrl: 'app/entities/optional-programs-members/optional-programs-members.html',
                        controller: 'OptionalProgramsMembersController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('optionalProgramsMembers');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }


})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('OptionalProgramsMembers', OptionalProgramsMembers);

    OptionalProgramsMembers.$inject = ['$resource', 'DateUtils'];

    function OptionalProgramsMembers ($resource, DateUtils) {
        var resourceUrl =  'api/optional-program-members/:congressId';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('OptionalProgramsMembersController', OptionalProgramsMembersController);

    OptionalProgramsMembersController.$inject = ['$scope', '$state', 'OptionalProgramsMembers', 'DTOptionsBuilder', 'DTColumnDefBuilder', 'CongressSelector', 'OptionalService'];

    function OptionalProgramsMembersController ($scope, $state, OptionalProgramsMembers, DTOptionsBuilder, DTColumnDefBuilder, CongressSelector, OptionalService) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions();
        vm.dtOptions.withOption('order', [1, 'asc']);
        vm.dtOptions.withOption('stateSave', true);
        vm.dtColumnDefs = [
/*
            DTColumnDefBuilder.newColumnDef(6).notSortable(),
            DTColumnDefBuilder.newColumnDef(7).notSortable(),
            DTColumnDefBuilder.newColumnDef(8).notSortable()
*/
        ];

        vm.downloadReportXls = downloadReportXls;

        vm.optionalProgramsMembers = [];

        loadAll();

        function loadAll() {
            OptionalProgramsMembers.query({
                    congressId: CongressSelector.getSelectedCongress().id
                },
                function (result) {
                    vm.optionalProgramsMembers = result;
                }
            );
        }

        function downloadReportXls () {
            window.location.href = '/api/optional-program-members' +
                '/' + CongressSelector.getSelectedCongress().id.toString() + '/download-report';
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('OnlineRegDiscountCodeDialogController', OnlineRegDiscountCodeDialogController);

    OnlineRegDiscountCodeDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'OnlineRegDiscountCode'];

    function OnlineRegDiscountCodeDialogController ($timeout, $scope, $uibModalInstance, entity, OnlineRegDiscountCode) {
        var vm = this;

        vm.discountCode = entity;
        vm.clear = clear;
        vm.save = save;
        vm.onDiscountTypeChanged = onDiscountTypeChanged;

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.discountCode.id !== null) {
                OnlineRegDiscountCode.update(vm.discountCode, onSaveSuccess, onSaveError);
            } else {
                OnlineRegDiscountCode.save(vm.discountCode, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:onlineRegDiscountCodeUpdate', result);
            $uibModalInstance.close(result);
            //vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function onDiscountTypeChanged() {
            if (vm.discountCode.discountType === '') {
                vm.discountCode.discountType = null;
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('OnlineRegDiscountCodeDeleteController',OnlineRegDiscountCodeDeleteController);

    OnlineRegDiscountCodeDeleteController.$inject = ['$uibModalInstance', 'entity', 'OnlineRegDiscountCode'];

    function OnlineRegDiscountCodeDeleteController($uibModalInstance, entity, OnlineRegDiscountCode) {
        var vm = this;

        vm.discountCode = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            OnlineRegDiscountCode.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('online-reg-discount-code', {
            parent: 'maintenance',
            url: '/congress/{congressId}/online-reg-discount-codes',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pcsApp.onlineRegDiscountCode.home.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/online-reg-discount-code/online-reg-discount-codes.html',
                    controller: 'OnlineRegDiscountCodeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                congress: ['$stateParams', 'Congress', function ($stateParams, Congress) {
                    return Congress.get({id: $stateParams.congressId}).$promise;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('onlineRegDiscountCode');
                    $translatePartialLoader.addPart('chargeableItemType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('online-reg-discount-code.new', {
            parent: 'online-reg-discount-code',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/online-reg-discount-code/online-reg-discount-code-dialog.html',
                    controller: 'OnlineRegDiscountCodeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null,
                                code: null,
                                discountPercentage: null,
                                discountType: null,
                                congress: {id: $stateParams.congressId }
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('online-reg-discount-code', null, { reload: 'online-reg-discount-code' });
                }, function() {
                    $state.go('online-reg-discount-code');
                });
            }]
        })
        .state('online-reg-discount-code.edit', {
            parent: 'online-reg-discount-code',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/online-reg-discount-code/online-reg-discount-code-dialog.html',
                    controller: 'OnlineRegDiscountCodeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OnlineRegDiscountCode', function (OnlineRegDiscountCode) {
                            return OnlineRegDiscountCode.get({id: $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('online-reg-discount-code', null, { reload: 'online-reg-discount-code' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('online-reg-discount-code.delete', {
            parent: 'online-reg-discount-code',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/online-reg-discount-code/online-reg-discount-code-delete-dialog.html',
                    controller: 'OnlineRegDiscountCodeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['OnlineRegDiscountCode', function(OnlineRegDiscountCode) {
                            return OnlineRegDiscountCode.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('online-reg-discount-code', null, { reload: 'online-reg-discount-code' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('OnlineRegDiscountCode', OnlineRegDiscountCode);

    OnlineRegDiscountCode.$inject = ['$resource'];

    function OnlineRegDiscountCode ($resource) {
        var resourceUrl = 'api/online-reg-discount-codes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryByCongressId': {
                method: 'GET',
                url: resourceUrl +'/congress',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('OnlineRegDiscountCodeController', OnlineRegDiscountCodeController);

    OnlineRegDiscountCodeController.$inject = ['$scope', '$state', '$stateParams', 'OnlineRegDiscountCode', 'DTOptionsBuilder', 'DTColumnDefBuilder', 'congress'];

    function OnlineRegDiscountCodeController ($scope, $state, $stateParams, OnlineRegDiscountCode, DTOptionsBuilder, DTColumnDefBuilder, congress) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions();
        vm.dtOptions.withOption('stateSave', true);
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(-1).notSortable()
        ];

        vm.congress = congress;

        loadAll();

        function loadAll() {
            OnlineRegDiscountCode.queryByCongressId({id: $stateParams.congressId}, function(result) {
                vm.discountCodes = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('OnlineRegCustomQuestionDialogController', OnlineRegCustomQuestionDialogController);

    OnlineRegCustomQuestionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'OnlineRegCustomQuestion', 'Congress'];

    function OnlineRegCustomQuestionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, OnlineRegCustomQuestion, Congress) {
        var vm = this;

        vm.onlineRegCustomQuestion = entity;
        vm.clear = clear;
        vm.save = save;
        vm.appendSelectableValue = appendSelectableValue;
        vm.deleteFromSelectableValues = deleteFromSelectableValues;

        Congress.getOnlineRegCurrenciesByCongressId({ id: vm.onlineRegCustomQuestion.congress.id } , function (result) {
            vm.currencies = result;
        });

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.onlineRegCustomQuestion.id !== null) {
                OnlineRegCustomQuestion.update(vm.onlineRegCustomQuestion, onSaveSuccess, onSaveError);
            } else {
                OnlineRegCustomQuestion.save(vm.onlineRegCustomQuestion, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:onlineRegCustomQuestionUpdate', result);
            $uibModalInstance.close(result);
            //vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function appendSelectableValue(values, idx) {
            var newValues = [];
            for (var i = 0; i < values.length; i++) {
                newValues.push(values[i]);
            }
            newValues.splice(idx, 0, "");

            values.splice(0, values.length);
            for (i = 0; i < newValues.length; i++) {
                values.push(newValues[i]);
            }
        }

        function deleteFromSelectableValues(values, idx) {
            values.splice(idx, 1);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('OnlineRegCustomQuestionDeleteController',OnlineRegCustomQuestionDeleteController);

    OnlineRegCustomQuestionDeleteController.$inject = ['$uibModalInstance', 'entity', 'OnlineRegCustomQuestion'];

    function OnlineRegCustomQuestionDeleteController($uibModalInstance, entity, OnlineRegCustomQuestion) {
        var vm = this;

        vm.onlineRegCustomQuestion = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            OnlineRegCustomQuestion.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('online-reg-custom-question', {
            parent: 'congress',
            url: '/{congressId}/online-reg-custom-questions',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/online-reg-custom-question/online-reg-custom-questions.html',
                    controller: 'OnlineRegCustomQuestionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                congress: ['Congress', '$stateParams', function(Congress, $stateParams) {
                    return Congress.get({id : $stateParams.congressId}).$promise;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('onlineRegCustomQuestion');
                    $translatePartialLoader.addPart('onlineVisibility');
                    return $translate.refresh();
                }]
            }
        })
        .state('online-reg-custom-question.new', {
            parent: 'online-reg-custom-question',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/online-reg-custom-question/online-reg-custom-question-dialog.html',
                    controller: 'OnlineRegCustomQuestionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null,
                                question: null,
                                questionOrder: null,
                                questionAnswers: [],
                                currency: null,
                                required: false,
                                onlineVisibility: 'VISIBLE',
                                congress: { id: $stateParams.congressId }
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('online-reg-custom-question', null, { reload: 'online-reg-custom-question' });
                }, function() {
                    $state.go('online-reg-custom-question');
                });
            }]
        })
        .state('online-reg-custom-question.edit', {
            parent: 'online-reg-custom-question',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/online-reg-custom-question/online-reg-custom-question-dialog.html',
                    controller: 'OnlineRegCustomQuestionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OnlineRegCustomQuestion', function(OnlineRegCustomQuestion) {
                            return OnlineRegCustomQuestion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('online-reg-custom-question', null, { reload: 'online-reg-custom-question' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('online-reg-custom-question.delete', {
            parent: 'online-reg-custom-question',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/online-reg-custom-question/online-reg-custom-question-delete-dialog.html',
                    controller: 'OnlineRegCustomQuestionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['OnlineRegCustomQuestion', function(OnlineRegCustomQuestion) {
                            return OnlineRegCustomQuestion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('online-reg-custom-question', null, { reload: 'online-reg-custom-question' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('OnlineRegCustomQuestion', OnlineRegCustomQuestion);

    OnlineRegCustomQuestion.$inject = ['$resource'];

    function OnlineRegCustomQuestion ($resource) {
        var resourceUrl =  '/api/congresses/online/custom-questions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('OnlineRegCustomQuestionController', OnlineRegCustomQuestionController);

    OnlineRegCustomQuestionController.$inject = ['$state', '$stateParams', 'Congress', 'congress', 'DTOptionsBuilder', 'DTColumnDefBuilder'];

    function OnlineRegCustomQuestionController ($state, $stateParams, Congress, congress, DTOptionsBuilder, DTColumnDefBuilder) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions();
        vm.dtOptions.withOption('order', [1, 'asc']);
        vm.dtOptions.withOption('stateSave', true);
        vm.dtColumnDefs = [
            // negative int calculated from the right of the columns
            DTColumnDefBuilder.newColumnDef(-1).notSortable()
        ];

        vm.congress = congress;
        vm.questions = [];

        loadAll();

        function loadAll() {
            Congress.getOnlineRegCustomQuestions({id: $stateParams.congressId}, function(result) {
                vm.questions = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('online-reg-custom-answer-report', {
                parent: 'report',
                url: '/online-reg-custom-answer-report',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'pcsApp.onlineRegCustomAnswerReportController.home.title'
                },
                views: {
                    'content@base': {
                        templateUrl: 'app/entities/online-reg-custom-answer-report/online-reg-custom-answer-reports.html',
                        controller: 'OnlineRegCustomAnswerReportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    reportFilter: function () {
                        return {
                            currency: null
                        };
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('onlineRegCustomAnswerReport');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('online-reg-custom-answer-report.detail', {
                parent: 'online-reg-custom-answer-report',
                url: '/{id}/detail',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/online-reg-custom-answer-report/online-reg-custom-answer-detail-dialog.html',
                        controller: 'OnlineRegCustomAnswerDetailDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                        }
                    }).result.then(function () {
                        $state.go('^', {}, {reload: false});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }


})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('OnlineRegCustomAnswerReport', OnlineRegCustomAnswerReport);

    OnlineRegCustomAnswerReport.$inject = ['$resource'];

    function OnlineRegCustomAnswerReport ($resource) {
        var resourceUrl =  'api/online-reg-custom-answer-report';

        return $resource(resourceUrl, {}, {
            'getCustomAnswers': { url: resourceUrl + '/:meetingCode/:currency', method: 'GET', isArray: true},
            'getAnswersByRegId': { url: resourceUrl + '/registration/:id', method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('OnlineRegCustomAnswerReportController', OnlineRegCustomAnswerReportController);

    OnlineRegCustomAnswerReportController.$inject = ['$scope', '$state', 'OnlineRegCustomAnswerReport', 'Congress', 'reportFilter',
        'DTOptionsBuilder', 'DTColumnDefBuilder', 'CongressSelector'];

    function OnlineRegCustomAnswerReportController ($scope, $state, OnlineRegCustomAnswerReport, Congress, reportFilter,
       DTOptionsBuilder, DTColumnDefBuilder, CongressSelector) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions();
        vm.dtOptions.withOption('order', [1, 'asc']);
        vm.dtOptions.withOption('stateSave', true);
        vm.dtColumnDefs = [
            // negative int calculated from the right of the columns
            DTColumnDefBuilder.newColumnDef(-1).notSortable()
        ];

        Congress.get({id: CongressSelector.getSelectedCongress().id}, function(data) {
            vm.currencies = data.onlineRegCurrencies;
        });
        vm.reportFilter = reportFilter;

        vm.search = search;
        vm.clear = clear;
        vm.isAnyFilterSet = isAnyFilterSet;
        vm.downloadReportXls = downloadReportXls;

        vm.reportList = [];

        function clear() {
            vm.reportList = [];
            vm.reportFilter.currency = null;
        }

        function search() {
            OnlineRegCustomAnswerReport.getCustomAnswers({meetingCode: CongressSelector.getSelectedCongress().meetingCode, currency: vm.reportFilter.currency.currency},
                function (result) {
                    vm.reportList = result;
                }
            );
        }

        function isAnyFilterSet() {
            return vm.reportFilter.regType;
        }

        function downloadReportXls () {
            window.location.href = 'api/online-reg-custom-answer-report/' + CongressSelector.getSelectedCongress().meetingCode + '/' + vm.reportFilter.currency.currency + '/download-report';
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('OnlineRegCustomAnswerDetailDialogController', OnlineRegCustomAnswerDetailDialogController);

    OnlineRegCustomAnswerDetailDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'OnlineRegCustomAnswerReport'];

    function OnlineRegCustomAnswerDetailDialogController ($timeout, $scope, $stateParams, $uibModalInstance, OnlineRegCustomAnswerReport) {
        var vm = this;

        vm.clear = clear;

        OnlineRegCustomAnswerReport.getAnswersByRegId({id: $stateParams.id}, function(result) {
            vm.customAnswers = result;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('OnlineRegPaymentResultController', OnlineRegPaymentResultController);

    OnlineRegPaymentResultController.$inject = ['$timeout', '$state', '$stateParams', 'OnlineReg', 'paymentResult'];

    function OnlineRegPaymentResultController ($timeout, $state, $stateParams, OnlineReg, paymentResult) {
        var vm = this;
        vm.paymentResult = paymentResult;

        vm.headerStyle = headerStyle;
        vm.getErrorStatus = getErrorStatus;

        setStripePaymentStatus();

        function headerStyle() {
            return vm.paymentResult && vm.paymentResult.colorCode ? { 'color': '#ffffff', 'background-color': vm.paymentResult.colorCode } : {};
        }

        function setStripePaymentStatus() {
            OnlineReg.setStripePaymentStatus({txId: $stateParams.txid});
        }

        function getErrorStatus() {
            if (vm.paymentResult.paymentTrxResultCode === '0') {
                if (vm.paymentResult.paymentTrxStatus === 'PAYMENT_CANCELLED') {
                    return 'paymentCancelled';
                }
                else if (vm.paymentResult.paymentTrxStatus === 'PAYMENT_DENIED') {
                    if (vm.paymentResult.paymentTrxResultMessage === 'Session expired') {
                        return 'sessionExpired';
                    }
                    else {
                        return 'paymentDenied';
                    }
                }
                else {
                    return 'generalError';
                }
            }
            else if (vm.paymentResult.paymentTrxResultCode === '120') {
                return 'merchantBlocked';
            }
            else if (vm.paymentResult.paymentTrxResultCode === '130') {
                return 'sessionExpired';
            }
            else if (vm.paymentResult.paymentTrxResultCode === '140') {
                return 'paymentNotFound';
            }
            else {
                return 'generalError';
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('OnlineRegErrorController', OnlineRegErrorController);

    OnlineRegErrorController.$inject = ['$timeout', '$filter', '$scope', '$state', '$stateParams', '$translate', 'tmhDynamicLocale', 'congress'];

    function OnlineRegErrorController ($timeout, $filter, $scope, $state, $stateParams, $translate, tmhDynamicLocale, congress) {
        var vm = this;
        vm.errorId = $stateParams.errorId ? $stateParams.errorId : 'unknown-error';
        vm.language = $stateParams.language;
        vm.congress = congress;

        if (vm.language) {
            $translate.use(vm.language);
            tmhDynamicLocale.set(vm.language);
        } else if (vm.congress) {
            vm.config = vm.congress.onlineRegConfig;
            $translate.use(vm.config.defaultLanguage);
            tmhDynamicLocale.set(vm.config.defaultLanguage);
        }

        vm.headerStyle = headerStyle;

        function headerStyle() {
            return vm.config && vm.config.colorCode ? {'color': '#ffffff', 'background-color': vm.config.colorCode } : {};
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('online-reg', {
                parent: 'base',
                url: '/registration/online/form/{uuid}/{currency}/{language}',
                data: {
                    authorities: [],
                    pageTitle: 'pcsApp.onlineReg.home.title'
                },
                views: {
                    'base@': {
                        templateUrl: 'app/entities/online-reg/online-reg-form.html',
                        controller: 'OnlineRegController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    congress: ['OnlineReg', '$state', '$stateParams', function (OnlineReg, $state, $stateParams) {
                        return OnlineReg.getCongress({uuid: $stateParams.uuid}).$promise.then(function (result) {
                            if (result.onlineRegCurrencies.indexOf($stateParams.currency) === -1) {
                                $state.go('online-reg-error', {
                                    uuid: $stateParams.uuid,
                                    currency: $stateParams.currency,
                                    language: $stateParams.language,
                                    errorId: 'currency-not-exist'
                                }, {reload: true});
                            }
                            else if (result.onlineRegConfig.closed) {
                                $state.go('online-reg-error', {
                                    uuid: $stateParams.uuid,
                                    currency: $stateParams.currency,
                                    language: $stateParams.language,
                                    errorId: 'congress-closed'
                                }, {reload: true});
                            }
                            else {
                                return result;
                            }
                        }, function (error) {
                            return $state.go('online-reg-error', {
                                uuid: $stateParams.uuid,
                                currency: $stateParams.currency,
                                language: $stateParams.language,
                                errorId: 'congress-not-exist'
                            }, {reload: true});
                        });
                    }],
                    registration: ['$stateParams', function ($stateParams) {
                        return { // in clear function as well!!!
                            title: null,
                            lastName: null,
                            firstName: null,
                            position: null,
                            department: null,
                            workplace: null,
                            zipCode: null,
                            city: null,
                            country: null,
                            street: null,
                            phone: null,
                            email: null,
                            email2: null,
                            otherData: null,
                            room: null,
                            arrivalDate: null,
                            departureDate: null,
                            roommate: null,
                            roomRemark: null,
                            regType: null,
                            extraRegTypes: {},
                            optionalServices: {},
                            customAnswers: {},
                            paymentMethod: null,
                            cardType: null,
                            checkName: null,
                            checkAddress: null,
                            cardHolderName: null,
                            cardHolderAddress: null,
                            cardNumber: null,
                            cardExpiryMonth: null,
                            cardExpiryYear: null,
                            invoiceName: null,
                            invoiceCountry: null,
                            invoiceZipCode: null,
                            invoiceCity: null,
                            invoiceAddress: null,
                            invoiceReferenceNumber: null,
                            invoiceTaxNumber: null,
                            termsAndConditions: null,
                            discountCode: null,
                            discountPercentage: null,
                            discountType: null,
                            gdpr: null,
                            newsletter: null,
                            currency: null,
                            uuid: $stateParams.uuid
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('onlineReg');
                        return $translate.refresh();
                    }]
                }
            })
            .state('online-reg-error', {
                parent: 'base',
                url: '/registration/online/{uuid}/{currency}/{language}/error/{errorId}',
                data: {
                    authorities: [],
                    pageTitle: 'pcsApp.onlineReg.home.errorTitle'
                },
                views: {
                    'base@': {
                        templateUrl: 'app/entities/online-reg/online-reg-error.html',
                        controller: 'OnlineRegErrorController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    congress: ['OnlineReg', '$state', '$stateParams', function (OnlineReg, $state, $stateParams) {
                        return OnlineReg.getCongress({uuid: $stateParams.uuid}).$promise.then(function (result) {
                            return result;
                        }, function (error) {
                            return null;
                        });
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('onlineReg');
                        return $translate.refresh();
                    }]
                }
            })
            .state('online-reg-payment-success', {
                parent: 'base',
                url: '/registration/online/payment/result/success?txid',
                params: {
                    txid: null
                },
                data: {
                    authorities: [],
                    pageTitle: 'pcsApp.onlineReg.home.successTitle'
                },
                views: {
                    'base@': {
                        templateUrl: 'app/entities/online-reg/online-reg-payment-success.html',
                        controller: 'OnlineRegPaymentResultController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    paymentResult: ['OnlineReg', '$state', '$stateParams', function (OnlineReg, $state, $stateParams) {
                        return OnlineReg.getPaymentResult({txid: $stateParams.txid}).$promise.then(function (result) {
                            return result;
                        }, function (error) {
                            return null;
                        });
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('onlineReg');
                        return $translate.refresh();
                    }]
                }
            })
            .state('online-reg-payment-failure', {
                parent: 'base',
                url: '/registration/online/payment/result/failure?txid',
                params: {
                    txid: null
                },
                data: {
                    authorities: [],
                    pageTitle: 'pcsApp.onlineReg.home.errorTitle'
                },
                views: {
                    'base@': {
                        templateUrl: 'app/entities/online-reg/online-reg-payment-failure.html',
                        controller: 'OnlineRegPaymentResultController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    paymentResult: ['OnlineReg', '$state', '$stateParams', function (OnlineReg, $state, $stateParams) {
                        return OnlineReg.getPaymentResult({txid: $stateParams.txid}).$promise.then(function (result) {
                            return result;
                        }, function (error) {
                            return null;
                        });
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('onlineReg');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

(function () {
    'use strict';

    angular.module('pcsApp')
        .factory('OnlineReg', OnlineReg);

    OnlineReg.$inject = ['$resource', 'DateUtils'];

    function OnlineReg($resource, DateUtils) {
        var resourceUrl = '/api/registration/online';

        return $resource(resourceUrl, {}, {
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.arrivalDate = DateUtils.convertLocalDateToServer(copy.arrivalDate);
                    copy.departureDate = DateUtils.convertLocalDateToServer(copy.departureDate);
                    return angular.toJson(copy);
                }
            },
            'setStripePaymentStatus': {
                method: 'POST',
                url: resourceUrl + '/stripe/payment/status'
            },
            'getCongress': {
                method: 'GET',
                url: resourceUrl + '/congress/:uuid',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertLocalDateFromServer(data.startDate);
                        data.endDate = DateUtils.convertLocalDateFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'getDiscountCode': {
                method: 'GET',
                url: resourceUrl + '/congress/:uuid/online-reg-discount-code/:code'
            },
            'getPaymentResult': {
                method: 'GET',
                url: resourceUrl + '/payment/result/:txid'
            },
            'queryCountries': { method: 'GET', url: resourceUrl + '/country', isArray: true},
            'queryRegistrationTypes': { method: 'GET', url: resourceUrl + '/congress/:uuid/registration-type/:currency', isArray: true},
            'queryHotelRooms': { method: 'GET', url: resourceUrl + '/congress/:uuid/hotel-room/:currency', isArray: true},
            'queryOptionalServices': { method: 'GET', url: resourceUrl + '/congress/:uuid/optional-service/:currency', isArray: true},
            'queryCustomQuestions': { method: 'GET', url: resourceUrl + '/congress/:uuid/custom-questions/:currency', isArray: true}
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('OnlineRegController', OnlineRegController);

    OnlineRegController.$inject = ['$timeout', '$filter', '$scope', '$state', '$stateParams', '$translate', 'tmhDynamicLocale', 'congress', 'registration', 'OnlineReg'];

    function OnlineRegController ($timeout, $filter, $scope, $state, $stateParams, $translate, tmhDynamicLocale, congress, registration, OnlineReg) {
        var vm = this;
        vm.isSending = false;
        vm.isSubmitSuccess = false;
        vm.selectedRoomOutOfStock = false;
        vm.originalLanguage = $translate.use();
        vm.language = $stateParams.language;
        vm.currency = $stateParams.currency;
        vm.isLangHu = 'hu' === vm.language;
        vm.registration = registration;
        vm.congress = congress;
        vm.nights = '';
        vm.config = congress.onlineRegConfig;
        vm.registration.invoiceCountry = vm.config.defaultCountry;
        vm.invoiceInfoCopied = false;

        vm.discountCodeText = null;
        vm.discountCode = null;

        initDefaultCountry();

        $translate.use(vm.language);
        tmhDynamicLocale.set(vm.language);

        vm.headerStyle = headerStyle;
        vm.submit = submit;
        vm.clear = clear;
        vm.getCurrency = getCurrency;
        vm.getHotelRooms = getHotelRooms;
        vm.getArrivalDates = getArrivalDates;
        vm.getDepartureDates = getDepartureDates;
        vm.calculateNights = calculateNights;
        vm.openRoomExternalLink = openRoomExternalLink;
        vm.calculateOSPrice = calculateOSPrice;
        vm.calculateRTTotal = calculateRTTotal;
        vm.calculateHRTotal = calculateHRTotal;
        vm.calculateOSTotal = calculateOSTotal;
        vm.displayRTSubTotal = displayRTSubTotal;
        vm.displayHRSubTotal = displayHRSubTotal;
        vm.displayOSSubTotal = displayOSSubTotal;
        vm.displayGrandTotal = displayGrandTotal;
        vm.displayRTSubTotalDiscount = displayRTSubTotalDiscount;
        vm.displayHRSubTotalDiscount = displayHRSubTotalDiscount;
        vm.displayOSSubTotalDiscount = displayOSSubTotalDiscount;
        vm.displayGrandTotalDiscount = displayGrandTotalDiscount;
        vm.displayRTTotal = displayRTTotal;
        vm.displayHRTotal = displayHRTotal;
        vm.displayOSTotal = displayOSTotal;
        vm.displayGrandTotalWithDiscount = displayGrandTotalWithDiscount;

        vm.isCardDataRequired = isCardDataRequired;
        vm.isCheckDataRequired = isCheckDataRequired;
        vm.isHotelRoomDatesRequired = isHotelRoomDatesRequired;
        vm.resetPaymentMethodState = resetPaymentMethodState;
        vm.isRegTypeSelected = isRegTypeSelected;
        vm.hasAnyAvailableRoom = hasAnyAvailableRoom;
        vm.addAccPeople = addAccPeople;
        vm.removeAccPeople = removeAccPeople;
        vm.selectExtraRegType = selectExtraRegType;
        vm.copyInvoiceInfo = copyInvoiceInfo;
        vm.setRegTypeRadioButtonValue = setRegTypeRadioButtonValue;
        vm.isRegTypeRadioButtonChecked = isRegTypeRadioButtonChecked;
        vm.setRoomRadioButtonValue = setRoomRadioButtonValue;
        vm.isRoomRadioButtonChecked = isRoomRadioButtonChecked;
        vm.hasExtraSecondRegFeeValue = hasExtraSecondRegFeeValue;
        vm.openCongressWebsite = openCongressWebsite;
        vm.isEmailIdentical = isEmailIdentical;
        vm.hasOtherDataSelectableValues = hasOtherDataSelectableValues;
        vm.getOtherDataSelectableValues = getOtherDataSelectableValues;
        vm.hasPositionSelectableValues = hasPositionSelectableValues;
        vm.getPositionSelectableValues = getPositionSelectableValues;
        vm.hasWorkplaceSelectableValues = hasWorkplaceSelectableValues;
        vm.getWorkplaceSelectableValues = getWorkplaceSelectableValues;
        vm.getTitleSelectableValues = getTitleSelectableValues;
        vm.checkDiscountCode = checkDiscountCode;
        vm.getValueByLanguage = getValueByLanguage;
        vm.getCustomerInformationFilename = getCustomerInformationFilename;
        vm.getPrivacyPolicyFilename = getPrivacyPolicyFilename;


        OnlineReg.queryCountries(function (result) {
            vm.countries = result;
        });

        OnlineReg.queryRegistrationTypes({uuid: $stateParams.uuid, currency: $stateParams.currency}, function(result) {
            vm.registrationTypes = result;
        });

        OnlineReg.queryHotelRooms({uuid: $stateParams.uuid, currency: $stateParams.currency}, function(result) {
            vm.hotelRooms = getHotelRooms(result);
        });

        OnlineReg.queryOptionalServices({uuid: $stateParams.uuid, currency: $stateParams.currency}, function(result) {
            vm.optionalServices = result;
        });

        OnlineReg.queryCustomQuestions({uuid: $stateParams.uuid, currency: $stateParams.currency}, function (result) {
            vm.customQuestions = result;
        });

        function buildOnlineReg() {
            var reg = { // in clear and state resolve function as well!!!
                title: vm.registration.title,
                lastName: vm.registration.lastName,
                firstName: vm.registration.firstName,
                position: vm.registration.position,
                department: vm.registration.department,
                workplace: vm.registration.workplace,
                zipCode: vm.registration.zipCode,
                city: vm.registration.city,
                country: vm.registration.country,
                street: vm.registration.street,
                phone: vm.registration.phone,
                email: vm.registration.email,
                otherData: vm.registration.otherData,
                room: vm.registration.room ? {id: vm.registration.room} : null,
                arrivalDate: vm.registration.arrivalDate,
                departureDate: vm.registration.departureDate,
                roommate: vm.registration.roommate,
                roomRemark: vm.registration.roomRemark,
                registrationType: vm.registration.regType ? {id: vm.registration.regType} : null,
                extraRegTypes: [],
                optionalServices: [],
                customAnswers: [],
                paymentMethod: vm.registration.paymentMethod,
                cardType: vm.registration.cardType,
                checkName: vm.registration.checkName,
                checkAddress: vm.registration.checkAddress,
                cardHolderName: vm.registration.cardHolderName,
                cardHolderAddress: vm.registration.cardHolderAddress,
                cardNumber: vm.registration.cardNumber,
                cardExpiryMonth: vm.registration.cardExpiryMonth,
                cardExpiryYear: vm.registration.cardExpiryYear,
                invoiceName: vm.registration.invoiceName,
                invoiceCountry: vm.registration.invoiceCountry,
                invoiceZipCode: vm.registration.invoiceZipCode,
                invoiceCity: vm.registration.invoiceCity,
                invoiceAddress: vm.registration.invoiceAddress,
                invoiceReferenceNumber:vm.registration.invoiceReferenceNumber,
                invoiceTaxNumber: vm.registration.invoiceTaxNumber,
                termsAndConditions: vm.registration.termsAndConditions,
                discountCode: vm.registration.discountCode,
                discountPercentage: vm.registration.discountPercentage,
                discountType: vm.registration.discountType,
                gdpr: vm.registration.gdpr,
                newsletter: vm.registration.newsletter,
                currency: vm.currency,
                uuid: vm.registration.uuid
            };

            var erts = vm.registration.extraRegTypes;
            for (var prop in erts) {
                if (erts.hasOwnProperty(prop) && erts[prop]) {
                    var regTypeVM = { registrationType: { id: prop}, accompanies: []};

                    for (var j = 0; j < erts[prop].length; j++) {
                        regTypeVM.accompanies.push(erts[prop][j]);
                    }
                    reg.extraRegTypes.push(regTypeVM);
                }
            }

            var oss = vm.registration.optionalServices;
            for (var prop in oss) {
                if (oss.hasOwnProperty(prop) && oss[prop]) {
                    var optionalServiceVM = { optionalService: { id: prop}, participants: oss[prop]};
                    reg.optionalServices.push(optionalServiceVM);
                }
            }

            var cq = vm.registration.customAnswers;
            for (var prop in cq) {
                if (cq.hasOwnProperty(prop) && cq[prop]) {
                    var customAnswerVM = { question: { id: prop }, answer: cq[prop]};
                    reg.customAnswers.push(customAnswerVM);
                }
            }
            return reg;
        }

        function isRoomAvailable(room, arrivalDate, departureDate) {
            if (!room || !departureDate || !arrivalDate) {
                return false;
            }

            var deptDate = new Date(departureDate);
            deptDate.setHours(0, 0, 0, 0);

            for (var i = 0; room && room.reservations && i < room.reservations.length; i++) {
                var reservation = room.reservations[i];
                var reservationDate = new Date(reservation.reservationDate);
                reservationDate.setHours(0, 0, 0, 0);
                //iterate over selected arrival and departure dates
                var arrDate = new Date(arrivalDate);
                arrDate.setHours(0, 0, 0, 0);
                for (; arrDate < deptDate; arrDate.setDate(arrDate.getDate() + 1)) {
                    if (reservationDate.getTime() === arrDate.getTime() && reservation.reserved >= room.quantity) {
                        return false;
                    }
                }
            }
            return true;
        }

        function hasAnyAvailableRoom() {
            if (!vm.hotelRooms) {
                return false;
            }
            for (var i = 0; i < vm.hotelRooms.length; i++) {
                if (vm.hotelRooms[i].rooms.length) {
                    return true;
                }
            }
            return false;
        }

        function submit() {
            vm.isSending = true;
            //We have to check the actual available number of the selected room at the moment of saving the online
            OnlineReg.queryHotelRooms({uuid: $stateParams.uuid, currency: $stateParams.currency}, function(result) {
                vm.selectedRoomOutOfStock = false;
                if (vm.registration.room) {
                    var hotelRooms = getHotelRooms(result);
                    var room = getRoomById(hotelRooms, vm.registration.room);
                    if (!isRoomAvailable(room, vm.registration.arrivalDate, vm.registration.departureDate)) {
                        vm.registration.room = null;
                        vm.registration.arrivalDate = null;
                        vm.registration.departureDate = null;
                        vm.nights = '';
                        vm.isSending = false;
                        vm.selectedRoomOutOfStock = true;
                        vm.hotelRooms = hotelRooms;
                    }
                }

                if (!vm.selectedRoomOutOfStock) {
                    OnlineReg.save(buildOnlineReg(), onSaveSuccess, onSaveError);
                }
            });
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:onlineRegSubmitted', result);
            var grandTotal = calculateRTSubTotal() + calculateHRSubTotal() + calculateOSSubTotal();
            if (vm.config.paymentSupplier === 'STRIPE' && grandTotal > 0) {
                try {
                    var stripe = Stripe(vm.config.stripePublicKey);
                    stripe.redirectToCheckout({sessionId: result.sessionId})
                        .then(function (result) {
                            // If redirection fails, display an error to the customer.
                            if (result.error) {
                                var displayError = document.getElementById('error-message');
                                displayError.textContent = result.error.message;
                            }
                        });
                }
                catch (e) {
                    alert('Unexpected error during the online payment process, please contact the congress organizer!');
                    console.error(e);
                }
            }
            else {
                vm.isSubmitSuccess = true;
            }
        }

        function onSaveError () {
            vm.isSending = false;
        }

        function getHotelRooms(hotelRooms) {
            var hotels = [];
            for (var i = 0; i < hotelRooms.length; i++) {
                var roomArrayLength = Math.max(hotelRooms[i].singleList.length, hotelRooms[i].doubleList.length);
                var hotel = {
                    name: hotelRooms[i].name,
                    zipCode: hotelRooms[i].zipCode,
                    city: hotelRooms[i].city,
                    street: hotelRooms[i].street,
                    rowSpan: roomArrayLength,
                    rooms: []
                };

                for (var j = 0; j < roomArrayLength; j++) {
                    var room = {};
                    if (hotelRooms[i].singleList[j]) {
                        room.single = hotelRooms[i].singleList[j];
                    }

                    if (hotelRooms[i].doubleList[j]) {
                        room.double = hotelRooms[i].doubleList[j];
                    }
                    hotel.rooms.push(room);
                }
                hotels.push(hotel)
            }
            return hotels;
        }

        function getRegTypeById(id) {
            if (!vm.registrationTypes) return null;
            for (var i = 0; i < vm.registrationTypes.length; i++) {
                if (vm.registrationTypes[i].id == id) {
                    return vm.registrationTypes[i];
                }
            }
            return null;
        }

        function getRoomById(hotelRooms, id) {
            if (!hotelRooms) return null;
            for (var i = 0; i < hotelRooms.length; i++) {
                var hotel = hotelRooms[i];
                for (var j = 0; j < hotel.rooms.length; j++) {

                    if (hotel.rooms[j].single && hotel.rooms[j].single.id == id) {
                        return hotel.rooms[j].single;
                    }

                    if (hotel.rooms[j].double && hotel.rooms[j].double.id == id) {
                        return hotel.rooms[j].double;
                    }
                }
            }
            return null;
        }

        function getOptionalServiceById(id) {
            if (!vm.optionalServices) return null;
            for (var i = 0; i < vm.optionalServices.length; i++) {
                if (vm.optionalServices[i].id == id) {
                    return vm.optionalServices[i];
                }
            }
            return null;
        }

        function getCurrency() {
            if (vm.registrationTypes && vm.registrationTypes.length) {
                return vm.registrationTypes[0].currency;
            }
            else if (vm.optionalServices && vm.optionalServices.length) {
                return vm.optionalServices[0].currency;
            }
            else if (vm.hotelRooms && vm.hotelRooms.length) {
                if (vm.hotelRooms[0].rooms[0].single) {
                    return vm.hotelRooms[0].rooms[0].single.currency;
                }
                if (vm.hotelRooms[0].rooms[0].double) {
                    return vm.hotelRooms[0].rooms[0].double.currency;
                }
            }
            return '';
        }

        function getArrivalDates() {
            if (!vm.arrivalDates) {
                vm.arrivalDates = [];
                vm.arrivalDates.push({value: null, label: $filter('translate')('pcsApp.onlineReg.form.please.select')});
                var d = new Date(vm.congress.startDate);
                var diffTime = Math.abs(vm.congress.endDate.getTime() - vm.congress.startDate.getTime());
                var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                for (var i = -4; i < diffDays; i++) {
                    var date = (new Date(vm.congress.startDate)).setDate((d).getDate() + i);
                    vm.arrivalDates.push({value: date, label: $filter('date')(date, 'longDate')});
                }
            }
            return vm.arrivalDates;
        }

        function getDepartureDates() {
            if (!vm.departureDates) {
                vm.departureDates = [];
                vm.departureDates.push({value: null, label: $filter('translate')('pcsApp.onlineReg.form.please.select')});
                var diffTime = Math.abs(vm.congress.endDate.getTime() - vm.congress.startDate.getTime());
                var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                var d = new Date(vm.congress.startDate);
                for (var i = 1; i < diffDays + 4; i++) {
                    var date = (new Date(vm.congress.startDate)).setDate((d).getDate() + i);
                    vm.departureDates.push({value: date, label: $filter('date')(date, 'longDate')});
                }
            }
            return vm.departureDates;
        }

        function calculateNights() {
            var diffTime = vm.registration.departureDate && vm.registration.arrivalDate ? vm.registration.departureDate - vm.registration.arrivalDate : 0;
            var diffDays = diffTime ? Math.ceil(diffTime / (1000 * 60 * 60 * 24)) : '';
            vm.nights = diffDays;
        }

        function calculateOSPrice(os) {
            if (vm.registration.optionalServices[os.id + '']) {
                return (os.price * vm.registration.optionalServices[os.id + '']) + ' ' + os.currency;
            }
            return '';
        }

        function calculateRTSubTotal() {
            var subTotal = 0;
            var selectedRegType = vm.registration.extraRegTypes;
            for (var prop in selectedRegType) {
                if (selectedRegType.hasOwnProperty(prop) && selectedRegType[prop]) {
                    var rt = getRegTypeById(prop);
                    subTotal += rt.currentRegFee * Math.max(1, selectedRegType[prop].length);
                }
            }
            var rt = getRegTypeById(vm.registration.regType);
            subTotal += rt ? rt.currentRegFee : 0;
            return subTotal;
        }

        function calculateRTSubTotalDiscount() {
            if (vm.registration.discountCode && vm.registration.discountPercentage &&
                (!vm.registration.discountType || vm.registration.discountType === 'REGISTRATION')) {
                var subTotal = calculateRTSubTotal();
                return Math.round(subTotal * (vm.registration.discountPercentage / 100));
            }
            return 0;
        }

        function calculateRTTotal() {
            return calculateRTSubTotal() - calculateRTSubTotalDiscount();
        }

        function calculateHRSubTotal() {
            var room = vm.registration.room ? getRoomById(vm.hotelRooms, vm.registration.room) : null;
            return vm.nights && room ? room.price * vm.nights : 0;
        }

        function calculateHRSubTotalDiscount() {
            if (vm.registration.discountCode && vm.registration.discountPercentage &&
                (!vm.registration.discountType || vm.registration.discountType === 'HOTEL')) {
                var subTotal = calculateHRSubTotal();
                return Math.round(subTotal * (vm.registration.discountPercentage / 100));
            }
            return 0;
        }

        function calculateHRTotal() {
            return calculateHRSubTotal() - calculateHRSubTotalDiscount();
        }

        function calculateOSSubTotal() {
            var subTotal = 0;
            var selectedOptionalService = vm.registration.optionalServices;
            for (var prop in selectedOptionalService) {
                if (selectedOptionalService.hasOwnProperty(prop) && selectedOptionalService[prop]) {
                    var os = getOptionalServiceById(prop);
                    subTotal += os.price * selectedOptionalService[prop];
                }
            }
            return subTotal;
        }

        function calculateOSSubTotalDiscount() {
            if (vm.registration.discountCode && vm.registration.discountPercentage &&
                (!vm.registration.discountType || vm.registration.discountType === 'OPTIONAL_SERVICE')) {
                var subTotal = calculateOSSubTotal();
                return Math.round(subTotal * (vm.registration.discountPercentage / 100));
            }
            return 0;
        }

        function calculateOSTotal() {
            return calculateOSSubTotal() - calculateOSSubTotalDiscount();
        }

        function displayRTSubTotal() {
            var subTotal = calculateRTSubTotal();
            return subTotal ? $filter('number')(subTotal) + ' ' + getCurrency() : '';
        }

        function displayRTSubTotalDiscount() {
            var discount = calculateRTSubTotalDiscount();
            return discount ? $filter('number')(discount) + ' ' + getCurrency() : '';
        }

        function displayRTTotal() {
            var total = calculateRTSubTotal() - calculateRTSubTotalDiscount();
            return total ? $filter('number')(total) + ' ' + getCurrency() : '';
        }

        function displayHRSubTotal() {
            var subTotal = calculateHRSubTotal();
            return subTotal ? $filter('number')(subTotal) + ' ' + getCurrency() : '';
        }

        function displayHRSubTotalDiscount() {
            var discount = calculateHRSubTotalDiscount();
            return discount ? $filter('number')(discount) + ' ' + getCurrency() : '';
        }

        function displayHRTotal() {
            var total = calculateHRSubTotal() - calculateHRSubTotalDiscount();
            return total ? $filter('number')(total) + ' ' + getCurrency() : '';
        }

        function displayOSSubTotal() {
            var subTotal = calculateOSSubTotal();
            return subTotal ? $filter('number')(subTotal) + ' ' + getCurrency() : '';
        }

        function displayOSSubTotalDiscount() {
            var discount = calculateOSSubTotalDiscount();
            return discount ? $filter('number')(discount) + ' ' + getCurrency() : '';
        }

        function displayOSTotal() {
            var total = calculateOSSubTotal() - calculateOSSubTotalDiscount();
            return total ? $filter('number')(total) + ' ' + getCurrency() : '';
        }

        function displayGrandTotal() {
            var grandTotal = calculateRTSubTotal() + calculateHRSubTotal() + calculateOSSubTotal();
            return grandTotal ? $filter('number')(grandTotal) + ' ' + getCurrency() : '';
        }

        function displayGrandTotalDiscount() {
            var discount = calculateRTSubTotalDiscount() + calculateHRSubTotalDiscount() + calculateOSSubTotalDiscount();
            return discount ? $filter('number')(discount) + ' ' + getCurrency() : '';
        }

        function displayGrandTotalWithDiscount() {
            var grandTotal = calculateRTSubTotal() + calculateHRSubTotal() + calculateOSSubTotal();
            var grandTotalDiscount = calculateRTSubTotalDiscount() + calculateHRSubTotalDiscount() + calculateOSSubTotalDiscount();
            return (grandTotal ? $filter('number')(grandTotal - grandTotalDiscount) : '0') + ' ' + getCurrency();
        }

        function isCardDataRequired() {
            return vm.registration.cardType == 'AMEX';
        }

        function isCheckDataRequired() {
            return vm.registration.paymentMethod == 'CHECK';
        }

        function isHotelRoomDatesRequired() {
            return vm.registration.room ? true : false;
        }

        function resetPaymentMethodState() {
            if (vm.registration.paymentMethod != 'CARD') {
                vm.registration.cardType = null;
                vm.registration.cardHolderName = null;
                vm.registration.cardHolderAddress = null;
                vm.registration.cardExpiryMonth = null;
                vm.registration.cardExpiryYear = null;
            }
        }

        function openRoomExternalLink(room) {
            window.open(room.onlineExternalLink, '_blank');
        }

        function clear() { // in state resolve as well!!!
            vm.registration.title = null;
            vm.registration.lastName = null;
            vm.registration.firstName = null;
            vm.registration.position = null;
            vm.registration.department = null;
            vm.registration.workplace = null;
            vm.registration.zipCode = null;
            vm.registration.city = null;
            vm.registration.country = null;
            vm.registration.street = null;
            vm.registration.phone = null;
            vm.registration.email = null;
            vm.registration.email2 = null;
            vm.registration.otherData = null;
            vm.registration.room = null;
            vm.registration.arrivalDate = null;
            vm.registration.departureDate = null;
            vm.registration.roommate = null;
            vm.registration.roomRemark = null;
            vm.registration.regType = null;
            vm.registration.extraRegTypes = {};
            vm.registration.optionalServices = {};
            vm.registration.customQuestions = {};
            vm.registration.paymentMethod = null;
            vm.registration.cardType = null;
            vm.registration.checkName = null;
            vm.registration.checkAddress = null;
            vm.registration.cardHolderName= null;
            vm.registration.cardHolderAddress= null;
            vm.registration.cardNumber= null;
            vm.registration.cardExpiryMonth= null;
            vm.registration.cardExpiryYear= null;
            vm.registration.invoiceName = null;
            vm.registration.invoiceCountry = null;
            vm.registration.invoiceZipCode = null;
            vm.registration.invoiceCity = null;
            vm.registration.invoiceAddress = null;
            vm.registration.invoiceReferenceNumber = null;
            vm.registration.invoiceTaxNumber = null;
            vm.registration.termsAndConditions = null;
            vm.registration.discountCode = null;
            vm.registration.discountPercentage = null;
            vm.registration.discountType = null;
            vm.registration.gdpr = null;
            vm.registration.newsletter = null;

            vm.nights = '';
        }

        function headerStyle() {
            return vm.config.colorCode ? {'color': '#ffffff', 'background-color': vm.config.colorCode } : {};
        }

        function isRegTypeSelected(rt) {
            if (rt.registrationType != 'ACCOMPANYING_FEE') {
                return false;
            }
            var selectedRegType = vm.registration.extraRegTypes;
            for (var prop in selectedRegType) {
                if (selectedRegType.hasOwnProperty(prop) && prop == rt.id && selectedRegType[prop] && selectedRegType[prop].length) {
                    return true;
                }
            }
            return false;
        }

        function selectExtraRegType(rt) {
            if (vm.registration.extraRegTypes[rt.id + ''] != null && rt.registrationType == 'ACCOMPANYING_FEE') {
                addAccPeople(rt.id);
            }
        }

        function addAccPeople(id) {
            vm.registration.extraRegTypes[id + ''].push({lastName: null, firstName: null});
        }

        function removeAccPeople(id, index) {
            vm.registration.extraRegTypes[id + ''].splice(index, 1);
        }

        function copyInvoiceInfo() {
            if (vm.invoiceInfoCopied) {
                vm.registration.invoiceCountry = vm.registration.country || vm.congress.defaultCountry;
                vm.registration.invoiceZipCode = vm.registration.zipCode || '';
                vm.registration.invoiceCity = vm.registration.city || '';
                vm.registration.invoiceAddress = vm.registration.street || '';
            }
            else {
                vm.registration.invoiceName = '';
                vm.registration.invoiceCountry = vm.congress.defaultCountry;
                vm.registration.invoiceZipCode = '';
                vm.registration.invoiceCity = '';
                vm.registration.invoiceAddress = '';
            }
        }

        function setRegTypeRadioButtonValue (event) {
            if (vm.registration.regType == event.target.value) {
                vm.registration.regType = null;

            }
            else {
                vm.registration.regType = event.target.value;
            }
        }

        function isRegTypeRadioButtonChecked(id) {
            return vm.registration.regType == id;
        }

        function setRoomRadioButtonValue (event) {
            if (vm.registration.room == event.target.value) {
                vm.registration.room = null;

            }
            else {
                vm.registration.room = event.target.value;
            }
        }

        function isRoomRadioButtonChecked(id) {
            return vm.registration.room == id;
        }

        function hasExtraSecondRegFeeValue() {
            for (var i = 0; vm.registrationTypes && i < vm.registrationTypes.length; i++) {
               if (vm.registrationTypes[i].onlineType === 'EXTRA' && vm.registrationTypes[i].secondRegFee) {
                   return true;
               }
            }
            return false;
        }

        function openCongressWebsite() {
            window.open(vm.congress.website.startsWith('http://') ? vm.congress.website : 'http://' + vm.congress.website, '_blank');
        }

        function isEmailIdentical () {
            if (!vm.registration.email || !vm.registration.email2) {
                return true;
            }
            else {
                return vm.registration.email === vm.registration.email2;
            }
        }

        function hasSelectableValuesByLanguage(fieldName) {
            let text;
            switch(vm.language) {
                case "hu":
                    text = 'Hu';
                    break;
                case "en":
                    text = 'En';
                    break;
                case "es":
                    text = 'Es';
                    break;
                case "pt":
                    text = 'Pt';
                    break;
                default:
                    text = 'Hu';
            }
            return vm.config[fieldName + text + 'Values'] && vm.config[fieldName + text + 'Values'].length;
        }

        function getSelectableValuesByLanguage(fieldName) {
            let text;
            switch(vm.language) {
                case "hu":
                    text = 'Hu';
                    break;
                case "en":
                    text = 'En';
                    break;
                case "es":
                    text = 'Es';
                    break;
                case "pt":
                    text = 'Pt';
                    break;
                default:
                    text = 'Hu';
            }
            return vm.config[fieldName + text + 'Values'];
        }

        function hasOtherDataSelectableValues() {
            return hasSelectableValuesByLanguage('otherData');
        }

        function getOtherDataSelectableValues() {
            return getSelectableValuesByLanguage('otherData');
        }

        function hasPositionSelectableValues() {
            return hasSelectableValuesByLanguage('position');
        }

        function getPositionSelectableValues() {
            return getSelectableValuesByLanguage('position');
        }

        function hasWorkplaceSelectableValues() {
            return hasSelectableValuesByLanguage('workplace');
        }

        function getWorkplaceSelectableValues() {
            return getSelectableValuesByLanguage('workplace');
        }

        function getTitleSelectableValues() {
            return vm.isLangHu ? ['Dr.', 'Prof.'] : ['Dr.', 'Ms.', 'Mr.', 'Mrs.', 'Prof.'];
        }

        function initDefaultCountry() {
            if (vm.config.defaultCountry) {
                vm.registration.country = vm.config.defaultCountry;
            }
        }

        function checkDiscountCode() {
            if (vm.discountCodeText && vm.discountCodeText.length >= 5) {
                OnlineReg.getDiscountCode({uuid: vm.congress.uuid, code: vm.discountCodeText}).$promise.then(function (result) {
                    vm.registration.discountCode = result.code;
                    vm.registration.discountPercentage = result.discountPercentage;
                    vm.registration.discountType = result.discountType;
                }, function (error) {
                    vm.registration.discountCode = null;
                    vm.registration.discountPercentage = null;
                    vm.registration.discountType = null;
                });
            }
        }

        function getValueByLanguage(fieldName) {
            let text;
            switch(vm.language) {
                case "hu":
                    text = vm.config[fieldName + 'Hu'];
                    break;
                case "en":
                    text = vm.config[fieldName + 'En'];
                    break;
                case "es":
                    text = vm.config[fieldName + 'Es'];
                    break;
                case "pt":
                    text = vm.config[fieldName + 'Pt'];
                    break;
                default:
                    text = vm.config[fieldName + 'Hu'];
            }
            return text;
        }

        function getCustomerInformationFilename() {
            let text;
            switch(vm.language) {
                case "hu":
                    text = 'congressline_vasarloi_tajekoztato.pdf';
                    break;
                case "en":
                    text = 'congressline_customer_information.pdf'
                    break;
                case "es":
                    text = 'congressline_customer_information.pdf'
                    break;
                case "pt":
                    text = 'congressline_customer_information.pdf'
                    break;
                default:
                    text = 'congressline_vasarloi_tajekoztato.pdf';
            }
            return text;
        }

        function getPrivacyPolicyFilename() {
            let text;
            switch(vm.language) {
                case "hu":
                    text = 'adatkezelesi-tajekoztato/';
                    break;
                case "en":
                    text = 'en/privacy-policy/';
                    break;
                case "es":
                    text = 'en/privacy-policy/';
                    break;
                case "pt":
                    text = 'en/privacy-policy/';
                    break;
                default:
                    text = 'adatkezelesi-tajekoztato/';
            }
            return text;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('MiscServiceDialogController', MiscServiceDialogController);

    MiscServiceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'MiscService', 'VatInfo', 'Congress', 'CongressSelector'];

    function MiscServiceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, MiscService, VatInfo,  Congress, CongressSelector) {
        var vm = this;

        vm.miscService = entity;
        vm.clear = clear;
        vm.save = save;
        vm.currencies = [];
        vm.vatInfos = [];

        VatInfo.queryForCongressAndItemType({ id: CongressSelector.getSelectedCongress().id, itemType: 'MISCELLANEOUS' } , function(result) {
            vm.vatInfos = result;
        });

        Congress.get({id: CongressSelector.getSelectedCongress().id}, function(data) {
            vm.currencies = data.currencies;
        });

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.miscService.id !== null) {
                MiscService.update(vm.miscService, onSaveSuccess, onSaveError);
            } else {
                MiscService.save(vm.miscService, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:miscServiceUpdate', result);
            $uibModalInstance.close(result);
            //vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('MiscServiceDeleteController',MiscServiceDeleteController);

    MiscServiceDeleteController.$inject = ['$uibModalInstance', 'entity', 'MiscService'];

    function MiscServiceDeleteController($uibModalInstance, entity, MiscService) {
        var vm = this;

        vm.miscService = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MiscService.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('misc-service', {
            parent: 'administration',
            url: '/misc-service',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pcsApp.miscService.home.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/misc-service/misc-services.html',
                    controller: 'MiscServiceController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('miscService');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('misc-service.new', {
            parent: 'misc-service',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'CongressSelector', function($stateParams, $state, $uibModal, CongressSelector) {
                $uibModal.open({
                    templateUrl: 'app/entities/misc-service/misc-service-dialog.html',
                    controller: 'MiscServiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                measure: null,
                                price: null,
                                id: null,
                                congress: CongressSelector.getSelectedCongress()
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('misc-service', null, { reload: 'misc-service' });
                }, function() {
                    $state.go('misc-service');
                });
            }]
        })
        .state('misc-service.edit', {
            parent: 'misc-service',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/misc-service/misc-service-dialog.html',
                    controller: 'MiscServiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MiscService', function(MiscService) {
                            return MiscService.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('misc-service', null, { reload: 'misc-service' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('misc-service.delete', {
            parent: 'misc-service',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/misc-service/misc-service-delete-dialog.html',
                    controller: 'MiscServiceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MiscService', function(MiscService) {
                            return MiscService.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('misc-service', null, { reload: 'misc-service' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('MiscService', MiscService);

    MiscService.$inject = ['$resource'];

    function MiscService ($resource) {
        var resourceUrl =  'api/misc-services/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryByCongress': {
                method: 'GET',
                url: 'api/misc-services/congress/:id',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('MiscServiceController', MiscServiceController);

    MiscServiceController.$inject = ['$scope', '$state', 'MiscService', 'CongressSelector'];

    function MiscServiceController ($scope, $state, MiscService, CongressSelector) {
        var vm = this;
        
        vm.miscServices = [];

        loadAll();

        function loadAll() {
            MiscService.queryByCongress({id: CongressSelector.getSelectedCongress().id}, function(result) {
                vm.miscServices = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('MiscInvoiceItemDialogController', MiscInvoiceItemDialogController);

    MiscInvoiceItemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'MiscService', 'miscInvoice', 'CongressSelector', 'selectedCurrency', 'Rate'];

    function MiscInvoiceItemDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity,
        MiscService, miscInvoice, CongressSelector, selectedCurrency, Rate) {
        var vm = this;

        vm.miscInvoice = miscInvoice;
        vm.miscInvoiceItem = entity;
        vm.clear = clear;
        vm.save = save;
        vm.getSelectedCurrency = getSelectedCurrency;
        vm.selectedCurrency = selectedCurrency;

        MiscService.queryByCongress({id: CongressSelector.getSelectedCongress().id}, function (result) {
            vm.miscServices = result;
        });

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function uuid() {
            function s4() {
                return Math.floor((1 + Math.random()) * 0x10000)
                    .toString(16)
                    .substring(1);
            }
            return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
                s4() + '-' + s4() + s4() + s4();
        }


        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.miscInvoiceItem.id == null) {
                vm.miscInvoiceItem.id = uuid();
                vm.miscInvoice.miscInvoiceItems.push(vm.miscInvoiceItem);
                vm.selectedCurrency.currency = vm.miscInvoiceItem.miscService.currency.currency;
                if (vm.selectedCurrency.currency !== 'HUF') {
                    Rate.getCurrentRate({currency: vm.selectedCurrency.currency},
                        function (result) {
                            vm.selectedCurrency.hasValidRate = true;
                        },
                        function (result) {
                            vm.selectedCurrency.hasValidRate = false;
                        }
                    );
                }
            }

            $uibModalInstance.close(true);
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:miscInvoiceItemUpdate', result);
            $uibModalInstance.close(result);
            //vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function getSelectedCurrency() {
            return vm.selectedCurrency.currency ? vm.selectedCurrency.currency : '';
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('MiscInvoiceItemDeleteController',MiscInvoiceItemDeleteController);

    MiscInvoiceItemDeleteController.$inject = ['$uibModalInstance', 'entity', 'miscInvoice'];

    function MiscInvoiceItemDeleteController($uibModalInstance, entity, miscInvoice) {
        var vm = this;

        vm.miscInvoiceItem = entity;
        vm.miscInvoice = miscInvoice;

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.confirmDelete = function (id) {
            for (var i = 0; i < vm.miscInvoice.miscInvoiceItems.length; i++) {
                if (vm.miscInvoice.miscInvoiceItems[i].id == id) {
                    vm.miscInvoice.miscInvoiceItems.splice(i, 1);
                }
            }
            $uibModalInstance.close(true);
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('misc-invoice-item', {
            parent: 'misc-invoice',
            url: '/misc-invoice-item',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pcsApp.miscInvoiceItem.home.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/misc-invoice-item/misc-invoice-items.html',
                    controller: 'MiscInvoiceItemController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                selectedCurrency: function () {
                    return {
                        currency: null,
                        hasValidRate: true
                    };
                },
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('miscInvoiceItem');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('misc-invoice-item.new', {
            parent: 'misc-invoice-item',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'miscInvoice', 'selectedCurrency', function($stateParams, $state, $uibModal, miscInvoice, selectedCurrency) {
                $uibModal.open({
                    templateUrl: 'app/entities/misc-invoice-item/misc-invoice-item-dialog.html',
                    controller: 'MiscInvoiceItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                itemQuantity: null,
                                id: null
                            };
                        },
                        miscInvoice: function () {
                            return miscInvoice;
                        },
                        selectedCurrency: function () {
                            return selectedCurrency;
                        }
                    }
                }).result.then(function() {
                    $state.go('misc-invoice-item');
                }, function() {
                    $state.go('misc-invoice-item');
                });
            }]
        })
        .state('misc-invoice-item.edit', {
            parent: 'misc-invoice-item',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'miscInvoice', 'selectedCurrency', function($stateParams, $state, $uibModal, miscInvoice, selectedCurrency) {
                $uibModal.open({
                    templateUrl: 'app/entities/misc-invoice-item/misc-invoice-item-dialog.html',
                    controller: 'MiscInvoiceItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function() {
                            for (var i = 0; i < miscInvoice.miscInvoiceItems.length; i++) {
                                if (miscInvoice.miscInvoiceItems[i].id == $stateParams.id) {
                                    return miscInvoice.miscInvoiceItems[i];
                                }
                            }
                            return null;
                        },
                        miscInvoice: function () {
                            return miscInvoice;
                        },
                        selectedCurrency: function () {
                            return selectedCurrency;
                        }
                    }
                }).result.then(function() {
                    $state.go('misc-invoice-item');
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('misc-invoice-item.delete', {
            parent: 'misc-invoice-item',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'miscInvoice', 'selectedCurrency', function($stateParams, $state, $uibModal, miscInvoice, selectedCurrency) {
                $uibModal.open({
                    templateUrl: 'app/entities/misc-invoice-item/misc-invoice-item-delete-dialog.html',
                    controller: 'MiscInvoiceItemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: function() {
                            for (var i = 0; i < miscInvoice.miscInvoiceItems.length; i++) {
                                if (miscInvoice.miscInvoiceItems[i].id == $stateParams.id) {
                                    return miscInvoice.miscInvoiceItems[i];
                                }
                            }
                            return null;
                        },
                        miscInvoice: function () {
                            return miscInvoice;
                        }
                    }
                }).result.then(function() {
                    if (!miscInvoice.miscInvoiceItems.length) {
                        selectedCurrency.currency = null;
                        selectedCurrency.hasValidRate = true;
                    }
                    $state.go('misc-invoice-item');
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('MiscInvoiceItem', MiscInvoiceItem);

    MiscInvoiceItem.$inject = ['$resource'];

    function MiscInvoiceItem ($resource) {
        var resourceUrl =  'api/misc-invoice-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('MiscInvoiceItemController', MiscInvoiceItemController);

    MiscInvoiceItemController.$inject = ['$scope', '$state', 'miscInvoice', 'selectedCurrency'];

    function MiscInvoiceItemController ($scope, $state, miscInvoice, selectedCurrency) {
        var vm = this;
        vm.miscInvoiceItems = miscInvoice.miscInvoiceItems;
        vm.selectedCurrency = selectedCurrency;
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('MiscInvoiceStornoController', MiscInvoiceStornoController);

    MiscInvoiceStornoController.$inject = ['$scope', '$uibModalInstance', 'entity', 'MiscInvoice'];

    function MiscInvoiceStornoController ($scope, $uibModalInstance, entity, MiscInvoice) {
        var vm = this;

        vm.invoiceCongress = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.confirmStorno = confirmStorno;

        function confirmStorno() {
            MiscInvoice.storno({id: vm.invoiceCongress.invoice.id},
                function (result) {
                    var pdfLink = '/api/misc-invoices/' + result.id + '/pdf';
                    window.open(pdfLink, '_blank');
                    $uibModalInstance.close(true);
                });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('MiscInvoiceSetupDialogController', MiscInvoiceSetupDialogController);

    MiscInvoiceSetupDialogController.$inject = ['$scope', '$state', '$stateParams', 'miscInvoice', 'MiscInvoice', 'Country',
        'OptionalText', 'CongressSelector', 'BankAccount', 'InvoiceUtils', 'Workplace'];

    function MiscInvoiceSetupDialogController ($scope, $state, $stateParams, miscInvoice, MiscInvoice, Country, OptionalText, CongressSelector, BankAccount, InvoiceUtils, Workplace) {
        var vm = this;
        vm.isShowInvoicePanel = false;
        vm.datePickerOpenStatus = {};
        vm.invoice = miscInvoice;
        vm.optionalTexts = [];
        vm.bankAccounts = [];
        vm.partners = [];
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.datePickerOpenStatus.dateOfFulfilment = false;
        vm.datePickerOpenStatus.paymentDeadline = false;
        vm.taxNumberPattern = '';

        vm.openCalendar = openCalendar;
        vm.setOptionalTextMessage = setOptionalTextMessage;
        vm.clear = clear;
        vm.showConfirmationPanel = showConfirmationPanel;
        vm.sendAndPrintInvoice = sendAndPrintInvoice;
        vm.printInvoice = printInvoice;
        vm.getCurrency = getCurrency;
        vm.selectPartner = selectPartner;
        vm.changeBillingMethod = changeBillingMethod;
        vm.navVatCategoryChanged = navVatCategoryChanged;
        vm.invoiceTypeChanged = invoiceTypeChanged;
        vm.isTaxNumberDisabled = isTaxNumberDisabled;
        vm.isTaxNumberRequired = isTaxNumberRequired;


        vm.countries = Country.query();
        Workplace.queryForCongress({ id: CongressSelector.getSelectedCongress().id }, function(result) {
            vm.partners = result;
        });

        OptionalText.queryByCongress({id: CongressSelector.getSelectedCongress().id}, function(result) {
            vm.optionalTexts = result;
        });

        function setOptionalTextMessage(text) {
            vm.invoice.optionalText = text;
        }

        function selectPartner(partner) {
            vm.invoice.name1 = partner.name;
            vm.invoice.vatRegNumber = partner.vatRegNumber;
            vm.invoice.country = partner.country ? partner.country.code : '';
            vm.invoice.department = partner.department;
            vm.invoice.zipCode = partner.zipCode;
            vm.invoice.city = partner.city;
            vm.invoice.street = partner.street;
            vm.invoice.phone = partner.phone;
            vm.invoice.fax = partner.fax;
            vm.invoice.email = partner.email;
        }

        function getCurrency() {
            if (vm.invoice.miscInvoiceItems.length) {
                return vm.invoice.miscInvoiceItems[0].miscService.currency.currency;
            }
            return null;
        }

        InvoiceUtils.hasValidRate(vm.getCurrency())
            .then(function (response) {
                if (response.hasValidRate) {
                    vm.hasValidRate = true;
                }
                else {
                    vm.hasValidRate = false;
                }
            })
            .catch(function() {
                vm.hasValidRate = false;
            });


        BankAccount.queryByCongressId({congressId: CongressSelector.getSelectedCongress().id, currency: vm.getCurrency() }, function(result) {
            vm.bankAccounts = result;
            if (vm.bankAccounts.length == 1) {
                vm.invoice.bankAccount = vm.bankAccounts[0];
            }
        });

        function clear() {
            vm.invoice.invoiceNumber = null;
            vm.invoice.stornoInvoiceNumber = null;
            vm.invoice.invoiceType = null;
            vm.invoice.name1 = null;
            vm.invoice.name2 = null;
            vm.invoice.name3 = null;
            vm.invoice.vatRegNumber = null;
            vm.invoice.city = null;
            vm.invoice.zipCode = null;
            vm.invoice.street = null;
            vm.invoice.country = null;
            vm.invoice.optionalText = null;
            vm.invoice.startDate = new Date(CongressSelector.getSelectedCongress().startDate);
            vm.invoice.endDate = new Date(CongressSelector.getSelectedCongress().endDate);
            vm.invoice.dateOfFulfilment = new Date();
            vm.invoice.paymentDeadline = (new Date()).setDate((new Date()).getDate() + 10);
            vm.invoice.billingMethod = 'TRANSFER';
            vm.invoice.language = 'hu';
            vm.invoice.bankAccount = null;
            vm.invoice.createdDate = new Date();
            vm.invoice.dateOfGroupPayment = null;
            vm.invoice.storno = null;
            vm.invoice.stornired = null;
            vm.invoice.id = null;
        }

        function showConfirmationPanel() {
            vm.invoiceEmail = "";
            vm.isShowConfirmationPanel = true;
        }

        function onSaveSuccess(result) {
            var pdfLink = '/api/misc-invoices/' + result.id + '/pdf';
            window.open(pdfLink, '_blank');
            $state.go('misc-invoice', {}, {reload: true, notify: true});
        }

        function onSaveError (result) {
            $state.go('misc-invoice', {}, {reload: true, notify: true});
            vm.isSaving = false;
        }

        function printInvoice() {
            vm.isSaving = true;
            MiscInvoice.save(createMiscInvoiceForPrinting(), onSaveSuccess, onSaveError);
        }

        function sendAndPrintInvoice () {
            vm.isSaving = true;
            MiscInvoice.saveAndSendEmail(createMiscInvoiceForPrinting(), onSaveSuccess, onSaveError);
        }

        function createMiscInvoiceForPrinting() {
            var invoice = {};
            invoice.name1 = vm.invoice.name1;
            invoice.name2 = vm.invoice.name2;
            invoice.name3 = vm.invoice.name3;
            invoice.invoiceType = vm.invoice.invoiceType;
            invoice.vatRegNumber = vm.invoice.vatRegNumber;
            invoice.city = vm.invoice.city;
            invoice.zipCode = vm.invoice.zipCode;
            invoice.street = vm.invoice.street;
            invoice.country = vm.invoice.country;
            invoice.startDate = vm.invoice.startDate;
            invoice.endDate = vm.invoice.endDate;
            invoice.dateOfFulfilment = vm.invoice.dateOfFulfilment;
            invoice.paymentDeadline = vm.invoice.paymentDeadline;
            invoice.billingMethod = vm.invoice.billingMethod;
            invoice.language = vm.invoice.language;
            invoice.navVatCategory = vm.invoice.navVatCategory;
            invoice.optionalText = vm.invoice.optionalText;
            invoice.bankAccount = vm.invoice.bankAccount;
            invoice.registration = vm.registration;
            invoice.customInvoiceEmail = vm.invoiceEmail;
            invoice.congress = vm.invoice.congress;
            invoice.miscInvoiceItems = vm.invoice.miscInvoiceItems;

            for (var i = 0; i < invoice.miscInvoiceItems.length; i++) {
                invoice.miscInvoiceItems[i].id = null;
            }
            return invoice;
        }

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function changeBillingMethod () {
            if (vm.invoice.billingMethod === 'TRANSFER') {
                vm.invoice.dateOfFulfilment = vm.invoice.startDate;
                vm.invoice.paymentDeadline = (new Date()).setDate((new Date()).getDate() + 10);
            }
            else {
                vm.invoice.dateOfFulfilment = new Date();
                vm.invoice.paymentDeadline = new Date();
            }
        }

        function isTaxNumberDisabled() {
            if (vm.invoice.navVatCategory === 'PRIVATE_PERSON') {
                return true;
            }
            else {
                return false;
            }
        }

        function isTaxNumberRequired() {
            if (vm.invoice.navVatCategory === 'DOMESTIC_NORMAL_VAT_TAX_NUMBER' ||
                vm.invoice.navVatCategory === 'DOMESTIC_GROUP_VAT_TAX_NUMBER') {
                return true;
            }
            else {
                return false;
            }
        }

        function invoiceTypeChanged() {
            if (vm.invoice.invoiceType === 'PRO_FORMA') {
                vm.invoice.navVatCategory = 'DOMESTIC_NORMAL_VAT_TAX_NUMBER';
            }
            else {
                vm.invoice.navVatCategory = null;
            }
        }

        function navVatCategoryChanged() {
            if (vm.invoice.navVatCategory === 'PRIVATE_PERSON') {
                vm.invoice.vatRegNumber = null;
            }

            if (vm.invoice.navVatCategory === 'DOMESTIC_NORMAL_VAT_TAX_NUMBER') {
                vm.taxNumberPattern = /^[0-9]{8}-[0-9]{1}-[0-9]{2}$/;
            }
            else if (vm.invoice.navVatCategory === 'EU_NO_VAT_EU_TAX_NUMBER' || vm.invoice.navVatCategory === 'EU_VAT_EU_TAX_NUMBER') {
                vm.taxNumberPattern = /^[A-Z]{2}[0-9A-Z]{2,13}$/;
            }
            else {
                vm.taxNumberPattern = '';
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('MiscInvoiceSetPaymentDateDialogController', MiscInvoiceSetPaymentDateDialogController);

    MiscInvoiceSetPaymentDateDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'MiscInvoice'];

    function MiscInvoiceSetPaymentDateDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, MiscInvoice) {
        var vm = this;

        vm.miscInvoice = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            MiscInvoice.savePaymentDate(vm.miscInvoice, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:miscInvoiceSetPaymentDate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.paymentDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('MiscInvoiceDialogController', MiscInvoiceDialogController);

    MiscInvoiceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'MiscInvoice', 'Congress'];

    function MiscInvoiceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, MiscInvoice, Congress) {
        var vm = this;

        vm.miscInvoice = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.congresses = Congress.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.miscInvoice.id !== null) {
                MiscInvoice.update(vm.miscInvoice, onSaveSuccess, onSaveError);
            } else {
                MiscInvoice.save(vm.miscInvoice, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:miscInvoiceUpdate', result);
            $uibModalInstance.close(result);
            //vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.datePickerOpenStatus.paymentDeadline = false;
        vm.datePickerOpenStatus.dateOfGroupPayment = false;
        vm.datePickerOpenStatus.createdDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('misc-invoice', {
            parent: 'administration',
            url: '/misc-invoice',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pcsApp.miscInvoice.home.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/misc-invoice/misc-invoices.html',
                    controller: 'MiscInvoiceController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                miscInvoice: ['CongressSelector', function (CongressSelector) {
                    return {
                        invoiceNumber: null,
                        stornoInvoiceNumber: null,
                        name1: null,
                        name2: null,
                        name3: null,
                        vatRegNumber: null,
                        city: null,
                        zipCode: null,
                        street: null,
                        country: CongressSelector.getSelectedCongress().defaultCountry ? CongressSelector.getSelectedCongress().defaultCountry.code : null,
                        optionalText: null,
                        startDate: new Date(CongressSelector.getSelectedCongress().startDate),
                        endDate: new Date(CongressSelector.getSelectedCongress().endDate),
                        dateOfFulfilment: new Date(),
                        paymentDeadline: (new Date()).setDate((new Date()).getDate() + 10),
                        billingMethod: 'TRANSFER',
                        language: 'hu',
                        invoiceType: null,
                        navVatCategory: null,
                        bankAccount: null,
                        createdDate: new Date(),
                        dateOfGroupPayment: null,
                        locale: null,
                        storno: null,
                        stornired: null,
                        id: null,
                        miscInvoiceItems: [],
                        congress: {id: CongressSelector.getSelectedCongress().id }
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('miscInvoice');
                    $translatePartialLoader.addPart('navVatCategory');
                    $translatePartialLoader.addPart('invoiceType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('misc-invoice.setup', {
            parent: 'misc-invoice',
            url: '/setup',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/misc-invoice/misc-invoice-setup-dialog.html',
                    controller: 'MiscInvoiceSetupDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('invoice');
                    $translatePartialLoader.addPart('optionalText');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('misc-invoice.optional-text-new', {
            parent: 'misc-invoice',
            url: '/optional-text/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'CongressSelector', function($stateParams, $state, $uibModal, CongressSelector) {
                $uibModal.open({
                    templateUrl: 'app/entities/optional-text/optional-text-dialog.html',
                    controller: 'OptionalTextDialogController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                optionalText: null,
                                id: null,
                                congress: CongressSelector.getSelectedCongress()
                            };
                        }
                    }
                }).result.then(function(result) {
                        $state.go('misc-invoice.setup', {reload: true});
                    }, function() {
                        $state.go('misc-invoice.setup');
                    })
            }]
        })
        .state('misc-invoice.storno', {
            parent: 'misc-invoice',
            url: '/{invoiceId}/storno',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/misc-invoice/misc-invoice-storno-dialog.html',
                    controller: 'MiscInvoiceStornoController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MiscInvoice', function(MiscInvoice) {
                            return MiscInvoice.get({id : $stateParams.invoiceId});
                        }]
                    }
                }).result.then(function(result) {
                        $state.go('misc-invoice', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    })
            }]
        })
        .state('misc-invoice.set-payment-date', {
            parent: 'misc-invoice',
            url: '/{id}/set-payment-date',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/misc-invoice/misc-invoice-set-payment-date-dialog.html',
                    controller: 'MiscInvoiceSetPaymentDateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                paymentDate: new Date(),
                                id: $stateParams.id
                            };
                        }
                    }
                }).result.then(function () {
                    $state.go('misc-invoice', null, {reload: 'misc-invoice'});
                }, function () {
                    $state.go('misc-invoice');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('MiscInvoice', MiscInvoice);

    MiscInvoice.$inject = ['$resource', 'DateUtils'];

    function MiscInvoice ($resource, DateUtils) {
        var resourceUrl =  'api/misc-invoices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryByCongress': {
                method: 'GET',
                url: 'api/misc-invoices/congress/:id',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertLocalDateFromServer(data.startDate);
                        data.endDate = DateUtils.convertLocalDateFromServer(data.endDate);
                        data.dateOfFulfilment = DateUtils.convertLocalDateFromServer(data.dateOfFulfilment);
                        data.paymentDeadline = DateUtils.convertLocalDateFromServer(data.paymentDeadline);
                        data.dateOfGroupPayment = DateUtils.convertLocalDateFromServer(data.dateOfGroupPayment);
                        data.createdDate = DateUtils.convertLocalDateFromServer(data.createdDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    copy.dateOfFulfilment = DateUtils.convertLocalDateToServer(copy.dateOfFulfilment);
                    copy.paymentDeadline = DateUtils.convertLocalDateToServer(copy.paymentDeadline);
                    copy.dateOfGroupPayment = DateUtils.convertLocalDateToServer(copy.dateOfGroupPayment);
                    copy.createdDate = DateUtils.convertLocalDateToServer(copy.createdDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    copy.dateOfFulfilment = DateUtils.convertLocalDateToServer(copy.dateOfFulfilment);
                    copy.paymentDeadline = DateUtils.convertLocalDateToServer(copy.paymentDeadline);
                    copy.dateOfGroupPayment = DateUtils.convertLocalDateToServer(copy.dateOfGroupPayment);
                    copy.createdDate = DateUtils.convertLocalDateToServer(copy.createdDate);
                    return angular.toJson(copy);
                }
            },
            'saveAndSendEmail': {
                method: 'POST',
                url: 'api/misc-invoices/save-and-send-email',
                transformRequest: function (data) {
                    data.startDate = DateUtils.convertLocalDateToServer(data.startDate);
                    data.endDate = DateUtils.convertLocalDateToServer(data.endDate);
                    data.dateOfFulfilment = DateUtils.convertLocalDateToServer(data.dateOfFulfilment);
                    data.paymentDeadline = DateUtils.convertLocalDateToServer(data.paymentDeadline);
                    data.dateOfGroupPayment = DateUtils.convertLocalDateToServer(data.dateOfGroupPayment);
                    data.createdDate = DateUtils.convertLocalDateToServer(data.createdDate);
                    return angular.toJson(data);
                }
            },
            'savePaymentDate': {
                method: 'PUT',
                url: 'api/misc-invoices/set-payment-date',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.paymentDate = DateUtils.convertLocalDateToServer(copy.paymentDate);
                    return angular.toJson(copy);
                }
            },
            'storno': {
                method: 'GET',
                url: 'api/misc-invoices/:id/storno'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('MiscInvoiceController', MiscInvoiceController);

    MiscInvoiceController.$inject = ['$scope', '$state', 'MiscInvoice', 'CongressSelector', 'DTOptionsBuilder', 'DTColumnDefBuilder'];

    function MiscInvoiceController ($scope, $state, MiscInvoice, CongressSelector, DTOptionsBuilder, DTColumnDefBuilder) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions().withOption('stateSave', true);
        vm.dtColumnDefs = [
            // negative int calculated from the right of the columns
            DTColumnDefBuilder.newColumnDef(-1).notSortable()
        ];

        vm.miscInvoices = [];

        loadAll();

        vm.downloadPdf = function (invoiceId) {
            //var contextPath = window.location.pathname.substring(0, window.location.pathname.indexOf("/", 2));
            window.open('/api/misc-invoices/' + invoiceId + '/pdf', '_blank');
        };

        function loadAll() {
            MiscInvoice.queryByCongress({id: CongressSelector.getSelectedCongress().id}, function(result) {
                vm.miscInvoices = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('maintenance', {
            abstract: true,
            url: '/maintenance',
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('ShowNavSendingStatusController',ShowNavSendingStatusController);

    ShowNavSendingStatusController.$inject = ['$uibModalInstance', 'DTOptionsBuilder', 'DTColumnDefBuilder', 'invoiceNavStatusArray'];

    function ShowNavSendingStatusController($uibModalInstance, DTOptionsBuilder, DTColumnDefBuilder,invoiceNavStatusArray) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions();
        vm.dtOptions.withOption('order', [0, 'asc']);
        vm.dtOptions.withOption('scrollX', true);

        vm.invoiceNavStatusArray = invoiceNavStatusArray;
        vm.clear = clear;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('InvoiceReportSendToNavConfirmController',InvoiceReportSendToNavConfirmController);

    InvoiceReportSendToNavConfirmController.$inject = ['$uibModalInstance', 'entity', 'InvoiceReport'];

    function InvoiceReportSendToNavConfirmController($uibModalInstance, entity, InvoiceReport) {
        var vm = this;

        vm.invoiceId = entity.id;
        vm.clear = clear;
        vm.confirmSend = confirmSend;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmSend (id) {
            InvoiceReport.sendToNav({id: id},
                function () {
                    $uibModalInstance.close(true);
                }
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('invoice-report', {
                parent: 'maintenance',
                url: '/invoice-report',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'pcsApp.invoiceReport.home.title'
                },
                views: {
                    'content@base': {
                        templateUrl: 'app/entities/invoice-report/invoice-reports.html',
                        controller: 'InvoiceReportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    reportFilter: function () {
                        return {
                            programNumber: null,
                            invoiceNumber: null,
                            fromDate: null,
                            toDate: null,
                            filterProforma: true
                        };
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invoiceType');
                        $translatePartialLoader.addPart('invoiceReport');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('invoice-report.send-to-nav', {
                parent: 'invoice-report',
                url: '/{id}/send-to-nav',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/invoice-report/invoice-report-send-to-nav-confirm-dialog.html',
                        controller: 'InvoiceReportSendToNavConfirmController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: function () {
                                return {
                                    id: $stateParams.id
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('invoice-report');
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('invoice-report.show-nav-sending-status', {
                parent: 'invoice-report',
                url: '/{id}/show-nav-sending-status',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/invoice-report/show-nav-sending-status-dialog.html',
                        controller: 'ShowNavSendingStatusController',
                        controllerAs: 'vm',
                        size: 'lg',
                        resolve: {
                            invoiceNavStatusArray: ['InvoiceReport', function (InvoiceReport) {
                                return InvoiceReport.queryInvoiceNavStatusById({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('invoice-report');
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }


})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('InvoiceReport', InvoiceReport);

    InvoiceReport.$inject = ['$resource'];

    function InvoiceReport ($resource) {
        var resourceUrl =  'api/invoice-report';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInvoiceNavStatusById': { url: 'api/invoice-report/show-nav-sending-status/:id', method: 'GET', isArray: true},
            'sendToNav': { method: 'GET', url: 'api/invoice-report/send-to-nav/:id' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('InvoiceReportController', InvoiceReportController);

    InvoiceReportController.$inject = ['$scope', '$state', 'reportFilter', 'InvoiceReport', 'DTOptionsBuilder',
        'DTColumnDefBuilder', 'DateUtils', 'B64Encoder', 'CongressSelector'];

    function InvoiceReportController ($scope, $state, reportFilter, InvoiceReport, DTOptionsBuilder,
        DTColumnDefBuilder, DateUtils, B64Encoder, CongressSelector) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions();
        vm.dtOptions.withOption('order', [2, 'desc']);
        vm.dtOptions.withOption('stateSave', true);
        vm.dtOptions.withOption('scrollY', '500px');
        vm.dtOptions.withOption('scrollX', true);

        vm.dtColumnDefs = [
            // negative int calculated from the right of the columns
            DTColumnDefBuilder.newColumnDef(0).notSortable()
        ];

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.fromDate = false;
        vm.datePickerOpenStatus.toDate = false;
        vm.openCalendar = openCalendar;
        vm.getInvoiceReportItemVatNettoValue = getInvoiceReportItemVatNettoValue;
        vm.getInvoiceReportItemVatValue = getInvoiceReportItemVatValue;
        vm.getInvoiceReportVatNettoTotal = getInvoiceReportVatNettoTotal;
        vm.getInvoiceReportVatValueTotal = getInvoiceReportVatValueTotal;
        vm.downloadPdf = downloadPdf;
        vm.isSendToNavButtonVisible = isSendToNavButtonVisible;
        vm.hasInvoiceSendingStatus = hasInvoiceSendingStatus;

        vm.filterProforma = true;

        vm.reportFilter = reportFilter;

        vm.search = search;
        vm.clear = clear;
        vm.isAnyFilterSet = isAnyFilterSet;
        vm.downloadReportXls = downloadReportXls;
        vm.downloadAccountantReportXls = downloadAccountantReportXls;
        vm.downloadNavXmlArchive = downloadNavXmlArchive;

        vm.reportList = [];
        vm.reportListVatColumn = [];

        function getInvoiceReportItemByVat(invoiceReport, vat) {
            var item;
            for (var i = 0; i < invoiceReport.items.length; i++) {
                if (invoiceReport.items[i].vat === vat) {
                    item = invoiceReport.items[i];
                }
            }
            return item;
        }

        function getInvoiceReportItemVatNettoValue(invoiceReport, vat) {
            var item = getInvoiceReportItemByVat(invoiceReport, vat);
            return item ? item.vatBase : '';
        }

        function getInvoiceReportItemVatValue(invoiceReport, vat) {
            var item = getInvoiceReportItemByVat(invoiceReport, vat);
            return item ? item.vatValue : '';
        }

        function getInvoiceReportVatNettoTotal(invoiceReport) {
            var value = 0.0;
            for (var i = 0; i < invoiceReport.items.length; i++) {
                value += invoiceReport.items[i].vatBase;
            }
            return value;
        }

        function getInvoiceReportVatValueTotal(invoiceReport) {
            var value = 0.0;
            for (var i = 0; i < invoiceReport.items.length; i++) {
                value += invoiceReport.items[i].vatValue;
            }
            return value;
        }

        function getInvoiceReportItemByVat(invoiceReport, vat) {
            var item;
            for (var i = 0; i < invoiceReport.items.length; i++) {
                if (invoiceReport.items[i].vat === vat) {
                    item = invoiceReport.items[i];
                }
            }
            return item;
        }

        function clear() {
            vm.reportList = [];
            vm.reportListVatColumn = [];
            vm.reportFilter.programNumber = null;
            vm.reportFilter.invoiceNumber = null;
            vm.reportFilter.fromDate = null;
            vm.reportFilter.toDate = null;
            vm.reportFilter.filterProforma = true;
            // search();
        }

        function buildReportFilter(reportFilter) {
            return {
                programNumber: reportFilter.programNumber,
                invoiceNumber: reportFilter.invoiceNumber,
                fromDate: DateUtils.convertLocalDateToServer(reportFilter.fromDate),
                toDate: DateUtils.convertLocalDateToServer(reportFilter.toDate),
                filterProforma: reportFilter.filterProforma
            };
        }

        function search() {
            InvoiceReport.query({
                    query: B64Encoder.encode(JSON.stringify(buildReportFilter(vm.reportFilter)))
                },
                function (result) {
                    vm.reportList = result;
                    var vatSet = new Set();
                    for (var i = 0; i < vm.reportList.length; i++) {
                        for (var j = 0; j < vm.reportList[i].items.length; j++) {
                            vatSet.add(vm.reportList[i].items[j].vat);
                        }
                    }
                    vm.reportListVatColumn = Array.from(vatSet);
                    vm.reportListVatColumn.sort();
                }
            );
        }

        function downloadReportXls () {
            window.location.href = '/api/invoice-report/download-report?query=' + B64Encoder.encode(JSON.stringify(buildReportFilter(vm.reportFilter)));
        }

        function downloadAccountantReportXls () {
            window.location.href = '/api/invoice-report/download-accountant-report?query=' + B64Encoder.encode(JSON.stringify(buildReportFilter(vm.reportFilter)));
        }

        function downloadNavXmlArchive () {
            window.location.href = '/api/invoice-report/download-nav-xml-archive?query=' + B64Encoder.encode(JSON.stringify(buildReportFilter(vm.reportFilter)));
        }

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function downloadPdf (invoiceId) {
            window.open('/api/invoice-report/' + invoiceId + '/pdf', '_blank');
        }

        function isAnyFilterSet() {
            return vm.reportFilter.programNumber || vm.reportFilter.invoiceNumber || vm.reportFilter.fromDate || vm.reportFilter.toDate;
        }

        function isSendToNavButtonVisible(invoiceType, status) {
            return invoiceType !== 'PRO_FORMA' && status !== 'DONE' && status !== 'SENT';
        }

        function hasInvoiceSendingStatus(status) {
            return status == 'ABORTED' || status == 'DONE' || status == 'SAVED';
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('InvoiceStornoController', InvoiceStornoController);

    InvoiceStornoController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'Invoice'];

    function InvoiceStornoController ($timeout, $scope, $uibModalInstance, entity, Invoice) {
        var vm = this;
        vm.invoice = entity;
        vm.clear = clear;
        vm.confirmStorno = confirmStorno;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmStorno() {
            Invoice.storno({id: vm.invoice.id},
                function (result) {
                    var pdfLink = '/api/invoices/' + result.id + '/pdf';
                    window.open(pdfLink, '_blank');
                    $uibModalInstance.close(true);
                });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('InvoiceSetupDialogController', InvoiceSetupDialogController);

    InvoiceSetupDialogController.$inject = ['$timeout', '$scope', '$state', '$stateParams', 'registration', 'invoice', 'Invoice',
        'OptionalText', 'CongressSelector', 'BankAccount', 'Country', 'InvoiceUtils', 'registrationRegistrationTypes', 'roomReservations', 'orderedOptionalServices'];

    function InvoiceSetupDialogController($timeout, $scope, $state, $stateParams, registration, invoice, Invoice,
              OptionalText, CongressSelector, BankAccount, Country, InvoiceUtils, registrationRegistrationTypes, roomReservations, orderedOptionalServices) {
        var vm = this;
        vm.datePickerOpenStatus = {};
        vm.isShowInvoicePanel = false;
        vm.invoice = invoice;
        vm.bankAccounts = [];
        vm.registration = registration;
        vm.registrationRegistrationTypes = registrationRegistrationTypes;
        vm.roomReservations = roomReservations;
        vm.orderedOptionalServices = orderedOptionalServices;
        vm.taxNumberPattern = '';
        vm.openCalendar = openCalendar;
        vm.createInvoiceForPrinting = createInvoiceForPrinting;
        vm.setOptionalTextMessage = setOptionalTextMessage;
        vm.getRegistrationCurrency = getRegistrationCurrency;
        vm.showConfirmationPanel = showConfirmationPanel;
        vm.printInvoice = printInvoice;
        vm.sendAndPrintInvoice = sendAndPrintInvoice;
        vm.isLastNameRequired = isLastNameRequired;
        vm.isFirstNameRequired = isFirstNameRequired;
        vm.isOptionalNameRequired = isOptionalNameRequired;
        vm.isOptionalNameRequired = isOptionalNameRequired;
        vm.changeBillingMethod = changeBillingMethod;
        vm.setInvoiceName = setInvoiceName;
        vm.navVatCategoryChanged = navVatCategoryChanged;
        vm.isTaxNumberDisabled = isTaxNumberDisabled;
        vm.isTaxNumberRequired = isTaxNumberRequired;


        vm.countries = Country.query();
        OptionalText.queryByCongress({id: CongressSelector.getSelectedCongress().id}, function(result) {
            vm.optionalTexts = result;
        });

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function setOptionalTextMessage(text) {
            vm.invoice.optionalText = text;
        }

        function getRegistrationCurrency() {
            if (vm.registrationRegistrationTypes.length) {
                return vm.registrationRegistrationTypes[0].chargeableItemCurrency;
            }

            if (vm.roomReservations.length) {
                return vm.roomReservations[0].chargeableItemCurrency;
            }

            if (vm.orderedOptionalServices.length) {
                return vm.orderedOptionalServices[0].chargeableItemCurrency;
            }
            return null;
        }

        InvoiceUtils.hasValidRate(vm.getRegistrationCurrency())
            .then(function (response) {
                if (response.hasValidRate) {
                    vm.hasValidRate = true;
                }
                else {
                    vm.hasValidRate = false;
                }
            })
            .catch(function() {
                vm.hasValidRate = false;
            });

        BankAccount.queryByCongressId({congressId: CongressSelector.getSelectedCongress().id, currency: vm.getRegistrationCurrency() }, function(result) {
            vm.bankAccounts = result;
            if (vm.bankAccounts.length === 1) {
                vm.invoice.bankAccount = vm.bankAccounts[0];
            }
        });

        function showConfirmationPanel() {
            vm.invoiceEmail = vm.registration.email;
            vm.isShowConfirmationPanel = true;
        }

        function onSaveSuccess(result) {
            var pdfLink = '/api/invoices/' + result.id + '/pdf';
            window.open(pdfLink, '_blank');
            $state.transitionTo('invoice', $stateParams, {
                reload: true, inherit: false, notify: true
            });
            //vm.isSaving = false;
        }

        function onSaveError(result) {
            //$state.go('invoice', {id: registration.id}, {reload: true
            $state.transitionTo('invoice', $stateParams, {
                reload: true, inherit: false, notify: true
            });
            vm.isSaving = false;
        }

        function printInvoice() {
            vm.isSaving = true;
            Invoice.save(createInvoiceForPrinting(), onSaveSuccess, onSaveError);
        }

        function sendAndPrintInvoice() {
            vm.isSaving = true;
            Invoice.saveAndSendEmail(createInvoiceForPrinting(), onSaveSuccess, onSaveError);
        }

        function createInvoiceForPrinting() {
            var invoice = {};
            invoice.name1 = vm.invoice.name1;
            invoice.name2 = vm.invoice.name2;
            // invoice.optionalName = vm.invoice.optionalName;
            invoice.vatRegNumber = vm.invoice.vatRegNumber;
            invoice.city = vm.invoice.city;
            invoice.zipCode = vm.invoice.zipCode;
            invoice.street = vm.invoice.street;
            invoice.country = vm.invoice.country;
            invoice.startDate = vm.invoice.startDate;
            invoice.endDate = vm.invoice.endDate;
            invoice.dateOfFulfilment = vm.invoice.dateOfFulfilment;
            invoice.paymentDeadline = vm.invoice.paymentDeadline;
            invoice.billingMethod = vm.invoice.billingMethod;
            invoice.language = vm.invoice.language;
            invoice.navVatCategory = vm.invoice.navVatCategory;
            invoice.optionalText = vm.invoice.optionalText;
            invoice.bankAccount = vm.invoice.bankAccount;
            invoice.registrationId = vm.registration.id;
            invoice.customInvoiceEmail = vm.invoiceEmail;

            // alter ignored items from obj properties to list of numbers
            invoice.ignoredChargeableItemIdList = [];
            for (var prop in vm.invoice.ignoredChargeableItems) {
                if (vm.invoice.ignoredChargeableItems.hasOwnProperty(prop) && vm.invoice.ignoredChargeableItems[prop]) {
                    invoice.ignoredChargeableItemIdList.push(parseInt(prop, 10));
                }
            }

            invoice.ignoredChargedServiceIdList = [];
            for (var prop in vm.invoice.ignoredChargedServices) {
                if (vm.invoice.ignoredChargedServices.hasOwnProperty(prop) && vm.invoice.ignoredChargedServices[prop]) {
                    invoice.ignoredChargedServiceIdList.push(parseInt(prop, 10));
                }
            }

            return invoice;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.datePickerOpenStatus.paymentDeadline = false;
        vm.datePickerOpenStatus.dateOfFulfilment = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function isLastNameRequired () {
            return vm.invoice.firstName || !vm.invoice.optionalName;
        }

        function isFirstNameRequired () {
            return vm.invoice.lastName || !vm.invoice.optionalName;
        }

        function isOptionalNameRequired () {
            return !vm.invoice.firstName && !vm.invoice.lastName;
        }

        function changeBillingMethod () {
            if (vm.invoice.billingMethod === 'TRANSFER') {
                vm.invoice.dateOfFulfilment = new Date();
                vm.invoice.paymentDeadline = (new Date()).setDate((new Date()).getDate() + 10);
            }
            else {
                vm.invoice.dateOfFulfilment = new Date();
                vm.invoice.paymentDeadline = new Date();
            }
        }

        function setInvoiceName() {
            if (!vm.invoice.invoiceName) {
                if (vm.invoice.language === 'hu') {
                    vm.invoice.name1 = vm.invoice.lastName + ' ' + vm.invoice.firstName;
                }
                else {
                    vm.invoice.name1 = vm.invoice.firstName + ' ' + vm.invoice.lastName;
                }
            }
        }

        function isTaxNumberDisabled() {
            if (vm.invoice.navVatCategory === 'PRIVATE_PERSON') {
                return true;
            }
            else {
                return false;
            }
        }

        function isTaxNumberRequired() {
            if (vm.invoice.navVatCategory === 'DOMESTIC_NORMAL_VAT_TAX_NUMBER' ||
                vm.invoice.navVatCategory === 'DOMESTIC_GROUP_VAT_TAX_NUMBER') {
                return true;
            }
            else {
                return false;
            }
        }

        function navVatCategoryChanged() {
            if (vm.invoice.navVatCategory === 'PRIVATE_PERSON') {
                vm.invoice.vatRegNumber = null;
            }

            if (vm.invoice.navVatCategory === 'DOMESTIC_NORMAL_VAT_TAX_NUMBER') {
                vm.taxNumberPattern = /^[0-9]{8}-[0-9]{1}-[0-9]{2}$/;
            }
            else if (vm.invoice.navVatCategory === 'EU_NO_VAT_EU_TAX_NUMBER' || vm.invoice.navVatCategory === 'EU_VAT_EU_TAX_NUMBER') {
                vm.taxNumberPattern = /^[A-Z]{2}[0-9A-Z]{2,13}$/;
            }
            else {
                vm.taxNumberPattern = '';
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('InvoiceSetPaymentDateDialogController', InvoiceSetPaymentDateDialogController);

    InvoiceSetPaymentDateDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Invoice'];

    function InvoiceSetPaymentDateDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Invoice) {
        var vm = this;

        vm.invoice = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            Invoice.savePaymentDate(vm.invoice, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:invoiceSetPaymentDate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.paymentDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('InvoiceDialogController', InvoiceDialogController);

    InvoiceDialogController.$inject = ['$timeout', 'registration', 'registrationRegistrationTypes', 'roomReservations', 'orderedOptionalServices',
        'chargedServices', 'invoice', 'invoicedChargeableItemIds', 'invoicedChargedServiceIds'];

    function InvoiceDialogController ($timeout, registration, registrationRegistrationTypes, roomReservations, orderedOptionalServices,
                                      chargedServices, invoice, invoicedChargeableItemIds, invoicedChargedServiceIds) {
        var vm = this;
        vm.invoice = invoice;
        vm.invoice.lastName = registration.lastName;
        vm.invoice.firstName = registration.firstName;
        vm.invoice.invoiceName = registration.invoiceName;
        vm.invoice.name1 = registration.invoiceName ? registration.invoiceName : registration.lastName + ' ' + registration.firstName;
        vm.invoice.vatRegNumber = registration.invoiceTaxNumber ? registration.invoiceTaxNumber : (registration.workplace ? (registration.workplace.vatRegNumber || '') : '');
        vm.invoice.country = registration.invoiceCountry ? registration.invoiceCountry.code : (registration.country ? registration.country.code : null);
        vm.invoice.city = registration.invoiceCity ? registration.invoiceCity : registration.city;
        vm.invoice.zipCode = registration.invoiceZipCode ? registration.invoiceZipCode : registration.zipCode;
        vm.invoice.street = registration.invoiceAddress ? registration.invoiceAddress : registration.street;
        vm.invoice.registration = registration;

        vm.registrationRegistrationTypes = registrationRegistrationTypes;
        vm.roomReservations = roomReservations;
        vm.orderedOptionalServices = orderedOptionalServices;
        vm.chargedServices = chargedServices;
        vm.invoicedChargeableItemIds = invoicedChargeableItemIds;
        vm.invoicedChargedServiceIds = invoicedChargedServiceIds;
        vm.unInvoiceableChargeableItems = [];
        vm.unInvoiceableChargedServiceIds = [];

        vm.calculateTotalDue = calculateTotalDue;
        vm.isInvoiceable = isInvoiceable;
        vm.getPriceAlreadyPaid = getPriceAlreadyPaid;
        vm.getGroupPaid = getGroupPaid;
        vm.getPriceToBePaid = getPriceToBePaid;
        vm.sumPriceToBePaid = sumPriceToBePaid;
        vm.sumGroupAlreadyPaid = sumGroupAlreadyPaid;
        vm.sumPriceAlreadyPaid = sumPriceAlreadyPaid;
        vm.isChargeableItemDisabled = isChargeableItemDisabled;
        vm.isChargedServiceDisabled = isChargedServiceDisabled;

        initIgnoredChargedServices();
        initIgnoredChargeableItems();

        function initIgnoredChargeableItems() {
            // init by already invoiced items
            if (vm.invoice.ignoredChargeableItems === null) {
                vm.invoice.ignoredChargeableItems = {};
                for (var i = 0; i < vm.invoicedChargeableItemIds.length; i++) {
                    vm.invoice.ignoredChargeableItems[vm.invoicedChargeableItemIds[i].toString()] = true;
                }
            }

            //init by the items where price have to be paid is zero, so it can not be on any invoice
            for (var i = 0; i < vm.registrationRegistrationTypes.length; i++) {
                var rrt = vm.registrationRegistrationTypes[i];
                if (rrt.chargeableItemPrice === vm.getGroupPaid(rrt)) {
                    vm.invoice.ignoredChargeableItems[rrt.id.toString()] = true;
                    vm.unInvoiceableChargeableItems.push(rrt.id);
                }
            }

            for (var i = 0; i < vm.roomReservations.length; i++) {
                var rr = vm.roomReservations[i];
                if (rr.chargeableItemPrice === vm.getGroupPaid(rr)) {
                    vm.invoice.ignoredChargeableItems[rr.id.toString()] = true;
                    vm.unInvoiceableChargeableItems.push(rr.id);
                }
            }

            for (i = 0; i < vm.orderedOptionalServices.length; i++) {
                var oos = vm.orderedOptionalServices[i];
                if (oos.chargeableItemPrice === vm.getGroupPaid(oos)) {
                    vm.invoice.ignoredChargeableItems[oos.id.toString()] = true;
                    vm.unInvoiceableChargeableItems.push(oos.id);
                }
            }

        }

        function initIgnoredChargedServices() {
            if (vm.invoice.ignoredChargedServices === null) {
                vm.invoice.ignoredChargedServices = {};
                for (var i = 0; i < vm.chargedServices.length; i++) {
                    var cs = vm.chargedServices[i];
                    if (cs.amount < 0) {
                        vm.unInvoiceableChargedServiceIds.push(cs.id);
                        vm.invoice.ignoredChargedServices[cs.id] = true;
                    }
                }

                for (i = 0; i < vm.invoicedChargedServiceIds.length; i++) {
                    vm.invoice.ignoredChargedServices[vm.invoicedChargedServiceIds[i].toString()] = true;
                }
            }
        }

        vm.toggleIgnoreChargeableItem = function (chargeableItemId) {

        };

        vm.toggleIgnoreChargedService = function (chargedServiceId) {

        };

        function isChargeableItemDisabled(id) {
            var disabled = vm.invoicedChargeableItemIds.indexOf(id) > -1;
            if (!disabled) {
                for (var i = 0; i < vm.unInvoiceableChargeableItems.length; i++) {
                    if (vm.unInvoiceableChargeableItems[i] === id) {
                        disabled = true;
                        break;
                    }
                }
            }
            return disabled;
        }

        function isChargedServiceDisabled(id) {
            var disabled = vm.invoicedChargedServiceIds.indexOf(id) > -1;
            if (!disabled) {
                for (var i = 0; i < vm.unInvoiceableChargedServiceIds.length; i++) {
                    if (vm.unInvoiceableChargedServiceIds[i] === id) {
                        disabled = true;
                        break;
                    }
                }
            }
            return disabled;
        }

        function isInvoiceable() {
            var itemNumInAllLists = vm.registrationRegistrationTypes.length +
                vm.roomReservations.length + vm.orderedOptionalServices.length + vm.chargedServices.length;
            var notAllIgnored = getNumberOfIgnoredItems() < itemNumInAllLists;
            return notAllIgnored && !(vm.invoicedChargeableItemIds.length == vm.registrationRegistrationTypes.length +
                vm.roomReservations.length + vm.orderedOptionalServices.length &&
                vm.invoicedChargedServiceIds.length == vm.chargedServices.length);
        }

        function getNumberOfIgnoredItems() {
            var result = 0;
            for (var prop in vm.invoice.ignoredChargeableItems) {
                if (vm.invoice.ignoredChargeableItems.hasOwnProperty(prop) && vm.invoice.ignoredChargeableItems[prop]) {
                    result++;
                }
            }

            for (var prop in vm.invoice.ignoredChargedServices) {
                if (vm.invoice.ignoredChargedServices.hasOwnProperty(prop) && vm.invoice.ignoredChargedServices[prop]) {
                    result++;
                }
            }
            return result;
        }

        function getPriceAlreadyPaid(chargeableItemId) {
            var i, amount = 0;
            for (i = 0; i < vm.chargedServices.length; i++) {
                if (vm.chargedServices[i].chargeableItemId === chargeableItemId) {
                    amount += vm.chargedServices[i].amount;
                }
            }
            return amount;
        }

        function getGroupPaid(chargeableItem) {
            return chargeableItem.chargeableItemPrice - chargeableItem.priceWithDiscount;
        }

        function getPriceToBePaid(price, chargeableItemId) {
            return price - vm.getPriceAlreadyPaid(chargeableItemId)
        }

        function sumPriceAlreadyPaid(list) {
            var i, sumAmount = 0;
            for (i = 0; i < list.length; i++) {
                sumAmount  += vm.getPriceAlreadyPaid(list[i].id);
            }
            return sumAmount;
        }

        function sumGroupAlreadyPaid(list) {
            var i, sumAmount = 0;
            for (i = 0; i < list.length; i++) {
                sumAmount  += vm.getGroupPaid(list[i]);
            }
            return sumAmount;
        }

        function sumPriceToBePaid(list) {
            var i, sumAmount = 0;
            for (i = 0; i < list.length; i++) {
                sumAmount  += vm.getPriceToBePaid(list[i].priceWithDiscount, list[i].id);
            }
            return sumAmount;
        }

        function calculateTotalDue() {
            var i, total = 0;
            for (i = 0; i < vm.registrationRegistrationTypes.length; i++) {
                if (!vm.invoice.ignoredChargeableItems[vm.registrationRegistrationTypes[i].id]) {
                    total += vm.registrationRegistrationTypes[i].priceWithDiscount;
                }
            }

            for (i = 0; i < vm.roomReservations.length; i++) {
                if (!vm.invoice.ignoredChargeableItems[vm.roomReservations[i].id]) {
                    total += vm.roomReservations[i].priceWithDiscount;
                }
            }

            for (i = 0; i < vm.orderedOptionalServices.length; i++) {
                if (!vm.invoice.ignoredChargeableItems[vm.orderedOptionalServices[i].id]) {
                    total += vm.orderedOptionalServices[i].priceWithDiscount;
                }
            }

            for (i = 0; i < vm.chargedServices.length; i++) {
                if (!vm.invoice.ignoredChargedServices[vm.chargedServices[i].id]) {
                    total -= vm.chargedServices[i].amount;
                }
            }

            return total;
        }

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;

/*
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });
*/

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.datePickerOpenStatus.paymentDeadline = false;
        vm.datePickerOpenStatus.createdDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('invoice', {
            parent: 'registration',
            url: '/invoice',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pcsApp.invoice.home.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/invoice/invoices.html',
                    controller: 'InvoiceController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                invoice: ['CongressSelector', 'DateUtils', function (CongressSelector, DateUtils) {
                    return {
                        name1: '',
                        name2: '',
                        invoiceName: '',
                        lastName: '',
                        firstName: '',
                        vatRegNumber: '',
                        city: '',
                        zipCode: '',
                        street: '',
                        country: CongressSelector.getSelectedCongress().defaultCountry ? CongressSelector.getSelectedCongress().defaultCountry.code : null,
                        optionalText: null,
                        startDate: new Date(CongressSelector.getSelectedCongress().startDate),
                        endDate: new Date(CongressSelector.getSelectedCongress().endDate),
                        dateOfFulfilment: new Date(),
                        paymentDeadline: (new Date()).setDate((new Date()).getDate() + 10),
                        billingMethod: 'TRANSFER',
                        language: 'hu',
                        navVatCategory: null,
                        createdDate: new Date(),
                        bankAccount: null,
                        registration: null,
                        ignoredChargeableItems: null,
                        ignoredChargedServices: null
                    };
                }],
                invoices: ['$stateParams', 'Invoice', function ($stateParams, Invoice) {
                    return Invoice.queryByRegistrationId({id: $stateParams.registrationId});
                }],
                invoicedChargeableItemIds: ['$stateParams', 'Invoice', function ($stateParams, Invoice) {
                    return Invoice.getInvoicedChargeableItemIdsByRegistrationId({id: $stateParams.registrationId});
                }],
                invoicedChargedServiceIds: ['$stateParams', 'Invoice', function ($stateParams, Invoice) {
                    return Invoice.getInvoicedChargedServiceIdsByRegistrationId({id: $stateParams.registrationId});
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('invoice');
                    $translatePartialLoader.addPart('optionalText');
                    $translatePartialLoader.addPart('navVatCategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('invoice.new', {
            parent: 'invoice',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/invoice/invoice-dialog.html',
                    controller: 'InvoiceDialogController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('invoice.setup', {
            parent: 'invoice',
            url: '/setup',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/invoice/invoice-setup-dialog.html',
                    controller: 'InvoiceSetupDialogController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('invoice.optional-text-new', {
            parent: 'invoice',
            url: '/optional-text/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'CongressSelector', function($stateParams, $state, $uibModal, CongressSelector) {
                $uibModal.open({
                    templateUrl: 'app/entities/optional-text/optional-text-dialog.html',
                    controller: 'OptionalTextDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                optionalText: null,
                                id: null,
                                congress: CongressSelector.getSelectedCongress()
                            };
                        }
                    }
                }).result.then(function(result) {
                        $state.go('invoice.setup', {reload: true});
                    }, function() {
                        $state.go('invoice.setup');
                    })
            }]
        })
        .state('invoice.set-payment-date', {
            parent: 'invoice',
            url: '/{id}/set-payment-date',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice/invoice-set-payment-date-dialog.html',
                    controller: 'InvoiceSetPaymentDateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                paymentDate: new Date(),
                                id: $stateParams.id
                            };
                        }
                    }
                }).result.then(function () {
                    $state.go('invoice', null, {reload: 'invoice'});
                }, function () {
                    $state.go('invoice');
                });
            }]
        })
        .state('invoice.storno', {
            parent: 'invoice',
            url: '/{invoiceId}/storno',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice/invoice-storno-dialog.html',
                    controller: 'InvoiceStornoController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['Invoice', function(Invoice) {
                            return Invoice.get({id : $stateParams.invoiceId}).$promise;
                        }]
                    }
                }).result.then(function(result) {
                        $state.go('invoice', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    })
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('Invoice', Invoice);

    Invoice.$inject = ['$resource', 'DateUtils'];

    function Invoice ($resource, DateUtils) {
        var resourceUrl =  'api/invoices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryByRegistrationId': {
                method: 'GET',
                url: 'api/registrations/:id/invoices',
                isArray: true
            },
            'getInvoicedChargeableItemIdsByRegistrationId': {
                method: 'GET',
                url: 'api/invoices/:id/invoiced-chargeable-items',
                isArray: true
            },
            'getInvoicedChargedServiceIdsByRegistrationId': {
                method: 'GET',
                url: 'api/invoices/:id/invoiced-charged-services',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertLocalDateFromServer(data.startDate);
                        data.endDate = DateUtils.convertLocalDateFromServer(data.endDate);
                        data.dateOfFulfilment = DateUtils.convertLocalDateFromServer(data.dateOfFulfilment);
                        data.paymentDeadline = DateUtils.convertLocalDateFromServer(data.paymentDeadline);
                        data.createdDate = DateUtils.convertLocalDateFromServer(data.createdDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    copy.dateOfFulfilment = DateUtils.convertLocalDateToServer(copy.dateOfFulfilment);
                    copy.paymentDeadline = DateUtils.convertLocalDateToServer(copy.paymentDeadline);
                    copy.createdDate = DateUtils.convertLocalDateToServer(copy.createdDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    copy.dateOfFulfilment = DateUtils.convertLocalDateToServer(copy.dateOfFulfilment);
                    copy.paymentDeadline = DateUtils.convertLocalDateToServer(copy.paymentDeadline);
                    copy.createdDate = DateUtils.convertLocalDateToServer(copy.createdDate);
                    return angular.toJson(copy);
                }
            },
            'saveAndSendEmail': {
                method: 'POST',
                url: 'api/invoices/save-and-send-email',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    copy.dateOfFulfilment = DateUtils.convertLocalDateToServer(copy.dateOfFulfilment);
                    copy.paymentDeadline = DateUtils.convertLocalDateToServer(copy.paymentDeadline);
                    copy.createdDate = DateUtils.convertLocalDateToServer(copy.createdDate);
                    return angular.toJson(copy);
                }
            },
            'savePaymentDate': {
                method: 'PUT',
                url: 'api/invoices/set-payment-date',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.paymentDate = DateUtils.convertLocalDateToServer(copy.paymentDate);
                    return angular.toJson(copy);
                }
            },
            'sendEmail': {
                method: 'POST',
                url: 'api/invoices/resend-email',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            },
            'storno': {
                method: 'GET',
                url: 'api/invoices/:id/storno'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('InvoiceController', InvoiceController);

    InvoiceController.$inject = ['$scope', '$state', 'invoices', 'registration', 'registrationRegistrationTypes',
        'roomReservations', 'orderedOptionalServices', 'Rate'];

    function InvoiceController ($scope, $state, invoices, registration, registrationRegistrationTypes,
        roomReservations, orderedOptionalServices, Rate) {
        var vm = this;

        vm.registration = registration;
        vm.invoices = invoices;
        vm.registrationRegistrationTypes = registrationRegistrationTypes;
        vm.roomReservations = roomReservations;
        vm.orderedOptionalServices = orderedOptionalServices;

        vm.hasValidCurrencyRate = true;

        checkValidCurrencyRate();


        vm.downloadPdf = function (invoiceId) {
            //var contextPath = window.location.pathname.substring(0, window.location.pathname.indexOf("/", 2));
            window.open('/api/invoices/' + invoiceId + '/pdf', '_blank');
        };

        function checkValidCurrencyRate() {
            var currency;
            if (vm.registrationRegistrationTypes.length) {
                currency = vm.registrationRegistrationTypes[0].chargeableItemCurrency;
            }
            else if (vm.roomReservations.length) {
                currency = vm.roomReservations[0].chargeableItemCurrency;
            }
            else if (vm.orderedOptionalServices.length) {
                currency = vm.orderedOptionalServices[0].chargeableItemCurrency;
            }

            if (currency && currency !== 'HUF') {
                Rate.getCurrentRate({currency: currency}, function (result) {
                    vm.hasValidCurrencyRate = true;
                }, function (result) { vm.hasValidCurrencyRate = false; });
            }
            else {
                vm.hasValidCurrencyRate = !currency || currency === 'HUF' || false;
            }
        }


    }
})();

 (function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('HotelSummarySelectionDialogController', HotelSummarySelectionDialogController);

    HotelSummarySelectionDialogController.$inject = ['$timeout', '$state', '$scope', '$stateParams', '$uibModalInstance', 'listFilter', 'CongressHotel', 'CongressSelector', 'HotelSummaryFilter'];

    function HotelSummarySelectionDialogController ($timeout, $state, $scope, $stateParams, $uibModalInstance, listFilter, CongressHotel, CongressSelector, HotelSummaryFilter) {
        var vm = this;

        vm.listFilter = listFilter;
        vm.clear = clear;
        vm.select = select;
        CongressHotel.queryByCongress({id: CongressSelector.getSelectedCongress().id}, function(result) {
            vm.congressHotels = result;
        });

/*
        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });
*/

        function clear () {
            $uibModalInstance.dismiss('cancel');
            $state.go('hotel-summary');
        }

        function select () {
            vm.isSaving = true;
            HotelSummaryFilter.setHotelSummaryFilter(vm.listFilter);
            $uibModalInstance.close();
            $state.go('hotel-summary', null, {reload: 'hotel-summary'});
            vm.isSaving = false;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('hotel-summary', {
                parent: 'report',
                url: '/hotel-summary',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'pcsApp.hotelSummary.home.title'
                },
                views: {
                    'content@base': {
                        templateUrl: 'app/entities/hotel-summary/hotel-summary.html',
                        controller: 'HotelSummaryController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    listFilter: ['HotelSummaryFilter', function (HotelSummaryFilter) {
                        return HotelSummaryFilter.getHotelSummaryFilter();
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('hotelSummary');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('hotel-summary.selection', {
                parent: 'hotel-summary',
                url: '/select',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'listFilter', function ($stateParams, $state, $uibModal, listFilter) {
                    $uibModal.open({
                        templateUrl: 'app/entities/hotel-summary/hotel-summary-selection-dialog.html',
                        controller: 'HotelSummarySelectionDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            listFilter: function () {
                                return listFilter;
                            }
                        }
                    });
                }]
            });
    }


})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('HotelSummary', HotelSummary);

    HotelSummary.$inject = ['$resource', 'DateUtils'];

    function HotelSummary ($resource, DateUtils) {
        var resourceUrl = 'api/hotel-summary/:meetingCode/:hotelId';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        for (var i = 0; i < data.rows.length; i++) {
                            data.rows[i] = DateUtils.convertLocalDateFromServer(data.rows[i]);
                        }

                        for (var j = 0; j < data.cells.length; j++) {
                            data.cells[j].reservationDate = DateUtils.convertLocalDateFromServer(data.cells[j].reservationDate);
                        }
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('HotelSummaryController', HotelSummaryController);

    HotelSummaryController.$inject = ['$scope', '$state', 'HotelSummary', 'DTOptionsBuilder', 'DTColumnDefBuilder', 'CongressSelector', 'listFilter'];

    function HotelSummaryController ($scope, $state, HotelSummary, DTOptionsBuilder, DTColumnDefBuilder, CongressSelector, listFilter) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions();
        vm.dtOptions.withOption('order', [0, 'asc']);
        vm.dtOptions.withOption('stateSave', true);
        vm.dtColumnDefs = [
        ];

        vm.listFilter = listFilter;
        vm.getNightFromCell = getNightFromCell;
        vm.getTotalByReservationDate = getTotalByReservationDate;
        vm.downloadReportXls = downloadReportXls;

        vm.hotelSummary = [];

        load();

        function load() {
            if (vm.listFilter.congressHotel) {
                HotelSummary.get({
                        meetingCode: CongressSelector.getSelectedCongress().meetingCode,
                        hotelId: listFilter.congressHotel.hotel.id
                    },
                    function (result) {
                        vm.hotelSummary = result;
                    }
                );
            }
        }

        function downloadReportXls () {
            window.location.href = '/api/hotel-summary/' + CongressSelector.getSelectedCongress().meetingCode
                + '/' + listFilter.congressHotel.hotel.id.toString() + '/download-report';
        }

        function getNightFromCell (reservationDate, roomId) {
            var nights = 0;
            for (var i = 0; i < vm.hotelSummary.cells.length; i++) {
                var cell = vm.hotelSummary.cells[i];
                if (cell.roomId === roomId && cell.reservationDate - reservationDate === 0) {
                    nights = cell.nights;
                    break;
                }
            }
            return nights;
        }

        function getTotalByReservationDate (reservationDate) {
            var nights = 0;
            for (var i = 0; i < vm.hotelSummary.cells.length; i++) {
                var cell = vm.hotelSummary.cells[i];
                if (cell.reservationDate - reservationDate === 0) {
                    nights += cell.nights;
                 }
            }
            return nights;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('hotel-general-report', {
                parent: 'report',
                url: '/hotel-general-report',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'pcsApp.hotelGeneralReport.home.title'
                },
                views: {
                    'content@base': {
                        templateUrl: 'app/entities/hotel-general-report/hotel-general-reports.html',
                        controller: 'HotelGeneralReportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('hotelGeneralReport');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }


})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('HotelGeneralReport', HotelGeneralReport);

    HotelGeneralReport.$inject = ['$resource'];

    function HotelGeneralReport ($resource) {
        var resourceUrl =  'api/hotel-general-report/:meetingCode';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('HotelGeneralReportController', HotelGeneralReportController);

    HotelGeneralReportController.$inject = ['$scope', '$state', 'HotelGeneralReport', 'DTOptionsBuilder', 'DTColumnDefBuilder', 'CongressSelector'];

    function HotelGeneralReportController ($scope, $state, HotelGeneralReport, DTOptionsBuilder, DTColumnDefBuilder, CongressSelector) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions();
        vm.dtOptions.withOption('order', [1, 'asc']);
        vm.dtOptions.withOption('scrollX', true);
        vm.dtOptions.withOption('stateSave', true);
        vm.dtColumnDefs = [
        ];

        vm.downloadReportXls = downloadReportXls;

        vm.hotelGeneralReports = [];

        loadAll();

        function loadAll() {
            HotelGeneralReport.query({
                    meetingCode: CongressSelector.getSelectedCongress().meetingCode
                },
                function (result) {
                    vm.hotelGeneralReports = result;
                }
            );
        }

        function downloadReportXls () {
            window.location.href = '/api/hotel-general-report/' + CongressSelector.getSelectedCongress().meetingCode + '/download-report';
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('HotelDialogController', HotelDialogController);

    HotelDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Hotel'];

    function HotelDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Hotel) {
        var vm = this;

        vm.hotel = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.hotel.id !== null) {
                Hotel.update(vm.hotel, onSaveSuccess, onSaveError);
            } else {
                Hotel.save(vm.hotel, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:hotelUpdate', result);
            $uibModalInstance.close(result);
            //vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('HotelDeleteController',HotelDeleteController);

    HotelDeleteController.$inject = ['$uibModalInstance', 'entity', 'Hotel'];

    function HotelDeleteController($uibModalInstance, entity, Hotel) {
        var vm = this;

        vm.hotel = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Hotel.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('hotel', {
            parent: 'maintenance',
            url: '/hotel',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pcsApp.hotel.home.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/hotel/hotels.html',
                    controller: 'HotelController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('hotel');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('hotel-detail', {
            parent: 'maintenance',
            url: '/hotel/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pcsApp.hotel.detail.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/hotel/hotel-detail.html',
                    controller: 'HotelDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('hotel');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Hotel', function($stateParams, Hotel) {
                    return Hotel.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'hotel',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('hotel-detail.edit', {
            parent: 'hotel-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hotel/hotel-dialog.html',
                    controller: 'HotelDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Hotel', function(Hotel) {
                            return Hotel.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('hotel.new', {
            parent: 'hotel',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hotel/hotel-dialog.html',
                    controller: 'HotelDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                code: null,
                                city: null,
                                street: null,
                                zipCode: null,
                                latitude: null,
                                longitude: null,
                                phone: null,
                                fax: null,
                                email: null,
                                contactName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('hotel', null, { reload: 'hotel' });
                }, function() {
                    $state.go('hotel');
                });
            }]
        })
        .state('hotel.edit', {
            parent: 'hotel',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hotel/hotel-dialog.html',
                    controller: 'HotelDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Hotel', function(Hotel) {
                            return Hotel.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('hotel', null, { reload: 'hotel' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('hotel.delete', {
            parent: 'hotel',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hotel/hotel-delete-dialog.html',
                    controller: 'HotelDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Hotel', function(Hotel) {
                            return Hotel.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('hotel', null, { reload: 'hotel' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('Hotel', Hotel);

    Hotel.$inject = ['$resource'];

    function Hotel ($resource) {
        var resourceUrl =  'api/hotels/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('HotelController', HotelController);

    HotelController.$inject = ['$scope', '$state', 'Hotel', 'DTOptionsBuilder', 'DTColumnBuilder', 'DTColumnDefBuilder'];

    function HotelController ($scope, $state, Hotel, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withDOM('<"html5buttons"B>ltfgitp')
            .withButtons([
                {extend: 'excel', title: 'hotels'},
                {extend: 'pdf', title: 'hotels'}
            ]);

        vm.dtOptions.withOption('stateSave', true);
        vm.dtColumnDefs = [
            // negative int calculated from the right of the columns
            DTColumnDefBuilder.newColumnDef(-1).notSortable()
        ];

        vm.hotels = [];

        loadAll();

        function loadAll() {
            Hotel.query(function(result) {
                vm.hotels = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('GroupDiscountPaymentDialogController', GroupDiscountPaymentDialogController);

    GroupDiscountPaymentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'GroupDiscountPayment', 'Currency', 'Congress', 'CongressSelector', 'PayingGroup'];

    function GroupDiscountPaymentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity,
        GroupDiscountPayment, Currency, Congress, CongressSelector, PayingGroup) {
        var vm = this;

        vm.groupDiscountPayment = entity;
        vm.payingGroups = PayingGroup.queryByCongress({id: CongressSelector.getSelectedCongress().id});
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.clear = clear;
        vm.save = save;
        vm.currencies = [];

        Congress.get({id: CongressSelector.getSelectedCongress().id}, function(data) {
            vm.currencies = data.currencies;
        });

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.groupDiscountPayment.id !== null) {
                GroupDiscountPayment.update(vm.groupDiscountPayment, onSaveSuccess, onSaveError);
            } else {
                GroupDiscountPayment.save(vm.groupDiscountPayment, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:groupDiscountPaymentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dateOfPayment = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('GroupDiscountPaymentDeleteController',GroupDiscountPaymentDeleteController);

    GroupDiscountPaymentDeleteController.$inject = ['$uibModalInstance', 'entity', 'GroupDiscountPayment'];

    function GroupDiscountPaymentDeleteController($uibModalInstance, entity, GroupDiscountPayment) {
        var vm = this;

        vm.groupDiscountPayment = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            GroupDiscountPayment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('group-discount-payment', {
            parent: 'group-discount',
            url: '/group-discount-payment',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pcsApp.groupDiscountPayment.home.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/group-discount-payment/group-discount-payments.html',
                    controller: 'GroupDiscountPaymentController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('groupDiscountPayment');
                    $translatePartialLoader.addPart('chargeableItemType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('group-discount-payment-detail.edit', {
            parent: 'group-discount-payment-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/group-discount-payment/group-discount-payment-dialog.html',
                    controller: 'GroupDiscountPaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GroupDiscountPayment', function(GroupDiscountPayment) {
                            return GroupDiscountPayment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('group-discount-payment.new', {
            parent: 'group-discount-payment',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'CongressSelector', function($stateParams, $state, $uibModal, CongressSelector) {
                $uibModal.open({
                    templateUrl: 'app/entities/group-discount-payment/group-discount-payment-dialog.html',
                    controller: 'GroupDiscountPaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                paymentType: null,
                                dateOfPayment: new Date(),
                                amount: null,
                                id: null,
                                congress: CongressSelector.getSelectedCongress()
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('group-discount-payment', null, { reload: 'group-discount-payment' });
                }, function() {
                    $state.go('group-discount-payment');
                });
            }]
        })
        .state('group-discount-payment.edit', {
            parent: 'group-discount-payment',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/group-discount-payment/group-discount-payment-dialog.html',
                    controller: 'GroupDiscountPaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GroupDiscountPayment', function(GroupDiscountPayment) {
                            return GroupDiscountPayment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('group-discount-payment', null, { reload: 'group-discount-payment' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('group-discount-payment.delete', {
            parent: 'group-discount-payment',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/group-discount-payment/group-discount-payment-delete-dialog.html',
                    controller: 'GroupDiscountPaymentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['GroupDiscountPayment', function(GroupDiscountPayment) {
                            return GroupDiscountPayment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('group-discount-payment', null, { reload: 'group-discount-payment' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('GroupDiscountPayment', GroupDiscountPayment);

    GroupDiscountPayment.$inject = ['$resource', 'DateUtils'];

    function GroupDiscountPayment ($resource, DateUtils) {
        var resourceUrl =  'api/group-discount-payments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryByCongress': {
                method: 'GET',
                url: 'api/group-discount-payments/congress/:id',
                isArray: true
            },
            'queryByPayingGroupId': {
                method: 'GET',
                url: 'api/group-discount-payments/paying-group/:id',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateOfPayment = DateUtils.convertLocalDateFromServer(data.dateOfPayment);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateOfPayment = DateUtils.convertLocalDateToServer(copy.dateOfPayment);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateOfPayment = DateUtils.convertLocalDateToServer(copy.dateOfPayment);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('GroupDiscountPaymentController', GroupDiscountPaymentController);

    GroupDiscountPaymentController.$inject = ['$scope', '$state', 'GroupDiscountPayment', 'DTOptionsBuilder', 'DTColumnDefBuilder', 'CongressSelector'];

    function GroupDiscountPaymentController ($scope, $state, GroupDiscountPayment, DTOptionsBuilder, DTColumnDefBuilder, CongressSelector) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions();
        vm.dtOptions.withOption('order', [0, 'asc']);
        vm.dtOptions.withOption('stateSave', true);
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(-1).notSortable()
        ];

        vm.groupDiscountPayments = [];

        loadAll();

        function loadAll() {
            GroupDiscountPayment.queryByCongress({id: CongressSelector.getSelectedCongress().id}, function(result) {
                vm.groupDiscountPayments = result;
            });
        }
    }
})();

 (function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('GroupDiscountItemSelectionDialogController', GroupDiscountItemSelectionDialogController);

    GroupDiscountItemSelectionDialogController.$inject = ['$timeout', '$state', 'CongressSelector', '$uibModalInstance', 'groupDiscountItemFilter', 'PayingGroup', 'GroupDiscountItemFilter'];

    function GroupDiscountItemSelectionDialogController ($timeout, $state, CongressSelector, $uibModalInstance, groupDiscountItemFilter, PayingGroup, GroupDiscountItemFilter) {
        var vm = this;

        vm.clear = clear;
        vm.select = select;
        vm.payingGroups = PayingGroup.queryByCongress({id: CongressSelector.getSelectedCongress().id});
        vm.groupDiscountItemFilter = groupDiscountItemFilter;

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
            $state.go('group-discount-item');
        }

        function select () {
            vm.isSaving = true;
            vm.groupDiscountItemFilter.selectedChargeableItemIds = {};
            GroupDiscountItemFilter.setGroupDiscountItemFilter(vm.groupDiscountItemFilter);
            $uibModalInstance.close();
            $state.go('group-discount-item', null, {reload: 'group-discount-item'});
            vm.isSaving = false;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('GroupDiscountItemInvoiceSetupDialogController', GroupDiscountItemInvoiceSetupDialogController);

    GroupDiscountItemInvoiceSetupDialogController.$inject = ['$timeout', '$scope', '$state', '$stateParams', 'invoice', 'GroupDiscountInvoice', 'groupDiscountItemFilter',
        'OptionalText', 'CongressSelector', 'BankAccount', 'Country', 'InvoiceUtils', 'GroupDiscountItemFilter'];

    function GroupDiscountItemInvoiceSetupDialogController($timeout, $scope, $state, $stateParams, invoice, GroupDiscountInvoice, groupDiscountItemFilter,
              OptionalText, CongressSelector, BankAccount, Country, InvoiceUtils, GroupDiscountItemFilter) {
        var vm = this;

        vm.invoice = invoice;
        vm.invoice.payingGroup = groupDiscountItemFilter.payingGroup;
        vm.selectedChargeableItemIds = groupDiscountItemFilter.selectedChargeableItemIds;
        if (!vm.invoice.payingGroup) {
            $state.go('group-discount-item', null, {refresh: 'group-discount-item'});
        }

        vm.datePickerOpenStatus = {};
        vm.isShowInvoicePanel = false;
        vm.printInvoice = printInvoice;
        vm.bankAccounts = [];
        vm.taxNumberPattern = '';

        vm.openCalendar = openCalendar;
        vm.createInvoiceForPrinting = createInvoiceForPrinting;
        vm.setOptionalTextMessage = setOptionalTextMessage;
        vm.showConfirmationPanel = showConfirmationPanel;
        vm.sendAndPrintInvoice = sendAndPrintInvoice;
        vm.isAnyItemSelectedForInvoicing = isAnyItemSelectedForInvoicing;
        vm.changeBillingMethod = changeBillingMethod;
        vm.navVatCategoryChanged = navVatCategoryChanged;
        vm.isTaxNumberDisabled = isTaxNumberDisabled;
        vm.isTaxNumberRequired = isTaxNumberRequired;

        vm.countries = Country.query();
        OptionalText.queryByCongress({id: CongressSelector.getSelectedCongress().id}, function(result) {
            vm.optionalTexts = result;
        });

        function setOptionalTextMessage(text) {
            vm.invoice.optionalText = text;
        }

        InvoiceUtils.hasValidRate(vm.invoice.payingGroup.currency)
            .then(function (response) {
                if (response.hasValidRate) {
                    vm.hasValidRate = true;
                }
                else {
                    vm.hasValidRate = false;
                }
            })
            .catch(function() {
                vm.hasValidRate = false;
            });

        BankAccount.queryByCongressId({congressId: CongressSelector.getSelectedCongress().id, currency: vm.invoice.payingGroup.currency.currency }, function(result) {
            vm.bankAccounts = result;
            if (vm.bankAccounts.length == 1) {
                vm.invoice.bankAccount = vm.bankAccounts[0];
            }
        });

        function showConfirmationPanel() {
            vm.invoiceEmail = vm.invoice.payingGroup.email;
            vm.isShowConfirmationPanel = true;
        }

        function onSaveSuccess(result) {
            GroupDiscountItemFilter.resetSelectedItems();
            var pdfLink = '/api/group-discount-invoices/' + result.id + '/pdf';
            window.open(pdfLink, '_blank');
            $state.transitionTo('group-discount-item', $stateParams, {
                reload: true, inherit: false, notify: true
            });
            //vm.isSaving = false;
        }

        function onSaveError(result) {
            $state.transitionTo('group-discount-item', $stateParams, {
                reload: true, inherit: false, notify: true
            });
            vm.isSaving = false;
        }

        function printInvoice() {
            vm.isSaving = true;
            GroupDiscountInvoice.save(createInvoiceForPrinting(), onSaveSuccess, onSaveError);
        }

        function sendAndPrintInvoice() {
            vm.isSaving = true;
            GroupDiscountInvoice.saveAndSendEmail(createInvoiceForPrinting(), onSaveSuccess, onSaveError);
        }

        function createInvoiceForPrinting() {
            var invoice = {};
            invoice.name = vm.invoice.name;
            invoice.taxNumber = vm.invoice.taxNumber;
            invoice.city = vm.invoice.city;
            invoice.zipCode = vm.invoice.zipCode;
            invoice.street = vm.invoice.street;
            invoice.country = vm.invoice.country;
            invoice.startDate = vm.invoice.startDate;
            invoice.endDate = vm.invoice.endDate;
            invoice.dateOfFulfilment = vm.invoice.dateOfFulfilment;
            invoice.paymentDeadline = vm.invoice.paymentDeadline;
            invoice.billingMethod = vm.invoice.billingMethod;
            invoice.language = vm.invoice.language;
            invoice.navVatCategory = vm.invoice.navVatCategory;
            invoice.optionalText = vm.invoice.optionalText;
            invoice.bankAccount = vm.invoice.bankAccount;
            invoice.payingGroup = vm.invoice.payingGroup;
            invoice.customInvoiceEmail = vm.invoiceEmail;

            // alter ignored items from obj properties to list of numbers
            invoice.chargeableItemIdList = [];
            for (var prop in vm.selectedChargeableItemIds) {
                if (vm.selectedChargeableItemIds.hasOwnProperty(prop) && vm.selectedChargeableItemIds[prop]) {
                    invoice.chargeableItemIdList.push(parseInt(prop, 10));
                }
            }
            return invoice;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.datePickerOpenStatus.dateOfFulfilment = false;
        vm.datePickerOpenStatus.paymentDeadline = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function isAnyItemSelectedForInvoicing () {
            for (var prop in vm.selectedChargeableItemIds) {
                if (vm.selectedChargeableItemIds.hasOwnProperty(prop)) {
                    return true;
                }
            }
            return false;
        }

        function changeBillingMethod () {
            if (vm.invoice.billingMethod === 'TRANSFER') {
                vm.invoice.dateOfFulfilment = new Date();
                vm.invoice.paymentDeadline = (new Date()).setDate((new Date()).getDate() + 10);
            }
            else {
                vm.invoice.dateOfFulfilment = new Date();
                vm.invoice.paymentDeadline = new Date();
            }
        }

        function isTaxNumberDisabled() {
            if (vm.invoice.navVatCategory === 'PRIVATE_PERSON') {
                return true;
            }
            else {
                return false;
            }
        }

        function isTaxNumberRequired() {
            if (vm.invoice.navVatCategory === 'DOMESTIC_NORMAL_VAT_TAX_NUMBER' ||
                vm.invoice.navVatCategory === 'DOMESTIC_GROUP_VAT_TAX_NUMBER') {
                return true;
            }
            else {
                return false;
            }
        }

        function navVatCategoryChanged() {
            if (vm.invoice.navVatCategory === 'PRIVATE_PERSON') {
                vm.invoice.vatRegNumber = null;
            }

            if (vm.invoice.navVatCategory === 'DOMESTIC_NORMAL_VAT_TAX_NUMBER') {
                vm.taxNumberPattern = /^[0-9]{8}-[0-9]{1}-[0-9]{2}$/;
            }
            else if (vm.invoice.navVatCategory === 'EU_NO_VAT_EU_TAX_NUMBER' || vm.invoice.navVatCategory === 'EU_VAT_EU_TAX_NUMBER') {
                vm.taxNumberPattern = /^[A-Z]{2}[0-9A-Z]{2,13}$/;
            }
            else {
                vm.taxNumberPattern = '';
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('group-discount-item', {
                parent: 'group-discount',
                url: '/group-discount-item',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'pcsApp.groupDiscountItem.home.title'
                },
                views: {
                    'content@base': {
                        templateUrl: 'app/entities/group-discount-item/group-discount-items.html',
                        controller: 'GroupDiscountItemController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('groupDiscountItem');
                        $translatePartialLoader.addPart('groupDiscountInvoice');
                        $translatePartialLoader.addPart('chargeableItemType');
                        $translatePartialLoader.addPart('optionalText');
                        $translatePartialLoader.addPart('navVatCategory');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('group-discount-item.selection', {
                parent: 'group-discount-item',
                url: '/select',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'groupDiscountItemFilter', function ($stateParams, $state, $uibModal, groupDiscountItemFilter) {
                    $uibModal.open({
                        templateUrl: 'app/entities/group-discount-item/group-discount-item-selection-dialog.html',
                        controller: 'GroupDiscountItemSelectionDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            groupDiscountItemFilter: function () {
                                return groupDiscountItemFilter;
                            }
                        }
                    });
                }]
            })
            .state('group-discount-item.setup', {
                parent: 'group-discount-item',
                url: '/invoice/setup',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@base': {
                        templateUrl: 'app/entities/group-discount-item/group-discount-item-invoice-setup-dialog.html',
                        controller: 'GroupDiscountItemInvoiceSetupDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    invoice: ['CongressSelector', 'groupDiscountItemFilter', function (CongressSelector, groupDiscountItemFilter) {
                        return {
                            invoiceNumber: null,
                            stornoInvoiceNumber: null,
                            name: groupDiscountItemFilter.payingGroup ? groupDiscountItemFilter.payingGroup.name : null,
                            taxNumber: groupDiscountItemFilter.payingGroup ? groupDiscountItemFilter.payingGroup.taxNumber : null,
                            city: groupDiscountItemFilter.payingGroup ? groupDiscountItemFilter.payingGroup.city : null,
                            zipCode: groupDiscountItemFilter.payingGroup ? groupDiscountItemFilter.payingGroup.zipCode : null,
                            street: groupDiscountItemFilter.payingGroup ? groupDiscountItemFilter.payingGroup.street : null,
                            country: groupDiscountItemFilter.payingGroup ? groupDiscountItemFilter.payingGroup.country.code : null,
                            optionalText: null,
                            startDate: new Date(CongressSelector.getSelectedCongress().startDate),
                            endDate: new Date(CongressSelector.getSelectedCongress().endDate),
                            dateOfFulfilment: new Date(),
                            paymentDeadline: (new Date()).setDate((new Date()).getDate() + 10),
                            billingMethod: 'TRANSFER',
                            language: 'hu',
                            navVatCategory: null,
                            bankName: null,
                            bankAccount: null,
                            swiftCode: null,
                            storno: null,
                            stornired: null,
                            createdDate: null,
                            dateOfGrougPayment: null,
                            id: null,
                            payingGroup: null
                        };
                    }]
                }
            })
            .state('group-discount-item.optional-text-new', {
                parent: 'group-discount-item',
                url: '/optional-text/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'CongressSelector', function ($stateParams, $state, $uibModal, CongressSelector) {
                    $uibModal.open({
                        templateUrl: 'app/entities/optional-text/optional-text-dialog.html',
                        controller: 'OptionalTextDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    name: null,
                                    optionalText: null,
                                    id: null,
                                    congress: CongressSelector.getSelectedCongress()
                                };
                            }
                        }
                    }).result.then(function (result) {
                            $state.go('group-discount-item.setup', {reload: true});
                        }, function () {
                            $state.go('group-discount-item.setup');
                        })
                }]
            });

    }


})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('GroupDiscountItem', GroupDiscountItem);

    GroupDiscountItem.$inject = ['$resource', 'DateUtils'];

    function GroupDiscountItem ($resource, DateUtils) {
        var resourceUrl =  'api/group-discount-items/:meetingCode/:payingGroupId/:chargeableItemType';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
/*
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateOfPayment = DateUtils.convertLocalDateFromServer(data.dateOfPayment);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateOfPayment = DateUtils.convertLocalDateToServer(copy.dateOfPayment);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateOfPayment = DateUtils.convertLocalDateToServer(copy.dateOfPayment);
                    return angular.toJson(copy);
                }
            }
*/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('GroupDiscountItemController', GroupDiscountItemController);

    GroupDiscountItemController.$inject = ['$scope', '$state', 'GroupDiscountItem', 'DTOptionsBuilder', 'DTColumnDefBuilder'
        , 'CongressSelector', 'groupDiscountItemFilter', 'Rate', 'GroupDiscountPayment'];

    function GroupDiscountItemController ($scope, $state, GroupDiscountItem, DTOptionsBuilder, DTColumnDefBuilder
                                          , CongressSelector, groupDiscountItemFilter, Rate, GroupDiscountPayment) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions();
        vm.dtOptions.withOption('order', [2, 'asc']);
        vm.dtOptions.withOption('stateSave', true);
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).notSortable()
        ];

        vm.allChargeableItemIdSelected = false;
        vm.toggleGroupDiscountSelection = toggleGroupDiscountSelection;
        vm.toggleAllGroupDiscountSelection = toggleAllGroupDiscountSelection;
        vm.groupDiscountItemFilter = groupDiscountItemFilter;
        vm.isAnyChargeableItemIdSelected = isAnyChargeableItemIdSelected;
        vm.groupDiscountItems = [];
        vm.groupDiscountPayments = [];
        vm.sumRegistration = 0;
        vm.sumHotel = 0;
        vm.sumOptionalService = 0;
        vm.groupPaidRegistration = 0;
        vm.groupPaid = 0;
        vm.groupPaidOptionalService = 0;

        vm.downloadReportXls = downloadReportXls;
        vm.downloadProFormaGroupInvoiceReportXls = downloadProFormaGroupInvoiceReportXls;
        vm.isSelectedPayingGroupInvoiceable = isSelectedPayingGroupInvoiceable;
        vm.hasValidCurrencyRate = true;

        checkValidCurrencyRate();
        loadAll();

        function loadAll() {
            if (vm.groupDiscountItemFilter.payingGroup) {
                if (vm.groupDiscountItemFilter.chargeableItemType !== 'ALL') {
                    GroupDiscountItem.query({
                            meetingCode: CongressSelector.getSelectedCongress().meetingCode,
                            payingGroupId: groupDiscountItemFilter.payingGroup.id,
                            chargeableItemType: groupDiscountItemFilter.chargeableItemType
                        },
                        function (result) {
                            vm.groupDiscountItems = result;
                            calculateSumAmountByChargeableItemType();
                        }
                    );
                }
                else {
                    GroupDiscountItem.query({
                            meetingCode: CongressSelector.getSelectedCongress().meetingCode,
                            payingGroupId: groupDiscountItemFilter.payingGroup.id
                        },
                        function (result) {
                            vm.groupDiscountItems = result;
                            calculateSumAmountByChargeableItemType();
                        }
                    );
                }

                GroupDiscountPayment.queryByPayingGroupId({id: groupDiscountItemFilter.payingGroup.id}, function(result) {
                    vm.groupDiscountPayments = result;
                    calculateGroupPaidAmountByChargeableItemType();
                });
            }
        }

        function toggleGroupDiscountSelection(chargeableItemId) {
            // vm.groupDiscountItemFilter.selectedChargeableItemIds[chargeableItemId.toString()] = !isChargeableItemIdSelected(chargeableItemId);
        }

        function toggleAllGroupDiscountSelection() {
            if (!vm.allChargeableItemIdSelected) {
                vm.groupDiscountItemFilter.selectedChargeableItemIds = {};
            }
            else {
                for (var i = 0; i < vm.groupDiscountItems.length; i++) {
                    if (!vm.groupDiscountItems[i].invoiceNumber) {
                        vm.groupDiscountItemFilter.selectedChargeableItemIds[vm.groupDiscountItems[i].chargeableItemId.toString()] = true;
                    }
                }
            }
        }

        function isChargeableItemIdSelected(chargeableItemId) {
            for (var prop in vm.groupDiscountItemFilter.selectedChargeableItemIds) {
                if (vm.groupDiscountItemFilter.selectedChargeableItemIds.hasOwnProperty(prop) && prop === chargeableItemId) {
                    return true;
                }
            }
            return false;
        }

        function isAnyChargeableItemIdSelected() {
            for (var prop in vm.groupDiscountItemFilter.selectedChargeableItemIds) {
                if (vm.groupDiscountItemFilter.selectedChargeableItemIds.hasOwnProperty(prop) && vm.groupDiscountItemFilter.selectedChargeableItemIds[prop]) {
                    return true;
                }
            }
            return false;
        }

        function isSelectedPayingGroupInvoiceable() {
            if (groupDiscountItemFilter.payingGroup && groupDiscountItemFilter.payingGroup.currency
                && groupDiscountItemFilter.payingGroup.currency.currency === 'HUF' && !groupDiscountItemFilter.payingGroup.taxNumber) {
                return false;
            }
            return true;
        }

        function calculateSumAmountByChargeableItemType() {
            vm.sumRegistration = 0;
            vm.sumHotel = 0;
            vm.sumOptionalService = 0;
            for (var i = 0; i < vm.groupDiscountItems.length; i++) {
                var item = vm.groupDiscountItems[i];
                switch (item.chargeableItemType) {
                    case "REGISTRATION":
                        vm.sumRegistration += item.amount;
                        break;
                    case "HOTEL":
                        vm.sumHotel += item.amount;
                        break;
                    case "OPTIONAL_SERVICE":
                        vm.sumOptionalService += item.amount;
                        break;
                }
            }
        }

        function calculateGroupPaidAmountByChargeableItemType() {
            vm.groupPaidRegistration = 0;
            vm.groupPaidHotel = 0;
            vm.groupPaidOptionalService = 0;
            for (var i = 0; i < vm.groupDiscountPayments.length; i++) {
                var item = vm.groupDiscountPayments[i];
                if (vm.groupDiscountItemFilter.payingGroup && vm.groupDiscountItemFilter.payingGroup.currency.currency === item.currency.currency) {
                    switch (item.paymentType) {
                        case "REGISTRATION":
                            vm.groupPaidRegistration += item.amount;
                            break;
                        case "HOTEL":
                            vm.groupPaidHotel += item.amount;
                            break;
                        case "OPTIONAL_SERVICE":
                            vm.groupPaidOptionalService += item.amount;
                            break;
                    }
                }
            }
        }

        function checkValidCurrencyRate() {
            var currency;
            if (vm.groupDiscountItemFilter && vm.groupDiscountItemFilter.payingGroup) {
                currency = vm.groupDiscountItemFilter.payingGroup.currency.currency;
            }

            if (currency && currency !== 'HUF') {
                Rate.getCurrentRate({currency: currency}, function (result) {
                    vm.hasValidCurrencyRate = true;
                }, function (result) { vm.hasValidCurrencyRate = false; });
            }
            else {
                vm.hasValidCurrencyRate = !currency || currency === 'HUF' || false;
            }
        }

        function downloadReportXls () {
            window.location.href = '/api/group-discount-items/' +
                CongressSelector.getSelectedCongress().meetingCode + '/' +
                groupDiscountItemFilter.payingGroup.id + '/' +
                groupDiscountItemFilter.chargeableItemType + '/' +
                '/download-report';
        }

        function downloadProFormaGroupInvoiceReportXls () {
            window.location.href = '/api/group-discount-items/' +
                CongressSelector.getSelectedCongress().meetingCode + '/' +
                groupDiscountItemFilter.payingGroup.id + '/' +
                groupDiscountItemFilter.chargeableItemType + '/' +
                '/download-pro-forma-group-invoice-report';
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('group-discount', {
            abstract: true,
            url: '/group-discount',
            parent: 'app',
            resolve: {
                groupDiscountItemFilter: ['GroupDiscountItemFilter', function (GroupDiscountItemFilter) {
                    return GroupDiscountItemFilter.getGroupDiscountItemFilter();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('GroupDiscountInvoiceHistoryDialogController', GroupDiscountInvoiceHistoryDialogController);

    GroupDiscountInvoiceHistoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'GroupDiscountInvoiceHistory', 'GroupDiscountInvoice'];

    function GroupDiscountInvoiceHistoryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, GroupDiscountInvoiceHistory, GroupDiscountInvoice) {
        var vm = this;

        vm.groupDiscountInvoiceHistory = entity;
        vm.clear = clear;
        vm.save = save;
        vm.groupdiscountinvoices = GroupDiscountInvoice.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.groupDiscountInvoiceHistory.id !== null) {
                GroupDiscountInvoiceHistory.update(vm.groupDiscountInvoiceHistory, onSaveSuccess, onSaveError);
            } else {
                GroupDiscountInvoiceHistory.save(vm.groupDiscountInvoiceHistory, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:groupDiscountInvoiceHistoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('GroupDiscountInvoiceHistoryDetailController', GroupDiscountInvoiceHistoryDetailController);

    GroupDiscountInvoiceHistoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'GroupDiscountInvoiceHistory', 'GroupDiscountInvoice'];

    function GroupDiscountInvoiceHistoryDetailController($scope, $rootScope, $stateParams, previousState, entity, GroupDiscountInvoiceHistory, GroupDiscountInvoice) {
        var vm = this;

        vm.groupDiscountInvoiceHistory = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('pcsApp:groupDiscountInvoiceHistoryUpdate', function(event, result) {
            vm.groupDiscountInvoiceHistory = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('GroupDiscountInvoiceHistoryDeleteController',GroupDiscountInvoiceHistoryDeleteController);

    GroupDiscountInvoiceHistoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'GroupDiscountInvoiceHistory'];

    function GroupDiscountInvoiceHistoryDeleteController($uibModalInstance, entity, GroupDiscountInvoiceHistory) {
        var vm = this;

        vm.groupDiscountInvoiceHistory = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            GroupDiscountInvoiceHistory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('group-discount-invoice-history', {
            parent: 'entity',
            url: '/group-discount-invoice-history',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pcsApp.groupDiscountInvoiceHistory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/group-discount-invoice-history/group-discount-invoice-histories.html',
                    controller: 'GroupDiscountInvoiceHistoryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('groupDiscountInvoiceHistory');
                    $translatePartialLoader.addPart('chargeableItemType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('group-discount-invoice-history-detail', {
            parent: 'entity',
            url: '/group-discount-invoice-history/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pcsApp.groupDiscountInvoiceHistory.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/group-discount-invoice-history/group-discount-invoice-history-detail.html',
                    controller: 'GroupDiscountInvoiceHistoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('groupDiscountInvoiceHistory');
                    $translatePartialLoader.addPart('chargeableItemType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'GroupDiscountInvoiceHistory', function($stateParams, GroupDiscountInvoiceHistory) {
                    return GroupDiscountInvoiceHistory.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'group-discount-invoice-history',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('group-discount-invoice-history-detail.edit', {
            parent: 'group-discount-invoice-history-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/group-discount-invoice-history/group-discount-invoice-history-dialog.html',
                    controller: 'GroupDiscountInvoiceHistoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GroupDiscountInvoiceHistory', function(GroupDiscountInvoiceHistory) {
                            return GroupDiscountInvoiceHistory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('group-discount-invoice-history.new', {
            parent: 'group-discount-invoice-history',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/group-discount-invoice-history/group-discount-invoice-history-dialog.html',
                    controller: 'GroupDiscountInvoiceHistoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                chargeableItemId: null,
                                chargeableItemType: null,
                                df: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('group-discount-invoice-history', null, { reload: 'group-discount-invoice-history' });
                }, function() {
                    $state.go('group-discount-invoice-history');
                });
            }]
        })
        .state('group-discount-invoice-history.edit', {
            parent: 'group-discount-invoice-history',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/group-discount-invoice-history/group-discount-invoice-history-dialog.html',
                    controller: 'GroupDiscountInvoiceHistoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GroupDiscountInvoiceHistory', function(GroupDiscountInvoiceHistory) {
                            return GroupDiscountInvoiceHistory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('group-discount-invoice-history', null, { reload: 'group-discount-invoice-history' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('group-discount-invoice-history.delete', {
            parent: 'group-discount-invoice-history',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/group-discount-invoice-history/group-discount-invoice-history-delete-dialog.html',
                    controller: 'GroupDiscountInvoiceHistoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['GroupDiscountInvoiceHistory', function(GroupDiscountInvoiceHistory) {
                            return GroupDiscountInvoiceHistory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('group-discount-invoice-history', null, { reload: 'group-discount-invoice-history' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('GroupDiscountInvoiceHistory', GroupDiscountInvoiceHistory);

    GroupDiscountInvoiceHistory.$inject = ['$resource'];

    function GroupDiscountInvoiceHistory ($resource) {
        var resourceUrl =  'api/group-discount-invoice-histories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('GroupDiscountInvoiceHistoryController', GroupDiscountInvoiceHistoryController);

    GroupDiscountInvoiceHistoryController.$inject = ['$scope', '$state', 'GroupDiscountInvoiceHistory'];

    function GroupDiscountInvoiceHistoryController ($scope, $state, GroupDiscountInvoiceHistory) {
        var vm = this;
        
        vm.groupDiscountInvoiceHistories = [];

        loadAll();

        function loadAll() {
            GroupDiscountInvoiceHistory.query(function(result) {
                vm.groupDiscountInvoiceHistories = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('GroupDiscountInvoiceStornoController',GroupDiscountInvoiceStornoController);

    GroupDiscountInvoiceStornoController.$inject = ['$uibModalInstance', 'entity', 'GroupDiscountInvoice'];

    function GroupDiscountInvoiceStornoController($uibModalInstance, entity, GroupDiscountInvoice) {
        var vm = this;

        vm.groupDiscountInvoice = entity;
        vm.clear = clear;
        vm.confirmStorno = confirmStorno;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmStorno () {
            GroupDiscountInvoice.storno({id: vm.groupDiscountInvoice.id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('GroupDiscountInvoiceSetPaymentDateDialogController', GroupDiscountInvoiceSetPaymentDateDialogController);

    GroupDiscountInvoiceSetPaymentDateDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'GroupDiscountInvoice'];

    function GroupDiscountInvoiceSetPaymentDateDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, GroupDiscountInvoice) {
        var vm = this;

        vm.groupDiscountInvoice = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            GroupDiscountInvoice.savePaymentDate(vm.groupDiscountInvoice, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:groupDiscountInvoiceSetPaymentDate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.paymentDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('group-discount-invoice', {
                parent: 'administration',
                url: '/group-discount-invoice',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'pcsApp.groupDiscountInvoice.home.title'
                },
                views: {
                    'content@base': {
                        templateUrl: 'app/entities/group-discount-invoice/group-discount-invoices.html',
                        controller: 'GroupDiscountInvoiceController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('groupDiscountInvoice');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('group-discount-invoice.set-payment-date', {
                parent: 'group-discount-invoice',
                url: '/{id}/set-payment-date',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/group-discount-invoice/group-discount-invoice-set-payment-date-dialog.html',
                        controller: 'GroupDiscountInvoiceSetPaymentDateDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    paymentDate: new Date(),
                                    id: $stateParams.id
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('group-discount-invoice', null, {reload: 'group-discount-invoice'});
                    }, function () {
                        $state.go('group-discount-invoice');
                    });
                }]
            })
            .state('group-discount-invoice.storno', {
                parent: 'group-discount-invoice',
                url: '/{id}/storno',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/group-discount-invoice/group-discount-invoice-storno-dialog.html',
                        controller: 'GroupDiscountInvoiceStornoController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            entity: ['GroupDiscountInvoice', function(GroupDiscountInvoice) {
                                return GroupDiscountInvoice.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('group-discount-invoice', null, { reload: 'group-discount-invoice' });
                    }, function() {
                        $state.go('^');
                    })
                }]
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('GroupDiscountInvoice', GroupDiscountInvoice);

    GroupDiscountInvoice.$inject = ['$resource', 'DateUtils'];

    function GroupDiscountInvoice ($resource, DateUtils) {
        var resourceUrl =  'api/group-discount-invoices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryByCongress': {
                method: 'GET',
                url: 'api/group-discount-invoices/congress/:id',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertLocalDateFromServer(data.startDate);
                        data.endDate = DateUtils.convertLocalDateFromServer(data.endDate);
                        data.dateOfFulfilment = DateUtils.convertLocalDateFromServer(data.dateOfFulfilment);
                        data.paymentDeadline = DateUtils.convertLocalDateFromServer(data.paymentDeadline);
                        data.createdDate = DateUtils.convertLocalDateFromServer(data.createdDate);
                        data.dateOfGrougPayment = DateUtils.convertLocalDateFromServer(data.dateOfGrougPayment);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    copy.dateOfFulfilment = DateUtils.convertLocalDateToServer(copy.dateOfFulfilment);
                    copy.paymentDeadline = DateUtils.convertLocalDateToServer(copy.paymentDeadline);
                    copy.createdDate = DateUtils.convertLocalDateToServer(copy.createdDate);
                    copy.dateOfGrougPayment = DateUtils.convertLocalDateToServer(copy.dateOfGrougPayment);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    copy.dateOfFulfilment = DateUtils.convertLocalDateToServer(copy.dateOfFulfilment);
                    copy.paymentDeadline = DateUtils.convertLocalDateToServer(copy.paymentDeadline);
                    copy.createdDate = DateUtils.convertLocalDateToServer(copy.createdDate);
                    copy.dateOfGrougPayment = DateUtils.convertLocalDateToServer(copy.dateOfGrougPayment);
                    return angular.toJson(copy);
                }
            },
            'saveAndSendEmail': {
                method: 'POST',
                url: 'api/group-discount-invoices/save-and-send-email',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    copy.dateOfFulfilment = DateUtils.convertLocalDateToServer(copy.dateOfFulfilment);
                    copy.paymentDeadline = DateUtils.convertLocalDateToServer(copy.paymentDeadline);
                    copy.createdDate = DateUtils.convertLocalDateToServer(copy.createdDate);
                    copy.dateOfGrougPayment = DateUtils.convertLocalDateToServer(copy.dateOfGrougPayment);
                    return angular.toJson(copy);
                }
            },
            'savePaymentDate': {
                method: 'PUT',
                url: 'api/group-discount-invoices/set-payment-date',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.paymentDate = DateUtils.convertLocalDateToServer(copy.paymentDate);
                    return angular.toJson(copy);
                }
            },
            'storno': {
                method: 'GET',
                url: 'api/group-discount-invoices/:id/storno'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('GroupDiscountInvoiceController', GroupDiscountInvoiceController);

    GroupDiscountInvoiceController.$inject = ['$scope', '$state', 'GroupDiscountInvoice', 'DTOptionsBuilder', 'DTColumnDefBuilder', 'CongressSelector'];

    function GroupDiscountInvoiceController ($scope, $state, GroupDiscountInvoice, DTOptionsBuilder, DTColumnDefBuilder, CongressSelector) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions();
        vm.dtOptions.withOption('order', [0, 'desc']);
        vm.dtOptions.withOption('stateSave', true);
        vm.dtColumnDefs = [
            // negative int calculated from the right of the columns
            DTColumnDefBuilder.newColumnDef(-1).notSortable()
        ];

        vm.downloadPdf = downloadPdf;
        vm.downloadXls = downloadXls;

        vm.groupDiscountInvoices = [];

        loadAll();

        function downloadPdf(invoiceId) {
            window.open('/api/group-discount-invoices/' + invoiceId + '/pdf', '_blank');
        }

        function downloadXls(invoiceId) {
            window.open('/api/group-discount-invoices/' + invoiceId + '/details/xls', '_blank');
        }

        function loadAll() {
            GroupDiscountInvoice.queryByCongress({id: CongressSelector.getSelectedCongress().id}, function(result) {
                vm.groupDiscountInvoices = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .directive('sendGeneralEmailToAllDialog', sendGeneralEmailToAllDialog);

    sendGeneralEmailToAllDialog.$inject = ['$uibModal'];

    function sendGeneralEmailToAllDialog($uibModal) {
        var directive = {
            transclude: true,
            restrict: 'EA',
            template: '<a ng-click="open()" ng-transclude>{{email}}</a>',
            scope: {
                filter: "="
            },
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            scope.open = function() {
                $uibModal.open({
                    templateUrl: 'app/entities/general-registration-report/send-general-email-to-all-dialog.html',
                    controller: 'SendGeneralEmailToAllDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        registrationSettings: function() {
                            return {filter: scope.filter};
                        },
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('sendGeneralEmailToAllDialog');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {

                }, function() {

                });
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('SendGeneralEmailToAllDialogController', SendGeneralEmailToAllDialogController);

    SendGeneralEmailToAllDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'GeneralRegistrationReport', 'registrationSettings'];

    function SendGeneralEmailToAllDialogController ($timeout, $scope, $uibModalInstance, GeneralRegistrationReport, registrationSettings) {
        var vm = this;

        vm.registrationSettings = registrationSettings.filter;
        vm.registrationSettings.topic = null;
        vm.registrationSettings.emailBody = null;

        vm.clear = clear;
        vm.send = send;

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function send () {
            vm.isSaving = true;
            GeneralRegistrationReport.sendGeneralEmailToAll(createGeneralEmailToAllFilter(), onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:sendGeneralEmailToAllSent', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function createGeneralEmailToAllFilter() {
            return {
                regId: vm.registrationSettings.regId,
                lastName: vm.registrationSettings.lastName,
                firstName: vm.registrationSettings.firstName,
                email: vm.registrationSettings.email,
                accPeopleLastName: vm.registrationSettings.accPeopleLastName,
                accPeopleFirstName: vm.registrationSettings.accPeopleFirstName,
                registrationType: vm.registrationSettings.registrationType ? vm.registrationSettings.registrationType.id : null,
                workplace: vm.registrationSettings.workplace ? vm.registrationSettings.workplace.id : null,
                payingGroup: vm.registrationSettings.payingGroup ? vm.registrationSettings.payingGroup.id : null,
                optionalService: vm.registrationSettings.optionalService ? vm.registrationSettings.optionalService.id : null,
                hotelId: vm.registrationSettings.congressHotel ? vm.registrationSettings.congressHotel.hotel.id : null,
                country: vm.registrationSettings.country ? vm.registrationSettings.country.id : null,
                countryNegation: vm.registrationSettings.countryNegation,
                presenter: vm.registrationSettings.presenter,
                etiquette: vm.registrationSettings.etiquette,
                closed: vm.registrationSettings.closed,
                onSpot: vm.registrationSettings.onSpot,
                cancelled: vm.registrationSettings.cancelled,
                congressId: vm.registrationSettings.congressId,
                topic: vm.registrationSettings.topic,
                emailBody: vm.registrationSettings.emailBody
            };
        }

        vm.summerNoteConfig = {
            height: 150,
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'superscript', 'subscript', 'strikethrough', 'clear']],
                ['alignment', ['ul', 'ol']]
            ]
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .directive('sendConfirmationToAllDialog', sendConfirmationToAllDialog);

    sendConfirmationToAllDialog.$inject = ['$uibModal'];

    function sendConfirmationToAllDialog($uibModal) {
        var directive = {
            transclude: true,
            restrict: 'EA',
            template: '<a ng-click="open()" ng-transclude>{{email}}</a>',
            scope: {
                filter: "="
            },
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            scope.open = function() {
                $uibModal.open({
                    templateUrl: 'app/entities/general-registration-report/send-confirmation-to-all-dialog.html',
                    controller: 'SendConfirmationToAllDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        confirmationSettings: function() {
                            return {filter: scope.filter};
                        },
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('sendConfirmationToAllDialog');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {

                }, function() {

                });
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('SendConfirmationToAllDialogController', SendConfirmationToAllDialogController);

    SendConfirmationToAllDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'confirmationSettings', 'Confirmation', 'OptionalText', 'CongressSelector'];

    function SendConfirmationToAllDialogController ($timeout, $scope, $uibModalInstance, confirmationSettings, Confirmation, OptionalText, CongressSelector) {
        var vm = this;

        vm.confirmationSettings = confirmationSettings.filter;
        vm.confirmationSettings.sendAllEmail = '';
        vm.confirmationSettings.language = 'hu';
        vm.confirmationSettings.optionalText = '';

        OptionalText.queryByCongress({id: CongressSelector.getSelectedCongress().id}, function(result) {
            vm.optionalTexts = result;
        });

        vm.clear = clear;
        vm.send = send;
        vm.setOptionalTextMessage = setOptionalTextMessage;
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function send () {
            vm.isSaving = true;
            Confirmation.sendConfirmationToAll(buildReportFilter(vm.confirmationSettings), onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:confirmationToAllSent', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function setOptionalTextMessage(text) {
            vm.confirmationSettings.optionalText = text;
        }

        function buildReportFilter(reportFilter) {
            return {
                regId: reportFilter.regId,
                lastName: reportFilter.lastName,
                firstName: reportFilter.firstName,
                email: reportFilter.email,
                accPeopleLastName: reportFilter.accPeopleLastName,
                accPeopleFirstName: reportFilter.accPeopleFirstName,
                registrationType: reportFilter.registrationType ? reportFilter.registrationType.id : null,
                workplace: reportFilter.workplace ? reportFilter.workplace.id : null,
                payingGroup: reportFilter.payingGroup ? reportFilter.payingGroup.id : null,
                optionalService: reportFilter.optionalService ? reportFilter.optionalService.id : null,
                hotelId: reportFilter.congressHotel ? reportFilter.congressHotel.hotel.id : null,
                country: reportFilter.country ? reportFilter.country.id : null,
                countryNegation: reportFilter.countryNegation,
                presenter: reportFilter.presenter,
                etiquette: reportFilter.etiquette,
                closed: reportFilter.closed,
                onSpot: reportFilter.onSpot,
                cancelled: reportFilter.cancelled,
                congressId: reportFilter.congressId,
                sendAllEmail: reportFilter.sendAllEmail,
                language: reportFilter.language,
                optionalText: reportFilter.optionalText
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .directive('sendAllConfirmationToEmailDialog', sendAllConfirmationToEmailDialog);

    sendAllConfirmationToEmailDialog.$inject = ['$uibModal'];

    function sendAllConfirmationToEmailDialog($uibModal) {
        var directive = {
            transclude: true,
            restrict: 'EA',
            template: '<a ng-click="open()" ng-transclude>{{email}}</a>',
            scope: {
                filter: "="
            },
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            scope.open = function() {
                $uibModal.open({
                    templateUrl: 'app/entities/general-registration-report/send-all-confirmation-to-email-dialog.html',
                    controller: 'SendAllConfirmationToEmailDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        confirmationSettings: function(){
                            return {filter: scope.filter};
                        },
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('sendAllConfirmationToEmailDialog');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {

                }, function() {

                });
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('SendAllConfirmationToEmailDialogController', SendAllConfirmationToEmailDialogController);

    SendAllConfirmationToEmailDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'confirmationSettings', 'Confirmation', 'OptionalText', 'CongressSelector'];

    function SendAllConfirmationToEmailDialogController ($timeout, $scope, $uibModalInstance, confirmationSettings, Confirmation, OptionalText, CongressSelector) {
        var vm = this;

        vm.confirmationSettings = confirmationSettings.filter;
        vm.confirmationSettings.sendAllEmail = '';
        vm.confirmationSettings.language = 'hu';
        vm.confirmationSettings.optionalText = '';
        OptionalText.queryByCongress({id: CongressSelector.getSelectedCongress().id}, function(result) {
            vm.optionalTexts = result;
        });

        vm.clear = clear;
        vm.send = send;
        vm.setOptionalTextMessage = setOptionalTextMessage;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function send () {
            vm.isSaving = true;
            Confirmation.sendAllConfirmationToEmail(buildReportFilter(vm.confirmationSettings), onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:allConfirmationToEmail', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function setOptionalTextMessage(text) {
            vm.confirmationSettings.optionalText = text;
        }

        function buildReportFilter(reportFilter) {
            return {
                regId: reportFilter.regId,
                lastName: reportFilter.lastName,
                firstName: reportFilter.firstName,
                email: reportFilter.email,
                accPeopleLastName: reportFilter.accPeopleLastName,
                accPeopleFirstName: reportFilter.accPeopleFirstName,
                registrationType: reportFilter.registrationType ? reportFilter.registrationType.id : null,
                workplace: reportFilter.workplace ? reportFilter.workplace.id : null,
                payingGroup: reportFilter.payingGroup ? reportFilter.payingGroup.id : null,
                optionalService: reportFilter.optionalService ? reportFilter.optionalService.id : null,
                hotelId: reportFilter.congressHotel ? reportFilter.congressHotel.hotel.id : null,
                country: reportFilter.country ? reportFilter.country.id : null,
                countryNegation: reportFilter.countryNegation,
                presenter: reportFilter.presenter,
                etiquette: reportFilter.etiquette,
                closed: reportFilter.closed,
                onSpot: reportFilter.onSpot,
                cancelled: reportFilter.cancelled,
                congressId: reportFilter.congressId,
                sendAllEmail: reportFilter.sendAllEmail,
                language: reportFilter.language,
                optionalText: reportFilter.optionalText
            };
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('general-registration-report', {
                parent: 'report',
                url: '/general-registration-report',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'pcsApp.generalRegistrationReport.home.title'
                },
                views: {
                    'content@base': {
                        templateUrl: 'app/entities/general-registration-report/general-registration-reports.html',
                        controller: 'GeneralRegistrationReportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    reportFilter: ['CongressSelector', function (CongressSelector) {
                        return {
                            regId: null,
                            lastName: null,
                            firstName: null,
                            invoiceName: null,
                            position: null,
                            otherData: null,
                            accPeopleLastName: null,
                            accPeopleFirstName: null,
                            registrationType: null,
                            workplace: null,
                            payingGroup: null,
                            optionalService: null,
                            congressHotel: null,
                            countryNegation: false,
                            presenter: null,
                            etiquette: null,
                            closed: null,
                            onSpot: null,
                            cancelled: null,
                            congressId: CongressSelector.getSelectedCongress().id
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('generalRegistrationReport');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }


})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('GeneralRegistrationReport', GeneralRegistrationReport);

    GeneralRegistrationReport.$inject = ['$resource'];

    function GeneralRegistrationReport ($resource) {
        var resourceUrl =  'api/general-registration-report';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'sendGeneralEmailToAll': {
                method: 'POST',
                url: 'api/general-registration-report/send-general-email-to-all'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('GeneralRegistrationReportController', GeneralRegistrationReportController);

    GeneralRegistrationReportController.$inject = ['$scope', '$state', 'reportFilter', 'GeneralRegistrationReport', 'DTOptionsBuilder', 'Confirmation',
        'DTColumnDefBuilder', 'CongressSelector', 'RegistrationType', 'Workplace', 'PayingGroup', 'OptionalService', 'Country', 'CongressHotel', 'B64Encoder'];

    function GeneralRegistrationReportController ($scope, $state, reportFilter, GeneralRegistrationReport, DTOptionsBuilder, Confirmation,
        DTColumnDefBuilder, CongressSelector, RegistrationType, Workplace, PayingGroup, OptionalService, Country, CongressHotel, B64Encoder) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions();
        vm.dtOptions.withOption('order', [2, 'asc']);
        vm.dtOptions.withOption('stateSave', true);
        vm.dtOptions.withOption('scrollY', '500px');
        vm.dtOptions.withOption('scrollX', true);
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).notSortable()
        ];

        RegistrationType.queryByCongress({id: CongressSelector.getSelectedCongress().id}, function(result) {
            vm.registrationTypes = result;
        });
        Workplace.queryByCongress({id: CongressSelector.getSelectedCongress().id}, function (result) {
            vm.workplaces = result;
        });
        PayingGroup.queryByCongress({id: CongressSelector.getSelectedCongress().id}, function (result) {
            vm.payingGroups = result;
        });
        OptionalService.queryByCongress({id: CongressSelector.getSelectedCongress().id}, function(result) {
            vm.optionalServices = result;
        });
        CongressHotel.queryByCongress({id: CongressSelector.getSelectedCongress().id}, function(result) {
            vm.congressHotels = result;
        });

        vm.positions = null;
        vm.otherDatas = null;
        vm.countries = Country.query();
        vm.reportFilter = reportFilter;

        vm.search = search;
        vm.clear = clear;
        vm.isFiltered = false;
        vm.downloadReportXls = downloadReportXls;
        vm.downloadReportXlsWithQRCode = downloadReportXlsWithQRCode;
        vm.getAvailableRegType = getAvailableRegType;
        vm.printConfirmation = printConfirmation;
        vm.showRegistrationDetails = showRegistrationDetails;

        vm.reportList = [];
        vm.regTypeColumnList = [];

        search();

        function clear() {
            vm.reportFilter.regId = null;
            vm.reportFilter.lastName = null;
            vm.reportFilter.firstName = null;
            vm.reportFilter.invoiceName = null;
            vm.reportFilter.email = null;
            vm.reportFilter.accPeopleLastName = null;
            vm.reportFilter.accPeopleFirstName = null;
            vm.reportFilter.position = null;
            vm.reportFilter.otherData = null;
            vm.reportFilter.registrationType = null;
            vm.reportFilter.workplace = null;
            vm.reportFilter.country = null;
            vm.reportFilter.payingGroup = null;
            vm.reportFilter.optionalService = null;
            vm.reportFilter.congressHotel = null;
            vm.reportFilter.countryNegation = false;
            vm.reportFilter.presenter = null;
            vm.reportFilter.etiquette = null;
            vm.reportFilter.closed = null;
            vm.reportFilter.onSpot = null;
            vm.reportFilter.cancelled = null;
            search();
        }

        function buildReportFilter(reportFilter) {
            return B64Encoder.encode(JSON.stringify({
                regId: reportFilter.regId,
                lastName: reportFilter.lastName,
                firstName: reportFilter.firstName,
                invoiceName: reportFilter.invoiceName,
                email: reportFilter.email,
                position: reportFilter.position,
                otherData: reportFilter.otherData,
                accPeopleLastName: reportFilter.accPeopleLastName,
                accPeopleFirstName: reportFilter.accPeopleFirstName,
                registrationType: reportFilter.registrationType ? reportFilter.registrationType.id : null,
                workplace: reportFilter.workplace ? reportFilter.workplace.id : null,
                payingGroup: reportFilter.payingGroup ? reportFilter.payingGroup.id : null,
                optionalService: reportFilter.optionalService ? reportFilter.optionalService.id : null,
                hotelId: reportFilter.congressHotel ? reportFilter.congressHotel.hotel.id : null,
                country: reportFilter.country ? reportFilter.country.id : null,
                countryNegation: reportFilter.countryNegation,
                presenter: reportFilter.presenter,
                etiquette: reportFilter.etiquette,
                closed: reportFilter.closed,
                onSpot: reportFilter.onSpot,
                cancelled: reportFilter.cancelled,
                congressId: reportFilter.congressId
            }));
        }

        function search() {
            GeneralRegistrationReport.query({
                    query: buildReportFilter(vm.reportFilter)
                },
                function (result) {
                    vm.reportList = result;
                    createFiltersFromReportList();
                    createRegTypeColumns();
                    checkListIsFiltered();
                }
            );
        }

        function createFiltersFromReportList() {
            if (!vm.positions || !vm.otherDatas) {
                var positionSet = new Set();
                var otherDataSet = new Set();
                for (var i = 0; i < vm.reportList.length; i++) {
                    if (vm.reportList[i].position) {
                        positionSet.add(vm.reportList[i].position);
                    }
                    if (vm.reportList[i].otherData) {
                        otherDataSet.add(vm.reportList[i].otherData);
                    }
                }
                vm.positions = Array.from(positionSet);
                vm.positions.sort();

                vm.otherDatas = Array.from(otherDataSet);
                vm.otherDatas.sort();
            }
        }

        function createRegTypeColumns() {
            var rtSet = new Set();
            for (var i = 0; i < vm.reportList.length; i++) {
                for (var j = 0; j < vm.reportList[i].registrationTypes.length; j++) {
                    var rt = vm.reportList[i].registrationTypes[j];
                    rtSet.add(rt.code);
                }
            }
            vm.regTypeColumnList = Array.from(rtSet);
            vm.regTypeColumnList.sort();
        }

        function getAvailableRegType(grr, regTypeColumn) {
            for (var i = 0; i < grr.registrationTypes.length; i++) {
                if (grr.registrationTypes[i].code == regTypeColumn) {
                    return regTypeColumn;
                }
            }
            return "";
        }

        function printConfirmation(registrationId, countryCode) {
            Confirmation.printConfirmation(createConfirmationForPrinting(registrationId, countryCode, ''));
        }

        function createConfirmationForPrinting(registrationId, countryCode, customConfirmationEmail) {
            var conf = {};
            conf.language = countryCode && countryCode !== 'HU' ? 'en' : 'hu';
            conf.confirmationTitleType = 'CONFIRMATION';
            conf.optionalText = '';
            conf.registrationId = registrationId;
            conf.customConfirmationEmail = customConfirmationEmail;
            conf.ignoredChargeableItemIdList = [];
            conf.ignoredChargedServiceIdList = [];
            return conf;
        }

        function downloadReportXls () {
            window.location.href = '/api/general-registration-report/download-report?query=' + buildReportFilter(vm.reportFilter);
        }

        function downloadReportXlsWithQRCode () {
            window.location.href = '/api/general-registration-report/download-report-with-qrcode?query=' + buildReportFilter(vm.reportFilter);
        }

        function showRegistrationDetails(id) {
            window.open('/#/administration/registrations/' + id, '_blank');
        }

        function checkListIsFiltered() {
            vm.isFiltered = vm.reportFilter.regId ||
            vm.reportFilter.lastName ||
            vm.reportFilter.firstName||
            vm.reportFilter.invoiceName||
            vm.reportFilter.email ||
            vm.reportFilter.position ||
            vm.reportFilter.otherData ||
            vm.reportFilter.accPeopleLastName ||
            vm.reportFilter.accPeopleFirstName ||
            vm.reportFilter.registrationType ||
            vm.reportFilter.workplace ||
            vm.reportFilter.country ||
            vm.reportFilter.payingGroup ||
            vm.reportFilter.optionalService ||
            vm.reportFilter.congressHotel ||
            vm.reportFilter.presenter ||
            vm.reportFilter.etiquette ||
            vm.reportFilter.closed ||
            vm.reportFilter.onSpot ||
            vm.reportFilter.cancelled;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .directive('sendFinancialNoticeToAllDialog', sendFinancialNoticeToAllDialog);

    sendFinancialNoticeToAllDialog.$inject = ['$uibModal'];

    function sendFinancialNoticeToAllDialog($uibModal) {
        var directive = {
            transclude: true,
            restrict: 'EA',
            template: '<a ng-click="open()" ng-transclude>{{email}}</a>',
            scope: {
            },
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            scope.open = function() {
                $uibModal.open({
                    templateUrl: 'app/entities/financial-report/send-financial-notice-to-all-dialog.html',
                    controller: 'SendFinancialNoticeToAllDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('sendFinancialNoticeToAllDialog');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {

                }, function() {

                });
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('SendFinancialNoticeToAllDialogController', SendFinancialNoticeToAllDialogController);

    SendFinancialNoticeToAllDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'Confirmation', 'OptionalText', 'CongressSelector'];

    function SendFinancialNoticeToAllDialogController ($timeout, $scope, $uibModalInstance, Confirmation, OptionalText, CongressSelector) {
        var vm = this;

        vm.confirmationSettings = {
            sendAllEmail: '',
            language: 'hu',
            optionalText: '',
            congressId: CongressSelector.getSelectedCongress().id
        };

        OptionalText.queryByCongress({id: CongressSelector.getSelectedCongress().id}, function(result) {
            vm.optionalTexts = result;
        });

        vm.clear = clear;
        vm.send = send;
        vm.setOptionalTextMessage = setOptionalTextMessage;
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function send () {
            vm.isSaving = true;
            Confirmation.sendFinancialNoticeToAll(vm.confirmationSettings, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:financialNoticeToAllSent', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function setOptionalTextMessage(text) {
            vm.confirmationSettings.optionalText = text;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('financial-report', {
                parent: 'report',
                url: '/financial-report',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'pcsApp.financialReport.home.title'
                },
                views: {
                    'content@base': {
                        templateUrl: 'app/entities/financial-report/financial-reports.html',
                        controller: 'FinancialReportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    reportFilter: ['CongressSelector', function (CongressSelector) {
                        return {
                            participantsToPay: false,
                            congressId: CongressSelector.getSelectedCongress().id
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('financialReport');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }


})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('FinancialReport', FinancialReport);

    FinancialReport.$inject = ['$resource'];

    function FinancialReport ($resource) {
        var resourceUrl =  'api/financial-report';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('FinancialReportController', FinancialReportController);

    FinancialReportController.$inject = ['$scope', '$state', 'reportFilter', 'FinancialReport', 'DTOptionsBuilder', 'DTColumnDefBuilder', 'B64Encoder', 'Confirmation'];

    function FinancialReportController ($scope, $state, reportFilter, FinancialReport, DTOptionsBuilder, DTColumnDefBuilder, B64Encoder, Confirmation) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions();
        vm.dtOptions.withOption('order', [2, 'asc']);
        vm.dtOptions.withOption('stateSave', true);
        vm.dtOptions.withOption('scrollY', '500px');
        vm.dtOptions.withOption('scrollX', true);
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).notSortable()
        ];

        vm.reportFilter = reportFilter;
        vm.downloadReportXls = downloadReportXls;
        vm.printConfirmation = printConfirmation;

        vm.participantsToPay = false;
        vm.financialReports = [];

        vm.loadAll = loadAll;

        vm.loadAll();

        function loadAll() {
            FinancialReport.query({
                    query: B64Encoder.encode(JSON.stringify(buildReportFilter(vm.reportFilter)))
                },
                function (result) {
                    vm.financialReports = result;
                }
            );
        }

        function buildReportFilter(reportFilter) {
            return {
                participantsToPay: reportFilter.participantsToPay,
                congressId: reportFilter.congressId
            };
        }

        function downloadReportXls () {
            window.location.href = '/api/financial-report/download?query=' + B64Encoder.encode(JSON.stringify(buildReportFilter(vm.reportFilter)));
        }

        function printConfirmation(registrationId, countryCode) {
            Confirmation.printConfirmation(createConfirmationForPrinting(registrationId, countryCode, ''));
        }

        function createConfirmationForPrinting(registrationId, countryCode, customConfirmationEmail) {
            var conf = {};
            conf.language = countryCode && countryCode !== 'HU' ? 'en' : 'hu';
            conf.confirmationTitleType = 'CONFIRMATION';
            conf.optionalText = '';
            conf.registrationId = registrationId;
            conf.customConfirmationEmail = customConfirmationEmail;
            conf.ignoredChargeableItemIdList = [];
            conf.ignoredChargedServiceIdList = [];
            return conf;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('CurrencyDialogController', CurrencyDialogController);

    CurrencyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Currency', 'Congress'];

    function CurrencyDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Currency, Congress) {
        var vm = this;

        vm.currency = entity;
        vm.clear = clear;
        vm.save = save;
        vm.congresses = Congress.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.currency.id !== null) {
                Currency.update(vm.currency, onSaveSuccess, onSaveError);
            } else {
                Currency.save(vm.currency, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:currencyUpdate', result);
            $uibModalInstance.close(result);
            //vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('CurrencyDeleteController',CurrencyDeleteController);

    CurrencyDeleteController.$inject = ['$uibModalInstance', 'entity', 'Currency'];

    function CurrencyDeleteController($uibModalInstance, entity, Currency) {
        var vm = this;

        vm.currency = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Currency.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('currency', {
            parent: 'entity',
            url: '/currency',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pcsApp.currency.home.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/currency/currencies.html',
                    controller: 'CurrencyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('currency');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('currency-detail', {
            parent: 'entity',
            url: '/currency/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pcsApp.currency.detail.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/currency/currency-detail.html',
                    controller: 'CurrencyDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('currency');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Currency', function($stateParams, Currency) {
                    return Currency.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'currency',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('currency-detail.edit', {
            parent: 'currency-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/currency/currency-dialog.html',
                    controller: 'CurrencyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Currency', function(Currency) {
                            return Currency.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('currency.new', {
            parent: 'currency',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/currency/currency-dialog.html',
                    controller: 'CurrencyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                currency: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('currency', null, { reload: 'currency' });
                }, function() {
                    $state.go('currency');
                });
            }]
        })
        .state('currency.edit', {
            parent: 'currency',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/currency/currency-dialog.html',
                    controller: 'CurrencyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Currency', function(Currency) {
                            return Currency.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('currency', null, { reload: 'currency' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('currency.delete', {
            parent: 'currency',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/currency/currency-delete-dialog.html',
                    controller: 'CurrencyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Currency', function(Currency) {
                            return Currency.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('currency', null, { reload: 'currency' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('Currency', Currency)
        .factory('CurrencyUtils', CurrencyUtils);

    Currency.$inject = ['$resource'];
    CurrencyUtils.$inject = ['$http'];

    function Currency ($resource) {
        var resourceUrl =  'api/currencies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }

    function CurrencyUtils($http) {
        return {
            isUnique: function (code) {
                return $http.get('api/currencys/unique/' + code);
            }
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('CurrencyController', CurrencyController);

    CurrencyController.$inject = ['$scope', '$state', 'Currency'];

    function CurrencyController ($scope, $state, Currency) {
        var vm = this;
        
        vm.currencies = [];

        loadAll();

        function loadAll() {
            Currency.query(function(result) {
                vm.currencies = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('credit-card-report', {
                parent: 'maintenance',
                url: '/credit-card-report',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'pcsApp.creditCardReport.home.title'
                },
                views: {
                    'content@base': {
                        templateUrl: 'app/entities/credit-card-report/credit-card-reports.html',
                        controller: 'CreditCardReportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    reportFilter: function () {
                        return {
                            transactionId: null,
                            programNumber: null,
                            fromDate: null,
                            toDate: null
                        };
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('creditCardReport');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }


})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('CreditCardReport', CreditCardReport);

    CreditCardReport.$inject = ['$resource'];

    function CreditCardReport ($resource) {
        var resourceUrl =  'api/credit-card-report';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET',isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('CreditCardReportController', CreditCardReportController);

    CreditCardReportController.$inject = ['$scope', '$state', 'reportFilter', 'CreditCardReport', 'DTOptionsBuilder',
        'DTColumnDefBuilder', 'DateUtils', 'B64Encoder'];

    function CreditCardReportController ($scope, $state, reportFilter, CreditCardReport, DTOptionsBuilder,
        DTColumnDefBuilder, DateUtils, B64Encoder) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions();
        vm.dtOptions.withOption('order', [1, 'asc']);
        vm.dtOptions.withOption('stateSave', true);
        vm.dtOptions.withOption('scrollX', true);
        vm.dtColumnDefs = [
            // negative int calculated from the right of the columns
            DTColumnDefBuilder.newColumnDef(-1).notSortable()
        ];

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.fromDate = false;
        vm.datePickerOpenStatus.toDate = false;
        vm.openCalendar = openCalendar;

        vm.reportFilter = reportFilter;

        vm.search = search;
        vm.clear = clear;
        vm.isAnyFilterSet = isAnyFilterSet;
        vm.downloadReportXls = downloadReportXls;

        vm.reportList = [];

        function clear() {
            vm.reportList = [];
            vm.reportFilter.transactionId = null;
            vm.reportFilter.programNumber = null;
            vm.reportFilter.fromDate = null;
            vm.reportFilter.toDate = null;
        }

        function buildReportFilter(reportFilter) {
            return {
                transactionId: reportFilter.transactionId,
                programNumber: reportFilter.programNumber,
                fromDate: DateUtils.convertLocalDateToServer(reportFilter.fromDate),
                toDate: DateUtils.convertLocalDateToServer(reportFilter.toDate)
            };
        }

        function search() {
            CreditCardReport.query({
                    query: B64Encoder.encode(JSON.stringify(buildReportFilter(vm.reportFilter)))
                },
                function (result) {
                    vm.reportList = result;
                }
            );
        }

        function downloadReportXls () {
            window.location.href = '/api/credit-card-report/download-report?query=' + B64Encoder.encode(JSON.stringify(buildReportFilter(vm.reportFilter)));
        }

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function isAnyFilterSet() {
            return vm.reportFilter.transactionId || vm.reportFilter.programNumber || vm.reportFilter.fromDate || vm.reportFilter.toDate;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('CountryDialogController', CountryDialogController);

    CountryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Country'];

    function CountryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Country) {
        var vm = this;

        vm.country = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.country.id !== null) {
                Country.update(vm.country, onSaveSuccess, onSaveError);
            } else {
                Country.save(vm.country, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:countryUpdate', result);
            $uibModalInstance.close(result);
            //vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('CountryDeleteController',CountryDeleteController);

    CountryDeleteController.$inject = ['$uibModalInstance', 'entity', 'Country'];

    function CountryDeleteController($uibModalInstance, entity, Country) {
        var vm = this;

        vm.country = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Country.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('country', {
            parent: 'maintenance',
            url: '/country',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pcsApp.country.home.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/country/countries.html',
                    controller: 'CountryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('country');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('country.new', {
            parent: 'country',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-dialog.html',
                    controller: 'CountryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('country', null, { reload: 'country' });
                }, function() {
                    $state.go('country');
                });
            }]
        })
        .state('country.edit', {
            parent: 'country',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-dialog.html',
                    controller: 'CountryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Country', function(Country) {
                            return Country.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('country', null, { reload: 'country' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('country.delete', {
            parent: 'country',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-delete-dialog.html',
                    controller: 'CountryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Country', function(Country) {
                            return Country.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('country', null, { reload: 'country' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('Country', Country);

    Country.$inject = ['$resource'];

    function Country ($resource) {
        var resourceUrl =  'api/countries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('CountryController', CountryController);

    CountryController.$inject = ['$scope', '$state', 'Country', 'DTOptionsBuilder', 'DTColumnDefBuilder'];

    function CountryController ($scope, $state, Country, DTOptionsBuilder, DTColumnDefBuilder) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withDOM('<"html5buttons"B>ltfgitp')
            .withButtons([
                {extend: 'excel', title: 'countries'},
                {extend: 'pdf', title: 'countries'}
            ]);

        vm.dtOptions.withOption('stateSave', true);
        vm.dtOptions.withOption('order', [1, 'asc']);
        vm.dtColumnDefs = [
            // negative int calculated from the right of the columns
            DTColumnDefBuilder.newColumnDef(-1).notSortable()
        ];

        vm.countries = [];

        loadAll();

        function loadAll() {
            Country.query(function(result) {
                vm.countries = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('CongressHotelSelectionController', CongressHotelSelectionController);

    CongressHotelSelectionController.$inject = ['$scope', '$rootScope', '$stateParams', 'CongressHotel', 'CongressSelector', 'Hotel', 'DTOptionsBuilder', 'DTColumnDefBuilder'];

    function CongressHotelSelectionController ($scope, $rootScope, $stateParams, CongressHotel, CongressSelector, Hotel, DTOptionsBuilder, DTColumnDefBuilder) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions();
        vm.dtOptions.withOption('order', [1, 'asc']);
        vm.dtOptions.withOption('stateSave', true);
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).notSortable()
        ];

        vm.selectedHotels = {};
        vm.hotels = [];
        vm.congressHotels = [];
        vm.loadAllHotel = loadAllHotel;
        vm.loadAllCongressHotel = loadAllCongressHotel;
        vm.toggleHotelSelection = toggleHotelSelection;

        function loadAllCongressHotel() {
            CongressHotel.queryByCongress({ id: CongressSelector.getSelectedCongress().id }, function(result) {
                vm.congressHotels = result;
                initSelectedHotels();
            });
        }

        function loadAllHotel() {
            Hotel.query(function(result) {
                vm.hotels = result;
                initSelectedHotels();
            });
        }

        vm.loadAllCongressHotel();
        vm.loadAllHotel();

        function toggleHotelSelection(hotelId) {
            if (isHotelIdSelected(hotelId)) {
                CongressHotel.delete(getCongressHotel(CongressSelector.getSelectedCongress().id, hotelId),
                    function (result) {
                        removeCongressHotel(hotelId);
                        vm.selectedHotels[hotelId.toString()] = false;
                    },
                    function (result) {
                        vm.selectedHotels[hotelId.toString()] = true;
                    });
            } else {
                CongressHotel.save({id: null, congress: { id: CongressSelector.getSelectedCongress().id }, hotel: { id: hotelId }},
                    function (result) {
                        vm.congressHotels.push(result);
                        vm.selectedHotels[hotelId.toString()] = true;
                    },
                    function (result) {
                        vm.selectedHotels[hotelId.toString()] = false;
                    });
            }
        }

        function getCongressHotel(congressId, hotelId) {
            for (var i = 0; i < vm.congressHotels.length; i++) {
                if (vm.congressHotels[i].congress.id === congressId && vm.congressHotels[i].hotel.id === hotelId) {
                    return vm.congressHotels[i];
                }
            }
            return null;
        }

        function removeCongressHotel(hotelId) {
            for (var i = 0; i < vm.congressHotels.length; i++) {
                if (vm.congressHotels[i].hotel.id === hotelId) {
                    vm.congressHotels.splice(i, 1);
                    break;
                }
            }
        }

        function isHotelIdSelected(hotelId) {
            for (var i = 0; i < vm.congressHotels.length; i++) {
                if (vm.congressHotels[i].hotel.id === hotelId) {
                    return true;
                }
            }
            return false;
        }

        function initSelectedHotels() {
            var i, hotelId;
            for (i = 0; i < vm.hotels.length; i++) {
                hotelId = vm.hotels[i].id;
                vm.selectedHotels[hotelId.toString()] = false;
            }

            for (i = 0; i < vm.congressHotels.length; i++) {
                hotelId = vm.congressHotels[i].hotel.id;
                vm.selectedHotels[hotelId.toString()] = true;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('CongressHotelDialogController', CongressHotelDialogController);

    CongressHotelDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CongressHotel', 'Congress', 'Hotel'];

    function CongressHotelDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CongressHotel, Congress, Hotel) {
        var vm = this;

        vm.congressHotel = entity;
        vm.clear = clear;
        vm.save = save;
        vm.congresses = Congress.query();
        vm.hotels = Hotel.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.congressHotel.id !== null) {
                CongressHotel.update(vm.congressHotel, onSaveSuccess, onSaveError);
            } else {
                CongressHotel.save(vm.congressHotel, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:congressHotelUpdate', result);
            $uibModalInstance.close(result);
            //vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('CongressHotelDeleteController',CongressHotelDeleteController);

    CongressHotelDeleteController.$inject = ['$uibModalInstance', 'entity', 'CongressHotel'];

    function CongressHotelDeleteController($uibModalInstance, entity, CongressHotel) {
        var vm = this;

        vm.congressHotel = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CongressHotel.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('congress-hotel', {
            parent: 'administration',
            url: '/congress-hotel',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pcsApp.congressHotel.home.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/congress-hotel/congress-hotels.html',
                    controller: 'CongressHotelController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('congressHotel');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('congress-hotel.select-hotel', {
            parent: 'congress-hotel',
            url: '/select-hotels',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pcsApp.congressHotel.selectHotel.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/congress-hotel/select-hotels.html',
                    controller: 'CongressHotelSelectionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('hotel');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('CongressHotel', CongressHotel);

    CongressHotel.$inject = ['$resource'];

    function CongressHotel ($resource) {
        var resourceUrl =  'api/congress-hotels/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryByCongress': {
                method: 'GET',
                url: 'api/congress-hotels/congress/:id',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('CongressHotelController', CongressHotelController);

    CongressHotelController.$inject = ['$scope', '$state', 'CongressHotel', 'CongressSelector', 'DTOptionsBuilder', 'DTColumnDefBuilder'];

    function CongressHotelController ($scope, $state, CongressHotel, CongressSelector, DTOptionsBuilder, DTColumnDefBuilder) {
        var vm = this;
        $scope.dtOptions = DTOptionsBuilder.newOptions();
        $scope.dtOptions.withOption('order', [1, 'asc']);
        $scope.dtOptions.withOption('stateSave', true);
        $scope.dtColumnDefs = [
            // negative int calculated from the right of the columns
            DTColumnDefBuilder.newColumnDef(-1).notSortable()
        ];

        vm.congressHotels = [];

        loadAll();

        function loadAll() {
            CongressHotel.queryByCongress({id: CongressSelector.getSelectedCongress().id}, function(result) {
                vm.congressHotels = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('OnlineRegConfigDialogController', OnlineRegConfigDialogController);

    OnlineRegConfigDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Congress', 'Country'];

    function OnlineRegConfigDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Congress, Country) {
        var vm = this;

        vm.countries = Country.query();
        vm.onlineRegConfig = entity;
        vm.clear = clear;
        vm.save = save;
        vm.setNormalFile = setNormalFile;
        vm.clearNormalFile = clearNormalFile;
        vm.appendSelectableValue = appendSelectableValue;
        vm.deleteFromSelectableValues = deleteFromSelectableValues;
        vm.noPaymentRequiredChanged = noPaymentRequiredChanged;
        vm.paymentSupplierChanged = paymentSupplierChanged;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            Congress.updateOnlineRegConfig(vm.onlineRegConfig, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:congressUpdate', result);
            $uibModalInstance.close(result);
            //vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.summerNoteConfig = {
            height: 150,
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'superscript', 'subscript', 'strikethrough', 'clear']],
                ['alignment', ['ul', 'ol']]
            ]
        };

        function appendSelectableValue(values, idx) {
            var newValues = [];
            for (var i = 0; i < values.length; i++) {
                newValues.push(values[i]);
            }
            newValues.splice(idx, 0, "");

            values.splice(0, values.length);
            for (i = 0; i < newValues.length; i++) {
                values.push(newValues[i]);
            }
        }

        function deleteFromSelectableValues(values, idx) {
            values.splice(idx, 1);
        }

        function setNormalFile($file, onlineRegConfig) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        onlineRegConfig.headerNormalName = $file.name;
                        onlineRegConfig.headerNormalContentType = $file.type ? $file.type : 'application/octet-stream';
                        onlineRegConfig.headerNormalFile  = base64Data;
                    });
                });
            }
        }

        function clearNormalFile() {
            vm.onlineRegConfig.headerNormalName = null;
            vm.onlineRegConfig.headerNormalContentType = null;
            vm.onlineRegConfig.headerNormalFile = null;
        }

        function noPaymentRequiredChanged() {
            if (vm.onlineRegConfig.noPaymentRequired) {
                vm.onlineRegConfig.paymentSupplier = null;
                vm.onlineRegConfig.stripeSecretKey = null;
                vm.onlineRegConfig.stripePublicKey = null;
            }
        }

        function paymentSupplierChanged() {
            if (vm.onlineRegConfig.paymentSupplier === 'STRIPE') {
                vm.onlineRegConfig.bankTransferVisible = false;
                vm.onlineRegConfig.checkVisible = false;
                vm.onlineRegConfig.creditCardVisible = false;
                vm.onlineRegConfig.bankTransferInfoHu = null;
                vm.onlineRegConfig.bankTransferInfoEn = null;
                vm.onlineRegConfig.bankTransferInfoEs = null;
                vm.onlineRegConfig.bankTransferInfoPt = null;
                vm.onlineRegConfig.billingRemarkHu = null;
                vm.onlineRegConfig.billingRemarkEn = null;
                vm.onlineRegConfig.billingRemarkEs = null;
                vm.onlineRegConfig.billingRemarkPt = null;
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .directive('editableTextValueCell', editableTextValueCell);

    editableTextValueCell.$inject = [];

    function editableTextValueCell() {
        var directive = {
            restrict: 'A',
            templateUrl: 'app/entities/congress/editable-text-value-template.html',
            scope: {
                editableTextList: "=",
                editableTextIdx: "@"
            },
            link: linkFunc,
            controller: controllerFunc
        };

        linkFunc.$inject = ['$scope'];

        function linkFunc($scope, $element) {
            $element.on('click', function ($event) {
                if ($scope.editMode()) return;
                $scope.enableEdit();
            });
        }

        controllerFunc.$inject = ['$scope', '$timeout'];

        function controllerFunc($scope, $timeout) {
            var toggling = false;

            $scope.meta = {
                mode: 'view'
            };

            $scope.enableEdit = function () {
                if (toggling) return;
                $scope.meta.mode = 'edit';
                $scope.editableTextValue = $scope.editableTextList[$scope.editableTextIdx];
                $timeout(function () {
                    // angular.element('.input-group:eq(0)>input').focus();
                    $scope.$apply()
                });
            };

            $scope.editMode = function () {
                return $scope.meta.mode === 'edit';
            };

            $scope.save = function () {
                toggling = true;
                $timeout(function () {
                    $scope.editableTextList[$scope.editableTextIdx] = $scope.editableTextValue;
                    $scope.meta.mode = 'view';
                    toggling = false;
                }, 250);
            };

            $scope.cancel = function () {
                toggling = true;
                $timeout(function () {
                    $scope.meta.mode = 'view';
                    $scope.editableTextValue = $scope.editableTextList[$scope.editableTextIdx];
                    toggling = false;
                }, 250);
            };
        }

        return directive;
    }

})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('CongressDialogController', CongressDialogController);

    CongressDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Congress', 'Country', 'Currency', 'BankAccount', 'User'];

    function CongressDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Congress, Country, Currency, BankAccount, User) {
        var vm = this;

        vm.congress = entity;
        vm.congressFromCopyWp;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.setCongressEndDate = setCongressEndDate;
        vm.save = save;
        vm.countries = Country.query();
        vm.currencies = Currency.query();
        vm.congresses = Congress.query();
        vm.bankaccounts = BankAccount.query();
        vm.users = User.query();
        vm.bankAccountByCurrency = {};

        initBankAccountsForCurrencies();

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function initBankAccountsForCurrencies () {
            for (var i = 0; i < vm.congress.currencies.length; i++) {
                vm.bankAccountByCurrency[vm.congress.currencies[i].currency] = null;
                for (var j = 0; j < vm.congress.bankAccounts.length; j++) {
                    if (vm.congress.bankAccounts[j].currency.currency === vm.congress.currencies[i].currency) {
                        vm.bankAccountByCurrency[vm.congress.currencies[i].currency] = vm.congress.bankAccounts[j];
                    }
                }
            }
        }

        function preProcessBankAccountsForCurrencies () {
            vm.congress.bankAccounts = [];
            for (var prop in vm.bankAccountByCurrency) {
                if (vm.bankAccountByCurrency.hasOwnProperty(prop) || vm.bankAccountByCurrency[prop]) {
                    vm.congress.bankAccounts.push(vm.bankAccountByCurrency[prop]);
                }
            }
        }

        function save () {
            vm.isSaving = true;
            preProcessBankAccountsForCurrencies();
            if (vm.congress.id !== null) {
                Congress.update(vm.congress, onSaveSuccess, onSaveError);
            } else {
                Congress.save(vm.congress, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:congressUpdate', result);
            if (vm.congressFromCopyWp) {
                Congress.migrateWorkplaces({from: vm.congressFromCopyWp.id, to: result.id},
                    function () {
                        vm.congressFromCopyWp = null;
                    }, function () {
                        vm.congressFromCopyWp = null;
                    });
            }
            $uibModalInstance.close(result);
            //vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function setCongressEndDate() {
            if (!vm.congress.endDate) {
                vm.congress.endDate = vm.congress.startDate;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('CongressDeleteController',CongressDeleteController);

    CongressDeleteController.$inject = ['$uibModalInstance', 'entity', 'Congress'];

    function CongressDeleteController($uibModalInstance, entity, Congress) {
        var vm = this;

        vm.congress = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Congress.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('congress', {
            parent: 'maintenance',
            url: '/congress',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pcsApp.congress.home.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/congress/congresses.html',
                    controller: 'CongressController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('congress');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('congress.new', {
            parent: 'congress',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/congress/congress-dialog.html',
                    controller: 'CongressDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                meetingCode: null,
                                name: null,
                                startDate: null,
                                endDate: null,
                                contactPerson: null,
                                contactEmail: null,
                                website: null,
                                programNumber: null,
                                archive: false,
                                additionalBillingTextHu: null,
                                additionalBillingTextEn: null,
                                currencies: [],
                                onlineRegCurrencies: [],
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('congress', null, { reload: 'congress' });
                }, function() {
                    $state.go('congress');
                });
            }]
        })
        .state('congress.edit', {
            parent: 'congress',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/congress/congress-dialog.html',
                    controller: 'CongressDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Congress', function(Congress) {
                            return Congress.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('congress', null, { reload: 'congress' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('congress.online-reg-config', {
            parent: 'congress',
            url: '/{id}/online-reg-config',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/congress/online-reg-config-dialog.html',
                    controller: 'OnlineRegConfigDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('paymentSupplier');
                            $translatePartialLoader.addPart('onlineRegConfig');
                            return $translate.refresh();
                        }],
                        congress: ['Congress', function(Congress) {
                            return Congress.get({id : $stateParams.id}).$promise;
                        }],
                        entity: ['Congress', function(Congress) {
                            return Congress.getOnlineRegConfig({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('congress', null, { reload: 'congress' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('congress.delete', {
            parent: 'congress',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/congress/congress-delete-dialog.html',
                    controller: 'CongressDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Congress', function(Congress) {
                            return Congress.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('congress', null, { reload: 'congress' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('Congress', Congress);

    Congress.$inject = ['$resource', 'DateUtils'];

    function Congress ($resource, DateUtils) {
        var resourceUrl =  'api/congresses/:id';

        return $resource(resourceUrl, {}, {
                'query': { method: 'GET', isArray: true},
                'queryStripped': { url: 'api/stripped-congresses',
                    method: 'GET',
                    isArray: true,
                    transformResponse: function (data) {
                        data = angular.fromJson(data);
                        for (var i = 0; i < data.length; i++) {
                            data[i].startDate = DateUtils.convertLocalDateFromServer(data[i].startDate);
                            data[i].endDate = DateUtils.convertLocalDateFromServer(data[i].endDate);
                        }
                        return data;
                    }
                },
                'get': {
                    method: 'GET',
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            data.startDate = DateUtils.convertLocalDateFromServer(data.startDate);
                            data.endDate = DateUtils.convertLocalDateFromServer(data.endDate);
                        }
                        return data;
                    }
                },
            'getOnlineRegConfig': {
                method: 'GET',
                url: 'api/congresses/:id/online-reg-config'
            },
            'getOnlineRegCurrenciesByCongressId': {
                method: 'GET',
                url: 'api/congresses/:id/online-reg-currencies'
                ,isArray: true
            },
            'getOnlineRegCustomQuestions': {
                method: 'GET',
                url: 'api/congresses/:id/online/custom-questions',
                isArray: true
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    return angular.toJson(copy);
                }
            },
            'updateOnlineRegConfig': {
                method: 'PUT',
                url: 'api/congresses/online-reg-config',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    return angular.toJson(copy);
                }
            },
            'migrateWorkplaces': {
                method: 'POST',
                url: 'api/congresses/migrate-workplaces'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('CongressController', CongressController);

    CongressController.$inject = ['Congress', 'DTOptionsBuilder', 'DTColumnDefBuilder'];

    function CongressController (Congress, DTOptionsBuilder, DTColumnDefBuilder) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions();
        vm.dtOptions.withOption('order', [0, 'desc']);
        vm.dtOptions.withOption('stateSave', true);
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(-1).notSortable(),
            DTColumnDefBuilder.newColumnDef(-2).notSortable()
        ];

        vm.congresses = [];
        vm.openOnlineReg = openOnlineReg;
        vm.getValue = getValue;

        loadAll();

        function loadAll() {
            Congress.query(function(result) {
                vm.congresses = result;
            });
        }

        function openOnlineReg(uuid, currency, language) {
            window.open('/#/registration/online/form/' + uuid + '/' + currency.toLowerCase() + '/' + language, '_blank');
        }

        function getValue(inputId) {
            return document.getElementById(inputId).value;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

        stateConfig.$inject = ['$stateProvider'];

        function stateConfig($stateProvider) {
            $stateProvider
                .state('confirmation', {
                    parent: 'registration',
                    url: '/confirmation',
                    data: {
                        authorities: ['ROLE_USER'],
                        pageTitle: 'pcsApp.registration.confirmation.title'
                    },
                    views: {
                        'content@base': {
                            templateUrl: 'app/entities/confirmation/confirmation.html',
                            controller: 'ConfirmationController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('optionalText');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                    }
                })
                .state('confirmation.optional-text-new', {
                    parent: 'confirmation',
                    url: '/optional-text/new',
                    data: {
                        authorities: ['ROLE_USER']
                    },
                    onEnter: ['$stateParams', '$state', '$uibModal', 'registration', 'CongressSelector', function ($stateParams, $state, $uibModal, registration, CongressSelector) {
                        $uibModal.open({
                            templateUrl: 'app/entities/optional-text/optional-text-dialog.html',
                            controller: 'OptionalTextDialogController',
                            controllerAs: 'vm',
                            size: 'lg',
                            backdrop: 'static',
                            resolve: {
                                entity: function () {
                                    return {
                                        name: null,
                                        optionalText: null,
                                        id: null,
                                        congress: CongressSelector.getSelectedCongress()
                                    };
                                }
                            }
                        }).result.then(function (result) {
                                $state.go('confirmation', {registrationId: registration.id}, {reload: true});
                            }, function () {
                                $state.go('confirmation', {registrationId: registration.id});
                            })
                    }]
                });
        }
})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('Confirmation', Confirmation);

    Confirmation.$inject = ['$http', '$timeout'];

    function Confirmation($http, $timeout) {
        return {
            'printConfirmation': function (confirmation) {
                $http.post('api/registrations/confirmation/pdf', confirmation, {responseType: 'arraybuffer'})
                    .success(function(data, status, headers) {
                        var filename = headers('Content-Disposition');
                        filename = filename.split('; filename=')[1].trim();
                        var blob = new Blob([data], {type: 'application/pdf'});
                        var pdfLink = (window.URL || window.webkitURL).createObjectURL(blob);
                        window.open(pdfLink, '_blank');
                        // downloadFile(blob, filename);
                    });
            },
            'sendAndPrintConfirmation': function (confirmation) {
                $http.post('api/registrations/confirmation/send-pdf', confirmation, {responseType: 'arraybuffer'})
                    .success(function(data, status, headers) {
                        var filename = headers('Content-Disposition');
                        filename = filename.split('; filename=')[1].trim();
                        var blob = new Blob([data], {type: 'application/pdf'});
                        var pdfLink = (window.URL || window.webkitURL).createObjectURL(blob);
                        window.open(pdfLink, '_blank');
                        // downloadFile(blob, filename);
                    });
            },
            'sendConfirmationToAll': function (confirmation, onSuccess, onFailure) {
                $http.post('api/registrations/confirmation/send-to-all', confirmation).then(onSuccess, onFailure);
            },
            'sendFinancialNoticeToAll': function (confirmation, onSuccess, onFailure) {
                $http.post('api/registrations/confirmation/notice-to-all', confirmation).then(onSuccess, onFailure);
            },
            'sendAllConfirmationToEmail': function (confirmation, onSuccess, onFailure) {
                $http.post('api/registrations/confirmation/send-all-to-email', confirmation).then(onSuccess, onFailure);
            }
        };

        function downloadFile(blob, filename) {
            if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                var a = document.createElement('a');
                document.body.appendChild(a);
                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.target = '_blank';
                a.download = filename;
                a.onclick = function () {
                    window.open(this.href, '_blank');
                };
                a.click();
                $timeout(function (){
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('ConfirmationController', ConfirmationController);

    ConfirmationController.$inject = ['$state', 'registration', 'registrationRegistrationTypes', 'roomReservations',
        'orderedOptionalServices', 'chargedServices', 'OptionalText', 'CongressSelector', 'Confirmation'];

    function ConfirmationController ($state, registration, registrationRegistrationTypes, roomReservations,
                                     orderedOptionalServices, chargedServices, OptionalText, CongressSelector, Confirmation) {
        var vm = this;
        vm.isShowConfirmationPanel = false;
        vm.confirmationTitleType = 'CONFIRMATION';
        vm.language = 'hu';
        vm.optionalText = '';
        vm.ignoredChargeableItems = {};
        vm.ignoredChargedServices = {};
        vm.registration = registration;
        vm.registrationRegistrationTypes = registrationRegistrationTypes;
        vm.roomReservations = roomReservations;
        vm.orderedOptionalServices = orderedOptionalServices;
        vm.chargedServices = chargedServices;
        OptionalText.queryByCongress({id: CongressSelector.getSelectedCongress().id}, function(result) {
            vm.optionalTexts = result;
        });

        vm.showConfirmationPanel = showConfirmationPanel;
        vm.printConfirmation = printConfirmation;
        vm.sendAndPrintConfirmation = sendAndPrintConfirmation;

        function showConfirmationPanel() {
            vm.confirmationEmail = vm.registration.email;
            vm.isShowConfirmationPanel = true;
        }

        function printConfirmation() {
            vm.isSaving = true;
            Confirmation.printConfirmation(createConfirmationForPrinting());
            //vm.isSaving = false;
            $state.go('registration', {id: registration.id});
        }

        function sendAndPrintConfirmation() {
            vm.isSaving = true;
            Confirmation.sendAndPrintConfirmation(createConfirmationForPrinting());
            vm.isSaving = false;
            $state.go('registration', {id: registration.id});
        }

        function createConfirmationForPrinting() {
            var conf = {};
            conf.confirmationTitleType = vm.confirmationTitleType;
            conf.language = vm.language;
            conf.optionalText = vm.optionalText;
            conf.registrationId = vm.registration.id;
            conf.customConfirmationEmail = vm.confirmationEmail;
            conf.congressId = CongressSelector.getSelectedCongress().id;

            // alter ignored items from obj properties to list of numbers
            conf.ignoredChargeableItemIdList = [];
            for (var prop in vm.ignoredChargeableItems) {
                if (vm.ignoredChargeableItems.hasOwnProperty(prop) && vm.ignoredChargeableItems[prop]) {
                    conf.ignoredChargeableItemIdList.push(parseInt(prop, 10));
                }
            }

            conf.ignoredChargedServiceIdList = [];
            for (var prop in vm.ignoredChargedServices) {
                if (vm.ignoredChargedServices.hasOwnProperty(prop) && vm.ignoredChargedServices[prop]) {
                    conf.ignoredChargedServiceIdList.push(parseInt(prop, 10));
                }
            }


            return conf;
        }

        function setOptionalTextMessage(text) {
            vm.optionalText = text;
        }

        vm.toggleIgnoreChargeableItem = toggleIgnoreChargeableItem;
        vm.toggleIgnoreChargedService = toggleIgnoreChargedService;
        vm.setOptionalTextMessage = setOptionalTextMessage;
        vm.getPriceAlreadyPaid = getPriceAlreadyPaid;
        vm.getGroupPaid = getGroupPaid;
        vm.getPriceToBePaid = getPriceToBePaid;
        vm.sumPriceToBePaid = sumPriceToBePaid;
        vm.sumGroupAlreadyPaid = sumGroupAlreadyPaid;
        vm.sumPriceAlreadyPaid = sumPriceAlreadyPaid;
        vm.calculateTotalDue = calculateTotalDue;

        function toggleIgnoreChargeableItem(chargeableItemId) {
            //vm.ignoredChargeableItems[chargeableItemId.toString()] = !vm.ignoredChargeableItems[chargeableItemId.toString()];
        }

        function toggleIgnoreChargedService (chargedServiceId) {

        }

        function getPriceAlreadyPaid(chargeableItemId) {
            var i, amount = 0;
            for (i = 0; i < vm.chargedServices.length; i++) {
                if (vm.chargedServices[i].chargeableItemId === chargeableItemId) {
                    amount += vm.chargedServices[i].amount;
                }
            }
            return amount;
        }

        function getGroupPaid(chargeableItem) {
            return chargeableItem.chargeableItemPrice - chargeableItem.priceWithDiscount;
        }

        function getPriceToBePaid(price, chargeableItemId) {
            return price - vm.getPriceAlreadyPaid(chargeableItemId)
        }

        function sumPriceAlreadyPaid(list) {
            var i, sumAmount = 0;
            for (i = 0; i < list.length; i++) {
                sumAmount  += vm.getPriceAlreadyPaid(list[i].id);
            }
            return sumAmount;
        }

        function sumGroupAlreadyPaid(list) {
            var i, sumAmount = 0;
            for (i = 0; i < list.length; i++) {
                sumAmount  += vm.getGroupPaid(list[i]);
            }
            return sumAmount;
        }

        function sumPriceToBePaid(list) {
            var i, sumAmount = 0;
            for (i = 0; i < list.length; i++) {
                sumAmount  += vm.getPriceToBePaid(list[i].priceWithDiscount, list[i].id);
            }
            return sumAmount;
        }

        function calculateTotalDue() {
            var i, total = 0;
            for (i = 0; i < vm.registrationRegistrationTypes.length; i++) {
                if (!vm.invoice.ignoredChargeableItems[vm.registrationRegistrationTypes[i].id]) {
                    total += vm.registrationRegistrationTypes[i].priceWithDiscount;
                }
            }

            for (i = 0; i < vm.roomReservations.length; i++) {
                if (!vm.invoice.ignoredChargeableItems[vm.roomReservations[i].id]) {
                    total += vm.roomReservations[i].priceWithDiscount;
                }
            }

            for (i = 0; i < vm.orderedOptionalServices.length; i++) {
                if (!vm.invoice.ignoredChargeableItems[vm.orderedOptionalServices[i].id]) {
                    total += vm.orderedOptionalServices[i].priceWithDiscount;
                }
            }

            for (i = 0; i < vm.chargedServices.length; i++) {
                if (!vm.invoice.ignoredChargedServices[vm.chargedServices[i].id]) {
                    total -= vm.chargedServices[i].amount;
                }
            }

            return total;
        }

        function calculateTotalDue() {
            var i, total = 0;
            for (i = 0; i < vm.registrationRegistrationTypes.length; i++) {
                if (!vm.ignoredChargeableItems[vm.registrationRegistrationTypes[i].id]) {
                    total += vm.registrationRegistrationTypes[i].priceWithDiscount;
                }
            }

            for (i = 0; i < vm.roomReservations.length; i++) {
                if (!vm.ignoredChargeableItems[vm.roomReservations[i].id]) {
                    total += vm.roomReservations[i].priceWithDiscount;
                }
            }

            for (i = 0; i < vm.orderedOptionalServices.length; i++) {
                if (!vm.ignoredChargeableItems[vm.orderedOptionalServices[i].id]) {
                    total += vm.orderedOptionalServices[i].priceWithDiscount;
                }
            }

            for (i = 0; i < vm.chargedServices.length; i++) {
                if (!vm.ignoredChargedServices[vm.chargedServices[i].id]) {
                    total -= vm.chargedServices[i].amount;
                }
            }

            return total;
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('company', {
                parent: 'maintenance',
                url: '/company',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'pcsApp.company.home.title'
                },
                views: {
                    'content@base': {
                        templateUrl: 'app/entities/company/company-dialog.html',
                        controller: 'CompanyController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['Company', function (Company) {
                        return Company.get();
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('Company', Company);

    Company.$inject = ['$resource'];

    function Company ($resource) {
        var resourceUrl =  'api/company';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('CompanyController', CompanyController);

    CompanyController.$inject = ['entity', 'Company'];

    function CompanyController (entity, Company) {
        var vm = this;
        vm.company = entity;
        vm.success = null;
        vm.error = null;

        vm.save = save;

        function save() {
            Company.update(vm.company, function (data) {
                vm.error = null;
                vm.success = 'OK';
            }, function (err) {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('ChargedServiceDialogController', ChargedServiceDialogController);

    ChargedServiceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ChargedService', 'registrationRegistrationTypes', 'roomReservations', 'orderedOptionalServices'];

    function ChargedServiceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ChargedService, registrationRegistrationTypes, roomReservations, orderedOptionalServices) {
        var vm = this;

        vm.chargedService = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        vm.registrationRegistrationTypes = registrationRegistrationTypes;
        vm.roomReservations = roomReservations;
        vm.orderedOptionalServices = orderedOptionalServices;

        vm.setDefaultPrice = setDefaultPrice;
        vm.chargeableItemTypeOnChanged = chargeableItemTypeOnChanged;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.chargedService.paymentType == 'HOTEL') {
                vm.chargedService.chargeableItem = {
                    id: vm.chargedService.chargeableItem.id,
                    '@class': 'hu.pcs.domain.RoomReservationRegistration'
                };
            }


            if (vm.chargedService.id !== null) {
                ChargedService.update(vm.chargedService, onSaveSuccess, onSaveError);
            } else {
                ChargedService.save(vm.chargedService, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:chargedServiceUpdate', result);
            $uibModalInstance.close(result);
            //vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function chargeableItemTypeOnChanged() {
            vm.chargedService.chargeableItem = null;
            vm.chargedService.amount = null;

            switch(vm.chargedService.paymentType) {
                case 'REGISTRATION':
                    if (vm.registrationRegistrationTypes.length == 1) {
                        vm.chargedService.chargeableItem = vm.registrationRegistrationTypes[0];
                        vm.setDefaultPrice();
                    }
                    break;
                case 'HOTEL':
                    if (vm.roomReservations.length == 1) {
                        vm.chargedService.chargeableItem = vm.roomReservations[0];
                        vm.setDefaultPrice();
                    }
                    break;
                case 'OPTIONAL_SERVICE':
                    if (vm.orderedOptionalServices.length == 1) {
                        vm.chargedService.chargeableItem = vm.orderedOptionalServices[0];
                        vm.setDefaultPrice();
                    }
                    break;
            }
        }

        function setDefaultPrice() {
            vm.chargedService.amount = vm.chargedService.chargeableItem && vm.chargedService.chargeableItem.chargeableItemPrice;
        }

        vm.datePickerOpenStatus.dateOfPayment = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('ChargedServiceDeleteController',ChargedServiceDeleteController);

    ChargedServiceDeleteController.$inject = ['$uibModalInstance', 'entity', 'ChargedService'];

    function ChargedServiceDeleteController($uibModalInstance, entity, ChargedService) {
        var vm = this;

        vm.chargedService = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ChargedService.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('charged-service', {
            abstract: true,
            parent: 'registration'
        })
        .state('charged-service.new', {
            parent: 'charged-service',
            url: '/charged-service/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'registration',
                function($stateParams, $state, $uibModal, registration) {
                    $uibModal.open({
                        templateUrl: 'app/entities/charged-service/charged-service-dialog.html',
                        controller: 'ChargedServiceDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    paymentMode: null,
                                    paymentType: null,
                                    dateOfPayment: new Date(),
                                    amount: null,
                                    cardType: null,
                                    cardNumber: null,
                                    cardExpirationDate: null,
                                    transactionId: null,
                                    comment: null,
                                    id: null,
                                    registration: {id: registration.id}
                                };
                            },
                            registrationRegistrationTypes: ['RegistrationRegistrationType', function (RegistrationRegistrationType) {
                                return RegistrationRegistrationType.queryByRegistrationId({id: $stateParams.registrationId});
                            }],
                            roomReservations: ['RoomReservation', function (RoomReservation) {
                                return RoomReservation.queryVMByRegistrationId({id: $stateParams.registrationId});
                            }],
                            orderedOptionalServices: ['OrderedOptionalService', function (OrderedOptionalService) {
                                return OrderedOptionalService.queryByRegistrationId({id: $stateParams.registrationId});
                            }]
                        }
                    }).result.then(function (result) {
                            $state.go('registration', {registrationId: registration.id}, {reload: true});
                        }, function () {
                            $state.go('registration', {registrationId: registration.id});
                        });
            }]
        })
        .state('charged-service.edit', {
            parent: 'charged-service',
            url: '/charged-service/{chargedServiceId}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'registration', 'registrationRegistrationTypes', 'orderedOptionalServices',
                function($stateParams, $state, $uibModal, registration, registrationRegistrationTypes, orderedOptionalServices) {
                $uibModal.open({
                    templateUrl: 'app/entities/charged-service/charged-service-dialog.html',
                    controller: 'ChargedServiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ChargedService', function (ChargedService) {
                            return ChargedService.get({id: $stateParams.chargedServiceId});
                        }],
                        registrationRegistrationTypes: function () {
                            return registrationRegistrationTypes;
                        },
                        roomReservations: ['RoomReservation', function (RoomReservation) {
                            return RoomReservation.queryByRegistrationId({id: $stateParams.registrationId});
                        }],
                        orderedOptionalServices: function () {
                            return orderedOptionalServices;
                        }
                    }
                }).result.then(function (result) {
                        $state.go('registration', {registrationId: registration.id}, {reload: true});
                    }, function () {
                        $state.go('registration', {registrationId: registration.id});
                    });
            }]
        })
        .state('charged-service.delete', {
            parent: 'charged-service',
            url: '/charged-service/{chargedServiceId}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'registration', function($stateParams, $state, $uibModal, registration) {
                $uibModal.open({
                    templateUrl: 'app/entities/charged-service/charged-service-delete-dialog.html',
                    controller: 'ChargedServiceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ChargedService', function(ChargedService) {
                            return ChargedService.get({id : $stateParams.chargedServiceId}).$promise;
                        }]
                    }
                }).result.then(function (result) {
                        $state.go('registration', {registrationId: registration.id}, {reload: true});
                    }, function () {
                        $state.go('registration', {registrationId: registration.id});
                    });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('ChargedService', ChargedService);

    ChargedService.$inject = ['$resource', 'DateUtils'];

    function ChargedService ($resource, DateUtils) {
        var resourceUrl =  'api/charged-services/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryByRegistrationId': {
                url: '/api/registrations/:id/charged-services',
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateOfPayment = DateUtils.convertLocalDateFromServer(data.dateOfPayment);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateOfPayment = DateUtils.convertLocalDateToServer(copy.dateOfPayment);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateOfPayment = DateUtils.convertLocalDateToServer(copy.dateOfPayment);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('BankAccountDialogController', BankAccountDialogController);

    BankAccountDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'BankAccount', 'Currency', 'Congress'];

    function BankAccountDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, BankAccount, Currency, Congress) {
        var vm = this;

        vm.bankAccount = entity;
        vm.clear = clear;
        vm.save = save;
        vm.currencies = Currency.query();
        vm.congresses = Congress.query();

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.bankAccount.id !== null) {
                BankAccount.update(vm.bankAccount, onSaveSuccess, onSaveError);
            } else {
                BankAccount.save(vm.bankAccount, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:bankAccountUpdate', result);
            $uibModalInstance.close(result);
            //vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('BankAccountDeleteController',BankAccountDeleteController);

    BankAccountDeleteController.$inject = ['$uibModalInstance', 'entity', 'BankAccount'];

    function BankAccountDeleteController($uibModalInstance, entity, BankAccount) {
        var vm = this;

        vm.bankAccount = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            BankAccount.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('bank-account', {
            parent: 'maintenance',
            url: '/bank-account',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pcsApp.bankAccount.home.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/bank-account/bank-accounts.html',
                    controller: 'BankAccountController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('bankAccount');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('bank-account.new', {
            parent: 'bank-account',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bank-account/bank-account-dialog.html',
                    controller: 'BankAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                bankName: null,
                                bankAddress: null,
                                bankAccount: null,
                                swiftCode: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('bank-account', null, { reload: 'bank-account' });
                }, function() {
                    $state.go('bank-account');
                });
            }]
        })
        .state('bank-account.edit', {
            parent: 'bank-account',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bank-account/bank-account-dialog.html',
                    controller: 'BankAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BankAccount', function(BankAccount) {
                            return BankAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('bank-account', null, { reload: 'bank-account' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('bank-account.delete', {
            parent: 'bank-account',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bank-account/bank-account-delete-dialog.html',
                    controller: 'BankAccountDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BankAccount', function(BankAccount) {
                            return BankAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('bank-account', null, { reload: 'bank-account' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('BankAccount', BankAccount);

    BankAccount.$inject = ['$resource'];

    function BankAccount ($resource) {
        var resourceUrl =  'api/bank-accounts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'queryByCongressId': {
                url: '/api/registrations/:congressId/:currency/bank-accounts',
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('BankAccountController', BankAccountController);

    BankAccountController.$inject = ['$scope', '$state', 'BankAccount', 'DTOptionsBuilder', 'DTColumnDefBuilder'];

    function BankAccountController ($scope, $state, BankAccount, DTOptionsBuilder, DTColumnDefBuilder) {
        var vm = this;
        $scope.dtOptions = DTOptionsBuilder.newOptions();
        $scope.dtOptions.withOption('stateSave', true);
        $scope.dtColumnDefs = [
            // negative int calculated from the right of the columns
            DTColumnDefBuilder.newColumnDef(-1).notSortable()
        ];

        vm.bankAccounts = [];

        loadAll();

        function loadAll() {
            BankAccount.query(function(result) {
                vm.bankAccounts = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('BackendOnlineRegDialogController', BackendOnlineRegDialogController);

    BackendOnlineRegDialogController.$inject = ['$timeout', '$scope', '$state', '$stateParams', 'entity', 'BackendOnlineReg'];

    function BackendOnlineRegDialogController ($timeout, $scope, $state, $stateParams, entity, BackendOnlineReg) {
        var vm = this;

        vm.backendOnlineReg = entity;
        vm.cancel = cancel;

        BackendOnlineReg.queryCustomAnswers({id: entity.id}, function (result) {
            vm.customAnswers = result;
        });

        function cancel () {
            $state.go('^');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('BackendOnlineRegDeleteController',BackendOnlineRegDeleteController);

    BackendOnlineRegDeleteController.$inject = ['$uibModalInstance', 'entity', 'BackendOnlineReg'];

    function BackendOnlineRegDeleteController($uibModalInstance, entity, BackendOnlineReg) {
        var vm = this;

        vm.backendOnlineReg = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            BackendOnlineReg.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('BackendOnlineRegDeleteAllDialogController',BackendOnlineRegDeleteAllDialogController);

    BackendOnlineRegDeleteAllDialogController.$inject = ['$uibModalInstance', 'onlineRegFilter', 'BackendOnlineReg'];

    function BackendOnlineRegDeleteAllDialogController($uibModalInstance, onlineRegFilter, BackendOnlineReg) {
        var vm = this;

        vm.onlineRegFilter = onlineRegFilter;
        vm.clear = clear;
        vm.confirm = confirm;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirm() {
            BackendOnlineReg.deleteAll(createOnlineRegVM(), function () {
                $uibModalInstance.close(true);
            });
        }

        function createOnlineRegVM() {
            var onlineRegVM = {};
            onlineRegVM.onlineRegIdList = [];
            for (var prop in vm.onlineRegFilter.selectedOnlineRegIds) {
                if (vm.onlineRegFilter.selectedOnlineRegIds.hasOwnProperty(prop) && vm.onlineRegFilter.selectedOnlineRegIds[prop]) {
                    onlineRegVM.onlineRegIdList.push(parseInt(prop, 10));
                }
            }
            return onlineRegVM;
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('BackendOnlineRegConfirmationDialogController',BackendOnlineRegConfirmationDialogController);

    BackendOnlineRegConfirmationDialogController.$inject = ['$uibModalInstance', 'entity', 'BackendOnlineReg'];

    function BackendOnlineRegConfirmationDialogController($uibModalInstance, entity, BackendOnlineReg) {
        var vm = this;

        vm.backendOnlineReg = entity;
        vm.clear = clear;
        vm.confirm = confirm;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirm() {
            BackendOnlineReg.accept(vm.backendOnlineReg, function () {
                $uibModalInstance.close(true);
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('BackendOnlineRegConfirmationAllDialogController',BackendOnlineRegConfirmationAllDialogController);

    BackendOnlineRegConfirmationAllDialogController.$inject = ['$uibModalInstance', 'onlineRegFilter', 'BackendOnlineReg'];

    function BackendOnlineRegConfirmationAllDialogController($uibModalInstance, onlineRegFilter, BackendOnlineReg) {
        var vm = this;

        vm.onlineRegFilter = onlineRegFilter;
        vm.clear = clear;
        vm.confirm = confirm;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirm() {
            BackendOnlineReg.acceptAll(createOnlineRegVM(), function () {
                $uibModalInstance.close(true);
            });
        }

        function createOnlineRegVM() {
            var onlineRegVM = {};
            onlineRegVM.onlineRegIdList = [];
            for (var prop in vm.onlineRegFilter.selectedOnlineRegIds) {
                if (vm.onlineRegFilter.selectedOnlineRegIds.hasOwnProperty(prop) && vm.onlineRegFilter.selectedOnlineRegIds[prop]) {
                    onlineRegVM.onlineRegIdList.push(parseInt(prop, 10));
                }
            }
            return onlineRegVM;
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('backend-online-reg', {
            parent: 'administration',
            url: '/backend-online-reg',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pcsApp.backendOnlineReg.home.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/backend-online-reg/backend-online-regs.html',
                    controller: 'BackendOnlineRegController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                onlineRegFilter: function () {
                    return {
                        selectedOnlineRegIds: {}
                    }
                },
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('onlineReg');
                    $translatePartialLoader.addPart('backendOnlineReg');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('backend-online-reg.accept', {
            parent: 'backend-online-reg',
            url: '/{id}/accept',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/backend-online-reg/backend-online-reg-dialog.html',
                    controller: 'BackendOnlineRegDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['BackendOnlineReg', '$stateParams', function(BackendOnlineReg, $stateParams) {
                    return BackendOnlineReg.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('backend-online-reg.accept-confirmation', {
            parent: 'backend-online-reg.accept',
            url: '/{id}/accept/confirmation',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/entities/backend-online-reg/backend-online-reg-confirmation-dialog.html',
                    controller: 'BackendOnlineRegConfirmationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function() {
                            return entity;
                        }
                    }
                }).result.then(function() {
                    $state.go('backend-online-reg', null, { reload: 'backend-online-reg' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('backend-online-reg.accept-confirmation-all', {
            parent: 'backend-online-reg',
            url: '/accept-all/confirmation',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'onlineRegFilter', function($stateParams, $state, $uibModal, onlineRegFilter) {
                $uibModal.open({
                    templateUrl: 'app/entities/backend-online-reg/backend-online-reg-confirmation-all-dialog.html',
                    controller: 'BackendOnlineRegConfirmationAllDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        onlineRegFilter: function() {
                            return onlineRegFilter;
                        }
                    }
                }).result.then(function() {
                    $state.go('backend-online-reg', null, { reload: 'backend-online-reg' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('backend-online-reg.delete-confirmation-all', {
            parent: 'backend-online-reg',
            url: '/delete-all/confirmation',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'onlineRegFilter', function($stateParams, $state, $uibModal, onlineRegFilter) {
                $uibModal.open({
                    templateUrl: 'app/entities/backend-online-reg/backend-online-reg-delete-all-dialog.html',
                    controller: 'BackendOnlineRegDeleteAllDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        onlineRegFilter: function() {
                            return onlineRegFilter;
                        }
                    }
                }).result.then(function() {
                    $state.go('backend-online-reg', null, { reload: 'backend-online-reg' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('backend-online-reg.delete', {
            parent: 'backend-online-reg',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/backend-online-reg/backend-online-reg-delete-dialog.html',
                    controller: 'BackendOnlineRegDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BackendOnlineReg', function(BackendOnlineReg) {
                            return BackendOnlineReg.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('backend-online-reg', null, { reload: 'backend-online-reg' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('BackendOnlineReg', BackendOnlineReg);

    BackendOnlineReg.$inject = ['$resource', 'DateUtils'];

    function BackendOnlineReg ($resource, DateUtils) {
        var resourceUrl =  'api/backend-online-regs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryByCongress': {
                method: 'GET',
                url: 'api/backend-online-regs/congress/:id',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertLocalDateFromServer(data.startDate);
                        data.endDate = DateUtils.convertLocalDateFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'queryCustomAnswers': {
                method: 'GET',
                url: resourceUrl + '/custom-answers',
                isArray: true
            },
            'accept': {
                method: 'POST'
            },
            'acceptAll': {
                method: 'POST',
                url: 'api/backend-online-regs/confirmation/all'
            },
            'deleteAll': {
                method: 'POST',
                url: 'api/backend-online-regs/delete/all'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('BackendOnlineRegController', BackendOnlineRegController);

    BackendOnlineRegController.$inject = ['$scope', '$state', '$http', 'BackendOnlineReg', 'CongressSelector', 'onlineRegFilter', 'DTOptionsBuilder', 'DTColumnDefBuilder'];

    function BackendOnlineRegController ($scope, $state, $http, BackendOnlineReg, CongressSelector, onlineRegFilter, DTOptionsBuilder, DTColumnDefBuilder) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions();
        vm.dtOptions.withOption('order', [9, 'desc']);
        vm.dtOptions.withOption('stateSave', true);
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).notSortable(),
            DTColumnDefBuilder.newColumnDef(-1).notSortable()
        ];

        vm.onlineRegFilter = onlineRegFilter;
        vm.allOnlineRegIdSelected = false;
        vm.toggleOnlineRegSelection = toggleOnlineRegSelection;
        vm.toggleAllOnlineRegSelection = toggleAllOnlineRegSelection;
        vm.isAnyOnlineRegIdSelected = isAnyOnlineRegIdSelected;

        vm.backendOnlineRegs = [];
        vm.downloadAllSelected = downloadAllSelected;
        vm.downloadPdf = downloadPdf;

        loadAll();

        function loadAll() {
            BackendOnlineReg.queryByCongress({id: CongressSelector.getSelectedCongress().id}, function(result) {
                vm.backendOnlineRegs = result;
            });
        }

        function downloadPdf(id) {
            $http.get('/api/registration/online/' + id + '/pdf', {responseType: 'arraybuffer'})
                .success(function (response) {
                    var blob = new Blob([response], {type: 'application/pdf'});
                    var pdfLink = (window.URL || window.webkitURL).createObjectURL(blob);
                    window.open(pdfLink, '_blank');
                });
        }

        function downloadAllSelected() {
            $http.post('api/backend-online-regs/pdf/all', createOnlineRegVM(), {responseType: 'arraybuffer'})
                .success(function(data, status, headers) {
                    var filename = headers('Content-Disposition');
                    filename = filename.split('; filename=')[1].trim();
                    var blob = new Blob([data], {type: 'application/pdf'});
                    var pdfLink = (window.URL || window.webkitURL).createObjectURL(blob);
                    window.open(pdfLink, '_blank');
                });
        }

        function toggleOnlineRegSelection(onlineRegId) {
            // vm.onlineRegFilter.selectedOnlineRegIds[onlineRegId.toString()] = !isOnlineRegIdSelected(onlineRegId);
        }

        function toggleAllOnlineRegSelection() {
            if (!vm.allOnlineRegIdSelected) {
                vm.onlineRegFilter.selectedOnlineRegIds = {};
            }
            else {
                vm.onlineRegFilter.selectedOnlineRegIds = {};
                for (var i = 0; i < vm.backendOnlineRegs.length; i++) {
                    vm.onlineRegFilter.selectedOnlineRegIds[vm.backendOnlineRegs[i].id.toString()] = true;
                }
            }
        }

        function isOnlineRegIdSelected(onlineRegId) {
            for (var prop in vm.onlineRegFilter.selectedOnlineRegIds) {
                if (vm.onlineRegFilter.selectedOnlineRegIds.hasOwnProperty(prop) && prop === onlineRegId) {
                    return true;
                }
            }
            return false;
        }

        function isAnyOnlineRegIdSelected() {
            for (var prop in vm.onlineRegFilter.selectedOnlineRegIds) {
                if (vm.onlineRegFilter.selectedOnlineRegIds.hasOwnProperty(prop) && vm.onlineRegFilter.selectedOnlineRegIds[prop]) {
                    return true;
                }
            }
            return false;
        }

        function createOnlineRegVM() {
            var onlineRegVM = {};
            onlineRegVM.onlineRegIdList = [];
            for (var prop in vm.onlineRegFilter.selectedOnlineRegIds) {
                if (vm.onlineRegFilter.selectedOnlineRegIds.hasOwnProperty(prop) && vm.onlineRegFilter.selectedOnlineRegIds[prop]) {
                    onlineRegVM.onlineRegIdList.push(parseInt(prop, 10));
                }
            }
            return onlineRegVM;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('administration', {
            abstract: true,
            url: '/administration',
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('AccPeopleDialogController', AccPeopleDialogController);

    AccPeopleDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AccPeople'];

    function AccPeopleDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AccPeople) {
        var vm = this;

        vm.accPeople = entity;
        vm.clear = clear;
        vm.save = save;
        // vm.registrationregistrationtypes = RegistrationRegistrationType.query();

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.accPeople.id !== null) {
                AccPeople.update(vm.accPeople, onSaveSuccess, onSaveError);
            } else {
                AccPeople.save(vm.accPeople, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('pcsApp:accPeopleUpdate', result);
            $uibModalInstance.close(result);
            //vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('AccPeopleDeleteController',AccPeopleDeleteController);

    AccPeopleDeleteController.$inject = ['$uibModalInstance', 'entity', 'AccPeople'];

    function AccPeopleDeleteController($uibModalInstance, entity, AccPeople) {
        var vm = this;

        vm.accPeople = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AccPeople.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('acc-people', {
            parent: 'registration',
            url: '/registration-types/{regTypeId}/acc-peoples',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pcsApp.accPeople.home.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/entities/acc-people/acc-people.html',
                    controller: 'AccPeopleController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                registrationRegistrationType: ['$stateParams', 'RegistrationRegistrationType', function ($stateParams, RegistrationRegistrationType) {
                    return RegistrationRegistrationType.get({id: $stateParams.regTypeId});
                }],
                accPeoples: ['$stateParams', 'AccPeople', function ($stateParams, AccPeople) {
                    return AccPeople.queryByRegistrationRegistrationType({id: $stateParams.regTypeId});
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('accPeople');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('acc-people.new', {
            parent: 'acc-people',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
                onEnter: ['$stateParams', '$state', '$uibModal', 'registrationRegistrationType', function($stateParams, $state, $uibModal, registrationRegistrationType) {
                $uibModal.open({
                    templateUrl: 'app/entities/acc-people/acc-people-dialog.html',
                    controller: 'AccPeopleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                lastName: null,
                                firstName: null,
                                id: null,
                                registrationRegistrationType: registrationRegistrationType
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('acc-people', null, { reload: 'acc-people' });
                }, function() {
                    $state.go('acc-people');
                });
            }]
        })
        .state('acc-people.edit', {
            parent: 'acc-people',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/acc-people/acc-people-dialog.html',
                    controller: 'AccPeopleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AccPeople', function(AccPeople) {
                            return AccPeople.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('acc-people', null, { reload: 'acc-people' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('acc-people.delete', {
            parent: 'acc-people',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/acc-people/acc-people-delete-dialog.html',
                    controller: 'AccPeopleDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AccPeople', function(AccPeople) {
                            return AccPeople.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('acc-people', null, { reload: 'acc-people' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('AccPeople', AccPeople);

    AccPeople.$inject = ['$resource'];

    function AccPeople ($resource) {
        var resourceUrl =  'api/acc-people/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryByRegistrationRegistrationType': {
                method: 'GET',
                url: 'api/registration-registration-type/:id/acc-peoples',
                isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('AccPeopleController', AccPeopleController);

    AccPeopleController.$inject = ['$scope', '$state', 'registrationRegistrationType', 'accPeoples', 'DTOptionsBuilder', 'DTColumnDefBuilder'];

    function AccPeopleController ($scope, $state, registrationRegistrationType, accPeoples, DTOptionsBuilder, DTColumnDefBuilder) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions();
        vm.dtColumnDefs = [
            // negative int calculated from the right of the columns
            DTColumnDefBuilder.newColumnDef(-1).notSortable()
        ];

        vm.registrationRegistrationType = registrationRegistrationType;
        vm.accPeoples = accPeoples;
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .filter('characters', characters);
        
    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

angular.module('pcsApp')
.filter('sumByKey', function () {
    return function(data, key) {
        var i, sum = 0;
        if (typeof data === 'undefined' || typeof key === 'undefined') {
            return sum;
        }

        for (i = 0; i < data.length; i++) {
            sum += (data[i][key]);
        }
        return sum;
    };
});

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .directive('sendInvoiceEmailDialog', sendInvoiceEmailDialog);

    sendInvoiceEmailDialog.$inject = ['$uibModal'];

    function sendInvoiceEmailDialog($uibModal) {
        var directive = {
            transclude: true,
            restrict: 'EA',
            template: '<a ng-click="open()" ng-transclude></a>',
            replace: true,
            scope: {
                invoice: "@",
                email: "@"
            },
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            scope.open = function() {
                $uibModal.open({
                    templateUrl: 'app/services/invoice/send-invoice-email-dialog.html',
                    controller: 'SendInvoiceEmailDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        invoiceEmail: function(){
                            return {invoice: scope.invoice, email: scope.email};
                        },
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('invoice');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {

                }, function() {

                });
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .directive('sendConfirmationDialog', sendConfirmationDialog);

    sendConfirmationDialog.$inject = ['$uibModal'];

    function sendConfirmationDialog($uibModal) {
        var directive = {
            transclude: true,
            restrict: 'EA',
            template: '<a ng-click="open()" ng-transclude>{{email}}</a>',
            scope: {
                regId: "@",
                email: "@"
            },
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            scope.open = function() {
                $uibModal.open({
                    templateUrl: 'app/services/confirmation/send-confirmation-dialog.html',
                    controller: 'SendConfirmationDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        confirmationSettings: function(){
                            return {regId: scope.regId, email: scope.email};
                        },
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('sendConfirmationDialog');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {

                }, function() {

                });
            };
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('pcsApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('pcsApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('pcsApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .factory('InvoiceUtils', InvoiceUtils);

    InvoiceUtils.$inject = ['$http'];

    function InvoiceUtils ($http) {
        return {
            hasValidRate: function (currency) {
                return $http.get('api/registrations/invoices/rates/' + currency);
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .directive('emailDialog', emailDialog);

    emailDialog.$inject = ['$uibModal'];

    function emailDialog($uibModal) {
        var directive = {
            transclude: true,
            restrict: 'EA',
            template: '<a ng-click="open()" ng-transclude>{{email}}</a>',
            scope: {
                firstName: "@",
                lastName: "@",
                email: "@"
            },
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            scope.open = function() {
                $uibModal.open({
                    templateUrl: 'app/services/email/email-dialog.html',
                    controller: 'EmailDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        registrationEmail: function(){
                            return {lastName: scope.lastName, firstName: scope.firstName, email: scope.email};
                        },
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('emailDialog');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {

                }, function() {

                });
            };
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('pcsApp')
        .factory('Email', Email);

    Email.$inject = ['$resource', 'DateUtils'];

    function Email ($resource, DateUtils) {
        var resourceUrl =  'api/email/:id';

        return $resource(resourceUrl, {}, {
            'send': { method:'POST', url: 'api/email/send' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .directive('dateLessThan', dateLessThan);

    dateLessThan.$inject = ['$filter'];

    function dateLessThan($filter) {
        var directive = {
            restrict: 'A',
            require: 'ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, ngModel) {
            var validate = function (modelValue) {
                var thresholdValue = attrs.dateLessThan;
/*
                console.log('thresholdValue:' + thresholdValue);
                console.log('modelValue:' + modelValue);
*/
                //todo valamiert "" jelek között érkezik meg ezért substr kell hogy meghamozzam, megnézni hogy miért van ez
                if (!modelValue || !thresholdValue) {
                    ngModel.$setValidity('dateLessThan', true);
                }
                else {
                    thresholdValue = "\"" === thresholdValue.substr(0, 1) && "\"" === thresholdValue.substr(thresholdValue.length - 1, thresholdValue.length - 2) ? thresholdValue.substr(1, thresholdValue.length - 2) : thresholdValue;
                    ngModel.$setValidity('dateLessThan',
                        +new Date($filter('date')(modelValue, 'yyyy-MM-dd')) >= +new Date($filter('date')(thresholdValue, 'yyyy-MM-dd')));
                }
                return modelValue;
            };

            //ngModel.$parsers.unshift(validate);
            ngModel.$parsers.push(validate);
            attrs.$observe('dateLessThan', function(thresholdValue){
                // Whenever the comparison model changes we'll re-validate
                return validate(ngModel.$modelValue);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

angular.module('pcsApp')
    .filter('filterChargeableItemsByCurrency', function () {
        return filterChargeableItemsByCurrency;
    });

function filterChargeableItemsByCurrency(list, search) {
    var out = [];
    var re = new RegExp(search.searchText, 'i');
    for (var i = 0; i < list.length; i++) {
        if (search.criteria) {
            if (search.criteria(list[i])) {
                out.push(list[i]);
            }
        }
        else if ((!search.registrationCurrency || search.registrationCurrency === list[i].currency.currency) && (!search.searchText || re.test(list[i].name))) {
            out.push(list[i]);
        }
    }
    return out;
}

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('pcsApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('pcsApp')
        .factory('B64Encoder', B64Encoder);
    
    function B64Encoder() {
        var service = {
            encode: encode
        };

        return service;

        function encode(str) {
            return base64EncArr(strToUTF8Arr(str))
        }

        function uint6ToB64 (nUint6) {

            return nUint6 < 26 ?
                nUint6 + 65
                : nUint6 < 52 ?
                    nUint6 + 71
                    : nUint6 < 62 ?
                        nUint6 - 4
                        : nUint6 === 62 ?
                            43
                            : nUint6 === 63 ?
                                47
                                :
                                65;

        }

        function base64EncArr (aBytes) {

            var eqLen = (3 - (aBytes.length % 3)) % 3, sB64Enc = "";

            for (var nMod3, nLen = aBytes.length, nUint24 = 0, nIdx = 0; nIdx < nLen; nIdx++) {
                nMod3 = nIdx % 3;
                /* Uncomment the following line in order to split the output in lines 76-character long: */
                /*
                if (nIdx > 0 && (nIdx * 4 / 3) % 76 === 0) { sB64Enc += "\r\n"; }
                */
                nUint24 |= aBytes[nIdx] << (16 >>> nMod3 & 24);
                if (nMod3 === 2 || aBytes.length - nIdx === 1) {
                    sB64Enc += String.fromCharCode(uint6ToB64(nUint24 >>> 18 & 63), uint6ToB64(nUint24 >>> 12 & 63), uint6ToB64(nUint24 >>> 6 & 63), uint6ToB64(nUint24 & 63));
                    nUint24 = 0;
                }
            }

            return  eqLen === 0 ?
                sB64Enc
                :
                sB64Enc.substring(0, sB64Enc.length - eqLen) + (eqLen === 1 ? "=" : "==");

        }

        /* UTF-8 array to DOMString and vice versa */

        function UTF8ArrToStr (aBytes) {

            var sView = "";

            for (var nPart, nLen = aBytes.length, nIdx = 0; nIdx < nLen; nIdx++) {
                nPart = aBytes[nIdx];
                sView += String.fromCharCode(
                    nPart > 251 && nPart < 254 && nIdx + 5 < nLen ? /* six bytes */
                        /* (nPart - 252 << 30) may be not so safe in ECMAScript! So...: */
                        (nPart - 252) * 1073741824 + (aBytes[++nIdx] - 128 << 24) + (aBytes[++nIdx] - 128 << 18) + (aBytes[++nIdx] - 128 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
                        : nPart > 247 && nPart < 252 && nIdx + 4 < nLen ? /* five bytes */
                        (nPart - 248 << 24) + (aBytes[++nIdx] - 128 << 18) + (aBytes[++nIdx] - 128 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
                        : nPart > 239 && nPart < 248 && nIdx + 3 < nLen ? /* four bytes */
                            (nPart - 240 << 18) + (aBytes[++nIdx] - 128 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
                            : nPart > 223 && nPart < 240 && nIdx + 2 < nLen ? /* three bytes */
                                (nPart - 224 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
                                : nPart > 191 && nPart < 224 && nIdx + 1 < nLen ? /* two bytes */
                                    (nPart - 192 << 6) + aBytes[++nIdx] - 128
                                    : /* nPart < 127 ? */ /* one byte */
                                    nPart
                );
            }

            return sView;

        }

        function strToUTF8Arr (sDOMStr) {

            var aBytes, nChr, nStrLen = sDOMStr.length, nArrLen = 0;

            /* mapping... */

            for (var nMapIdx = 0; nMapIdx < nStrLen; nMapIdx++) {
                nChr = sDOMStr.charCodeAt(nMapIdx);
                nArrLen += nChr < 0x80 ? 1 : nChr < 0x800 ? 2 : nChr < 0x10000 ? 3 : nChr < 0x200000 ? 4 : nChr < 0x4000000 ? 5 : 6;
            }

            aBytes = new Uint8Array(nArrLen);

            /* transcription... */

            for (var nIdx = 0, nChrIdx = 0; nIdx < nArrLen; nChrIdx++) {
                nChr = sDOMStr.charCodeAt(nChrIdx);
                if (nChr < 128) {
                    /* one byte */
                    aBytes[nIdx++] = nChr;
                } else if (nChr < 0x800) {
                    /* two bytes */
                    aBytes[nIdx++] = 192 + (nChr >>> 6);
                    aBytes[nIdx++] = 128 + (nChr & 63);
                } else if (nChr < 0x10000) {
                    /* three bytes */
                    aBytes[nIdx++] = 224 + (nChr >>> 12);
                    aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
                    aBytes[nIdx++] = 128 + (nChr & 63);
                } else if (nChr < 0x200000) {
                    /* four bytes */
                    aBytes[nIdx++] = 240 + (nChr >>> 18);
                    aBytes[nIdx++] = 128 + (nChr >>> 12 & 63);
                    aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
                    aBytes[nIdx++] = 128 + (nChr & 63);
                } else if (nChr < 0x4000000) {
                    /* five bytes */
                    aBytes[nIdx++] = 248 + (nChr >>> 24);
                    aBytes[nIdx++] = 128 + (nChr >>> 18 & 63);
                    aBytes[nIdx++] = 128 + (nChr >>> 12 & 63);
                    aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
                    aBytes[nIdx++] = 128 + (nChr & 63);
                } else /* if (nChr <= 0x7fffffff) */ {
                    /* six bytes */
                    aBytes[nIdx++] = 252 + (nChr >>> 30);
                    aBytes[nIdx++] = 128 + (nChr >>> 24 & 63);
                    aBytes[nIdx++] = 128 + (nChr >>> 18 & 63);
                    aBytes[nIdx++] = 128 + (nChr >>> 12 & 63);
                    aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
                    aBytes[nIdx++] = 128 + (nChr & 63);
                }
            }

            return aBytes;

        }
    }


})();
(function () {
    'use strict';

    angular
        .module('pcsApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('pcsApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en',
            'hu'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" ng-show="false">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('pcsApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(

                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('pcsApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var errorHeader = httpResponse.headers('X-pcsApp-error');
                var constraintViolationHeader = httpResponse.headers('X-pcsApp-constraint-violation');
                var entityKey = httpResponse.headers('X-pcsApp-params');
                var translate = httpResponse.headers('X-pcsApp-translate');
                if (errorHeader) {
                    var entityName = translate ? $translate.instant('global.menu.entities.' + entityKey) : entityKey;
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (constraintViolationHeader) {
                    var tableName = $translate.instant('global.menu.constraints.' + entityKey);
                    addErrorAlert(constraintViolationHeader, constraintViolationHeader, {entityName: tableName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('pcsApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate', 'notify'];

        function getService ($timeout, $sce,$translate, notify) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: this.toast ? addToastAlert : addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function addToastAlert(alertOptions, extAlerts) {
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                notify({
                    message: $sce.trustAsHtml(alertOptions.msg),
                    classes: 'alert-' + alertOptions.type,
                    duration: alertOptions.timeout,
                    position: alertOptions.position ? alertOptions.position : 'right',
                    templateUrl: 'app/components/alert/inspinia-notify.html'
                });
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('pcsApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .factory('paymentForwardInterceptor', paymentForwardInterceptor);

    paymentForwardInterceptor.$inject = ['$q', '$injector'];

    function paymentForwardInterceptor ($q, $injector) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var redirectHeader = response.headers('X-pcsApp-payment-redirect');
            if (angular.isString(redirectHeader)) {
                // console.log(redirectHeader);
                if (redirectHeader) {
                    document.location.href = redirectHeader;
                    return;
                }
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', '$injector'];

    function notificationInterceptor ($q, $injector) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            if (response) {
                var alertKey = response.headers('X-pcsApp-alert');
                if (angular.isString(alertKey)) {
                    var AlertService = $injector.get('AlertService');
                    AlertService.success(alertKey, {param: response.headers('X-pcsApp-params')});
                }
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('pcsApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    
    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$document'];

    function authExpiredInterceptor($rootScope, $q, $injector, $document) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            // If we have an unauthorized request we redirect to the login page
            // Don't do this check on the account API to avoid infinite loop
            if (response.status === 401 && angular.isDefined(response.data.path) && response.data.path.indexOf('/api/account') === -1) {
                var Auth = $injector.get('Auth');
                var state = $injector.get('$state');
                var to = $rootScope.toState;
                var params = $rootScope.toStateParams;
                Auth.logout();
                if (to.name !== 'accessdenied') {
                    Auth.storePreviousState(to.name, params);
                }

                state.go('login');
            } else if (response.status === 403 && response.config.method !== 'GET' && getCSRF() === '') {
                // If the CSRF token expired, then try to get a new CSRF token and retry the old request
                var $http = $injector.get('$http');
                return $http.get('/').finally(function() { return afterCSRFRenewed(response); });
            }
            return $q.reject(response);
        }

        function getCSRF() {
            var doc = $document[0];
            if (doc) {
                var name = 'CSRF-TOKEN=';
                var ca = doc.cookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) === ' ') {c = c.substring(1);}

                    if (c.indexOf(name) !== -1) {
                        return c.substring(name.length, c.length);
                    }
                }
            }
            return '';
        }

        function afterCSRFRenewed(oldResponse) {
            if (getCSRF() !== '') {
                // retry the old request after the new CSRF-TOKEN is obtained
                var $http = $injector.get('$http');
                return $http(oldResponse.config);
            } else {
                // unlikely get here but reject with the old response any way and avoid infinite loop
                return $q.reject(oldResponse);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precendence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
                
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('pcsApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to prefered language "en"');
                $cookies.putObject(name, 'en');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('en');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        
        //enable CSRF
        $httpProvider.defaults.xsrfCookieName = 'CSRF-TOKEN';
        $httpProvider.defaults.xsrfHeaderName = 'X-CSRF-TOKEN';
        
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        $httpProvider.interceptors.push('paymentForwardInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);
        
        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(true);
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('base', {
            abstract: true,
            views: {
                'base@': {
                    templateUrl: 'app/layouts/content/content.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });

        $stateProvider.state('app', {
            parent: 'base',
            abstract: true,
            views: {
                'navbar@base': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                },
                'header@base': {
                    templateUrl: 'app/layouts/header/header.html',
                    controller: 'HeaderController',
                    controllerAs: 'hd'
                },
                'footer@base': {
                    templateUrl: 'app/layouts/footer/footer.html',
                    controller: 'FooterController',
                    controllerAs: 'ft'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('pcsApp')
        .constant('VERSION', "1.5.55")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService', 'Congress'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService, Congress) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;
        vm.congresses = Congress.queryStripped();



        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            //vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'system',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }        })
        .state('user-management-detail', {
            parent: 'system',
            url: '/user/:login',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.new', {
            parent: 'user-management',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: 'en', createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null, congresses: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            parent: 'user-management',
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management.delete', {
            parent: 'user-management',
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService', 'DTOptionsBuilder', 'DTColumnDefBuilder'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService, DTOptionsBuilder, DTColumnDefBuilder) {
        var vm = this;
        vm.dtOptions = DTOptionsBuilder.newOptions();
        vm.dtOptions.withOption('stateSave', true);
        vm.dtColumnDefs = [
            // negative int calculated from the right of the columns
            DTColumnDefBuilder.newColumnDef(-1).notSortable()
        ];

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            //hide anonymous user from user management: it's a required user for Spring Security
            var hiddenUsersSize = 0;
            for (var i in data) {
                if (data[i]['login'] === 'anonymoususer') {
                    data.splice(i, 1);
                    hiddenUsersSize++;
                }
            }
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count') - hiddenUsersSize;
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('system', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'system',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/jhipster/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            vm.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    vm.cachesStats[newKey] = {
                        'name': newKey,
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'system',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/jhipster/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'system',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('pcsApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'system',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'system',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'system',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/jhipster/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('sessions', {
            parent: 'account',
            url: '/sessions',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.sessions'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/account/sessions/sessions.html',
                    controller: 'SessionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sessions');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('SessionsController', SessionsController);

    SessionsController.$inject = ['Sessions', 'Principal'];

    function SessionsController (Sessions, Principal) {
        var vm = this;

        vm.account = null;
        vm.error = null;
        vm.invalidate = invalidate;
        vm.sessions = Sessions.getAll();
        vm.success = null;


        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function invalidate (series) {
            Sessions.delete({series: encodeURIComponent(series)},
                function () {
                    vm.error = null;
                    vm.success = 'OK';
                    vm.sessions = Sessions.getAll();
                },
                function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'base@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'base@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth'];

    function ResetFinishController ($stateParams, $timeout, Auth) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth'];

    function RegisterController ($translate, $timeout, Auth)  {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('pcsApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penality (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penality (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('login', {
            url: '/login',
            data: {
                authorities: [],
                pageTitle: 'pcsApp.login.title'
                //specialClass: 'gray-bg'
            },
            views: {
                'base@': {
                    templateUrl: 'app/account/login/login.html',
                    controller: 'LoginController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('login');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth'];

    function LoginController ($rootScope, $state, $timeout, Auth) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
                else {
                    $state.go('home');
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@base': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth'];

    function ActivationController ($stateParams, Auth) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pcsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('pcsApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<div ng-cloak><div class="row"><div class="col-md-12"><h1 data-translate="home.title">Welcome to the Professional Congress System+!</h1><!--<p class="lead" data-translate="home.subtitle">This is your homepage</p>--><div ng-switch="vm.isAuthenticated()"><div class="alert alert-success" ng-switch-when="true" data-translate="home.logged.message" translate-values="{username: \'{{vm.account.login}}\'}">You are logged in as user "{{vm.account.login}}".</div></div></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top"></iframe>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.ehcache.title">Ehcache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.ehcache.cachename">Cache name</th><th class="text-right" data-translate="metrics.ehcache.objects">Objects</th><th class="text-right" data-translate="metrics.ehcache.hits">Hits</th><th class="text-right" data-translate="metrics.ehcache.misses">Misses</th><th class="text-right" data-translate="metrics.ehcache.evictioncount">Eviction count</th><th class="text-right" data-translate="metrics.ehcache.mean">Mean get time (ms)</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.objects\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.eviction-count\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.mean-get-time\'].value | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span data-translate="userManagement.detail.title">User</span> "{{vm.user.login}}"</h2><dl class="dl-horizontal"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.activated">Activated</span></dt><dd>{{vm.user.activated}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span>{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" autocomplete="off" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="error-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="error-block" ng-show="editForm.login.$error.pattern" data-translate="entity.validation.pattern" data-translate-values="{ pattern: \'_ . @ A-Z a-z 0-9 -\' }">Ez a mez\u0151 csak sz\xE1mokat tartalmazhat pl.: 36703125678</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" required autocomplete="off" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="error-block" ng-show="editForm.lastName.$error.required" translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" required autocomplete="off" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="error-block" ng-show="editForm.lastName.$error.required" translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" autocomplete="off" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="error-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="error-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><!--\n        <div class="form-group">\n            <label data-translate="userManagement.langKey">Lang Key</label>\n            <select class="form-control" name="langKey" ng-model="vm.user.langKey"\n                    ng-options="language as language for language in vm.languages track by language">\n            </select>\n        </div>\n--><div class="form-group"><label translate="userManagement.profiles" for="field_authority">Profiles</label><ui-select multiple="multiple" ng-model="vm.user.authorities" class="form-control" id="field_authority" name="authority" theme="bootstrap" required><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}">{{$item}}</ui-select-match><ui-select-choices repeat="authority in vm.authorities | filter: $select.search"><div ng-bind-html="authority | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.authority.$invalid"><p class="error-block" ng-show="editForm.authority.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="userManagement.congresses" for="field_congresses">Congresses</label><ui-select multiple="multiple" ng-model="vm.user.congresses" id="field_congresses" name="congresses" theme="bootstrap"><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}">{{$item.meetingCode}}</ui-select-match><ui-select-choices repeat="congress in vm.congresses | filter: $select.search track by congress.id"><div ng-bind-html="congress.meetingCode | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 translate="userManagement.home.title">Users</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-primary" type="submit" ui-sref="user-management.new"><i class="fa fa-plus"></i></button><!--<div ibox-tools></div>--></div><div class="ibox-content"><table datatable="ng" id="user-management-datatable" dt-options="dtOptions" dt-column-defs="dtColumnDefs" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th translate="userManagement.login">Login</th><th translate="userManagement.email">Email</th><th translate="userManagement.activated">Activated</th><th translate="userManagement.profiles">Profiles</th><th translate="userManagement.createdDate">Created date</th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td>{{user.login}}</td><td>{{user.email}}</td><td><span class="label label-danger" ng-click="setActive(user, true)" ng-show="!user.activated" translate="userManagement.deactivated" style="cursor: pointer">Desactivated</span> <span class="label label-success" ng-click="setActive(user, false)" ng-show="user.activated" translate="userManagement.activated" style="cursor: pointer">Activated</span></td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'mediumDate\'}}</td><td><button class="btn btn-info" type="submit" ui-sref="user-management.edit({login:user.login})"><i class="fa fa-pencil-square-o"></i></button> <button class="btn btn-danger" type="submit" ui-sref="user-management.delete({login:user.login})"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ui-sref="login">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/login/login.html','<div class="middle-box text-center loginscreen animated fadeInDown"><div><h1 class="logo-name">PCS+</h1></div><h3>Welcome to PCS System!</h3><!--<p translate="login.title">Sign in</p>--><div class="alert alert-danger" ng-show="vm.authenticationError" translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div><div class="loginscreen form-box"><form class="m-t" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary block full-width m-b" translate="login.form.button">Sign in</button> <a class="alert-link" href="#/reset/request" translate="login.password.forgot">Did you forget your password?</a></form></div></div>');
$templateCache.put('app/account/password/password.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2></div><div class="col-lg-2"></div></div><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins" ng-show="vm.success"><div class="form-group alert alert-success" data-translate="password.messages.success"><strong>Password changed!</strong></div></div><div class="ibox float-e-margins" ng-show="vm.error"><div class="form-group alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div></div><div class="ibox float-e-margins" ng-show="vm.doNotMatch"><div class="form-group alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="ibox float-e-margins"><div class="ibox-content"><form name="form" role="form" novalidate ng-submit="vm.changePassword()" class="form-horizontal" show-validation><div class="form-group"><label class="col-sm-2 control-label" for="password" translate="global.form.newpassword">New password</label><div class="col-sm-10"><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="error-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="error-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="error-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div></div><div class="hr-line-dashed"></div><div class="form-group"><label class="col-sm-2 control-label" for="confirmPassword" translate="global.form.confirmpassword">New password confirmation</label><div class="col-sm-10"><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="error-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="error-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="error-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><div class="col-sm-4 col-sm-offset-2"><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="password.form.button">Save</span></button></div></div></form></div></div></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="register.title">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login" data-translate="global.form.username">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="error-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">Your username is required.</p><p class="error-block" ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="error-block" ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="error-block" ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="error-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="error-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="error-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="error-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="error-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="error-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="error-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="error-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="error-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="error-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="register.form.button">Register</button></form><p></p><div class="alert alert-warning" data-translate="global.messages.info.authenticated" translate-compile>If you want to <a class="alert-link" href="" ui-sref="login">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div></div></div>');
$templateCache.put('app/account/sessions/sessions.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 data-translate="sessions.title" translate-values="{username: \'{{vm.account.login}}\'}">Active sessions for [<b>{{vm.account.login}}</b>]</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins" ng-show="vm.success"><div class="form-group alert alert-success"><span data-translate="sessions.messages.success"><strong>Session invalidated!</strong></span></div></div><div class="ibox float-e-margins" ng-show="vm.error"><div class="form-group alert alert-danger"><span data-translate="sessions.messages.error"><strong>An error has occured!</strong> The session could not be invalidated.</span></div></div><div class="ibox"><div class="ibox-content"><table id="sessions-datatable" class="table table-striped table-bordered table-hover"><thead><tr><th data-translate="sessions.table.ipaddress">IP Address</th><th data-translate="sessions.table.useragent">User agent</th><th data-translate="sessions.table.date">Date</th><th></th></tr></thead><tbody><tr ng-repeat="session in vm.sessions"><td>{{session.ipAddress}}</td><td>{{session.userAgent}}</td><td>{{session.tokenDate | date:\'longDate\'}}</td><td><button type="submit" class="btn btn-primary" ng-click="vm.invalidate(session.series)" data-translate="sessions.table.button">Invalidate</button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2></div><div class="col-lg-2"></div></div><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins" ng-show="vm.success"><div class="form-group alert alert-success"><span data-translate="settings.messages.success"><strong>Settings saved!</strong></span></div></div><div class="ibox float-e-margins" ng-show="vm.errorEmailExists"><div class="form-group alert alert-danger"><span data-translate="settings.messages.error.emailexists"><strong>E-mail is already in use!</strong> Please choose another one.</span></div></div><div class="ibox float-e-margins" ng-show="vm.error"><div class="form-group alert alert-danger"><span data-translate="settings.messages.error.fail"><strong>An error has occurred!</strong> Settings could not be saved.</span></div></div><div class="ibox float-e-margins"><div class="ibox-content"><form name="form" role="form" novalidate ng-submit="vm.save()" class="form-horizontal" show-validation><div class="form-group"><label class="col-sm-2 control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><div class="col-sm-10"><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" autocomplete="off" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="error-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="error-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="error-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><label class="col-sm-2 control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><div class="col-sm-10"><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" autocomplete="off" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="error-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="error-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="error-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><label class="col-sm-2 control-label" for="email" data-translate="global.form.email">E-mail</label><div class="col-sm-10"><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" autocomplete="off" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="error-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="error-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="error-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="error-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div></div><!--\n                        <div class="hr-line-dashed"></div>\n\n                        <div class="form-group">\n                            <label class="col-sm-2 control-label" for="langKey" data-translate="settings.form.language">Language</label>\n                            <div class="col-sm-10">\n                                <select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="LanguageController" ng-options="code as (code | findLanguageFromKey) for code in languages"></select>\n                            </div>\n                        </div>\n--><div class="hr-line-dashed"></div><div class="form-group"><div class="col-sm-4 col-sm-offset-2"><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="settings.form.button">Save</span></button></div></div></form></div></div></div></div></div>');
$templateCache.put('app/layouts/content/content.html','<!-- Navigation --><div ui-view="navbar" ng-cloak></div><!-- Page wraper --><!-- ng-class with current state name give you the ability to extended customization your view --><div id="page-wrapper" class="gray-bg {{$state.current.name}}"><!-- Page wrapper --><div ui-view="header" ng-cloak></div><!-- Main view  --><div ui-view="content"><!-- Angular views --></div><!-- Footer --><div ui-view="footer" ng-cloak></div></div><!-- End page wrapper-->');
$templateCache.put('app/layouts/error/accessdenied.html','<div class="text-center"><h2 class="logo-name">PCS+</h2></div><div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/footer/footer.html','<div class="footer"><div class="pull-right">Version: <strong>{{ VERSION }}</strong></div><div><strong>Copyright</strong> Congressline Kft. &copy; 2020</div></div>');
$templateCache.put('app/layouts/header/header.html','<div class="row border-bottom"><nav class="navbar navbar-static-top" role="navigation" style="margin-bottom: 0"><div class="navbar-header"><span minimaliza-sidebar></span></div><ul class="nav navbar-top-links navbar-left"><li uib-dropdown><a class="count-info" href uib-dropdown-toggle>{{hd.selectedCongress ? hd.selectedCongress.name : \'Please select a congress!\'}}</a><ul uib-dropdown-menu class="animated fadeInRight m-t-xs"><li active-menu="{{congress}}" ng-repeat="congress in hd.congresses track by congress.id"><a href="" ng-click="hd.selectCongress(congress)">{{congress.meetingCode}}</a></li></ul></li></ul><ul class="nav navbar-top-links navbar-right"><!--\n            <li uib-dropdown ng-controller="JhiLanguageController as languageVm">\n                <a class="count-info" href uib-dropdown-toggle>\n                    Language\n                </a>\n                <ul uib-dropdown-menu class="animated fadeInRight m-t-xs" ng-if="languageVm.languages.length > 1">\n                    <li active-menu="{{language}}" ng-repeat="language in languageVm.languages">\n                        <a href="" ng-click="languageVm.changeLanguage(language);">{{language | findLanguageFromKey}}</a>\n                    </li>\n                </ul>\n            </li>\n--><li><a href="" ng-click="hd.logout()"><i class="fa fa-sign-out"></i> Log out</a></li></ul></nav></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar-default navbar-static-side" role="navigation"><div class="sidebar-collapse"><ul side-navigation class="nav metismenu" id="side-menu"><li class="nav-header"><div class="profile-element"><span class="clear"><span class="block m-t-xs"><h1 style="margin-top: 0px; font-weight: 700">PCS+</h1></span><span class="text-muted text-xs block">{{vm.account.firstName}} {{vm.account.lastName}}</span></span></div><div class="logo-element">PCS+</div></li><li ng-class="{active: $state.includes(\'administration\')}" ng-show="vm.isCongressSelected()"><a href=""><i class="fa fa-edit"></i> <span class="nav-label" translate="global.menu.administration.main">Administration</span> <span class="fa arrow"></span></a><ul class="nav nav-second-level collapse" ng-class="{in: $state.includes(\'administration\')}"><li ui-sref-active="active"><a ui-sref="registration" translate="global.menu.administration.registration">Registration</a></li><li ui-sref-active="active"><a ui-sref="backend-online-reg" translate="global.menu.administration.onlineReg">Online Reg</a></li><li ui-sref-active="active"><a ui-sref="workplace" translate="global.menu.administration.workplace">Workplace</a></li><li ui-sref-active="active"><a ui-sref="registration-type" translate="global.menu.administration.registrationType">Registration Type</a></li><li ui-sref-active="active"><a ui-sref="congress-hotel" translate="global.menu.administration.selectedHotel">Selected hotel</a></li><li ui-sref-active="active"><a ui-sref="optional-service" translate="global.menu.administration.optionalService">Optional Service</a></li><li ui-sref-active="active"><a ui-sref="group-discount-item" translate="global.menu.administration.groupFinancial">Group financial</a></li><li ui-sref-active="active"><a ui-sref="group-discount-invoice" translate="global.menu.administration.groupInvoice">Group invoice</a></li><li ui-sref-active="active"><a ui-sref="group-discount-payment" translate="global.menu.administration.groupPayment">Group payment</a></li><li ui-sref-active="active"><a ui-sref="paying-group" translate="global.menu.administration.payingGroup">Paying Group</a></li><li ui-sref-active="active"><a ui-sref="misc-invoice" translate="global.menu.administration.miscInvoice">Misc Invoice</a></li><li ui-sref-active="active"><a ui-sref="misc-service" translate="global.menu.administration.miscService">Misc Service</a></li><li ui-sref-active="active"><a ui-sref="congress-vat-info({congressSpecific: true})" translate="global.menu.administration.vatInfo">VAT Info</a></li><li ui-sref-active="active"><a ui-sref="optional-text" translate="global.menu.administration.optionalText">Optional text</a></li></ul></li><li ng-class="{active: $state.includes(\'report\')}" ng-show="vm.isCongressSelected()"><a href=""><i class="fa fa-bar-chart-o"></i> <span class="nav-label" translate="global.menu.report.main">Report</span> <span class="fa arrow"></span></a><ul class="nav nav-second-level collapse" ng-class="{in: $state.includes(\'report\')}"><li ui-sref-active="active"><a ui-sref="general-registration-report" translate="global.menu.report.generalRegistrationReport">Registration Report</a></li><li ui-sref-active="active"><a ui-sref="financial-report" translate="global.menu.report.financialReport">Financial Report</a></li><li ui-sref-active="active"><a ui-sref="hotel-general-report" translate="global.menu.report.hotelGeneralReport">Hotel General Report</a></li><li ui-sref-active="active"><a ui-sref="room-reservation-by-participant" translate="global.menu.report.roomReservationByParticipant">Reservation By Participant</a></li><li ui-sref-active="active"><a ui-sref="room-reservation-by-room" translate="global.menu.report.roomReservationByRoom">Reservation By Room</a></li><li ui-sref-active="active"><a ui-sref="hotel-summary" translate="global.menu.report.hotelSummary">Hotel Summary</a></li><li ui-sref-active="active"><a ui-sref="optional-service-applicant" translate="global.menu.report.optionalServiceApplicant">Optional Service Applicant</a></li><li ui-sref-active="active"><a ui-sref="optional-programs-members" translate="global.menu.report.optionalProgramsMembers">Optional service</a></li><li ui-sref-active="active"><a ui-sref="payment-summary" translate="global.menu.report.paymentSummary">Payment summary</a></li><li ui-sref-active="active"><a ui-sref="regfee-details-by-participant" translate="global.menu.report.regFeeDetailsByParticipant">Regfee by participant</a></li><li ui-sref-active="active"><a ui-sref="regfee-details" translate="global.menu.report.regFeeDetails">Regfee details</a></li><li ui-sref-active="active"><a ui-sref="online-reg-custom-answer-report" translate="global.menu.report.onlineRegCustomAnswerReport">Online reg custom answer report</a></li></ul></li><li ng-class="{active: $state.includes(\'maintenance\')}" has-authority="ROLE_ADMIN"><a href=""><i class="fa fa-th-large"></i> <span class="nav-label" translate="global.menu.maintenance.main">Maintenance</span> <span class="fa arrow"></span></a><ul class="nav nav-second-level collapse" ng-class="{in: $state.includes(\'maintenance\')}"><li ui-sref-active="active"><a ui-sref="congress" translate="global.menu.maintenance.congress">Congress</a></li><li ui-sref-active="active"><a ui-sref="hotel" translate="global.menu.maintenance.hotel">Hotel</a></li><li ui-sref-active="active"><a ui-sref="invoice-report" translate="global.menu.maintenance.invoiceReport">Invoice Report</a></li><li ui-sref-active="active"><a ui-sref="credit-card-report" translate="global.menu.maintenance.creditCardReport">Credit Card Report</a></li><li ui-sref-active="active"><a ui-sref="payment-transaction-report" translate="global.menu.maintenance.paymentTransactionReport">Payment Transaction Report</a></li><li ui-sref-active="active"><a ui-sref="rate" translate="global.menu.maintenance.rate">Currency Rate</a></li><li ui-sref-active="active"><a ui-sref="bank-account" translate="global.menu.maintenance.bankAccount">Bank Account</a></li><li ui-sref-active="active"><a ui-sref="vat-info({congressSpecific: false})" translate="global.menu.maintenance.vatInfo">VAT info</a></li><li ui-sref-active="active"><a ui-sref="partner" translate="global.menu.maintenance.partner">Partner</a></li><li ui-sref-active="active"><a ui-sref="country" translate="global.menu.maintenance.country">Country</a></li><li ui-sref-active="active"><a ui-sref="company" translate="global.menu.maintenance.companyProfile">Company Profile</a></li></ul></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ui-sref-active="active" ng-show="false"><a href=""><i class="fa fa-th-large"></i> <span class="nav-label" translate="global.menu.entities.main">Entities</span> <span class="fa arrow"></span></a><ul class="nav nav-second-level collapse" ng-class="{in: $state.includes(\'dashboards\')}"><li ui-sref-active="active"><a ui-sref="currency" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.currency">Currency</span></a></li><li ui-sref-active="active"><a ui-sref="congress" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.congress">Congress</span></a></li><li ui-sref-active="active"><a ui-sref="country" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.country">Country</span></a></li><li ui-sref-active="active"><a ui-sref="bank-account" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.bankAccount">Bank Account</span></a></li><li ui-sref-active="active"><a ui-sref="rate" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.rate">Rate</span></a></li><li ui-sref-active="active"><a ui-sref="hotel" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.hotel">Hotel</span></a></li><li ui-sref-active="active"><a ui-sref="vat-info" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.vatInfo">Vat Info</span></a></li><li ui-sref-active="active"><a ui-sref="company" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.company">Company</span></a></li><li ui-sref-active="active"><a ui-sref="optional-text" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.optionalText">Optional Text</span></a></li><li ui-sref-active="active"><a ui-sref="workplace" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.workplace">Workplace</span></a></li><li ui-sref-active="active"><a ui-sref="registration-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.registrationType">Registration Type</span></a></li><li ui-sref-active="active"><a ui-sref="optional-service" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.optionalService">Optional Service</span></a></li><li ui-sref-active="active"><a ui-sref="paying-group" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.payingGroup">Paying Group</span></a></li><li ui-sref-active="active"><a ui-sref="paying-group-item" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.payingGroupItem">Paying Group Item</span></a></li><li ui-sref-active="active"><a ui-sref="misc-service" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.miscService">Misc Service</span></a></li><li ui-sref-active="active"><a ui-sref="congress-hotel" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.congressHotel">Congress Hotel</span></a></li><li ui-sref-active="active"><a ui-sref="room" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.room">Room</span></a></li><li ui-sref-active="active"><a ui-sref="misc-invoice" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.miscInvoice">Misc Invoice</span></a></li><li ui-sref-active="active"><a ui-sref="misc-invoice-item" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.miscInvoiceItem">Misc Invoice Item</span></a></li><li ui-sref-active="active"><a ui-sref="registration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.registration">Registration</span></a></li><li ui-sref-active="active"><a ui-sref="registration-registration-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.registrationRegistrationType">Registration Registration Type</span></a></li><li ui-sref-active="active"><a ui-sref="room-reservation" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.roomReservation">Room Reservation</span></a></li><li ui-sref-active="active"><a ui-sref="room-reservation-registration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.roomReservationRegistration">Room Reservation Registration</span></a></li><li ui-sref-active="active"><a ui-sref="ordered-optional-service" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.orderedOptionalService">Ordered Optional Service</span></a></li><li ui-sref-active="active"><a ui-sref="charged-service" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.chargedService">Charged Service</span></a></li><li ui-sref-active="active"><a ui-sref="acc-people" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.accPeople">Acc People</span></a></li><li ui-sref-active="active"><a ui-sref="invoice" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.invoice">Invoice</span></a></li><li ui-sref-active="active"><a ui-sref="group-discount-item" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.groupDiscountItem">Group Discount Item</span></a></li><li ui-sref-active="active"><a ui-sref="group-discount-invoice" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.groupDiscountInvoice">Group Invoice</span></a></li><li ui-sref-active="active"><a ui-sref="group-discount-invoice-history" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.groupDiscountInvoiceHistory">Group Invoice History</span></a></li><li ui-sref-active="active"><a ui-sref="group-discount-payment" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.groupDiscountPayment">Group Discount Payment</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: $state.includes(\'account\')}"><a href=""><i class="fa fa-user"></i> <span class="nav-label" translate="global.menu.account.main">Account</span> <span class="fa arrow"></span></a><ul class="nav nav-second-level collapse" ng-class="{in: $state.includes(\'account\')}"><li ui-sref-active="active"><a ui-sref="settings" translate="global.menu.account.settings">Settings</a></li><li ui-sref-active="active"><a ui-sref="password" translate="global.menu.account.password">Password</a></li><li ui-sref-active="active"><a ui-sref="sessions" translate="global.menu.account.sessions">Sessions</a></li></ul></li><li ng-class="{active: $state.includes(\'system\')}" has-authority="ROLE_ADMIN"><a href=""><i class="fa fa-cogs"></i> <span class="nav-label" translate="global.menu.admin.main">Administration</span> <span class="fa arrow"></span></a><ul class="nav nav-second-level collapse" ng-class="{in: $state.includes(\'system\')}"><li ui-sref-active="active"><a ui-sref="user-management" translate="global.menu.admin.user-management">User management</a></li><li ui-sref-active="active"><a ui-sref="currency" translate="global.menu.admin.currency">Currency</a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" translate="global.menu.admin.metrics">Metrics</a></li><li ui-sref-active="active"><a ui-sref="jhi-health" translate="global.menu.admin.health">Health</a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" translate="global.menu.admin.configuration">Configuration</a></li><li ui-sref-active="active"><a ui-sref="audits" translate="global.menu.admin.audits">Audits</a></li><li ui-sref-active="active"><a ui-sref="logs" translate="global.menu.admin.logs">Logs</a></li><li ng-hide="inProduction" ui-sref-active="active"><a ui-sref="docs" translate="global.menu.admin.apidocs">API</a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li></ul></div></nav>');
$templateCache.put('app/entities/acc-people/acc-people-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.accPeople.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.accPeople.delete.question" translate-values="{id: \'{{vm.accPeople.id}}\'}">Are you sure you want to delete this Acc People?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/acc-people/acc-people-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAccPeopleLabel" data-translate="pcsApp.accPeople.home.createOrEditLabel">Create or edit a Acc People</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="pcsApp.accPeople.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" autocomplete="off" ng-model="vm.accPeople.title" ng-maxlength="8"><div ng-show="editForm.title.$invalid"><p class="error-block" ng-show="editForm.title.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="8">This field cannot be longer than 8 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.accPeople.lastName" for="field_lastName">Last Name</label><input type="text" class="form-control" name="lastName" id="field_lastName" autocomplete="off" ng-model="vm.accPeople.lastName" required ng-maxlength="64"><div ng-show="editForm.lastName.$invalid"><p class="error-block" ng-show="editForm.lastName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.accPeople.firstName" for="field_firstName">First Name</label><input type="text" class="form-control" name="firstName" id="field_firstName" autocomplete="off" ng-model="vm.accPeople.firstName" required ng-maxlength="64"><div ng-show="editForm.firstName.$invalid"><p class="error-block" ng-show="editForm.firstName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/acc-people/acc-people.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 translate="pcsApp.accPeople.home.title" translate-values="{regId: \'{{vm.registrationRegistrationType.registration.regId}}\', regType: \'{{vm.registrationRegistrationType.registrationType.name }}\'}">Acc People for registration id: {{vm.registrationRegistrationType.registration.regId}}</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-primary" type="submit" ng-hide="vm.registrationRegistrationType.accPeople <= vm.accPeoples.length" ui-sref="acc-people.new"><i class="fa fa-plus"></i></button> <button class="btn btn-info" type="submit" ui-sref="registration({registrationId: registrationRegistrationType.registration.id})"><i class="fa fa-arrow-left"></i></button><!--<div ibox-tools></div>--></div><div class="ibox-content"><table datatable="ng" id="acc-people-datatable" dt-options="dtOptions" dt-column-defs="dtColumnDefs" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.accPeople.lastName">Last name</span></th><th><span translate="pcsApp.accPeople.firstName">First name</span></th><th><span translate="pcsApp.accPeople.title">Title</span></th><th></th></tr></thead><tbody><tr ng-repeat="accPeople in vm.accPeoples track by accPeople.id"><td>{{accPeople.lastName}}</td><td>{{accPeople.firstName}}</td><td>{{accPeople.title}}</td><td><button class="btn btn-info" type="submit" ui-sref="acc-people.edit({id: accPeople.id})"><i class="fa fa-pencil-square-o"></i></button> <button class="btn btn-danger" type="submit" ui-sref="acc-people.delete({id: accPeople.id})"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/backend-online-reg/backend-online-reg-confirmation-all-dialog.html','<form name="confirmationForm" ng-submit="vm.confirm()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.accept.title">Confirm accept operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.backendOnlineReg.acceptAll.question">Are you sure you want to accept all the selected online registrations?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="confirmationForm.$invalid" class="btn btn-primary"><span class="fa fa-group"></span>&nbsp;<span data-translate="entity.action.accept">Accept</span></button></div></form>');
$templateCache.put('app/entities/backend-online-reg/backend-online-reg-confirmation-dialog.html','<form name="confirmationForm" ng-submit="vm.confirm(vm.backendOnlineReg.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.accept.title">Confirm accept operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.backendOnlineReg.accept.question" translate-values="{id: \'{{vm.backendOnlineReg.id}}\'}">Are you sure you want to accept this online registration?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="confirmationForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.accept">Accept</span></button></div></form>');
$templateCache.put('app/entities/backend-online-reg/backend-online-reg-delete-all-dialog.html','<form name="confirmationForm" ng-submit="vm.confirm()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.backendOnlineReg.deleteAll.question">Are you sure you want to delete all the selected online registrations?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="confirmationForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/backend-online-reg/backend-online-reg-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.backendOnlineReg.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.backendOnlineReg.delete.question" translate-values="{id: \'{{vm.backendOnlineReg.id}}\'}">Are you sure you want to delete this Optional Service?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/backend-online-reg/backend-online-reg-dialog.html','<div class="row wrapper border-bottom white-bg page-heading"><div style="padding-left: 15px"><h2 data-translate="pcsApp.backendOnlineReg.home.createOrEditLabel" translate-values="{lastName: \'{{vm.backendOnlineReg.lastName}}\', firstName: \'{{vm.backendOnlineReg.firstName}}\'}">Create a new registration for {{vm.backendOnlineReg.lastName + \', \' + vm.backendOnlineReg.firstName}}</h2></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-content"><div class="row m-b-sm"><div class="col-xs-2"><label class="control-label" data-translate="pcsApp.onlineReg.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" autocomplete="off" disabled="disabled" ng-value="vm.backendOnlineReg.title"></div><div class="col-xs-5"><label class="control-label" data-translate="pcsApp.onlineReg.lastName" for="field_lastName">Last name</label><input type="text" class="form-control" name="lastName" id="field_lastName" autocomplete="off" disabled="disabled" ng-value="vm.backendOnlineReg.lastName"></div><div class="col-xs-5"><label class="control-label" data-translate="pcsApp.onlineReg.firstName" for="field_firstName">First name</label><input type="text" class="form-control" name="firstName" id="field_firstName" autocomplete="off" disabled="disabled" ng-value="vm.backendOnlineReg.firstName"></div></div><div class="row m-b-sm"><div class="col-xs-6"><label class="control-label" data-translate="pcsApp.onlineReg.position" for="field_position">Position</label><input type="text" class="form-control" name="position" id="field_position" autocomplete="off" disabled="disabled" ng-value="vm.backendOnlineReg.position"></div><div class="col-xs-6"><label class="control-label" data-translate="pcsApp.onlineReg.department" for="field_department">Department</label><input type="text" class="form-control" name="department" id="field_department" autocomplete="off" disabled="disabled" ng-value="vm.backendOnlineReg.department"></div></div><div class="row m-b-sm"><div class="col-xs-6"><label class="control-label" data-translate="pcsApp.onlineReg.workplace" for="field_workplace">Workplace</label><input type="text" class="form-control" name="workplace" id="field_workplace" autocomplete="off" disabled="disabled" ng-value="vm.backendOnlineReg.workplace"></div><div class="col-xs-6"><label class="control-label" data-translate="pcsApp.onlineReg.otherData" for="field_otherData">Other data</label><input type="text" class="form-control" name="otherData" id="field_otherData" autocomplete="off" disabled="disabled" ng-value="vm.backendOnlineReg.otherData"></div></div><div class="row m-b-sm"><div class="col-xs-2"><label class="control-label" data-translate="pcsApp.onlineReg.zipCode" for="field_zipCode">Zip code</label><input type="text" class="form-control" name="zipCode" id="field_zipCode" autocomplete="off" disabled="disabled" ng-value="vm.backendOnlineReg.zipCode"></div><div class="col-xs-4"><label class="control-label" data-translate="pcsApp.onlineReg.city" for="field_city">City</label><input type="text" class="form-control" name="city" id="field_city" autocomplete="off" disabled="disabled" ng-value="vm.backendOnlineReg.city"></div><div class="col-xs-4"><label class="control-label" data-translate="pcsApp.onlineReg.street" for="field_street">Street</label><input type="text" class="form-control" name="street" id="field_street" autocomplete="off" disabled="disabled" ng-value="vm.backendOnlineReg.street"></div><div class="col-xs-2"><label class="control-label" data-translate="pcsApp.onlineReg.country" for="field_country">Country</label><input type="text" class="form-control" name="country" id="field_country" autocomplete="off" disabled="disabled" ng-value="vm.backendOnlineReg.country.name"></div></div><div class="row m-b-sm"><div class="col-xs-6"><label class="control-label" data-translate="pcsApp.onlineReg.phone" for="field_phone">Phone</label><input type="text" class="form-control" name="phone" id="field_phone" autocomplete="off" disabled="disabled" ng-value="vm.backendOnlineReg.phone"></div><div class="col-xs-6"><label class="control-label" data-translate="pcsApp.onlineReg.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" autocomplete="off" disabled="disabled" ng-value="vm.backendOnlineReg.email"></div></div><div class="row m-b-sm"><div class="col-xs-12"><label class="control-label" data-translate="pcsApp.onlineReg.registration" for="field_regType">Registration</label><input type="text" class="form-control" name="regType" id="field_regType" autocomplete="off" disabled="disabled" ng-value="vm.backendOnlineReg.registrationType.name"></div></div><div class="row m-b-sm"><div class="col-xs-12"><label class="control-label" data-translate="pcsApp.onlineReg.home.extraRegistration">Extra Registration(s)</label><table class="table chargeable-item online-accept-table"><thead><tr><th data-translate="pcsApp.onlineReg.type">Type</th><th data-translate="pcsApp.onlineReg.accompanies">Accompanies</th></tr></thead><tbody><tr ng-repeat="rt in vm.backendOnlineReg.extraRegTypes track by $index"><td>{{rt.registrationType.name}}</td><td><small ng-repeat="acc in rt.accompanies">{{!$first ? \', \' : \'\'}}{{acc.lastName + \' \' + acc.firstName}}</small></td></tr></tbody></table></div></div><div class="row m-b-sm"><div class="col-xs-8"><label class="control-label" data-translate="pcsApp.onlineReg.room" for="field_room">Room</label><input type="text" class="form-control" name="room" id="field_room" autocomplete="off" disabled="disabled" ng-value="vm.backendOnlineReg.room.roomType + \' \' + vm.backendOnlineReg.room.hotelName"></div><div class="col-xs-2"><label class="control-label" data-translate="pcsApp.onlineReg.arrivalDate" for="field_arrivalDate">Arrival date</label><input type="text" class="form-control" name="arrivalDate" id="field_arrivalDate" autocomplete="off" disabled="disabled" ng-value="vm.backendOnlineReg.arrivalDate"></div><div class="col-xs-2"><label class="control-label" data-translate="pcsApp.onlineReg.departureDate" for="field_departureDate">Departure date</label><input type="text" class="form-control" name="departureDate" id="field_departureDate" autocomplete="off" disabled="disabled" ng-value="vm.backendOnlineReg.departureDate"></div></div><div class="row m-b-sm"><div class="col-xs-12"><label class="control-label" data-translate="pcsApp.onlineReg.roommate" for="field_roommate">Roommate</label><input type="text" class="form-control" name="roommate" id="field_roommate" autocomplete="off" disabled="disabled" ng-value="vm.backendOnlineReg.roommate"></div></div><div class="row m-b-sm"><div class="col-xs-12"><label class="control-label" data-translate="pcsApp.onlineReg.roomRemark" for="field_roomRemark">Room remark</label><textarea class="form-control" name="roomRemark" id="field_roomRemark" row="5" autocomplete="off" disabled="disabled">{{vm.backendOnlineReg.roomRemark}}</textarea></div></div><div class="row m-b-sm"><div class="col-xs-12"><label class="control-label" data-translate="pcsApp.onlineReg.home.optionalService">Optional services</label><table class="table chargeable-item online-accept-table"><thead><tr><th data-translate="pcsApp.onlineReg.osName">Name</th><th data-translate="pcsApp.onlineReg.osPax">Pax</th></tr></thead><tbody><tr ng-repeat="os in vm.backendOnlineReg.optionalServices track by $index"><td>{{os.optionalService.name}} <small>{{os.optionalService.startDate | date: \'longDate\'}}</small></td><td>{{os.participants}}</td></tr></tbody></table></div></div><div class="row m-b-sm"><div class="col-xs-12"><label class="control-label" data-translate="pcsApp.onlineReg.paymentMethod" for="field_paymentMethod">Payment method</label><input type="text" class="form-control" name="paymentMethod" id="field_paymentMethod" autocomplete="off" disabled="disabled" ng-value="vm.backendOnlineReg.paymentMethod"></div></div><div class="row m-b-sm"><div class="col-xs-8"><label class="control-label" data-translate="pcsApp.onlineReg.invoiceName" for="field_invoiceName">Invoice name</label><input type="text" class="form-control" name="invoiceName" id="field_invoiceName" autocomplete="off" disabled="disabled" ng-value="vm.backendOnlineReg.invoiceName"></div><div class="col-xs-4"><label class="control-label" data-translate="pcsApp.onlineReg.invoiceCountry" for="field_invoiceCountry">Invoice country</label><input type="text" class="form-control" name="invoiceCountry" id="field_invoiceCountry" autocomplete="off" disabled="disabled" ng-value="vm.backendOnlineReg.invoiceCountry.name"></div></div><div class="row m-b-sm"><div class="col-xs-6"><label class="control-label" data-translate="pcsApp.onlineReg.invoiceZipCode" for="field_invoiceZipCode">Invoice zipcode</label><input type="text" class="form-control" name="invoiceZipCode" id="field_invoiceZipCode" autocomplete="off" disabled="disabled" ng-value="vm.backendOnlineReg.invoiceZipCode"></div><div class="col-xs-6"><label class="control-label" data-translate="pcsApp.onlineReg.invoiceCity" for="field_invoiceCity">Invoice address</label><input type="text" class="form-control" name="invoiceAddress" id="field_invoiceCity" autocomplete="off" disabled="disabled" ng-value="vm.backendOnlineReg.invoiceCity"></div></div><div class="row m-b-sm"><div class="col-xs-12"><label class="control-label" data-translate="pcsApp.onlineReg.invoiceAddress" for="field_invoiceAddress">Invoice address</label><input type="text" class="form-control" name="invoiceAddress" id="field_invoiceAddress" autocomplete="off" disabled="disabled" ng-value="vm.backendOnlineReg.invoiceAddress"></div></div><div class="row m-b-sm"><div class="col-xs-6"><label class="control-label" data-translate="pcsApp.onlineReg.invoiceReferenceNumberShort" for="field_invoiceReferenceNumber">Invoice ref number</label><input type="text" class="form-control" name="invoiceReferenceNumber" id="field_invoiceReferenceNumber" autocomplete="off" disabled="disabled" ng-value="vm.backendOnlineReg.invoiceReferenceNumber"></div><div class="col-xs-6"><label class="control-label" data-translate="pcsApp.onlineReg.invoiceTaxNumberShort" for="field_invoiceTaxNumber">Invoice tax number</label><input type="text" class="form-control" name="invoiceTaxNumber" id="field_invoiceTaxNumber" autocomplete="off" disabled="disabled" ng-value="vm.backendOnlineReg.invoiceTaxNumber"></div></div></div></div><div class="ibox" ng-if="vm.customAnswers.length"><div class="ibox-content"><div class="row m-b-sm" ng-repeat="answer in vm.customAnswers track by answer.id"><div class="col-xs-12"><label class="control-label" for="field_custom_answer{{answer.id}}">{{answer.question.question}}</label><input type="text" class="form-control" name="custom_answer{{answer.id}}" id="field_custom_answer{{answer.id}}" autocomplete="off" disabled="disabled" ng-value="answer.answer"></div></div></div></div><div class="ibox"><div class="ibox-title float-e-margins"><button type="submit" ui-sref="backend-online-reg.accept-confirmation({id: vm.backendOnlineReg.id})" class="btn btn-primary"><span class="fa fa-group"></span>&nbsp;<span data-translate="entity.action.accept ">Accept</span></button> <button type="button" class="btn btn-default" ng-click="vm.cancel()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button></div></div></div></div></div>');
$templateCache.put('app/entities/backend-online-reg/backend-online-regs.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 translate="pcsApp.backendOnlineReg.home.title">OptionalServices</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins" ng-if="vm.isAnyOnlineRegIdSelected()"><button class="btn btn-primary" type="submit" ui-sref="backend-online-reg.accept-confirmation-all"><i class="fa fa-group"></i></button> <button class="btn btn-danger" type="submit" ui-sref="backend-online-reg.delete-confirmation-all"><i class="fa fa-trash-o"></i></button> <button class="btn btn-info" type="submit" ng-click="vm.downloadAllSelected()"><i class="fa fa-download"></i></button></div><div class="ibox-content"><table datatable="ng" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" id="backend-online-reg-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><input ng-model="vm.allOnlineRegIdSelected" ng-change="vm.toggleAllOnlineRegSelection()" type="checkbox"></th><th><span translate="pcsApp.onlineReg.lastName">Family name</span></th><th><span translate="pcsApp.onlineReg.firstName">First name</span></th><th><span translate="pcsApp.onlineReg.zipCode">Zip code</span></th><th><span translate="pcsApp.onlineReg.city">City</span></th><th><span translate="pcsApp.onlineReg.street">Street</span></th><th><span translate="pcsApp.onlineReg.country">Country</span></th><th><span translate="pcsApp.onlineReg.phone">Phone</span></th><th><span translate="pcsApp.onlineReg.email">Email</span></th><th><span translate="pcsApp.onlineReg.dateOfApp">Date of app.</span></th><th></th></tr></thead><tbody><tr ng-repeat="backendOnlineReg in vm.backendOnlineRegs track by backendOnlineReg.id"><td><input ng-model="vm.onlineRegFilter.selectedOnlineRegIds[backendOnlineReg.id.toString()]" ng-change="vm.toggleOnlineRegSelection(backendOnlineReg.id)" type="checkbox"></td><td>{{backendOnlineReg.lastName}}</td><td>{{backendOnlineReg.firstName}}</td><td>{{backendOnlineReg.zipCode}}</td><td>{{backendOnlineReg.city}}</td><td>{{backendOnlineReg.street}}</td><td>{{backendOnlineReg.country.name}}</td><td>{{backendOnlineReg.phone}}</td><td>{{backendOnlineReg.email}}</td><td>{{backendOnlineReg.dateOfApp | date: \'yyyy-MM-dd HH:mm:ss\'}}</td><td><button class="btn btn-primary" type="submit" tooltip-placement="top" uib-tooltip="Accept" ui-sref="backend-online-reg.accept({id:backendOnlineReg.id})"><i class="fa fa-group"></i></button> <button class="btn btn-info" type="submit" tooltip-placement="top" uib-tooltip="Download pdf" ng-click="vm.downloadPdf(backendOnlineReg.id)"><i class="fa fa-download"></i></button> <button class="btn btn-danger" type="submit" tooltip-placement="top" uib-tooltip="Delete" ui-sref="backend-online-reg.delete({id:backendOnlineReg.id})"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/bank-account/bank-account-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.bankAccount.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.bankAccount.delete.question" translate-values="{id: \'{{vm.bankAccount.id}}\'}">Are you sure you want to delete this Bank Account?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/bank-account/bank-account-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBankAccountLabel" data-translate="pcsApp.bankAccount.home.createOrEditLabel">Create or edit a Bank Account</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="pcsApp.bankAccount.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" autocomplete="off" ng-model="vm.bankAccount.name" required ng-minlength="3" ng-maxlength="32"><div ng-show="editForm.name.$invalid"><p class="error-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 3 characters.</p><p class="error-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.bankAccount.bankName" for="field_bankName">Bank Name</label><input type="text" class="form-control" name="bankName" id="field_bankName" autocomplete="off" ng-model="vm.bankAccount.bankName" required ng-minlength="3" ng-maxlength="32"><div ng-show="editForm.bankName.$invalid"><p class="error-block" ng-show="editForm.bankName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.bankName.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 3 characters.</p><p class="error-block" ng-show="editForm.bankName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.bankAccount.bankAddress" for="field_bankAddress">Bank Address</label><input type="text" class="form-control" name="bankAddress" id="field_bankAddress" autocomplete="off" ng-model="vm.bankAccount.bankAddress" required ng-minlength="8" ng-maxlength="250"><div ng-show="editForm.bankAddress.$invalid"><p class="error-block" ng-show="editForm.bankAddress.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.bankAddress.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="8">This field is required to be at least 8 characters.</p><p class="error-block" ng-show="editForm.bankAddress.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="250">This field cannot be longer than 250 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.bankAccount.bankAccount" for="field_bankAccount">Bank Account</label><input type="text" class="form-control" name="bankAccount" id="field_bankAccount" autocomplete="off" ng-pattern="/^[0-9]{8}[-][0-9]{8}[-][0-9]{8}|[0-9]{8}[-][0-9]{8}|[A-Z]{2}[0-9]{2}[0-9A-Za-z]{11,30}$/" ng-model="vm.bankAccount.bankAccount" required ng-minlength="8" ng-maxlength="32"><div ng-show="editForm.bankAccount.$invalid"><p class="error-block" ng-show="editForm.bankAccount.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.bankAccount.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="8">This field is required to be at least 8 characters.</p><p class="error-block" ng-show="editForm.bankAccount.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p><p class="error-block" ng-show="editForm.bankAccount.$error.pattern" data-translate="entity.validation.pattern" data-translate-values="{ pattern: \'[0-9]{8}[-][0-9]{8}[-][0-9]{8}|[0-9]{8}[-][0-9]{8}|[A-Z]{2}[0-9]{2}[0-9A-Za-z]{11,30}\' }">Ez a mez\u0151 csak a k\xF6v sz\xE1mokat tartalmazhat pl.: 36703125678</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.bankAccount.swiftCode" for="field_swiftCode">Swift Code</label><input type="text" class="form-control" name="swiftCode" id="field_swiftCode" autocomplete="off" ng-model="vm.bankAccount.swiftCode" ng-required="vm.bankAccount.currency.currency != \'HUF\'" ng-maxlength="32"><div ng-show="editForm.swiftCode.$invalid"><p class="error-block" ng-show="editForm.swiftCode.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.swiftCode.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label translate="pcsApp.bankAccount.currency" for="field_currency">Currency</label><ui-select ng-model="vm.bankAccount.currency" name="currency" id="field_currency" theme="bootstrap" required><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.currency"></span></ui-select-match><ui-select-choices repeat="currency in (vm.currencies | filter: $select.search) track by currency.id"><div ng-bind-html="currency.currency | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.currency.$invalid"><p class="error-block" ng-show="editForm.currency.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/bank-account/bank-accounts.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 translate="pcsApp.bankAccount.home.title">Bank accounts</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-primary" type="submit" ui-sref="bank-account.new"><i class="fa fa-plus"></i></button><!--<div ibox-tools></div>--></div><div class="ibox-content"><table datatable="ng" id="bankaccount-table" dt-options="dtOptions" dt-column-defs="dtColumnDefs" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.bankAccount.name">Name</span></th><th><span translate="pcsApp.bankAccount.bankName">Bank name</span></th><th><span translate="pcsApp.bankAccount.currency">Currency</span></th><th><span translate="pcsApp.bankAccount.bankAccount">Bank account</span></th><th><span translate="pcsApp.bankAccount.swiftCode">Swift code</span></th><th></th></tr></thead><tbody><tr ng-repeat="bankAccount in vm.bankAccounts track by bankAccount.id"><td>{{bankAccount.name}}</td><td>{{bankAccount.bankName}}</td><td>{{bankAccount.currency.currency}}</td><td>{{bankAccount.bankAccount}}</td><td>{{bankAccount.swiftCode}}</td><td><button class="btn btn-info" type="submit" ui-sref="bank-account.edit({id:bankAccount.id})"><i class="fa fa-pencil-square-o"></i></button> <button class="btn btn-danger" type="submit" ui-sref="bank-account.delete({id:bankAccount.id})"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/charged-service/charged-service-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.chargedService.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.chargedService.delete.question" translate-values="{id: \'{{vm.chargedService.id}}\'}">Are you sure you want to delete this Charged Service?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/charged-service/charged-service-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myChargedServiceLabel" data-translate="pcsApp.chargedService.home.createOrEditLabel">Create or edit a Charged Service</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="pcsApp.chargedService.paymentMode" for="field_paymentMode">Payment Mode</label><select class="form-control" name="paymentMode" ng-model="vm.chargedService.paymentMode" id="field_paymentMode" required><option value="" data-translate="global.form.please.select">Please select</option><option value="CARD" data-translate="pcsApp.ChargedServicePaymentMode.CARD">CARD</option><option value="CHECK" data-translate="pcsApp.ChargedServicePaymentMode.CHECK">CHECK</option><option value="CASH" data-translate="pcsApp.ChargedServicePaymentMode.CASH">CASH</option><option value="BANK_TRANSFER" data-translate="pcsApp.ChargedServicePaymentMode.BANK_TRANSFER">BANK_TRANSFER</option></select><div ng-show="editForm.paymentMode.$invalid"><p class="error-block" ng-show="editForm.paymentMode.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.chargedService.paymentType" for="field_paymentType">Payment Type</label><select class="form-control" name="paymentType" ng-model="vm.chargedService.paymentType" ng-change="vm.chargeableItemTypeOnChanged()" id="field_paymentType" required><option value="" data-translate="global.form.please.select">Please select</option><option value="REGISTRATION" data-translate="pcsApp.ChargeableItemType.REGISTRATION">REGISTRATION</option><option value="HOTEL" data-translate="pcsApp.ChargeableItemType.HOTEL">HOTEL</option><option value="OPTIONAL_SERVICE" data-translate="pcsApp.ChargeableItemType.OPTIONAL_SERVICE">OPTIONAL_SERVICE</option><option value="MISCELLANEOUS" data-translate="pcsApp.ChargeableItemType.MISCELLANEOUS">MISCELLANEOUS</option></select><div ng-show="editForm.paymentType.$invalid"><p class="error-block" ng-show="editForm.paymentType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ng-show="vm.chargedService.paymentType === \'REGISTRATION\'"><label translate="pcsApp.chargedService.chargeableItem" for="field_rrt_for_chargeableItem">Chargeable item</label><ui-select ng-model="vm.chargedService.chargeableItem" name="rrtForChargeableItem" id="field_rrt_for_chargeableItem" ng-change="vm.setDefaultPrice()" theme="bootstrap" ng-required="vm.chargedService.paymentType === \'REGISTRATION\'"><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.chargeableItemName"></span></ui-select-match><ui-select-choices repeat="registrationRegistrationType in (vm.registrationRegistrationTypes | filter: $select.search) track by registrationRegistrationType.id"><div ng-bind-html="registrationRegistrationType.chargeableItemName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.rrtForChargeableItem.$invalid"><p class="error-block" ng-show="editForm.chargeableItem.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ng-show="vm.chargedService.paymentType === \'HOTEL\'"><label translate="pcsApp.chargedService.chargeableItem" for="field_rr_for_chargeableItem">Chargeable item</label><ui-select ng-model="vm.chargedService.chargeableItem" name="rrForChargeableItem" id="field_rr_for_chargeableItem" ng-change="vm.setDefaultPrice()" theme="bootstrap" ng-required="vm.chargedService.paymentType === \'HOTEL\'"><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.chargeableItemName"></span></ui-select-match><ui-select-choices repeat="rr in (vm.roomReservations | filter: $select.search) track by rr.id"><div ng-bind-html="rr.chargeableItemName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.chargeableItem.$invalid"><p class="error-block" ng-show="editForm.rrForChargeableItem.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ng-show="vm.chargedService.paymentType === \'OPTIONAL_SERVICE\'"><label translate="pcsApp.chargedService.chargeableItem" for="field_oos_for_chargeableItem">Chargeable item</label><ui-select ng-model="vm.chargedService.chargeableItem" name="oosForChargeableItem" id="field_oos_for_chargeableItem" ng-change="vm.setDefaultPrice()" theme="bootstrap" ng-required="vm.chargedService.paymentType === \'OPTIONAL_SERVICE\'"><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.chargeableItemName"></span></ui-select-match><ui-select-choices repeat="orderedOptionalService in (vm.orderedOptionalServices | filter: $select.search) track by orderedOptionalService.id"><div ng-bind-html="orderedOptionalService.chargeableItemName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.oosForChargeableItem.$invalid"><p class="error-block" ng-show="editForm.chargeableItem.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.chargedService.dateOfPayment" for="field_dateOfPayment">Date Of Payment</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateOfPayment\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_dateOfPayment" type="text" class="form-control" autocomplete="off" name="dateOfPayment" uib-datepicker-popup="{{dateformat}}" ng-model="vm.chargedService.dateOfPayment" is-open="vm.datePickerOpenStatus.dateOfPayment" required></div><div ng-show="editForm.dateOfPayment.$invalid"><p class="error-block" ng-show="editForm.dateOfPayment.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.chargedService.amount" for="field_amount">Amount</label><input type="number" class="form-control" name="amount" id="field_amount" autocomplete="off" ng-model="vm.chargedService.amount" required min="-1000000" max="1000000"><div ng-show="editForm.amount.$invalid"><p class="error-block" ng-show="editForm.amount.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.amount.$error.min" data-translate="entity.validation.min" translate-value-min="-1000000">This field should be more than -1000000.</p><p class="error-block" ng-show="editForm.amount.$error.max" data-translate="entity.validation.max" translate-value-max="1000000">This field cannot be more than 1000000.</p><p class="error-block" ng-show="editForm.amount.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group" ng-show="vm.chargedService.paymentMode === \'CARD\'"><label class="control-label" data-translate="pcsApp.chargedService.cardType" for="field_cardType">Card Type</label><select class="form-control" name="cardType" ng-model="vm.chargedService.cardType" id="field_cardType"><option value="" data-translate="global.form.please.select">Please select</option><option value="VISA">VISA</option><option value="EC/MC">EC/MC</option><option value="AMEX">AMEX</option></select><div ng-show="editForm.cardType.$invalid"><p class="error-block" ng-show="editForm.cardType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ng-show="vm.chargedService.paymentMode === \'CARD\'"><label class="control-label" data-translate="pcsApp.chargedService.cardNumber" for="field_cardNumber">Card Number</label><input type="text" class="form-control" name="cardNumber" id="field_cardNumber" autocomplete="off" ng-model="vm.chargedService.cardNumber" ng-maxlength="50"><div ng-show="editForm.cardNumber.$invalid"><p class="error-block" ng-show="editForm.cardNumber.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group" ng-show="vm.chargedService.paymentMode === \'CARD\'"><label class="control-label" data-translate="pcsApp.chargedService.cardExpirationDate" for="field_cardExpirationDate">Card Expiration Date</label><input type="text" class="form-control" name="cardExpirationDate" id="field_cardExpirationDate" ng-model="vm.chargedService.cardExpirationDate" autocomplete="off" ng-maxlength="8"><div ng-show="editForm.cardExpirationDate.$invalid"><p class="error-block" ng-show="editForm.cardExpirationDate.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="8">This field cannot be longer than 8 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.chargedService.transactionId" for="field_transactionId">Transaction Id</label><input type="text" class="form-control" name="transactionId" id="field_transactionId" ng-model="vm.chargedService.transactionId" autocomplete="off" ng-maxlength="50"><div ng-show="editForm.transactionId.$invalid"><p class="error-block" ng-show="editForm.transactionId.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" translate="pcsApp.chargedService.comment" for="field_comment">Comment</label><textarea class="form-control" name="comment" id="field_comment" rows="3" autocomplete="off" ng-model="vm.chargedService.comment" ng-maxlength="1024">\n            </textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/company/company-dialog.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 translate="pcsApp.company.home.title">Settings of the Company profil</h2></div><div class="col-lg-2"></div></div><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins" ng-show="false"><div class="form-group alert alert-success"><span translate="pcsApp.company.message.success"><strong>Company profile settings has been saved!</strong></span></div></div><div class="ibox float-e-margins" ng-show="vm.error"><div class="form-group alert alert-danger"><span translate="pcsApp.company.message.error"><strong>An error has occurred!</strong> Settings could not be saved!</span></div></div><div class="ibox float-e-margins"><div class="ibox-content"><form name="editForm" role="form" novalidate ng-submit="vm.save()" class="form-horizontal" show-validation><div class="form-group"><label class="col-sm-2 control-label" translate="pcsApp.company.name" for="field_name">Name</label><div class="col-sm-10"><input type="text" class="form-control" name="name" id="field_name" autocomplete="off" ng-model="vm.company.name" required ng-minlength="5" ng-maxlength="255"><div ng-show="editForm.name.$invalid"><span class="help-block m-b-none" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required. </span><span class="help-block m-b-none" ng-show="editForm.name.$error.minlength" translate="entity.validation.minlength" translate-value-min="5">This field is required to be at least 5 characters. </span><span class="help-block m-b-none" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</span></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><label class="col-sm-2 control-label" translate="pcsApp.company.name2" for="field_name2">Name2</label><div class="col-sm-10"><input type="text" class="form-control" name="name2" id="field_name2" autocomplete="off" ng-model="vm.company.name2" ng-maxlength="255"><div ng-show="editForm.name2.$invalid"><span class="help-block m-b-none" ng-show="editForm.name2.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</span></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><label class="col-sm-2 control-label" translate="pcsApp.company.countryCode" for="field_countryCode">Country code</label><div class="col-sm-10"><input type="text" class="form-control" name="countryCode" id="field_countryCode" autocomplete="off" ng-model="vm.company.countryCode" required ng-maxlength="2"><div ng-show="editForm.countryCode.$invalid"><span class="help-block m-b-none" ng-show="editForm.countryCode.$error.required" translate="entity.validation.required">This field is required. </span><span class="help-block m-b-none" ng-show="editForm.countryCode.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="2">This field cannot be longer than 2 characters.</span></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><label class="col-sm-2 control-label" translate="pcsApp.company.zipCode" for="field_zipCode">Zip code</label><div class="col-sm-10"><input type="text" class="form-control" name="zipCode" id="field_zipCode" autocomplete="off" ng-model="vm.company.zipCode" required ng-maxlength="10"><div ng-show="editForm.zipCode.$invalid"><span class="help-block m-b-none" ng-show="editForm.zipCode.$error.required" translate="entity.validation.required">This field is required. </span><span class="help-block m-b-none" ng-show="editForm.zipCode.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="10">This field cannot be longer than 10 characters.</span></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><label class="col-sm-2 control-label" translate="pcsApp.company.city" for="field_city">City</label><div class="col-sm-10"><input type="text" class="form-control" name="city" id="field_city" autocomplete="off" ng-model="vm.company.city" required ng-maxlength="100"><div ng-show="editForm.city.$invalid"><span class="help-block m-b-none" ng-show="editForm.city.$error.required" translate="entity.validation.required">This field is required. </span><span class="help-block m-b-none" ng-show="editForm.city.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</span></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><label class="col-sm-2 control-label" translate="pcsApp.company.streetName" for="field_streetName">Street</label><div class="col-sm-10"><input type="text" class="form-control" name="streetName" id="field_streetName" autocomplete="off" ng-model="vm.company.streetName" required ng-maxlength="250"><div ng-show="editForm.streetName.$invalid"><span class="help-block m-b-none" ng-show="editForm.streetName.$error.required" translate="entity.validation.required">This field is required. </span><span class="help-block m-b-none" ng-show="editForm.streetName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="250">This field cannot be longer than 250 characters.</span></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><label class="col-sm-2 control-label" translate="pcsApp.company.publicPlaceCategory" for="field_publicPlaceCategory">Public place category</label><div class="col-sm-10"><input type="text" class="form-control" name="publicPlaceCategory" id="field_publicPlaceCategory" autocomplete="off" ng-model="vm.company.publicPlaceCategory" required ng-maxlength="100"><div ng-show="editForm.publicPlaceCategory.$invalid"><span class="help-block m-b-none" ng-show="editForm.publicPlaceCategory.$error.required" translate="entity.validation.required">This field is required. </span><span class="help-block m-b-none" ng-show="editForm.publicPlaceCategory.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</span></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><label class="col-sm-2 control-label" translate="pcsApp.company.number" for="field_number">Number</label><div class="col-sm-10"><input type="text" class="form-control" name="number" id="field_number" autocomplete="off" ng-model="vm.company.number" required ng-maxlength="10"><div ng-show="editForm.number.$invalid"><span class="help-block m-b-none" ng-show="editForm.number.$error.required" translate="entity.validation.required">This field is required. </span><span class="help-block m-b-none" ng-show="editForm.number.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="10">This field cannot be longer than 10 characters.</span></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><label class="col-sm-2 control-label" translate="pcsApp.company.building" for="field_building">Building</label><div class="col-sm-10"><input type="text" class="form-control" name="building" id="field_building" autocomplete="off" ng-model="vm.company.building" ng-maxlength="10"><div ng-show="editForm.building.$invalid"><span class="help-block m-b-none" ng-show="editForm.building.$error.required" translate="entity.validation.required">This field is required. </span><span class="help-block m-b-none" ng-show="editForm.building.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="10">This field cannot be longer than 10 characters.</span></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><label class="col-sm-2 control-label" translate="pcsApp.company.staircase" for="field_staircase">Staircase</label><div class="col-sm-10"><input type="text" class="form-control" name="staircase" id="field_staircase" autocomplete="off" ng-model="vm.company.staircase" ng-maxlength="10"><div ng-show="editForm.staircase.$invalid"><span class="help-block m-b-none" ng-show="editForm.staircase.$error.required" translate="entity.validation.required">This field is required. </span><span class="help-block m-b-none" ng-show="editForm.staircase.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="10">This field cannot be longer than 10 characters.</span></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><label class="col-sm-2 control-label" translate="pcsApp.company.floor" for="field_floor">Floor</label><div class="col-sm-10"><input type="text" class="form-control" name="floor" id="field_floor" autocomplete="off" ng-model="vm.company.floor" ng-maxlength="10"><div ng-show="editForm.floor.$invalid"><span class="help-block m-b-none" ng-show="editForm.floor.$error.required" translate="entity.validation.required">This field is required. </span><span class="help-block m-b-none" ng-show="editForm.floor.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="10">This field cannot be longer than 10 characters.</span></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><label class="col-sm-2 control-label" translate="pcsApp.company.door" for="field_door">Door</label><div class="col-sm-10"><input type="text" class="form-control" name="door" id="field_door" autocomplete="off" ng-model="vm.company.door" ng-maxlength="10"><div ng-show="editForm.door.$invalid"><span class="help-block m-b-none" ng-show="editForm.door.$error.required" translate="entity.validation.required">This field is required. </span><span class="help-block m-b-none" ng-show="editForm.door.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="10">This field cannot be longer than 10 characters.</span></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><label class="col-sm-2 control-label" translate="pcsApp.company.address2" for="field_address2">Address2</label><div class="col-sm-10"><input type="text" class="form-control" name="address2" id="field_address2" autocomplete="off" ng-model="vm.company.address2" ng-maxlength="255"><div ng-show="editForm.address2.$invalid"><span class="help-block m-b-none" ng-show="editForm.address2.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</span></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><label class="col-sm-2 control-label" translate="pcsApp.company.taxNumber" for="field_taxNumber">TaxNumber</label><div class="col-sm-10"><input type="text" class="form-control" name="taxNumber" id="field_taxNumber" autocomplete="off" ng-model="vm.company.taxNumber" ng-pattern="/^[0-9]{8}[-][0-5]{1}[-][0-9]{2}$/" required ng-maxlength="64"><div ng-show="editForm.taxNumber.$invalid"><span class="help-block m-b-none" ng-show="editForm.taxNumber.$error.required" translate="entity.validation.required">This field is required. </span><span class="help-block m-b-none" ng-show="editForm.taxNumber.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</span><p class="error-block" ng-show="editForm.taxNumber.$error.pattern" data-translate="entity.validation.pattern" data-translate-values="{ pattern: \'12345678-2-42\' }">Ez a mez\u0151 csak sz\xE1mokat tartalmazhat pl.: 36703125678</p></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><label class="col-sm-2 control-label" translate="pcsApp.company.euTaxNumber" for="field_euTaxNumber">EuTaxNumber</label><div class="col-sm-10"><input type="text" class="form-control" name="euTaxNumber" id="field_euTaxNumber" autocomplete="off" ng-model="vm.company.euTaxNumber" ng-maxlength="64"><div ng-show="editForm.euTaxNumber.$invalid"><span class="help-block m-b-none" ng-show="editForm.euTaxNumber.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</span></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><label class="col-sm-2 control-label" translate="pcsApp.company.phone" for="field_phone">Phone</label><div class="col-sm-10"><input type="text" class="form-control" name="phone" id="field_phone" autocomplete="off" required ng-model="vm.company.phone" ng-maxlength="64"><div ng-show="editForm.phone.$invalid"><span class="help-block m-b-none" ng-show="editForm.phone.$error.required" translate="entity.validation.required">This field is required. </span><span class="help-block m-b-none" ng-show="editForm.phone.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</span></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><label class="col-sm-2 control-label" translate="pcsApp.company.fax" for="field_fax">Fax</label><div class="col-sm-10"><input type="text" class="form-control" name="fax" id="field_fax" autocomplete="off" ng-model="vm.company.fax" ng-maxlength="64"><div ng-show="editForm.fax.$invalid"><span class="help-block m-b-none" ng-show="editForm.fax.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</span></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><label class="col-sm-2 control-label" translate="pcsApp.company.licenceNumber" for="field_licenceNumber">LicenceNumber</label><div class="col-sm-10"><input type="text" class="form-control" name="licenceNumber" id="field_licenceNumber" autocomplete="off" required ng-model="vm.company.licenceNumber"><div ng-show="editForm.licenceNumber.$invalid"><span class="help-block m-b-none" ng-show="editForm.licenceNumber.$error.required" translate="entity.validation.required">This field is required.</span></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><label class="col-sm-2 control-label" translate="pcsApp.company.invoiceNumberPrefix" for="field_invoiceNumberPrefix">InvoiceNumberPrefix</label><div class="col-sm-10"><input type="text" class="form-control" name="invoiceNumberPrefix" id="field_invoiceNumberPrefix" autocomplete="off" ng-model="vm.company.invoiceNumberPrefix" required ng-maxlength="64"><div ng-show="editForm.invoiceNumberPrefix.$invalid"><span class="help-block m-b-none" ng-show="editForm.invoiceNumberPrefix.$error.required" translate="entity.validation.required">This field is required. </span><span class="help-block m-b-none" ng-show="editForm.invoiceNumberPrefix.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</span></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><label class="col-sm-2 control-label" translate="pcsApp.company.invoiceNumber" for="field_invoiceNumber">InvoiceNumber</label><div class="col-sm-10"><input type="number" class="form-control" name="invoiceNumber" disabled="disabled" id="field_invoiceNumber" autocomplete="off" ng-model="vm.company.invoiceNumber" required><div ng-show="editForm.invoiceNumber.$invalid"><span class="help-block m-b-none" ng-show="editForm.invoiceNumber.$error.required" translate="entity.validation.required">This field is required. </span><span class="help-block m-b-none" ng-show="editForm.invoiceNumber.$error.number" translate="entity.validation.number">This field should be a number.</span></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><label class="col-sm-2 control-label" translate="pcsApp.company.proFormaInvoiceNumber" for="field_proFormaInvoiceNumber">Proforma InvoiceNumber</label><div class="col-sm-10"><input type="number" class="form-control" name="proFormaInvoiceNumber" disabled="disabled" id="field_proFormaInvoiceNumber" autocomplete="off" ng-model="vm.company.proFormaInvoiceNumber" required><div ng-show="editForm.proFormaInvoiceNumber.$invalid"><span class="help-block m-b-none" ng-show="editForm.proFormaInvoiceNumber.$error.required" translate="entity.validation.required">This field is required. </span><span class="help-block m-b-none" ng-show="editForm.proFormaInvoiceNumber.$error.number" translate="entity.validation.number">This field should be a number.</span></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><div class="col-sm-4 col-sm-offset-2"><button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/confirmation/confirmation.html','<div class="row wrapper border-bottom white-bg page-heading"><div style="padding-left: 15px"><h2 translate="pcsApp.registration.confirmation.title" translate-values="{name: \'{{vm.registration.lastName + \', \' + vm.registration.firstName}}\'}">Confirmation management of {{vm.registration.lastName + \', \' + vm.registration.firstName}}</h2></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="col-lg-6 no-padding-left"><div class="ibox" ng-show="!vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.confirmation.confirmationTitleType\' | translate}}</strong></div><div class="ibox-content"><div><label><input ng-model="vm.confirmationTitleType" value="CONFIRMATION" id="titleTypeConfirmation" name="titleType" type="radio"> Confirmation</label></div><div><label><input ng-model="vm.confirmationTitleType" value="PRO_FORMA_INVOICE" id="titleTypeProFormaInvoice" name="titleType" type="radio"> Pro forma invoice</label></div></div></div></div><div class="col-lg-6 no-padding-right"><div class="ibox" ng-show="!vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.confirmation.language\' | translate}}</strong></div><div class="ibox-content"><div><label><input ng-model="vm.language" value="hu" id="languageHu" name="language" type="radio"> Hungarian</label></div><div><label><input ng-model="vm.language" value="en" id="languageEn" name="language" type="radio"> English</label></div><div><label><input ng-model="vm.language" value="es" id="languageEs" name="language" type="radio"> Spanish</label></div><div><label><input ng-model="vm.language" value="pt" id="languagePt" name="language" type="radio"> Portuguese</label></div></div></div></div><div class="ibox" ng-show="!vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.registrationRegistrationType.home.title\' | translate}}</strong><!--<div ibox-tools></div>--></div><div class="ibox-content"><table id="registration-type-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.registrationRegistrationType.registrationType">Registration Type</span></th><th><span translate="pcsApp.registrationRegistrationType.accPeople">Acc People</span></th><th><span translate="pcsApp.registrationRegistrationType.regFee">Price</span></th><th><span translate="pcsApp.registration.confirmation.groupPaid">Group paid</span></th><th><span translate="pcsApp.registration.confirmation.priceAlreadyPaid">Price already paid</span></th><th><span translate="pcsApp.registration.confirmation.priceToBePaid">Price to be paid</span></th><th><span translate="pcsApp.registration.confirmation.ignore">Ignore</span></th></tr></thead><tbody><tr ng-repeat="rrt in vm.registrationRegistrationTypes track by rrt.id"><td>{{rrt.registrationTypeName}}</td><td>{{rrt.accPeople}}</td><td>{{rrt.chargeableItemPrice + \' \' + rrt.chargeableItemCurrency}}</td><td>{{vm.getGroupPaid(rrt) + \' \' + rrt.chargeableItemCurrency}}</td><td>{{vm.getPriceAlreadyPaid(rrt.id) + \' \' + rrt.chargeableItemCurrency}}</td><td>{{vm.getPriceToBePaid(rrt.priceWithDiscount, rrt.id) + \' \' + rrt.chargeableItemCurrency}}</td><td><input ng-model="vm.ignoredChargeableItems[rrt.id.toString()]" ng-change="vm.toggleIgnoreChargeableItem(rrt.id)" type="checkbox"></td></tr><tr ng-show="vm.registrationRegistrationTypes.length"><td colspan="2">&nbsp;</td><td><strong>{{ (vm.registrationRegistrationTypes | sumByKey: \'chargeableItemPrice\') + \' \' + vm.registrationRegistrationTypes[0].chargeableItemCurrency }}</strong></td><td><strong>{{ vm.sumGroupAlreadyPaid(vm.registrationRegistrationTypes) + \' \' + vm.registrationRegistrationTypes[0].chargeableItemCurrency }}</strong></td><td><strong>{{ vm.sumPriceAlreadyPaid(vm.registrationRegistrationTypes) + \' \' + vm.registrationRegistrationTypes[0].chargeableItemCurrency }}</strong></td><td><strong>{{ vm.sumPriceToBePaid(vm.registrationRegistrationTypes) + \' \' + vm.registrationRegistrationTypes[0].chargeableItemCurrency }}</strong></td><td></td></tr></tbody></table></div></div><div class="ibox" ng-show="!vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.roomReservation.home.title\' | translate}}</strong><!--<div ibox-tools></div>--></div><div class="ibox-content"><table id="room-reservation-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.roomReservation.id">Res #</span></th><th><span translate="pcsApp.roomReservation.room">Room type</span></th><th><span translate="pcsApp.roomReservation.hotel">Hotel</span></th><th><span translate="pcsApp.roomReservation.shared">Shared</span></th><th><span translate="pcsApp.roomReservation.arrivalDate">Arrival Date</span></th><th><span translate="pcsApp.roomReservation.departureDate">Departure Date</span></th><th><span translate="pcsApp.roomReservation.price">Price</span></th><th><span translate="pcsApp.registration.confirmation.groupPaid">Group paid</span></th><th><span translate="pcsApp.registration.confirmation.priceAlreadyPaid">Price already paid</span></th><th><span translate="pcsApp.registration.confirmation.priceToBePaid">Price to be paid</span></th><th><span translate="pcsApp.registration.confirmation.ignore">Ignore</span></th></tr></thead><tbody><tr ng-repeat="rr in vm.roomReservations track by rr.id"><td>{{rr.id}}</td><td>{{rr.roomType}}</td><td>{{rr.hotelName}}</td><td>{{rr.shared}}</td><td>{{rr.arrivalDate | date:\'mediumDate\'}}</td><td>{{rr.departureDate | date:\'mediumDate\'}}</td><td>{{rr.chargeableItemPrice + \' \' + rr.chargeableItemCurrency}}</td><td>{{vm.getGroupPaid(rr) + \' \' + rr.chargeableItemCurrency}}</td><td>{{vm.getPriceAlreadyPaid(rr.id) + \' \' + rr.chargeableItemCurrency}}</td><td>{{vm.getPriceToBePaid(rr.priceWithDiscount, rr.id) + \' \' + rr.chargeableItemCurrency}}</td><td><input ng-model="vm.ignoredChargeableItems[rr.id.toString()]" ng-change="vm.toggleIgnoreChargeableItem(rr.id)" type="checkbox"></td></tr><tr ng-show="vm.roomReservations.length"><td colspan="6">&nbsp;</td><td><strong>{{ (vm.roomReservations | sumByKey: \'chargeableItemPrice\') + \' \' + vm.roomReservations[0].chargeableItemCurrency }}</strong></td><td><strong>{{ vm.sumGroupAlreadyPaid(vm.roomReservations) + \' \' + vm.roomReservations[0].chargeableItemCurrency }}</strong></td><td><strong>{{ vm.sumPriceAlreadyPaid(vm.roomReservations) + \' \' + vm.roomReservations[0].chargeableItemCurrency }}</strong></td><td><strong>{{ vm.sumPriceToBePaid(vm.roomReservations) + \' \' + vm.roomReservations[0].chargeableItemCurrency }}</strong></td><td></td></tr></tbody></table></div></div><div class="ibox" ng-show="!vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.orderedOptionalService.home.title\' | translate}}</strong><!--<div ibox-tools></div>--></div><div class="ibox-content"><table id="optional-service-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.orderedOptionalService.optionalService">Optional Service</span></th><th><span translate="pcsApp.orderedOptionalService.participant">Participant</span></th><th><span translate="pcsApp.orderedOptionalService.price">Price</span></th><th><span translate="pcsApp.registration.confirmation.groupPaid">Group paid</span></th><th><span translate="pcsApp.registration.confirmation.priceAlreadyPaid">Price already paid</span></th><th><span translate="pcsApp.registration.confirmation.priceToBePaid">Price to be paid</span></th><th><span translate="pcsApp.registration.confirmation.ignore">Ignore</span></th></tr></thead><tbody><tr ng-repeat="oos in vm.orderedOptionalServices track by oos.id"><td>{{oos.chargeableItemName}}</td><td>{{oos.participant}}</td><td>{{oos.chargeableItemPrice + \' \' + oos.chargeableItemCurrency}}</td><td>{{vm.getGroupPaid(oos) + \' \' + oos.chargeableItemCurrency}}</td><td>{{vm.getPriceAlreadyPaid(oos.id) + \' \' + oos.chargeableItemCurrency}}</td><td>{{vm.getPriceToBePaid(oos.priceWithDiscount, oos.id) + \' \' + oos.chargeableItemCurrency}}</td><td><input ng-model="vm.ignoredChargeableItems[oos.id.toString()]" ng-change="vm.toggleIgnoreChargeableItem(oos.id)" type="checkbox"></td></tr><tr ng-show="vm.orderedOptionalServices.length"><td colspan="2">&nbsp;</td><td><strong>{{ (vm.orderedOptionalServices | sumByKey: \'chargeableItemPrice\') + \' \' + vm.orderedOptionalServices[0].chargeableItemCurrency }}</strong></td><td><strong>{{ vm.sumGroupAlreadyPaid(vm.orderedOptionalServices) + \' \' + vm.orderedOptionalServices[0].chargeableItemCurrency }}</strong></td><td><strong>{{ vm.sumPriceAlreadyPaid(vm.orderedOptionalServices) + \' \' + vm.orderedOptionalServices[0].chargeableItemCurrency }}</strong></td><td><strong>{{ vm.sumPriceToBePaid(vm.orderedOptionalServices) + \' \' + vm.orderedOptionalServices[0].chargeableItemCurrency }}</strong></td><td></td></tr></tbody></table></div></div><div class="ibox" ng-show="!vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.chargedService.home.title\' | translate}}</strong><!--<div ibox-tools></div>--></div><div class="ibox-content"><table id="charged-service-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.chargedService.paymentMode">Payment mode</span></th><th><span translate="pcsApp.chargedService.paymentType">Payment type</span></th><th><span translate="pcsApp.chargedService.chargeableItem">Chargeable item</span></th><th><span translate="pcsApp.chargedService.amount">Amount</span></th><th><span translate="pcsApp.chargedService.dateOfPayment">Date of Payment</span></th><th><span translate="pcsApp.chargedService.invoiceNumber">Invoice number</span></th><th><span translate="pcsApp.registration.confirmation.ignore">Ignore</span></th></tr></thead><tbody><tr ng-repeat="chargedService in vm.chargedServices track by chargedService.id"><td><span translate="pcsApp.ChargedServicePaymentMode.{{chargedService.paymentMode}}">{{chargedService.paymentMode}}</span></td><td><span translate="pcsApp.ChargeableItemType.{{chargedService.paymentType}}">{{chargedService.paymentType}}</span></td><td>{{chargedService.chargeableItem.chargeableItemName}}</td><td>{{chargedService.amount | number : 2}} {{chargedService.chargeableItem.chargeableItemCurrency}}</td><td>{{chargedService.dateOfPayment | date:\'mediumDate\'}}</td><td>{{chargedService.invoiceNumber}}</td><td><input ng-model="vm.ignoredChargedServices[chargedService.id.toString()]" ng-checked="vm.ignoredChargedServices[chargedService.id.toString()]" ng-change="vm.toggleIgnoreChargedService(chargedService.id)" type="checkbox"></td></tr><tr ng-show="vm.chargedServices.length"><td colspan="3">&nbsp;</td><td><strong>{{(vm.chargedServices | sumByKey: \'amount\') | number : 2}} {{vm.chargedServices[0].chargeableItem.chargeableItemCurrency}}</strong></td><td colspan="2">&nbsp;</td><td></td></tr></tbody></table></div></div><div class="ibox" ng-show="!vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.confirmation.totalDue\' | translate}}: {{vm.calculateTotalDue() | number : 2}}</strong></div></div><div class="ibox" ng-show="!vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.registration.optionalText.title\' | translate}}:</strong><div class="input-group m-b"><span class="input-group-btn"><button class="btn btn-primary" type="submit" ui-sref="confirmation.optional-text-new"><i class="fa fa-plus"></i></button></span><ui-select ng-model="vm.selectedOptionalText" ng-change="vm.setOptionalTextMessage($select.selected.optionalText)" name="optionalTextSelector" id="field_optionalTextSelector" theme="bootstrap"><ui-select-match allow-clear="true" placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="optionalText in (vm.optionalTexts | filter: $select.search) track by optionalText.id"><div ng-bind-html="optionalText.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><!--<div ibox-tools></div>--></div><div class="ibox-content"><div class="text-center"><textarea class="form-control" name="optionalText" id="field_optionalText" rows="5" autocomplete="off" ng-model="vm.optionalText">\n                        </textarea></div></div></div><form name="editForm" role="form" novalidate ng-submit="vm.sendAndPrintConfirmation()" show-validation><div class="ibox" ng-show="vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.registration.confirmation.email\' | translate}}:</strong><div class="input-group m-b"><input class="form-control" name="confirmationEmail" ng-minlength="5" ng-maxlength="255" ng-model="vm.confirmationEmail" type="email" required> <span class="input-group-btn"><button type="submit" class="btn btn-primary"><span translate="entity.action.send">Send</span></button> <button type="button" ng-click="vm.isShowConfirmationPanel = false;" class="btn btn-default"><span translate="entity.action.cancel">Cancel</span></button></span></div><div ng-show="editForm.confirmationEmail.$invalid"><p class="error-block" ng-show="editForm.confirmationEmail.$error.required" translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.confirmationEmail.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="error-block" ng-show="editForm.confirmationEmail.$error.minlength" translate="entity.validation.minlength" translate-value-min="5">This field is required to be at least 5 characters.</p><p class="error-block" ng-show="editForm.confirmationEmail.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div></div></form><div class="ibox" ng-show="!vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><button type="button" ng-click="vm.showConfirmationPanel()" ng-disabled="vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="pcsApp.registration.confirmation.sendConfirmationByMail">Send confirmation by mail</span></button> <button type="button" ng-click="vm.printConfirmation()" ng-disabled="vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-print"></span>&nbsp;<span translate="pcsApp.registration.confirmation.printConfirmation">Print confirmation</span></button> <button type="button" class="btn btn-default" ui-sref="registration({id: registration.id})"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></div></div></div></div>');
$templateCache.put('app/entities/congress/congress-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.congress.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.congress.delete.question" translate-values="{id: \'{{vm.congress.id}}\'}">Are you sure you want to delete this Congress?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/congress/congress-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCongressLabel" data-translate="pcsApp.congress.home.createOrEditLabel">Create or edit a Congress</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="pcsApp.congress.meetingCode" for="field_meetingCode">Meeting Code</label><input type="text" class="form-control" name="meetingCode" id="field_meetingCode" autocomplete="off" ng-model="vm.congress.meetingCode" required ng-minlength="3" ng-maxlength="15"><div ng-show="editForm.meetingCode.$invalid"><p class="error-block" ng-show="editForm.meetingCode.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.meetingCode.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 3 characters.</p><p class="error-block" ng-show="editForm.meetingCode.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="15">This field cannot be longer than 15 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.congress.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" autocomplete="off" ng-model="vm.congress.name" required ng-maxlength="100"><div ng-show="editForm.name.$invalid"><p class="error-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.congress.startDate" for="field_startDate">Start Date</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_startDate" type="text" class="form-control" name="startDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.congress.startDate" is-open="vm.datePickerOpenStatus.startDate" ng-change="vm.setCongressEndDate()" required></div><div ng-show="editForm.startDate.$invalid"><p class="error-block" ng-show="editForm.startDate.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.congress.endDate" for="field_endDate">End Date</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_endDate" type="text" class="form-control" name="endDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.congress.endDate" is-open="vm.datePickerOpenStatus.endDate" date-less-than="{{vm.congress.startDate}}" required></div><div ng-show="editForm.endDate.$invalid"><p class="error-block" ng-show="editForm.endDate.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.endDate.$error.dateLessThan" translate="pcsApp.congress.message.endDateLessThanStartDate">End date must be later than Start date.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.congress.contactPerson" for="field_contactPerson">Contact Person</label><input type="text" class="form-control" name="contactPerson" id="field_contactPerson" autocomplete="off" ng-model="vm.congress.contactPerson" ng-maxlength="128" required><div ng-show="editForm.contactPerson.$invalid"><p class="error-block" ng-show="editForm.contactPerson.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.contactPerson.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="128">This field cannot be longer than 128 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.congress.contactEmail" for="field_contactEmail">Contact Email</label><input type="email" class="form-control" name="contactEmail" id="field_contactEmail" autocomplete="off" ng-model="vm.congress.contactEmail" ng-maxlength="64" required><div ng-show="editForm.contactEmail.$invalid"><p class="error-block" ng-show="editForm.contactEmail.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.contactEmail.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p><p class="error-block" ng-show="editForm.contactEmail.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.congress.programNumber" for="field_programNumber">Program Number</label><input type="text" class="form-control" name="programNumber" id="field_programNumber" autocomplete="off" required ng-model="vm.congress.programNumber" ng-maxlength="64"><div ng-show="editForm.programNumber.$invalid"><p class="error-block" ng-show="editForm.programNumber.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.programNumber.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.congress.website" for="field_website">Website</label><input type="text" class="form-control" name="website" id="field_website" autocomplete="off" ng-model="vm.congress.website" ng-maxlength="1000"><div ng-show="editForm.website.$invalid"><p class="error-block" ng-show="editForm.website.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 1000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.congress.additionalBillingTextHu" for="field_additionalBillingTextHu">Additional Billing Text Hu</label><input type="text" class="form-control" name="additionalBillingTextHu" id="field_additionalBillingTextHu" autocomplete="off" ng-model="vm.congress.additionalBillingTextHu" ng-maxlength="1000"><div ng-show="editForm.additionalBillingTextHu.$invalid"><p class="error-block" ng-show="editForm.additionalBillingTextHu.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 1000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.congress.additionalBillingTextEn" for="field_additionalBillingTextEn">Additional Billing Text En</label><input type="text" class="form-control" name="additionalBillingTextEn" id="field_additionalBillingTextEn" autocomplete="off" ng-model="vm.congress.additionalBillingTextEn" ng-maxlength="1000"><div ng-show="editForm.additionalBillingTextEn.$invalid"><p class="error-block" ng-show="editForm.additionalBillingTextEn.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 1000 characters.</p></div></div><div class="form-group"><label translate="pcsApp.congress.defaultCountry" for="field_defaultCountry">Default Country</label><ui-select ng-model="vm.congress.defaultCountry" name="defaultCountry" id="field_defaultCountry" theme="bootstrap"><ui-select-match allow-clear="true" placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="country in (vm.countries | filter: $select.search) track by country.id"><div ng-bind-html="country.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="form-group"><label translate="pcsApp.congress.currencies" for="field_currencies">Currencies</label><ui-select multiple="multiple" ng-model="vm.congress.currencies" class="form-control" id="field_currencies" name="currencies" theme="bootstrap" required><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}">{{$item.currency}}</ui-select-match><ui-select-choices repeat="currency in vm.currencies | filter: $select.search"><div ng-bind-html="currency.currency | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.currencies.$invalid"><p class="error-block" ng-show="editForm.currencies.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label translate="pcsApp.congress.onlineRegCurrencies" for="field_onlineRegCurrencies">Currencies for online reg</label><ui-select multiple="multiple" ng-model="vm.congress.onlineRegCurrencies" class="form-control" id="field_onlineRegCurrencies" name="onlineRegCurrencies" theme="bootstrap"><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}">{{$item.currency}}</ui-select-match><ui-select-choices repeat="currency in vm.congress.currencies | filter: $select.search"><div ng-bind-html="currency.currency | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="form-group" ng-repeat="currency in vm.congress.currencies"><label data-translate="pcsApp.congress.bankAccounts" data-translate-values="{currency: \'{{currency.currency}}\'}" for="field_bankAccount_{{currency.currency}}">Bank accounts for {{currency.currency}}</label><ui-select ng-model="vm.bankAccountByCurrency[currency.currency]" name="bankAccount_{{currency.currency}}" id="field_bankAccount_{{currency.currency}}" theme="bootstrap" required><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="bankAccount in (vm.bankaccounts | filter: currency.currency | filter: $select.search) track by bankAccount.id"><div ng-bind-html="bankAccount.name | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.bankAccount_{{currency.currency}}.$invalid"><p class="error-block" ng-show="editForm.bankAccount_{{currency.currency}}.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ng-if="!vm.congress.id"><label translate="pcsApp.congress.congressFromCopyWp" for="field_defaultCountry">Default Country</label><ui-select ng-model="vm.congressFromCopyWp" name="congressFromCopyWp" id="field_congressFromCopyWp" theme="bootstrap"><ui-select-match allow-clear="true" placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="congress in (vm.congresses | filter: $select.search) track by congress.id"><div ng-bind-html="congress.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="form-group" ng-if="vm.congress.id"><label translate="pcsApp.congress.archive" for="field_archive">Archive</label><div class="checkbox" style="margin-top: 0px; margin-bottom: 0px"><input type="checkbox" ng-model="vm.congress.archive" id="field_archive" name="archive"><label style="cursor: default"></label></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/congress/congresses.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 translate="pcsApp.congress.home.title">Congresses</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-primary" type="submit" ui-sref="congress.new"><i class="fa fa-plus"></i></button><!--<div ibox-tools></div>--></div><div class="ibox-content"><table datatable="ng" id="congress-datatable" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="global.field.id">ID</span></th><th><span translate="pcsApp.congress.meetingCode">MeetingCode</span></th><th><span translate="pcsApp.congress.name">Name</span></th><th><span translate="pcsApp.congress.startDate">StartDate</span></th><th><span translate="pcsApp.congress.endDate">EndDate</span></th><th><span translate="pcsApp.congress.contactPerson">ContactPerson</span></th><th><span translate="pcsApp.congress.contactEmail">ContactEmail</span></th><th><span translate="pcsApp.congress.archive">Archive</span></th><th class="online-reg-buttons"></th><th></th></tr></thead><tbody><tr ng-repeat="congress in vm.congresses track by congress.id"><td>{{congress.id}}</td><td>{{congress.meetingCode}}</td><td>{{congress.name}} {{ congress.migratedFromCongressCode != null ? \' (migrated from: \' + congress.migratedFromCongressCode + \')\' : \'\'}}</td><td>{{congress.startDate | date:\'mediumDate\'}}</td><td>{{congress.endDate | date:\'mediumDate\'}}</td><td>{{congress.contactPerson}}</td><td>{{congress.contactEmail}}</td><td>{{congress.archive}}</td><td class="online-reg-buttons"><div ng-show="congress.onlineRegCurrencies.length"><select class="form-control" id="field_onlineRegCurrencies_{{congress.id}}" name="onlineRegCurrencies_{{congress.id}}" theme="bootstrap"><option ng-repeat="currency in congress.onlineRegCurrencies track by currency.id">{{currency.currency}}</option></select><select class="form-control" id="field_onlineRegLanguage_{{congress.id}}" name="onlineRegLanguage_{{congress.id}}" theme="bootstrap"><option value="hu">hu</option><option value="en">en</option><option value="es">es</option><option value="pt">pt</option></select><button type="submit" class="btn btn-info" tooltip-placement="top" uib-tooltip="Open online reg" ng-click="vm.openOnlineReg(congress.uuid, vm.getValue(\'field_onlineRegCurrencies_\' + congress.id), vm.getValue(\'field_onlineRegLanguage_\' + congress.id))"><i class="glyphicon glyphicon-eye-open"></i></button><!--\n                                    <button ng-repeat="currency in congress.onlineRegCurrencies track by currency.id" type="submit" class="btn btn-info" ng-class="{\'m-l-xs\': $index > 0}"\n                                            ng-click="vm.openOnlineReg(congress.uuid, currency.currency)" tooltip-placement="top" uib-tooltip="Open online reg for {{currency.currency}}">\n                                        <i class="glyphicon glyphicon-eye-open"></i>\n                                    </button>\n                                    --></div></td><td><button class="btn btn-info" type="submit" tooltip-placement="top" uib-tooltip="Edit congress" ui-sref="congress.edit({id:congress.id})"><i class="fa fa-pencil-square-o"></i></button> <button ng-show="congress.onlineRegCurrencies.length" class="btn btn-info" type="submit" tooltip-placement="top" uib-tooltip="Edit online registration config" ui-sref="congress.online-reg-config({id: congress.id})"><i class="fa fa-child"></i></button> <button ng-show="congress.onlineRegCurrencies.length" class="btn btn-info" type="submit" tooltip-placement="top" uib-tooltip="Edit online reg custom questions" ui-sref="online-reg-custom-question({congressId: congress.id})"><i class="fa fa-question"></i></button> <button ng-show="congress.onlineRegCurrencies.length" class="btn btn-info" type="submit" tooltip-placement="top" uib-tooltip="Edit online reg discount codes" ui-sref="online-reg-discount-code({congressId: congress.id})"><i class="fa fa-ticket"></i></button> <button class="btn btn-danger" type="submit" tooltip-placement="top" uib-tooltip="Delete congress" ui-sref="congress.delete({id:congress.id})"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/congress/editable-text-value-template.html','<div class="input-group" ng-show="editMode()"><input type="text" class="form-control full-width" ng-model="editableTextValue" autocomplete="off" ng-maxlength="64"> <span class="input-group-btn width-min"><button class="btn btn-primary btn-md" type="button" ng-click="save()"><i class="fa fa-check"></i></button> <button class="btn btn-default btn-md" type="button" ng-click="cancel()"><i class="fa fa-times"></i></button></span></div><span ng-show="!editMode()">{{ editableTextList[editableTextIdx] }}</span>');
$templateCache.put('app/entities/congress/online-reg-config-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" class="form-horizontal" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCongressLabel" data-translate="pcsApp.onlineRegConfig.home.createOrEditLabel">Modify online registration configuration</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="tabs-container"><uib-tabset><uib-tab heading="Online"><div class="panel-body"><div class="form-group"><div class="col-xs-2"><label class="control-label" data-translate="pcsApp.onlineRegConfig.closed">Closed</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="closed" id="field_closed" ng-model="vm.onlineRegConfig.closed" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_closed"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="col-xs-3"><label translate="pcsApp.onlineRegConfig.defaultCountry" for="field_defaultCountry">Default Country</label><ui-select ng-model="vm.onlineRegConfig.defaultCountry" name="defaultCountry" id="field_defaultCountry" theme="bootstrap"><ui-select-match allow-clear="true" placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="country in (vm.countries | filter: $select.search) track by country.id"><div ng-bind-html="country.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="form-group col-xs-2"><label class="control-label" data-translate="pcsApp.onlineRegConfig.colorCode">Color code</label><input type="text" class="form-control" name="colorCode" id="field_colorCode" ng-model="vm.onlineRegConfig.colorCode" autocomplete="off" required ng-maxlength="16"><div ng-show="editForm.colorCode.$invalid"><p class="error-block" ng-show="editForm.colorCode.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.colorCode.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="16">This field cannot be longer than 16 characters.</p></div></div><div class="form-group col-xs-5" style="margin-left: 30px"><label class="control-label" data-translate="pcsApp.onlineRegConfig.headerNormal" for="field_headerNormal">Header image</label><div class="input-group"><input type="text" value="{{vm.onlineRegConfig.headerNormalName}} {{vm.onlineRegConfig.headerNormalContentType}} {{vm.byteSize(vm.onlineRegConfig.headerNormalFile)}}" autocomplete="off" class="form-control"> <input type="hidden" class="form-control" name="headerNormal" id="field_headerNormal" ng-change="vm.changeValue()" ng-model="vm.onlineRegConfig.headerNormalFile" maxbytes="2000000"> <span class="input-group-btn"><button type="file" class="btn btn-white" ngf-select ngf-change="vm.setNormalFile($file, vm.onlineRegConfig)" ng-if="!vm.onlineRegConfig.headerNormalFile">Select file</button> <button type="button" class="btn btn-white" ng-if="vm.onlineRegConfig.headerNormalFile" ng-click="vm.clearNormalFile()"><i class="fa fa-trash-o"></i></button> <button type="button" class="btn btn-white" ng-if="vm.onlineRegConfig.headerNormalFile" ng-click="vm.openFile(vm.onlineRegConfig.headerNormalContentType, vm.onlineRegConfig.headerNormalFile)"><i class="fa fa-download"></i></button></span></div><div ng-show="editForm.headerNormal.$invalid"><p class="error-block" ng-show="editForm.headerNormal.$error.maxbytes" translate="entity.validation.maxbytes" translate-value-max="2000000">This field cannot be more than 2000000 bytes.</p></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.noPaymentRequired">No payment required</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="closed" id="field_no_payment_required" ng-change="vm.noPaymentRequiredChanged()" ng-model="vm.onlineRegConfig.noPaymentRequired" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_no_payment_required"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="col-xs-3" ng-hide="vm.onlineRegConfig.noPaymentRequired"><label translate="pcsApp.onlineRegConfig.paymentSupplier" for="field_paymentSupplier">Payment Supplier</label><select class="form-control" name="paymentSupplier" ng-model="vm.onlineRegConfig.paymentSupplier" id="field_paymentSupplier" ng-change="vm.paymentSupplierChanged()" ng-required="!vm.onlineRegConfig.noPaymentRequired"><option value="" data-translate="global.form.please.select">Please select</option><option value="KH" data-translate="pcsApp.PaymentSupplier.KH">KH</option><option value="STRIPE" data-translate="pcsApp.PaymentSupplier.STRIPE">STRIPE</option></select><div ng-show="editForm.paymentSupplier.$invalid"><p class="error-block" ng-show="editForm.paymentSupplier.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="col-xs-3" ng-show="!vm.onlineRegConfig.noPaymentRequired && vm.onlineRegConfig.paymentSupplier === \'STRIPE\'"><label class="control-label" data-translate="pcsApp.onlineRegConfig.stripeSecretKey">Stripe secret key</label><input type="text" class="form-control" name="stripeSecretKey" id="field_stripeSecretKey" ng-model="vm.onlineRegConfig.stripeSecretKey" autocomplete="off" ng-required="vm.onlineRegConfig.paymentSupplier === \'STRIPE\'"><div ng-show="editForm.stripeSecretKey.$invalid"><p class="error-block" ng-show="editForm.stripeSecretKey.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="col-xs-3" ng-show="!vm.onlineRegConfig.noPaymentRequired && vm.onlineRegConfig.paymentSupplier === \'STRIPE\'"><label class="control-label" data-translate="pcsApp.onlineRegConfig.stripePublicKey">Stripe api key</label><input type="text" class="form-control" name="stripePublicKey" id="field_stripePublicKey" ng-model="vm.onlineRegConfig.stripePublicKey" autocomplete="off" ng-required="vm.onlineRegConfig.paymentSupplier === \'STRIPE\'"><div ng-show="editForm.stripePublicKey.$invalid"><p class="error-block" ng-show="editForm.stripePublicKey.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.browserRemarkHu" for="field_browserRemarkHu">Browser remark(hu)</label><summernote id="field_browserRemarkHu" name="browserRemarkHu" ng-model="vm.onlineRegConfig.browserRemarkHu" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.browserRemarkHu.$invalid"><p class="help-block" ng-show="editForm.browserRemarkHu.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.browserRemarkHu.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.browserRemarkEn" for="field_browserRemarkEn">Browser remark(en)</label><summernote id="field_browserRemarkEn" name="browserRemarkEn" ng-model="vm.onlineRegConfig.browserRemarkEn" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.browserRemarkEn.$invalid"><p class="help-block" ng-show="editForm.browserRemarkEn.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.browserRemarkEn.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.browserRemarkEs" for="field_browserRemarkEs">Browser remark(es)</label><summernote id="field_browserRemarkEs" name="browserRemarkEs" ng-model="vm.onlineRegConfig.browserRemarkEs" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.browserRemarkEs.$invalid"><p class="help-block" ng-show="editForm.browserRemarkEs.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.browserRemarkEs.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.browserRemarkPt" for="field_browserRemarkPt">Browser remark(pt)</label><summernote id="field_browserRemarkPt" name="browserRemarkPt" ng-model="vm.onlineRegConfig.browserRemarkPt" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.browserRemarkPt.$invalid"><p class="help-block" ng-show="editForm.browserRemarkPt.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.browserRemarkPt.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div></div></uib-tab><uib-tab heading="Personal data"><div class="panel-body"><div class="form-group"><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.titleVisible">Title visible</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="titleVisible" id="field_titleVisible" ng-model="vm.onlineRegConfig.titleVisible" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_titleVisible"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.titleSelectable">Title selectable</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="titleSelectable" id="field_titleSelectable" ng-model="vm.onlineRegConfig.titleSelectable" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_titleSelectable"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.lastNameVisible">Last name visible</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="lastNameVisible" id="field_lastNameVisible" ng-model="vm.onlineRegConfig.lastNameVisible" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_lastNameVisible"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.firstNameVisible">First name visible</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="firstNameVisible" id="field_firstNameVisible" ng-model="vm.onlineRegConfig.firstNameVisible" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_firstNameVisible"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div></div><div class="form-group"><div class="col-xs-6"><label class="control-label" data-translate="pcsApp.onlineRegConfig.titleRequired">Title required</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="titleRequired" id="field_titleRequired" ng-model="vm.onlineRegConfig.titleRequired" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_titleRequired"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.lastNameRequired">Last name required</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="lastNameRequired" id="field_lastNameRequired" ng-model="vm.onlineRegConfig.lastNameRequired" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_lastNameRequired"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.firstNameRequired">First name required</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="firstNameRequired" id="field_firstNameRequired" ng-model="vm.onlineRegConfig.firstNameRequired" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_firstNameRequired"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.departmentVisible">Department visible</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="departmentVisible" id="field_departmentVisible" ng-model="vm.onlineRegConfig.departmentVisible" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_departmentVisible"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.phoneVisible">Phone visible</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="phoneVisible" id="field_phoneVisible" ng-model="vm.onlineRegConfig.phoneVisible" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_phoneVisible"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.emailVisible">Email visible</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="emailVisible" id="field_emailVisible" ng-model="vm.onlineRegConfig.emailVisible" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_emailVisible"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div></div><div class="form-group"><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.departmentRequired">Department required</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="departmentRequired" id="field_departmentRequired" ng-model="vm.onlineRegConfig.departmentRequired" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_departmentRequired"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.phoneRequired">Phone required</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="phoneRequired" id="field_phoneRequired" ng-model="vm.onlineRegConfig.phoneRequired" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_phoneRequired"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.emailRequired">Email required</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="emailRequired" id="field_emailRequired" ng-model="vm.onlineRegConfig.emailRequired" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_emailRequired"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.countryVisible">Country visible</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="countryVisible" id="field_countryVisible" ng-model="vm.onlineRegConfig.countryVisible" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_countryVisible"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.zipCodeVisible">Zip code visible</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="zipCodeVisible" id="field_zipCodeVisible" ng-model="vm.onlineRegConfig.zipCodeVisible" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_zipCodeVisible"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.cityVisible">City visible</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="cityVisible" id="field_cityVisible" ng-model="vm.onlineRegConfig.cityVisible" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_cityVisible"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.streetVisible">Street visible</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="streetVisible" id="field_streetVisible" ng-model="vm.onlineRegConfig.streetVisible" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_streetVisible"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div></div><div class="form-group"><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.countryRequired">Country required</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="countryRequired" id="field_countryRequired" ng-model="vm.onlineRegConfig.countryRequired" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_countryRequired"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.zipCodeRequired">Zip code required</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="zipCodeRequired" id="field_zipCodeRequired" ng-model="vm.onlineRegConfig.zipCodeRequired" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_zipCodeRequired"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.cityRequired">City required</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="cityRequired" id="field_cityRequired" ng-model="vm.onlineRegConfig.cityRequired" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_cityRequired"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.streetRequired">Street required</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="streetRequired" id="field_streetRequired" ng-model="vm.onlineRegConfig.streetRequired" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_streetRequired"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.workplaceVisible">workplace visible</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="workplaceVisible" id="field_workplaceVisible" ng-model="vm.onlineRegConfig.workplaceVisible" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_workplaceVisible"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.workplaceRequired">Workplace required</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="workplaceRequired" id="field_workplaceRequired" ng-model="vm.onlineRegConfig.workplaceRequired" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_workplaceRequired"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="col-xs-12 m-t-xs"><table id="workplace-selectable-hu-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span>Workplace selectable values(hu)</span></th><th><button class="btn btn-primary btn-xs" type="button" ng-click="vm.appendSelectableValue(vm.onlineRegConfig.workplaceHuValues, 0)"><i class="fa fa-plus"></i></button></th></tr></thead><tbody><tr ng-repeat="workplaceValue in vm.onlineRegConfig.workplaceHuValues track by $index"><td editable-text-value-cell editable-text-list="vm.onlineRegConfig.workplaceHuValues" editable-text-idx="{{$index}}"></td><td><button class="btn btn-primary btn-xs" type="button" ng-click="vm.appendSelectableValue(vm.onlineRegConfig.workplaceHuValues, $index + 1)"><i class="fa fa-plus"></i></button> <button class="btn btn-danger btn-xs" type="button" ng-click="vm.deleteFromSelectableValues(vm.onlineRegConfig.workplaceHuValues, $index)"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table><table id="workplace-selectable-en-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span>Workplace selectable values(en)</span></th><th><button class="btn btn-primary btn-xs" type="button" ng-click="vm.appendSelectableValue(vm.onlineRegConfig.workplaceEnValues, 0)"><i class="fa fa-plus"></i></button></th></tr></thead><tbody><tr ng-repeat="workplaceValue in vm.onlineRegConfig.workplaceEnValues track by $index"><td editable-text-value-cell editable-text-list="vm.onlineRegConfig.workplaceEnValues" editable-text-idx="{{$index}}"></td><td><button class="btn btn-primary btn-xs" type="button" ng-click="vm.appendSelectableValue(vm.onlineRegConfig.workplaceEnValues, $index + 1)"><i class="fa fa-plus"></i></button> <button class="btn btn-danger btn-xs" type="button" ng-click="vm.deleteFromSelectableValues(vm.onlineRegConfig.workplaceEnValues, $index)"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table><table id="workplace-selectable-es-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span>Workplace selectable values(es)</span></th><th><button class="btn btn-primary btn-xs" type="button" ng-click="vm.appendSelectableValue(vm.onlineRegConfig.workplaceEsValues, 0)"><i class="fa fa-plus"></i></button></th></tr></thead><tbody><tr ng-repeat="workplaceValue in vm.onlineRegConfig.workplaceEsValues track by $index"><td editable-text-value-cell editable-text-list="vm.onlineRegConfig.workplaceEsValues" editable-text-idx="{{$index}}"></td><td><button class="btn btn-primary btn-xs" type="button" ng-click="vm.appendSelectableValue(vm.onlineRegConfig.workplaceEsValues, $index + 1)"><i class="fa fa-plus"></i></button> <button class="btn btn-danger btn-xs" type="button" ng-click="vm.deleteFromSelectableValues(vm.onlineRegConfig.workplaceEsValues, $index)"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table><table id="workplace-selectable-pt-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span>Workplace selectable values(pt)</span></th><th><button class="btn btn-primary btn-xs" type="button" ng-click="vm.appendSelectableValue(vm.onlineRegConfig.workplacePtValues, 0)"><i class="fa fa-plus"></i></button></th></tr></thead><tbody><tr ng-repeat="workplaceValue in vm.onlineRegConfig.workplacePtValues track by $index"><td editable-text-value-cell editable-text-list="vm.onlineRegConfig.workplacePtValues" editable-text-idx="{{$index}}"></td><td><button class="btn btn-primary btn-xs" type="button" ng-click="vm.appendSelectableValue(vm.onlineRegConfig.workplacePtValues, $index + 1)"><i class="fa fa-plus"></i></button> <button class="btn btn-danger btn-xs" type="button" ng-click="vm.deleteFromSelectableValues(vm.onlineRegConfig.workplacePtValues, $index)"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table></div></div><div class="hr-line-dashed"></div><div class="form-group"><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.positionVisible">Position visible</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="positionVisible" id="field_positionVisible" ng-model="vm.onlineRegConfig.positionVisible" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_positionVisible"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="col-xs-9"><label class="control-label" data-translate="pcsApp.onlineRegConfig.positionRequired">Position required</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="positionRequired" id="field_positionRequired" ng-model="vm.onlineRegConfig.positionRequired" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_positionRequired"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.positionLabelHu" for="field_positionLabelHu">Position label(hu)</label><input type="text" class="form-control" name="positionLabelHu" id="field_positionLabelHu" ng-model="vm.onlineRegConfig.positionLabelHu" autocomplete="off" ng-maxlength="200"><div ng-show="editForm.positionLabelHu.$invalid"><p class="error-block" ng-show="editForm.positionLabelHu.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.positionLabelHu.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="200">This field cannot be longer than 200 characters.</p></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.positionLabelEn" for="field_positionLabelEn">Position label(en)</label><input type="text" class="form-control" name="positionLabelEn" id="field_positionLabelEn" ng-model="vm.onlineRegConfig.positionLabelEn" autocomplete="off" ng-maxlength="200"><div ng-show="editForm.positionLabelEn.$invalid"><p class="error-block" ng-show="editForm.positionLabelEn.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.positionLabelEn.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="200">This field cannot be longer than 200 characters.</p></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.positionLabelEs" for="field_positionLabelEs">Position label(es)</label><input type="text" class="form-control" name="positionLabelEs" id="field_positionLabelEs" ng-model="vm.onlineRegConfig.positionLabelEs" autocomplete="off" ng-maxlength="200"><div ng-show="editForm.positionLabelEs.$invalid"><p class="error-block" ng-show="editForm.positionLabelEs.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.positionLabelEs.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="200">This field cannot be longer than 200 characters.</p></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.positionLabelPt" for="field_positionLabelPt">Position label(pt)</label><input type="text" class="form-control" name="positionLabelPt" id="field_positionLabelPt" ng-model="vm.onlineRegConfig.positionLabelPt" autocomplete="off" ng-maxlength="200"><div ng-show="editForm.positionLabelPt.$invalid"><p class="error-block" ng-show="editForm.positionLabelPt.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.positionLabelPt.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="200">This field cannot be longer than 200 characters.</p></div></div><div class="col-xs-12 m-t-xs"><table id="position-selectable-hu-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span>Position selectable values(hu)</span></th><th><button class="btn btn-primary btn-xs" type="button" ng-click="vm.appendSelectableValue(vm.onlineRegConfig.positionHuValues, 0)"><i class="fa fa-plus"></i></button></th></tr></thead><tbody><tr ng-repeat="positionValue in vm.onlineRegConfig.positionHuValues track by $index"><td editable-text-value-cell editable-text-list="vm.onlineRegConfig.positionHuValues" editable-text-idx="{{$index}}"></td><td><button class="btn btn-primary btn-xs" type="button" ng-click="vm.appendSelectableValue(vm.onlineRegConfig.positionHuValues, $index + 1)"><i class="fa fa-plus"></i></button> <button class="btn btn-danger btn-xs" type="button" ng-click="vm.deleteFromSelectableValues(vm.onlineRegConfig.positionHuValues, $index)"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table><table id="position-selectable-en-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span>Position selectable values(en)</span></th><th><button class="btn btn-primary btn-xs" type="button" ng-click="vm.appendSelectableValue(vm.onlineRegConfig.positionEnValues, 0)"><i class="fa fa-plus"></i></button></th></tr></thead><tbody><tr ng-repeat="positionValue in vm.onlineRegConfig.positionEnValues track by $index"><td editable-text-value-cell editable-text-list="vm.onlineRegConfig.positionEnValues" editable-text-idx="{{$index}}"></td><td><button class="btn btn-primary btn-xs" type="button" ng-click="vm.appendSelectableValue(vm.onlineRegConfig.positionEnValues, $index + 1)"><i class="fa fa-plus"></i></button> <button class="btn btn-danger btn-xs" type="button" ng-click="vm.deleteFromSelectableValues(vm.onlineRegConfig.positionEnValues, $index)"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table><table id="position-selectable-es-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span>Position selectable values(es)</span></th><th><button class="btn btn-primary btn-xs" type="button" ng-click="vm.appendSelectableValue(vm.onlineRegConfig.positionEsValues, 0)"><i class="fa fa-plus"></i></button></th></tr></thead><tbody><tr ng-repeat="positionValue in vm.onlineRegConfig.positionEsValues track by $index"><td editable-text-value-cell editable-text-list="vm.onlineRegConfig.positionEsValues" editable-text-idx="{{$index}}"></td><td><button class="btn btn-primary btn-xs" type="button" ng-click="vm.appendSelectableValue(vm.onlineRegConfig.positionEsValues, $index + 1)"><i class="fa fa-plus"></i></button> <button class="btn btn-danger btn-xs" type="button" ng-click="vm.deleteFromSelectableValues(vm.onlineRegConfig.positionEsValues, $index)"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table><table id="position-selectable-pt-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span>Position selectable values(pt)</span></th><th><button class="btn btn-primary btn-xs" type="button" ng-click="vm.appendSelectableValue(vm.onlineRegConfig.positionPtValues, 0)"><i class="fa fa-plus"></i></button></th></tr></thead><tbody><tr ng-repeat="positionValue in vm.onlineRegConfig.positionPtValues track by $index"><td editable-text-value-cell editable-text-list="vm.onlineRegConfig.positionPtValues" editable-text-idx="{{$index}}"></td><td><button class="btn btn-primary btn-xs" type="button" ng-click="vm.appendSelectableValue(vm.onlineRegConfig.positionPtValues, $index + 1)"><i class="fa fa-plus"></i></button> <button class="btn btn-danger btn-xs" type="button" ng-click="vm.deleteFromSelectableValues(vm.onlineRegConfig.positionPtValues, $index)"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table></div></div><div class="hr-line-dashed"></div><div class="form-group"><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.otherDataVisible">Other data visible</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="otherDataVisible" id="field_otherDataVisible" ng-model="vm.onlineRegConfig.otherDataVisible" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_otherDataVisible"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="col-xs-9"><label class="control-label" data-translate="pcsApp.onlineRegConfig.otherDataRequired">Other data required</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="otherDataRequired" id="field_otherDataRequired" ng-model="vm.onlineRegConfig.otherDataRequired" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_otherDataRequired"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.otherDataLabelHu">Other data label(hu)</label><input type="text" class="form-control" name="otherDataLabelHu" id="field_otherDataLabelHu" ng-model="vm.onlineRegConfig.otherDataLabelHu" autocomplete="off" ng-maxlength="200"><div ng-show="editForm.otherDataLabelHu.$invalid"><p class="error-block" ng-show="editForm.otherDataLabelHu.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.otherDataLabelHu.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="200">This field cannot be longer than 200 characters.</p></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.otherDataLabelEn">Other data label(en)</label><input type="text" class="form-control" name="otherDataLabelEn" id="field_otherDataLabelEn" ng-model="vm.onlineRegConfig.otherDataLabelEn" autocomplete="off" ng-maxlength="200"><div ng-show="editForm.otherDataLabelEn.$invalid"><p class="error-block" ng-show="editForm.otherDataLabelEn.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.otherDataLabelEn.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="200">This field cannot be longer than 200 characters.</p></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.otherDataLabelEs">Other data label(es)</label><input type="text" class="form-control" name="otherDataLabelEs" id="field_otherDataLabelEs" ng-model="vm.onlineRegConfig.otherDataLabelEs" autocomplete="off" ng-maxlength="200"><div ng-show="editForm.otherDataLabelEs.$invalid"><p class="error-block" ng-show="editForm.otherDataLabelEs.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.otherDataLabelEs.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="200">This field cannot be longer than 200 characters.</p></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.otherDataLabelPt">Other data label(pt)</label><input type="text" class="form-control" name="otherDataLabelPt" id="field_otherDataLabelPt" ng-model="vm.onlineRegConfig.otherDataLabelPt" autocomplete="off" ng-maxlength="200"><div ng-show="editForm.otherDataLabelPt.$invalid"><p class="error-block" ng-show="editForm.otherDataLabelPt.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.otherDataLabelPt.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="200">This field cannot be longer than 200 characters.</p></div></div><div class="col-xs-12 m-t-xs"><table id="otherdata-selectable-hu-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span>Other data selectable values(hu)</span></th><th><button class="btn btn-primary btn-xs" type="button" ng-click="vm.appendSelectableValue(vm.onlineRegConfig.otherDataHuValues, 0)"><i class="fa fa-plus"></i></button></th></tr></thead><tbody><tr ng-repeat="otherDataValue in vm.onlineRegConfig.otherDataHuValues track by $index"><td editable-text-value-cell editable-text-list="vm.onlineRegConfig.otherDataHuValues" editable-text-idx="{{$index}}"></td><td><button class="btn btn-primary btn-xs" type="button" ng-click="vm.appendSelectableValue(vm.onlineRegConfig.otherDataHuValues, $index + 1)"><i class="fa fa-plus"></i></button> <button class="btn btn-danger btn-xs" type="button" ng-click="vm.deleteFromSelectableValues(vm.onlineRegConfig.otherDataHuValues, $index)"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table><table id="otherdata-selectable-en-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span>Other data selectable values(en)</span></th><th><button class="btn btn-primary btn-xs" type="button" ng-click="vm.appendSelectableValue(vm.onlineRegConfig.otherDataEnValues, 0)"><i class="fa fa-plus"></i></button></th></tr></thead><tbody><tr ng-repeat="otherDataValue in vm.onlineRegConfig.otherDataEnValues track by $index"><td editable-text-value-cell editable-text-list="vm.onlineRegConfig.otherDataEnValues" editable-text-idx="{{$index}}"></td><td><button class="btn btn-primary btn-xs" type="button" ng-click="vm.appendSelectableValue(vm.onlineRegConfig.otherDataEnValues, $index + 1)"><i class="fa fa-plus"></i></button> <button class="btn btn-danger btn-xs" type="button" ng-click="vm.deleteFromSelectableValues(vm.onlineRegConfig.otherDataEnValues, $index)"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table><table id="otherdata-selectable-es-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span>Other data selectable values(es)</span></th><th><button class="btn btn-primary btn-xs" type="button" ng-click="vm.appendSelectableValue(vm.onlineRegConfig.otherDataEsValues, 0)"><i class="fa fa-plus"></i></button></th></tr></thead><tbody><tr ng-repeat="otherDataValue in vm.onlineRegConfig.otherDataEsValues track by $index"><td editable-text-value-cell editable-text-list="vm.onlineRegConfig.otherDataEsValues" editable-text-idx="{{$index}}"></td><td><button class="btn btn-primary btn-xs" type="button" ng-click="vm.appendSelectableValue(vm.onlineRegConfig.otherDataEsValues, $index + 1)"><i class="fa fa-plus"></i></button> <button class="btn btn-danger btn-xs" type="button" ng-click="vm.deleteFromSelectableValues(vm.onlineRegConfig.otherDataEsValues, $index)"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table><table id="otherdata-selectable-pt-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span>Other data selectable values(pt)</span></th><th><button class="btn btn-primary btn-xs" type="button" ng-click="vm.appendSelectableValue(vm.onlineRegConfig.otherDataPtValues, 0)"><i class="fa fa-plus"></i></button></th></tr></thead><tbody><tr ng-repeat="otherDataValue in vm.onlineRegConfig.otherDataPtValues track by $index"><td editable-text-value-cell editable-text-list="vm.onlineRegConfig.otherDataPtValues" editable-text-idx="{{$index}}"></td><td><button class="btn btn-primary btn-xs" type="button" ng-click="vm.appendSelectableValue(vm.onlineRegConfig.otherDataPtValues, $index + 1)"><i class="fa fa-plus"></i></button> <button class="btn btn-danger btn-xs" type="button" ng-click="vm.deleteFromSelectableValues(vm.onlineRegConfig.otherDataPtValues, $index)"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table></div></div><div class="hr-line-dashed"></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.personalDataRemarkHu" for="field_personalDataRemarkHu">Personal data remark</label><summernote id="field_personalDataRemarkHu" name="personalDataRemarkHu" ng-model="vm.onlineRegConfig.personalDataRemarkHu" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.personalDataRemarkHu.$invalid"><p class="error-block" ng-show="editForm.personalDataRemarkHu.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.personalDataRemarkHu.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.personalDataRemarkEn" for="field_personalDataRemarkEn">Personal data remark</label><summernote id="field_personalDataRemarkEn" name="personalDataRemarkEn" ng-model="vm.onlineRegConfig.personalDataRemarkEn" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.personalDataRemarkEn.$invalid"><p class="error-block" ng-show="editForm.personalDataRemarkEn.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.personalDataRemarkEn.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.personalDataRemarkEs" for="field_personalDataRemarkEs">Personal data remark</label><summernote id="field_personalDataRemarkEs" name="personalDataRemarkEs" ng-model="vm.onlineRegConfig.personalDataRemarkEs" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.personalDataRemarkEs.$invalid"><p class="error-block" ng-show="editForm.personalDataRemarkEs.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.personalDataRemarkEs.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.personalDataRemarkPt" for="field_personalDataRemarkPt">Personal data remark</label><summernote id="field_personalDataRemarkPt" name="personalDataRemarkPt" ng-model="vm.onlineRegConfig.personalDataRemarkPt" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.personalDataRemarkPt.$invalid"><p class="error-block" ng-show="editForm.personalDataRemarkPt.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.personalDataRemarkPt.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div></div></uib-tab><uib-tab heading="Registration"><div class="panel-body"><div class="form-group"><div class="col-xs-4"><label class="control-label" data-translate="pcsApp.onlineRegConfig.regTypeFirstFeeLabelHu" for="field_regTypeFirstFeeLabelHu">First fee label(hu)</label><input type="text" class="form-control" name="regTypeFirstFeeLabelHu" id="field_regTypeFirstFeeLabelHu" ng-model="vm.onlineRegConfig.regTypeFirstFeeLabelHu" autocomplete="off" ng-maxlength="100"><div ng-show="editForm.regTypeFirstFeeLabelHu.$invalid"><p class="error-block" ng-show="editForm.regTypeFirstFeeLabelHu.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.regTypeFirstFeeLabelHu.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="col-xs-4"><label class="control-label" data-translate="pcsApp.onlineRegConfig.regTypeSecondFeeLabelHu" for="field_regTypeSecondFeeLabelHu">Second fee label(hu)</label><input type="text" class="form-control" name="regTypeSecondFeeLabelHu" id="field_regTypeSecondFeeLabelHu" ng-model="vm.onlineRegConfig.regTypeSecondFeeLabelHu" autocomplete="off" ng-maxlength="100"><div ng-show="editForm.regTypeSecondFeeLabelHu.$invalid"><p class="error-block" ng-show="editForm.regTypeSecondFeeLabelHu.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.regTypeSecondFeeLabelHu.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="col-xs-4"><label class="control-label" data-translate="pcsApp.onlineRegConfig.regTypeThirdFeeLabelHu" for="field_regTypeThirdFeeLabelHu">Third fee label(hu)</label><input type="text" class="form-control" name="regTypeThirdFeeLabelHu" id="field_regTypeThirdFeeLabelHu" ng-model="vm.onlineRegConfig.regTypeThirdFeeLabelHu" autocomplete="off" ng-maxlength="100"><div ng-show="editForm.regTypeThirdFeeLabelHu.$invalid"><p class="error-block" ng-show="editForm.regTypeThirdFeeLabelHu.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.regTypeThirdFeeLabelHu.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div><div class="form-group"><div class="col-xs-4"><label class="control-label" data-translate="pcsApp.onlineRegConfig.regTypeFirstFeeLabelEn" for="field_regTypeFirstFeeLabelEn">First fee label(en)</label><input type="text" class="form-control" name="regTypeFirstFeeLabelEn" id="field_regTypeFirstFeeLabelEn" ng-model="vm.onlineRegConfig.regTypeFirstFeeLabelEn" autocomplete="off" ng-maxlength="100"><div ng-show="editForm.regTypeFirstFeeLabelEn.$invalid"><p class="error-block" ng-show="editForm.regTypeFirstFeeLabelEn.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.regTypeFirstFeeLabelEn.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="col-xs-4"><label class="control-label" data-translate="pcsApp.onlineRegConfig.regTypeSecondFeeLabelEn" for="field_regTypeSecondFeeLabelEn">Second fee label(en)</label><input type="text" class="form-control" name="regTypeSecondFeeLabelEn" id="field_regTypeSecondFeeLabelEn" ng-model="vm.onlineRegConfig.regTypeSecondFeeLabelEn" autocomplete="off" ng-maxlength="100"><div ng-show="editForm.regTypeSecondFeeLabelEn.$invalid"><p class="error-block" ng-show="editForm.regTypeSecondFeeLabelEn.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.regTypeSecondFeeLabelEn.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="col-xs-4"><label class="control-label" data-translate="pcsApp.onlineRegConfig.regTypeThirdFeeLabelEn" for="field_regTypeThirdFeeLabelEn">Third fee label(en)</label><input type="text" class="form-control" name="regTypeThirdFeeLabelEn" id="field_regTypeThirdFeeLabelEn" ng-model="vm.onlineRegConfig.regTypeThirdFeeLabelEn" autocomplete="off" ng-maxlength="100"><div ng-show="editForm.regTypeThirdFeeLabelEn.$invalid"><p class="error-block" ng-show="editForm.regTypeThirdFeeLabelEn.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.regTypeThirdFeeLabelEn.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div><div class="form-group"><div class="col-xs-4"><label class="control-label" data-translate="pcsApp.onlineRegConfig.regTypeFirstFeeLabelEs" for="field_regTypeFirstFeeLabelEs">First fee label(es)</label><input type="text" class="form-control" name="regTypeFirstFeeLabelEs" id="field_regTypeFirstFeeLabelEs" ng-model="vm.onlineRegConfig.regTypeFirstFeeLabelEs" autocomplete="off" ng-maxlength="100"><div ng-show="editForm.regTypeFirstFeeLabelEs.$invalid"><p class="error-block" ng-show="editForm.regTypeFirstFeeLabelEs.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.regTypeFirstFeeLabelEs.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="col-xs-4"><label class="control-label" data-translate="pcsApp.onlineRegConfig.regTypeSecondFeeLabelEs" for="field_regTypeSecondFeeLabelEs">Second fee label(es)</label><input type="text" class="form-control" name="regTypeSecondFeeLabelEs" id="field_regTypeSecondFeeLabelEs" ng-model="vm.onlineRegConfig.regTypeSecondFeeLabelEs" autocomplete="off" ng-maxlength="100"><div ng-show="editForm.regTypeSecondFeeLabelEs.$invalid"><p class="error-block" ng-show="editForm.regTypeSecondFeeLabelEs.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.regTypeSecondFeeLabelEs.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="col-xs-4"><label class="control-label" data-translate="pcsApp.onlineRegConfig.regTypeThirdFeeLabelEs" for="field_regTypeThirdFeeLabelEs">Third fee label(es)</label><input type="text" class="form-control" name="regTypeThirdFeeLabelEs" id="field_regTypeThirdFeeLabelEs" ng-model="vm.onlineRegConfig.regTypeThirdFeeLabelEs" autocomplete="off" ng-maxlength="100"><div ng-show="editForm.regTypeThirdFeeLabelEs.$invalid"><p class="error-block" ng-show="editForm.regTypeThirdFeeLabelEs.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.regTypeThirdFeeLabelEs.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div><div class="form-group"><div class="col-xs-4"><label class="control-label" data-translate="pcsApp.onlineRegConfig.regTypeFirstFeeLabelPt" for="field_regTypeFirstFeeLabelPt">First fee label(pt)</label><input type="text" class="form-control" name="regTypeFirstFeeLabelPt" id="field_regTypeFirstFeeLabelPt" ng-model="vm.onlineRegConfig.regTypeFirstFeeLabelPt" autocomplete="off" ng-maxlength="100"><div ng-show="editForm.regTypeFirstFeeLabelPt.$invalid"><p class="error-block" ng-show="editForm.regTypeFirstFeeLabelPt.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.regTypeFirstFeeLabelPt.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="col-xs-4"><label class="control-label" data-translate="pcsApp.onlineRegConfig.regTypeSecondFeeLabelPt" for="field_regTypeSecondFeeLabelPt">Second fee label(pt)</label><input type="text" class="form-control" name="regTypeSecondFeeLabelPt" id="field_regTypeSecondFeeLabelPt" ng-model="vm.onlineRegConfig.regTypeSecondFeeLabelPt" autocomplete="off" ng-maxlength="100"><div ng-show="editForm.regTypeSecondFeeLabelPt.$invalid"><p class="error-block" ng-show="editForm.regTypeSecondFeeLabelPt.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.regTypeSecondFeeLabelPt.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="col-xs-4"><label class="control-label" data-translate="pcsApp.onlineRegConfig.regTypeThirdFeeLabelPt" for="field_regTypeThirdFeeLabelPt">Third fee label(pt)</label><input type="text" class="form-control" name="regTypeThirdFeeLabelPt" id="field_regTypeThirdFeeLabelPt" ng-model="vm.onlineRegConfig.regTypeThirdFeeLabelPt" autocomplete="off" ng-maxlength="100"><div ng-show="editForm.regTypeThirdFeeLabelPt.$invalid"><p class="error-block" ng-show="editForm.regTypeThirdFeeLabelPt.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.regTypeThirdFeeLabelPt.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.regTypeRemarkHu" for="field_regTypeRemarkHu">Reg type remark(hu)</label><summernote id="field_regTypeRemarkHu" name="regTypeRemarkHu" ng-model="vm.onlineRegConfig.regTypeRemarkHu" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.regTypeRemarkHu.$invalid"><p class="error-block" ng-show="editForm.regTypeRemarkHu.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.regTypeRemarkHu.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.regTypeRemarkEn" for="field_regTypeRemarkEn">Reg type remark(en)</label><summernote id="field_regTypeRemarkEn" name="regTypeRemarkEn" ng-model="vm.onlineRegConfig.regTypeRemarkEn" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.regTypeRemarkEn.$invalid"><p class="error-block" ng-show="editForm.regTypeRemarkEn.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.regTypeRemarkEn.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.regTypeRemarkEs" for="field_regTypeRemarkEs">Reg type remark(es)</label><summernote id="field_regTypeRemarkEs" name="regTypeRemarkEs" ng-model="vm.onlineRegConfig.regTypeRemarkEs" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.regTypeRemarkEs.$invalid"><p class="error-block" ng-show="editForm.regTypeRemarkEs.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.regTypeRemarkEs.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.regTypeRemarkPt" for="field_regTypeRemarkPt">Reg type remark(pt)</label><summernote id="field_regTypeRemarkPt" name="regTypeRemarkPt" ng-model="vm.onlineRegConfig.regTypeRemarkPt" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.regTypeRemarkPt.$invalid"><p class="error-block" ng-show="editForm.regTypeRemarkPt.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.regTypeRemarkPt.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div></div></uib-tab><uib-tab heading="Title&Remarks"><div class="panel-body"><div class="form-group"><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.regTypeExtraTitleHu" for="field_regTypeExtraTitleHu">Reg type extra title(hu)</label><input type="text" class="form-control" name="regTypeFirstFeeLabelHu" id="field_regTypeExtraTitleHu" ng-model="vm.onlineRegConfig.regTypeExtraTitleHu" autocomplete="off" ng-maxlength="255"><div ng-show="editForm.regTypeExtraTitleHu.$invalid"><p class="error-block" ng-show="editForm.regTypeExtraTitleHu.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.regTypeExtraTitleEn" for="field_regTypeExtraTitleEn">Reg type extra title(en)</label><input type="text" class="form-control" name="regTypeFirstFeeLabelEn" id="field_regTypeExtraTitleEn" ng-model="vm.onlineRegConfig.regTypeExtraTitleEn" autocomplete="off" ng-maxlength="255"><div ng-show="editForm.regTypeExtraTitleEn.$invalid"><p class="error-block" ng-show="editForm.regTypeExtraTitleEn.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.regTypeExtraTitleEs" for="field_regTypeExtraTitleEs">Reg type extra title(es)</label><input type="text" class="form-control" name="regTypeFirstFeeLabelEs" id="field_regTypeExtraTitleEs" ng-model="vm.onlineRegConfig.regTypeExtraTitleEs" autocomplete="off" ng-maxlength="255"><div ng-show="editForm.regTypeExtraTitleEs.$invalid"><p class="error-block" ng-show="editForm.regTypeExtraTitleEs.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.regTypeExtraTitlePt" for="field_regTypeExtraTitlePt">Reg type extra title(pt)</label><input type="text" class="form-control" name="regTypeFirstFeeLabelPt" id="field_regTypeExtraTitlePt" ng-model="vm.onlineRegConfig.regTypeExtraTitlePt" autocomplete="off" ng-maxlength="255"><div ng-show="editForm.regTypeExtraTitlePt.$invalid"><p class="error-block" ng-show="editForm.regTypeExtraTitlePt.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div></div><div class="form-group"><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.optionalServiceExtraTitleHu" for="field_optionalServiceExtraTitleHu">Optional service extra title(hu)</label><input type="text" class="form-control" name="optionalServiceFirstFeeLabelHu" id="field_optionalServiceExtraTitleHu" ng-model="vm.onlineRegConfig.optionalServiceExtraTitleHu" autocomplete="off" ng-maxlength="255"><div ng-show="editForm.optionalServiceExtraTitleHu.$invalid"><p class="error-block" ng-show="editForm.optionalServiceExtraTitleHu.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.optionalServiceExtraTitleEn" for="field_optionalServiceExtraTitleEn">Optional service extra title(en)</label><input type="text" class="form-control" name="optionalServiceFirstFeeLabelEn" id="field_optionalServiceExtraTitleEn" ng-model="vm.onlineRegConfig.optionalServiceExtraTitleEn" autocomplete="off" ng-maxlength="255"><div ng-show="editForm.optionalServiceExtraTitleEn.$invalid"><p class="error-block" ng-show="editForm.optionalServiceExtraTitleEn.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.optionalServiceExtraTitleEs" for="field_optionalServiceExtraTitleEs">Optional service extra title(es)</label><input type="text" class="form-control" name="optionalServiceFirstFeeLabelEs" id="field_optionalServiceExtraTitleEs" ng-model="vm.onlineRegConfig.optionalServiceExtraTitleEs" autocomplete="off" ng-maxlength="255"><div ng-show="editForm.optionalServiceExtraTitleEs.$invalid"><p class="error-block" ng-show="editForm.optionalServiceExtraTitleEs.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.optionalServiceExtraTitlePt" for="field_optionalServiceExtraTitlePt">Optional service extra title(pt)</label><input type="text" class="form-control" name="optionalServiceFirstFeeLabelPt" id="field_optionalServiceExtraTitlePt" ng-model="vm.onlineRegConfig.optionalServiceExtraTitlePt" autocomplete="off" ng-maxlength="255"><div ng-show="editForm.optionalServiceExtraTitlePt.$invalid"><p class="error-block" ng-show="editForm.optionalServiceExtraTitlePt.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.roomRemarkHu" for="field_roomRemarkHu">Room remark(hu)</label><summernote id="field_roomRemarkHu" name="roomRemarkHu" ng-model="vm.onlineRegConfig.roomRemarkHu" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.roomRemarkHu.$invalid"><p class="error-block" ng-show="editForm.roomRemarkHu.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.roomRemarkHu.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.roomRemarkEn" for="field_roomRemarkEn">Room remark(en)</label><summernote id="field_roomRemarkEn" name="roomRemarkEn" ng-model="vm.onlineRegConfig.roomRemarkEn" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.roomRemarkEn.$invalid"><p class="error-block" ng-show="editForm.roomRemarkEn.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.roomRemarkEn.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.roomRemarkEs" for="field_roomRemarkEs">Room remark(es)</label><summernote id="field_roomRemarkEs" name="roomRemarkEs" ng-model="vm.onlineRegConfig.roomRemarkEs" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.roomRemarkEs.$invalid"><p class="error-block" ng-show="editForm.roomRemarkEs.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.roomRemarkEs.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.roomRemarkPt" for="field_roomRemarkPt">Room remark(pt)</label><summernote id="field_roomRemarkPt" name="roomRemarkPt" ng-model="vm.onlineRegConfig.roomRemarkPt" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.roomRemarkPt.$invalid"><p class="error-block" ng-show="editForm.roomRemarkPt.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.roomRemarkPt.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.optionalServiceRemarkHu" for="field_optionalServiceRemarkHu">Optional service remark(hu)</label><summernote id="field_optionalServiceRemarkHu" name="optionalServiceRemarkHu" ng-model="vm.onlineRegConfig.optionalServiceRemarkHu" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.optionalServiceRemarkHu.$invalid"><p class="error-block" ng-show="editForm.optionalServiceRemarkHu.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.optionalServiceRemarkHu.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.optionalServiceRemarkEn" for="field_optionalServiceRemarkEn">Optional service remark(en)</label><summernote id="field_optionalServiceRemarkEn" name="optionalServiceRemarkEn" ng-model="vm.onlineRegConfig.optionalServiceRemarkEn" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.optionalServiceRemarkEn.$invalid"><p class="error-block" ng-show="editForm.optionalServiceRemarkEn.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.optionalServiceRemarkEn.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.optionalServiceRemarkEs" for="field_optionalServiceRemarkEs">Optional service remark(es)</label><summernote id="field_optionalServiceRemarkEs" name="optionalServiceRemarkEs" ng-model="vm.onlineRegConfig.optionalServiceRemarkEs" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.optionalServiceRemarkEs.$invalid"><p class="error-block" ng-show="editForm.optionalServiceRemarkEs.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.optionalServiceRemarkEs.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.optionalServiceRemarkPt" for="field_optionalServiceRemarkPt">Optional service remark(pt)</label><summernote id="field_optionalServiceRemarkPt" name="optionalServiceRemarkPt" ng-model="vm.onlineRegConfig.optionalServiceRemarkPt" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.optionalServiceRemarkPt.$invalid"><p class="error-block" ng-show="editForm.optionalServiceRemarkPt.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.optionalServiceRemarkPt.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div></div></uib-tab><uib-tab heading="Billing"><div class="panel-body"><div class="form-group"><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.bankTransferVisible">Bank transfer visible</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="bankTransferVisible" id="field_bankTransferVisible" ng-disabled="vm.onlineRegConfig.paymentSupplier === \'STRIPE\'" ng-model="vm.onlineRegConfig.bankTransferVisible" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_bankTransferVisible"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.checkVisible">Check visible</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="checkVisible" id="field_checkVisible" ng-disabled="vm.onlineRegConfig.paymentSupplier === \'STRIPE\'" ng-model="vm.onlineRegConfig.checkVisible" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_checkVisible"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="col-xs-3"><label class="control-label" data-translate="pcsApp.onlineRegConfig.creditCardVisible">First name visible</label><div class="switch"><div class="onoffswitch"><input type="checkbox" name="creditCardVisible" id="field_creditCardVisible" ng-disabled="vm.onlineRegConfig.paymentSupplier === \'STRIPE\'" ng-model="vm.onlineRegConfig.creditCardVisible" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="field_creditCardVisible"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.bankTransferInfoHu" for="field_bankTransferInfoHu">Bank transfer info(hu)</label><summernote id="field_bankTransferInfoHu" name="bankTransferInfoHu" ng-model="vm.onlineRegConfig.bankTransferInfoHu" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.bankTransferInfoHu.$invalid"><p class="error-block" ng-show="editForm.bankTransferInfoHu.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.bankTransferInfoHu.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.bankTransferInfoEn" for="field_bankTransferInfoEn">Bank transfer info(en)</label><summernote id="field_bankTransferInfoEn" name="bankTransferInfoEn" ng-model="vm.onlineRegConfig.bankTransferInfoEn" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.bankTransferInfoEn.$invalid"><p class="error-block" ng-show="editForm.bankTransferInfoEn.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.bankTransferInfoEn.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.bankTransferInfoEs" for="field_bankTransferInfoEs">Bank transfer info(es)</label><summernote id="field_bankTransferInfoEs" name="bankTransferInfoEs" ng-model="vm.onlineRegConfig.bankTransferInfoEs" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.bankTransferInfoEs.$invalid"><p class="error-block" ng-show="editForm.bankTransferInfoEs.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.bankTransferInfoEs.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.bankTransferInfoPt" for="field_bankTransferInfoPt">Bank transfer info(pt)</label><summernote id="field_bankTransferInfoPt" name="bankTransferInfoPt" ng-model="vm.onlineRegConfig.bankTransferInfoPt" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.bankTransferInfoPt.$invalid"><p class="error-block" ng-show="editForm.bankTransferInfoPt.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.bankTransferInfoPt.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.billingRemarkHu" for="field_billingRemarkHu">Billing remark(hu)</label><summernote id="field_billingRemarkHu" name="billingRemarkHu" ng-model="vm.onlineRegConfig.billingRemarkHu" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.billingRemarkHu.$invalid"><p class="error-block" ng-show="editForm.billingRemarkHu.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.billingRemarkHu.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.billingRemarkEn" for="field_billingRemarkEn">Billing remark(en)</label><summernote id="field_billingRemarkEn" name="billingRemarkEn" ng-model="vm.onlineRegConfig.billingRemarkEn" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.billingRemarkEn.$invalid"><p class="error-block" ng-show="editForm.billingRemarkEn.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.billingRemarkEn.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.billingRemarkEs" for="field_billingRemarkEs">Billing remark(es)</label><summernote id="field_billingRemarkEs" name="billingRemarkEs" ng-model="vm.onlineRegConfig.billingRemarkEs" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.billingRemarkEs.$invalid"><p class="error-block" ng-show="editForm.billingRemarkEs.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.billingRemarkEs.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.billingRemarkPt" for="field_billingRemarkPt">Billing remark(pt)</label><summernote id="field_billingRemarkPt" name="billingRemarkPt" ng-model="vm.onlineRegConfig.billingRemarkPt" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.billingRemarkPt.$invalid"><p class="error-block" ng-show="editForm.billingRemarkPt.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.billingRemarkPt.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div></div></uib-tab><uib-tab heading="Conditions and granting"><div class="panel-body"><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.termsAndConditionsRemarkHu" for="field_termsAndConditionsRemarkHu">Terms and conditions remark(hu)</label><summernote id="field_termsAndConditionsRemarkHu" name="termsAndConditionsRemarkHu" ng-model="vm.onlineRegConfig.termsAndConditionsRemarkHu" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.termsAndConditionsRemarkHu.$invalid"><p class="error-block" ng-show="editForm.termsAndConditionsRemarkHu.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.termsAndConditionsRemarkHu.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.termsAndConditionsRemarkEn" for="field_termsAndConditionsRemarkEn">Terms and conditions remark(en)</label><summernote id="field_termsAndConditionsRemarkEn" name="termsAndConditionsRemarkEn" ng-model="vm.onlineRegConfig.termsAndConditionsRemarkEn" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.termsAndConditionsRemarkEn.$invalid"><p class="error-block" ng-show="editForm.termsAndConditionsRemarkEn.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.termsAndConditionsRemarkEn.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.termsAndConditionsRemarkEs" for="field_termsAndConditionsRemarkEs">Terms and conditions remark(es)</label><summernote id="field_termsAndConditionsRemarkEs" name="termsAndConditionsRemarkEs" ng-model="vm.onlineRegConfig.termsAndConditionsRemarkEs" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.termsAndConditionsRemarkEs.$invalid"><p class="error-block" ng-show="editForm.termsAndConditionsRemarkEs.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.termsAndConditionsRemarkEs.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.termsAndConditionsRemarkPt" for="field_termsAndConditionsRemarkPt">Terms and conditions remark(pt)</label><summernote id="field_termsAndConditionsRemarkPt" name="termsAndConditionsRemarkPt" ng-model="vm.onlineRegConfig.termsAndConditionsRemarkPt" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.termsAndConditionsRemarkPt.$invalid"><p class="error-block" ng-show="editForm.termsAndConditionsRemarkPt.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.termsAndConditionsRemarkPt.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.gdprRemarkHu" for="field_gdprRemarkHu">GDPR remark(hu)</label><summernote id="field_gdprRemarkHu" name="gdprRemarkHu" ng-model="vm.onlineRegConfig.gdprRemarkHu" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.gdprRemarkHu.$invalid"><p class="error-block" ng-show="editForm.gdprRemarkHu.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.gdprRemarkHu.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.gdprRemarkEn" for="field_gdprRemarkEn">GDPR remark(en)</label><summernote id="field_gdprRemarkEn" name="gdprRemarkEn" ng-model="vm.onlineRegConfig.gdprRemarkEn" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.gdprRemarkEn.$invalid"><p class="error-block" ng-show="editForm.gdprRemarkEn.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.gdprRemarkEn.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.gdprRemarkEs" for="field_gdprRemarkEs">GDPR remark(es)</label><summernote id="field_gdprRemarkEs" name="gdprRemarkEs" ng-model="vm.onlineRegConfig.gdprRemarkEs" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.gdprRemarkEs.$invalid"><p class="error-block" ng-show="editForm.gdprRemarkEs.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.gdprRemarkEs.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.gdprRemarkPt" for="field_gdprRemarkPt">GDPR remark(pt)</label><summernote id="field_gdprRemarkPt" name="gdprRemarkPt" ng-model="vm.onlineRegConfig.gdprRemarkPt" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.gdprRemarkPt.$invalid"><p class="error-block" ng-show="editForm.gdprRemarkPt.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.gdprRemarkPt.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.marketingRemarkHu" for="field_marketingRemarkHu">Marketing remark(hu)</label><summernote id="field_marketingRemarkHu" name="marketingRemarkHu" ng-model="vm.onlineRegConfig.marketingRemarkHu" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.marketingRemarkHu.$invalid"><p class="error-block" ng-show="editForm.marketingRemarkHu.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.marketingRemarkHu.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.marketingRemarkEn" for="field_marketingRemarkEn">Marketing remark(en)</label><summernote id="field_marketingRemarkEn" name="marketingRemarkEn" ng-model="vm.onlineRegConfig.marketingRemarkEn" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.marketingRemarkEn.$invalid"><p class="error-block" ng-show="editForm.marketingRemarkEn.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.marketingRemarkEn.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.marketingRemarkEs" for="field_marketingRemarkEs">Marketing remark(es)</label><summernote id="field_marketingRemarkEs" name="marketingRemarkEs" ng-model="vm.onlineRegConfig.marketingRemarkEs" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.marketingRemarkEs.$invalid"><p class="error-block" ng-show="editForm.marketingRemarkEs.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.marketingRemarkEs.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.marketingRemarkPt" for="field_marketingRemarkPt">Marketing remark(pt)</label><summernote id="field_marketingRemarkPt" name="marketingRemarkPt" ng-model="vm.onlineRegConfig.marketingRemarkPt" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.marketingRemarkPt.$invalid"><p class="error-block" ng-show="editForm.marketingRemarkPt.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.marketingRemarkPt.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.conditionsAndGrantingRemarkHu" for="field_conditionsAndGrantingRemarkHu">Conditions and Granting remark(hu)</label><summernote id="field_conditionsAndGrantingRemarkHu" name="conditionsAndGrantingRemarkHu" ng-model="vm.onlineRegConfig.conditionsAndGrantingRemarkHu" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.conditionsAndGrantingRemarkHu.$invalid"><p class="error-block" ng-show="editForm.conditionsAndGrantingRemarkHu.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.conditionsAndGrantingRemarkHu.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.conditionsAndGrantingRemarkEn" for="field_conditionsAndGrantingRemarkEn">Conditions and granting remark(en)</label><summernote id="field_conditionsAndGrantingRemarkEn" name="conditionsAndGrantingRemarkEn" ng-model="vm.onlineRegConfig.conditionsAndGrantingRemarkEn" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.conditionsAndGrantingRemarkEn.$invalid"><p class="error-block" ng-show="editForm.conditionsAndGrantingRemarkEn.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.conditionsAndGrantingRemarkEn.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.conditionsAndGrantingRemarkEs" for="field_conditionsAndGrantingRemarkEs">Conditions and granting remark(es)</label><summernote id="field_conditionsAndGrantingRemarkEs" name="conditionsAndGrantingRemarkEs" ng-model="vm.onlineRegConfig.conditionsAndGrantingRemarkEs" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.conditionsAndGrantingRemarkEs.$invalid"><p class="error-block" ng-show="editForm.conditionsAndGrantingRemarkEs.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.conditionsAndGrantingRemarkEs.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegConfig.conditionsAndGrantingRemarkPt" for="field_conditionsAndGrantingRemarkPt">Conditions and granting remark(pt)</label><summernote id="field_conditionsAndGrantingRemarkPt" name="conditionsAndGrantingRemarkPt" ng-model="vm.onlineRegConfig.conditionsAndGrantingRemarkPt" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.conditionsAndGrantingRemarkPt.$invalid"><p class="error-block" ng-show="editForm.conditionsAndGrantingRemarkPt.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.conditionsAndGrantingRemarkPt.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="60000">This field cannot be longer than 60000 characters.</p></div></div></div></uib-tab></uib-tabset></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/congress-hotel/congress-hotel-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.congressHotel.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.congressHotel.delete.question" translate-values="{id: \'{{vm.congressHotel.id}}\'}">Are you sure you want to delete this Congress Hotel?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/congress-hotel/congress-hotel-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCongressHotelLabel" data-translate="pcsApp.congressHotel.home.createOrEditLabel">Create or edit a Congress Hotel</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.congressHotel.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.congressHotel.id" readonly="readonly"></div><div class="form-group"><label data-translate="pcsApp.congressHotel.congress" for="field_congress">Congress</label><select class="form-control" id="field_congress" name="congress" ng-model="vm.congressHotel.congress" ng-options="congress as congress.meetingCode for congress in vm.congresses track by congress.id"><option value=""></option></select></div><div class="form-group"><label data-translate="pcsApp.congressHotel.hotel" for="field_hotel">Hotel</label><select class="form-control" id="field_hotel" name="hotel" ng-model="vm.congressHotel.hotel" ng-options="hotel as hotel.name for hotel in vm.hotels track by hotel.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/congress-hotel/congress-hotels.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 translate="pcsApp.congressHotel.home.title">Selected Hotels</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-primary" type="submit" ui-sref="congress-hotel.select-hotel"><i class="fa fa-plus"></i></button></div><div class="ibox-content"><table datatable="ng" id="congress-hotel-datatable" dt-options="dtOptions" dt-column-defs="dtColumnDefs" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.congressHotel.code">Code</span></th><th><span translate="pcsApp.congressHotel.name">Name</span></th><th></th></tr></thead><tbody><tr ng-repeat="congressHotel in vm.congressHotels track by congressHotel.id"><td>{{congressHotel.hotel.code}}</td><td>{{congressHotel.hotel.name}}</td><td><button class="btn btn-primary" type="submit" ui-sref="room({congressHotelId: congressHotel.id})"><i class="fa fa-sitemap"></i></button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/congress-hotel/select-hotels.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 translate="pcsApp.congressHotel.selectHotel.title">Hotel Selection</h2></div><div class="col-lg-2"></div></div><jhi-alert-error></jhi-alert-error><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-info" type="submit" ui-sref="congress-hotel"><i class="fa fa-arrow-left"></i></button></div><div class="ibox-content"><table datatable="ng" id="hotelselection-datatable" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" class="table table-striped table-bordered table-hover batch-selection-datatable"><thead><tr><th></th><th><span translate="pcsApp.hotel.code">Code</span></th><th><span translate="pcsApp.hotel.name">Name</span></th><th><span translate="pcsApp.hotel.zipCode">Zip code</span></th><th><span translate="pcsApp.hotel.city">City</span></th><th><span translate="pcsApp.hotel.street">Street</span></th></tr></thead><tbody><tr ng-repeat="hotel in vm.hotels track by hotel.id"><td><input ng-model="vm.selectedHotels[hotel.id.toString()]" ng-change="vm.toggleHotelSelection(hotel.id)" type="checkbox"></td><td>{{hotel.code}}</td><td>{{hotel.name}}</td><td>{{hotel.zipCode}}</td><td>{{hotel.city}}</td><td>{{hotel.street}}</td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/country/countries.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 translate="pcsApp.country.home.title">Countries</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-primary" type="submit" ui-sref="country.new"><i class="fa fa-plus"></i></button></div><div class="ibox-content"><table datatable="ng" id="country-datatable" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.country.code">Code</span></th><th><span translate="pcsApp.country.name">Name</span></th><th></th></tr></thead><tbody><tr ng-repeat="country in vm.countries track by country.id"><td>{{country.code}}</td><td>{{country.name}}</td><td><button class="btn btn-info" type="submit" ui-sref="country.edit({id:country.id})"><i class="fa fa-pencil-square-o"></i></button> <button class="btn btn-danger" type="submit" ui-sref="country.delete({id:country.id})"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/country/country-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.country.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.country.delete.question" translate-values="{id: \'{{vm.country.id}}\'}">Are you sure you want to delete this Country?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/country/country-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCountryLabel" data-translate="pcsApp.country.home.createOrEditLabel">Create or edit a Country</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="pcsApp.country.code" for="field_code">Code</label><input type="text" class="form-control" name="code" id="field_code" autocomplete="off" ng-model="vm.country.code" required ng-minlength="2" ng-maxlength="2"><div ng-show="editForm.code.$invalid"><p class="error-block" ng-show="editForm.code.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.code.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="error-block" ng-show="editForm.code.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="2">This field cannot be longer than 2 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.country.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" autocomplete="off" ng-model="vm.country.name" required ng-minlength="5" ng-maxlength="200"><div ng-show="editForm.name.$invalid"><p class="error-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="5">This field is required to be at least 5 characters.</p><p class="error-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/credit-card-report/credit-card-reports.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 data-translate="pcsApp.creditCardReport.home.title">Credit Card Report</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-md-12"><div class="col-md-3 no-padding-left"><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_fromDate" type="text" class="form-control" name="fromDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.reportFilter.fromDate" is-open="vm.datePickerOpenStatus.fromDate" placeholder="{{ \'pcsApp.creditCardReport.fromDate\' | translate }}" required></div></div><div class="col-md-3 no-padding-left"><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_toDate" type="text" class="form-control" name="toDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.reportFilter.toDate" is-open="vm.datePickerOpenStatus.toDate" placeholder="{{ \'pcsApp.creditCardReport.toDate\' | translate }}" required></div></div><div class="col-md-3 no-padding-left"><input type="text" class="form-control full-width" ng-model="vm.reportFilter.transactionId" autocomplete="off" id="transactionId" name="transactionId" placeholder="{{ \'pcsApp.creditCardReport.transactionId\' | translate }}"></div><div class="col-md-3 input-group"><input type="text" class="form-control full-width" ng-model="vm.reportFilter.programNumber" autocomplete="off" id="programNumber" name="programNumber" placeholder="{{ \'pcsApp.creditCardReport.programNumber\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search()"><span class="glyphicon glyphicon-search"></span></button> <button class="btn btn-danger" ng-if="vm.reportList.length || vm.isAnyFilterSet()" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button> <button class="btn btn-primary" ng-if="vm.reportList.length" type="submit" ng-click="vm.downloadReportXls()"><i class="fa fa-download"></i></button></span></div></div></div></div></div></div></div></div><div class="ibox-content" ng-show="vm.reportList.length"><table datatable="ng" id="credit-card-report-datatable" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span data-translate="pcsApp.creditCardReport.regId">Reg Id</span></th><th><span data-translate="pcsApp.creditCardReport.name">Name</span></th><th><span data-translate="pcsApp.creditCardReport.amount">Amount</span></th><th><span data-translate="pcsApp.creditCardReport.currency">Currency</span></th><th><span data-translate="pcsApp.creditCardReport.dateOfPayment">Date of payment</span></th><th><span data-translate="pcsApp.creditCardReport.cardNumber">Card number</span></th><th><span data-translate="pcsApp.creditCardReport.transactionId">Transaction ID</span></th><th><span data-translate="pcsApp.creditCardReport.congressName">Congress name</span></th><th><span data-translate="pcsApp.creditCardReport.programNumber">Program number</span></th><th><span data-translate="pcsApp.creditCardReport.comment">Comment</span></th></tr></thead><tbody><tr ng-repeat="ccr in vm.reportList track by ccr.id"><td>{{ccr.regId}}</td><td>{{ccr.name}}</td><td>{{ccr.amount}}</td><td>{{ccr.currency}}</td><td>{{ccr.dateOfPayment}}</td><td>{{ccr.cardNumber}}</td><td>{{ccr.transactionId}}</td><td>{{ccr.congressName}}</td><td>{{ccr.programNumber}}</td><td>{{ccr.comment}}</td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/currency/currencies.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 translate="pcsApp.currency.home.title">Currencies</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-primary" type="submit" ui-sref="currency.new"><i class="fa fa-plus"></i></button><!--<div ibox-tools></div>--></div><div class="ibox-content"><table id="currency-table" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.currency.currency">Currency</span></th><th></th></tr></thead><tbody><tr ng-repeat="currency in vm.currencies track by currency.id"><td>{{currency.currency}}</td><td><button class="btn btn-info" type="submit" ui-sref="currency.edit({id:currency.id})"><i class="fa fa-pencil-square-o"></i></button> <button class="btn btn-danger" type="submit" ui-sref="currency.delete({id:currency.id})"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/currency/currency-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.currency.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.currency.delete.question" translate-values="{id: \'{{vm.currency.id}}\'}">Are you sure you want to delete this Currency?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/currency/currency-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCurrencyLabel" data-translate="pcsApp.currency.home.createOrEditLabel">Create or edit a Currency</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.currency.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.currency.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="pcsApp.currency.currency" for="field_currency">Currency</label><input type="text" class="form-control" name="currency" id="field_currency" autocomplete="off" ng-model="vm.currency.currency" required ng-minlength="3" ng-maxlength="3"><div ng-show="editForm.currency.$invalid"><p class="error-block" ng-show="editForm.currency.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.currency.$error.unique" translate="entity.validation.unique">This field must be unique.</p><p class="error-block" ng-show="editForm.currency.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 3 characters.</p><p class="error-block" ng-show="editForm.currency.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="3">This field cannot be longer than 3 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/financial-report/financial-reports.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 data-translate="pcsApp.financialReport.home.title">Financial Report</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div ng-if="vm.financialReports.length" class="ibox-title float-e-margins"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-md-12"><div class="col-md-9 no-padding-left"><send-financial-notice-to-all-dialog><button class="btn btn-info" type="button" data-translate="pcsApp.financialReport.sendFinancialNoticeToAll">Send financial notice to all</button></send-financial-notice-to-all-dialog></div><div class="col-md-3 input-group"><select class="form-control full-width" name="filterParticipantsToPay" ng-model="vm.reportFilter.participantsToPay" id="id_FilterParticipantsToPay" ng-change="vm.loadAll()"><option ng-selected="!vm.filterParticipantsToPay" ng-value="false">All rows</option><option ng-selected="vm.filterParticipantsToPay" ng-value="true">Participants to pay</option></select><span class="input-group-btn width-min"><button class="btn btn-primary" type="submit" ng-click="vm.downloadReportXls()"><i class="fa fa-download"></i></button></span></div></div></div></div></div></div></div></div><div class="ibox-content" ng-show="vm.financialReports.length"><table datatable="ng" id="room-reservation-by-room-datatable" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" class="table table-striped table-bordered table-hover"><thead><tr><th></th><th><span data-translate="pcsApp.financialReport.regId">Reg Id</span></th><th><span data-translate="pcsApp.financialReport.name">Name</span></th><th><span data-translate="pcsApp.financialReport.regTypes">Reg types</span></th><th><span data-translate="pcsApp.financialReport.payingGroupName">Paying group</span></th><th><span data-translate="pcsApp.financialReport.country">Country</span></th><th><span data-translate="pcsApp.financialReport.city">City</span></th><th><span data-translate="pcsApp.financialReport.workingPlace">Working place</span></th><th><span data-translate="pcsApp.financialReport.phone">Phone</span></th><th><span data-translate="pcsApp.financialReport.email">Email</span></th><th><span data-translate="pcsApp.financialReport.personCost">P cost</span></th><th><span data-translate="pcsApp.financialReport.personPaid">P paid</span></th><th><span data-translate="pcsApp.financialReport.personToPay">P to pay</span></th><th><span data-translate="pcsApp.financialReport.groupCost">G cost</span></th><th><span data-translate="pcsApp.financialReport.groupPaid">G paid</span></th><th><span data-translate="pcsApp.financialReport.groupToPay">G to pay</span></th><th><span data-translate="pcsApp.financialReport.totalCost">T cost</span></th><th><span data-translate="pcsApp.financialReport.totalPaid">T paid</span></th><th><span data-translate="pcsApp.financialReport.totalToPay">T to pay</span></th><th><span data-translate="pcsApp.financialReport.currency">Currency</span></th><th><span data-translate="pcsApp.financialReport.remark">Remark</span></th></tr></thead><tbody><tr ng-repeat="financialReport in vm.financialReports track by financialReport.id"><td><button class="btn btn-info m-b-xs" type="submit" tooltip-placement="right" uib-tooltip="Print confirmation" ng-click="vm.printConfirmation(financialReport.id, financialReport.countryCode)"><i class="fa fa-paperclip"></i></button><send-confirmation-dialog email="{{financialReport.email}}" reg-id="{{financialReport.id}}"><button class="btn btn-info" type="submit" tooltip-placement="right" uib-tooltip="Send confirmation via email"><i class="fa fa-envelope-square email-icon"></i></button></send-confirmation-dialog></td><td>{{financialReport.regId}}</td><td>{{financialReport.name}}</td><td>{{financialReport.regTypes}}</td><td>{{financialReport.payingGroupName}}</td><td>{{financialReport.country}}</td><td>{{financialReport.city}}</td><td>{{financialReport.workingPlace}}</td><td>{{financialReport.phone}}</td><td><email-dialog email="{{financialReport.email}}" last-name="{{financialReport.name}}" first-name="">{{financialReport.email}}</email-dialog></td><td>{{financialReport.personCost}}</td><td>{{financialReport.personPaid}}</td><td>{{financialReport.personToPay}}</td><td>{{financialReport.groupCost}}</td><td>{{financialReport.groupPaid}}</td><td>{{financialReport.groupToPay}}</td><td>{{financialReport.totalCost}}</td><td>{{financialReport.totalPaid}}</td><td>{{financialReport.totalToPay}}</td><td>{{financialReport.currency}}</td><td>{{financialReport.remark}}</td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/financial-report/send-financial-notice-to-all-dialog.html','<form name="editForm" ng-submit="vm.send()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pcsApp.sendFinancialNoticeToAllDialog.home.createLabel">Send confirmation to all</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="pcsApp.sendFinancialNoticeToAllDialog.language">Language</label><div><label><input ng-model="vm.confirmationSettings.language" value="hu" id="languageHu" name="language" type="radio"> Hungarian</label></div><div><label><input ng-model="vm.confirmationSettings.language" value="en" id="languageEn" name="language" type="radio"> English</label></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.sendFinancialNoticeToAllDialog.optionalText" for="field_optionalTextSelector">Optional text</label><ui-select ng-model="vm.selectedOptionalText" ng-change="vm.setOptionalTextMessage($select.selected.optionalText)" name="optionalTextSelector" id="field_optionalTextSelector" theme="bootstrap"><ui-select-match allow-clear="true" placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="optionalText in (vm.optionalTexts | filter: $select.search) track by optionalText.id"><div ng-bind-html="optionalText.name | highlight: $select.search"></div></ui-select-choices></ui-select><textarea class="form-control m-t-sm" name="optionalText" id="field_optionalText" rows="10" autocomplete="off" ng-model="vm.confirmationSettings.optionalText"></textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.send">Send</span></button></div></form>');
$templateCache.put('app/entities/general-registration-report/general-registration-reports.html','<script>$(\'.advanced_search_box__more\').click(function(){\n        $(this).find(\'i\').toggleClass(\'fa-chevron-down\');\n        $(\'#advanced_search_box\').toggleClass(\'hide\');\n        return false;\n    });</script><div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 data-translate="pcsApp.generalRegistrationReport.home.title">Registation Report</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-md-12"><div class="col-md-1 no-padding-left"><input type="text" class="form-control full-width" ng-model="vm.reportFilter.regId" autocomplete="off" id="regId" name="regId" placeholder="{{ \'pcsApp.generalRegistrationReport.regId\' | translate }}"></div><div class="col-md-3 no-padding-left"><input type="text" class="form-control full-width" ng-model="vm.reportFilter.lastName" autocomplete="off" id="lastName" name="lastName" placeholder="{{ \'pcsApp.generalRegistrationReport.lastName\' | translate }}"></div><div class="col-md-3 no-padding-left"><input type="text" class="form-control full-width" ng-model="vm.reportFilter.firstName" autocomplete="off" id="firstName" name="firstName" placeholder="{{ \'pcsApp.generalRegistrationReport.firstName\' | translate }}"></div><div class="col-md-2 no-padding-left"><input type="text" class="form-control full-width" ng-model="vm.reportFilter.invoiceName" autocomplete="off" id="invoiceName" name="invoiceName" placeholder="{{ \'pcsApp.generalRegistrationReport.invoiceName\' | translate }}"></div><div class="col-md-3 input-group"><input type="text" class="form-control full-width" ng-model="vm.reportFilter.email" autocomplete="off" id="email" name="email" placeholder="{{ \'pcsApp.generalRegistrationReport.email\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search()"><span class="glyphicon glyphicon-search"></span></button> <button class="btn btn-danger" ng-if="vm.isFiltered" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button> <button class="btn btn-primary" ng-if="vm.reportList.length" type="submit" ng-click="vm.downloadReportXls()"><i class="fa fa-download"></i></button> <button class="btn btn-success" ng-if="vm.reportList.length" type="submit" ng-click="vm.downloadReportXlsWithQRCode()"><i class="fa fa-qrcode"></i></button></span></div></div></div></div></div></div></div><div class="row"><div class="col-md-12"><a href="#" class="advanced_search_box__more pull-right"><i class="fa fa-chevron-down fa-chevron-up"></i><span data-translate="pcsApp.generalRegistrationReport.advancedSearch">Advanced search</span></a></div></div><div id="advanced_search_box" class="hide"><div class="row"><div class="col-lg-4 col-md-6 col-sm-4"><div class="form-group full-width"><label class="control-label control-label" data-translate="pcsApp.generalRegistrationReport.workplace" for="workplace"></label><ui-select ng-model="vm.reportFilter.workplace" name="workplace" id="workplace" theme="bootstrap" required><ui-select-match allow-clear="true" placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="workplace in (vm.workplaces | filter: $select.search) track by workplace.id"><div ng-bind-html="workplace.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="hr-line-dashed"></div><div class="form-group full-width"><label class="control-label control-label" data-translate="pcsApp.generalRegistrationReport.registrationType" for="registrationType"></label><ui-select ng-model="vm.reportFilter.registrationType" name="registrationType" id="registrationType" theme="bootstrap" required><ui-select-match allow-clear="true" placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="registrationType in (vm.registrationTypes | filter: $select.search) track by registrationType.id"><div ng-bind-html="registrationType.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="hr-line-dashed"></div><div class="form-group full-width"><label class="control-label" data-translate="pcsApp.generalRegistrationReport.position"></label><ui-select ng-model="vm.reportFilter.position" name="position" id="position" theme="bootstrap" required><ui-select-match allow-clear="true" placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected"></span></ui-select-match><ui-select-choices repeat="position in (vm.positions | filter: $select.search) track by position"><div ng-bind-html="position | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="hr-line-dashed"></div><div class="form-group full-width"><label class="control-label" data-translate="pcsApp.generalRegistrationReport.presenter" for="presenter"></label><select class="form-control full-width" name="presenter" ng-model="vm.reportFilter.presenter" id="presenter"><option value="" data-translate="global.form.please.select">Please select</option><option value="true">true</option><option value="false">false</option></select></div><div class="hr-line-dashed"></div><div class="form-group full-width"><label class="control-label" data-translate="pcsApp.generalRegistrationReport.onSpot" for="on-spot"></label><select class="form-control full-width" name="on-spot" ng-model="vm.reportFilter.onSpot" id="on-spot"><option value="" data-translate="global.form.please.select">Please select</option><option value="true">true</option><option value="false">false</option></select></div><div class="hr-line-dashed"></div></div><div class="col-lg-4 col-md-6 col-sm-4"><div class="form-group full-width"><label class="control-label" data-translate="pcsApp.generalRegistrationReport.payingGroup" for="payingGroup"></label><ui-select ng-model="vm.reportFilter.payingGroup" name="payingGroup" id="payingGroup" theme="bootstrap" required><ui-select-match allow-clear="true" placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="payingGroup in (vm.payingGroups | filter: $select.search) track by payingGroup.id"><div ng-bind-html="payingGroup.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="hr-line-dashed"></div><div class="form-group full-width"><label class="control-label control-label" data-translate="pcsApp.generalRegistrationReport.country" for="country"></label><div class="input-group"><span class="input-group-addon"><input type="checkbox" name="countryNegation" id="countryNegation" ng-model="vm.reportFilter.countryNegation" class="ng-valid ng-dirty ng-valid-parse ng-empty ng-touched"></span><ui-select ng-model="vm.reportFilter.country" name="country" id="country" theme="bootstrap" required><ui-select-match allow-clear="true" placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="country in (vm.countries | filter: $select.search) track by country.id"><div ng-bind-html="country.name | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="hr-line-dashed"></div><div class="form-group full-width"><label class="control-label" data-translate="pcsApp.generalRegistrationReport.otherData"></label><ui-select ng-model="vm.reportFilter.otherData" name="otherData" id="otherData" theme="bootstrap" required><ui-select-match allow-clear="true" placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected"></span></ui-select-match><ui-select-choices repeat="otherData in (vm.otherDatas | filter: $select.search) track by otherData"><div ng-bind-html="otherData | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="hr-line-dashed"></div><div class="form-group full-width"><label class="control-label" data-translate="pcsApp.generalRegistrationReport.etiquette" for="etiquette"></label><select class="form-control full-width" name="etiquette" ng-model="vm.reportFilter.etiquette" id="etiquette"><option value="" data-translate="global.form.please.select">Please select</option><option value="true">true</option><option value="false">false</option></select></div><div class="hr-line-dashed"></div><div class="form-group full-width"><label class="control-label" data-translate="pcsApp.generalRegistrationReport.cancelled" for="cancelled"></label><select class="form-control full-width" name="cancelled" ng-model="vm.reportFilter.cancelled" id="cancelled"><option value="" data-translate="global.form.please.select">Please select</option><option value="true">true</option><option value="false">false</option></select></div><div class="hr-line-dashed"></div></div><div class="col-lg-4 col-md-6 col-sm-4"><div class="form-group full-width"><label class="control-label" data-translate="pcsApp.generalRegistrationReport.optionalService" for="optionalService"></label><ui-select ng-model="vm.reportFilter.optionalService" name="optionalService" id="optionalService" theme="bootstrap" required><ui-select-match allow-clear="true" placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="optionalService in (vm.optionalServices | filter: $select.search) track by optionalService.id"><div ng-bind-html="optionalService.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="hr-line-dashed"></div><div class="form-group full-width"><label class="control-label" data-translate="pcsApp.generalRegistrationReport.hotelNames" for="optionalService"></label><ui-select ng-model="vm.reportFilter.congressHotel" name="hotel" id="hotel" theme="bootstrap" required><ui-select-match allow-clear="true" placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.hotel.name"></span></ui-select-match><ui-select-choices repeat="congressHotel in (vm.congressHotels | filter: $select.search) track by congressHotel.id"><div ng-bind-html="congressHotel.hotel.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="hr-line-dashed"></div><div class="form-group full-width clearfix"><label class="control-label" data-translate="pcsApp.generalRegistrationReport.accPeople"></label><div class="col-lg-12"><div class="row"><div class="col-md-6 no-padding-left"><input type="text" class="form-control full-width" ng-model="vm.reportFilter.accPeopleLastName" id="accPeopleLastName" name="accPeopleLastName" placeholder="{{ \'pcsApp.generalRegistrationReport.lastName\' | translate }}"></div><div class="col-md-6 no-padding"><input type="text" class="form-control full-width" ng-model="vm.reportFilter.accPeopleFirstName" id="accPeopleFirstName" name="accPeopleFirstName" placeholder="{{ \'pcsApp.generalRegistrationReport.firstName\' | translate }}"></div></div></div></div><div class="hr-line-dashed"></div><div class="form-group full-width"><label class="control-label" data-translate="pcsApp.generalRegistrationReport.closed" for="closed"></label><select class="form-control full-width" name="closed" ng-model="vm.reportFilter.closed" id="closed"><option value="" data-translate="global.form.please.select">Please select</option><option value="true">true</option><option value="false">false</option></select></div><div class="hr-line-dashed"></div></div></div><div class="row gutter_helper"><div class="col-md-12 form-group"><div class="col-sm-8 col-sm-offset-2"><button class="btn btn-primary m-r-sm" ng-click="vm.search()" type="button" data-translate="entity.action.search">Search</button><send-confirmation-to-all-dialog filter="vm.reportFilter"><button class="btn btn-info m-r-sm" type="button" data-translate="pcsApp.generalRegistrationReport.sendConfirmationToAll">Send confirmation to all</button></send-confirmation-to-all-dialog><send-all-confirmation-to-email-dialog filter="vm.reportFilter"><button class="btn btn-info m-r-sm" type="button" data-translate="pcsApp.generalRegistrationReport.sendAllConfirmationToEmail">Send selected confirmations to email</button></send-all-confirmation-to-email-dialog><send-general-email-to-all-dialog filter="vm.reportFilter"><button class="btn btn-info" type="button" data-translate="pcsApp.generalRegistrationReport.sendGeneralEmailToAll">Send email to all</button></send-general-email-to-all-dialog></div></div></div></div></div><div class="ibox-content" ng-show="vm.reportList.length"><table datatable="ng" id="general-registration-report-datatable" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" class="table table-striped table-bordered table-hover datatable-selector"><thead><tr><th></th><th><span data-translate="pcsApp.generalRegistrationReport.regId">Reg ID</span></th><th><span data-translate="pcsApp.generalRegistrationReport.lastName">Family Name</span></th><th><span data-translate="pcsApp.generalRegistrationReport.firstName">First Name</span></th><th><span data-translate="pcsApp.generalRegistrationReport.shortName">Short Name</span></th><th><span data-translate="pcsApp.generalRegistrationReport.invoiceName">Invoice Name</span></th><th><span data-translate="pcsApp.generalRegistrationReport.title">Title</span></th><th><span data-translate="pcsApp.generalRegistrationReport.position">Position</span></th><th><span data-translate="pcsApp.generalRegistrationReport.zipCode">Zipcode</span></th><th><span data-translate="pcsApp.generalRegistrationReport.city">City</span></th><th><span data-translate="pcsApp.generalRegistrationReport.street">Street</span></th><th><span data-translate="pcsApp.generalRegistrationReport.country">Country</span></th><th><span data-translate="pcsApp.generalRegistrationReport.phone">Phone</span></th><th><span data-translate="pcsApp.generalRegistrationReport.email">Email</span></th><th><span data-translate="pcsApp.generalRegistrationReport.workplaceName">Wp. Name</span></th><th><span data-translate="pcsApp.generalRegistrationReport.workplaceDepartment">Wp. Dept."</span></th><th><span data-translate="pcsApp.generalRegistrationReport.workplaceZipCode">Wp. Zipcode</span></th><th><span data-translate="pcsApp.generalRegistrationReport.workplaceCity">Wp. City</span></th><th><span data-translate="pcsApp.generalRegistrationReport.workplaceStreet">Wp. Street</span></th><th><span data-translate="pcsApp.generalRegistrationReport.workplaceCountry">Wp. Country</span></th><th><span data-translate="pcsApp.generalRegistrationReport.workplacePhone">Wp. Phone</span></th><th><span data-translate="pcsApp.generalRegistrationReport.workplaceEmail">Wp. Email</span></th><th ng-repeat="regTypeColumn in vm.regTypeColumnList"><span data-translate="pcsApp.generalRegistrationReport.registrationTypeColName" data-translate-values="{colName: \'{{ regTypeColumn }}\'}">Reg. type {{regTypeColumn}}</span></th><th><span data-translate="pcsApp.generalRegistrationReport.accompanyingNum">Accompanying No.</span></th><th><span data-translate="pcsApp.generalRegistrationReport.accompanyingNames">Accompanying Names</span></th><th><span data-translate="pcsApp.generalRegistrationReport.otherData">Other data</span></th><th><span data-translate="pcsApp.generalRegistrationReport.hotelNames">Hotel Names</span></th><th><span data-translate="pcsApp.generalRegistrationReport.remark">Remark</span></th></tr></thead><tbody><tr ng-repeat="grr in vm.reportList track by grr.id"><td><button class="btn btn-info m-b-xs" type="submit" tooltip-placement="right" uib-tooltip="Print confirmation" ng-click="vm.printConfirmation(grr.id, grr.countryCode)"><i class="fa fa-paperclip"></i></button> <button class="btn btn-success m-b-xs" type="submit" tooltip-placement="right" uib-tooltip="Registration details" ng-click="vm.showRegistrationDetails(grr.id)"><i class="fa fa-info-circle"></i></button><send-confirmation-dialog email="{{grr.email}}" reg-id="{{grr.id}}"><button class="btn btn-info m-b-xs" type="submit" tooltip-placement="right" uib-tooltip="Send confirmation via email"><i class="fa fa-envelope-square email-icon"></i></button></send-confirmation-dialog></td><td>{{grr.regId}}</td><td>{{grr.lastName}}</td><td>{{grr.firstName}}</td><td>{{grr.shortName}}</td><td>{{grr.invoiceName}}</td><td>{{grr.title}}</td><td>{{grr.position}}</td><td>{{grr.zipCode}}</td><td>{{grr.city}}</td><td>{{grr.street}}</td><td>{{grr.country}}</td><td>{{grr.phone}}</td><td><email-dialog email="{{grr.email}}" last-name="{{grr.lastName}}" first-name="{{grr.firstName}}">{{grr.email}}</email-dialog></td><td>{{grr.workplaceName}}</td><td>{{grr.workplaceDepartment}}</td><td>{{grr.workplaceZipCode}}</td><td>{{grr.workplaceCity}}</td><td>{{grr.workplaceStreet}}</td><td>{{grr.workplaceCountry}}</td><td>{{grr.workplacePhone}}</td><td>{{grr.workplaceEmail}}</td><td ng-repeat="regTypeColumn in vm.regTypeColumnList">{{vm.getAvailableRegType(grr, regTypeColumn)}}</td><td>{{grr.accompanyingNum ? grr.accompanyingNum : ""}}</td><td>{{grr.accompanyingNames}}</td><td>{{grr.otherData}}</td><td>{{grr.hotelNames}}</td><td>{{grr.remark}}</td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/general-registration-report/send-all-confirmation-to-email-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.send()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myLabel" data-translate="pcsApp.sendAllConfirmationToEmailDialog.home.createLabel">Sending selected confirmations to email</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="pcsApp.sendAllConfirmationToEmailDialog.email" for="field_email">Email</label><input type="email" class="form-control" name="email" id="field_email" autocomplete="off" required ng-model="vm.confirmationSettings.sendAllEmail" ng-maxlength="64"><div ng-show="editForm.email.$invalid"><p class="error-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p><p class="error-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.sendAllConfirmationToEmailDialog.language">Language</label><div><label><input ng-model="vm.confirmationSettings.language" value="hu" id="languageHu" name="language" type="radio"> Hungarian</label></div><div><label><input ng-model="vm.confirmationSettings.language" value="en" id="languageEn" name="language" type="radio"> English</label></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.sendAllConfirmationToEmailDialog.optionalText" for="field_optionalTextSelector">Optional text</label><ui-select ng-model="vm.selectedOptionalText" ng-change="vm.setOptionalTextMessage($select.selected.optionalText)" name="optionalTextSelector" id="field_optionalTextSelector" theme="bootstrap"><ui-select-match allow-clear="true" placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="optionalText in (vm.optionalTexts | filter: $select.search) track by optionalText.id"><div ng-bind-html="optionalText.name | highlight: $select.search"></div></ui-select-choices></ui-select><textarea class="form-control m-t-sm" name="optionalText" id="field_optionalText" rows="10" autocomplete="off" ng-model="vm.confirmationSettings.optionalText"></textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.send">Send</span></button></div></form>');
$templateCache.put('app/entities/general-registration-report/send-confirmation-to-all-dialog.html','<form name="editForm" ng-submit="vm.send()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pcsApp.sendConfirmationToAllDialog.home.createLabel">Send confirmation to all</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="pcsApp.sendConfirmationToAllDialog.language">Language</label><div><label><input ng-model="vm.confirmationSettings.language" value="hu" id="languageHu" name="language" type="radio"> Hungarian</label></div><div><label><input ng-model="vm.confirmationSettings.language" value="en" id="languageEn" name="language" type="radio"> English</label></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.sendConfirmationToAllDialog.optionalText" for="field_optionalTextSelector">Optional text</label><ui-select ng-model="vm.selectedOptionalText" ng-change="vm.setOptionalTextMessage($select.selected.optionalText)" name="optionalTextSelector" id="field_optionalTextSelector" theme="bootstrap"><ui-select-match allow-clear="true" placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="optionalText in (vm.optionalTexts | filter: $select.search) track by optionalText.id"><div ng-bind-html="optionalText.name | highlight: $select.search"></div></ui-select-choices></ui-select><textarea class="form-control m-t-sm" name="optionalText" id="field_optionalText" rows="10" autocomplete="off" ng-model="vm.confirmationSettings.optionalText"></textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.send">Send</span></button></div></form>');
$templateCache.put('app/entities/general-registration-report/send-general-email-to-all-dialog.html','<form name="editForm" ng-submit="vm.send()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pcsApp.sendGeneralEmailToAllDialog.home.createLabel">Send email to all</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="pcsApp.sendGeneralEmailToAllDialog.topic" for="field_topic">Topic</label><input type="text" class="form-control" name="topic" id="field_topic" autocomplete="off" ng-model="vm.registrationSettings.topic" ng-maxlength="200"><div ng-show="editForm.topic.$invalid"><p class="error-block" ng-show="editForm.topic.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.topic.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="200">This field cannot be longer than 200 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.sendGeneralEmailToAllDialog.emailBody" for="field_emailBody">Email</label><summernote id="field_emailBody" ng-model="vm.registrationSettings.emailBody" ng-required="true" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.emailBody.$invalid"><p class="help-block" ng-show="editForm.emailBody.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.emailBody.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 1000 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.send">Send</span></button></div></form>');
$templateCache.put('app/entities/group-discount-invoice/group-discount-invoice-set-payment-date-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myGroupDiscountInvoiceLabel" data-translate="pcsApp.groupDiscountInvoice.home.setPaymentDateLabel">Create or edit a Group Invoice</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="pcsApp.groupDiscountInvoice.dateOfGroupPayment" for="field_paymentDate">Date Of Group Payment</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'paymentDate\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_paymentDate" type="text" class="form-control" name="paymentDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.groupDiscountInvoice.paymentDate" is-open="vm.datePickerOpenStatus.paymentDate"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/group-discount-invoice/group-discount-invoice-storno-dialog.html','<form name="stornoForm" ng-submit="vm.confirmStorno()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="pcsApp.groupDiscountInvoice.home.stornoLabel">Confirm storno operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="pcsApp.groupDiscountInvoice.confirmation.storno" translate-values="{invoiceNumber: \'{{vm.groupDiscountInvoice.invoiceNumber}}\'}">Are you sure you want to storno this invoice?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="stornoForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.ok">OK</span></button></div></form>');
$templateCache.put('app/entities/group-discount-invoice/group-discount-invoices.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 data-translate="pcsApp.groupDiscountInvoice.home.title">Group Invoices</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-content"><table datatable="ng" id="group-discount-invoice-datatable" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span data-translate="pcsApp.groupDiscountInvoice.invoiceNumber">Invoice Number</span></th><th><span data-translate="pcsApp.groupDiscountInvoice.storno">Storno</span></th><th><span data-translate="pcsApp.groupDiscountInvoice.stornoInvoiceNumber">Storno Invoice Number</span></th><th><span data-translate="pcsApp.groupDiscountInvoice.name">Name</span></th><th><span data-translate="pcsApp.groupDiscountInvoice.dateOfGroupPayment">Date Of Groug Payment</span></th><th><span data-translate="pcsApp.groupDiscountInvoice.createdDate">Created Date</span></th><th><span data-translate="pcsApp.groupDiscountInvoice.payingGroup">Paying Group</span></th><th></th></tr></thead><tbody><tr ng-repeat="groupDiscountInvoice in vm.groupDiscountInvoices track by groupDiscountInvoice.id"><td>{{groupDiscountInvoice.invoice.invoiceNumber}}</td><td>{{groupDiscountInvoice.invoice.stornired}}</td><td>{{groupDiscountInvoice.invoice.stornoInvoiceNumber}}</td><td>{{groupDiscountInvoice.invoice.name1}}</td><td>{{groupDiscountInvoice.dateOfGroupPayment | date:\'mediumDate\'}}</td><td>{{groupDiscountInvoice.invoice.createdDate | date:\'mediumDate\'}}</td><td>{{groupDiscountInvoice.payingGroup.name}}</td><td><button class="btn btn-info" type="button" tooltip-placement="left" uib-tooltip="Download pdf" ng-click="vm.downloadPdf(groupDiscountInvoice.id)"><i class="fa fa-download"></i></button> <button class="btn btn-info" type="button" tooltip-placement="left" uib-tooltip="Download xls report" ng-click="vm.downloadXls(groupDiscountInvoice.id)"><i class="fa fa-file-excel-o"></i></button> <button class="btn btn-danger" type="submit" ng-hide="groupDiscountInvoice.invoice.storno || groupDiscountInvoice.invoice.stornired" ui-sref="group-discount-invoice.storno({id: groupDiscountInvoice.id})" tooltip-placement="left" uib-tooltip="Storno invoice"><i class="fa fa-undo"></i></button> <button class="btn btn-success" type="submit" ng-hide="groupDiscountInvoice.invoice.storno || groupDiscountInvoice.invoice.stornired" ui-sref="group-discount-invoice.set-payment-date({id: groupDiscountInvoice.id})" tooltip-placement="left" uib-tooltip="Set payment date"><i class="fa fa-calendar"></i></button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/group-discount-invoice-history/group-discount-invoice-histories.html','<div><h2 data-translate="pcsApp.groupDiscountInvoiceHistory.home.title">Group Invoice Histories</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="group-discount-invoice-history.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="pcsApp.groupDiscountInvoiceHistory.home.createLabel">Create new Group Invoice History</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="pcsApp.groupDiscountInvoiceHistory.chargeableItemId">Chargeable Item Id</span></th><th><span data-translate="pcsApp.groupDiscountInvoiceHistory.chargeableItemType">Chargeable Item Type</span></th><th><span data-translate="pcsApp.groupDiscountInvoiceHistory.df">Df</span></th><th><span data-translate="pcsApp.groupDiscountInvoiceHistory.groupDiscountInvoice">Group Invoice</span></th><th></th></tr></thead><tbody><tr ng-repeat="groupDiscountInvoiceHistory in vm.groupDiscountInvoiceHistories track by groupDiscountInvoiceHistory.id"><td><a ui-sref="group-discount-invoice-history-detail({id:groupDiscountInvoiceHistory.id})">{{groupDiscountInvoiceHistory.id}}</a></td><td>{{groupDiscountInvoiceHistory.chargeableItemId}}</td><td data-translate="{{\'pcsApp.ChargeableItemType.\' + groupDiscountInvoiceHistory.chargeableItemType}}">{{groupDiscountInvoiceHistory.chargeableItemType}}</td><td>{{groupDiscountInvoiceHistory.df}}</td><td><a ui-sref="group-discount-invoice-detail({id:groupDiscountInvoiceHistory.groupDiscountInvoice.id})">{{groupDiscountInvoiceHistory.groupDiscountInvoice.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="group-discount-invoice-history-detail({id:groupDiscountInvoiceHistory.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="group-discount-invoice-history.edit({id:groupDiscountInvoiceHistory.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="group-discount-invoice-history.delete({id:groupDiscountInvoiceHistory.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/group-discount-invoice-history/group-discount-invoice-history-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.groupDiscountInvoiceHistory.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.groupDiscountInvoiceHistory.delete.question" translate-values="{id: \'{{vm.groupDiscountInvoiceHistory.id}}\'}">Are you sure you want to delete this Group Invoice History?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/group-discount-invoice-history/group-discount-invoice-history-detail.html','<div><h2><span data-translate="pcsApp.groupDiscountInvoiceHistory.detail.title">Group Invoice History</span> {{vm.groupDiscountInvoiceHistory.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="pcsApp.groupDiscountInvoiceHistory.chargeableItemId">Chargeable Item Id</span></dt><dd><span>{{vm.groupDiscountInvoiceHistory.chargeableItemId}}</span></dd><dt><span data-translate="pcsApp.groupDiscountInvoiceHistory.chargeableItemType">Chargeable Item Type</span></dt><dd><span data-translate="{{\'pcsApp.ChargeableItemType.\' + vm.groupDiscountInvoiceHistory.chargeableItemType}}">{{vm.groupDiscountInvoiceHistory.chargeableItemType}}</span></dd><dt><span data-translate="pcsApp.groupDiscountInvoiceHistory.df">Df</span></dt><dd><span>{{vm.groupDiscountInvoiceHistory.df}}</span></dd><dt><span data-translate="pcsApp.groupDiscountInvoiceHistory.groupDiscountInvoice">Group Invoice</span></dt><dd><a ui-sref="group-discount-invoice-detail({id:vm.groupDiscountInvoiceHistory.groupDiscountInvoice.id})">{{vm.groupDiscountInvoiceHistory.groupDiscountInvoice.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="group-discount-invoice-history-detail.edit({id:vm.groupDiscountInvoiceHistory.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/group-discount-invoice-history/group-discount-invoice-history-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myGroupDiscountInvoiceHistoryLabel" data-translate="pcsApp.groupDiscountInvoiceHistory.home.createOrEditLabel">Create or edit a Group Invoice History</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.groupDiscountInvoiceHistory.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.groupDiscountInvoiceHistory.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="pcsApp.groupDiscountInvoiceHistory.chargeableItemId" for="field_chargeableItemId">Chargeable Item Id</label><input type="number" class="form-control" name="chargeableItemId" id="field_chargeableItemId" ng-model="vm.groupDiscountInvoiceHistory.chargeableItemId"></div><div class="form-group"><label class="control-label" data-translate="pcsApp.groupDiscountInvoiceHistory.chargeableItemType" for="field_chargeableItemType">Chargeable Item Type</label><select class="form-control" name="chargeableItemType" ng-model="vm.groupDiscountInvoiceHistory.chargeableItemType" id="field_chargeableItemType"><option value="REGISTRATION" data-translate="pcsApp.ChargeableItemType.REGISTRATION">REGISTRATION</option><option value="HOTEL" data-translate="pcsApp.ChargeableItemType.HOTEL">HOTEL</option><option value="OPTIONAL_SERVICE" data-translate="pcsApp.ChargeableItemType.OPTIONAL_SERVICE">OPTIONAL_SERVICE</option><option value="MISCELLANEOUS" data-translate="pcsApp.ChargeableItemType.MISCELLANEOUS">MISCELLANEOUS</option></select></div><div class="form-group"><label class="control-label" data-translate="pcsApp.groupDiscountInvoiceHistory.df" for="field_df">Df</label><input type="text" class="form-control" name="df" id="field_df" ng-model="vm.groupDiscountInvoiceHistory.df"></div><div class="form-group"><label data-translate="pcsApp.groupDiscountInvoiceHistory.groupDiscountInvoice" for="field_groupDiscountInvoice">Group Invoice</label><select class="form-control" id="field_groupDiscountInvoice" name="groupDiscountInvoice" ng-model="vm.groupDiscountInvoiceHistory.groupDiscountInvoice" ng-options="groupDiscountInvoice as groupDiscountInvoice.id for groupDiscountInvoice in vm.groupdiscountinvoices track by groupDiscountInvoice.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/group-discount-item/group-discount-item-invoice-setup-dialog.html','<div class="row wrapper border-bottom white-bg page-heading"><div style="padding-left: 15px"><h2 data-translate="pcsApp.groupDiscountInvoice.home.setupLabel" translate-values="{name: \'{{vm.invoice.payingGroup.name}}\'}">Print setup of creating invoice for {{vm.invoice.payingGroup.name}}</h2></div></div><jhi-alert-error></jhi-alert-error><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><form name="editForm" role="form" novalidate ng-submit="vm.printInvoice()" show-validation><div class="ibox" ng-show="!vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.groupDiscountInvoice.language\' | translate}}</strong></div><div class="ibox-content"><div><label><input ng-model="vm.invoice.language" value="hu" id="languageHu" name="language" type="radio"> Hungarian</label></div><div><label><input ng-model="vm.invoice.language" value="en" id="languageEn" name="language" type="radio"> English</label></div></div></div><div class="ibox" ng-show="!vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.groupDiscountInvoice.navVatCategory\' | translate}}</strong><!--<div ibox-tools></div>--></div><div class="ibox-content"><select class="form-control" name="navVatCategory" ng-model="vm.invoice.navVatCategory" id="field_navVatCategory" ng-change="vm.navVatCategoryChanged()" required><option value="" data-translate="global.form.please.select">Please select</option><option value="DOMESTIC_NORMAL_VAT_TAX_NUMBER" data-translate="pcsApp.NavVatCategory.DOMESTIC_NORMAL_VAT_TAX_NUMBER">DOMESTIC_NORMAL_VAT_TAX_NUMBER</option><option value="PRIVATE_PERSON" data-translate="pcsApp.NavVatCategory.PRIVATE_PERSON">PRIVATE_PERSON</option><option value="EU_VAT_EU_TAX_NUMBER" data-translate="pcsApp.NavVatCategory.EU_VAT_EU_TAX_NUMBER">EU_VAT_EU_TAX_NUMBER</option><option value="OTHER_COUNTRY" data-translate="pcsApp.NavVatCategory.OTHER_COUNTRY">OTHER_COUNTRY</option><option value="EU_NO_VAT_EU_TAX_NUMBER" data-translate="pcsApp.NavVatCategory.EU_NO_VAT_EU_TAX_NUMBER">EU_NO_VAT_EU_TAX_NUMBER</option><option value="OTHER_CUSTOMER" data-translate="pcsApp.NavVatCategory.OTHER_CUSTOMER">OTHER_CUSTOMER</option><option value="DOMESTIC_GROUP_VAT_TAX_NUMBER" data-translate="pcsApp.NavVatCategory.DOMESTIC_GROUP_VAT_TAX_NUMBER">DOMESTIC_GROUP_VAT_TAX_NUMBER</option></select></div></div><div class="ibox" ng-show="!vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.groupDiscountInvoice.home.billingInfoLabel\' | translate}}</strong><!--<div ibox-tools></div>--></div><div class="ibox-content"><div class="form-group"><label class="control-label" data-translate="pcsApp.groupDiscountInvoice.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.invoice.name" ng-maxlength="64"><div ng-show="editForm.name.$invalid"><p class="error-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.groupDiscountInvoice.taxNumber" for="field_taxNumber">Tax number</label><input type="text" class="form-control" name="taxNumber" id="field_taxNumber" ng-required="vm.isTaxNumberRequired()" ng-pattern="vm.taxNumberPattern" ng-disabled="vm.isTaxNumberDisabled()" ng-model="vm.invoice.taxNumber" ng-maxlength="64"><div ng-show="editForm.taxNumber.$invalid"><p class="error-block" ng-show="editForm.taxNumber.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.taxNumber.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p><p class="error-block" ng-show="editForm.taxNumber.$error.pattern" data-translate="entity.validation.pattern" data-translate-values="{ pattern: \'12345678-1-12\' }">Ez a mez\u0151 csak ad\xF3sz\xE1m form\xE1tumot tartalmazhat pl.: 12345678-1-12</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.groupDiscountInvoice.city" for="field_city">City</label><input type="text" class="form-control" name="city" id="field_city" required ng-model="vm.invoice.city" ng-maxlength="64"><div ng-show="editForm.city.$invalid"><p class="error-block" ng-show="editForm.city.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.city.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.groupDiscountInvoice.zipCode" for="field_zipCode">ZipCode</label><input type="text" class="form-control" name="zipCode" id="field_zipCode" required ng-model="vm.invoice.zipCode" ng-maxlength="64"><div ng-show="editForm.zipCode.$invalid"><p class="error-block" ng-show="editForm.zipCode.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.zipCode.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.groupDiscountInvoice.street" for="field_street">Street</label><input type="text" class="form-control" name="street" id="field_street" required ng-model="vm.invoice.street" ng-maxlength="128"><div ng-show="editForm.street.$invalid"><p class="error-block" ng-show="editForm.street.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.street.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="128">This field cannot be longer than 128 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.groupDiscountInvoice.country" for="field_country">Country</label><ui-select ng-model="vm.invoice.country" name="country" id="field_country" theme="bootstrap"><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="country.code as country in (vm.countries | filter: $select.search) track by country.code"><div ng-bind-html="country.name | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.country.$invalid"><p class="error-block" ng-show="editForm.country.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="ibox" ng-show="!vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.groupDiscountInvoice.home.invoiceSetupDateLabel\' | translate}}</strong><!--<div ibox-tools></div>--></div><div class="ibox-content"><div class="form-group"><label class="control-label" data-data-translate="pcsApp.groupDiscountInvoice.startDate" for="field_startDate">Start Date</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_startDate" type="text" class="form-control" name="startDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.invoice.startDate" is-open="vm.datePickerOpenStatus.startDate" required></div><div ng-show="editForm.startDate.$invalid"><p class="error-block" ng-show="editForm.startDate.$error.required" data-data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-data-translate="pcsApp.groupDiscountInvoice.endDate" for="field_endDate">End Date</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_endDate" type="text" class="form-control" name="endDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.invoice.endDate" is-open="vm.datePickerOpenStatus.endDate" date-less-than="{{vm.invoice.startDate}}" required></div><div ng-show="editForm.endDate.$invalid"><p class="error-block" ng-show="editForm.endDate.$error.required" data-data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.endDate.$error.dateLessThan" data-translate="pcsApp.groupDiscountInvoice.message.endDateLessThanStartDate">End date must be later than Start date.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.groupDiscountInvoice.dateOfFulfilment" for="field_dateOfFulfilment">End Date</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateOfFulfilment\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_dateOfFulfilment" type="text" class="form-control" name="dateOfFulfilment" uib-datepicker-popup="{{dateformat}}" ng-model="vm.invoice.dateOfFulfilment" is-open="vm.datePickerOpenStatus.dateOfFulfilment" required></div><div ng-show="editForm.dateOfFulfilment.$invalid"><p class="error-block" ng-show="editForm.dateOfFulfilment.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.dateOfFulfilment.$error.dateLessThan" translate="pcsApp.groupDiscountInvoice.message.dateOfFulfilmentLessThanStartDate">Date of fullfilment must be later than Start date.</p></div></div><div class="form-group"><label class="control-label" data-data-translate="pcsApp.groupDiscountInvoice.paymentDeadline" for="field_paymentDeadline">Payment deadline</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'paymentDeadline\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_paymentDeadline" type="text" class="form-control" name="paymentDeadline" uib-datepicker-popup="{{dateformat}}" ng-model="vm.invoice.paymentDeadline" is-open="vm.datePickerOpenStatus.paymentDeadline" required></div><div ng-show="editForm.paymentDeadline.$invalid"><p class="error-block" ng-show="editForm.paymentDeadline.$error.required" data-data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="pcsApp.groupDiscountInvoice.bankAccount" for="field_bankAccount">Bank account</label><ui-select ng-model="vm.invoice.bankAccount" name="bankAccount" id="field_bankAccount" theme="bootstrap" required><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="bankAccount in (bankAccounts | filter: $select.search) track by bankAccount.id"><div ng-bind-html="bankAccount.name | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.bankAccount.$invalid"><p class="error-block" ng-show="editForm.bankAccount.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="ibox" ng-show="!vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.groupDiscountInvoice.home.paymentMethodLabel\' | translate}}</strong><!--<div ibox-tools></div>--></div><div class="ibox-content"><div><label><input ng-model="vm.invoice.billingMethod" value="TRANSFER" id="paymentTransfer" ng-click="vm.changeBillingMethod()" name="billingMethod" type="radio"> Transfer</label></div><div><label><input ng-model="vm.invoice.billingMethod" value="CASH" id="paymentCash" ng-click="vm.changeBillingMethod()" name="billingMethod" type="radio"> Cash</label></div><div><label><input ng-model="vm.invoice.billingMethod" value="CARD" id="paymentCreditCard" ng-click="vm.changeBillingMethod()" name="billingMethod" type="radio"> Credit card</label></div></div></div><div class="ibox" ng-show="!vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.optionalText.optionalText\' | translate}}:</strong><div class="input-group m-b"><span class="input-group-btn"><button class="btn btn-primary" type="submit" ui-sref="group-discount-item.optional-text-new"><i class="fa fa-plus"></i></button></span><ui-select ng-model="vm.selectedOptionalText" ng-change="vm.setOptionalTextMessage($select.selected.optionalText)" name="optionalTextSelector" id="field_optionalTextSelector" theme="bootstrap"><ui-select-match allow-clear="true" placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="optionalText in (vm.optionalTexts | filter: $select.search) track by optionalText.id"><div ng-bind-html="optionalText.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><!--<div ibox-tools></div>--></div><div class="ibox-content"><div class="text-center"><textarea class="form-control" name="optionalText" id="field_optionalText" rows="5" autocomplete="off" ng-model="vm.invoice.optionalText">\n                        </textarea></div></div></div><div class="ibox" ng-show="!vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><button type="button" ng-click="vm.showConfirmationPanel()" ng-disabled="!vm.isAnyItemSelectedForInvoicing() || editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="pcsApp.groupDiscountInvoice.sendInvoiceByMail">Send invoice by mail</span></button> <button type="button" ng-click="vm.printInvoice()" ng-disabled="!vm.isAnyItemSelectedForInvoicing() || editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-print"></span>&nbsp;<span data-translate="pcsApp.groupDiscountInvoice.printInvoice">Print invoice</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()" ui-sref="group-discount-item"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button></div></div></form><form name="confirmationForm" role="form" novalidate ng-submit="vm.sendAndPrintInvoice()" show-validation><div class="ibox" ng-show="vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.groupDiscountInvoice.confirmation.email\' | translate}}:</strong><div class="input-group m-b"><input class="form-control" name="invoiceEmail" ng-minlength="5" ng-maxlength="255" ng-model="vm.invoiceEmail" type="email" required> <span class="input-group-btn"><button type="submit" class="btn btn-primary"><span data-translate="entity.action.send">Send</span></button> <button type="button" ng-click="vm.isShowConfirmationPanel = false;" class="btn btn-default"><span data-translate="entity.action.cancel">Cancel</span></button></span></div><div ng-show="confirmationForm.confirmationEmail.$invalid"><p class="error-block" ng-show="confirmationForm.invoiceEmail.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="confirmationForm.invoiceEmail.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="error-block" ng-show="confirmationForm.invoiceEmail.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="5">This field is required to be at least 5 characters.</p><p class="error-block" ng-show="confirmationForm.invoiceEmail.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div></div></form></div></div></div>');
$templateCache.put('app/entities/group-discount-item/group-discount-item-selection-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.select()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myGroupDiscountItemLabel" data-translate="pcsApp.groupDiscountItem.home.createOrEditLabel">Create or edit a Group Discount Item</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="pcsApp.groupDiscountItem.payingGroup" for="field_payingGroup">Paying Group</label><ui-select ng-model="vm.groupDiscountItemFilter.payingGroup" name="payingGroup" id="field_payingGroup" theme="bootstrap" required><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="payingGroup in (vm.payingGroups | filter: $select.search) track by payingGroup.id"><div ng-bind-html="payingGroup.name | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.payingGroup.$invalid"><p class="error-block" ng-show="editForm.payingGroup.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.groupDiscountItem.chargeableItemType" for="field_chargeableItemType">Chargeable Item Type</label><select class="form-control" name="chargeableItemType" ng-model="vm.groupDiscountItemFilter.chargeableItemType" id="field_chargeableItemType" required><option value="" data-translate="global.form.please.select">Please select</option><option value="ALL" data-translate="pcsApp.ChargeableItemType.ALL">ALL</option><option value="REGISTRATION" data-translate="pcsApp.ChargeableItemType.REGISTRATION">REGISTRATION</option><option value="HOTEL" data-translate="pcsApp.ChargeableItemType.HOTEL">HOTEL</option><option value="OPTIONAL_SERVICE" data-translate="pcsApp.ChargeableItemType.OPTIONAL_SERVICE">OPTIONAL_SERVICE</option><option value="MISCELLANEOUS" data-translate="pcsApp.ChargeableItemType.MISCELLANEOUS">MISCELLANEOUS</option></select><div ng-show="editForm.chargeableItemType.$invalid"><p class="error-block" ng-show="editForm.chargeableItemType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.select">Select</span></button></div></form>');
$templateCache.put('app/entities/group-discount-item/group-discount-items.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 data-translate="pcsApp.groupDiscountItem.home.title">Group financial administration</h2><small class="text-danger" ng-show="!vm.hasValidCurrencyRate">Please add valid currency rate in order to make valid invoices!</small></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-primary" type="submit" ui-sref="group-discount-item.selection"><i class="fa fa-search-plus"></i></button> <button class="btn btn-primary" type="submit" ng-show="vm.groupDiscountItemFilter.payingGroup" ng-disabled="!vm.isSelectedPayingGroupInvoiceable() || !vm.isAnyChargeableItemIdSelected() || !vm.hasValidCurrencyRate" ui-sref="group-discount-item.setup"><i class="fa fa-dollar"></i></button> <button class="btn btn-primary" type="submit" ng-show="vm.groupDiscountItemFilter.payingGroup" ng-click="vm.downloadReportXls()"><i class="fa fa-download"></i></button> <button class="btn btn-primary" type="submit" ng-show="vm.groupDiscountItemFilter.payingGroup" ng-click="vm.downloadProFormaGroupInvoiceReportXls()"><i class="fa fa-file-excel-o"></i></button>&nbsp;&nbsp; &nbsp;&nbsp; <span ng-show="vm.groupDiscountItemFilter.payingGroup">Paying group: <strong>{{vm.groupDiscountItemFilter.payingGroup.name}}</strong>&nbsp;&nbsp;</span> <span ng-show="vm.groupDiscountItemFilter.chargeableItemType">Item type: <strong data-translate="pcsApp.ChargeableItemType.{{vm.groupDiscountItemFilter.chargeableItemType}}">{{vm.groupDiscountItemFilter.chargeableItemType}}</strong></span><p ng-show="vm.sumRegistration || vm.sumHotel || vm.sumOptionalService"><small>Registration: <strong>{{vm.sumRegistration}}</strong>&nbsp;&nbsp;&nbsp;Hotel: <strong>{{vm.sumHotel}}</strong>&nbsp;&nbsp;&nbsp;Optional service: <strong>{{vm.sumOptionalService}}</strong></small></p><p ng-show="vm.groupPaidRegistration || vm.groupPaidHotel || vm.groupPaidOptionalService"><small>Group paid registration: <strong>{{vm.groupPaidRegistration}}</strong>&nbsp;&nbsp;&nbsp;Group paid hotel: <strong>{{vm.groupPaidHotel}}</strong>&nbsp;&nbsp;&nbsp;Group paid optional service: <strong>{{vm.groupPaidOptionalService}}</strong></small></p><p ng-show="vm.groupPaidRegistration || vm.groupPaidHotel || vm.groupPaidOptionalService"><small>Group to be paid registration: <strong>{{vm.sumRegistration - vm.groupPaidRegistration}}</strong>&nbsp;&nbsp;&nbsp;Group to be paid hotel: <strong>{{vm.sumHotel - vm.groupPaidHotel}}</strong>&nbsp;&nbsp;&nbsp;Group paid optional service: <strong>{{vm.sumOptionalService - vm.groupPaidOptionalService}}</strong></small></p></div><div class="ibox-content" ng-show="vm.groupDiscountItems.length"><table datatable="ng" id="group-discount-item-datatable" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" class="table table-striped table-bordered table-hover"><thead><tr><th><input ng-model="vm.allChargeableItemIdSelected" ng-change="vm.toggleAllGroupDiscountSelection()" type="checkbox"></th><th><span data-translate="pcsApp.groupDiscountItem.regId">Reg Id</span></th><th><span data-translate="pcsApp.groupDiscountItem.lastName">Last Name</span></th><th><span data-translate="pcsApp.groupDiscountItem.firstName">First Name</span></th><th><span data-translate="pcsApp.groupDiscountItem.chargeableItemType">Chargeable Item Type</span></th><th><span data-translate="pcsApp.groupDiscountItem.payingGroup">Paying Group</span></th><th><span data-translate="pcsApp.groupDiscountItem.payingGroupItemName">Paying Group Item Name</span></th><th><span data-translate="pcsApp.groupDiscountItem.amount">Amount</span></th><th><span data-translate="pcsApp.groupDiscountItem.dateOfPayment">Date Of Payment</span></th><th><span data-translate="pcsApp.groupDiscountItem.invoiceNumber">Invoice Number</span></th></tr></thead><tbody><tr ng-repeat="groupDiscountItem in vm.groupDiscountItems track by groupDiscountItem.id"><td><input ng-show="!groupDiscountItem.invoiceNumber" ng-model="vm.groupDiscountItemFilter.selectedChargeableItemIds[groupDiscountItem.chargeableItemId.toString()]" ng-change="vm.toggleGroupDiscountSelection(groupDiscountItem.chargeableItemId)" type="checkbox"></td><td>{{groupDiscountItem.regId}}</td><td>{{groupDiscountItem.lastName}}</td><td>{{groupDiscountItem.firstName}}</td><td data-translate="{{\'pcsApp.ChargeableItemType.\' + groupDiscountItem.chargeableItemType}}">{{groupDiscountItem.chargeableItemType}}</td><td>{{groupDiscountItem.payingGroup.name}}</td><td>{{groupDiscountItem.payingGroupItemName}}</td><td>{{groupDiscountItem.amount}}</td><td>{{groupDiscountItem.dateOfPayment | date:\'mediumDate\'}}</td><td>{{groupDiscountItem.invoiceNumber}}</td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/group-discount-payment/group-discount-payment-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.groupDiscountPayment.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.groupDiscountPayment.delete.question" translate-values="{id: \'{{vm.groupDiscountPayment.id}}\'}">Are you sure you want to delete this Group Discount Payment?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/group-discount-payment/group-discount-payment-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myGroupDiscountPaymentLabel" data-translate="pcsApp.groupDiscountPayment.home.createOrEditLabel">Create or edit a Group Discount Payment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="pcsApp.groupDiscountPayment.payingGroup" for="field_payingGroup">Paying Group</label><ui-select ng-model="vm.groupDiscountPayment.payingGroup" name="payingGroup" id="field_payingGroup" theme="bootstrap" required><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="payingGroup in (vm.payingGroups | filter: $select.search) track by payingGroup.id"><div ng-bind-html="payingGroup.name | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.payingGroup.$invalid"><p class="error-block" ng-show="editForm.payingGroup.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.groupDiscountPayment.paymentType" for="field_paymentType">Payment Type</label><select class="form-control" name="paymentType" ng-model="vm.groupDiscountPayment.paymentType" id="field_paymentType" required><option value="" data-translate="global.form.please.select">Please select</option><option value="REGISTRATION" data-translate="pcsApp.ChargeableItemType.REGISTRATION">REGISTRATION</option><option value="HOTEL" data-translate="pcsApp.ChargeableItemType.HOTEL">HOTEL</option><option value="OPTIONAL_SERVICE" data-translate="pcsApp.ChargeableItemType.OPTIONAL_SERVICE">OPTIONAL_SERVICE</option><option value="MISCELLANEOUS" data-translate="pcsApp.ChargeableItemType.MISCELLANEOUS">MISCELLANEOUS</option></select><div ng-show="editForm.paymentType.$invalid"><p class="error-block" ng-show="editForm.paymentType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.groupDiscountPayment.amount" for="field_amount">Amount</label><input type="number" class="form-control" name="amount" id="field_amount" ng-model="vm.groupDiscountPayment.amount" required min="0" max="100000000"><div ng-show="editForm.amount.$invalid"><p class="error-block" ng-show="editForm.amount.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.amount.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be more than 0.</p><p class="error-block" ng-show="editForm.amount.$error.max" data-translate="entity.validation.max" translate-value-max="100000000">This field cannot be more than 100000000.</p><p class="error-block" ng-show="editForm.amount.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label translate="pcsApp.groupDiscountPayment.currency" for="field_currency">Currency</label><ui-select ng-model="vm.groupDiscountPayment.currency" name="currency" id="field_currency" theme="bootstrap" required><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.currency"></span></ui-select-match><ui-select-choices repeat="currency in (vm.currencies | filter: $select.search) track by currency.id"><div ng-bind-html="currency.currency | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.currency.$invalid"><p class="error-block" ng-show="editForm.currency.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.groupDiscountPayment.dateOfPayment" for="field_dateOfPayment">Date of payment</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateOfPayment\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_dateOfPayment" type="text" class="form-control" name="dateOfPayment" uib-datepicker-popup="{{dateformat}}" ng-model="vm.groupDiscountPayment.dateOfPayment" is-open="vm.datePickerOpenStatus.dateOfPayment" required></div><div ng-show="editForm.dateOfPayment.$invalid"><p class="error-block" ng-show="editForm.dateOfPayment.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/group-discount-payment/group-discount-payments.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 translate="pcsApp.groupDiscountPayment.home.title">Group Payments</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-primary" type="submit" ui-sref="group-discount-payment.new"><i class="fa fa-plus"></i></button><!--<div ibox-tools></div>--></div><div class="ibox-content"><table datatable="ng" id="group-discount-payment-datatable" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span data-translate="pcsApp.groupDiscountPayment.payingGroup">Paying Group</span></th><th><span data-translate="pcsApp.groupDiscountPayment.paymentType">Payment Type</span></th><th><span data-translate="pcsApp.groupDiscountPayment.amount">Amount</span></th><th><span data-translate="pcsApp.groupDiscountPayment.currency">Currency</span></th><th><span data-translate="pcsApp.groupDiscountPayment.dateOfPayment">Date Of Payment</span></th><th></th></tr></thead><tbody><tr ng-repeat="groupDiscountPayment in vm.groupDiscountPayments track by groupDiscountPayment.id"><td>{{groupDiscountPayment.payingGroup.name}}</td><td data-translate="{{\'pcsApp.ChargeableItemType.\' + groupDiscountPayment.paymentType}}">{{groupDiscountPayment.paymentType}}</td><td>{{groupDiscountPayment.amount}}</td><td>{{groupDiscountPayment.currency.currency}}</td><td>{{groupDiscountPayment.dateOfPayment | date:\'mediumDate\'}}</td><td><button class="btn btn-info" type="submit" ui-sref="group-discount-payment.edit({id:groupDiscountPayment.id})"><i class="fa fa-pencil-square-o"></i></button> <button class="btn btn-danger" type="submit" ui-sref="group-discount-payment.delete({id:groupDiscountPayment.id})"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/hotel/hotel-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.hotel.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.hotel.delete.question" translate-values="{id: \'{{vm.hotel.id}}\'}">Are you sure you want to delete this Hotel?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/hotel/hotel-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myHotelLabel" data-translate="pcsApp.hotel.home.createOrEditLabel">Create or edit a Hotel</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="pcsApp.hotel.code" for="field_code">Code</label><input type="text" class="form-control" name="code" id="field_code" autocomplete="off" ng-model="vm.hotel.code" required ng-minlength="3" ng-maxlength="16"><div ng-show="editForm.code.$invalid"><p class="error-block" ng-show="editForm.code.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.code.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 3 characters.</p><p class="error-block" ng-show="editForm.code.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="16">This field cannot be longer than 16 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.hotel.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" autocomplete="off" ng-model="vm.hotel.name" required ng-maxlength="255"><div ng-show="editForm.name.$invalid"><p class="error-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.hotel.city" for="field_city">City</label><input type="text" class="form-control" name="city" id="field_city" autocomplete="off" ng-model="vm.hotel.city" required ng-maxlength="255"><div ng-show="editForm.city.$invalid"><p class="error-block" ng-show="editForm.city.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.city.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.hotel.street" for="field_street">Street</label><input type="text" class="form-control" name="street" id="field_street" autocomplete="off" ng-model="vm.hotel.street" required ng-maxlength="255"><div ng-show="editForm.street.$invalid"><p class="error-block" ng-show="editForm.street.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.street.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.hotel.zipCode" for="field_zipCode">Zip Code</label><input type="text" class="form-control" name="zipCode" id="field_zipCode" autocomplete="off" ng-model="vm.hotel.zipCode" required ng-maxlength="32"><div ng-show="editForm.zipCode.$invalid"><p class="error-block" ng-show="editForm.zipCode.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.zipCode.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.hotel.latitude" for="field_latitude">Latitude</label><input type="number" class="form-control" name="latitude" id="field_latitude" autocomplete="off" ng-model="vm.hotel.latitude"></div><div class="form-group"><label class="control-label" data-translate="pcsApp.hotel.longitude" for="field_longitude">Longitude</label><input type="number" class="form-control" name="longitude" id="field_longitude" autocomplete="off" ng-model="vm.hotel.longitude"></div><div class="form-group"><label class="control-label" data-translate="pcsApp.hotel.phone" for="field_phone">Phone</label><input type="text" class="form-control" name="phone" id="field_phone" autocomplete="off" ng-model="vm.hotel.phone" ng-maxlength="64"><div ng-show="editForm.phone.$invalid"><p class="error-block" ng-show="editForm.phone.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.hotel.fax" for="field_fax">Fax</label><input type="text" class="form-control" name="fax" id="field_fax" autocomplete="off" ng-model="vm.hotel.fax" ng-maxlength="64"><div ng-show="editForm.fax.$invalid"><p class="error-block" ng-show="editForm.fax.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.hotel.email" for="field_email">Email</label><input type="email" class="form-control" name="email" id="field_email" autocomplete="off" ng-model="vm.hotel.email" ng-maxlength="64"><div ng-show="editForm.email.$invalid"><p class="error-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p><p class="error-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.hotel.contactName" for="field_contactName">Contact Name</label><input type="text" class="form-control" name="contactName" id="field_contactName" autocomplete="off" ng-model="vm.hotel.contactName" ng-maxlength="128"><div ng-show="editForm.contactName.$invalid"><p class="error-block" ng-show="editForm.contactName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="128">This field cannot be longer than 128 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/hotel/hotels.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 translate="pcsApp.hotel.home.title">Hotels</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-primary" type="submit" ui-sref="hotel.new"><i class="fa fa-plus"></i></button><!--<div ibox-tools></div>--></div><div class="ibox-content"><table datatable="ng" id="hotel-datatable" dt-options="dtOptions" dt-column-defs="dtColumnDefs" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.hotel.code">Code</span></th><th><span translate="pcsApp.hotel.name">Name</span></th><th><span translate="pcsApp.hotel.city">City</span></th><th><span translate="pcsApp.hotel.street">Street</span></th><th><span translate="pcsApp.hotel.zipCode">Zip code</span></th><th><span translate="pcsApp.hotel.phone">Phone</span></th><th><span translate="pcsApp.hotel.email">Email</span></th><th><span translate="pcsApp.hotel.contactName">Contact name</span></th><th></th></tr></thead><tbody><tr ng-repeat="hotel in vm.hotels track by hotel.id"><td>{{hotel.code}}</td><td>{{hotel.name}}</td><td>{{hotel.city}}</td><td>{{hotel.street}}</td><td>{{hotel.zipCode}}</td><td>{{hotel.phone}}</td><td>{{hotel.email}}</td><td>{{hotel.contactName}}</td><td><button class="btn btn-info" type="submit" ui-sref="hotel.edit({id:hotel.id})"><i class="fa fa-pencil-square-o"></i></button> <button class="btn btn-danger" type="submit" ui-sref="hotel.delete({id:hotel.id})"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/hotel-general-report/hotel-general-reports.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 data-translate="pcsApp.hotelGeneralReport.home.title">Hotel General Report</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-primary" type="submit" ng-click="vm.downloadReportXls()"><i class="fa fa-download"></i></button></div><div class="ibox-content" ng-show="vm.hotelGeneralReports.length"><table datatable="ng" id="hotel-general-datatable" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" class="table table-striped table-bordered table-hover"><thead><tr><th><span data-translate="pcsApp.hotelGeneralReport.regId">Reg Id</span></th><th><span data-translate="pcsApp.hotelGeneralReport.name">Name</span></th><th><span data-translate="pcsApp.hotelGeneralReport.regTypes">Reg types</span></th><th><span data-translate="pcsApp.hotelGeneralReport.payingGroupName">Paying group</span></th><th><span data-translate="pcsApp.hotelGeneralReport.country">Country</span></th><th><span data-translate="pcsApp.hotelGeneralReport.city">City</span></th><th><span data-translate="pcsApp.hotelGeneralReport.phone">Phone</span></th><th><span data-translate="pcsApp.hotelGeneralReport.email">Email</span></th><th><span data-translate="pcsApp.hotelGeneralReport.hotelName">Hotel name</span></th><th><span data-translate="pcsApp.hotelGeneralReport.roomType">Room type</span></th><th><span data-translate="pcsApp.hotelGeneralReport.arrivalDate">Arrival date</span></th><th><span data-translate="pcsApp.hotelGeneralReport.departureDate">Departure date</span></th><th><span data-translate="pcsApp.hotelGeneralReport.roomMates">Room mates</span></th></tr></thead><tbody><tr ng-repeat="hotelGeneralReport in vm.hotelGeneralReports track by hotelGeneralReport.id"><td>{{hotelGeneralReport.regId}}</td><td>{{hotelGeneralReport.name}}</td><td>{{hotelGeneralReport.regTypes}}</td><td>{{hotelGeneralReport.payingGroupName}}</td><td>{{hotelGeneralReport.country}}</td><td>{{hotelGeneralReport.city}}</td><td>{{hotelGeneralReport.phone}}</td><td><email-dialog email="{{hotelGeneralReport.email}}" last-name="{{hotelGeneralReport.name}}" first-name="">{{hotelGeneralReport.email}}</email-dialog></td><td>{{hotelGeneralReport.hotelName}}</td><td>{{hotelGeneralReport.roomType}}</td><td>{{hotelGeneralReport.arrivalDate}}</td><td>{{hotelGeneralReport.departureDate}}</td><td>{{hotelGeneralReport.roomMates}}</td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/hotel-summary/hotel-summary-selection-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.select()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="hotelSummaryLabel" data-translate="pcsApp.hotelSummary.home.createOrEditLabel">Create or edit a Group Discount Item</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="pcsApp.hotelSummary.hotel" for="field_hotel">Hotel</label><ui-select ng-model="vm.listFilter.congressHotel" name="hotel" id="field_hotel" theme="bootstrap" required><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.hotel.name"></span></ui-select-match><ui-select-choices repeat="congressHotel in (vm.congressHotels | filter: $select.search) track by congressHotel.id"><div ng-bind-html="congressHotel.hotel.name | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.hotel.$invalid"><p class="error-block" ng-show="editForm.hotel.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.select">Select</span></button></div></form>');
$templateCache.put('app/entities/hotel-summary/hotel-summary.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 data-translate="pcsApp.hotelSummary.home.title">Room Reservation By Rooms</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-primary" type="submit" ui-sref="hotel-summary.selection"><i class="fa fa-search-plus"></i></button> <button class="btn btn-primary" type="submit" ng-show="vm.listFilter.congressHotel" ng-click="vm.downloadReportXls()"><i class="fa fa-download"></i></button>&nbsp;&nbsp; <span ng-show="vm.listFilter.congressHotel">Hotel: <strong>{{vm.listFilter.congressHotel.hotel.name}}</strong>&nbsp;&nbsp;</span></div><div class="ibox-content" ng-show="vm.hotelSummary.cells.length"><table datatable="ng" id="hotel-summary-datatable" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" class="table table-striped table-bordered table-hover"><thead><tr><th><span data-translate="pcsApp.hotelSummary.reservationDate">Reservation date</span></th><th ng-repeat="column in vm.hotelSummary.columns"><span>{{ column.roomType }}</span></th><th><span data-translate="pcsApp.hotelSummary.total">Total</span></th></tr></thead><tbody><tr ng-repeat="rowDate in vm.hotelSummary.rows" ng-init="reservationDate = rowDate"><td>{{reservationDate | date: \'mediumDate\'}}</td><td ng-repeat="column in vm.hotelSummary.columns">{{vm.getNightFromCell(reservationDate, column.roomId)}}</td><td>{{vm.getTotalByReservationDate(reservationDate)}}</td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/invoice/invoice-dialog.html','<div class="row wrapper border-bottom white-bg page-heading"><div style="padding-left: 15px"><h2 translate="pcsApp.invoice.home.createLabel" translate-values="{lastName: \'{{vm.invoice.registration.lastName}}\', firstName: \'{{vm.invoice.registration.firstName}}\'}">Create a new invoice for {{vm.invoice.registration.lastName + \', \' + invoice.registration.firstName}}</h2></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.registrationRegistrationType.home.title\' | translate}}</strong></div><div class="ibox-content"><table id="registration-type-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.registrationRegistrationType.registrationType">Registration Type</span></th><th><span translate="pcsApp.registrationRegistrationType.accPeople">Acc People</span></th><th><span translate="pcsApp.registrationRegistrationType.regFee">Price</span></th><th><span translate="pcsApp.registration.confirmation.groupPaid">Group paid</span></th><th><span translate="pcsApp.registration.confirmation.priceAlreadyPaid">Price already paid</span></th><th><span translate="pcsApp.registration.confirmation.priceToBePaid">Price to be paid</span></th><th><span translate="pcsApp.registration.confirmation.ignore">Ignore</span></th></tr></thead><tbody><tr ng-repeat="rrt in vm.registrationRegistrationTypes track by rrt.id"><td>{{rrt.registrationTypeName}}</td><td>{{rrt.accPeople}}</td><td>{{rrt.chargeableItemPrice | number : 2}} {{rrt.chargeableItemCurrency}}</td><td>{{vm.getGroupPaid(rrt) + \' \' + rrt.chargeableItemCurrency}}</td><td>{{vm.getPriceAlreadyPaid(rrt.id) | number : 2}} {{rrt.chargeableItemCurrency}}</td><td>{{vm.getPriceToBePaid(rrt.priceWithDiscount, rrt.id) | number : 2}} {{rrt.chargeableItemCurrency}}</td><td><input ng-model="vm.invoice.ignoredChargeableItems[rrt.id.toString()]" ng-checked="vm.invoice.ignoredChargeableItems[rrt.id.toString()]" ng-disabled="vm.isChargeableItemDisabled(rrt.id)" ng-change="vm.toggleIgnoreChargeableItem(rrt.id)" type="checkbox"></td></tr><tr ng-show="vm.registrationRegistrationTypes.length"><td colspan="2">&nbsp;</td><td><strong>{{(vm.registrationRegistrationTypes | sumByKey: \'chargeableItemPrice\') | number : 2}} {{vm.registrationRegistrationTypes[0].chargeableItemCurrency}}</strong></td><td><strong>{{ vm.sumGroupAlreadyPaid(vm.registrationRegistrationTypes) + \' \' + vm.registrationRegistrationTypes[0].chargeableItemCurrency }}</strong></td><td><strong>{{vm.sumPriceAlreadyPaid(vm.registrationRegistrationTypes) | number : 2}} {{vm.registrationRegistrationTypes[0].chargeableItemCurrency}}</strong></td><td><strong>{{vm.sumPriceToBePaid(vm.registrationRegistrationTypes) | number : 2}} {{vm.registrationRegistrationTypes[0].chargeableItemCurrency}}</strong></td><td></td></tr></tbody></table></div></div><div class="ibox"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.roomReservation.home.title\' | translate}}</strong><!--<div ibox-tools></div>--></div><div class="ibox-content"><table id="room-reservation-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.roomReservation.id">Res #</span></th><th><span translate="pcsApp.roomReservation.room">Room type</span></th><th><span translate="pcsApp.roomReservation.hotel">Hotel</span></th><th><span translate="pcsApp.roomReservation.shared">Shared</span></th><th><span translate="pcsApp.roomReservation.arrivalDate">Arrival Date</span></th><th><span translate="pcsApp.roomReservation.departureDate">Departure Date</span></th><th><span translate="pcsApp.roomReservation.price">Price</span></th><th><span translate="pcsApp.registration.confirmation.groupPaid">Group paid</span></th><th><span translate="pcsApp.registration.confirmation.priceAlreadyPaid">Price already paid</span></th><th><span translate="pcsApp.registration.confirmation.priceToBePaid">Price to be paid</span></th><th><span translate="pcsApp.registration.confirmation.ignore">Ignore</span></th></tr></thead><tbody><tr ng-repeat="rr in vm.roomReservations track by rr.id"><td>{{rr.id}}</td><td>{{rr.roomType}}</td><td>{{rr.hotelName}}</td><td>{{rr.shared}}</td><td>{{rr.arrivalDate | date:\'mediumDate\'}}</td><td>{{rr.departureDate | date:\'mediumDate\'}}</td><td>{{rr.chargeableItemPrice | number : 2}} {{rr.chargeableItemCurrency}}</td><td>{{vm.getGroupPaid(rr) + \' \' + rr.chargeableItemCurrency}}</td><td>{{vm.getPriceAlreadyPaid(rr.id) | number : 2}} {{rr.chargeableItemCurrency}}</td><td>{{vm.getPriceToBePaid(rr.priceWithDiscount, rr.id) | number : 2}} {{rr.chargeableItemCurrency}}</td><td><input ng-model="vm.invoice.ignoredChargeableItems[rr.id.toString()]" ng-checked="vm.invoice.ignoredChargeableItems[rr.id.toString()]" ng-disabled="vm.isChargeableItemDisabled(rr.id)" ng-change="vm.toggleIgnoreChargeableItem(rr.id)" type="checkbox"></td></tr><tr ng-show="vm.roomReservations.length"><td colspan="6">&nbsp;</td><td><strong>{{(vm.roomReservations | sumByKey: \'chargeableItemPrice\') | number : 2}} {{vm.roomReservations[0].chargeableItemCurrency}}</strong></td><td><strong>{{ vm.sumGroupAlreadyPaid(vm.roomReservations) + \' \' + vm.roomReservations[0].chargeableItemCurrency }}</strong></td><td><strong>{{vm.sumPriceAlreadyPaid(vm.roomReservations) | number : 2}} {{vm.roomReservations[0].chargeableItemCurrency}}</strong></td><td><strong>{{vm.sumPriceToBePaid(vm.roomReservations) | number : 2}} {{vm.roomReservations[0].chargeableItemCurrency}}</strong></td><td></td></tr></tbody></table></div></div><div class="ibox"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.orderedOptionalService.home.title\' | translate}}</strong><!--<div ibox-tools></div>--></div><div class="ibox-content"><table id="optional-service-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.orderedOptionalService.optionalService">Optional Service</span></th><th><span translate="pcsApp.orderedOptionalService.participant">Participant</span></th><th><span translate="pcsApp.orderedOptionalService.price">Price</span></th><th><span translate="pcsApp.registration.confirmation.groupPaid">Group paid</span></th><th><span translate="pcsApp.registration.confirmation.priceAlreadyPaid">Price already paid</span></th><th><span translate="pcsApp.registration.confirmation.priceToBePaid">Price to be paid</span></th><th><span translate="pcsApp.registration.confirmation.ignore">Ignore</span></th></tr></thead><tbody><tr ng-repeat="oos in vm.orderedOptionalServices track by oos.id"><td>{{oos.chargeableItemName}}</td><td>{{oos.participant}}</td><td>{{oos.chargeableItemPrice | number : 2}} {{oos.chargeableItemCurrency}}</td><td>{{vm.getGroupPaid(oos) + \' \' + oos.chargeableItemCurrency}}</td><td>{{vm.getPriceAlreadyPaid(oos.id) | number : 2}} {{oos.chargeableItemCurrency}}</td><td>{{vm.getPriceToBePaid(oos.priceWithDiscount, oos.id) | number : 2}} {{oos.chargeableItemCurrency}}</td><td><input ng-model="vm.invoice.ignoredChargeableItems[oos.id.toString()]" ng-checked="vm.invoice.ignoredChargeableItems[oos.id.toString()]" ng-disabled="vm.isChargeableItemDisabled(oos.id)" ng-change="vm.toggleIgnoreChargeableItem(oos.id)" type="checkbox"></td></tr><tr ng-show="vm.orderedOptionalServices.length"><td colspan="2">&nbsp;</td><td><strong>{{(vm.orderedOptionalServices | sumByKey: \'chargeableItemPrice\') | number : 2}} {{vm.orderedOptionalServices[0].chargeableItemCurrency}}</strong></td><td><strong>{{ vm.sumGroupAlreadyPaid(vm.orderedOptionalServices) + \' \' + vm.orderedOptionalServices[0].chargeableItemCurrency }}</strong></td><td><strong>{{vm.sumPriceAlreadyPaid(vm.orderedOptionalServices) | number : 2}} {{vm.orderedOptionalServices[0].chargeableItemCurrency}}</strong></td><td><strong>{{vm.sumPriceToBePaid(vm.orderedOptionalServices) | number : 2}} {{vm.orderedOptionalServices[0].chargeableItemCurrency}}</strong></td><td></td></tr></tbody></table></div></div><div class="ibox"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.chargedService.home.title\' | translate}}</strong><!--<div ibox-tools></div>--></div><div class="ibox-content"><table id="charged-service-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.chargedService.paymentMode">Payment mode</span></th><th><span translate="pcsApp.chargedService.paymentType">Payment type</span></th><th><span translate="pcsApp.chargedService.chargeableItem">Chargeable item</span></th><th><span translate="pcsApp.chargedService.amount">Amount</span></th><th><span translate="pcsApp.chargedService.dateOfPayment">Date of Payment</span></th><th><span translate="pcsApp.chargedService.invoiceNumber">Invoice number</span></th><th><span translate="pcsApp.registration.confirmation.ignore">Ignore</span></th></tr></thead><tbody><tr ng-repeat="chargedService in vm.chargedServices track by chargedService.id"><td><span translate="pcsApp.ChargedServicePaymentMode.{{chargedService.paymentMode}}">{{chargedService.paymentMode}}</span></td><td><span translate="pcsApp.ChargeableItemType.{{chargedService.paymentType}}">{{chargedService.paymentType}}</span></td><td>{{chargedService.chargeableItemName}}</td><td>{{chargedService.amount | number : 2}} {{chargedService.chargeableItemCurrency}}</td><td>{{chargedService.dateOfPayment | date:\'mediumDate\'}}</td><td>{{chargedService.invoiceNumber}}</td><td><input ng-model="vm.invoice.ignoredChargedServices[chargedService.id.toString()]" ng-checked="vm.invoice.ignoredChargedServices[chargedService.id.toString()]" ng-disabled="vm.isChargedServiceDisabled(chargedService.id)" ng-change="vm.toggleIgnoreChargedService(chargedService.id)" type="checkbox"></td></tr><tr ng-show="vm.chargedServices.length"><td colspan="3">&nbsp;</td><td><strong>{{(vm.chargedServices | sumByKey: \'amount\') | number : 2}} {{vm.chargedServices[0].chargeableItem.chargeableItemCurrency}}</strong></td><td colspan="2">&nbsp;</td><td></td></tr></tbody></table></div></div><div class="ibox"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.invoice.totalDue\' | translate}}: {{vm.calculateTotalDue() | number : 2}}</strong></div></div><div class="ibox"><div class="ibox-title float-e-margins"><button type="button" ui-sref="invoice.setup" ng-disabled="editForm.$invalid || !vm.isInvoiceable()" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="pcsApp.invoice.createInvoice">Create invoice</span></button> <button type="button" class="btn btn-default" ui-sref="invoice({id: invoice.registration.id})"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></div></div></div></div>');
$templateCache.put('app/entities/invoice/invoice-set-payment-date-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="invoiceLabel" data-translate="pcsApp.invoice.home.setPaymentDateLabel">Create or edit a Invoice</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="pcsApp.invoice.dateOfPayment" for="field_paymentDate">Date Of Payment</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'paymentDate\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_paymentDate" type="text" class="form-control" name="paymentDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.invoice.paymentDate" is-open="vm.datePickerOpenStatus.paymentDate"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/invoice/invoice-setup-dialog.html','<div class="row wrapper border-bottom white-bg page-heading"><div style="padding-left: 15px"><h2 translate="pcsApp.invoice.home.setupLabel" translate-values="{lastName: \'{{vm.registration.lastName}}\', firstName: \'{{vm.registration.firstName}}\'}">Print setup of creating invoice for {{vm.registration.lastName + \', \' + vm.registration.firstName}}</h2></div></div><jhi-alert-error></jhi-alert-error><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><form name="editForm" role="form" novalidate ng-submit="vm.printInvoice()" show-validation><div class="ibox" ng-show="!vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.invoice.language\' | translate}}</strong><!--<div ibox-tools></div>--></div><div class="ibox-content"><div><label><input ng-model="vm.invoice.language" value="hu" id="languageHu" name="language" type="radio" ng-click="vm.setInvoiceName()"> Hungarian</label></div><div><label><input ng-model="vm.invoice.language" value="en" id="languageEn" name="language" type="radio" ng-click="vm.setInvoiceName()"> English</label></div></div></div><div class="ibox" ng-show="!vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.invoice.navVatCategory\' | translate}}</strong><!--<div ibox-tools></div>--></div><div class="ibox-content"><select class="form-control" name="navVatCategory" ng-model="vm.invoice.navVatCategory" id="navVatCategory" ng-change="vm.navVatCategoryChanged()" required><option value="" data-translate="global.form.please.select">Please select</option><option value="DOMESTIC_NORMAL_VAT_TAX_NUMBER" data-translate="pcsApp.NavVatCategory.DOMESTIC_NORMAL_VAT_TAX_NUMBER">DOMESTIC_NORMAL_VAT_TAX_NUMBER</option><option value="PRIVATE_PERSON" data-translate="pcsApp.NavVatCategory.PRIVATE_PERSON">PRIVATE_PERSON</option><option value="EU_VAT_EU_TAX_NUMBER" data-translate="pcsApp.NavVatCategory.EU_VAT_EU_TAX_NUMBER">EU_VAT_EU_TAX_NUMBER</option><option value="OTHER_COUNTRY" data-translate="pcsApp.NavVatCategory.OTHER_COUNTRY">OTHER_COUNTRY</option><option value="EU_NO_VAT_EU_TAX_NUMBER" data-translate="pcsApp.NavVatCategory.EU_NO_VAT_EU_TAX_NUMBER">EU_NO_VAT_EU_TAX_NUMBER</option><option value="OTHER_CUSTOMER" data-translate="pcsApp.NavVatCategory.OTHER_CUSTOMER">OTHER_CUSTOMER</option><option value="DOMESTIC_GROUP_VAT_TAX_NUMBER" data-translate="pcsApp.NavVatCategory.DOMESTIC_GROUP_VAT_TAX_NUMBER">DOMESTIC_GROUP_VAT_TAX_NUMBER</option></select></div></div><div class="ibox" ng-show="!vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.invoice.home.billingInfoLabel\' | translate}}</strong><!--<div ibox-tools></div>--></div><div class="ibox-content"><div class="form-group"><label class="control-label" translate="pcsApp.invoice.name1" for="field_name1">Name1</label><input type="text" class="form-control" name="name1" id="field_name1" required ng-model="vm.invoice.name1" ng-maxlength="64"><div ng-show="editForm.name1.$invalid"><p class="error-block" ng-show="editForm.name1.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.name1.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="200">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" translate="pcsApp.invoice.name2" for="field_name2">Name2</label><input type="text" class="form-control" name="name2" id="field_name2" ng-required="vm.isname2Required()" ng-model="vm.invoice.name2" ng-maxlength="64"><div ng-show="editForm.name2.$invalid"><p class="error-block" ng-show="editForm.name2.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.name2.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="200">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" translate="pcsApp.invoice.vatRegNumber" for="field_vatRegNumber">VatRegNumber</label><input type="text" class="form-control" name="vatRegNumber" id="field_vatRegNumber" ng-required="vm.isTaxNumberRequired()" ng-pattern="vm.taxNumberPattern" ng-disabled="vm.isTaxNumberDisabled()" ng-model="vm.invoice.vatRegNumber" ng-maxlength="64"><div ng-show="editForm.vatRegNumber.$invalid"><p class="error-block" ng-show="editForm.vatRegNumber.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.vatRegNumber.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p><p class="error-block" ng-show="editForm.vatRegNumber.$error.pattern" data-translate="entity.validation.pattern" data-translate-values="{ pattern: \'12345678-1-12\' }">Ez a mez\u0151 csak ad\xF3sz\xE1m form\xE1tumot tartalmazhat pl.: 12345678-1-12</p></div></div><div class="form-group"><label class="control-label" translate="pcsApp.invoice.city" for="field_city">City</label><input type="text" class="form-control" name="city" id="field_city" required ng-model="vm.invoice.city" ng-maxlength="64"><div ng-show="editForm.city.$invalid"><p class="error-block" ng-show="editForm.city.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.city.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" translate="pcsApp.invoice.zipCode" for="field_zipCode">ZipCode</label><input type="text" class="form-control" name="zipCode" id="field_zipCode" required ng-model="vm.invoice.zipCode" ng-maxlength="64"><div ng-show="editForm.zipCode.$invalid"><p class="error-block" ng-show="editForm.zipCode.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.zipCode.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" translate="pcsApp.invoice.street" for="field_street">Street</label><input type="text" class="form-control" name="street" id="field_street" required ng-model="vm.invoice.street" ng-maxlength="128"><div ng-show="editForm.street.$invalid"><p class="error-block" ng-show="editForm.street.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.street.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="128">This field cannot be longer than 128 characters.</p></div></div><div class="form-group"><label class="control-label" translate="pcsApp.invoice.country" for="field_country">Country</label><ui-select ng-model="vm.invoice.country" name="country" id="field_country" theme="bootstrap"><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="country.code as country in (vm.countries | filter: $select.search) track by country.code"><div ng-bind-html="country.name | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.country.$invalid"><p class="error-block" ng-show="editForm.country.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="ibox" ng-show="!vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.invoice.home.invoiceSetupDateLabel\' | translate}}</strong><!--<div ibox-tools></div>--></div><div class="ibox-content"><div class="form-group"><label class="control-label" data-translate="pcsApp.invoice.startDate" for="field_startDate">Start Date</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_startDate" type="text" class="form-control" name="startDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.invoice.startDate" is-open="vm.datePickerOpenStatus.startDate" required></div><div ng-show="editForm.startDate.$invalid"><p class="error-block" ng-show="editForm.startDate.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.invoice.endDate" for="field_endDate">End Date</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_endDate" type="text" class="form-control" name="endDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.invoice.endDate" is-open="vm.datePickerOpenStatus.endDate" date-less-than="{{vm.invoice.startDate}}" required></div><div ng-show="editForm.endDate.$invalid"><p class="error-block" ng-show="editForm.endDate.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.endDate.$error.dateLessThan" translate="pcsApp.invoice.message.endDateLessThanStartDate">End date must be later than Start date.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.invoice.dateOfFulfilment" for="field_dateOfFulfilment">End Date</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateOfFulfilment\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_dateOfFulfilment" type="text" class="form-control" name="dateOfFulfilment" uib-datepicker-popup="{{dateformat}}" ng-model="vm.invoice.dateOfFulfilment" is-open="vm.datePickerOpenStatus.dateOfFulfilment" required></div><div ng-show="editForm.dateOfFulfilment.$invalid"><p class="error-block" ng-show="editForm.dateOfFulfilment.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.dateOfFulfilment.$error.dateLessThan" translate="pcsApp.invoice.message.dateOfFulfilmentLessThanStartDate">Date of fullfilment must be later than Start date.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.invoice.paymentDeadline" for="field_paymentDeadline">Start Date</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'paymentDeadline\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_paymentDeadline" type="text" class="form-control" name="paymentDeadline" uib-datepicker-popup="{{dateformat}}" ng-model="vm.invoice.paymentDeadline" is-open="vm.datePickerOpenStatus.paymentDeadline" required></div><div ng-show="editForm.paymentDeadline.$invalid"><p class="error-block" ng-show="editForm.paymentDeadline.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label translate="pcsApp.invoice.bankAccount" for="field_bankAccount">Bank account</label><ui-select ng-model="vm.invoice.bankAccount" name="bankAccount" id="field_bankAccount" theme="bootstrap" required><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="bankAccount in (bankAccounts | filter: $select.search) track by bankAccount.id"><div ng-bind-html="bankAccount.name | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.bankAccount.$invalid"><p class="error-block" ng-show="editForm.bankAccount.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="ibox" ng-show="!vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.invoice.home.paymentMethodLabel\' | translate}}</strong><!--<div ibox-tools></div>--></div><div class="ibox-content"><div><label><input ng-model="vm.invoice.billingMethod" value="TRANSFER" id="paymentTransfer" ng-click="vm.changeBillingMethod()" name="billingMethod" type="radio"> Transfer</label></div><div><label><input ng-model="vm.invoice.billingMethod" value="CASH" id="paymentCash" ng-click="vm.changeBillingMethod()" name="billingMethod" type="radio"> Cash</label></div><div><label><input ng-model="vm.invoice.billingMethod" value="CARD" id="paymentCreditCard" ng-click="vm.changeBillingMethod()" name="billingMethod" type="radio"> Credit card</label></div></div></div><div class="ibox" ng-show="!vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.optionalText.optionalText\' | translate}}:</strong><div class="input-group m-b"><span class="input-group-btn"><button class="btn btn-primary" type="submit" ui-sref="invoice.optional-text-new"><i class="fa fa-plus"></i></button></span><ui-select ng-model="vm.selectedOptionalText" ng-change="vm.setOptionalTextMessage($select.selected.optionalText)" name="optionalTextSelector" id="field_optionalTextSelector" theme="bootstrap"><ui-select-match allow-clear="true" placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="optionalText in (vm.optionalTexts | filter: $select.search) track by optionalText.id"><div ng-bind-html="optionalText.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><!--<div ibox-tools></div>--></div><div class="ibox-content"><div class="text-center"><textarea class="form-control" name="optionalText" id="field_optionalText" rows="5" autocomplete="off" ng-model="vm.invoice.optionalText">\n                        </textarea></div></div></div><div class="ibox" ng-show="!vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><button type="button" ng-click="vm.showConfirmationPanel()" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="pcsApp.invoice.sendInvoiceByMail">Send invoice by mail</span></button> <button type="button" ng-click="vm.printInvoice()" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-print"></span>&nbsp;<span translate="pcsApp.invoice.printInvoice">Print invoice</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()" ui-sref="invoice.new({id: registration.id})"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></div></form><form name="confirmationForm" role="form" novalidate ng-submit="vm.sendAndPrintInvoice()" show-validation><div class="ibox" ng-show="vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.invoice.confirmation.email\' | translate}}:</strong><div class="input-group m-b"><input class="form-control" name="invoiceEmail" ng-minlength="5" ng-maxlength="255" ng-model="vm.invoiceEmail" type="email" required> <span class="input-group-btn"><button type="submit" class="btn btn-primary"><span translate="entity.action.send">Send</span></button> <button type="button" ng-click="vm.isShowConfirmationPanel = false;" class="btn btn-default"><span translate="entity.action.cancel">Cancel</span></button></span></div><div ng-show="confirmationForm.confirmationEmail.$invalid"><p class="error-block" ng-show="confirmationForm.invoiceEmail.$error.required" translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="confirmationForm.invoiceEmail.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="error-block" ng-show="confirmationForm.invoiceEmail.$error.minlength" translate="entity.validation.minlength" translate-value-min="5">This field is required to be at least 5 characters.</p><p class="error-block" ng-show="confirmationForm.invoiceEmail.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div></div></form></div></div></div>');
$templateCache.put('app/entities/invoice/invoice-storno-dialog.html','<form name="stornoForm" ng-submit="vm.confirmStorno()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="pcsApp.invoice.home.stornoLabel">Confirm storno operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="pcsApp.invoice.confirmation.storno" translate-values="{invoiceNumber: \'{{vm.invoice.invoiceNumber}}\'}">Are you sure you want to storno this invoice?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="stornoForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.ok">OK</span></button></div></form>');
$templateCache.put('app/entities/invoice/invoices.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 translate="pcsApp.invoice.home.invoiceListLabel" translate-values="{lastName: \'{{vm.registration.lastName}}\', firstName: \'{{vm.registration.firstName}}\'}">Invoices for {{vm.registration.lastName}}, {{vm.registration.firstName}}</h2><small class="text-danger" ng-show="!vm.hasValidCurrencyRate">Please add valid currency rate in order to make valid invoices!</small></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button ng-show="vm.hasValidCurrencyRate" class="btn btn-primary" type="submit" ui-sref="invoice.new"><i class="fa fa-plus"></i></button> <button class="btn btn-info" type="submit" ui-sref="registration({registrationId: vm.registration.id})"><i class="fa fa-arrow-left"></i></button></div><div class="ibox-content"><table id="invoice-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.invoice.invoiceNumber">Invoice Number</span></th><th><span translate="pcsApp.invoice.storno">Storno</span></th><th><span translate="pcsApp.invoice.stornoInvoiceNumber">Storno Invoice Number</span></th><th><span translate="pcsApp.invoice.createdDate">Created Date</span></th><th><span translate="pcsApp.invoice.dateOfPayment">Date of payment</span></th><th></th></tr></thead><tbody><tr ng-repeat="invoice in vm.invoices track by invoice.id"><td>{{invoice.invoiceNumber}}</td><td>{{invoice.storno}}</td><td>{{invoice.stornoInvoiceNumber}}</td><td>{{invoice.createdDate | date:\'mediumDate\'}}</td><td>{{invoice.dateOfPayment}}</td><td><send-invoice-email-dialog invoice="{{invoice.id}}" email="{{vm.registration.email}}"><button class="btn btn-info" tooltip-placement="top" uib-tooltip="Resend invoice via email" type="button"><i class="fa fa-envelope"></i></button></send-invoice-email-dialog><button class="btn btn-info" type="button" tooltip-placement="top" uib-tooltip="Download invoice" ng-click="vm.downloadPdf(invoice.id)"><i class="fa fa-download"></i></button> <button class="btn btn-danger" type="submit" tooltip-placement="top" uib-tooltip="Invoice storno" ng-hide="invoice.storno || invoice.stornired" ui-sref="invoice.storno({invoiceId: invoice.id})"><i class="fa fa-undo"></i></button> <button class="btn btn-success" type="submit" ng-hide="invoiceCongress.invoice.storno || invoiceCongress.invoice.stornired" ui-sref="invoice.set-payment-date({id: invoice.id})" tooltip-placement="left" uib-tooltip="Set payment date"><i class="fa fa-calendar"></i></button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/invoice-report/invoice-report-send-to-nav-confirm-dialog.html','<form name="confirmForm" ng-submit="vm.confirmSend(vm.invoiceId)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pcsApp.invoiceReport.sendToNavConfirmDialog.title">Confirm sending to NAV operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.invoiceReport.sendToNavConfirmDialog.question">Are you sure you want to send this invoice to NAV?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="confirmForm.$invalid" class="btn btn-danger"><span class="fa fa-upload"></span>&nbsp;<span data-translate="entity.action.send">Send</span></button></div></form>');
$templateCache.put('app/entities/invoice-report/invoice-reports.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 data-translate="pcsApp.invoiceReport.home.title">Registation Report</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-md-12"><div class="col-md-3 no-padding-left"><input type="text" class="form-control full-width" ng-model="vm.reportFilter.programNumber" autocomplete="off" id="programNumber" name="programNumber" placeholder="{{ \'pcsApp.invoiceReport.programNumber\' | translate }}"></div><div class="col-md-2 no-padding-left"><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_fromDate" type="text" class="form-control" name="fromDate" uib-datepicker-popup="{{dateformat}}" autocomplete="off" ng-model="vm.reportFilter.fromDate" is-open="vm.datePickerOpenStatus.fromDate" placeholder="{{ \'pcsApp.invoiceReport.fromDate\' | translate }}" required></div></div><div class="col-md-2 no-padding-left"><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_toDate" type="text" class="form-control" name="toDate" uib-datepicker-popup="{{dateformat}}" autocomplete="off" ng-model="vm.reportFilter.toDate" is-open="vm.datePickerOpenStatus.toDate" placeholder="{{ \'pcsApp.invoiceReport.toDate\' | translate }}" required></div></div><div class="col-md-2 no-padding-left"><input type="text" class="form-control full-width" ng-model="vm.reportFilter.invoiceNumber" autocomplete="off" id="invoiceNumber" name="invoiceNumber" placeholder="{{ \'pcsApp.invoiceReport.invoiceNumber\' | translate }}"></div><div class="col-md-3 input-group"><select class="form-control full-width" name="filterProforma" ng-model="vm.reportFilter.filterProforma" id="id_filterProforma"><option ng-selected="vm.filterProforma" ng-value="true">Regular</option><option ng-selected="!vm.filterProforma" ng-value="false">Pro forma</option></select><span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search()"><span class="glyphicon glyphicon-search"></span></button> <button class="btn btn-danger" ng-if="vm.reportList.length || vm.isAnyFilterSet()" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button> <button class="btn btn-primary" ng-if="vm.reportList.length" tooltip-placement="left" uib-tooltip="Download xls report" type="submit" ng-click="vm.downloadReportXls()"><i class="fa fa-download"></i></button> <button class="btn btn-primary" ng-if="vm.reportList.length" tooltip-placement="left" uib-tooltip="Download accountant xls report" type="submit" ng-click="vm.downloadAccountantReportXls()"><i class="fa fa-book"></i></button> <button class="btn btn-primary" ng-if="vm.reportList.length" tooltip-placement="left" uib-tooltip="Download NAV report" type="submit" ng-click="vm.downloadNavXmlArchive()"><i class="fa fa-file-zip-o"></i></button></span></div></div></div></div></div></div></div></div><div class="ibox-content" ng-show="vm.reportList.length"><table datatable="ng" id="invoice-report-datatable" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th></th><th><span data-translate="pcsApp.invoiceReport.navStatus">NAV status</span></th><th><span data-translate="pcsApp.invoiceReport.invoiceNumber">Invoice number</span></th><th><span data-translate="pcsApp.invoiceReport.stornoInvoiceNumber">Storno invoice number</span></th><th><span data-translate="pcsApp.invoiceReport.invoiceReportType">Type</span></th><th><span data-translate="pcsApp.invoiceReport.invoiceType">Invoice type</span></th><th><span data-translate="pcsApp.invoiceReport.name2">Name2</span></th><th><span data-translate="pcsApp.invoiceReport.name1">Name1</span></th><th><span data-translate="pcsApp.invoiceReport.optionalName">Optional name</span></th><th><span data-translate="pcsApp.invoiceReport.taxNumber">Tax no.</span></th><th><span data-translate="pcsApp.invoiceReport.zipCode">Zipcode</span></th><th><span data-translate="pcsApp.invoiceReport.city">City</span></th><th><span data-translate="pcsApp.invoiceReport.street">Street</span></th><th><span data-translate="pcsApp.invoiceReport.country">Country</span></th><th><span data-translate="pcsApp.invoiceReport.congressName">Congress name</span></th><th><span data-translate="pcsApp.invoiceReport.programNumber">Prg. num.</span></th><th><span data-translate="pcsApp.invoiceReport.createdDate">Date of invoice</span></th><th><span data-translate="pcsApp.invoiceReport.dateOfFulfilment">Date of fulfilment</span></th><th><span data-translate="pcsApp.invoiceReport.paymentDeadline">Payment deadline</span></th><th><span data-translate="pcsApp.invoiceReport.billingMethod">Method of payment</span></th><th ng-repeat-start="vatColumn in vm.reportListVatColumn"><span data-translate="pcsApp.invoiceReport.vatNettoColumn" data-translate-values="{vat: \'{{ vatColumn }}\'}">VAT Netto column</span></th><th ng-repeat-end><span data-translate="pcsApp.invoiceReport.vatValueColumn" data-translate-values="{vat: \'{{ vatColumn }}\'}">VAT value column</span></th><th><span data-translate="pcsApp.invoiceReport.vatNettoTotal">VAT Netto Total</span></th><th><span data-translate="pcsApp.invoiceReport.vatValueTotal">VAT Value Total</span></th></tr></thead><tbody><tr ng-repeat="ir in vm.reportList track by ir.id"><td><send-invoice-email-dialog invoice="{{ir.id}}" email="{{vm.registration.email}}"><button class="btn btn-info m-b-xs" tooltip-placement="right" uib-tooltip="Resend invoice via email" type="button"><i class="fa fa-envelope"></i></button></send-invoice-email-dialog><button class="btn btn-info m-b-xs" type="button" tooltip-placement="right" uib-tooltip="Download invoice" ng-click="vm.downloadPdf(ir.id)"><i class="fa fa-download"></i></button> <button ng-show="vm.isSendToNavButtonVisible(ir.invoiceType, ir.navStatus)" class="btn btn-danger m-b-xs" type="submit" tooltip-placement="right" uib-tooltip="Send to NAV" ui-sref="invoice-report.send-to-nav({id:ir.id})"><i class="fa fa-upload"></i></button> <button ng-show="vm.hasInvoiceSendingStatus(ir.navStatus)" class="btn btn-info" type="submit" tooltip-placement="right" uib-tooltip="NAV invoice sending status" ui-sref="invoice-report.show-nav-sending-status({id:ir.id})"><i class="fa fa-list"></i></button></td><td>{{ir.navStatus}}</td><td>{{ir.invoiceNumber}}</td><td>{{ir.stornoInvoiceNumber}}</td><td>{{ir.invoiceReportType}}</td><td data-translate="pcsApp.InvoiceType.{{ir.invoiceType}}"></td><td>{{ir.name2}}</td><td>{{ir.name1}}</td><td>{{ir.optionalName}}</td><td>{{ir.vatRegNumber}}</td><td>{{ir.zipCode}}</td><td>{{ir.city}}</td><td>{{ir.street}}</td><td>{{ir.country}}</td><td>{{ir.congressName}}</td><td>{{ir.programNumber}}</td><td>{{ir.createdDate | date: \'mediumDate\' }}</td><td>{{ir.dateOfFulfilment | date: \'mediumDate\' }}</td><td>{{ir.paymentDeadline | date: \'mediumDate\' }}</td><td>{{ "pcsApp.invoiceReport.billingMethodOption." + ir.billingMethod | translate }}</td><td ng-repeat-start="vatColumn in vm.reportListVatColumn">{{vm.getInvoiceReportItemVatNettoValue(ir, vatColumn)}}</td><td ng-repeat-end>{{vm.getInvoiceReportItemVatValue(ir, vatColumn)}}</td><td><strong>{{vm.getInvoiceReportVatNettoTotal(ir, vatColumn)}}</strong></td><td><strong>{{vm.getInvoiceReportVatValueTotal(ir, vatColumn)}}</strong></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/invoice-report/show-nav-sending-status-dialog.html','<form name="confirmForm"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pcsApp.invoiceReport.showNavSendingStatusDialog.title">NAV validation status of invoice</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><table datatable="ng" id="invoice-report-datatable" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span data-translate="pcsApp.invoiceReport.showNavSendingStatusDialog.id">ID</span></th><th><span data-translate="pcsApp.invoiceReport.showNavSendingStatusDialog.errorCode">Error code</span></th><th><span data-translate="pcsApp.invoiceReport.showNavSendingStatusDialog.validationType">Validation type</span></th><th><span data-translate="pcsApp.invoiceReport.showNavSendingStatusDialog.validationSeverity">Validation severity</span></th><th><span data-translate="pcsApp.invoiceReport.showNavSendingStatusDialog.message">Message</span></th></tr></thead><tbody><tr ng-repeat="validation in vm.invoiceNavStatusArray track by validation.id"><td>{{validation.id}}</td><td>{{validation.errorCode}}</td><td>{{validation.validationType}}</td><td>{{validation.validationSeverity}}</td><td>{{validation.message}}</td></tr></tbody></table></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.close">Close</span></button></div></form>');
$templateCache.put('app/entities/misc-invoice/misc-invoice-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMiscInvoiceLabel" data-translate="pcsApp.miscInvoice.home.createOrEditLabel">Create or edit a Misc Invoice</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.miscInvoice.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.miscInvoice.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="pcsApp.miscInvoice.invoiceNumber" for="field_invoiceNumber">Invoice Number</label><input type="text" class="form-control" name="invoiceNumber" id="field_invoiceNumber" ng-model="vm.miscInvoice.invoiceNumber" ng-maxlength="30"><div ng-show="editForm.invoiceNumber.$invalid"><p class="error-block" ng-show="editForm.invoiceNumber.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="30">This field cannot be longer than 30 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.miscInvoice.stornoInvoiceNumber" for="field_stornoInvoiceNumber">Storno Invoice Number</label><input type="text" class="form-control" name="stornoInvoiceNumber" id="field_stornoInvoiceNumber" ng-model="vm.miscInvoice.stornoInvoiceNumber" ng-maxlength="30"><div ng-show="editForm.stornoInvoiceNumber.$invalid"><p class="error-block" ng-show="editForm.stornoInvoiceNumber.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="30">This field cannot be longer than 30 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.miscInvoice.name1" for="field_name1">Name 1</label><input type="text" class="form-control" name="name1" id="field_name1" ng-model="vm.miscInvoice.name1" ng-maxlength="80"><div ng-show="editForm.name1.$invalid"><p class="error-block" ng-show="editForm.name1.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="80">This field cannot be longer than 80 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.miscInvoice.name2" for="field_name2">Name 2</label><input type="text" class="form-control" name="name2" id="field_name2" ng-model="vm.miscInvoice.name2" ng-maxlength="80"><div ng-show="editForm.name2.$invalid"><p class="error-block" ng-show="editForm.name2.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="80">This field cannot be longer than 80 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.miscInvoice.name3" for="field_name3">Name 3</label><input type="text" class="form-control" name="name3" id="field_name3" ng-model="vm.miscInvoice.name3" ng-maxlength="80"><div ng-show="editForm.name3.$invalid"><p class="error-block" ng-show="editForm.name3.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="80">This field cannot be longer than 80 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.miscInvoice.vatRegNumber" for="field_vatRegNumber">Vat Reg Number</label><input type="text" class="form-control" name="vatRegNumber" id="field_vatRegNumber" ng-model="vm.miscInvoice.vatRegNumber" ng-maxlength="80"><div ng-show="editForm.vatRegNumber.$invalid"><p class="error-block" ng-show="editForm.vatRegNumber.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="80">This field cannot be longer than 80 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.miscInvoice.city" for="field_city">City</label><input type="text" class="form-control" name="city" id="field_city" ng-model="vm.miscInvoice.city" ng-maxlength="80"><div ng-show="editForm.city.$invalid"><p class="error-block" ng-show="editForm.city.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="80">This field cannot be longer than 80 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.miscInvoice.zipCode" for="field_zipCode">Zip Code</label><input type="text" class="form-control" name="zipCode" id="field_zipCode" ng-model="vm.miscInvoice.zipCode" ng-maxlength="80"><div ng-show="editForm.zipCode.$invalid"><p class="error-block" ng-show="editForm.zipCode.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="80">This field cannot be longer than 80 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.miscInvoice.street" for="field_street">Street</label><input type="text" class="form-control" name="street" id="field_street" ng-model="vm.miscInvoice.street" ng-maxlength="128"><div ng-show="editForm.street.$invalid"><p class="error-block" ng-show="editForm.street.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="128">This field cannot be longer than 128 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.miscInvoice.country" for="field_country">Country</label><input type="text" class="form-control" name="country" id="field_country" ng-model="vm.miscInvoice.country" ng-maxlength="80"><div ng-show="editForm.country.$invalid"><p class="error-block" ng-show="editForm.country.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="80">This field cannot be longer than 80 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.miscInvoice.optionalText" for="field_optionalText">Optional Text</label><input type="text" class="form-control" name="optionalText" id="field_optionalText" ng-model="vm.miscInvoice.optionalText"></div><div class="form-group"><label class="control-label" data-translate="pcsApp.miscInvoice.startDate" for="field_startDate">Start Date</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_startDate" type="text" class="form-control" name="startDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.miscInvoice.startDate" is-open="vm.datePickerOpenStatus.startDate" required></div><div ng-show="editForm.startDate.$invalid"><p class="error-block" ng-show="editForm.startDate.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.miscInvoice.endDate" for="field_endDate">End Date</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_endDate" type="text" class="form-control" name="endDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.miscInvoice.endDate" is-open="vm.datePickerOpenStatus.endDate" date-less-than="{{vm.miscInvoice.startDate}}" required></div><div ng-show="editForm.endDate.$invalid"><p class="error-block" ng-show="editForm.endDate.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.endDate.$error.dateLessThan" translate="pcsApp.miscInvoice.message.endDateLessThanStartDate">End date must be later than Start date.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.miscInvoice.dateOfFulfilment" for="field_dateOfFulfilment">End Date</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateOfFulfilment\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_dateOfFulfilment" type="text" class="form-control" name="dateOfFulfilment" uib-datepicker-popup="{{dateformat}}" ng-model="vm.miscInvoice.dateOfFulfilment" is-open="vm.datePickerOpenStatus.dateOfFulfilment" date-less-than="{{vm.miscInvoice.startDate}}" required></div><div ng-show="editForm.dateOfFulfilment.$invalid"><p class="error-block" ng-show="editForm.dateOfFulfilment.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.dateOfFulfilment.$error.dateLessThan" translate="pcsApp.miscInvoice.message.dateOfFulfilmentLessThanStartDate">Date of fullfilment must be later than Start date.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.miscInvoice.paymentDeadline" for="field_paymentDeadline">Payment Deadline</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'paymentDeadline\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_paymentDeadline" type="text" class="form-control" name="paymentDeadline" uib-datepicker-popup="{{dateformat}}" ng-model="vm.miscInvoice.paymentDeadline" is-open="vm.datePickerOpenStatus.paymentDeadline"></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.miscInvoice.billingMethod" for="field_billingMethod">Billing Method</label><input type="text" class="form-control" name="billingMethod" id="field_billingMethod" ng-model="vm.miscInvoice.billingMethod" ng-maxlength="12"><div ng-show="editForm.billingMethod.$invalid"><p class="error-block" ng-show="editForm.billingMethod.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="12">This field cannot be longer than 12 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.miscInvoice.dateOfGroupPayment" for="field_dateOfGroupPayment">Date Of Group Payment</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateOfGroupPayment\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_dateOfGroupPayment" type="text" class="form-control" name="dateOfGroupPayment" uib-datepicker-popup="{{dateformat}}" ng-model="vm.miscInvoice.dateOfGroupPayment" is-open="vm.datePickerOpenStatus.dateOfGroupPayment"></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.miscInvoice.bankName" for="field_bankName">Bank Name</label><input type="text" class="form-control" name="bankName" id="field_bankName" ng-model="vm.miscInvoice.bankName" required ng-minlength="3" ng-maxlength="32"><div ng-show="editForm.bankName.$invalid"><p class="error-block" ng-show="editForm.bankName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.bankName.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 3 characters.</p><p class="error-block" ng-show="editForm.bankName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.miscInvoice.bankAccount" for="field_bankAccount">Bank Account</label><input type="text" class="form-control" name="bankAccount" id="field_bankAccount" ng-model="vm.miscInvoice.bankAccount" required ng-minlength="8" ng-maxlength="32"><div ng-show="editForm.bankAccount.$invalid"><p class="error-block" ng-show="editForm.bankAccount.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.bankAccount.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="8">This field is required to be at least 8 characters.</p><p class="error-block" ng-show="editForm.bankAccount.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.miscInvoice.swiftCode" for="field_swiftCode">Swift Code</label><input type="text" class="form-control" name="swiftCode" id="field_swiftCode" ng-model="vm.miscInvoice.swiftCode" required ng-minlength="4" ng-maxlength="32"><div ng-show="editForm.swiftCode.$invalid"><p class="error-block" ng-show="editForm.swiftCode.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.swiftCode.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4">This field is required to be at least 4 characters.</p><p class="error-block" ng-show="editForm.swiftCode.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.miscInvoice.printLocale" for="field_printLocale">Print Locale</label><input type="text" class="form-control" name="printLocale" id="field_printLocale" ng-model="vm.miscInvoice.printLocale" ng-maxlength="8"><div ng-show="editForm.printLocale.$invalid"><p class="error-block" ng-show="editForm.printLocale.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="8">This field cannot be longer than 8 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.miscInvoice.storno" for="field_storno">Storno</label><input type="checkbox" class="form-control" name="storno" id="field_storno" ng-model="vm.miscInvoice.storno"></div><div class="form-group"><label class="control-label" data-translate="pcsApp.miscInvoice.stornired" for="field_stornired">Stornired</label><input type="checkbox" class="form-control" name="stornired" id="field_stornired" ng-model="vm.miscInvoice.stornired"></div><div class="form-group"><label class="control-label" data-translate="pcsApp.miscInvoice.createdDate" for="field_createdDate">Created Date</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdDate\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_createdDate" type="text" class="form-control" name="createdDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.miscInvoice.createdDate" is-open="vm.datePickerOpenStatus.createdDate"></div></div><div class="form-group"><label data-translate="pcsApp.miscInvoice.congress" for="field_congress">Congress</label><select class="form-control" id="field_congress" name="congress" ng-model="vm.miscInvoice.congress" ng-options="congress as congress.id for congress in vm.congresses track by congress.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/misc-invoice/misc-invoice-set-payment-date-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="miscInvoiceLabel" data-translate="pcsApp.miscInvoice.home.setPaymentDateLabel">Misc Invoice</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="pcsApp.miscInvoice.dateOfPayment" for="field_paymentDate">Date Of Payment</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'paymentDate\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_paymentDate" type="text" class="form-control" name="paymentDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.miscInvoice.paymentDate" is-open="vm.datePickerOpenStatus.paymentDate"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/misc-invoice/misc-invoice-setup-dialog.html','<div class="row wrapper border-bottom white-bg page-heading"><div style="padding-left: 15px"><h2 data-translate="pcsApp.invoice.home.miscSetupLabel">Misc Invoice Print Setup</h2></div></div><jhi-alert-error></jhi-alert-error><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><form name="editForm" role="form" novalidate ng-submit="vm.printInvoice()" show-validation><div class="ibox" ng-show="!vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.invoice.language\' | translate}}</strong><!--<div ibox-tools></div>--></div><div class="ibox-content"><div><label><input ng-model="vm.invoice.language" value="hu" id="languageHu" name="language" type="radio"> Hungarian</label></div><div><label><input ng-model="vm.invoice.language" value="en" id="languageEn" name="language" type="radio"> English</label></div></div></div><div class="ibox" ng-show="!vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.invoice.invoiceType\' | translate}}</strong><!--<div ibox-tools></div>--></div><div class="ibox-content"><select class="form-control" name="invoiceType" ng-model="vm.invoice.invoiceType" id="field_invoiceType" ng-change="vm.invoiceTypeChanged()" required><option value="" data-translate="global.form.please.select">Please select</option><option value="REGULAR" data-translate="pcsApp.InvoiceType.REGULAR">REGULAR</option><option value="PREPAYMENT" data-translate="pcsApp.InvoiceType.PREPAYMENT">PREPAYMENT</option><option value="PRO_FORMA" data-translate="pcsApp.InvoiceType.PRO_FORMA">PRO_FORMA</option></select><div ng-show="editForm.invoiceType.$invalid"><p class="error-block" ng-show="editForm.invoiceType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="ibox" ng-show="!vm.isShowConfirmationPanel && vm.invoice.invoiceType !== \'PRO_FORMA\'"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.invoice.navVatCategory\' | translate}}</strong><!--<div ibox-tools></div>--></div><div class="ibox-content"><select class="form-control" name="navVatCategory" ng-model="vm.invoice.navVatCategory" id="field_navVatCategory" ng-change="vm.navVatCategoryChanged()" required><option value="" data-translate="global.form.please.select">Please select</option><option value="DOMESTIC_NORMAL_VAT_TAX_NUMBER" data-translate="pcsApp.NavVatCategory.DOMESTIC_NORMAL_VAT_TAX_NUMBER">DOMESTIC_NORMAL_VAT_TAX_NUMBER</option><option value="PRIVATE_PERSON" data-translate="pcsApp.NavVatCategory.PRIVATE_PERSON">PRIVATE_PERSON</option><option value="EU_VAT_EU_TAX_NUMBER" data-translate="pcsApp.NavVatCategory.EU_VAT_EU_TAX_NUMBER">EU_VAT_EU_TAX_NUMBER</option><option value="OTHER_COUNTRY" data-translate="pcsApp.NavVatCategory.OTHER_COUNTRY">OTHER_COUNTRY</option><option value="EU_NO_VAT_EU_TAX_NUMBER" data-translate="pcsApp.NavVatCategory.EU_NO_VAT_EU_TAX_NUMBER">EU_NO_VAT_EU_TAX_NUMBER</option><option value="OTHER_CUSTOMER" data-translate="pcsApp.NavVatCategory.OTHER_CUSTOMER">OTHER_CUSTOMER</option><option value="DOMESTIC_GROUP_VAT_TAX_NUMBER" data-translate="pcsApp.NavVatCategory.DOMESTIC_GROUP_VAT_TAX_NUMBER">DOMESTIC_GROUP_VAT_TAX_NUMBER</option></select><div ng-show="editForm.navVatCategory.$invalid"><p class="error-block" ng-show="editForm.navVatCategory.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="ibox" ng-show="!vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.invoice.partner\' | translate}}</strong><!--<div ibox-tools></div>--></div><div class="ibox-content"><ui-select ng-model="dummyvalue" ng-change="vm.selectPartner($select.selected)" name="partner-search" id="partner-search" theme="bootstrap"><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="partner in (vm.partners | filter: $select.search) track by partner.id"><div ng-bind-html="partner.name | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="ibox" ng-show="!vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.invoice.home.billingInfoLabel\' | translate}}</strong><!--<div ibox-tools></div>--></div><div class="ibox-content"><div class="form-group"><label class="control-label" data-translate="pcsApp.invoice.name1" for="field_name1">Name1</label><input type="text" class="form-control" name="name1" id="field_name1" autocomplete="off" ng-model="vm.invoice.name1" required ng-maxlength="64"><div ng-show="editForm.name1.$invalid"><p class="error-block" ng-show="editForm.name1.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.name1.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.invoice.name2" for="field_name2">Name2</label><input type="text" class="form-control" name="name2" id="field_name2" autocomplete="off" ng-model="vm.invoice.name2" ng-maxlength="64"><div ng-show="editForm.name2.$invalid"><p class="error-block" ng-show="editForm.name2.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.invoice.name3" for="field_name3">Name3</label><input type="text" class="form-control" name="name3" id="field_name3" autocomplete="off" ng-model="vm.invoice.name3" ng-maxlength="64"><div ng-show="editForm.name3.$invalid"><p class="error-block" ng-show="editForm.name3.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.invoice.vatRegNumber" for="field_vatRegNumber">VatRegNumber</label><input type="text" class="form-control" name="vatRegNumber" id="field_vatRegNumber" ng-required="vm.isTaxNumberRequired()" ng-pattern="vm.taxNumberPattern" ng-disabled="vm.isTaxNumberDisabled()" ng-model="vm.invoice.vatRegNumber" ng-maxlength="64"><div ng-show="editForm.vatRegNumber.$invalid"><p class="error-block" ng-show="editForm.vatRegNumber.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.vatRegNumber.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p><p class="error-block" ng-show="editForm.vatRegNumber.$error.pattern" data-translate="entity.validation.pattern" data-translate-values="{ pattern: \'12345678-1-12\' }">Ez a mez\u0151 csak ad\xF3sz\xE1m form\xE1tumot tartalmazhat pl.: 12345678-1-12</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.invoice.city" for="field_city">City</label><input type="text" class="form-control" name="city" id="field_city" autocomplete="off" ng-model="vm.invoice.city" required ng-maxlength="64"><div ng-show="editForm.city.$invalid"><p class="error-block" ng-show="editForm.city.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.city.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.invoice.zipCode" for="field_zipCode">ZipCode</label><input type="text" class="form-control" name="zipCode" id="field_zipCode" autocomplete="off" ng-model="vm.invoice.zipCode" required ng-maxlength="64"><div ng-show="editForm.zipCode.$invalid"><p class="error-block" ng-show="editForm.zipCode.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.zipCode.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.invoice.street" for="field_street">Street</label><input type="text" class="form-control" name="street" id="field_street" autocomplete="off" ng-model="vm.invoice.street" required ng-maxlength="128"><div ng-show="editForm.street.$invalid"><p class="error-block" ng-show="editForm.street.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.street.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="128">This field cannot be longer than 128 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.invoice.country" for="field_country">Country</label><ui-select ng-model="vm.invoice.country" name="country" id="field_country" theme="bootstrap"><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="country.code as country in (vm.countries | filter: $select.search) track by country.code"><div ng-bind-html="country.name | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.country.$invalid"><p class="error-block" ng-show="editForm.country.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="ibox" ng-show="!vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.invoice.home.invoiceSetupDateLabel\' | translate}}</strong><!--<div ibox-tools></div>--></div><div class="ibox-content"><div class="form-group"><label class="control-label" data-translate="pcsApp.invoice.startDate" for="field_startDate">Start Date</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_startDate" type="text" class="form-control" name="startDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.invoice.startDate" is-open="vm.datePickerOpenStatus.startDate" required></div><div ng-show="editForm.startDate.$invalid"><p class="error-block" ng-show="editForm.startDate.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.invoice.endDate" for="field_endDate">End Date</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_endDate" type="text" class="form-control" name="endDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.invoice.endDate" is-open="vm.datePickerOpenStatus.endDate" date-less-than="{{vm.invoice.startDate}}" required></div><div ng-show="editForm.endDate.$invalid"><p class="error-block" ng-show="editForm.endDate.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.endDate.$error.dateLessThan" translate="pcsApp.invoice.message.endDateLessThanStartDate">End date must be later than Start date.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.invoice.dateOfFulfilment" for="field_dateOfFulfilment">End Date</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateOfFulfilment\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_dateOfFulfilment" type="text" class="form-control" name="dateOfFulfilment" uib-datepicker-popup="{{dateformat}}" ng-model="vm.invoice.dateOfFulfilment" is-open="vm.datePickerOpenStatus.dateOfFulfilment" required></div><div ng-show="editForm.dateOfFulfilment.$invalid"><p class="error-block" ng-show="editForm.dateOfFulfilment.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.dateOfFulfilment.$error.dateLessThan" translate="pcsApp.invoice.message.dateOfFulfilmentLessThanStartDate">Date of fullfilment must be later than Start date.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.invoice.paymentDeadline" for="field_paymentDeadline">Start Date</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'paymentDeadline\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_paymentDeadline" type="text" class="form-control" name="paymentDeadline" uib-datepicker-popup="{{dateformat}}" ng-model="vm.invoice.paymentDeadline" is-open="vm.datePickerOpenStatus.paymentDeadline" required></div><div ng-show="editForm.paymentDeadline.$invalid"><p class="error-block" ng-show="editForm.paymentDeadline.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="pcsApp.invoice.bankAccount" for="field_bankAccount">Bank account</label><ui-select ng-model="vm.invoice.bankAccount" name="bankAccount" id="field_bankAccount" theme="bootstrap" required><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="bankAccount in (bankAccounts | filter: $select.search) track by bankAccount.id"><div ng-bind-html="bankAccount.name | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.bankAccount.$invalid"><p class="error-block" ng-show="editForm.bankAccount.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="ibox" ng-show="!vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.invoice.home.paymentMethodLabel\' | translate}}</strong><!--<div ibox-tools></div>--></div><div class="ibox-content"><div><label><input ng-model="vm.invoice.billingMethod" value="TRANSFER" id="paymentTransfer" ng-click="vm.changeBillingMethod()" name="billingMethod" type="radio"> Transfer</label></div><div><label><input ng-model="vm.invoice.billingMethod" value="CASH" id="paymentCash" ng-click="vm.changeBillingMethod()" name="billingMethod" type="radio"> Cash</label></div><div><label><input ng-model="vm.invoice.billingMethod" value="CARD" id="paymentCreditCard" ng-click="vm.changeBillingMethod()" name="billingMethod" type="radio"> Credit card</label></div></div></div><div class="ibox" ng-show="!vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.optionalText.optionalText\' | translate}}:</strong><div class="input-group m-b"><span class="input-group-btn"><button class="btn btn-primary" type="submit" ui-sref="misc-invoice.optional-text-new"><i class="fa fa-plus"></i></button></span><ui-select ng-model="vm.selectedOptionalText" ng-change="vm.setOptionalTextMessage($select.selected.optionalText)" name="optionalTextSelector" id="field_optionalTextSelector" theme="bootstrap"><ui-select-match allow-clear="true" placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="optionalText in (vm.optionalTexts | filter: $select.search) track by optionalText.id"><div ng-bind-html="optionalText.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><!--<div ibox-tools></div>--></div><div class="ibox-content"><div class="text-center"><textarea class="form-control" name="optionalText" id="field_optionalText" rows="5" autocomplete="off" ng-model="vm.invoice.optionalText">\n                        </textarea></div></div></div><div class="ibox" ng-show="!vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><button type="button" ng-click="vm.showConfirmationPanel()" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="pcsApp.invoice.sendInvoiceByMail">Send invoice by mail</span></button> <button type="button" ng-click="vm.printInvoice()" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-print"></span>&nbsp;<span data-translate="pcsApp.invoice.printInvoice">Print invoice</span></button> <button type="button" class="btn btn-info" ng-click="vm.clear()" ui-sref="misc-invoice-item"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back">Back</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()" ui-sref="misc-invoice" ui-sref-opts="{reload: true, notify: true}"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button></div></div></form><form name="confirmationForm" role="form" novalidate ng-submit="vm.sendAndPrintInvoice()" show-validation><div class="ibox" ng-show="vm.isShowConfirmationPanel"><div class="ibox-title float-e-margins"><strong>{{\'pcsApp.miscInvoice.confirmation.email\' | translate}}:</strong><div class="input-group m-b"><input class="form-control" name="invoiceEmail" ng-minlength="5" ng-maxlength="255" ng-model="vm.invoiceEmail" autocomplete="off" type="email" required> <span class="input-group-btn"><button type="submit" class="btn btn-primary"><span data-translate="entity.action.send">Send</span></button> <button type="button" ng-click="vm.isShowConfirmationPanel = false;" class="btn btn-default"><span data-translate="entity.action.cancel">Cancel</span></button></span></div><div ng-show="confirmationForm.confirmationEmail.$invalid"><p class="error-block" ng-show="confirmationForm.invoiceEmail.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="confirmationForm.invoiceEmail.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="error-block" ng-show="confirmationForm.invoiceEmail.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="5">This field is required to be at least 5 characters.</p><p class="error-block" ng-show="confirmationForm.invoiceEmail.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div></div></form></div></div></div>');
$templateCache.put('app/entities/misc-invoice/misc-invoice-storno-dialog.html','<form name="stornoForm" ng-submit="vm.confirmStorno()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pcsApp.miscInvoice.home.stornoLabel">Confirm storno operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.miscInvoice.confirmation.storno" data-translate-values="{invoiceNumber: \'{{vm.invoiceCongress.invoice.invoiceNumber}}\'}">Are you sure you want to storno this invoice?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="stornoForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.ok">OK</span></button></div></form>');
$templateCache.put('app/entities/misc-invoice/misc-invoices.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 translate="pcsApp.miscInvoice.home.title">Misc Invoices</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-primary" type="submit" ui-sref="misc-invoice-item"><i class="fa fa-plus"></i></button><!--<div ibox-tools></div>--></div><div class="ibox-content"><table datatable="ng" id="misc-invoice-datatable" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.miscInvoice.invoiceNumber">Invoice number</span></th><th><span translate="pcsApp.miscInvoice.stornoInvoiceNumber">Storno invoice number</span></th><th><span translate="pcsApp.miscInvoice.invoiceType">Invoice type</span></th><th><span translate="pcsApp.miscInvoice.createdDate">Create date</span></th><th><span translate="pcsApp.miscInvoice.name1">Name1</span></th><th><span translate="pcsApp.miscInvoice.vatRegNumber">Vat Reg number</span></th><th><span translate="pcsApp.miscInvoice.dateOfPayment">Date of payment</span></th><th></th></tr></thead><tbody><tr ng-repeat="invoiceCongress in vm.miscInvoices track by invoiceCongress.id"><td>{{invoiceCongress.invoice.invoiceNumber}}</td><td>{{invoiceCongress.invoice.stornoInvoiceNumber}}</td><td data-translate="pcsApp.InvoiceType.{{invoiceCongress.invoice.invoiceType}}"></td><td>{{invoiceCongress.invoice.createdDate | date: \'mediumDate\'}}</td><td>{{invoiceCongress.invoice.name1}}</td><td>{{invoiceCongress.invoice.vatRegNumber}}</td><td>{{invoiceCongress.dateOfPayment}}</td><td><button class="btn btn-info" type="button" ng-click="vm.downloadPdf(invoiceCongress.id)"><i class="fa fa-download"></i></button> <button class="btn btn-danger" type="submit" ng-hide="invoiceCongress.invoice.storno || invoiceCongress.invoice.stornired || invoiceCongress.invoice.invoiceType == \'PRO_FORMA\'" ui-sref="misc-invoice.storno({invoiceId: invoiceCongress.id})"><i class="fa fa-undo"></i></button> <button class="btn btn-success" type="submit" ng-hide="invoiceCongress.invoice.storno || invoiceCongress.invoice.stornired" ui-sref="misc-invoice.set-payment-date({id: invoiceCongress.id})" tooltip-placement="left" uib-tooltip="Set payment date"><i class="fa fa-calendar"></i></button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/misc-invoice-item/misc-invoice-item-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.miscInvoiceItem.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.miscInvoiceItem.delete.question" translate-values="{id: \'{{vm.miscInvoiceItem.id}}\'}">Are you sure you want to delete this Misc Invoice Item?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/misc-invoice-item/misc-invoice-item-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMiscInvoiceItemLabel" data-translate="pcsApp.miscInvoiceItem.home.createOrEditLabel">Create or edit a Misc Invoice Item</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label translate="pcsApp.miscInvoiceItem.miscService" for="field_miscService">Misc service</label><ui-select ng-model="vm.miscInvoiceItem.miscService" name="miscService" id="field_miscService" theme="bootstrap" required><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name + \' - \' + $select.selected.price + $select.selected.currency.currency + \'/\' + $select.selected.measure"></span></ui-select-match><ui-select-choices repeat="miscService in (vm.miscServices | filter: vm.getSelectedCurrency() | filter: $select.search) track by miscService.id"><div ng-bind-html="miscService.name + \' - \' + miscService.price + miscService.currency.currency  + \'/\' + miscService\n                    .measure | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.miscService.$invalid"><p class="error-block" ng-show="editForm.miscService.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.miscInvoiceItem.itemQuantity" for="field_itemQuantity">Item Quantity</label><input type="number" class="form-control" name="itemQuantity" id="field_itemQuantity" ng-model="vm.miscInvoiceItem.itemQuantity" required min="0" max="100000"><div ng-show="editForm.itemQuantity.$invalid"><p class="error-block" ng-show="editForm.itemQuantity.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.itemQuantity.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be more than 0.</p><p class="error-block" ng-show="editForm.itemQuantity.$error.max" data-translate="entity.validation.max" translate-value-max="100000">This field cannot be more than 100000.</p><p class="error-block" ng-show="editForm.itemQuantity.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/misc-invoice-item/misc-invoice-items.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 translate="pcsApp.miscInvoiceItem.home.title">Misc Invoice Items</h2><small class="text-danger">Please add valid currency rate in order to be able to make valid invoices!</small></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-primary" type="submit" ui-sref="misc-invoice-item.new"><i class="fa fa-plus"></i></button> <button class="btn btn-info" type="submit" ui-sref="misc-invoice" ui-sref-opts="{reload: true, notify: true}"><i class="fa fa-arrow-left"></i></button> <button class="btn btn-info" type="submit" ng-disabled="!vm.miscInvoiceItems.length || !vm.selectedCurrency.hasValidRate" ui-sref="misc-invoice.setup"><i class="fa fa-dollar"></i></button><!--<div ibox-tools></div>--></div><div class="ibox-content"><table id="misc-invoice-item-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.miscInvoiceItem.miscService">Misc service</span></th><th><span translate="pcsApp.miscInvoiceItem.itemQuantity">Item quantity</span></th><th><span translate="pcsApp.miscInvoiceItem.measure">Measure</span></th><th></th></tr></thead><tbody><tr ng-repeat="miscInvoiceItem in vm.miscInvoiceItems track by miscInvoiceItem.id"><td>{{miscInvoiceItem.miscService.name}}</td><td>{{miscInvoiceItem.itemQuantity}}</td><td>{{miscInvoiceItem.miscService.measure}}</td><td><button class="btn btn-info" type="submit" ui-sref="misc-invoice-item.edit({id:miscInvoiceItem.id})"><i class="fa fa-pencil-square-o"></i></button> <button class="btn btn-danger" type="submit" ui-sref="misc-invoice-item.delete({id:miscInvoiceItem.id})"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/misc-service/misc-service-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.miscService.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.miscService.delete.question" translate-values="{id: \'{{vm.miscService.id}}\'}">Are you sure you want to delete this Misc Service?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/misc-service/misc-service-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMiscServiceLabel" data-translate="pcsApp.miscService.home.createOrEditLabel">Create or edit a Misc Service</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="pcsApp.miscService.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" autocomplete="off" ng-model="vm.miscService.name" required ng-maxlength="100"><div ng-show="editForm.name.$invalid"><p class="error-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.miscService.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" autocomplete="off" ng-model="vm.miscService.description" ng-maxlength="500"><div ng-show="editForm.description.$invalid"><p class="error-block" ng-show="editForm.description.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="500">This field cannot be longer than 500 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.miscService.measure" for="field_measure">Measure</label><input type="text" class="form-control" name="measure" id="field_measure" autocomplete="off" ng-model="vm.miscService.measure" required ng-maxlength="20"><div ng-show="editForm.measure.$invalid"><p class="error-block" ng-show="editForm.measure.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.measure.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.miscService.price" for="field_price">Price</label><input type="number" class="form-control" name="price" id="field_price" autocomplete="off" ng-model="vm.miscService.price" required min="-99000000" max="99000000"><div ng-show="editForm.price.$invalid"><p class="error-block" ng-show="editForm.price.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.price.$error.min" data-translate="entity.validation.min" translate-value-min="-99000000">This field should be more than -99000000.</p><p class="error-block" ng-show="editForm.price.$error.max" data-translate="entity.validation.max" translate-value-max="99000000">This field cannot be more than 99000000.</p><p class="error-block" ng-show="editForm.price.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label translate="pcsApp.miscService.currency" for="field_currency">Currency</label><ui-select ng-model="vm.miscService.currency" name="currency" id="field_currency" theme="bootstrap" required><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.currency"></span></ui-select-match><ui-select-choices repeat="currency in (vm.currencies | filter: $select.search) track by currency.id"><div ng-bind-html="currency.currency | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.currency.$invalid"><p class="error-block" ng-show="editForm.currency.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label translate="pcsApp.miscService.vatInfo" for="field_vatInfo">Vat info</label><ui-select ng-model="vm.miscService.vatInfo" name="vatInfo" id="field_vatInfo" theme="bootstrap" required><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="vatInfo in (vm.vatInfos | filter: $select.search) track by vatInfo.id"><div ng-bind-html="vatInfo.name | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.vatInfo.$invalid"><p class="error-block" ng-show="editForm.vatInfo.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/misc-service/misc-services.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 translate="pcsApp.miscService.home.title">Misc Services</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-primary" type="submit" ui-sref="misc-service.new"><i class="fa fa-plus"></i></button><!--<div ibox-tools></div>--></div><div class="ibox-content"><table datatable="ng" id="misc-service-datatable" dt-options="dtOptions" dt-column-defs="dtColumnDefs" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.miscService.name">Name</span></th><th><span translate="pcsApp.miscService.measure">Measure</span></th><th><span translate="pcsApp.miscService.price">Price</span></th><th><span translate="pcsApp.miscService.currency">Currency</span></th><th><span translate="pcsApp.miscService.vatInfo">Vat Info</span></th><th></th></tr></thead><tbody><tr ng-repeat="miscService in vm.miscServices track by miscService.id"><td>{{miscService.name}}</td><td>{{miscService.measure}}</td><td>{{miscService.price}}</td><td>{{miscService.currency.currency}}</td><td>{{miscService.vatInfo.name}}</td><td><button class="btn btn-info" type="submit" ui-sref="misc-service.edit({id:miscService.id})"><i class="fa fa-pencil-square-o"></i></button> <button class="btn btn-danger" type="submit" ui-sref="misc-service.delete({id:miscService.id})"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/online-reg/online-reg-error.html','<jhi-alert></jhi-alert><div class="wrapper wrapper-content p-xl gray-bg"><div class="container animated fadeInRight"><div class="row"><div class="col-md-12"><img class="online-reg-header-image" ng-src="{{\'/api/registration/online/header/\' + vm.congress.uuid }}" onerror="this.style.display=\'none\'"></div></div><div class="row"><div class="col-md-12"><div class="ibox float-e-margins"><div class="ibox-title" ng-style="vm.headerStyle()"><h2 data-translate="pcsApp.onlineReg.home.errorTitle">Online registration error</h2></div><div class="ibox-content text-center p-md"><h2 class="text-danger" data-translate="pcsApp.onlineReg.error.{{vm.errorId}}">Online registration error</h2></div></div></div></div><div class="online-reg-footer" data-translate="pcsApp.onlineReg.footer">Congressline Kft. \u2022 1065 Budapest, R\xE9vay k\xF6z 2. \u2022 Tel: (+36-1) 429-0146, (+36-1) 312-1582 Fax: (+36-1) 429-0147 \u2022 Web: <a href="http://www.congressline.hu" target="_blank">www.congressline.hu</a></div></div></div>');
$templateCache.put('app/entities/online-reg/online-reg-form.html','<jhi-alert xmlns:https="http://www.w3.org/1999/xhtml"></jhi-alert><form name="editForm" role="form" novalidate show-validation><div class="wrapper wrapper-content p-xl gray-bg"><div class="container animated fadeInRight"><div class="row"><div class="col-md-12"><img class="online-reg-header-image" ng-src="{{\'/api/registration/online/header/\' + vm.congress.uuid }}" onerror="this.style.display=\'none\'"></div></div><div class="row" ng-if="vm.isSubmitSuccess"><div class="col-md-12"><div class="ibox float-e-margins"><div class="ibox-title" ng-style="vm.headerStyle()"><h2 data-translate="pcsApp.onlineReg.home.mainTitle">Online registration</h2></div><div class="widget navy-bg"><p data-translate="pcsApp.onlineReg.message.submitOnlineSuccess">Successful submission!</p></div><div class="widget yellow-bg"><p data-translate="pcsApp.onlineReg.message.submitOnlineSpamWarning">Email sent successfully Check spam folder if not received!</p></div><button ng-if="vm.congress.website" type="submit" class="btn btn-success" ng-click="vm.openCongressWebsite()"><strong data-translate="pcsApp.onlineReg.congressWebsiteButton">Vissza a rendezv\xE9ny weboldal\xE1ra</strong></button></div></div></div><div ng-if="!vm.isSubmitSuccess" class="row"><div class="col-md-12"><div class="ibox float-e-margins"><div class="ibox-title" ng-style="vm.headerStyle()"><h2 data-translate="pcsApp.onlineReg.home.mainTitle">Online registration</h2></div><div class="ibox-content text-center p-md browser-check"><div ng-bind-html="vm.getValueByLanguage(\'browserRemark\')"></div><ul><li><a target="_blank" class="ff" href="https://www.mozilla.org/en-US/firefox/all/">firefox</a> Firefox</li><li><a target="_blank" class="ch" href="https://www.google.com/intl/hu/chrome/browser/">chrome</a> Chrome</li><li><a target="_blank" class="sf" href="https://support.apple.com/downloads/safari">safari</a> Safari</li><li><a target="_blank" class="edge" href="https://www.microsoft.com/en-us/edge">edge</a> Edge</li></ul></div></div></div></div><!-- Personal data --><div ng-if="!vm.isSubmitSuccess" class="row"><div class="col-md-12"><div class="ibox float-e-margins"><div class="ibox-title" ng-style="vm.headerStyle()"><h3 data-translate="pcsApp.onlineReg.home.personalData">Personal data</h3></div><div class="ibox-content"><div class="form-group row" ng-if="vm.config.titleVisible || vm.config.lastNameVisible || vm.config.firstNameVisible"><div class="col-md-2" ng-if="vm.config.titleVisible"><label class="control-label" ng-class="{\'required-field\': vm.config.titleRequired}" data-translate="pcsApp.onlineReg.title" for="field_title">Title</label><input ng-if="!vm.config.titleSelectable" type="text" class="form-control online-form-control" name="title" id="field_title" autocomplete="off" ng-model="vm.registration.title" ng-required="vm.config.titleRequired" ng-maxlength="16"><select ng-if="vm.config.titleSelectable" class="form-control" name="title" id="field_title" ng-model="vm.registration.title" ng-required="vm.config.titleRequired"><option value="" data-translate="pcsApp.onlineReg.form.please.select">Please select</option><option ng-repeat="opt in vm.getTitleSelectableValues() track by opt" value="{{opt}}">{{opt}}</option></select><div ng-show="editForm.title.$invalid"><p class="error-block" ng-show="editForm.title.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.title.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="16">This field cannot be longer than 16 characters.</p></div></div><div class="col-md-{{ vm.config.titleVisible ? \'5\' : \'6\' }}" ng-if="vm.config.lastNameVisible"><label class="control-label" ng-class="{\'required-field\': vm.config.lastNameRequired}" data-translate="pcsApp.onlineReg.lastName" for="field_lastName">Family name</label><input type="text" class="form-control online-form-control" name="lastName" id="field_lastName" autocomplete="off" ng-model="vm.registration.lastName" ng-required="vm.config.lastNameRequired" ng-maxlength="64"><div ng-show="editForm.lastName.$invalid"><p class="error-block" ng-show="editForm.lastName.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.lastName.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="col-md-{{ vm.config.titleVisible ? \'5\' : \'6\' }}" ng-if="vm.config.firstNameVisible"><label class="control-label" ng-class="{\'required-field\': vm.config.firstNameRequired}" data-translate="pcsApp.onlineReg.firstName" for="field_firstName">First name</label><input type="text" class="form-control online-form-control" name="firstName" id="field_firstName" autocomplete="off" ng-model="vm.registration.firstName" ng-required="vm.config.firstNameRequired" ng-maxlength="64"><div ng-show="editForm.firstName.$invalid"><p class="error-block" ng-show="editForm.firstName.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.firstName.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div></div><div class="form-group" ng-if="vm.config.workplaceVisible"><label class="control-label" ng-class="{\'required-field\': vm.config.workplaceRequired}" data-translate="pcsApp.onlineReg.workplace" for="field_workplace">Workplace</label><input ng-if="!vm.hasWorkplaceSelectableValues()" type="text" class="form-control online-form-control" name="workplace" id="field_workplace" autocomplete="off" ng-model="vm.registration.workplace" ng-required="vm.config.workplaceRequired" ng-maxlength="255"><select ng-if="vm.hasWorkplaceSelectableValues()" class="form-control" name="workplace" id="field_workplace" ng-model="vm.registration.workplace" ng-required="vm.config.workplaceRequired"><option value="" data-translate="pcsApp.onlineReg.form.please.select">Please select</option><option ng-repeat="opt in vm.getWorkplaceSelectableValues() track by opt" value="{{opt}}">{{opt}}</option></select><div ng-show="editForm.workplace.$invalid"><p class="error-block" ng-show="editForm.workplace.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.workplace.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="form-group" ng-if="vm.config.departmentVisible"><label class="control-label" ng-class="{\'required-field\': vm.config.departmentRequired}" data-translate="pcsApp.onlineReg.department" for="field_department">Department</label><input type="text" class="form-control online-form-control" name="department" id="field_department" autocomplete="off" ng-model="vm.registration.department" ng-required="vm.config.departmentRequired" ng-maxlength="128"><div ng-show="editForm.department.$invalid"><p class="error-block" ng-show="editForm.department.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.department.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="128">This field cannot be longer than 128 characters.</p></div></div><div class="form-group row" ng-if="vm.config.zipCodeVisible || vm.config.cityVisible || vm.config.countryVisible"><div class="col-md-4" ng-if="vm.config.zipCodeVisible"><label class="control-label" ng-class="{\'required-field\': vm.config.zipCodeRequired}" data-translate="pcsApp.onlineReg.zipCode" for="field_zipCode">Zipcode</label><input type="text" class="form-control online-form-control" name="zipCode" id="field_zipCode" autocomplete="off" ng-model="vm.registration.zipCode" ng-required="vm.config.zipCodeRequired" ng-maxlength="32"><div ng-show="editForm.zipCode.$invalid"><p class="error-block" ng-show="editForm.zipCode.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.zipCode.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="col-md-4" ng-if="vm.config.cityVisible"><label class="control-label" ng-class="{\'required-field\': vm.config.cityRequired}" data-translate="pcsApp.onlineReg.city" for="field_city">city</label><input type="text" class="form-control online-form-control" name="city" id="field_city" autocomplete="off" ng-model="vm.registration.city" ng-required="vm.config.cityRequired" ng-maxlength="64"><div ng-show="editForm.city.$invalid"><p class="error-block" ng-show="editForm.city.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.city.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="col-md-4" ng-if="vm.config.countryVisible"><label class="control-label" ng-class="{\'required-field\': vm.config.countryRequired}" data-translate="pcsApp.onlineReg.country" for="field_country">Country</label><ui-select name="country" id="field_country" theme="bootstrap" ng-model="vm.registration.country" ng-required="vm.config.countryRequired"><ui-select-match placeholder="{{ \'pcsApp.onlineReg.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="country in (vm.countries | filter: $select.search) track by country.id"><div ng-bind-html="country.name | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.country.$invalid"><p class="error-block" ng-show="editForm.country.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.country.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div></div><div class="form-group" ng-if="vm.config.streetVisible"><label class="control-label" ng-class="{\'required-field\': vm.config.streetRequired}" data-translate="pcsApp.onlineReg.street" for="field_street">Street</label><input type="text" class="form-control online-form-control" name="street" id="field_street" autocomplete="off" ng-model="vm.registration.street" ng-required="vm.config.streetRequired" ng-maxlength="255"><div ng-show="editForm.street.$invalid"><p class="error-block" ng-show="editForm.street.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.street.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="form-group row" ng-if="vm.config.phoneVisible || vm.config.emailVisible"><div class="col-md-6" ng-if="vm.config.phoneVisible"><label class="control-label" ng-class="{\'required-field\': vm.config.phoneRequired}" data-translate="pcsApp.onlineReg.phone" for="field_phone">Phone</label><input type="text" class="form-control online-form-control" name="phone" id="field_phone" autocomplete="off" ng-model="vm.registration.phone" ng-required="vm.config.phoneRequired" ng-maxlength="64" placeholder="+36-30-1234567"><div ng-show="editForm.phone.$invalid"><p class="error-block" ng-show="editForm.phone.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.phone.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="col-md-3" ng-if="vm.config.emailVisible"><label class="control-label" ng-class="{\'required-field\': vm.config.emailRequired}" data-translate="pcsApp.onlineReg.email" for="field_email">Email</label><input type="email" class="form-control online-form-control" name="email" id="field_email" autocomplete="off" ng-model="vm.registration.email" ng-required="vm.config.emailRequired" ng-maxlength="64"><div ng-show="editForm.email.$invalid"><p class="error-block" ng-show="editForm.email.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.email.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p><p class="error-block" ng-show="editForm.email.$error.email" data-translate="pcsApp.onlineReg.form.validation.email.invalid">Your e-mail is invalid.</p></div><div ng-show="!vm.isEmailIdentical()"><p class="error-block" data-translate="pcsApp.onlineReg.form.validation.email.confirmation.failed">Email and Email confirmation are different.</p></div></div><div class="col-md-3" ng-if="vm.config.emailVisible"><label class="control-label" ng-class="{\'required-field\': vm.config.emailRequired}" data-translate="pcsApp.onlineReg.email2" for="field_email2">Email again</label><input type="email" class="form-control online-form-control" name="email2" id="field_email2" autocomplete="off" ng-model="vm.registration.email2" ng-required="vm.config.emailRequired" ng-maxlength="64"><div ng-show="editForm.email2.$invalid"><p class="error-block" ng-show="editForm.email2.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.email2.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p><p class="error-block" ng-show="editForm.email2.$error.email" data-translate="pcsApp.onlineReg.form.validation.email.invalid">Your e-mail is invalid.</p></div></div></div><div class="form-group" ng-if="vm.config.positionVisible"><label class="control-label" ng-class="{\'required-field\': vm.config.positionRequired}" for="field_position">{{vm.getValueByLanguage(\'positionLabel\')}}</label><input ng-if="!vm.hasPositionSelectableValues()" type="text" class="form-control online-form-control" name="position" id="field_position" autocomplete="off" ng-model="vm.registration.position" ng-required="vm.config.positionRequired" ng-maxlength="64"><select ng-if="vm.hasPositionSelectableValues()" class="form-control" name="position" id="field_position" ng-model="vm.registration.position" ng-required="vm.config.positionRequired"><option value="" data-translate="pcsApp.onlineReg.form.please.select">Please select</option><option ng-repeat="opt in vm.getPositionSelectableValues() track by opt" value="{{opt}}">{{opt}}</option></select><div ng-show="editForm.position.$invalid"><p class="error-block" ng-show="editForm.position.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.position.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group" ng-if="vm.config.otherDataVisible"><label class="control-label" ng-class="{\'required-field\': vm.config.otherDataRequired}" for="field_otherData">{{vm.getValueByLanguage(\'otherDataLabel\')}}</label><input ng-if="!vm.hasOtherDataSelectableValues()" type="text" class="form-control online-form-control" name="otherData" id="field_otherData" autocomplete="off" ng-model="vm.registration.otherData" ng-required="vm.config.otherDataRequired" ng-maxlength="255"><select ng-if="vm.hasOtherDataSelectableValues()" class="form-control" name="otherData" id="field_otherData" ng-model="vm.registration.otherData" ng-required="vm.config.otherDataRequired"><option value="" data-translate="pcsApp.onlineReg.form.please.select">Please select</option><option ng-repeat="opt in vm.getOtherDataSelectableValues() track by opt" value="{{opt}}">{{opt}}</option></select><div ng-show="editForm.otherData.$invalid"><p class="error-block" ng-show="editForm.otherData.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.otherData.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div ng-if="vm.getValueByLanguage(\'personalDataRemark\')"><div ng-bind-html="vm.getValueByLanguage(\'personalDataRemark\')"></div></div></div></div></div></div><!-- Reg types --><div class="row" ng-if="!vm.isSubmitSuccess && vm.registrationTypes.length"><div class="col-md-12"><div class="ibox float-e-margins"><div class="ibox-title" ng-style="vm.headerStyle()"><h3 data-translate="pcsApp.onlineReg.home.registration">Registration</h3></div><div class="ibox-content"><div ng-if="(vm.registrationTypes | filter: {onlineType: \'NORMAL\'}).length"><div class="well b-r-xs required-message-block" ng-if="!vm.registration.regType" data-translate="pcsApp.onlineReg.message.regTypeRequired">Please select a registration below</div><table class="table chargeable-item"><thead><tr><th></th><th data-translate="pcsApp.onlineReg.type">Type</th><th>{{ vm.getValueByLanguage(\'regTypeFirstFeeLabel\') }}</th><th>{{ vm.getValueByLanguage(\'regTypeSecondFeeLabel\') }}</th><th>{{ vm.getValueByLanguage(\'regTypeThirdFeeLabel\') }}</th></tr></thead><tbody><tr ng-repeat="rt in vm.registrationTypes | filter: {onlineType: \'NORMAL\'} track by rt.id"><td><div class="radio radio-success"><input type="radio" required ng-click="vm.setRegTypeRadioButtonValue($event)" name="normal-reg-type" ng-checked="vm.isRegTypeRadioButtonChecked(rt.id)" value="{{rt.id}}"><label style="cursor: default"></label></div></td><td>{{rt.name}}</td><td>{{rt.firstRegFee | number }} {{rt.firstRegFee ? rt.currency : \'\'}}</td><td>{{rt.secondRegFee | number}} {{rt.secondRegFee ? rt.currency : \'\'}}</td><td>{{rt.thirdRegFee | number}} {{rt.thirdRegFee ? rt.currency : \'\'}}</td></tr></tbody></table></div><div ng-if="(vm.registrationTypes | filter: {onlineType: \'EXTRA\'}).length"><h4 ng-show="vm.getValueByLanguage(\'regTypeExtraTitle\')">{{ vm.getValueByLanguage(\'regTypeExtraTitle\') }}</h4><h4 ng-hide="vm.getValueByLanguage(\'regTypeExtraTitle\')" data-translate="pcsApp.onlineReg.home.extraRegistration">Extra Registration(s)</h4><table class="table chargeable-item"><thead><tr><th></th><th data-translate="pcsApp.onlineReg.type">Type</th><th>{{ vm.getValueByLanguage(\'regTypeFirstFeeLabel\') }}</th><th>{{ vm.hasExtraSecondRegFeeValue() ? vm.getValueByLanguage(\'regTypeSecondFeeLabel\') : \'&nbsp;\' }}</th><th>{{ vm.getValueByLanguage(\'regTypeThirdFeeLabel\') }}</th></tr></thead><tbody><tr ng-repeat-start="rt in vm.registrationTypes | filter: {onlineType: \'EXTRA\'} track by rt.id" ng-init="rtId = rt.id" ng-class="{\'table-row-color-odd\': $index % 2 == 0}"><td><div class="checkbox checkbox-success"><input type="checkbox" ng-model="vm.registration.extraRegTypes[rt.id + \'\']" name="reg-type-{{rt.id}}" ng-click="vm.selectExtraRegType(rt)" ng-true-value="[]" ng-false-value="null"><label style="cursor: default"></label></div></td><td>{{rt.name}}</td><td>{{rt.firstRegFee | number}} {{rt.firstRegFee ? rt.currency : \'\'}}</td><td>{{rt.secondRegFee | number}} {{rt.secondRegFee ? rt.currency : \'\'}}</td><td>{{rt.thirdRegFee | number}} {{rt.thirdRegFee ? rt.currency : \'\'}}</td></tr><tr ng-show="vm.isRegTypeSelected(rt)" ng-class="{\'table-row-color-odd\': $index % 2 == 0}"><td colspan="12" style="padding-top: 0"><table class="table m-b-none datatable-with-operations" ng-class="{\'table-row-color-odd\': $index % 2 == 0}"><thead><tr><th colspan="3" class="font-noraml font-italic" data-translate="pcsApp.onlineReg.accPeopleTitle" data-translate-values="{name: \'{{rt.name}}\' }">{{rt.name}}</th></tr></thead><tbody><tr ng-repeat="accPeople in vm.registration.extraRegTypes[rt.id + \'\'] track by $index"><td><div class="form-group"><label class="control-label font-noraml font-italic required-field" data-translate="pcsApp.onlineReg.lastName" for="field_accPeopleLastName{{$index}}">Family name</label><input type="text" class="form-control online-form-control" name="accPeopleLastName{{$index}}" id="field_accPeopleLastName{{$index}}" autocomplete="off" ng-model="vm.registration.extraRegTypes[rt.id + \'\'][$index].lastName" ng-required="vm.isRegTypeSelected(rt)" ng-maxlength="64"><div ng-show="editForm.accPeopleLastName{{$index}}.$invalid"><p class="error-block" ng-show="editForm.accPeopleLastName{{$index}}.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.accPeopleLastName{{$index}}.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div></td><td><div class="form-group"><label class="control-label font-noraml font-italic required-field" data-translate="pcsApp.onlineReg.firstName" for="field_accPeopleFirstName{{$index}}">First name</label><input type="text" class="form-control online-form-control" name="accPeopleFirstName{{$index}}" id="field_accPeopleFirstName{{$index}}" autocomplete="off" ng-model="vm.registration.extraRegTypes[rt.id + \'\'][$index].firstName" ng-required="vm.isRegTypeSelected(rt)" ng-maxlength="64"><div ng-show="editForm.accPeopleFirstName{{$index}}.$invalid"><p class="error-block" ng-show="editForm.accPeopleFirstName{{$index}}.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.accPeopleFirstName{{$index}}.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div></td><td style="vertical-align: middle"><button ng-click="vm.addAccPeople(rtId)" ng-if="$first" class="btn btn-info" type="button" tooltip-placement="top" uib-tooltip="Add"><i class="fa fa-plus"></i></button> <button ng-click="vm.removeAccPeople(rtId, $index)" ng-if="!$first" class="btn btn-danger" type="button" tooltip-placement="top" uib-tooltip="Delete"><i class="fa fa-minus"></i></button></td></tr></tbody></table></td></tr><tr ng-repeat-end=""></tr></tbody></table></div><div ng-if="vm.getValueByLanguage(\'regTypeRemark\')"><div ng-bind-html="vm.getValueByLanguage(\'regTypeRemark\')"></div></div></div></div></div></div><!-- Hotel booking --><div class="row" ng-if="!vm.isSubmitSuccess && vm.hasAnyAvailableRoom()"><div class="col-md-12"><div class="ibox"><div class="ibox-title" ng-style="vm.headerStyle()"><h3 data-translate="pcsApp.onlineReg.home.hotelBooking">Hotel booking</h3></div><div class="ibox-content"><table class="table chargeable-item"><thead><tr><th data-translate="pcsApp.onlineReg.hotel">Hotel</th><th data-translate="pcsApp.onlineReg.single">Single</th><th data-translate="pcsApp.onlineReg.double">Double</th></tr></thead><tbody ng-repeat="h in vm.hotelRooms" ng-init="hotel = h" ng-class="{\'table-row-color-odd\': $index % 2 == 0}"><tr ng-repeat="room in hotel.rooms"><td ng-if="$index == 0" rowspan="{{ hotel.rowSpan }}"><strong>{{hotel.name}}</strong><br><small ng-if="!vm.isLangHu">{{hotel.street ? hotel.street : \'\'}}{{hotel.city ? \', \' + hotel.city : \'\'}}{{hotel.zipCode ? \', \' + hotel.zipCode : \'\'}}</small> <small ng-if="vm.isLangHu">{{hotel.zipCode ? hotel.zipCode : \'\'}}{{hotel.city ? \' \' + hotel.city : \'\'}}{{hotel.street ? \', \' + hotel.street : \'\'}}</small></td><td><div ng-if="room.single" class="radio radio-success"><input type="radio" name="selected-room" id="selected-room-{{room.single.id}}" ng-click="vm.registration.departureDate = null; vm.setRoomRadioButtonValue($event)" ng-checked="vm.isRoomRadioButtonChecked(room.single.id)" value="{{room.single.id}}"><label for="selected-room-{{room.single.id}}">{{room.single.price | number}} {{room.single.currency}} {{room.single.name}}</label><button tooltip-placement="top" uib-tooltip="Room external link" style="display: inline-block" class="btn btn-xs btn-info m-t-n-xs" ng-if="room.single.onlineExternalLink" ng-click="vm.openRoomExternalLink(room.single)"><i class="fa fa-external-link"></i></button> <a href="mailto: {{ room.single.onlineExternalEmail }}" ng-if="room.single.onlineExternalEmail" tooltip-placement="top" uib-tooltip="Send email to the hotel: {{room.single.onlineExternalEmail}}" style="display: inline-block" class="btn btn-xs btn-info m-t-n-xs"><i class="fa fa-mail-forward"></i></a></div></td><td><div ng-if="room.double" class="radio radio-success"><input type="radio" name="selected-room" id="selected-room-{{room.double.id}}" ng-click="vm.registration.departureDate = null; vm.setRoomRadioButtonValue($event)" ng-checked="vm.isRoomRadioButtonChecked(room.double.id)" value="{{room.double.id}}"><label for="selected-room-{{room.double.id}}">{{room.double.price | number}} {{room.double.currency}} {{room.double.name}}</label><button tooltip-placement="top" uib-tooltip="Room external link" class="btn btn-xs btn-info m-t-n-xs" ng-if="room.double.onlineExternalLink" ng-click="vm.openRoomExternalLink(room.double)"><i class="fa fa-external-link"></i></button></div></td></tr></tbody></table><div class="form-group row"><div class="col-lg-5"><label class="control-label" ng-class="{\'required-field\': vm.isHotelRoomDatesRequired()}" data-translate="pcsApp.onlineReg.arrivalDate" for="field_arrivalDate">Arrival date</label><select class="form-control online-form-control" name="arrivalDate" ng-model="vm.registration.arrivalDate" ng-change="vm.registration.departureDate = null; vm.calculateNights();" ng-options="item.value as item.label for item in vm.getArrivalDates()" id="field_arrivalDate" ng-required="vm.isHotelRoomDatesRequired()"></select><div ng-show="editForm.arrivalDate.$invalid"><p class="error-block" ng-show="editForm.arrivalDate.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.arrivalDate.$error.quantity" translate="pcsApp.onlineReg.error.noMoreRoomAvailable">Between the arrival and departure date, on one, or more night there is no available room of the selected roomtype.</p></div></div><div class="col-lg-5"><label class="control-label" ng-class="{\'required-field\': vm.isHotelRoomDatesRequired()}" data-translate="pcsApp.onlineReg.departureDate" for="field_departureDate">Departure date</label><select online-room-quantity-validation hotel-rooms="vm.hotelRooms" room-id="vm.registration.room" arrival-date="vm.registration.arrivalDate" class="form-control online-form-control" name="departureDate" ng-model="vm.registration.departureDate" ng-change="vm.calculateNights()" ng-options="item.value as item.label for item in vm.getDepartureDates()" id="field_departureDate" ng-required="vm.isHotelRoomDatesRequired()"></select><div ng-show="editForm.departureDate.$invalid"><p class="error-block" ng-show="editForm.departureDate.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.departureDate.$error.quantity" translate="pcsApp.onlineReg.error.noMoreRoomAvailable">Between the arrival and departure date, on one, or more night there is no available room of the selected roomtype.</p></div></div><div class="col-lg-2"><label class="control-label" data-translate="pcsApp.onlineReg.night">Night</label><p class="form-control-static">{{vm.nights}}</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineReg.roommate" for="field_roommate">Roommate</label><input type="text" class="form-control online-form-control" name="roommate" id="field_roommate" autocomplete="off" ng-model="vm.registration.roommate" ng-maxlength="64"><div ng-show="editForm.roommate.$invalid"><p class="error-block" ng-show="editForm.roommate.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.roommate.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineReg.roomRemark" for="field_roomRemark">Remark</label><textarea class="form-control online-form-control" name="roomRemark" id="field_roomRemark" rows="1" ng-maxlength="255" autocomplete="off" ng-model="vm.registration.roomRemark">\n                            </textarea><div ng-show="editForm.roomRemark.$invalid"><p class="error-block" ng-show="editForm.roomRemark.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.roomRemark.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="255">This field cannot be longer than 155 characters.</p></div></div><div ng-if="vm.getValueByLanguage(\'roomRemark\')"><div ng-bind-html="vm.getValueByLanguage(\'roomRemark\')"></div></div></div></div></div></div><!-- Optional services --><div class="row" ng-if="!vm.isSubmitSuccess && vm.optionalServices.length"><div class="col-md-12"><div class="ibox float-e-margins"><div class="ibox-title" ng-style="vm.headerStyle()"><h3 data-translate="pcsApp.onlineReg.home.optionalService">Optional services</h3></div><div class="ibox-content"><div ng-if="(vm.optionalServices | filter: {onlineType: \'NORMAL\'}).length"><!--<h4 data-translate="pcsApp.onlineReg.home.socialEvents">Social Events</h4>--><table class="table table-striped chargeable-item"><thead><tr><th data-translate="pcsApp.onlineReg.osName">Name</th><th data-translate="pcsApp.onlineReg.osPricePerPerson">Price/Person</th><th data-translate="pcsApp.onlineReg.osPax">Pax</th><th data-translate="pcsApp.onlineReg.osAmount">Amount</th></tr></thead><tbody><tr ng-repeat="os in vm.optionalServices | filter: {onlineType: \'NORMAL\'} track by os.id"><td><strong>{{os.name}}</strong> <small>{{os.startDate | date: \'longDate\'}}</small></td><td>{{os.price | number}} {{os.currency}}</td><td><select class="form-control online-form-control" ng-model="vm.registration.optionalServices[os.id + \'\']" name="os-normal-person-{{os.id}}" id="os-normal-person-{{os.id}}"><option value="">--</option><option value="1">1</option><option value="2" ng-if="os.available >= 2">2</option><option value="3" ng-if="os.available >= 3">3</option><option value="4" ng-if="os.available >= 4">4</option></select></td><td>{{vm.calculateOSPrice(os)}}</td></tr></tbody></table></div><div ng-if="(vm.optionalServices | filter: {onlineType: \'EXTRA\'}).length"><h4 ng-show="vm.getValueByLanguage(\'optionalServiceExtraTitle\')">{{ vm.getValueByLanguage(\'optionalServiceExtraTitle\') }}</h4><h4 ng-hide="vm.getValueByLanguage(\'optionalServiceExtraTitle\')" data-translate="pcsApp.onlineReg.home.miscellaneous">Miscellaneous</h4><table class="table table-striped chargeable-item"><thead><tr><th data-translate="pcsApp.onlineReg.osName">Name</th><th data-translate="pcsApp.onlineReg.osPricePerPerson">Price/Person</th><th data-translate="pcsApp.onlineReg.osPax">Pax</th><th data-translate="pcsApp.onlineReg.osAmount">Amount</th></tr></thead><tbody><tr ng-repeat="os in vm.optionalServices | filter: {onlineType: \'EXTRA\'} track by os.id"><td>{{os.name}} <small>{{os.startDate | date:\'longDate\'}}</small></td><td>{{os.price}} {{os.currency}}</td><td><select class="form-control online-form-control" ng-model="vm.registration.optionalServices[os.id + \'\']" name="os-extra-person-{{os.id}}" id="os-extra-person-{{os.id}}"><option value="">--</option><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></td><td>{{vm.calculateOSPrice(os)}}</td></tr></tbody></table></div><div ng-if="vm.getValueByLanguage(\'optionalServiceRemark\')"><div ng-bind-html="vm.getValueByLanguage(\'optionalServiceRemark\')"></div></div></div></div></div></div><!-- Custom questions --><div class="row" ng-if="!vm.isSubmitSuccess && vm.customQuestions.length"><div class="col-md-12"><div class="ibox float-e-margins"><div class="ibox-title" ng-style="vm.headerStyle()"><h3 data-translate="pcsApp.onlineReg.home.customQuestions">Custom questions</h3></div><div class="ibox-content"><div><table class="table table-striped chargeable-item"><tbody><tr ng-repeat="question in vm.customQuestions track by question.id"><td><div class="form-group"><label class="control-label" for="field_custom_question{{question.id}}" ng-class="{\'required-field\': question.required}">{{question.question}}</label><textarea ng-if="!question.questionAnswers.length" class="form-control online-form-control" ng-required="question.required" name="custom_question{{question.id}}" id="field_custom_question{{question.id}}" rows="1" ng-maxlength="1000" autocomplete="off" ng-model="vm.registration.customAnswers[question.id + \'\']">\n                                            </textarea><select ng-if="question.questionAnswers.length" style="width: 100%" class="form-control online-form-control" ng-required="question.required" name="custom_question{{question.id}}" id="field_custom_question{{question.id}}" ng-model="vm.registration.customAnswers[question.id + \'\']"><option value="" data-translate="pcsApp.onlineReg.form.please.select">Please select</option><option ng-repeat="opt in question.questionAnswers track by opt" value="{{opt}}">{{opt}}</option></select><div ng-show="editForm.custom_question{{question.id}}.$invalid"><p class="error-block" ng-show="editForm.custom_question{{question.id}}.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.custom_question{{question.id}}.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="1000">This field cannot be longer than 1000 characters.</p></div></div></td></tr></tbody></table></div></div></div></div></div><!-- Discount codes --><div class="row" ng-if="!vm.isSubmitSuccess && vm.config.discountAvailable"><div class="col-md-12"><div class="ibox float-e-margins"><div class="ibox-title" ng-style="vm.headerStyle()"><h3 data-translate="pcsApp.onlineReg.home.discountCodes">Discount codes</h3></div><div class="ibox-content"><div><table class="table table-striped chargeable-item"><tbody><tr><td style="width: 20%"><strong data-translate="pcsApp.onlineReg.discountCode">Discount code</strong></td><td style="width: 140px"><input type="text" class="form-control online-form-control" name="discountCode" id="field_discountCode" autocomplete="off" ng-model="vm.discountCodeText" ng-keyup="vm.checkDiscountCode()"></td><td><span class="text-info" ng-if="vm.registration.discountCode" data-translate="pcsApp.onlineReg.message.discountCodeMessage" data-translate-values="{ discountPercentage: \'{{ vm.registration.discountPercentage }}\'}"></span> <span class="text-warning" ng-if="!vm.registration.discountCode">No valid code provided yet</span></td></tr></tbody></table></div></div></div></div></div><!-- Payment --><div ng-if="!vm.isSubmitSuccess && !vm.config.noPaymentRequired" class="row"><div class="col-md-12"><div class="ibox float-e-margins"><div class="ibox-title" ng-style="vm.headerStyle()"><h3 data-translate="pcsApp.onlineReg.home.payment">Payment</h3></div><div class="ibox-content"><table class="table table-striped chargeable-item"><thead><tr><th data-translate="pcsApp.onlineReg.paymentType">Type</th><th ng-if="vm.registration.discountPercentage" data-translate="pcsApp.onlineReg.paymentAmount">Amount</th><th ng-if="vm.registration.discountPercentage" data-translate="pcsApp.onlineReg.discountAmount">Discount</th><th data-translate="pcsApp.onlineReg.totalAmount">Amount</th></tr></thead><tbody><tr ng-if="vm.calculateRTTotal()"><td data-translate="pcsApp.onlineReg.rtSubTotal">Registration subtotal</td><td ng-if="vm.registration.discountPercentage">{{vm.displayRTSubTotal()}}</td><td ng-if="vm.registration.discountPercentage">{{vm.displayRTSubTotalDiscount()}}</td><td>{{vm.displayRTTotal()}}</td></tr><tr ng-if="vm.calculateHRTotal()"><td data-translate="pcsApp.onlineReg.hrSubTotal">Accomodation subtotal</td><td ng-if="vm.registration.discountPercentage">{{vm.displayHRSubTotal()}}</td><td ng-if="vm.registration.discountPercentage">{{vm.displayHRSubTotalDiscount()}}</td><td>{{vm.displayHRTotal()}}</td></tr><tr ng-if="vm.calculateOSTotal()"><td data-translate="pcsApp.onlineReg.osSubTotal">Programmes subtotal</td><td ng-if="vm.registration.discountPercentage">{{vm.displayOSSubTotal()}}</td><td ng-if="vm.registration.discountPercentage">{{vm.displayOSSubTotalDiscount()}}</td><td>{{vm.displayOSTotal()}}</td></tr><tr><td data-translate="pcsApp.onlineReg.grandTotal" class="font-bold">TOTAL PAYABLE</td><td ng-if="vm.registration.discountPercentage">{{vm.displayGrandTotal()}}</td><td ng-if="vm.registration.discountPercentage">{{vm.displayGrandTotalDiscount()}}</td><td class="font-bold">{{vm.displayGrandTotalWithDiscount()}}</td></tr></tbody></table></div></div></div></div><!-- Method of payment --><div ng-if="!vm.isSubmitSuccess && !vm.config.noPaymentRequired && (vm.config.bankTransferVisible || vm.config.checkVisible || vm.config.creditCardVisible)" class="row"><div class="col-md-12"><div class="ibox float-e-margins"><div class="ibox-title" ng-style="vm.headerStyle()"><h3 data-translate="pcsApp.onlineReg.home.paymentMethod">Method of payment</h3></div><div class="ibox-content"><div class="well b-r-xs required-message-block" ng-if="!vm.registration.paymentMethod" data-translate="pcsApp.onlineReg.message.paymentMethodRequired">Please select a payment method below</div><div class="form-group row"><label class="col-sm-2 control-label" data-translate="pcsApp.onlineReg.paymentMethod">Method of payment</label><div class="col-sm-10"><div ng-if="vm.config.bankTransferVisible" class="radio radio-success radio-inline"><input type="radio" value="TRANSFER" ng-model="vm.registration.paymentMethod" required ng-change="vm.resetPaymentMethodState()" name="paymentMethod" id="paymentMethod1"><label for="paymentMethod1" data-translate="pcsApp.onlineReg.bankTransfer">Bank Transfer</label></div><div ng-if="vm.config.checkVisible" class="radio radio-success radio-inline"><input type="radio" value="CHECK" ng-model="vm.registration.paymentMethod" required ng-change="vm.resetPaymentMethodState()" name="paymentMethod" id="paymentMethod2"><label for="paymentMethod2" data-translate="pcsApp.onlineReg.check">Check</label></div><div ng-if="vm.config.creditCardVisible" class="radio radio-success radio-inline"><input type="radio" value="CARD" ng-model="vm.registration.paymentMethod" required ng-change="vm.resetPaymentMethodState()" name="paymentMethod" id="paymentMethod3"><label for="paymentMethod3" data-translate="pcsApp.onlineReg.creditCard">Credit card</label><img ng-show="vm.registration.cardType != \'AMEX\' && vm.isLangHu" class="p-w-xs" src="/content/images/kh_label_hu.png"> <img ng-show="vm.registration.cardType != \'AMEX\' && !vm.isLangHu" class="p-w-xs" src="/content/images/kh_label_en.png"></div></div></div><!--<hr class="hr-line-dashed">--><div ng-show="vm.registration.paymentMethod == \'TRANSFER\'" class="ibox float-e-margins border-left-right border-top-bottom"><div class="ibox-title bg-muted"><h3 data-translate="pcsApp.onlineReg.bankTransfer">Bank Transfer</h3></div><div class="ibox-content"><div ng-if="vm.getValueByLanguage(\'bankTransferInfo\')"><div ng-bind-html="vm.getValueByLanguage(\'bankTransferInfo\')"></div></div></div></div><div ng-show="vm.registration.paymentMethod == \'CHECK\'" class="ibox float-e-margins border-left-right border-top-bottom"><div class="ibox-title bg-muted"><h3 data-translate="pcsApp.onlineReg.check">Check</h3></div><div class="ibox-content"><div class="form-group"><label class="control-label required-field" data-translate="pcsApp.onlineReg.checkName" for="field_checkName">Check Name</label><input type="text" class="form-control online-form-control" name="checkName" id="field_checkName" autocomplete="off" ng-model="vm.registration.checkName" ng-required="vm.isCheckDataRequired()" ng-maxlength="64"><div ng-show="editForm.checkName.$invalid"><p class="error-block" ng-show="editForm.checkName.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.checkName.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label required-field" data-translate="pcsApp.onlineReg.checkAddress" for="field_checkAddress">Check Address</label><input type="text" class="form-control online-form-control" name="checkAddress" id="field_checkAddress" autocomplete="off" ng-model="vm.registration.checkAddress" ng-required="vm.isCheckDataRequired()" ng-maxlength="255"><div ng-show="editForm.checkAddress.$invalid"><p class="error-block" ng-show="editForm.checkAddress.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.checkAddress.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div><p class="form-control-static font-bold">K\xE9rem a csekk post\xE1z\xE1s\xE1t c\xEDmemre!</p></div></div></div><div ng-show="vm.registration.paymentMethod == \'CARD\'" class="ibox float-e-margins border-left-right border-top-bottom"><div class="ibox-title bg-muted"><h3 data-translate="pcsApp.onlineReg.creditCard">Credit card</h3></div><div class="ibox-content"><div class="well bg-payment-info font-bold m-b-md b-r-xs"><p ng-show="vm.registration.cardType != \'AMEX\'" data-translate="pcsApp.onlineReg.message.creditCardInfo"></p><a ng-href="https://www.congressline.hu/wp-content/uploads/{{ vm.getCustomerInformationFilename() }}" data-translate="pcsApp.onlineReg.customerInfo" target="_blank">Customer Information</a> <a ng-href="https://www.congressline.hu/{{ vm.getPrivacyPolicyFilename() }}" style="padding-left: 20px" data-translate="pcsApp.onlineReg.privacyPolicy" target="_blank">Privacy Policy</a></div><div class="well b-r-xs required-message-block" ng-if="!vm.registration.cardType && vm.registration.paymentMethod == \'CARD\'" data-translate="pcsApp.onlineReg.message.cardTypeRequired">Please select your card type below</div><div class="form-group row"><div class="col-sm-1" ng-show="vm.registration.cardType == \'EC_MC\' || vm.registration.cardType == \'VISA\'"><img src="/content/images/kh_logo.jpg"></div><div class="col-sm-10"><div class="col-sm-8 p-h-md"><label class="p-w-xs control-label" data-translate="pcsApp.onlineReg.form.please.charge.prefix" data-translate-values="{ amount: \'{{ vm.displayGrandTotalWithDiscount() }}\' }">Please charge {{ vm.displayGrandTotalWithDiscount() }} to my</label><div class="radio radio-success radio-inline"><input type="radio" value="VISA" ng-model="vm.registration.cardType" name="cardType" id="cardType1"><label for="cardType1">VISA</label></div><div class="radio radio-success radio-inline"><input type="radio" value="EC_MC" ng-model="vm.registration.cardType" name="cardType" id="cardType2"><label for="cardType2">EC/MC</label></div><div class="radio radio-success radio-inline"><input type="radio" value="AMEX" ng-model="vm.registration.cardType" name="cardType" id="cardType3"><label for="cardType3">AMEX</label></div><label class="p-w-xs control-label" data-translate="pcsApp.onlineReg.form.please.charge.suffix">card</label></div></div></div><div ng-show="vm.isCardDataRequired()"><div class="form-group row"><div class="col-md-6"><label class="control-label" ng-class="{\'required-field\': vm.isCardDataRequired()}" data-translate="pcsApp.onlineReg.cardHolderName" for="field_cardHolderName">Name of Cardholder</label><input type="text" class="form-control online-form-control" ng-model="vm.registration.cardHolderName" name="cardHolderName" id="field_cardHolderName" autocomplete="off" ng-model="vm.registration.cardHolderName" ng-required="vm.isCardDataRequired()" ng-maxlength="64"><div ng-show="editForm.cardHolderName.$invalid"><p class="error-block" ng-show="editForm.cardHolderName.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.cardHolderName.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="col-md-6"><label class="control-label" ng-class="{\'required-field\': vm.isCardDataRequired()}" data-translate="pcsApp.onlineReg.cardHolderAddress" for="field_cardHolderAddress">Billing address of the Cardholder</label><input type="text" class="form-control online-form-control" name="cardHolderAddress" id="field_cardHolderAddress" autocomplete="off" ng-model="vm.registration.cardHolderAddress" ng-required="vm.isCardDataRequired()" ng-maxlength="64"><div ng-show="editForm.cardHolderAddress.$invalid"><p class="error-block" ng-show="editForm.cardHolderAddress.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.cardHolderAddress.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div></div><div class="form-group row"><div class="col-md-6"><label class="control-label" ng-class="{\'required-field\': vm.isCardDataRequired()}" data-translate="pcsApp.onlineReg.cardNumber" for="field_cardNumber">Card number</label><input type="text" class="form-control online-form-control" name="cardNumber" id="field_cardNumber" autocomplete="off" ng-model="vm.registration.cardNumber" ng-required="vm.isCardDataRequired()" ng-minlength="15" ng-maxlength="15"><div ng-show="editForm.cardNumber.$invalid"><p class="error-block" ng-show="editForm.cardNumber.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.cardNumber.$error.minlength" data-translate="pcsApp.onlineReg.form.validation.amexcard.length" translate-value-max="15">This field cannot be shorter than 15 characters.</p><p class="error-block" ng-show="editForm.cardNumber.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.amexcard.length" translate-value-max="15">This field cannot be longer than 15 characters.</p></div></div><div class="col-md-3"><label class="control-label" ng-class="{\'required-field\': vm.isCardDataRequired()}" data-translate="pcsApp.onlineReg.cardExpiryMonth" for="field_cardExpiryMonth">Expiry Month</label><input type="text" class="form-control online-form-control" name="cardExpiryMonth" id="field_cardExpiryMonth" autocomplete="off" ng-model="vm.registration.cardExpiryMonth" ng-required="vm.isCardDataRequired()" ng-maxlength="2" ng-pattern="/^01|02|03|04|05|06|07|08|09|10|11|12$/"><div ng-show="editForm.cardExpiryMonth.$invalid"><p class="error-block" ng-show="editForm.cardExpiryMonth.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.cardExpiryMonth.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="2">This field cannot be longer than 2 characters.</p><p class="error-block" ng-show="editForm.cardExpiryMonth.$error.pattern" data-translate="pcsApp.onlineReg.form.validation.cardMonthPattern" data-translate-values="{ pattern: \'01-12\' }">Ez a mez\u0151 csak sz\xE1mokat tartalmazhat pl.: 01-12</p></div></div><div class="col-md-3"><label class="control-label" ng-class="{\'required-field\': vm.isCardDataRequired()}" data-translate="pcsApp.onlineReg.cardExpiryYear" for="field_cardExpiryYear">Expiry Year</label><input type="text" class="form-control online-form-control" name="cardExpiryYear" id="field_cardExpiryYear" autocomplete="off" ng-model="vm.registration.cardExpiryYear" ng-required="vm.isCardDataRequired()" ng-maxlength="2"><div ng-show="editForm.cardExpiryYear.$invalid"><p class="error-block" ng-show="editForm.cardExpiryYear.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.cardExpiryYear.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="2">This field cannot be longer than 2 characters.</p></div></div></div></div></div></div></div></div></div></div><!-- Invoice / Receipt / Billing --><div ng-if="!vm.isSubmitSuccess && !vm.config.noPaymentRequired && vm.config.paymentSupplier !== \'STRIPE\'" class="row"><div class="col-md-12"><div class="ibox float-e-margins"><div class="ibox-title" ng-style="vm.headerStyle()"><h3 data-translate="pcsApp.onlineReg.home.billing">Invoice / Receipt / Billing</h3></div><div class="ibox-content"><div class="form-group row"><div class="col-md-8"><label class="control-label required-field" data-translate="pcsApp.onlineReg.invoiceName" for="field_invoiceName">Name for invoice</label><input type="text" class="form-control online-form-control" name="invoiceName" id="field_invoiceName" autocomplete="off" ng-model="vm.registration.invoiceName" required ng-maxlength="128"><div ng-show="editForm.invoiceName.$invalid"><p class="error-block" ng-show="editForm.invoiceName.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.invoiceName.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="128">This field cannot be longer than 128 characters.</p></div></div><div class="col-md-4"><label class="control-label" data-translate="pcsApp.onlineReg.invoiceTaxNumber" for="field_invoiceTaxNumber">invoiceTaxNumber</label><input type="text" class="form-control online-form-control" name="invoiceTaxNumber" id="field_invoiceTaxNumber" autocomplete="off" ng-model="vm.registration.invoiceTaxNumber" ng-maxlength="64"><div ng-show="editForm.invoiceTaxNumber.$invalid"><p class="error-block" ng-show="editForm.invoiceTaxNumber.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.invoiceTaxNumber.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div></div><div class="form-group"><div class="checkbox checkbox-success"><input type="checkbox" name="copyInvoiceData" ng-click="vm.copyInvoiceInfo()" ng-model="vm.invoiceInfoCopied"><label style="cursor: default" class="control-label" data-translate="pcsApp.onlineReg.copyInvoiceInfo">Copy invoice info from personal data</label></div></div><div class="form-group row"><div class="col-md-4"><label class="control-label required-field" data-translate="pcsApp.onlineReg.country" for="field_invoiceCountry">Country</label><ui-select name="invoiceCountry" id="field_invoiceCountry" theme="bootstrap" ng-model="vm.registration.invoiceCountry" required><ui-select-match placeholder="{{ \'pcsApp.onlineReg.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="country in (vm.countries | filter: $select.search) track by country.id"><div ng-bind-html="country.name | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.invoiceCountry.$invalid"><p class="error-block" ng-show="editForm.invoiceCountry.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.invoiceCountry.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="col-md-4"><label class="control-label required-field" data-translate="pcsApp.onlineReg.zipCode" for="field_invoiceZipCode">Invoice zipcode</label><input type="text" class="form-control online-form-control" name="invoiceZipCode" id="field_invoiceZipCode" autocomplete="off" required ng-model="vm.registration.invoiceZipCode" ng-maxlength="64"><div ng-show="editForm.invoiceZipCode.$invalid"><p class="error-block" ng-show="editForm.invoiceZipCode.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.invoiceZipCode.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="col-md-4"><label class="control-label required-field" data-translate="pcsApp.onlineReg.city" for="field_invoiceCity">Invoice city</label><input type="text" class="form-control online-form-control" name="invoiceCity" id="field_invoiceCity" autocomplete="off" required ng-model="vm.registration.invoiceCity" ng-maxlength="64"><div ng-show="editForm.invoiceCity.$invalid"><p class="error-block" ng-show="editForm.invoiceCity.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.invoiceCity.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div></div><div class="form-group"><label class="control-label required-field" data-translate="pcsApp.onlineReg.invoiceAddress" for="field_invoiceAddress">Billing address for invoice</label><input type="text" class="form-control online-form-control" name="invoiceAddress" id="field_invoiceAddress" autocomplete="off" ng-model="vm.registration.invoiceAddress" required ng-maxlength="255"><div ng-show="editForm.invoiceAddress.$invalid"><p class="error-block" ng-show="editForm.invoiceAddress.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.invoiceAddress.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="form-group row"><div class="col-md-12"><label class="control-label" data-translate="pcsApp.onlineReg.invoiceReferenceNumber" for="field_invoiceReferenceNumber">Reference name or number for the invoice</label><input type="text" class="form-control online-form-control" name="invoiceReferenceNumber" id="field_invoiceReferenceNumber" autocomplete="off" ng-model="vm.registration.invoiceReferenceNumber" ng-maxlength="64"><div ng-show="editForm.invoiceReferenceNumber.$invalid"><p class="error-block" ng-show="editForm.invoiceReferenceNumber.$error.required" data-translate="pcsApp.onlineReg.form.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.invoiceReferenceNumber.$error.maxlength" data-translate="pcsApp.onlineReg.form.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div></div><div class="well m-t-md b-r-xs" ng-if="vm.getValueByLanguage(\'billingRemark\')"><div ng-bind-html="vm.getValueByLanguage(\'billingRemark\')"></div></div></div></div></div></div><!-- Conditions and granting --><div ng-if="!vm.isSubmitSuccess" class="row"><div class="col-md-12"><div class="ibox float-e-margins"><div class="ibox-title" ng-style="vm.headerStyle()"><h3 data-translate="pcsApp.onlineReg.home.conditions">Conditions and granting</h3></div><div class="ibox-content"><div ng-if="!vm.registration.termsAndConditions || !vm.registration.gdpr" data-translate="pcsApp.onlineReg.form.validation.all.required" class="well m-t-sm b-r-xs required-message-block">All fields are mandatory!</div><table class="table table-striped chargeable-item"><tbody><tr><td><div ng-bind-html="vm.getValueByLanguage(\'termsAndConditionsRemark\')"></div></td><td><div class="checkbox checkbox-success"><input type="checkbox" name="termsAndConditions" ng-model="vm.registration.termsAndConditions" required ng-value="true"><label style="cursor: default"></label></div></td></tr><tr><td><div ng-bind-html="vm.getValueByLanguage(\'gdprRemark\')"></div></td><td><div class="checkbox checkbox-success"><input type="checkbox" name="gdpr" ng-model="vm.registration.gdpr" required ng-value="true"><label style="cursor: default"></label></div></td></tr><tr ng-if="vm.getValueByLanguage(\'marketingRemark\')"><td><div ng-bind-html="vm.getValueByLanguage(\'marketingRemark\')"></div></td><td><div class="checkbox checkbox-success"><input type="checkbox" name="newsletter" ng-model="vm.registration.newsletter" ng-value="true"><label style="cursor: default"></label></div></td></tr></tbody></table><div ng-if="vm.getValueByLanguage(\'conditionsAndGrantingRemark\')" class="well m-t-md b-r-xs"><div ng-bind-html="vm.getValueByLanguage(\'conditionsAndGrantingRemark\')"></div></div></div></div></div></div><div ng-if="vm.selectedRoomOutOfStock" class="row"><div class="col-md-12"><div class="ibox float-e-margins"><div class="ibox-title" ng-style="vm.headerStyle()"><p data-translate="pcsApp.onlineReg.error.selectedRoomNotAvailable">Selected room has been out of stock</p></div></div></div></div><div ng-if="!vm.isSubmitSuccess" class="row"><div class="col-md-12"><div class="ibox"><div class="ibox-content p-sm"><div class="row col-sm-offset-2"><button class="btn btn-white" ng-click="vm.clear()" type="button" data-translate="pcsApp.onlineReg.reset">Reset</button> <button class="btn btn-primary" ng-click="vm.submit()" ng-disabled="!vm.isEmailIdentical() || editForm.$invalid || vm.isSending" type="button" data-translate="pcsApp.onlineReg.submit">Submit registration</button></div></div></div></div></div><div class="online-reg-footer" data-translate="pcsApp.onlineReg.footer">Congressline Kft. \u2022 1065 Budapest, R\xE9vay k\xF6z 2. \u2022 Tel: (+36-1) 429-0146, (+36-1) 312-1582 \u2022 Web: <a href="http://www.congressline.hu" target="_blank">www.congressline.hu</a></div></div></div></form>');
$templateCache.put('app/entities/online-reg/online-reg-payment-failure.html','<jhi-alert></jhi-alert><style>.stretch-background {\n        height: 100% !important;\n    }</style><div class="wrapper wrapper-content p-xl gray-bg stretch-background"><div class="container animated fadeInRight"><div class="row"><div class="col-md-12"><img class="online-reg-header-image" ng-src="{{\'/api/registration/online/header/\' + vm.paymentResult.congressUuid }}" onerror="this.style.display=\'none\'"></div></div><div class="row"><div class="col-md-12"><div class="ibox float-e-margins"><div class="ibox-title" ng-style="vm.headerStyle()"><h2 data-translate="pcsApp.onlineReg.home.paymentFailureTitle">Payment failure!</h2></div><div class="ibox-content"><h3 class="text-danger" data-translate="pcsApp.onlineReg.message.paymentFailure.{{ vm.getErrorStatus() }}"></h3><p data-translate="pcsApp.onlineReg.message.paymentFailureInfo.{{ vm.getErrorStatus() }}">Please check your bank account. Please go back to your on-line registration and chose another payment option.</p><a href="https://{{ vm.paymentResult.website }}" data-translate="pcsApp.onlineReg.congressWebsiteButton">Vissza a rendezv\xE9ny weboldal\xE1ra</a></div></div></div></div><div class="online-reg-footer" data-translate="pcsApp.onlineReg.footer">Congressline Kft. \u2022 1065 Budapest, R\xE9vay k\xF6z 2. \u2022 Tel: (+36-1) 429-0146, (+36-1) 312-1582 Fax: (+36-1) 429-0147 \u2022 Web: <a href="http://www.congressline.hu" target="_blank">www.congressline.hu</a></div></div></div>');
$templateCache.put('app/entities/online-reg/online-reg-payment-success.html','<jhi-alert></jhi-alert><style>.stretch-background {\n        height: 100% !important;\n    }</style><div class="wrapper wrapper-content p-xl gray-bg stretch-background"><div class="container animated fadeInRight"><div class="row"><div class="col-md-12"><img class="online-reg-header-image" ng-src="{{\'/api/registration/online/header/\' + vm.paymentResult.congressUuid }}" onerror="this.style.display=\'none\'"></div></div><div class="row"><div class="col-md-12"><div class="ibox float-e-margins"><div class="ibox-title" ng-style="vm.headerStyle()"><h2 data-translate="pcsApp.onlineReg.home.paymentSuccessTitle">Payment was successful!</h2></div><div class="ibox-content"><h3 class="text-info" data-translate="pcsApp.onlineReg.message.paymentSuccess"></h3><p data-translate="pcsApp.onlineReg.message.paymentSuccessInfo" data-translate-values="{ amount: \'{{ vm.paymentResult.amount }}\', currency: \'{{ vm.paymentResult.currency }}\'}">Az \xF6n hitelk\xE1rty\xE1j\xE1n HUF 1000 \xF6sszeg ker\xFClt terhel\xE9sre.<br>A t\xE9teles elsz\xE1mol\xE1st a konferencia szervez\u0151je \xE1ltal, e-mailen k\xFCld\xF6tt r\xE9szletes visszaigazol\xE1s fogja tartalmazni.</p><p data-translate="pcsApp.onlineReg.message.submitOnlineSpamWarning">Email sent successfully Check spam folder if not received!</p><a href="https://{{ vm.paymentResult.website }}" data-translate="pcsApp.onlineReg.congressWebsiteButton">Vissza a rendezv\xE9ny weboldal\xE1ra</a></div></div></div></div><div class="online-reg-footer" data-translate="pcsApp.onlineReg.footer">Congressline Kft. \u2022 1065 Budapest, R\xE9vay k\xF6z 2. \u2022 Tel: (+36-1) 429-0146, (+36-1) 312-1582 Fax: (+36-1) 429-0147 \u2022 Web: <a href="http://www.congressline.hu" target="_blank">www.congressline.hu</a></div></div></div>');
$templateCache.put('app/entities/online-reg-custom-answer-report/online-reg-custom-answer-detail-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAnswerLabel" data-translate="pcsApp.onlineRegCustomAnswerReport.home.detail">Answer details</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-repeat="answer in vm.customAnswers track by $index"><label class="control-label" for="field_custom_answer{{answer.id}}">{{answer.question}}</label><input type="text" class="form-control" name="custom_answer{{answer.id}}" id="field_custom_answer{{answer.id}}" autocomplete="off" disabled="disabled" ng-value="answer.answer"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button></div></form>');
$templateCache.put('app/entities/online-reg-custom-answer-report/online-reg-custom-answer-reports.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 data-translate="pcsApp.onlineRegCustomAnswerReport.home.title">Online Reg Custom Answer Report</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><div class="row"><div class="col-md-12"><div class="col-md-8"></div><div class="col-md-4 input-group"><ui-select ng-model="vm.reportFilter.currency" name="currency" id="search_currency" theme="bootstrap"><ui-select-match allow-clear="true" placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.currency"></span></ui-select-match><ui-select-choices repeat="currency in vm.currencies | filter: $select.search track by currency.id"><div ng-bind-html="currency.currency | highlight: $select.search"></div></ui-select-choices></ui-select><span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search()"><span class="glyphicon glyphicon-search"></span></button> <button class="btn btn-danger" ng-if="vm.reportList.length || vm.isAnyFilterSet()" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button> <button class="btn btn-primary" ng-if="vm.reportList.length" type="submit" ng-click="vm.downloadReportXls()"><i class="fa fa-download"></i></button></span></div></div></div></div><div class="ibox-content" ng-show="vm.reportList.length"><table datatable="ng" id="regfee-details-by-participant-datatable" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span data-translate="pcsApp.onlineRegCustomAnswerReport.regId">Reg Id</span></th><th><span data-translate="pcsApp.onlineRegCustomAnswerReport.name">Name</span></th><th></th></tr></thead><tbody><tr ng-repeat="answer in vm.reportList track by answer.regId"><td>{{answer.regId}}</td><td>{{answer.name}}</td><td><button class="btn btn-info" type="submit" ui-sref="online-reg-custom-answer-report.detail({id:answer.registrationId})"><i class="glyphicon glyphicon-eye-open"></i></button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/online-reg-custom-question/online-reg-custom-question-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.onlineRegCustomQuestion.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.onlineRegCustomQuestion.delete.question" translate-values="{id: \'{{vm.onlineRegCustomQuestion.id}}\'}">Are you sure you want to delete this question?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/online-reg-custom-question/online-reg-custom-question-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myOnlineRegCustomQuestionLabel" data-translate="pcsApp.onlineRegCustomQuestion.home.createOrEditLabel">Create or edit a question</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegCustomQuestion.question" for="field_question">Question</label><input type="text" class="form-control" name="question" id="field_question" autocomplete="off" ng-model="vm.onlineRegCustomQuestion.question" required ng-minlength="5" ng-maxlength="1000"><div ng-show="editForm.question.$invalid"><p class="error-block" ng-show="editForm.question.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.question.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="5">This field is required to be at least 5 characters.</p><p class="error-block" ng-show="editForm.question.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegCustomQuestion.questionOrder" for="field_questionOrder">Question order</label><input type="number" class="form-control" name="questionOrder" id="field_questionOrder" autocomplete="off" ng-model="vm.onlineRegCustomQuestion.questionOrder" required min="0" max="100"><div ng-show="editForm.questionOrder.$invalid"><p class="error-block" ng-show="editForm.questionOrder.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.questionOrder.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be more than 0.</p><p class="error-block" ng-show="editForm.questionOrder.$error.max" data-translate="entity.validation.max" translate-value-max="100">This field cannot be more than 100.</p><p class="error-block" ng-show="editForm.questionOrder.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label translate="pcsApp.onlineRegCustomQuestion.required" for="field_required">Required</label><div class="checkbox" style="margin-top: 0px; margin-bottom: 0px"><input type="checkbox" ng-model="vm.onlineRegCustomQuestion.required" id="field_required" name="required"><label style="cursor: default"></label></div></div><div class="form-group"><label translate="pcsApp.onlineRegCustomQuestion.currency" for="field_currency">Currency</label><ui-select ng-model="vm.onlineRegCustomQuestion.currency" name="currency" id="field_currency" theme="bootstrap" required><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.currency"></span></ui-select-match><ui-select-choices repeat="currency in (vm.currencies | filter: $select.search) track by currency.id"><div ng-bind-html="currency.currency | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.currency.$invalid"><p class="error-block" ng-show="editForm.currency.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegCustomQuestion.onlineVisibility" for="onlineVisibility">Online visibility</label><select class="form-control" name="onlineVisibility" ng-model="vm.onlineRegCustomQuestion.onlineVisibility" id="onlineVisibility" required><option value="" data-translate="global.form.please.select">Please select</option><option value="VISIBLE" data-translate="pcsApp.OnlineVisibility.VISIBLE">VISIBLE</option><option value="NOT_VISIBLE" data-translate="pcsApp.OnlineVisibility.NOT_VISIBLE">NOT_VISIBLE</option></select><div ng-show="editForm.onlineVisibility.$invalid"><p class="error-block" ng-show="editForm.onlineVisibility.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><table id="position-selectable-hu-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span>Selectable values</span></th><th><button class="btn btn-primary btn-xs" type="button" ng-click="vm.appendSelectableValue(vm.onlineRegCustomQuestion.questionAnswers, 0)"><i class="fa fa-plus"></i></button></th></tr></thead><tbody><tr ng-repeat="answer in vm.onlineRegCustomQuestion.questionAnswers track by $index"><td editable-text-value-cell editable-text-list="vm.onlineRegCustomQuestion.questionAnswers" editable-text-idx="{{$index}}"></td><td><button class="btn btn-primary btn-xs" type="button" ng-click="vm.appendSelectableValue(vm.onlineRegCustomQuestion.questionAnswers, $index + 1)"><i class="fa fa-plus"></i></button> <button class="btn btn-danger btn-xs" type="button" ng-click="vm.deleteFromSelectableValues(vm.onlineRegCustomQuestion.questionAnswers, $index)"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/online-reg-custom-question/online-reg-custom-questions.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 data-translate="pcsApp.onlineRegCustomQuestion.home.title" data-translate-values="{ meetingCode: \'{{ vm.congress.meetingCode }}\' }">Online reg custom questions</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-primary" type="submit" ui-sref="online-reg-custom-question.new"><i class="fa fa-plus"></i></button> <button class="btn btn-info" type="submit" ui-sref="congress"><i class="fa fa-arrow-left"></i></button></div><div class="ibox-content"><table datatable="ng" id="online-reg-custom-question-datatable" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.onlineRegCustomQuestion.question">Question</span></th><th><span translate="pcsApp.onlineRegCustomQuestion.currency">Currency</span></th><th><span translate="pcsApp.onlineRegCustomQuestion.required">Required</span></th><th><span translate="pcsApp.onlineRegCustomQuestion.onlineVisibility">Online visibility</span></th><th><span translate="pcsApp.onlineRegCustomQuestion.questionOrder">Order</span></th><th></th></tr></thead><tbody><tr ng-repeat="question in vm.questions track by question.id"><td>{{question.question}}</td><td>{{question.currency.currency}}</td><td>{{question.required}}</td><td>{{\'pcsApp.OnlineVisibility.\' + question.onlineVisibility | translate}}</td><td>{{question.questionOrder}}</td><td><button class="btn btn-info" type="submit" ui-sref="online-reg-custom-question.edit({id: question.id})"><i class="fa fa-pencil-square-o"></i></button> <button class="btn btn-danger" type="submit" ui-sref="online-reg-custom-question.delete({id: question.id})"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/online-reg-discount-code/online-reg-discount-code-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.discountCode.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.onlineRegDiscountCode.delete.question" translate-values="{id: \'{{vm.discountCode.id}}\'}">Are you sure you want to delete this discount code?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/online-reg-discount-code/online-reg-discount-code-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myVatInfoLabel" data-translate="pcsApp.onlineRegDiscountCode.home.createOrEditLabel">Create or edit a Vat Info</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegDiscountCode.code" for="field_code">Code</label><input type="text" class="form-control" name="code" id="field_code" autocomplete="off" ng-pattern="/^[A-Za-z0-9]+$/" ng-model="vm.discountCode.code" required ng-minlength="5" ng-maxlength="32"><div ng-show="editForm.code.$invalid"><p class="error-block" ng-show="editForm.code.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.code.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="5">This field is required to be at least 5 characters.</p><p class="error-block" ng-show="editForm.code.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p><p class="error-block" ng-show="editForm.code.$error.pattern" data-translate="entity.validation.pattern" data-translate-values="{ pattern: \'A-Z, a-z, 0-9\' }">Ez a mez\u0151 csak alfanumerikus \xE9rt\xE9keket tartalmazhat pl.: A-Z, a-z, 0-9</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegDiscountCode.discountPercentage" for="field_discountPercentage">Amount Percentage</label><input type="number" class="form-control" name="discountPercentage" id="field_discountPercentage" ng-model="vm.discountCode.discountPercentage" autocomplete="off" min="0" max="100" required><div ng-show="editForm.discountPercentage.$invalid"><p class="error-block" ng-show="editForm.discountPercentage.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.discountPercentage.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be more than 0.</p><p class="error-block" ng-show="editForm.discountPercentage.$error.max" data-translate="entity.validation.max" translate-value-max="100">This field cannot be more than 100.</p><p class="error-block" ng-show="editForm.discountPercentage.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.onlineRegDiscountCode.discountType" for="field_discountType">Discount Type</label><select class="form-control" name="discountType" ng-model="vm.discountCode.discountType" ng-change="vm.onDiscountTypeChanged()" id="field_discountType"><option value="" data-translate="global.form.please.select">Please select</option><option value="REGISTRATION" data-translate="pcsApp.ChargeableItemType.REGISTRATION">REGISTRATION</option><option value="HOTEL" data-translate="pcsApp.ChargeableItemType.HOTEL">HOTEL</option><option value="OPTIONAL_SERVICE" data-translate="pcsApp.ChargeableItemType.OPTIONAL_SERVICE">OPTIONAL_SERVICE</option></select><div ng-show="editForm.discountType.$invalid"><p class="error-block" ng-show="editForm.discountType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/online-reg-discount-code/online-reg-discount-codes.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 data-translate="pcsApp.onlineRegDiscountCode.home.title" translate-values="{ congressName: \'{{vm.congress.meetingCode}}\' }">Online reg discount code for {{vm.congress.code}}</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-primary" type="submit" ui-sref="online-reg-discount-code.new"><i class="fa fa-plus"></i></button> <button class="btn btn-info" type="submit" ui-sref="congress"><i class="fa fa-arrow-left"></i></button><!--<div ibox-tools></div>--></div><div class="ibox-content"><table datatable="ng" id="online-reg-discount-code-datatable" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.onlineRegDiscountCode.code">Code</span></th><th><span translate="pcsApp.onlineRegDiscountCode.discountPercentage">Discount percentage</span></th><th><span translate="pcsApp.onlineRegDiscountCode.discountType">Discount type</span></th><th></th></tr></thead><tbody><tr ng-repeat="discountCode in vm.discountCodes track by discountCode.id"><td>{{discountCode.code}}</td><td>{{discountCode.discountPercentage}}</td><td data-translate="{{\'pcsApp.ChargeableItemType.\' + discountCode.discountType}}">{{discountCode.discountType}}</td><td><button class="btn btn-info" type="submit" ui-sref="online-reg-discount-code.edit({id: discountCode.id})"><i class="fa fa-pencil-square-o"></i></button> <button class="btn btn-danger" type="submit" ui-sref="online-reg-discount-code.delete({id: discountCode.id})"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/optional-programs-members/optional-programs-members.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 data-translate="pcsApp.optionalProgramsMembers.home.title">Optional service report</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-primary" type="submit" ng-click="vm.downloadReportXls()"><i class="fa fa-download"></i></button></div><div class="ibox-content" ng-show="vm.optionalProgramsMembers.length"><table datatable="ng" id="optional-program-members-datatable" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" class="table table-striped table-bordered table-hover"><thead><tr><th><span data-translate="pcsApp.optionalProgramsMembers.program">Program</span></th><th><span data-translate="pcsApp.optionalProgramsMembers.name">Name</span></th><th><span data-translate="pcsApp.optionalProgramsMembers.start">Start</span></th><th><span data-translate="pcsApp.optionalProgramsMembers.end">End</span></th><th><span data-translate="pcsApp.optionalProgramsMembers.price">Price</span></th><th><span data-translate="pcsApp.optionalProgramsMembers.currency">Currency</span></th><th><span data-translate="pcsApp.optionalProgramsMembers.applicantsNumber">Applicants no.</span></th><th><span data-translate="pcsApp.optionalProgramsMembers.maxCapacity">Max.capacity</span></th></tr></thead><tbody><tr ng-repeat="optionalProgramMember in vm.optionalProgramsMembers track by optionalProgramMember.program"><td>{{optionalProgramMember.program}}</td><td>{{optionalProgramMember.name}}</td><td>{{optionalProgramMember.startDate}}</td><td>{{optionalProgramMember.endDate}}</td><td>{{optionalProgramMember.price}}</td><td>{{optionalProgramMember.currency}}</td><td>{{optionalProgramMember.numberOfApplicants}}</td><td>{{optionalProgramMember.maxPerson}}</td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/optional-service/optional-service-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.optionalService.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.optionalService.delete.question" translate-values="{id: \'{{vm.optionalService.id}}\'}">Are you sure you want to delete this Optional Service?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/optional-service/optional-service-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myOptionalServiceLabel" data-translate="pcsApp.optionalService.home.createOrEditLabel">Create or edit a Optional Service</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="pcsApp.optionalService.code" for="field_code">Code</label><input type="text" class="form-control" name="code" id="field_code" autocomplete="off" ng-model="vm.optionalService.code" required><div ng-show="editForm.code.$invalid"><p class="error-block" ng-show="editForm.code.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.optionalService.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" autocomplete="off" ng-model="vm.optionalService.name" required ng-minlength="5" ng-maxlength="100"><div ng-show="editForm.name.$invalid"><p class="error-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="5">This field is required to be at least 5 characters.</p><p class="error-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.optionalService.startDate" for="field_startDate">Start Date</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_startDate" type="text" class="form-control" name="startDate" autocomplete="off" required uib-datepicker-popup="{{dateformat}}" ng-model="vm.optionalService.startDate" is-open="vm.datePickerOpenStatus.startDate"></div><div ng-show="editForm.startDate.$invalid"><p class="error-block" ng-show="editForm.startDate.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.optionalService.endDate" for="field_endDate">End Date</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_endDate" type="text" class="form-control" name="endDate" autocomplete="off" date-less-than="{{vm.optionalService.startDate}}" uib-datepicker-popup="{{dateformat}}" ng-model="vm.optionalService.endDate" is-open="vm.datePickerOpenStatus.endDate" required></div><div ng-show="editForm.endDate.$invalid"><p class="error-block" ng-show="editForm.endDate.$error.required" translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.endDate.$error.dateLessThan" translate="pcsApp.optionalService.message.endDateLessThanStartDate">End date must be later than Start date.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.optionalService.price" for="field_price">Price</label><input type="number" class="form-control" name="price" id="field_price" autocomplete="off" ng-model="vm.optionalService.price" required min="-1000000" max="1000000"><div ng-show="editForm.price.$invalid"><p class="error-block" ng-show="editForm.price.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.price.$error.min" data-translate="entity.validation.min" translate-value-min="-1000000">This field should be more than -1000000.</p><p class="error-block" ng-show="editForm.price.$error.max" data-translate="entity.validation.min" translate-value-max="1000000">This field should be more than 1000000.</p><p class="error-block" ng-show="editForm.price.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.optionalService.maxPerson" for="field_maxPerson">Max Person</label><input type="number" class="form-control" name="maxPerson" id="field_maxPerson" autocomplete="off" ng-model="vm.optionalService.maxPerson" optional-service-max-person-validation reserved="vm.optionalService.reserved" required min="0"><div ng-show="editForm.maxPerson.$invalid"><p class="error-block" ng-show="editForm.maxPerson.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.maxPerson.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be more than 0.</p><p class="error-block" ng-show="editForm.maxPerson.$error.number" data-translate="entity.validation.number">This field should be a number.</p><p class="error-block" ng-show="editForm.maxPerson.$error.maxPerson" translate="pcsApp.optionalService.error.maxPersonExceededByReserved">Quantity can not be smaller than the already reserved number of optional service.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.optionalService.reserved" for="field_reserved">Reserved</label><input type="number" class="form-control" name="reserved" id="field_reserved" disabled="disabled" ng-model="vm.optionalService.reserved"></div><div class="form-group"><label translate="pcsApp.optionalService.currency" for="field_currency">Currency</label><ui-select ng-model="vm.optionalService.currency" name="currency" id="field_currency" theme="bootstrap" required><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.currency"></span></ui-select-match><ui-select-choices repeat="currency in (vm.currencies | filter: $select.search) track by currency.id"><div ng-bind-html="currency.currency | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.currency.$invalid"><p class="error-block" ng-show="editForm.currency.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label translate="pcsApp.optionalService.vatInfo" for="field_vatInfo">Vat info</label><ui-select ng-model="vm.optionalService.vatInfo" name="vatInfo" id="field_vatInfo" theme="bootstrap" required><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="vatInfo in (vm.vatInfos | filter: $select.search) track by vatInfo.id"><div ng-bind-html="vatInfo.name | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.vatInfo.$invalid"><p class="error-block" ng-show="editForm.vatInfo.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.optionalService.onlineLabel" for="field_onlineLabel">Online label</label><input type="text" class="form-control" name="onlineLabel" id="field_onlineLabel" autocomplete="off" ng-model="vm.optionalService.onlineLabel" ng-maxlength="200"><div ng-show="editForm.onlineLabel.$invalid"><p class="error-block" ng-show="editForm.onlineLabel.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="200">This field cannot be longer than 200 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.optionalService.onlineOrder" for="field_onlineOrder">Online order</label><input type="number" class="form-control" name="onlineOrder" id="field_onlineOrder" autocomplete="off" ng-model="vm.optionalService.onlineOrder" ng-required="vm.optionalService.onlineVisibility == \'VISIBLE\'" min="0" max="100"><div ng-show="editForm.onlineOrder.$invalid"><p class="error-block" ng-show="editForm.onlineOrder.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.onlineOrder.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be more than 0.</p><p class="error-block" ng-show="editForm.onlineOrder.$error.max" data-translate="entity.validation.max" translate-value-max="100">This field cannot be more than 100.</p><p class="error-block" ng-show="editForm.onlineOrder.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.optionalService.onlineVisibility" for="onlineVisibility">Online visibility</label><select class="form-control" name="onlineVisibility" ng-model="vm.optionalService.onlineVisibility" id="onlineVisibility" required><option value="" data-translate="global.form.please.select">Please select</option><option value="VISIBLE" data-translate="pcsApp.OnlineVisibility.VISIBLE">VISIBLE</option><option value="NOT_VISIBLE" data-translate="pcsApp.OnlineVisibility.NOT_VISIBLE">NOT_VISIBLE</option></select><div ng-show="editForm.onlineVisibility.$invalid"><p class="error-block" ng-show="editForm.onlineVisibility.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.optionalService.onlineType" for="onlineType">Online type</label><select class="form-control" name="onlineType" ng-model="vm.optionalService.onlineType" id="onlineType" required><option value="" data-translate="global.form.please.select">Please select</option><option value="NORMAL" data-translate="pcsApp.OnlineType.NORMAL">NORMAL</option><option value="EXTRA" data-translate="pcsApp.OnlineType.EXTRA">EXTRA</option></select><div ng-show="editForm.onlineType.$invalid"><p class="error-block" ng-show="editForm.onlineType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/optional-service/optional-services.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 translate="pcsApp.optionalService.home.title">Optional Services</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-primary" type="submit" ui-sref="optional-service.new"><i class="fa fa-plus"></i></button></div><div class="ibox-content"><table id="optional-service-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.optionalService.code">Code</span></th><th><span translate="pcsApp.optionalService.name">Name</span></th><th><span translate="pcsApp.optionalService.startDate">Start date</span></th><th><span translate="pcsApp.optionalService.endDate">End date</span></th><th><span translate="pcsApp.optionalService.price">Price</span></th><th><span translate="pcsApp.optionalService.maxPerson">Max person</span></th><th><span translate="pcsApp.optionalService.reserved">Reserved</span></th><th><span translate="pcsApp.optionalService.currency">Currency</span></th><th><span translate="pcsApp.optionalService.vatInfo">Vat Info</span></th><th><span translate="pcsApp.optionalService.onlineVisibility">Online visibility</span></th><th><span translate="pcsApp.optionalService.onlineOrder">Online order</span></th><th></th></tr></thead><tbody><tr ng-repeat="optionalService in vm.optionalServices track by optionalService.id"><td>{{optionalService.code}}</td><td>{{optionalService.name}}</td><td>{{optionalService.startDate | date:\'mediumDate\'}}</td><td>{{optionalService.endDate | date:\'mediumDate\'}}</td><td>{{optionalService.price}}</td><td>{{optionalService.maxPerson}}</td><td>{{optionalService.reserved}}</td><td>{{optionalService.currency.currency}}</td><td>{{optionalService.vatInfo.name}}</td><td>{{\'pcsApp.OnlineVisibility.\' + optionalService.onlineVisibility | translate}}</td><td>{{optionalService.onlineOrder}}</td><td><button class="btn btn-info" type="submit" ui-sref="optional-service.edit({id:optionalService.id})"><i class="fa fa-pencil-square-o"></i></button> <button class="btn btn-danger" type="submit" ui-sref="optional-service.delete({id:optionalService.id})"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/optional-service-applicant/optional-service-applicant-selection-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.select()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="optionalServiceApplicantLabel" data-translate="pcsApp.optionalServiceApplicant.home.createOrEditLabel">Create or edit a Group Discount Item</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="pcsApp.optionalServiceApplicant.optionalService" for="field_optionalService">Optional Service</label><ui-select ng-model="vm.listFilter.optionalService" name="optionalService" id="field_optionalService" theme="bootstrap" required><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="optionalService in (vm.optionalServices | filter: $select.search) track by optionalService.id"><div ng-bind-html="optionalService.name | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.optionalService.$invalid"><p class="error-block" ng-show="editForm.optionalService.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.select">Select</span></button></div></form>');
$templateCache.put('app/entities/optional-service-applicant/optional-service-applicants.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 data-translate="pcsApp.optionalServiceApplicant.home.title">Optional Service By Applicants</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-primary" type="submit" ui-sref="optional-service-applicant.selection"><i class="fa fa-search-plus"></i></button> <button class="btn btn-primary" type="submit" ng-show="vm.listFilter.optionalService" ng-click="vm.downloadReportXls()"><i class="fa fa-download"></i></button>&nbsp;&nbsp; <span ng-show="vm.listFilter.optionalService">Optional service: <strong>{{vm.listFilter.optionalService.name}}</strong>&nbsp;&nbsp;</span></div><div class="ibox-content" ng-show="vm.optionalServiceApplicants.length"><table datatable="ng" id="optional-service-applicant-datatable" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" class="table table-striped table-bordered table-hover"><thead><tr><th><span data-translate="pcsApp.optionalServiceApplicant.regId">Reg Id</span></th><th><span data-translate="pcsApp.optionalServiceApplicant.lastName">Last Name</span></th><th><span data-translate="pcsApp.optionalServiceApplicant.firstName">First Name</span></th><th><span data-translate="pcsApp.optionalServiceApplicant.applicants">Applicants</span></th><th><span data-translate="pcsApp.optionalServiceApplicant.country">Country</span></th><th><span data-translate="pcsApp.optionalServiceApplicant.currency">Currency</span></th><th><span data-translate="pcsApp.optionalServiceApplicant.orderedPrice">Ordered Price</span></th><th><span data-translate="pcsApp.optionalServiceApplicant.paid">Paid</span></th><th><span data-translate="pcsApp.optionalServiceApplicant.hotel">Hotel</span></th><th><span data-translate="pcsApp.optionalServiceApplicant.payingGroup">Paying Group</span></th><th><span data-translate="pcsApp.optionalServiceApplicant.groupCost">Group cost</span></th><th><span data-translate="pcsApp.optionalServiceApplicant.paidByGroup">Paid By Group</span></th></tr></thead><tbody><tr ng-repeat="optionalServiceApplicant in vm.optionalServiceApplicants track by optionalServiceApplicant.id"><td>{{optionalServiceApplicant.regId}}</td><td>{{optionalServiceApplicant.lastName}}</td><td>{{optionalServiceApplicant.firstName}}</td><td>{{optionalServiceApplicant.numOfApplicants}}</td><td>{{optionalServiceApplicant.country}}</td><td>{{optionalServiceApplicant.currency}}</td><td>{{optionalServiceApplicant.orderedPrice}}</td><td>{{optionalServiceApplicant.paid}}</td><td>{{optionalServiceApplicant.hotel}}</td><td>{{optionalServiceApplicant.payingGroupName}}</td><td>{{optionalServiceApplicant.groupCost}}</td><td>{{optionalServiceApplicant.paidByGroup}}</td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/optional-text/optional-text-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.optionalText.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.optionalText.delete.question" translate-values="{id: \'{{vm.optionalText.id}}\'}">Are you sure you want to delete this Optional Text?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/optional-text/optional-text-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myOptionalTextLabel" data-translate="pcsApp.optionalText.home.createOrEditLabel">Create or edit an Optional Text</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="pcsApp.optionalText.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" autocomplete="off" ng-model="vm.optionalText.name" required ng-maxlength="32"><div ng-show="editForm.name.$invalid"><p class="error-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" translate="pcsApp.optionalText.optionalText" for="field_optionalText">Optional text</label><textarea class="form-control" name="optionalText" id="field_optionalText" rows="10" autocomplete="off" required ng-model="vm.optionalText.optionalText" ng-maxlength="2048">\n            </textarea><div ng-show="editForm.optionalText.$invalid"><p class="error-block" ng-show="editForm.optionalText.$error.required" translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.optionalText.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="2048">This field cannot be longer than 2048 characters.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></div></form>');
$templateCache.put('app/entities/optional-text/optional-texts.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 translate="pcsApp.optionalText.home.title">Optional texts</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-primary" type="submit" ui-sref="optional-text.new"><i class="fa fa-plus"></i></button></div><div class="ibox-content"><table id="optional-text-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.optionalText.name">Name</span></th><!--<th><span translate="pcsApp.optionalText.optionalText">Optional text</span></th>--><th></th></tr></thead><tbody><tr ng-repeat="optionalText in vm.optionalTexts track by optionalText.id"><td>{{optionalText.name}}</td><!--<td>{{optionalText.optionalText}}</td>--><td><button class="btn btn-info" type="submit" ui-sref="optional-text.edit({id:optionalText.id})"><i class="fa fa-pencil-square-o"></i></button> <button class="btn btn-danger" type="submit" ui-sref="optional-text.delete({id:optionalText.id})"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/ordered-optional-service/ordered-optional-service-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.orderedOptionalService.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.orderedOptionalService.delete.question" translate-values="{id: \'{{vm.orderedOptionalService.id}}\'}">Are you sure you want to delete this Ordered Optional Service?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/ordered-optional-service/ordered-optional-service-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myOrderedOptionalServiceLabel" data-translate="pcsApp.orderedOptionalService.home.createOrEditLabel">Create or edit a Ordered Optional Service</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label translate="pcsApp.orderedOptionalService.optionalService" for="field_optionalService">Optional service</label><ui-select ng-model="vm.orderedOptionalService.optionalService" ng-change="vm.resetParticipantsField()" ng-disabled="vm.orderedOptionalService.id" name="optionalService" id="field_optionalService" theme="bootstrap"><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="optionalService in (vm.optionalServices | filterChargeableItemsByCurrency : {searchText: $select.search, registrationCurrency: vm.registrationCurrency }) track by optionalService.id"><div ng-bind-html="optionalService.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="form-group"><label class="control-label" data-translate="pcsApp.orderedOptionalService.participant" for="field_participant">Participant</label><input type="number" class="form-control" name="participant" id="field_participant" autocomplete="off" ng-disabled="vm.orderedOptionalService.id" ng-model="vm.orderedOptionalService.participant" oos-reserved-validation optionalservice="vm.orderedOptionalService.optionalService" required min="1" max="100"><div ng-show="editForm.participant.$invalid"><p class="error-block" ng-show="editForm.participant.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.participant.$error.min" data-translate="entity.validation.min" translate-value-min="1">This field should be more than 1.</p><p class="error-block" ng-show="editForm.participant.$error.max" data-translate="entity.validation.max" translate-value-max="100">This field cannot be more than 100.</p><p class="error-block" ng-show="editForm.participant.$error.number" data-translate="entity.validation.number">This field should be a number.</p><p class="error-block" ng-show="editForm.participant.$error.exceededMaxPerson" translate="pcsApp.orderedOptionalService.error.exceededMaxPerson" translate-values="{notReservedSpots: \'{{vm.orderedOptionalService.optionalService.maxPerson - vm.orderedOptionalService.optionalService.reserved}}\'}">Available free spots exceeded. Max participants can be {{ orderedOptionalService.optionalService.maxPerson - orderedOptionalService.optionalService.reserved}}.</p></div></div><div class="form-group"><label translate="pcsApp.orderedOptionalService.payingGroupItem" for="field_payingGroupItem">Discount</label><ui-select ng-model="vm.orderedOptionalService.payingGroupItem" name="payingGroupItem" id="field_payingGroupItem" theme="bootstrap"><ui-select-match allow-clear="true" placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.payingGroup.name + \'/\' + $select.selected.name"></span></ui-select-match><ui-select-choices repeat="payingGroupItem in (vm.payingGroupItems | filter: { payingGroup: { currency: { currency: vm.orderedOptionalService.optionalService.currency.currency }}} | filter: $select.search) track by payingGroupItem.id"><div ng-bind-html="payingGroupItem.payingGroup.name + \'/\' + payingGroupItem.name | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/paying-group/paying-group-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.payingGroup.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.payingGroup.delete.question" translate-values="{id: \'{{vm.payingGroup.id}}\'}">Are you sure you want to delete this Paying Group?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/paying-group/paying-group-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPayingGroupLabel" data-translate="pcsApp.payingGroup.home.createOrEditLabel">Create or edit a Paying Group</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="pcsApp.payingGroup.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" autocomplete="off" ng-model="vm.payingGroup.name" required ng-maxlength="64"><div ng-show="editForm.name.$invalid"><p class="error-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" translate="pcsApp.payingGroup.taxNumber" for="field_taxNumber">TaxNumber</label><input type="text" class="form-control" name="taxNumber" id="field_taxNumber" autocomplete="off" ng-model="vm.payingGroup.taxNumber" ng-maxlength="64"><div ng-show="editForm.taxNumber.$invalid"><span class="help-block m-b-none" ng-show="editForm.taxNumber.$error.required" translate="entity.validation.required">This field is required. </span><span class="help-block m-b-none" ng-show="editForm.taxNumber.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</span><p class="error-block" ng-show="editForm.taxNumber.$error.pattern" data-translate="entity.validation.pattern" data-translate-values="{ pattern: \'12345678-2-42\' }">Ez a mez\u0151 csak sz\xE1mokat tartalmazhat pl.: 36703125678</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.payingGroup.zipCode" for="field_zipCode">Zip Code</label><input type="text" class="form-control" name="zipCode" id="field_zipCode" autocomplete="off" ng-model="vm.payingGroup.zipCode" ng-maxlength="32"><div ng-show="editForm.zipCode.$invalid"><p class="error-block" ng-show="editForm.zipCode.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.payingGroup.city" for="field_city">City</label><input type="text" class="form-control" name="city" id="field_city" autocomplete="off" ng-model="vm.payingGroup.city" ng-maxlength="64"><div ng-show="editForm.city.$invalid"><p class="error-block" ng-show="editForm.city.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.payingGroup.street" for="field_street">Street</label><input type="text" class="form-control" name="street" id="field_street" autocomplete="off" ng-model="vm.payingGroup.street" ng-maxlength="128"><div ng-show="editForm.street.$invalid"><p class="error-block" ng-show="editForm.street.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="128">This field cannot be longer than 128 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.payingGroup.contactName" for="field_contactName">Contact Name</label><input type="text" class="form-control" name="contactName" id="field_contactName" autocomplete="off" ng-model="vm.payingGroup.contactName" ng-maxlength="128"><div ng-show="editForm.contactName.$invalid"><p class="error-block" ng-show="editForm.contactName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="128">This field cannot be longer than 128 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.payingGroup.email" for="field_email">Email</label><input type="email" class="form-control" name="email" id="field_email" autocomplete="off" ng-model="vm.payingGroup.email" ng-maxlength="64"><div ng-show="editForm.email.$invalid"><p class="error-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p><p class="error-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.payingGroup.phone" for="field_phone">Phone</label><input type="text" class="form-control" name="phone" id="field_phone" autocomplete="off" ng-model="vm.payingGroup.phone" ng-maxlength="64"><div ng-show="editForm.phone.$invalid"><p class="error-block" ng-show="editForm.phone.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.payingGroup.fax" for="field_fax">Fax</label><input type="text" class="form-control" name="fax" id="field_fax" autocomplete="off" ng-model="vm.payingGroup.fax" ng-maxlength="64"><div ng-show="editForm.fax.$invalid"><p class="error-block" ng-show="editForm.fax.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label translate="pcsApp.payingGroup.country" for="field_country">Default Country</label><ui-select ng-model="vm.payingGroup.country" name="country" id="field_country" theme="bootstrap" required><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="country in (vm.countries | filter: $select.search) track by country.id"><div ng-bind-html="country.name | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.country.$invalid"><p class="error-block" ng-show="editForm.country.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label translate="pcsApp.payingGroup.currency" for="field_currency">Currency</label><ui-select ng-model="vm.payingGroup.currency" name="currency" id="field_currency" theme="bootstrap" required><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.currency"></span></ui-select-match><ui-select-choices repeat="currency in (vm.currencies | filter: $select.search) track by currency.id"><div ng-bind-html="currency.currency | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.currency.$invalid"><p class="error-block" ng-show="editForm.currency.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/paying-group/paying-groups.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 translate="pcsApp.payingGroup.home.title">Paying Groups</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-primary" type="submit" ui-sref="paying-group.new"><i class="fa fa-plus"></i></button><!--<div ibox-tools></div>--></div><div class="ibox-content"><table datatable="ng" id="paying-group-datatable" dt-options="dtOptions" dt-column-defs="dtColumnDefs" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.payingGroup.name">Name</span></th><th><span translate="pcsApp.payingGroup.taxNumber">Tax number</span></th><th><span translate="pcsApp.payingGroup.zipCode">ZipCode</span></th><th><span translate="pcsApp.payingGroup.city">City</span></th><th><span translate="pcsApp.payingGroup.street">Street</span></th><th><span translate="pcsApp.payingGroup.contactName">ContactName</span></th><th><span translate="pcsApp.payingGroup.email">Email</span></th><th><span translate="pcsApp.payingGroup.phone">Phone</span></th><th><span translate="pcsApp.payingGroup.country">Country</span></th><th><span translate="pcsApp.payingGroup.currency">Currency</span></th><th></th></tr></thead><tbody><tr ng-repeat="payingGroup in vm.payingGroups track by payingGroup.id"><td>{{payingGroup.name}}</td><td>{{payingGroup.taxNumber}}</td><td>{{payingGroup.zipCode}}</td><td>{{payingGroup.city}}</td><td>{{payingGroup.street}}</td><td>{{payingGroup.contactName}}</td><td>{{payingGroup.email}}</td><td>{{payingGroup.phone}}</td><td>{{payingGroup.country.name}}</td><td>{{payingGroup.currency.currency}}</td><td><button class="btn btn-info" type="submit" ui-sref="paying-group.edit({id:payingGroup.id})"><i class="fa fa-pencil-square-o"></i></button> <button class="btn btn-danger" type="submit" ui-sref="paying-group.delete({id:payingGroup.id})"><i class="fa fa-trash-o"></i></button> <button class="btn btn-primary" type="submit" ui-sref="paying-group-item({payingGroupId: payingGroup.id})"><i class="fa fa-sitemap"></i></button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/paying-group-item/paying-group-item-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.payingGroupItem.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.payingGroupItem.delete.question" translate-values="{id: \'{{vm.payingGroupItem.id}}\'}">Are you sure you want to delete this Paying Group Item?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/paying-group-item/paying-group-item-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPayingGroupItemLabel" data-translate="pcsApp.payingGroupItem.home.createOrEditLabel">Create or edit a Paying Group Item</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="pcsApp.payingGroupItem.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" autocomplete="off" ng-model="vm.payingGroupItem.name" required ng-maxlength="128"><div ng-show="editForm.name.$invalid"><p class="error-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="128">This field cannot be longer than 128 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.payingGroupItem.amountPercentage" for="field_amountPercentage">Amount Percentage</label><input type="number" class="form-control" name="amountPercentage" id="field_amountPercentage" ng-change="vm.clearOtherFields(\'PERCENTAGE\')" ng-model="vm.payingGroupItem.amountPercentage" autocomplete="off" min="0" max="100" ng-required="vm.isFieldRequired()"><div ng-show="editForm.amountPercentage.$invalid"><p class="error-block" ng-show="editForm.amountPercentage.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.amountPercentage.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be more than 0.</p><p class="error-block" ng-show="editForm.amountPercentage.$error.max" data-translate="entity.validation.max" translate-value-max="100">This field cannot be more than 100.</p><p class="error-block" ng-show="editForm.amountPercentage.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.payingGroupItem.amountValue" for="field_amountValue">Amount Value</label><input type="number" class="form-control" name="amountValue" id="field_amountValue" ng-change="vm.clearOtherFields(\'VALUE\')" ng-model="vm.payingGroupItem.amountValue" autocomplete="off" min="0" max="100000000" ng-required="vm.isFieldRequired()"><div ng-show="editForm.amountValue.$invalid"><p class="error-block" ng-show="editForm.amountValue.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.amountValue.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be more than 0.</p><p class="error-block" ng-show="editForm.amountValue.$error.max" data-translate="entity.validation.max" translate-value-max="100000000">This field cannot be more than 100000000.</p><p class="error-block" ng-show="editForm.amountValue.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group" ng-show="vm.isHotelDateDiscountVisible()"><label class="control-label" data-translate="pcsApp.payingGroupItem.hotelDateFrom" for="field_hotelDateFrom">Hotel Date From</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'hotelDateFrom\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_hotelDateFrom" type="text" class="form-control" name="hotelDateFrom" uib-datepicker-popup="{{dateformat}}" autocomplete="off" ng-required="vm.isFieldRequired() || vm.payingGroupItem.hotelDateTo" ng-change="vm.clearOtherFields(\'HOTEL_DATE\')" ng-model="vm.payingGroupItem.hotelDateFrom" is-open="vm.datePickerOpenStatus.hotelDateFrom"></div><div ng-show="editForm.hotelDateFrom.$invalid"><p class="error-block" ng-show="editForm.hotelDateFrom.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ng-show="vm.isHotelDateDiscountVisible()"><label class="control-label" data-translate="pcsApp.payingGroupItem.hotelDateTo" for="field_hotelDateTo">Hotel Date To</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'hotelDateTo\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_hotelDateTo" type="text" class="form-control" name="hotelDateTo" uib-datepicker-popup="{{dateformat}}" date-less-than="{{vm.payingGroupItem.hotelDateFrom}}" autocomplete="off" ng-required="vm.isFieldRequired() || vm.payingGroupItem.hotelDateFrom" ng-change="vm.clearOtherFields(\'HOTEL_DATE\')" ng-model="vm.payingGroupItem.hotelDateTo" is-open="vm.datePickerOpenStatus.hotelDateTo"></div><div ng-show="editForm.hotelDateTo.$invalid"><p class="error-block" ng-show="editForm.hotelDateTo.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.hotelDateTo.$error.dateLessThan" translate="pcsApp.payingGroupItem.message.endDateLessThanStartDate">End date must be later than Start date.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.payingGroupItem.chargeableItemType" for="field_chargeableItemType">Chargeable Item Type</label><select class="form-control" name="chargeableItemType" ng-model="vm.payingGroupItem.chargeableItemType" id="field_chargeableItemType" required><option value="" data-translate="global.form.please.select">Please select</option><option value="REGISTRATION" data-translate="pcsApp.ChargeableItemType.REGISTRATION">REGISTRATION</option><option value="HOTEL" data-translate="pcsApp.ChargeableItemType.HOTEL">HOTEL</option><option value="OPTIONAL_SERVICE" data-translate="pcsApp.ChargeableItemType.OPTIONAL_SERVICE">OPTIONAL_SERVICE</option><option value="MISCELLANEOUS" data-translate="pcsApp.ChargeableItemType.MISCELLANEOUS">MISCELLANEOUS</option></select><div ng-show="editForm.chargeableItemType.$invalid"><p class="error-block" ng-show="editForm.chargeableItemType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/paying-group-item/paying-group-items.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 translate="pcsApp.payingGroupItem.home.title" translate-values="{groupName: \'{{vm.payingGroup.name}}\'}">Paying Group Items for Group: {{vm.payingGroup.name}}</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-primary" type="submit" ui-sref="paying-group-item.new"><i class="fa fa-plus"></i></button> <button class="btn btn-info" type="submit" ui-sref="paying-group"><i class="fa fa-arrow-left"></i></button><!--<div ibox-tools></div>--></div><div class="ibox-content"><table datatable="ng" id="paying-group-item-datatable" dt-options="dtOptions" dt-column-defs="dtColumnDefs" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.payingGroupItem.name">Name</span></th><th><span translate="pcsApp.payingGroupItem.amountPercentage">AmountPercentage</span></th><th><span translate="pcsApp.payingGroupItem.amountValue">AmountValue</span></th><th><span translate="pcsApp.payingGroupItem.hotelDateFrom">HotelDateFrom</span></th><th><span translate="pcsApp.payingGroupItem.hotelDateTo">HotelDateTo</span></th><th><span translate="pcsApp.payingGroupItem.chargeableItemType">Item Type</span></th><th></th></tr></thead><tbody><tr ng-repeat="payingGroupItem in vm.payingGroupItems track by payingGroupItem.id"><td>{{payingGroupItem.name}}</td><td>{{payingGroupItem.amountPercentage}}</td><td>{{payingGroupItem.amountValue}}</td><td>{{payingGroupItem.hotelDateFrom | date:\'mediumDate\'}}</td><td>{{payingGroupItem.hotelDateTo | date:\'mediumDate\'}}</td><td data-translate="{{\'pcsApp.ChargeableItemType.\' + payingGroupItem.chargeableItemType}}">{{payingGroupItem.chargeableItemType}}</td><td><button class="btn btn-info" type="submit" ui-sref="paying-group-item.edit({id: payingGroupItem.id})"><i class="fa fa-pencil-square-o"></i></button> <button class="btn btn-danger" type="submit" ui-sref="paying-group-item.delete({id: payingGroupItem.id})"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/payment-summary/payment-summarys.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 data-translate="pcsApp.paymentSummary.home.title">Payment summary</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins" ng-show="vm.reportList.length"><button class="btn btn-primary" type="submit" ng-click="vm.downloadReportXls()"><i class="fa fa-download"></i></button></div><div class="ibox-content" ng-show="vm.reportList.length"><table datatable="ng" id="payment-summary-datatable" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" class="table table-striped table-bordered table-hover"><thead><tr><th><span data-translate="pcsApp.paymentSummary.currency">Currency</span></th><th><span data-translate="pcsApp.paymentSummary.regFee">Registration fee</span></th><th><span data-translate="pcsApp.paymentSummary.reservationFee">Reservation fee</span></th><th><span data-translate="pcsApp.paymentSummary.optionalFee">Optional service fee</span></th><th><span data-translate="pcsApp.paymentSummary.miscFee">Misc fee</span></th><th><span data-translate="pcsApp.paymentSummary.total">Total</span></th></tr></thead><tbody><tr ng-repeat="paymentSummary in vm.reportList track by paymentSummary.currency"><td>{{paymentSummary.currency}}</td><td>{{paymentSummary.registrationFee}}</td><td>{{paymentSummary.reservationFee}}</td><td>{{paymentSummary.optionalFee}}</td><td>{{paymentSummary.miscFee}}</td><td>{{paymentSummary.total}}</td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/payment-transaction-report/payment-transaction-report-refund-dialog.html','<form name="editForm" ng-submit="vm.confirm()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pcsApp.paymentTransactionReport.home.refundTitle">Confirm KH refund operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="pcsApp.paymentTransactionReport.refund" for="field_refundAmount">Refund</label><div class="input-group m-b"><span class="input-group-addon">{{vm.paymentTransaction.currency}}</span> <input type="number" class="form-control" name="refundAmount" id="field_refundAmount" autocomplete="off" ng-disabled="vm.isReverse()" ng-model="vm.refundAmount" required min="0" max="{{vm.paymentTransaction.amount}}"></div><div ng-show="editForm.refundAmount.$invalid"><p class="error-block" ng-show="editForm.refundAmount.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.refundAmount.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be more than 0.</p><p class="error-block" ng-show="editForm.refundAmount.$error.max" data-translate="entity.validation.max" translate-value-max="{{vm.paymentTransaction.amount}}">This field cannot be more than {{vm.paymentTransaction.amount}}.</p><p class="error-block" ng-show="editForm.refundAmount.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><span class="fa fa-reply"></span>&nbsp;<span data-translate="entity.action.refund">Refund</span></button></div></form>');
$templateCache.put('app/entities/payment-transaction-report/payment-transaction-reports.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 data-translate="pcsApp.paymentTransactionReport.home.title">Payment Transaction Report</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-md-12"><div class="col-md-3 no-padding-left"><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_fromDate" type="text" class="form-control" name="fromDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.reportFilter.fromDate" is-open="vm.datePickerOpenStatus.fromDate" placeholder="{{ \'pcsApp.paymentTransactionReport.fromDate\' | translate }}" required></div></div><div class="col-md-3 no-padding-left"><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_toDate" type="text" class="form-control" name="toDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.reportFilter.toDate" is-open="vm.datePickerOpenStatus.toDate" placeholder="{{ \'pcsApp.paymentTransactionReport.toDate\' | translate }}" required></div></div><div class="col-md-3 no-padding-left"><input type="text" class="form-control full-width" ng-model="vm.reportFilter.orderNumber" autocomplete="off" id="orderNumber" name="orderNumber" placeholder="{{ \'pcsApp.paymentTransactionReport.orderNumber\' | translate }}"></div><div class="col-md-3 input-group"><input type="text" class="form-control full-width" ng-model="vm.reportFilter.transactionId" autocomplete="off" id="transactionId" name="transactionId" placeholder="{{ \'pcsApp.paymentTransactionReport.transactionId\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search()"><span class="glyphicon glyphicon-search"></span></button> <button class="btn btn-danger" ng-if="vm.reportList.length || vm.isAnyFilterSet()" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button> <button class="btn btn-primary" ng-if="vm.reportList.length" type="submit" ng-click="vm.downloadReportXls()"><i class="fa fa-download"></i></button></span></div></div></div></div></div></div></div></div><div class="ibox-content" ng-show="vm.reportList.length"><table datatable="ng" id="payment-transaction-report-datatable" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" class="table table-striped table-bordered table-hover"><thead><tr><th></th><th><span data-translate="pcsApp.paymentTransactionReport.paymentTrxDate">Payment trx date</span></th><th><span data-translate="pcsApp.paymentTransactionReport.firstName">First name</span></th><th><span data-translate="pcsApp.paymentTransactionReport.lastName">Last name</span></th><th><span data-translate="pcsApp.paymentTransactionReport.orderNumber">Order No</span></th><th><span data-translate="pcsApp.paymentTransactionReport.transactionId">Transaction ID</span></th><th><span data-translate="pcsApp.paymentTransactionReport.amount">Amount</span></th><th><span data-translate="pcsApp.paymentTransactionReport.currency">Currency</span></th><th><span data-translate="pcsApp.paymentTransactionReport.congressName">Congress name</span></th></tr></thead><tbody><tr ng-repeat="pt in vm.reportList track by pt.id"><td><button class="btn btn-danger btn-sm" type="submit" ui-sref="payment-transaction-report.refund({id:pt.id})"><i class="fa fa-reply"></i></button> <button class="btn btn-info btn-sm" type="submit" tooltip-placement="right" uib-tooltip="Payment refund transactions" ng-show="pt.hasRefundTransaction" ui-sref="payment-transaction-report.show-payment-refund-transaction({id:pt.transactionId})"><i class="fa fa-list"></i></button></td><td>{{pt.paymentTrxDate | date: \'yyyy-MM-dd HH:mm:ss\'}}</td><td>{{pt.firstName}}</td><td>{{pt.lastName}}</td><td>{{pt.orderNumber}}</td><td>{{pt.transactionId}}</td><td>{{pt.amount}}</td><td>{{pt.currency}}</td><td>{{pt.congressName}}</td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/payment-transaction-report/show-payment-refund-transaction-dialog.html','<form name="confirmForm"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pcsApp.paymentTransactionReport.showPaymentRefundTransactionDialog.title">Refund transactions of a payment transaction</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><table datatable="ng" id="invoice-report-datatable" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span data-translate="pcsApp.paymentTransactionReport.showPaymentRefundTransactionDialog.paymentTrxDate">Refund date</span></th><th><span data-translate="pcsApp.paymentTransactionReport.showPaymentRefundTransactionDialog.paymentTrxResultCode">Result code</span></th><th><span data-translate="pcsApp.paymentTransactionReport.showPaymentRefundTransactionDialog.paymentTrxResultMessage">Result message</span></th><th><span data-translate="pcsApp.paymentTransactionReport.showPaymentRefundTransactionDialog.paymentTrxStatus">Refund status</span></th><th><span data-translate="pcsApp.paymentTransactionReport.showPaymentRefundTransactionDialog.amount">Amount</span></th><th><span data-translate="pcsApp.paymentTransactionReport.showPaymentRefundTransactionDialog.currency">Currency</span></th></tr></thead><tbody><tr ng-repeat="refund in vm.refunds track by refund.id"><td>{{refund.paymentTrxDate | date: \'yyyy-MM-dd HH:mm:ss\'}}</td><td>{{refund.paymentTrxResultCode}}</td><td>{{refund.paymentTrxResultMessage}}</td><td>{{refund.paymentTrxStatus}}</td><td>{{refund.amount}}</td><td>{{refund.currency}}</td></tr></tbody></table></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.close">Close</span></button></div></form>');
$templateCache.put('app/entities/rate/rate-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.rate.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.rate.delete.question" translate-values="{id: \'{{vm.rate.id}}\'}">Are you sure you want to delete this Rate?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/rate/rate-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRateLabel" data-translate="pcsApp.rate.home.createOrEditLabel">Create or edit a Rate</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label translate="pcsApp.rate.currency" for="field_currency">Currency</label><div class="input-group m-b"><span class="input-group-addon">1</span><ui-select ng-model="vm.rate.currency" name="currency" id="field_currency" theme="bootstrap" required><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.currency"></span></ui-select-match><ui-select-choices repeat="currency in (vm.currencies | filter: { currency: \'!HUF\' } | filter: $select.search) track by currency.id"><div ng-bind-html="currency.currency | highlight: $select.search"></div></ui-select-choices></ui-select></div><div ng-show="editForm.currency.$invalid"><p class="error-block" ng-show="editForm.currency.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><!--<label class="control-label" data-translate="pcsApp.rate.rate" for="field_rate">Rate</label>--><label class="control-label" data-translate="pcsApp.rate.equalsTo" for="field_rate">equals to</label><div class="input-group m-b"><span class="input-group-addon">HUF</span> <input type="number" class="form-control" name="rate" id="field_rate" autocomplete="off" ng-model="vm.rate.rate" required min="0" max="10000"></div><div ng-show="editForm.rate.$invalid"><p class="error-block" ng-show="editForm.rate.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.rate.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be more than 0.</p><p class="error-block" ng-show="editForm.rate.$error.max" data-translate="entity.validation.max" translate-value-max="10000">This field cannot be more than 10000.</p><p class="error-block" ng-show="editForm.rate.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.rate.valid" for="field_valid">Valid</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'valid\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_valid" type="text" class="form-control" name="valid" uib-datepicker-popup="{{dateformat}}" autocomplete="off" ng-model="vm.rate.valid" is-open="vm.datePickerOpenStatus.valid" required></div><div ng-show="editForm.valid.$invalid"><p class="error-block" ng-show="editForm.valid.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/rate/rates.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 translate="pcsApp.rate.home.title">Rates</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-primary" type="submit" ui-sref="rate.new"><i class="fa fa-plus"></i></button><!--<div ibox-tools></div>--></div><div class="ibox-content"><table datatable="ng" id="rate-datatable" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.rate.currency">Currency</span></th><th><span translate="pcsApp.rate.valid">Valid</span></th><th><span translate="pcsApp.rate.rate">Rate</span></th><th></th></tr></thead><tbody><tr ng-repeat="rate in vm.rates track by rate.id"><td>{{rate.currency.currency}}</td><td>{{rate.valid | date:\'mediumDate\'}}</td><td>{{rate.rate}}</td><td><button class="btn btn-info" type="submit" ui-sref="rate.edit({id:rate.id})"><i class="fa fa-pencil-square-o"></i></button> <button class="btn btn-danger" type="submit" ui-sref="rate.delete({id:rate.id})"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/regfee-details/regfee-details.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 data-translate="pcsApp.regFeeDetails.home.title">Reg fee payment details</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins" ng-show="vm.reportList.length"><button class="btn btn-primary" type="submit" ng-click="vm.downloadReportXls()"><i class="fa fa-download"></i></button></div><div class="ibox-content" ng-show="vm.reportList.length"><table datatable="ng" id="regfee-details-datatable" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" class="table table-striped table-bordered table-hover"><thead><tr><th><span data-translate="pcsApp.regFeeDetails.code">Code</span></th><th><span data-translate="pcsApp.regFeeDetails.name">Name</span></th><th><span data-translate="pcsApp.regFeeDetails.firstCount">First count</span></th><th><span data-translate="pcsApp.regFeeDetails.secondCount">Second count</span></th><th><span data-translate="pcsApp.regFeeDetails.thirdCount">Third count</span></th><th><span data-translate="pcsApp.regFeeDetails.firstFee">First fee</span></th><th><span data-translate="pcsApp.regFeeDetails.secondFee">Second fee</span></th><th><span data-translate="pcsApp.regFeeDetails.thirdFee">Third fee</span></th><th><span data-translate="pcsApp.regFeeDetails.total">Total</span></th><th><span data-translate="pcsApp.regFeeDetails.paidByPerson">Paid by person</span></th><th><span data-translate="pcsApp.regFeeDetails.paidByGroup">Paid by group</span></th><th><span data-translate="pcsApp.regFeeDetails.currency">Currency</span></th></tr></thead><tbody><tr ng-repeat="regFeeDetails in vm.reportList track by regFeeDetails.id"><td>{{regFeeDetails.code}}</td><td>{{regFeeDetails.name}}</td><td>{{regFeeDetails.firstCount}}</td><td>{{regFeeDetails.secondCount}}</td><td>{{regFeeDetails.thirdCount}}</td><td>{{regFeeDetails.firstFee}}</td><td>{{regFeeDetails.secondFee}}</td><td>{{regFeeDetails.thirdFee}}</td><td>{{regFeeDetails.total}}</td><td>{{regFeeDetails.paidByPerson}}</td><td>{{regFeeDetails.paidByGroup}}</td><td>{{regFeeDetails.currency}}</td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/regfee-details-by-participant/regfee-details-by-participants.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 data-translate="pcsApp.regFeeDetailsByParticipant.home.title">Reg Fee Details By Participant</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><div class="row"><div class="col-md-12"><div class="col-md-8"></div><div class="col-md-4 input-group"><ui-select ng-model="vm.reportFilter.regType" name="regType" id="search_regType" theme="bootstrap"><ui-select-match allow-clear="true" placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="registrationType in vm.registrationTypes | filter: $select.search track by registrationType.id"><div ng-bind-html="registrationType.name | highlight: $select.search"></div></ui-select-choices></ui-select><span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search()"><span class="glyphicon glyphicon-search"></span></button> <button class="btn btn-danger" ng-if="vm.reportList.length || vm.isAnyFilterSet()" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button> <button class="btn btn-primary" ng-if="vm.reportList.length" type="submit" ng-click="vm.downloadReportXls()"><i class="fa fa-download"></i></button></span></div></div></div></div><div class="ibox-content" ng-show="vm.reportList.length"><table datatable="ng" id="regfee-details-by-participant-datatable" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" class="table table-striped table-bordered table-hover"><thead><tr><th><span data-translate="pcsApp.regFeeDetailsByParticipant.regId">Reg Id</span></th><th><span data-translate="pcsApp.regFeeDetailsByParticipant.name">Name</span></th><th><span data-translate="pcsApp.regFeeDetailsByParticipant.firstFee">First fee</span></th><th><span data-translate="pcsApp.regFeeDetailsByParticipant.secondFee">Second fee</span></th><th><span data-translate="pcsApp.regFeeDetailsByParticipant.thirdFee">Third fee</span></th><th><span data-translate="pcsApp.regFeeDetailsByParticipant.paidByPerson">Paid by person</span></th><th><span data-translate="pcsApp.regFeeDetailsByParticipant.payingGroupName">Group name</span></th><th><span data-translate="pcsApp.regFeeDetailsByParticipant.paidByGroup">Paid by group</span></th></tr></thead><tbody><tr ng-repeat="regFeeDetails in vm.reportList track by regFeeDetails.regId"><td>{{regFeeDetails.regId}}</td><td>{{regFeeDetails.name}}</td><td>{{regFeeDetails.firstFee}}</td><td>{{regFeeDetails.secondFee}}</td><td>{{regFeeDetails.thirdFee}}</td><td>{{regFeeDetails.paidByPerson}}</td><td>{{regFeeDetails.payingGroupName}}</td><td>{{regFeeDetails.paidByGroup}}</td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/registration/registration-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.registration.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.registration.delete.question" translate-values="{id: \'{{vm.registration.id}}\'}">Are you sure you want to delete this Registration?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/registration/registration-dialog.html','<div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><h2 translate="pcsApp.registration.home.createOrEditLabel">Create or edit a Registration</h2></div><div class="ibox-content"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" translate="pcsApp.registration.regId" for="field_regId">Reg Id</label><input type="number" class="form-control" name="regId" id="field_regId" disabled="disabled" ng-model="vm.registration.regId"></div><div class="form-group"><label class="control-label" translate="pcsApp.registration.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" autocomplete="off" ng-model="vm.registration.title" ng-maxlength="16"><div ng-show="editForm.title.$invalid"><p class="error-block" ng-show="editForm.title.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="16">This field cannot be longer than 16 characters.</p></div></div><div class="form-group"><label class="control-label" translate="pcsApp.registration.lastName" for="field_lastName">Last name</label><input type="text" class="form-control" name="lastName" id="field_lastName" autocomplete="off" ng-model="vm.registration.lastName" required ng-maxlength="64"><div ng-show="editForm.lastName.$invalid"><p class="error-block" ng-show="editForm.lastName.$error.required" translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.lastName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" translate="pcsApp.registration.firstName" for="field_firstName">First name</label><input type="text" class="form-control" name="firstName" id="field_firstName" ng-blur="vm.setShortName()" ng-model="vm.registration.firstName" autocomplete="off" required ng-maxlength="64"><div ng-show="editForm.firstName.$invalid"><p class="error-block" ng-show="editForm.firstName.$error.required" translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.firstName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" translate="pcsApp.registration.shortName" for="field_shortName">Short name</label><input type="text" class="form-control" name="shortName" id="field_shortName" autocomplete="off" ng-model="vm.registration.shortName" ng-maxlength="16"><div ng-show="editForm.shortName.$invalid"><p class="error-block" ng-show="editForm.shortName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="16">This field cannot be longer than 16 characters.</p></div></div><div class="form-group"><label class="control-label" translate="pcsApp.registration.position" for="field_position">Position</label><input type="text" class="form-control" name="position" id="field_position" autocomplete="off" ng-model="vm.registration.position" ng-maxlength="64"><div ng-show="editForm.position.$invalid"><p class="error-block" ng-show="editForm.position.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" translate="pcsApp.registration.otherData" for="field_otherData">Other data</label><input type="text" class="form-control" name="otherData" id="field_otherData" autocomplete="off" ng-model="vm.registration.otherData" ng-maxlength="255"><div ng-show="editForm.otherData.$invalid"><p class="error-block" ng-show="editForm.otherData.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="form-group"><label translate="pcsApp.registration.workplace" for="field_workplace">workplace</label><div class="input-group"><select class="form-control" id="field_workplace" name="workplace" ng-model="vm.registration.workplace" ng-options="workplace as workplace.name for workplace in vm.workplaces | orderBy: \'name\' track by workplace.id"><option value="" translate="global.form.please.select">Please select!</option></select><span class="input-group-btn"><button type="button" ng-click="vm.copyWorkplace()" class="btn btn-info">Copy</button></span> <span class="input-group-btn"><button type="button" ui-sref=".workplace-new" class="btn btn-primary">New workplace</button></span></div></div><div class="form-group"><label class="control-label" translate="pcsApp.registration.department" for="field_department">Department</label><input type="text" class="form-control" name="department" id="field_department" autocomplete="off" ng-model="vm.registration.department" ng-maxlength="128"><div ng-show="editForm.department.$invalid"><p class="error-block" ng-show="editForm.department.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="128">This field cannot be longer than 128 characters.</p></div></div><div class="form-group"><label translate="pcsApp.registration.country" for="field_country">Country</label><!--<div class="input-group">--><select class="form-control" id="field_country" name="country" ng-model="vm.registration.country" ng-options="country as country.name for country in vm.countries | orderBy: \'name\' track by country.id"><option value="" translate="global.form.please.select">Please select!</option></select><!--<span class="input-group-btn"> <button type="button" ui-sref=".country-new" class="btn btn-primary">New country</button></span>--><!--</div>--></div><div class="form-group"><label class="control-label" translate="pcsApp.registration.zipCode" for="field_zipCode">Zip code</label><input type="text" class="form-control" name="zipCode" id="field_zipCode" autocomplete="off" ng-model="vm.registration.zipCode" ng-maxlength="32"><div ng-show="editForm.zipCode.$invalid"><p class="error-block" ng-show="editForm.zipCode.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" translate="pcsApp.registration.city" for="field_city">City</label><input type="text" class="form-control" name="city" id="field_city" autocomplete="off" ng-model="vm.registration.city" ng-maxlength="64"><div ng-show="editForm.city.$invalid"><p class="error-block" ng-show="editForm.city.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" translate="pcsApp.registration.street" for="field_street">Street</label><input type="text" class="form-control" name="street" id="field_street" autocomplete="off" ng-model="vm.registration.street" ng-maxlength="255"><div ng-show="editForm.street.$invalid"><p class="error-block" ng-show="editForm.street.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="form-group"><label class="control-label" translate="pcsApp.registration.phone" for="field_phone">Phone</label><input type="text" class="form-control" name="phone" id="field_phone" autocomplete="off" ng-model="vm.registration.phone" ng-maxlength="64"><div ng-show="editForm.phone.$invalid"><p class="error-block" ng-show="editForm.phone.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" translate="pcsApp.registration.email" for="field_email">Email</label><input type="email" class="form-control" name="email" id="field_email" autocomplete="off" ng-model="vm.registration.email" ng-maxlength="64"><div ng-show="editForm.email.$invalid"><p class="error-block" ng-show="editForm.email.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p><p class="error-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group"><label class="control-label" translate="pcsApp.registration.fax" for="field_fax">Fax</label><input type="text" class="form-control" name="fax" id="field_fax" autocomplete="off" ng-model="vm.registration.fax" ng-maxlength="64"><div ng-show="editForm.fax.$invalid"><p class="error-block" ng-show="editForm.fax.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.registration.dateOfApp" for="field_dateOfApp">Date of app</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateOfApp\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_dateOfApp" type="text" class="form-control" name="dateOfApp" uib-datepicker-popup="{{dateformat}}" ng-disabled="vm.registration.regId && (vm.registrationRegistrationTypes.length || vm.roomReservations.length || vm.orderedOptionalServices.length || vm.chargedServices.length)" ng-model="vm.registration.dateOfApp" is-open="vm.datePickerOpenStatus.dateOfApp" required></div><div ng-show="editForm.dateOfApp.$invalid"><p class="error-block" ng-show="editForm.dateOfApp.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="pcsApp.registration.invoiceName" for="field_invoiceName">Invoice name</label><div class="input-group"><input type="text" class="form-control" name="invoiceName" id="field_invoiceName" autocomplete="off" ng-model="vm.registration.invoiceName" ng-maxlength="128"> <span class="input-group-btn"><button type="button" ng-click="vm.copyInvoiceDataFromReg()" class="btn btn-info">Copy from reg</button></span> <span class="input-group-btn"><button type="button" ng-click="vm.copyInvoiceDataFromWorkplace()" class="btn btn-success">Copy from workplace</button></span></div><div ng-show="editForm.invoiceName.$invalid"><p class="error-block" ng-show="editForm.invoiceName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="128">This field cannot be longer than 128 characters.</p></div></div><div class="form-group"><label translate="pcsApp.registration.invoiceCountry" for="field_invoiceCountry">Invoice country</label><select class="form-control" id="field_invoiceCountry" name="invoiceCountry" ng-model="vm.registration.invoiceCountry" ng-options="country as country.name for country in vm.countries | orderBy: \'name\' track by country.id"><option value="" translate="global.form.please.select">Please select!</option></select></div><div class="form-group"><label class="control-label" translate="pcsApp.registration.invoiceZipCode" for="field_invoiceZipCode">Invoice Zip code</label><input type="text" class="form-control" name="invoiceZipCode" id="field_invoiceZipCode" autocomplete="off" ng-model="vm.registration.invoiceZipCode" ng-maxlength="32"><div ng-show="editForm.invoiceZipCode.$invalid"><p class="error-block" ng-show="editForm.invoiceZipCode.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" translate="pcsApp.registration.invoiceCity" for="field_invoiceCity">Invoice city</label><input type="text" class="form-control" name="invoiceCity" id="field_invoiceCity" autocomplete="off" ng-model="vm.registration.invoiceCity" ng-maxlength="64"><div ng-show="editForm.invoiceCity.$invalid"><p class="error-block" ng-show="editForm.invoiceCity.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" translate="pcsApp.registration.invoiceAddress" for="field_invoiceAddress">Invoice street</label><input type="text" class="form-control" name="invoiceAddress" id="field_invoiceAddress" autocomplete="off" ng-model="vm.registration.invoiceAddress" ng-maxlength="255"><div ng-show="editForm.invoiceAddress.$invalid"><p class="error-block" ng-show="editForm.invoiceAddress.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="form-group"><label class="control-label" translate="pcsApp.registration.invoiceTaxNumber" for="field_invoiceTaxNumber">Invoice tax number</label><input type="text" class="form-control" name="invoiceTaxNumber" id="field_invoiceTaxNumber" autocomplete="off" ng-model="vm.registration.invoiceTaxNumber" ng-maxlength="64"><div ng-show="editForm.invoiceTaxNumber.$invalid"><p class="error-block" ng-show="editForm.invoiceTaxNumber.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form></div></div></div></div></div>');
$templateCache.put('app/entities/registration/registration-search-dialog.html','<form name="searchForm"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pcsApp.registration.home.search">Registration search</h4></div><div class="modal-body no-padding-bottom"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-lg-12 search-datatable-block"><table datatable="ng" id="search-datatable" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" class="table table-striped table-bordered table-hover"><thead><tr><th><span translate="pcsApp.registration.regId">Reg Id</span></th><th><span translate="pcsApp.registration.lastName">Last name</span></th><th><span translate="pcsApp.registration.firstName">First name</span></th></tr></thead><tbody><tr ng-repeat="reg in vm.registrationArray track by reg.id"><td>{{reg.regId}}</td><td>{{reg.lastName}}</td><td>{{reg.firstName}}</td></tr></tbody></table></div></div></div></form>');
$templateCache.put('app/entities/registration/registration-summary-dialog.html','<div class="modal-header"><h4 class="modal-title" id="summaryTitleLabel" translate="pcsApp.registration.summary.title">Registration Summary</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><table id="registration-summary-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th></th><th><span translate="pcsApp.registration.summary.participants">Participants</span></th><th><span translate="pcsApp.registration.summary.accPeople">Acc. People</span></th></tr></thead><tbody><tr><td><span translate="pcsApp.registration.summary.participants">Registered:</span></td><td>{{vm.summary.registered}}</td><td>{{vm.summary.accPeople}}</td></tr><tr><td><span translate="pcsApp.registration.summary.onSpot">On spot:</span></td><td>{{vm.summary.onSpot}}</td><td></td></tr></tbody></table></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div>');
$templateCache.put('app/entities/registration/registration-upload-dialog.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 data-translate="pcsApp.registration.home.uploadTitle">Registration upload</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><div class="form-group"><label class="control-label" translate="pcsApp.registration.uploadFile" for="field_upload">Upload file</label><div class="input-group"><input type="text" value="{{vm.uploadFile.name}} {{vm.byteSize(vm.uploadFile.file)}}" autocomplete="off" class="form-control file-upload"> <input type="hidden" class="form-control" name="upload" id="field_upload" ng-model="vm.uploadFile.file" maxbytes="2000000"> <span class="input-group-btn"><button type="file" tooltip-placement="top" uib-tooltip="Select file" class="btn btn-info" ngf-select ngf-change="vm.setFile($file, vm.uploadFile)" ngf-pattern="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"><i class="fa fa-file"></i></button> <button type="button" tooltip-placement="top" uib-tooltip="Remove file" class="btn btn-danger" ng-if="vm.uploadFile.file" ng-click="vm.clearFile(vm.uploadFile)"><i class="fa fa-remove"></i></button> <button type="button" tooltip-placement="top" uib-tooltip="Upload file" class="btn btn-primary" ng-if="vm.uploadFile.file" ng-click="vm.sendUpload()"><i class="fa fa-upload"></i></button> <button type="button" tooltip-placement="top" uib-tooltip="Back to registrations" class="btn btn-success" ng-click="vm.back()"><i class="fa fa-arrow-left"></i></button></span></div><div ng-show="editForm.upload.$invalid"><p class="error-block" ng-show="editForm.upload.$error.maxbytes" translate="entity.validation.maxbytes" translate-value-max="2000000">This field cannot be more than 2000000 bytes.</p></div></div></div><div class="ibox-content" ng-show="vm.messages.length"><table datatable="ng" id="registration-upload-datatable" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" class="table table-striped table-bordered table-hover"><thead><tr><th><span data-translate="pcsApp.registration.uploadMessage">Upload messages</span></th></tr></thead><tbody><tr ng-repeat="message in vm.messages track by $index"><td>{{message}}</td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/registration/registrations.html','<div class="row wrapper border-bottom white-bg page-heading"><!--    <div class="col-lg-2">--><div class="pull-right reg-toolbar-button"><button class="btn-lg btn-success" type="submit" tooltip-placement="top" uib-tooltip="First" ng-disabled="!vm.hasPrevRegId()" ui-sref="registration({registrationId: vm.firstRegId()})"><i class="fa fa-angle-double-left"></i></button> <button class="btn-lg btn-success" type="submit" tooltip-placement="top" uib-tooltip="Previous" ng-disabled="!vm.hasPrevRegId()" ui-sref="registration({registrationId: vm.prevRegId()})"><i class="fa fa-angle-left"></i></button> <button class="btn-lg btn-success" type="submit" ng-disabled="!vm.hasNextRegId()" tooltip-placement="top" uib-tooltip="Next" ui-sref="registration({registrationId: vm.nextRegId()})"><i class="fa fa-angle-right"></i></button> <button class="btn-lg btn-success" type="submit" ng-disabled="!vm.hasNextRegId()" tooltip-placement="top" uib-tooltip="Last" ui-sref="registration({registrationId: vm.lastRegId()})"><i class="fa fa-angle-double-right"></i></button> <button class="btn-lg btn-success m-l-sm" type="submit" ng-disabled="!vm.registration.id" tooltip-placement="top" uib-tooltip="Summary" ui-sref="registration.summary"><i class="fa fa-bar-chart-o"></i></button> <button class="btn-lg btn-info m-l-sm" type="submit" tooltip-placement="top" uib-tooltip="Upload registrations" ui-sref="registration.upload"><i class="fa fa-upload"></i></button> <button class="btn-lg btn-info m-l-sm" type="submit" ng-disabled="!vm.registration.id" tooltip-placement="top" uib-tooltip="Edit" ui-sref="registration.edit({id:vm.registration.id})"><i class="fa fa-pencil-square-o"></i></button> <button class="btn-lg btn-danger" type="submit" ng-disabled="!vm.registration.id" tooltip-placement="top" uib-tooltip="Delete" ui-sref="registration.delete({id:vm.registration.id})"><i class="fa fa-trash-o"></i></button> <button class="btn-lg btn-info m-l-sm" type="submit" tooltip-placement="top" uib-tooltip="Invoice" ui-sref="invoice({id:vm.registration.id})"><i class="fa fa-dollar"></i></button> <button class="btn-lg btn-info m-l-sm" type="submit" ng-disabled="!vm.registration.id" tooltip-placement="top" uib-tooltip="Confirmation" ui-sref="confirmation({id:vm.registration.id})"><i class="fa fa-paperclip"></i></button> <button class="btn-lg btn-primary m-l-sm" type="submit" ui-sref="registration.new" tooltip-placement="top" uib-tooltip="New"><i class="fa fa-plus"></i></button> <button class="btn-lg btn-success m-l-sm" ui-sref="registration.search" tooltip-placement="top" uib-tooltip="Search"><i class="fa fa-search"></i></button></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight" ng-if="vm.registration.id"><div class="row"><div class="col-lg-4"><div class="ibox float-e-margins"><div class="ibox-title"><h5>{{ "pcsApp.registration.personalData" | translate }}</h5><!--<div ibox-tools></div>--></div><div class="ibox-content"><address><strong>{{ "pcsApp.registration.regId" | translate }}: </strong>{{vm.registration.regId}}</address><address><strong>{{ "pcsApp.registration.name" | translate }}: </strong>{{vm.registration.title}} {{vm.registration.lastName}}, {{vm.registration.firstName}}</address><address><strong>{{ "pcsApp.registration.position" | translate }}: </strong>{{vm.registration.position}}</address><address><strong>{{ "pcsApp.registration.email" | translate }}: </strong>{{vm.registration.email}}</address><address><strong>{{ "pcsApp.registration.phone" | translate }}: </strong>{{vm.registration.phone}}</address><address><strong>{{ "pcsApp.registration.fax" | translate }}: </strong>{{vm.registration.fax}}</address><address><strong>{{ "pcsApp.registration.workplace" | translate }}: </strong>{{vm.registration.workplace.name}}</address><address><strong>{{ "pcsApp.registration.address" | translate }}: </strong>{{vm.registration.city}} {{vm.registration.zipCode}} {{vm.registration.street}} {{vm.registration.country.name}}</address><address><strong>{{ "pcsApp.registration.otherData" | translate }}: </strong>{{vm.registration.otherData}}</address><address><strong>{{ "pcsApp.registration.invoiceName" | translate }}: </strong>{{vm.registration.invoiceName}}</address><address><strong>{{ "pcsApp.registration.invoiceAddress" | translate }}: </strong>{{vm.registration.invoiceCountry ? vm.registration.invoiceCountry.name : \'\'}} {{vm.registration.invoiceZipCode}} {{vm.registration.invoiceCity}} {{vm.registration.invoiceAddress}}</address><address><strong>{{ "pcsApp.registration.invoiceTaxNumber" | translate }}: </strong>{{vm.registration.invoiceTaxNumber}}</address><address><strong>{{ "pcsApp.registration.dateOfApp" | translate }}: </strong>{{ vm.registration.dateOfApp | date:\'mediumDate\' }}</address></div></div><div class="ibox float-e-margins"><div class="ibox-title"><h5>{{ "pcsApp.registration.properties" | translate }}</h5></div><div class="ibox-content"><div class="form-group"><label class="checkbox-inline"><input ng-model="vm.registration.presenter" id="presenterCheckbox" ng-click="vm.saveCheckboxProperties(\'presenter\')" ng-disabled="vm.isSaving" type="checkbox"> <strong>{{ "pcsApp.registration.presenter" | translate }}</strong></label><label class="checkbox-inline"><input ng-model="vm.registration.etiquette" id="etiquetteCheckbox" ng-click="vm.saveCheckboxProperties(\'etiquette\')" ng-disabled="vm.isSaving" type="checkbox"> <strong>{{ "pcsApp.registration.etiquette" | translate }}</strong></label><label class="checkbox-inline"><input ng-model="vm.registration.closed" id="closedCheckbox" ng-click="vm.saveCheckboxProperties(\'closed\')" ng-disabled="vm.isSaving" type="checkbox"> <strong>{{ "pcsApp.registration.closed" | translate }}</strong></label></div><div class="form-group"><label class="checkbox-inline"><input ng-model="vm.registration.cancelled" id="cancelledCheckbox" ng-click="vm.saveCheckboxProperties(\'closed\')" ng-disabled="vm.isSaving" type="checkbox"> <strong>{{ "pcsApp.registration.cancelled" | translate }}</strong></label><label class="checkbox-inline"><input ng-model="vm.registration.onSpot" id="onSpotCheckbox" ng-click="vm.saveCheckboxProperties(\'onSpot\')" ng-disabled="vm.isSaving" type="checkbox"> <strong>{{ "pcsApp.registration.onSpot" | translate }}</strong></label></div></div></div><div class="ibox float-e-margins"><div class="ibox-title"><h5>{{ "pcsApp.registration.remark" | translate }}</h5></div><div class="ibox-content"><div class="text-center"><textarea class="form-control" name="remark" id="field_remark" rows="6" autocomplete="off" ng-model="vm.registration.remark" ng-blur="vm.save()">\n                        </textarea></div></div></div></div><div class="col-lg-8"><div class="ibox"><div class="ibox-title ibox-title-reg float-e-margins"><div class="ibox-title-button-block"><button class="btn btn-primary btn-sm" type="submit" ui-sref="registration-registration-type.new"><i class="fa fa-plus"></i></button> <strong>{{\'pcsApp.registrationRegistrationType.home.title\' | translate}}</strong></div><div ibox-tools></div></div><div class="ibox-content"><table id="registration-type-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.registrationRegistrationType.registrationType">Registration Type</span></th><th><span translate="pcsApp.registrationRegistrationType.regFee">Price</span></th><th><span translate="pcsApp.registrationRegistrationType.accPeople">Acc People</span></th><th><span translate="pcsApp.registrationRegistrationType.payingGroupItem">Discount</span></th><th></th></tr></thead><tbody><tr ng-repeat="rrt in vm.registrationRegistrationTypes track by rrt.id"><td>{{rrt.registrationTypeName}}</td><td>{{rrt.chargeableItemPrice + \' \' + rrt.chargeableItemCurrency}}</td><td>{{ vm.displayRRTAccPeople(rrt) }}</td><td>{{rrt.payingGroupName}}</td><td><button class="btn btn-info btn-sm" type="submit" ui-sref="registration-registration-type.edit({regTypeId:rrt.id})"><i class="fa fa-pencil-square-o"></i></button> <button class="btn btn-danger btn-sm" type="submit" ui-sref="registration-registration-type.delete({regTypeId:rrt.id})"><i class="fa fa-trash-o"></i></button> <button class="btn btn-primary btn-sm" type="submit" ng-if="rrt.registrationTypeType == \'ACCOMPANYING_FEE\'" ui-sref="acc-people({regTypeId:rrt.id})"><i class="fa fa-sitemap"></i></button></td></tr></tbody></table></div></div><div class="ibox"><div class="ibox-title ibox-title-reg float-e-margins"><div class="ibox-title-button-block"><button class="btn btn-primary btn-sm" type="submit" ui-sref="room-reservation.new"><i class="fa fa-plus"></i></button> <button class="btn btn-primary btn-sm" type="submit" ui-sref="room-reservation.shared-selection" tooltip-placement="top" uib-tooltip="Shared room selection"><i class="fa fa-users"></i></button> <strong>{{\'pcsApp.roomReservation.home.title\' | translate}}</strong></div><div ibox-tools></div></div><div class="ibox-content"><table id="room-reservation-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.roomReservation.id">Res #</span></th><th><span translate="pcsApp.roomReservation.room">Room type</span></th><th><span translate="pcsApp.roomReservation.hotel">Hotel</span></th><th><span translate="pcsApp.roomReservation.shared">Shared</span></th><th><span translate="pcsApp.roomReservation.arrivalDate">Arrival Date</span></th><th><span translate="pcsApp.roomReservation.departureDate">Departure Date</span></th><th><span translate="pcsApp.roomReservation.price">Price</span></th><th><span translate="pcsApp.roomReservation.payingGroupItem">Discount</span></th><th><span translate="pcsApp.roomReservation.roomMates">Roommates</span></th><th></th></tr></thead><tbody><tr ng-repeat="rrr in vm.roomReservations track by rrr.id"><td>{{rrr.id}}</td><td>{{rrr.roomType}}</td><td>{{rrr.hotelName}}</td><td>{{rrr.shared}}</td><td>{{rrr.arrivalDate | date:\'mediumDate\'}}</td><td>{{rrr.departureDate | date:\'mediumDate\'}}</td><td>{{rrr.chargeableItemPrice + \' \' + rrr.chargeableItemCurrency}}</td><td>{{rrr.payingGroupName}}</td><td>{{rrr.roomMates}}</td><td><button popover-placement="left" ng-show="rrr.comment" uib-popover="{{rrr.comment}}" class="btn btn-success btn-sm"><i class="fa fa-info-circle"></i></button> <button class="btn btn-info btn-sm" type="submit" ui-sref="room-reservation.edit({rrrId:rrr.id})"><i class="fa fa-pencil-square-o"></i></button> <button class="btn btn-danger btn-sm" type="submit" ui-sref="room-reservation.delete({rrrId:rrr.id})"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table></div></div><div class="ibox"><div class="ibox-title ibox-title-reg float-e-margins"><div class="ibox-title-button-block"><button class="btn btn-primary btn-sm" type="submit" ui-sref="ordered-optional-service.new"><i class="fa fa-plus"></i></button> <strong>{{\'pcsApp.orderedOptionalService.home.title\' | translate}}</strong></div><div ibox-tools></div></div><div class="ibox-content"><table id="optional-service-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.orderedOptionalService.optionalService">Optional Service</span></th><th><span translate="pcsApp.orderedOptionalService.price">Price</span></th><th><span translate="pcsApp.orderedOptionalService.participant">Participant</span></th><th><span translate="pcsApp.orderedOptionalService.payingGroupItem">Discount</span></th><th></th></tr></thead><tbody><tr ng-repeat="oos in vm.orderedOptionalServices track by oos.id"><td>{{oos.chargeableItemName}}</td><td>{{oos.chargeableItemPrice + \' \' + oos.chargeableItemCurrency}}</td><td>{{oos.participant}}</td><td>{{oos.payingGroupName}}</td><td><button class="btn btn-info btn-sm" type="submit" ui-sref="ordered-optional-service.edit({optionalServiceId:oos.id})"><i class="fa fa-pencil-square-o"></i></button> <button class="btn btn-danger btn-sm" type="submit" ui-sref="ordered-optional-service.delete({optionalServiceId:oos.id})"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table></div></div><div class="ibox"><div class="ibox-title ibox-title-reg float-e-margins"><div class="ibox-title-button-block"><button class="btn btn-primary btn-sm" type="submit" ui-sref="charged-service.new"><i class="fa fa-plus"></i></button> <strong>{{\'pcsApp.chargedService.home.title\' | translate}}</strong></div><div ibox-tools></div></div><div class="ibox-content"><table id="charged-service-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.chargedService.paymentMode">Payment mode</span></th><th><span translate="pcsApp.chargedService.paymentType">Payment type</span></th><th><span translate="pcsApp.chargedService.debitedItem">Debited item</span></th><th><span translate="pcsApp.chargedService.amount">Amount</span></th><th><span translate="pcsApp.chargedService.dateOfPayment">Date of Payment</span></th><th><span translate="pcsApp.chargedService.invoiceNumber">Invoice number</span></th><th><span translate="pcsApp.chargedService.transactionId">Transaction Id</span></th><th></th></tr></thead><tbody><tr ng-repeat="chargedService in vm.chargedServices track by chargedService.id"><td><span translate="pcsApp.ChargedServicePaymentMode.{{chargedService.paymentMode}}">{{chargedService.paymentMode}}</span></td><td><span translate="pcsApp.ChargeableItemType.{{chargedService.paymentType}}">{{chargedService.paymentType}}</span></td><td>{{chargedService.chargeableItemName}}</td><td>{{chargedService.amount + \' \' + chargedService.chargeableItem.chargeableItemCurrency}}</td><td>{{chargedService.dateOfPayment | date:\'mediumDate\'}}</td><td>{{chargedService.invoiceNumber}}</td><td>{{chargedService.transactionId}}</td><td><button popover-placement="left" ng-show="chargedService.comment" uib-popover="{{chargedService.comment}}" class="btn btn-success btn-sm"><i class="fa fa-info-circle"></i></button> <button class="btn btn-info btn-sm" type="submit" ui-sref="charged-service.edit({chargedServiceId: chargedService.id})"><i class="fa fa-pencil-square-o"></i></button> <button class="btn btn-danger btn-sm" type="submit" ui-sref="charged-service.delete({chargedServiceId: chargedService.id})"><i class="fa fa-trash-o"></i></button></td></tr><tr ng-show="vm.chargedServices.length"><td colspan="3">&nbsp;</td><td><strong>{{ (vm.chargedServices | sumByKey: \'amount\') + \' \' + vm.chargedServices[0].chargeableItem.chargeableItemCurrency }}</strong></td><td colspan="4">&nbsp;</td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/registration-registration-type/registration-registration-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.registrationRegistrationType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.registrationRegistrationType.delete.question" translate-values="{id: \'{{vm.registrationRegistrationType.id}}\'}">Are you sure you want to delete this Registration Registration Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/registration-registration-type/registration-registration-type-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRegistrationRegistrationTypeLabel" data-translate="pcsApp.registrationRegistrationType.home.createOrEditLabel">Create or edit a Registration Registration Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label translate="pcsApp.registrationRegistrationType.registrationType" for="field_registrationType">Registration type</label><ui-select ng-model="vm.registrationRegistrationType.registrationType" name="registrationType" id="field_registrationType" theme="bootstrap" ng-change="vm.setRegFeeAndCurrency()" ng-disabled="vm.registrationRegistrationType.id" required><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="registrationType in (vm.registrationTypes | filterChargeableItemsByCurrency: {searchText: $select.search, registrationCurrency: vm.registrationCurrency }) track by registrationType.id"><div ng-bind-html="registrationType.name | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.registrationType.$invalid"><p class="error-block" ng-show="editForm.registrationType.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.registrationRegistrationType.regFee" for="field_regFee">Reg Fee</label><input type="number" class="form-control" name="regFee" id="field_regFee" disabled="disabled" autocomplete="off" ng-model="vm.registrationRegistrationType.regFee" required><div ng-show="editForm.regFee.$invalid"><p class="error-block" ng-show="editForm.regFee.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.regFee.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.registrationRegistrationType.currency" for="field_currency">Currency</label><input type="text" class="form-control" name="currency" id="field_currency" disabled="disabled" autocomplete="off" ng-model="vm.registrationRegistrationType.currency" required ng-maxlength="3"><div ng-show="editForm.currency.$invalid"><p class="error-block" ng-show="editForm.currency.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.currency.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="3">This field cannot be longer than 3 characters.</p></div></div><div class="form-group" ng-show="vm.registrationRegistrationType.registrationType.registrationType == \'ACCOMPANYING_FEE\'"><label class="control-label" data-translate="pcsApp.registrationRegistrationType.accPeople" for="field_accPeople">Acc People</label><input type="number" class="form-control" name="accPeople" id="field_accPeople" autocomplete="off" ng-required="vm.registrationRegistrationType.registrationType.registrationType == \'ACCOMPANYING_FEE\'" ng-disabled="vm.registrationRegistrationType.id" ng-model="vm.registrationRegistrationType.accPeople"></div><div class="form-group"><label translate="pcsApp.registrationRegistrationType.payingGroupItem" for="field_payingGroupItem">Discount</label><ui-select ng-model="vm.registrationRegistrationType.payingGroupItem" name="payingGroupItem" id="field_payingGroupItem" theme="bootstrap"><ui-select-match allow-clear="true" placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.payingGroup.name + \'/\' + $select.selected.name"></span></ui-select-match><ui-select-choices repeat="payingGroupItem in (vm.payingGroupItems | filter: { payingGroup: { currency: { currency: vm.registrationRegistrationType.registrationType.currency.currency }}} | filter: $select.search) track by payingGroupItem.id"><div ng-bind-html="payingGroupItem.payingGroup.name + \'/\' + payingGroupItem.name | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/registration-type/registration-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.registrationType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.registrationType.delete.question" translate-values="{id: \'{{vm.registrationType.id}}\'}">Are you sure you want to delete this Registration Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/registration-type/registration-type-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRegistrationTypeLabel" data-translate="pcsApp.registrationType.home.createOrEditLabel">Create or edit a Registration Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="pcsApp.registrationType.code" for="field_code">Code</label><input type="text" class="form-control" name="code" id="field_code" autocomplete="off" ng-model="vm.registrationType.code" required ng-maxlength="16"><div ng-show="editForm.code.$invalid"><p class="error-block" ng-show="editForm.code.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.code.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="16">This field cannot be longer than 16 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.registrationType.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" autocomplete="off" ng-model="vm.registrationType.name" required ng-minlength="5" ng-maxlength="100"><div ng-show="editForm.name.$invalid"><p class="error-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="5">This field is required to be at least 5 characters.</p><p class="error-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.registrationType.firstRegFee" for="field_firstRegFee">First Reg Fee</label><input type="number" class="form-control" name="firstRegFee" id="field_firstRegFee" autocomplete="off" ng-model="vm.registrationType.firstRegFee" required min="-1000000" max="1000000"><div ng-show="editForm.firstRegFee.$invalid"><p class="error-block" ng-show="editForm.firstRegFee.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.firstRegFee.$error.min" data-translate="entity.validation.min" translate-value-min="-1000000">This field should be more than -1000000.</p><p class="error-block" ng-show="editForm.firstRegFee.$error.max" data-translate="entity.validation.min" translate-value-max="1000000">This field should be more than 1000000.</p><p class="error-block" ng-show="editForm.firstRegFee.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.registrationType.firstDeadline" for="field_firstDeadline">First Deadline</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'firstDeadline\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_firstDeadline" type="text" class="form-control" autocomplete="off" name="firstDeadline" uib-datepicker-popup="{{dateformat}}" ng-model="vm.registrationType.firstDeadline" is-open="vm.datePickerOpenStatus.firstDeadline" ng-required="vm.registrationType.secondDeadline || vm.registrationType.secondRegFee || vm.registrationType.thirdRegFee"></div><div ng-show="editForm.firstDeadline.$invalid"><p class="error-block" ng-show="editForm.firstDeadline.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.registrationType.secondRegFee" for="field_secondRegFee">Second Reg Fee</label><input type="number" class="form-control" name="secondRegFee" id="field_secondRegFee" autocomplete="off" ng-required="vm.registrationType.firstDeadline || vm.registrationType.secondDeadline || vm.registrationType.thirdRegFee" ng-model="vm.registrationType.secondRegFee" min="-1000000" max="1000000"><div ng-show="editForm.secondRegFee.$invalid"><p class="error-block" ng-show="editForm.secondRegFee.$error.min" data-translate="entity.validation.min" translate-value-min="-1000000">This field should be more than -1000000.</p><p class="error-block" ng-show="editForm.secondRegFee.$error.max" data-translate="entity.validation.min" translate-value-max="1000000">This field should be more than 1000000.</p><p class="error-block" ng-show="editForm.secondRegFee.$error.number" data-translate="entity.validation.number">This field should be a number.</p><p class="error-block" ng-show="editForm.secondRegFee.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.registrationType.secondDeadline" for="field_secondDeadline">Second Deadline</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'secondDeadline\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_secondDeadline" date-less-than="{{vm.registrationType.firstDeadline}}" type="text" class="form-control" name="secondDeadline" autocomplete="off" uib-datepicker-popup="{{dateformat}}" ng-model="vm.registrationType.secondDeadline" is-open="vm.datePickerOpenStatus.secondDeadline" ng-required="vm.registrationType.thirdRegFee"></div><div ng-show="editForm.secondDeadline.$invalid"><p class="error-block" ng-show="editForm.secondDeadline.$error.required" translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.secondDeadline.$error.dateLessThan" translate="pcsApp.registrationType.messages.secondDeadlineLessThanFirstDeadline">End date must be later than Start date.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.registrationType.thirdRegFee" for="field_thirdRegFee">Third Reg Fee</label><input type="number" class="form-control" name="thirdRegFee" id="field_thirdRegFee" autocomplete="off" ng-model="vm.registrationType.thirdRegFee" ng-required="vm.registrationType.secondDeadline" min="-1000000" max="1000000"><div ng-show="editForm.thirdRegFee.$invalid"><p class="error-block" ng-show="editForm.thirdRegFee.$error.required" translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.thirdRegFee.$error.min" data-translate="entity.validation.min" translate-value-min="-1000000">This field should be more than -1000000.</p><p class="error-block" ng-show="editForm.thirdRegFee.$error.max" data-translate="entity.validation.min" translate-value-max="1000000">This field should be more than 1000000.</p><p class="error-block" ng-show="editForm.thirdRegFee.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.registrationType.registrationType" for="field_registrationType">Registration Type</label><select class="form-control" name="registrationType" ng-model="vm.registrationType.registrationType" id="field_registrationType" required><option value="" data-translate="global.form.please.select">Please select</option><option value="REGISTRATION_FEE" data-translate="pcsApp.RegistrationTypeType.REGISTRATION_FEE">REGISTRATION_FEE</option><option value="ACCOMPANYING_FEE" data-translate="pcsApp.RegistrationTypeType.ACCOMPANYING_FEE">ACCOMPANYING_FEE</option></select><div ng-show="editForm.registrationType.$invalid"><p class="error-block" ng-show="editForm.registrationType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label translate="pcsApp.registrationType.currency" for="field_currency">Currency</label><ui-select ng-model="vm.registrationType.currency" name="currency" id="field_currency" theme="bootstrap" required><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.currency"></span></ui-select-match><ui-select-choices repeat="currency in (vm.currencies | filter: $select.search) track by currency.id"><div ng-bind-html="currency.currency | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.currency.$invalid"><p class="error-block" ng-show="editForm.currency.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label translate="pcsApp.registrationType.vatInfo" for="field_vatInfo">Vat info</label><ui-select ng-model="vm.registrationType.vatInfo" name="vatInfo" id="field_vatInfo" theme="bootstrap" required><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="vatInfo in (vm.vatInfos | filter: $select.search) track by vatInfo.id"><div ng-bind-html="vatInfo.name | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.vatInfo.$invalid"><p class="error-block" ng-show="editForm.vatInfo.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.registrationType.onlineLabel" for="field_onlineLabel">Online label</label><input type="text" class="form-control" name="onlineLabel" id="field_onlineLabel" autocomplete="off" ng-model="vm.registrationType.onlineLabel" ng-maxlength="200"><div ng-show="editForm.onlineLabel.$invalid"><p class="error-block" ng-show="editForm.onlineLabel.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="200">This field cannot be longer than 200 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.registrationType.onlineOrder" for="field_onlineOrder">Online order</label><input type="number" class="form-control" name="onlineOrder" id="field_onlineOrder" autocomplete="off" ng-model="vm.registrationType.onlineOrder" ng-required="vm.registrationType.onlineVisibility == \'VISIBLE\'" min="0" max="100"><div ng-show="editForm.onlineOrder.$invalid"><p class="error-block" ng-show="editForm.onlineOrder.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.onlineOrder.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be more than 0.</p><p class="error-block" ng-show="editForm.onlineOrder.$error.max" data-translate="entity.validation.max" translate-value-max="100">This field cannot be more than 100.</p><p class="error-block" ng-show="editForm.onlineOrder.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.registrationType.onlineVisibility" for="onlineVisibility">Online visibility</label><select class="form-control" name="onlineVisibility" ng-model="vm.registrationType.onlineVisibility" id="onlineVisibility" required><option value="" data-translate="global.form.please.select">Please select</option><option value="VISIBLE" data-translate="pcsApp.OnlineVisibility.VISIBLE">VISIBLE</option><option value="NOT_VISIBLE" data-translate="pcsApp.OnlineVisibility.NOT_VISIBLE">NOT_VISIBLE</option></select><div ng-show="editForm.onlineVisibility.$invalid"><p class="error-block" ng-show="editForm.onlineVisibility.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.registrationType.onlineType" for="onlineType">Online type</label><select class="form-control" name="onlineType" ng-model="vm.registrationType.onlineType" id="onlineType" required><option value="" data-translate="global.form.please.select">Please select</option><option value="NORMAL" data-translate="pcsApp.OnlineType.NORMAL">NORMAL</option><option value="EXTRA" data-translate="pcsApp.OnlineType.EXTRA">EXTRA</option></select><div ng-show="editForm.onlineType.$invalid"><p class="error-block" ng-show="editForm.onlineType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/registration-type/registration-types.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 translate="pcsApp.registrationType.home.title">Registration types</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-primary" type="submit" ui-sref="registration-type.new"><i class="fa fa-plus"></i></button><!--<div ibox-tools></div>--></div><div class="ibox-content"><table id="registration-type-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.registrationType.code">Code</span></th><th><span translate="pcsApp.registrationType.name">Name</span></th><th><span translate="pcsApp.registrationType.firstRegFee">FirstRegFee</span></th><th><span translate="pcsApp.registrationType.firstDeadline">FirstDeadline</span></th><th><span translate="pcsApp.registrationType.secondRegFee">SecondRegFee</span></th><th><span translate="pcsApp.registrationType.secondDeadline">SecondDeadline</span></th><th><span translate="pcsApp.registrationType.thirdRegFee">ThirdRegFee</span></th><th><span translate="pcsApp.registrationType.registrationType">Registration Type</span></th><th><span translate="pcsApp.registrationType.currency">Currency</span></th><th><span translate="pcsApp.registrationType.vatInfo">Vat info</span></th><th><span translate="pcsApp.registrationType.onlineVisibility">Online visibility</span></th><th><span translate="pcsApp.registrationType.onlineOrder">Online order</span></th><th></th></tr></thead><tbody><tr ng-repeat="registrationType in vm.registrationTypes track by registrationType.id"><td>{{registrationType.code}}</td><td>{{registrationType.name}}</td><td>{{registrationType.firstRegFee}}</td><td>{{registrationType.firstDeadline | date:\'mediumDate\'}}</td><td>{{registrationType.secondRegFee}}</td><td>{{registrationType.secondDeadline | date:\'mediumDate\'}}</td><td>{{registrationType.thirdRegFee}}</td><td data-translate="{{\'pcsApp.RegistrationTypeType.\' + registrationType.registrationType}}">{{registrationType.registrationType}}</td><td>{{registrationType.currency.currency}}</td><td>{{registrationType.vatInfo.name}}</td><td>{{\'pcsApp.OnlineVisibility.\' + registrationType.onlineVisibility | translate}}</td><td>{{registrationType.onlineOrder}}</td><td><button class="btn btn-info" type="submit" ui-sref="registration-type.edit({id:registrationType.id})"><i class="fa fa-pencil-square-o"></i></button> <button class="btn btn-danger" type="submit" ui-sref="registration-type.delete({id:registrationType.id})"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/room/room-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.room.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.room.delete.question" translate-values="{id: \'{{vm.room.id}}\'}">Are you sure you want to delete this Room?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/room/room-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRoomLabel" data-translate="pcsApp.room.home.createOrEditLabel" data-translate-values="{ name: vm.congressHotel.hotel.name }">Create or edit a room for {{ vm.congressHotel.hotel.name }}</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="pcsApp.room.roomType" for="field_roomType">Room Type</label><input type="text" class="form-control" name="roomType" id="field_roomType" autocomplete="off" ng-model="vm.room.roomType" required ng-maxlength="32"><div ng-show="editForm.roomType.$invalid"><p class="error-block" ng-show="editForm.roomType.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.roomType.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.room.bed" for="field_bed">Bed</label><input type="number" class="form-control" name="bed" id="field_bed" autocomplete="off" ng-model="vm.room.bed" required min="0" max="100"><div ng-show="editForm.bed.$invalid"><p class="error-block" ng-show="editForm.bed.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.bed.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be more than 0.</p><p class="error-block" ng-show="editForm.bed.$error.max" data-translate="entity.validation.max" translate-value-max="100">This field cannot be more than 100.</p><p class="error-block" ng-show="editForm.bed.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.room.quantity" for="field_quantity">Quantity</label><input type="number" class="form-control" name="quantity" id="field_quantity" autocomplete="off" ng-model="vm.room.quantity" room-quantity-validation reserved="vm.getMaxReservedRoomNumber()" required min="0" max="1000"><div ng-show="editForm.quantity.$invalid"><p class="error-block" ng-show="editForm.quantity.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.quantity.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be more than 0.</p><p class="error-block" ng-show="editForm.quantity.$error.max" data-translate="entity.validation.max" translate-value-max="1000">This field cannot be more than 1000.</p><p class="error-block" ng-show="editForm.quantity.$error.number" data-translate="entity.validation.number">This field should be a number.</p><p class="error-block" ng-show="editForm.quantity.$error.quantity" translate="pcsApp.room.error.quantityExceededByReserved">Quantity can not be smaller than the already reserved number of rooms.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.room.price" for="field_price">Price</label><input type="number" class="form-control" name="price" id="field_price" autocomplete="off" ng-model="vm.room.price" required min="-1000000" max="1000000"><div ng-show="editForm.price.$invalid"><p class="error-block" ng-show="editForm.price.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.price.$error.min" data-translate="entity.validation.min" translate-value-min="-1000000">This field should be more than -1000000.</p><p class="error-block" ng-show="editForm.price.$error.max" data-translate="entity.validation.max" translate-value-max="1000000">This field cannot be more than 1000000.</p><p class="error-block" ng-show="editForm.price.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label translate="pcsApp.room.currency" for="field_currency">Currency</label><ui-select ng-model="vm.room.currency" name="currency" id="field_currency" theme="bootstrap" required><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.currency"></span></ui-select-match><ui-select-choices repeat="currency in (vm.currencies | filter: $select.search) track by currency.id"><div ng-bind-html="currency.currency | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.currency.$invalid"><p class="error-block" ng-show="editForm.currency.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label translate="pcsApp.room.vatInfo" for="field_vatInfo">Vat info</label><ui-select ng-model="vm.room.vatInfo" name="vatInfo" id="field_vatInfo" theme="bootstrap" required><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="vatInfo in (vm.vatInfos | filter: $select.search) track by vatInfo.id"><div ng-bind-html="vatInfo.name | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.vatInfo.$invalid"><p class="error-block" ng-show="editForm.vatInfo.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.room.onlineLabel" for="field_onlineLabel">Online label</label><input type="text" class="form-control" name="onlineLabel" id="field_onlineLabel" autocomplete="off" ng-model="vm.room.onlineLabel" ng-maxlength="200"><div ng-show="editForm.onlineLabel.$invalid"><p class="error-block" ng-show="editForm.onlineLabel.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="200">This field cannot be longer than 200 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.room.onlineExternalLink" for="field_onlineExternalLink">Online external link</label><input type="text" class="form-control" name="onlineExternalLink" id="field_onlineExternalLink" autocomplete="off" ng-model="vm.room.onlineExternalLink" ng-maxlength="255"><div ng-show="editForm.onlineExternalLink.$invalid"><p class="error-block" ng-show="editForm.onlineExternalLink.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.room.onlineExternalEmail" for="field_onlineExternalEmail">Online external email</label><input type="email" class="form-control" name="onlineExternalEmail" id="field_onlineExternalEmail" autocomplete="off" ng-model="vm.room.onlineExternalEmail" ng-maxlength="64"><div ng-show="editForm.onlineExternalEmail.$invalid"><p class="error-block" ng-show="editForm.onlineExternalEmail.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p><p class="error-block" ng-show="editForm.onlineExternalEmail.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.room.onlineVisibility" for="onlineVisibility">Online visibility</label><select class="form-control" name="onlineVisibility" ng-model="vm.room.onlineVisibility" id="onlineVisibility" required><option value="" data-translate="global.form.please.select">Please select</option><option value="VISIBLE" data-translate="pcsApp.OnlineVisibility.VISIBLE">VISIBLE</option><option value="NOT_VISIBLE" data-translate="pcsApp.OnlineVisibility.NOT_VISIBLE">NOT_VISIBLE</option></select><div ng-show="editForm.onlineVisibility.$invalid"><p class="error-block" ng-show="editForm.onlineVisibility.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/room/rooms.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 translate="pcsApp.room.home.listTitle" translate-values="{hotelName: \'{{vm.congressHotel.hotel.name}}\'}">Rooms for {{vm.congressHotel.hotel.name}}</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-primary" type="submit" ui-sref="room.new"><i class="fa fa-plus"></i></button> <button class="btn btn-info" type="submit" ui-sref="congress-hotel"><i class="fa fa-arrow-left"></i></button><!--<div ibox-tools></div>--></div><div class="ibox-content"><table datatable="ng" id="room-datatable" dt-options="dtOptions" dt-column-defs="dtColumnDefs" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.room.roomType">RoomType</span></th><th><span translate="pcsApp.room.bed">Bed</span></th><th><span translate="pcsApp.room.quantity">Quantity</span></th><th><span translate="pcsApp.room.reserved">Reserved</span></th><th><span translate="pcsApp.room.price">Price</span></th><th><span translate="pcsApp.room.currency">Currency</span></th><th><span translate="pcsApp.room.vatInfo">Vat Info</span></th><th></th></tr></thead><tbody><tr ng-repeat="room in vm.rooms track by room.id"><td>{{room.roomType}}</td><td>{{room.bed}}</td><td>{{room.quantity}}</td><td><span ng-repeat=" reservation in room.reservations track by reservation.id">{{reservation.reservationDate | date: \'yyyy-MM-dd\' }}: {{reservation.reserved }}<br></span></td><td>{{room.price}}</td><td>{{room.currency.currency}}</td><td>{{room.vatInfo.name}}</td><td><button class="btn btn-info" type="submit" ui-sref="room.edit({id: room.id})"><i class="fa fa-pencil-square-o"></i></button> <button class="btn btn-danger" type="submit" ui-sref="room.delete({id: room.id})"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/room-reservation/room-reservation-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.rrr.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.roomReservation.delete.question" translate-values="{id: \'{{vm.rrr.id}}\'}">Are you sure you want to delete this Room Reservation?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/room-reservation/room-reservation-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRoomReservationLabel" data-translate="pcsApp.roomReservation.home.createOrEditLabel">Create or edit a Room Reservation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label translate="pcsApp.roomReservation.room" for="field_room">Room</label><ui-select ng-model="vm.roomReservation.roomId" name="room" id="field_room" theme="bootstrap" required ng-disabled="vm.roomReservation.id"><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.hotelName + \' - \' + $select.selected.roomType"></span></ui-select-match><ui-select-choices repeat="room.id as room in (vm.rooms | filterChargeableItemsByCurrency: {searchText: $select.search, registrationCurrency: vm.registrationCurrency, criteria: vm.filterChargeableItemsByCurrencyCriteria }) track by room.id"><div ng-bind-html="room.hotelName + \' - \' + room.roomType | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.room.$invalid"><p class="error-block" ng-show="editForm.room.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label translate="pcsApp.roomReservation.shared" for="field_shared">shared</label><div class="checkbox" style="margin-top: 0px; margin-bottom: 0px"><input type="checkbox" id="field_shared" name="shared" ng-model="vm.roomReservation.shared" ng-disabled="vm.roomReservation.id"><label style="cursor: default"></label></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.roomReservation.arrivalDate" for="field_arrivalDate">Arrival Date</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'arrivalDate\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_arrivalDate" type="text" class="form-control" name="arrivalDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.roomReservation.arrivalDate" is-open="vm.datePickerOpenStatus.arrivalDate" ng-disabled="!vm.isDateEditable()" required></div><div ng-show="editForm.arrivalDate.$invalid"><p class="error-block" ng-show="editForm.arrivalDate.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.roomReservation.departureDate" for="field_departureDate">Departure Date</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'departureDate\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input id="field_departureDate" type="text" class="form-control" name="departureDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.roomReservation.departureDate" is-open="vm.datePickerOpenStatus.departureDate" ng-disabled="!vm.isDateEditable()" required></div><div ng-show="editForm.departureDate.$invalid"><p class="error-block" ng-show="editForm.departureDate.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label translate="pcsApp.roomReservation.payingGroupItem" for="field_payingGroupItem">Discount</label><ui-select ng-model="vm.roomReservation.payingGroupItem" name="payingGroupItem" id="field_payingGroupItem" theme="bootstrap"><ui-select-match allow-clear="true" placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.payingGroup.name + \'/\' + $select.selected.name"></span></ui-select-match><ui-select-choices repeat="payingGroupItem as payingGroupItem in (vm.payingGroupItems | filter: { payingGroup: { currency: { currency: vm.registrationCurrency }}} | filter: $select.search) track by payingGroupItem.id"><div ng-bind-html="payingGroupItem.payingGroup.name + \'/\' + payingGroupItem.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="form-group"><label class="control-label" translate="pcsApp.roomReservation.comment" for="field_comment">Comment</label><textarea class="form-control" name="comment" id="field_comment" rows="3" autocomplete="off" ng-model="vm.roomReservation.comment" ng-maxlength="1024">\n            </textarea><div ng-show="editForm.comment.$invalid"><p class="error-block" ng-show="editForm.comment.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="1024">This field cannot be longer than 1024 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/room-reservation/shared-room-reservation-dialog.html','<div class="modal-header"><h4 class="modal-title" id="myRoomReservationLabel" translate="pcsApp.roomReservation.home.createSharedLabel">Create or edit a Shared Room Reservation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><table datatable="ng" id="shared-room-reservation-datatable" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.roomReservation.id">Res #</span></th><th><span translate="pcsApp.roomReservation.room">Room type</span></th><th><span translate="pcsApp.roomReservation.hotel">Hotel</span></th><th><span translate="pcsApp.roomReservation.arrivalDate">Arrival Date</span></th><th><span translate="pcsApp.roomReservation.departureDate">Departure Date</span></th><th><span translate="pcsApp.roomReservation.price">Price</span></th><th><span translate="pcsApp.roomReservation.roomMates">Roommates</span></th><th></th></tr></thead><tbody><tr ng-repeat="rr in vm.roomReservations | filter: vm.registrationCurrency track by rr.id"><td>{{rr.id}}</td><td>{{rr.roomType}}</td><td>{{rr.hotelName}}</td><td>{{rr.arrivalDate | date:\'mediumDate\'}}</td><td>{{rr.departureDate | date:\'mediumDate\'}}</td><td>{{rr.price + \' \' + rr.currency}}</td><td>{{rr.roomMates}}</td><td><button class="btn btn-info" ng-click="vm.save(rr.id)"><i class="fa fa-slideshare"></i></button></td></tr></tbody></table></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div>');
$templateCache.put('app/entities/room-reservation-by-participant/room-reservation-by-participant-selection-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.select()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="roomReservationByParticipantLabel" data-translate="pcsApp.roomReservationByParticipant.home.createOrEditLabel">Create or edit a Group Discount Item</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="pcsApp.roomReservationByParticipant.hotel" for="field_hotel">Hotel</label><ui-select ng-model="vm.listFilter.congressHotel" name="hotel" id="field_hotel" theme="bootstrap" required><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.hotel.name"></span></ui-select-match><ui-select-choices repeat="congressHotel in (vm.congressHotels | filter: $select.search) track by congressHotel.id"><div ng-bind-html="congressHotel.hotel.name | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.hotel.$invalid"><p class="error-block" ng-show="editForm.hotel.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.select">Select</span></button></div></form>');
$templateCache.put('app/entities/room-reservation-by-participant/room-reservation-by-participants.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 data-translate="pcsApp.roomReservationByParticipant.home.title">Room Reservation By Participants</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-primary" type="submit" ui-sref="room-reservation-by-participant.selection"><i class="fa fa-search-plus"></i></button> <button class="btn btn-primary" type="submit" ng-show="vm.listFilter.congressHotel" ng-click="vm.downloadReportXls()"><i class="fa fa-download"></i></button>&nbsp;&nbsp; <span ng-show="vm.listFilter.congressHotel">Hotel: <strong>{{vm.listFilter.congressHotel.hotel.name}}</strong>&nbsp;&nbsp;</span></div><div class="ibox-content" ng-show="vm.roomReservationByParticipants.length"><table datatable="ng" id="room-reservation-by-participant-datatable" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" class="table table-striped table-bordered table-hover"><thead><tr><th><span data-translate="pcsApp.roomReservationByParticipant.regId">Reg Id</span></th><th><span data-translate="pcsApp.roomReservationByParticipant.name">Name</span></th><th><span data-translate="pcsApp.roomReservationByParticipant.roomType">Room type</span></th><th><span data-translate="pcsApp.roomReservationByParticipant.arrivalDate">Arrival date</span></th><th><span data-translate="pcsApp.roomReservationByParticipant.departureDate">Departure date</span></th><th><span data-translate="pcsApp.roomReservationByParticipant.nights">Nights</span></th><th><span data-translate="pcsApp.roomReservationByParticipant.personCost">P cost</span></th><th><span data-translate="pcsApp.roomReservationByParticipant.personPaid">P paid</span></th><th><span data-translate="pcsApp.roomReservationByParticipant.personToPay">P to pay</span></th><th><span data-translate="pcsApp.roomReservationByParticipant.groupCost">G cost</span></th><th><span data-translate="pcsApp.roomReservationByParticipant.groupPaid">G paid</span></th><th><span data-translate="pcsApp.roomReservationByParticipant.groupToPay">G to pay</span></th><th><span data-translate="pcsApp.roomReservationByParticipant.totalCost">T cost</span></th><th><span data-translate="pcsApp.roomReservationByParticipant.totalPaid">T paid</span></th><th><span data-translate="pcsApp.roomReservationByParticipant.totalToPay">T to pay</span></th><th><span data-translate="pcsApp.roomReservationByParticipant.currency">Currency</span></th><th><span data-translate="pcsApp.roomReservationByParticipant.payingGroupName">Paying group</span></th><th><span data-translate="pcsApp.roomReservationByParticipant.comment">Comment</span></th></tr></thead><tbody><tr ng-repeat="roomReservationByParticipant in vm.roomReservationByParticipants track by roomReservationByParticipant.id"><td>{{roomReservationByParticipant.regId}}</td><td>{{roomReservationByParticipant.lastName}} {{roomReservationByParticipant.firstName}}</td><td>{{roomReservationByParticipant.roomType}}</td><td>{{roomReservationByParticipant.arrivalDate}}</td><td>{{roomReservationByParticipant.departureDate}}</td><td>{{roomReservationByParticipant.nights}}</td><td>{{roomReservationByParticipant.personCost}}</td><td>{{roomReservationByParticipant.personPaid}}</td><td>{{roomReservationByParticipant.personToPay}}</td><td>{{roomReservationByParticipant.groupCost}}</td><td>{{roomReservationByParticipant.groupPaid}}</td><td>{{roomReservationByParticipant.groupToPay}}</td><td>{{roomReservationByParticipant.totalCost}}</td><td>{{roomReservationByParticipant.totalPaid}}</td><td>{{roomReservationByParticipant.totalToPay}}</td><td>{{roomReservationByParticipant.currency}}</td><td>{{roomReservationByParticipant.payingGroupName}}</td><td>{{roomReservationByParticipant.comment}}</td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/room-reservation-by-room/room-reservation-by-room-selection-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.select()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="roomReservationByRoomLabel" data-translate="pcsApp.roomReservationByRoom.home.createOrEditLabel">Create or edit a Group Discount Item</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="pcsApp.roomReservationByRoom.hotel" for="field_hotel">Hotel</label><ui-select ng-model="vm.listFilter.congressHotel" name="hotel" id="field_hotel" theme="bootstrap" required><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.hotel.name"></span></ui-select-match><ui-select-choices repeat="congressHotel in (vm.congressHotels | filter: $select.search) track by congressHotel.id"><div ng-bind-html="congressHotel.hotel.name | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.hotel.$invalid"><p class="error-block" ng-show="editForm.hotel.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.select">Select</span></button></div></form>');
$templateCache.put('app/entities/room-reservation-by-room/room-reservation-by-rooms.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 data-translate="pcsApp.roomReservationByRoom.home.title">Room Reservation By Rooms</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-primary" type="submit" ui-sref="room-reservation-by-room.selection"><i class="fa fa-search-plus"></i></button> <button class="btn btn-primary" type="submit" ng-show="vm.listFilter.congressHotel" ng-click="vm.downloadReportXls()"><i class="fa fa-download"></i></button>&nbsp;&nbsp; <span ng-show="vm.listFilter.congressHotel">Hotel: <strong>{{vm.listFilter.congressHotel.hotel.name}}</strong>&nbsp;&nbsp;</span></div><div class="ibox-content" ng-show="vm.roomReservationByRooms.length"><table datatable="ng" id="room-reservation-by-room-datatable" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" class="table table-striped table-bordered table-hover"><thead><tr><th><span data-translate="pcsApp.roomReservationByRoom.roomType">Room type</span></th><th><span data-translate="pcsApp.roomReservationByRoom.regId">Reg Id</span></th><th><span data-translate="pcsApp.roomReservationByRoom.name">Name</span></th><th><span data-translate="pcsApp.roomReservationByRoom.country">Country</span></th><th><span data-translate="pcsApp.roomReservationByRoom.arrivalDate">Arrival date</span></th><th><span data-translate="pcsApp.roomReservationByRoom.departureDate">Departure date</span></th><th><span data-translate="pcsApp.roomReservationByRoom.nights">Nights</span></th><th><span data-translate="pcsApp.roomReservationByRoom.personCost">P cost</span></th><th><span data-translate="pcsApp.roomReservationByRoom.personPaid">P paid</span></th><th><span data-translate="pcsApp.roomReservationByRoom.personToPay">P to pay</span></th><th><span data-translate="pcsApp.roomReservationByRoom.groupCost">G cost</span></th><th><span data-translate="pcsApp.roomReservationByRoom.groupPaid">G paid</span></th><th><span data-translate="pcsApp.roomReservationByRoom.groupToPay">G to pay</span></th><th><span data-translate="pcsApp.roomReservationByRoom.totalCost">T cost</span></th><th><span data-translate="pcsApp.roomReservationByRoom.totalPaid">T paid</span></th><th><span data-translate="pcsApp.roomReservationByRoom.totalToPay">T to pay</span></th><th><span data-translate="pcsApp.roomReservationByRoom.currency">Currency</span></th><th><span data-translate="pcsApp.roomReservationByRoom.payingGroupName">Paying group</span></th><th><span data-translate="pcsApp.roomReservationByRoom.comment">Comment</span></th></tr></thead><tbody><tr ng-repeat="roomReservationByRoom in vm.roomReservationByRooms track by roomReservationByRoom.id"><td>{{roomReservationByRoom.roomType}}</td><td>{{roomReservationByRoom.regId}}</td><td>{{roomReservationByRoom.name}}</td><td>{{roomReservationByRoom.country}}</td><td>{{roomReservationByRoom.arrivalDate}}</td><td>{{roomReservationByRoom.departureDate}}</td><td>{{roomReservationByRoom.nights}}</td><td>{{roomReservationByRoom.personCost}}</td><td>{{roomReservationByRoom.personPaid}}</td><td>{{roomReservationByRoom.personToPay}}</td><td>{{roomReservationByRoom.groupCost}}</td><td>{{roomReservationByRoom.groupPaid}}</td><td>{{roomReservationByRoom.groupToPay}}</td><td>{{roomReservationByRoom.totalCost}}</td><td>{{roomReservationByRoom.totalPaid}}</td><td>{{roomReservationByRoom.totalToPay}}</td><td>{{roomReservationByRoom.currency}}</td><td>{{roomReservationByRoom.payingGroupName}}</td><td>{{roomReservationByRoom.comment}}</td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/vat-info/vat-info-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.vatInfo.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.vatInfo.delete.question" translate-values="{id: \'{{vm.vatInfo.id}}\'}">Are you sure you want to delete this Vat Info?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/vat-info/vat-info-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myVatInfoLabel" data-translate="pcsApp.vatInfo.home.createOrEditLabel">Create or edit a Vat Info</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="pcsApp.vatInfo.vatRateType" for="field_vatRateType">Vat Rate Type</label><select class="form-control" name="vatRateType" ng-model="vm.vatInfo.vatRateType" id="field_vatRateType" ng-change="vm.vatRateTypeChanged()" required><option value="" data-translate="global.form.please.select">Please select</option><option value="REGULAR" data-translate="pcsApp.VatRateType.REGULAR">REGULAR</option><option value="EUFAD37" data-translate="pcsApp.VatRateType.EUFAD37">EUFAD37</option><option value="HO" data-translate="pcsApp.VatRateType.HO">HO</option><option value="ATK" data-translate="pcsApp.VatRateType.ATK">ATK</option><option value="EUE" data-translate="pcsApp.VatRateType.EUE">EUE</option><option value="NAM" data-translate="pcsApp.VatRateType.NAM">NAM</option><option value="NAM" data-translate="pcsApp.VatRateType.TAM">TAM</option></select><div ng-show="editForm.vatRateType.$invalid"><p class="error-block" ng-show="editForm.vatRateType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.vatInfo.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" autocomplete="off" ng-model="vm.vatInfo.name" required ng-minlength="3" ng-maxlength="128"><div ng-show="editForm.name.$invalid"><p class="error-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 3 characters.</p><p class="error-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="128">This field cannot be longer than 128 characters.</p></div></div><div class="form-group" ng-show="vm.vatInfo.vatRateType === \'REGULAR\'"><label class="control-label" data-translate="pcsApp.vatInfo.vat" for="field_vat">Vat</label><input type="number" class="form-control" name="vat" id="field_vat" autocomplete="off" ng-model="vm.vatInfo.vat" ng-required="vm.vatInfo.vatRateType === \'REGULAR\'" min="0" max="100"><div ng-show="editForm.vat.$invalid"><p class="error-block" ng-show="editForm.vat.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.vat.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be more than 0.</p><p class="error-block" ng-show="editForm.vat.$error.max" data-translate="entity.validation.max" translate-value-max="100">This field cannot be more than 100.</p><p class="error-block" ng-show="editForm.vat.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.vatInfo.szj" for="field_szj">Szj</label><input type="text" class="form-control" name="szj" id="field_szj" autocomplete="off" ng-model="vm.vatInfo.szj" ng-maxlength="20"><div ng-show="editForm.szj.$invalid"><p class="error-block" ng-show="editForm.szj.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.vatInfo.chargeableItemType" for="field_chargeableItemType">Chargeable Item Type</label><select class="form-control" name="chargeableItemType" ng-model="vm.vatInfo.chargeableItemType" id="field_chargeableItemType" required><option value="" data-translate="global.form.please.select">Please select</option><option value="REGISTRATION" data-translate="pcsApp.ChargeableItemType.REGISTRATION">REGISTRATION</option><option value="HOTEL" data-translate="pcsApp.ChargeableItemType.HOTEL">HOTEL</option><option value="OPTIONAL_SERVICE" data-translate="pcsApp.ChargeableItemType.OPTIONAL_SERVICE">OPTIONAL_SERVICE</option><option value="MISCELLANEOUS" data-translate="pcsApp.ChargeableItemType.MISCELLANEOUS">MISCELLANEOUS</option></select><div ng-show="editForm.chargeableItemType.$invalid"><p class="error-block" ng-show="editForm.chargeableItemType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ng-show="vm.vatInfo.vatRateType !== \'REGULAR\'"><label class="control-label" translate="pcsApp.vatInfo.vatExceptionReason" for="field_vatExceptionReason">Vat exception reason</label><textarea class="form-control" name="vatExceptionReason" id="field_vatExceptionReason" rows="10" autocomplete="off" ng-required="vm.vatInfo.vatRateType !== \'REGULAR\'" ng-model="vm.vatInfo.vatExceptionReason" ng-maxlength="200">\n            </textarea><div ng-show="editForm.vatExceptionReason.$invalid"><p class="error-block" ng-show="editForm.vatExceptionReason.$error.required" translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.vatExceptionReason.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="200">This field cannot be longer than 200 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/vat-info/vat-infos.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2><span translate="{{ \'pcsApp.vatInfo.home.\' + (vm.congressSpecific ? \'titleCustom\' : \'title\') }}">Vat Infos</span> {{ vm.selectedCongressMeetingCode }}</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-primary" type="submit" ui-sref="vat-info.new"><i class="fa fa-plus"></i></button><!--<div ibox-tools></div>--></div><div class="ibox-content"><table id="vatinfo-datatable" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.vatInfo.name">Name</span></th><th><span translate="pcsApp.vatInfo.vatRateType">Vat rate type</span></th><th><span translate="pcsApp.vatInfo.vat">VAT</span></th><th><span translate="pcsApp.vatInfo.szj">SZ.J.</span></th><th><span translate="pcsApp.vatInfo.chargeableItemType">Item type</span></th><th></th></tr></thead><tbody><tr ng-repeat="vatInfo in vm.vatInfos track by vatInfo.id"><td>{{vatInfo.name}}</td><td data-translate="{{\'pcsApp.VatRateType.\' + vatInfo.vatRateType}}">{{vatInfo.vatRateType}}</td><td>{{vatInfo.vat}}</td><td>{{vatInfo.szj}}</td><td data-translate="{{\'pcsApp.ChargeableItemType.\' + vatInfo.chargeableItemType}}">{{vatInfo.chargeableItemType}}</td><td><button class="btn btn-info" type="submit" ui-sref="{{vm.congressSpecific ? \'congress-\' : \'\'}}vat-info.edit({id:vatInfo.id})"><i class="fa fa-pencil-square-o"></i></button> <button class="btn btn-danger" type="submit" ui-sref="{{vm.congressSpecific ? \'congress-\' : \'\'}}vat-info.delete({id:vatInfo.id})"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/workplace/merge-workplaces.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 translate="pcsApp.workplace.home.mergeTitle" translate-values="{workplaceName: \'{{vm.workplace.name}}\'}">Merging workplaces into {{vm.workplace.name}}</h2></div><div class="col-lg-2"></div></div><jhi-alert-error></jhi-alert-error><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-info" type="submit" ui-sref="workplace"><i class="fa fa-arrow-left"></i></button> <button class="btn btn-success" type="submit" ng-disabled="!vm.isAnyWorkplaceSelected()" ui-sref="workplace.merge.confirm({id:vm.workplace.id})"><i class="fa fa-random"></i></button><!--<div ibox-tools></div>--></div><div class="ibox-content"><table datatable="ng" id="workplace-merge-datatable" dt-options="vm.dtOptions" dt-column-defs="vm.dtColumnDefs" class="table table-striped table-bordered table-hover batch-selection-datatable datatable-with-operations"><thead><tr><th></th><th><span translate="pcsApp.workplace.name">Name</span></th><th><span translate="pcsApp.workplace.country">Country</span></th><th><span translate="pcsApp.workplace.zipCode">Zip code</span></th><th><span translate="pcsApp.workplace.city">City</span></th><th><span translate="pcsApp.workplace.street">Street</span></th><th><span translate="pcsApp.workplace.phone">Phone</span></th><th><span translate="pcsApp.workplace.email">Email</span></th></tr></thead><tbody><tr ng-repeat="workplace in vm.workplaces track by workplace.id"><td><input ng-model="vm.selectedWorkplaces[workplace.id.toString()]" ng-change="vm.toggleWorkplaceSelection(workplace.id)" type="checkbox"></td><td>{{workplace.name}}</td><td>{{workplace.country.name}}</td><td>{{workplace.zipCode}}</td><td>{{workplace.city}}</td><td>{{workplace.street}}</td><td>{{workplace.phone}}</td><td>{{workplace.email}}</td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/workplace/workplace-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.workplace.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pcsApp.workplace.delete.question" translate-values="{id: \'{{vm.workplace.id}}\'}">Are you sure you want to delete this Workplace?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/workplace/workplace-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myWorkplaceLabel" data-translate="pcsApp.workplace.home.createOrEditLabel">Create or edit a Workplace</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="pcsApp.workplace.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" autocomplete="off" ng-model="vm.workplace.name" required ng-maxlength="255"><div ng-show="editForm.name.$invalid"><p class="error-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.workplace.department" for="field_department">Department</label><input type="text" class="form-control" name="department" id="field_department" autocomplete="off" ng-model="vm.workplace.department" ng-maxlength="128"><div ng-show="editForm.department.$invalid"><p class="error-block" ng-show="editForm.department.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="128">This field cannot be longer than 128 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.workplace.vatRegNumber" for="field_vatRegNumber">Vat Reg Number</label><input type="text" class="form-control" name="vatRegNumber" id="field_vatRegNumber" autocomplete="off" ng-model="vm.workplace.vatRegNumber"></div><div class="form-group"><label translate="pcsApp.workplace.country" for="field_country">Country</label><ui-select ng-model="vm.workplace.country" name="country" id="field_country" theme="bootstrap" required><ui-select-match placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="country in (vm.countries | filter: $select.search) track by country.id"><div ng-bind-html="country.name | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.country.$invalid"><p class="error-block" ng-show="editForm.country.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.workplace.zipCode" for="field_zipCode">Zip Code</label><input type="text" class="form-control" name="zipCode" id="field_zipCode" autocomplete="off" ng-model="vm.workplace.zipCode" ng-maxlength="32"><div ng-show="editForm.zipCode.$invalid"><p class="error-block" ng-show="editForm.zipCode.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.workplace.city" for="field_city">City</label><input type="text" class="form-control" name="city" id="field_city" autocomplete="off" ng-model="vm.workplace.city" ng-maxlength="64"><div ng-show="editForm.city.$invalid"><p class="error-block" ng-show="editForm.city.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.workplace.street" for="field_street">Street</label><input type="text" class="form-control" name="street" id="field_street" autocomplete="off" ng-model="vm.workplace.street" ng-maxlength="255"><div ng-show="editForm.street.$invalid"><p class="error-block" ng-show="editForm.street.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.workplace.phone" for="field_phone">Phone</label><input type="text" class="form-control" name="phone" id="field_phone" autocomplete="off" ng-model="vm.workplace.phone" ng-maxlength="64"><div ng-show="editForm.phone.$invalid"><p class="error-block" ng-show="editForm.phone.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.workplace.fax" for="field_fax">Fax</label><input type="text" class="form-control" name="fax" id="field_fax" autocomplete="off" ng-model="vm.workplace.fax" ng-maxlength="64"><div ng-show="editForm.fax.$invalid"><p class="error-block" ng-show="editForm.fax.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.workplace.email" for="field_email">Email</label><input type="email" class="form-control" name="email" id="field_email" autocomplete="off" ng-model="vm.workplace.email" ng-maxlength="64"><div ng-show="editForm.email.$invalid"><p class="error-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p><p class="error-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/workplace/workplace-merge-confirm-dialog.html','<form name="mergeForm" ng-submit="vm.confirmMerge(workplace.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.merge.title">Confirm merge operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="pcsApp.workplace.merge.question" translate-values="{name: \'{{vm.workplace.name}}\'}">Are you sure you want to merge the selected workplaces into this workplace?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="mergeForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.merge">Merge</span></button></div></form>');
$templateCache.put('app/entities/workplace/workplaces.html','<div class="row wrapper border-bottom white-bg page-heading"><div class="col-lg-10"><h2 translate="pcsApp.workplace.home.title">Workplaces</h2></div><div class="col-lg-2"></div></div><jhi-alert></jhi-alert><div class="wrapper wrapper-content animated fadeInRight"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title float-e-margins"><button class="btn btn-primary" type="submit" ui-sref="{{ (vm.isPartner ? \'partner\' : \'workplace\') + \'.new\' }}"><i class="fa fa-plus"></i></button><!--<div ibox-tools></div>--></div><div class="ibox-content"><table datatable="ng" id="workplace-datatable" dt-options="dtOptions" dt-column-defs="dtColumnDefs" class="table table-striped table-bordered table-hover datatable-with-operations"><thead><tr><th><span translate="pcsApp.workplace.name">Name</span></th><th><span translate="pcsApp.workplace.vatRegNumber">Vat Reg Number</span></th><th><span translate="pcsApp.workplace.country">Country</span></th><th><span translate="pcsApp.workplace.zipCode">Zip code</span></th><th><span translate="pcsApp.workplace.city">City</span></th><th><span translate="pcsApp.workplace.street">Street</span></th><th><span translate="pcsApp.workplace.phone">Phone</span></th><th><span translate="pcsApp.workplace.email">Email</span></th><th></th></tr></thead><tbody><tr ng-repeat="workplace in vm.workplaces track by workplace.id"><td>{{workplace.name}}</td><td>{{workplace.vatRegNumber}}</td><td>{{workplace.country.name}}</td><td>{{workplace.zipCode}}</td><td>{{workplace.city}}</td><td>{{workplace.street}}</td><td>{{workplace.phone}}</td><td>{{workplace.email}}</td><td><button class="btn btn-info" type="submit" ui-sref="{{ (vm.isPartner ? \'partner\' : \'workplace\') + \'.edit({id:workplace.id})\' }}"><i class="fa fa-pencil-square-o"></i></button> <button class="btn btn-success" type="submit" ng-show="!vm.isPartner" ui-sref="workplace.merge({id:workplace.id})"><i class="fa fa-random"></i></button> <button class="btn btn-danger" type="submit" ui-sref="{{ (vm.isPartner ? \'partner\' : \'workplace\') + \'.delete({id:workplace.id})\' }}"><i class="fa fa-trash-o"></i></button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/services/confirmation/send-confirmation-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.sendAndPrintConfirmation()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myLabel" data-translate="pcsApp.sendConfirmationDialog.home.createLabel">Sending email</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="pcsApp.sendConfirmationDialog.email" for="field_email">Email</label><input type="email" class="form-control" name="email" id="field_email" autocomplete="off" required ng-model="vm.confirmationEmail" ng-maxlength="64"><div ng-show="editForm.email.$invalid"><p class="error-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="64">This field cannot be longer than 64 characters.</p><p class="error-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.sendConfirmationDialog.language">Language</label><div><label><input ng-model="vm.language" value="hu" id="languageHu" name="language" type="radio"> Hungarian</label></div><div><label><input ng-model="vm.language" value="en" id="languageEn" name="language" type="radio"> English</label></div></div><div class="form-group"><label class="control-label" data-translate="pcsApp.sendConfirmationDialog.optionalText" for="field_optionalTextSelector">Optional text</label><ui-select ng-model="vm.selectedOptionalText" ng-change="vm.setOptionalTextMessage($select.selected.optionalText)" name="optionalTextSelector" id="field_optionalTextSelector" theme="bootstrap"><ui-select-match allow-clear="true" placeholder="{{ \'global.form.please.select\' | translate }}"><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="optionalText in (vm.optionalTexts | filter: $select.search) track by optionalText.id"><div ng-bind-html="optionalText.name | highlight: $select.search"></div></ui-select-choices></ui-select><textarea class="form-control m-t-sm" name="optionalText" id="field_optionalText" rows="10" autocomplete="off" ng-model="vm.optionalText"></textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.send">Send</span></button></div></form>');
$templateCache.put('app/services/email/email-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myLabel" data-translate="pcsApp.emailDialog.home.createLabel" data-translate-values="{lastName: \'{{vm.mail.lastName}}\', firstName: \'{{vm.mail.firstName}}\'}">Sending email</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="pcsApp.emailDialog.body" for="field_body">Email body</label><summernote id="field_body" ng-model="vm.mail.body" ng-required="true" config="vm.summerNoteConfig"></summernote><div ng-show="editForm.body.$invalid"><p class="help-block" ng-show="editForm.body.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.body.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 1000 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.send">Send</span></button></div></form>');
$templateCache.put('app/services/invoice/send-invoice-email-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.send()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myLabel" data-translate="pcsApp.invoice.sendInvoiceDialog.title">Send invoice dialog</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="pcsApp.invoice.sendInvoiceDialog.email" for="field_email">Email</label><input class="form-control" id="field_email" name="email" ng-minlength="5" ng-maxlength="255" autocomplete="off" ng-model="vm.invoiceEmail.email" type="email" required><div ng-show="editForm.email.$invalid"><p class="error-block" ng-show="editForm.email.$error.required" translate="entity.validation.required">This field is required.</p><p class="error-block" ng-show="editForm.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="error-block" ng-show="editForm.email.$error.minlength" translate="entity.validation.minlength" translate-value-min="5">This field is required to be at least 5 characters.</p><p class="error-block" ng-show="editForm.email.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.send">Send</span></button></div></form>');
$templateCache.put('app/components/alert/inspinia-notify.html','<div class="cg-notify-message inspinia-notify" ng-class="[$classes,\n    $position === \'center\' ? \'cg-notify-message-center\' : \'\',\n    $position === \'left\' ? \'cg-notify-message-left\' : \'\',\n    $position === \'right\' ? \'cg-notify-message-right\' : \'\']" ng-style="{\'margin-left\': $centerMargin}"><div class="p-lg"><div ng-show="!$messageTemplate">{{$message}}</div><div ng-show="$messageTemplate" class="cg-notify-message-template"></div><button type="button" class="cg-notify-close" ng-click="$close()"><span aria-hidden="true">&times;</span> <span class="cg-notify-sr-only">Close</span></button></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><div><h1 class="logo-name">PCS+</h1></div><h1 data-translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ui-sref="login">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="error-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="error-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="error-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="error-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="error-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="error-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div class="text-center"><h2 class="logo-name">PCS+</h2></div><div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p data-translate="reset.request.messages.info">Enter the e-mail address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p data-translate="reset.request.messages.success">Check your e-mails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" autocomplete="off" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="error-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="error-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="error-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="error-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.request.form.button">Reset</button></form></div></div></div>');}]);})();